(function () {
  'use strict';

  var app = angular
    .module('garanteasyApp', [
      'ngStorage',
      'puigcerber.countryPicker',
      'tmh.dynamicLocale',
      'pascalprecht.translate',
      'ngResource',
      'ngCookies',
      'ngAria',
      'ngCacheBuster',
      'ngFileUpload',
      'ui.bootstrap',
      'ui.bootstrap.datetimepicker',
      'ui.router',
      'infinite-scroll',
      'ui.select',
      'ngSanitize',
      'ncy-angular-breadcrumb',
      // jhipster-needle-angularjs-add-module JHipster will add new module here
      'angular-loading-bar',
      'angular-elevate-zoom',
      'rt.debounce',
      'bs.screenSize',
      // 'textAngular',
      'angular-barcode',
      'jkuri.gallery'
    ])
    .filter('iconify', ['$sce', function ($sce) {
      return function (input, type) {
        var iconType = 'fas fa-file-invoice-dollar';
        if (input) {
          if (input.startsWith('image/')) {
            iconType = 'fas fa-file-image';
          } else if (input === 'application/pdf') {
            iconType = 'fas fa-file-pdf';
          } else if (input === 'application/msword' || input == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            iconType = 'fas fa-file-word';
          } else if (input === 'application/zip') {
            iconType = 'fas fa-file-archive';
          } else if (input.startsWith('text/')) {
            iconType = 'fas fa-file-alt';
          } else if (input === 'application/vnd.ms-excel' || input == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            iconType = 'fas fa-file-excel';
          }
        } else {
          input = '';
        }

        var out = '<i class="' + input + ' fa fa-2x ' + iconType + '" aria-hidden="true"></i>';
        return $sce.trustAs(type || 'html', out);
      }
    }])
    .run(run);
  app.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('!');
  }]);
  app.config(['pvpCountriesProvider', function (pvpCountriesProvider) {
    pvpCountriesProvider.setCountries(
      [
        {
          name: "Åland Islands",
          alpha2: "AX"
        },
        {
          name: "Austria",
          alpha2: "AT"
        },
        {
          name: "Belgium",
          alpha2: "BE"
        },
        {
          name: "Bulgaria",
          alpha2: "BG"
        },
        {
          name: "Croatia",
          alpha2: "HR"
        },
        {
          name: "Cyprus",
          alpha2: "CY"
        },
        {
          name: "Czech Republic",
          alpha2: "CZ"
        },
        {
          name: "Denmark",
          alpha2: "DK"
        },
        {
          name: "Estonia",
          alpha2: "EE"
        },
        {
          name: "Faroe Islands",
          alpha2: "FO"
        },
        {
          name: "Finland",
          alpha2: "FI"
        },
        {
          name: "France",
          alpha2: "FR"
        },
        {
          name: "French Guiana",
          alpha2: "GF"
        },
        {
          name: "Germany",
          alpha2: "DE"
        },
        {
          name: "Gibraltar",
          alpha2: "GI"
        },
        {
          name: "Greece",
          alpha2: "GR"
        },
        {
          name: "Hungary",
          alpha2: "HU"
        },
        {
          name: "Ireland",
          alpha2: "IE"
        },
        {
          name: "Isle of Man",
          alpha2: "IM"
        },
        {
          name: "Italy",
          alpha2: "IT"
        },
        {
          name: "Latvia",
          alpha2: "LV"
        },
        {
          name: "Lithuania",
          alpha2: "LT"
        },
        {
          name: "Luxembourg",
          alpha2: "LU"
        },
        {
          name: "Malta",
          alpha2: "MT"
        },
        {
          name: "Netherlands",
          alpha2: "NL"
        },
        {
          name: "Poland",
          alpha2: "PL"
        },
        {
          name: "Portugal",
          alpha2: "PT"
        },
        {
          name: "Romania",
          alpha2: "RO"
        },
        {
          name: "Slovakia",
          alpha2: "SK"
        },
        {
          name: "Slovenia",
          alpha2: "SI"
        },
        {
          name: "Spain",
          alpha2: "ES"
        },
        {
          name: "Sweden",
          alpha2: "SE"
        },
        {
          name: "United Kingdom of Great Britain and Northern Ireland",
          alpha2: "GB"
        }
      ]
    );
  }]);

  run.$inject = ['stateHandler', 'translationHandler'];

  function run(stateHandler, translationHandler) {
    stateHandler.initialize();
    translationHandler.initialize();
  }

  app.run(['$rootScope', '$http', '$location', '$state', function ($rootScope, $http, $location, $state) {

    $state.defaultErrorHandler(function (error) {
      // This is a naive example of how to silence the default error handler.
      console.log(error);
    });
    //Variabile in root scope usata per condividere dati nei diversi stati tra sidebar/content
    $rootScope.stateData = {};
    $rootScope._ = window._;
    $rootScope.showSearchBar = true;
    $rootScope.inputSearch = true;
    $rootScope.gridView = $rootScope.bsScreenSize.state === 'sm' || $rootScope.bsScreenSize.state === 'xs';

    var globalSearchChange = $rootScope.$on('dashboardSearchChange', function (evt, data) {
      console.log('dispatch');
      if (!(typeof data.s === 'string' || data.s instanceof String)) {
        data.s = JSON.stringify(data.s);
      }
      // add random item to force router change
      data.r = Math.random();
      if ((data || {}).search) {
        $state.go("search", data);
      }
    });

    $rootScope.$on('$destroy', function (event, next, current) {
      globalSearchChange();
    });

    $rootScope.datepickerOptions = {
      showWeeks: false
    };

    $rootScope.getFromUrl = function (path, destObj, field) {

      if (field) {
        if (!destObj[field])
          destObj[field] = {};
        destObj = destObj[field];
      }

      if (destObj && angular.isDefined(destObj.data))
        return destObj;

      destObj.data = null;

      $http.get(path, {
        responseType: 'arraybuffer',
        headers: {
          'accept': 'image/webp,image/*,*/*;q=0.8'
        }
      })
        .then(function (response) {
          var blob = new Blob(
            [response.data],
            { type: response.headers('Content-Type') }
          );
          destObj.data = URL.createObjectURL(blob);

        });

    };

    $rootScope.printFromPage = function () {
      print();
    }

    $rootScope.noprint = function () {
      $(".no-print").remove();
    }
    $rootScope.getClass = function (path) {
      return ($location.path().substr(0, path.length) === path) ? 'active' : '';
    }

  }]);


})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('User', User);

  User.$inject = ['$resource', 'API_URI'];

  function User($resource, API_URI) {
    return $resource(API_URI + 'api/users/:login', {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          data = angular.fromJson(data);
          return data;
        }
      },
      'save': {method: 'POST'},
      'update': {method: 'PUT'},
      'delete': {method: 'DELETE'}
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('SelectedMerchantService', SelectedMerchantService);

    SelectedMerchantService.$inject = ['$rootScope', 'Dashboard', 'AlertService', 'Principal'];

    function SelectedMerchantService($rootScope, Dashboard, AlertService, Principal) {

        var merchantChange = 'SelectedMerchantService.merchantChange';
        var shopChange = 'SelectedMerchantService.shopChange';
        var vm = this;
        vm.merchants = [];
        vm.shops = [];
        vm.currentMerchant = null;
        vm.currentShop = null;

        var selectShop = function (shop) {
            vm.currentShop = shop;
            $rootScope.$emit(shopChange, shop);
        };

        var onSuccessShop = function (data) {
            vm.shops = data;
            angular.forEach(vm.shops, function (shop) {
                shop.toParamsJson = JSON.stringify(shop);
                shop.description = "[" + shop.code + "] " + shop.description 
            });

            if (data && data.length > 0) {
                selectShop(data[0]);
            } else
                selectShop(null);
        };

        var onError = function (error) {
            vm.isLoading = false;
            AlertService.error(error.data.message);
        };

        var loadShops = function (force) {
            if (vm.currentMerchant || force) {
                Dashboard.getShops({ merchant_id: vm.currentMerchant.id }, onSuccessShop, onError);
            } else onSuccessShop([]);
        };

        var selectMerchant = function (merchant) {
            vm.currentMerchant = merchant;
            $rootScope.$emit(merchantChange, merchant);
            onSuccessShop( merchant.shops );
            loadShops();
        };


        var onSuccessMerchant = function (data) {
            vm.merchants = data;
            if (data.length >= 1) {
                selectMerchant(data[0]);
            }
        };

        var init = function () {

            vm.merchants = [];
            vm.shops = [];
            vm.currentMerchant = null;
            vm.currentShop = null;
            Dashboard.getMerchants({}, onSuccessMerchant, onError);

        };

        if (Principal.isAuthenticated) {
            init();
        }

        $rootScope.$on('authenticationSuccess',
            function () {
                init();
            }
        );

        return {
            onMerchantChange: function (funcToCall) {
                return $rootScope.$on(merchantChange,
                    function (evt, data) {
                        funcToCall(data);
                    }
                );
            },
            onShopChange: function (funcToCall) {
                return $rootScope.$on(shopChange,
                    function (evt, data) {
                        funcToCall(data);
                    }
                );
            },

            get merchant() { return vm.currentMerchant; },
            set merchant(merchant) {
                selectMerchant(merchant);
            },

            get shop() { return vm.currentShop; },

            set shop(shop) {
                selectShop(shop);
            },
            get merchants() {
                return vm.merchants;
            },
            get shops() {
                return vm.shops;
            },
            loadShops: loadShops
        };
    };
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProfileService', ProfileService);

  ProfileService.$inject = ['$q', '$http', 'API_URI'];

  function ProfileService($q, $http, API_URI) {

    var dataPromise;

    return {
      getProfileInfo: getProfileInfo
    };

    function getProfileInfo() {
      if (angular.isUndefined(dataPromise)) {
        dataPromise = $http.get(API_URI + 'api/profile-info').then(function (result) {
          if (result.data.activeProfiles) {
            var response = {};
            response.activeProfiles = result.data.activeProfiles;
            response.ribbonEnv = result.data.ribbonEnv;
            response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
            response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
            return response;
          }
        });
      }
      return dataPromise;
    }
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response && response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
'use strict';
(function () {

    angular
        .module('garanteasyApp')
        .factory('CmsWarrantyService', CmsWarrantyService);

    CmsWarrantyService.$inject = ['$http', 'CMS_URI', '$log'];

    function CmsWarrantyService($http, CMS_URI, $log) {
        var service = {
            getWarrantyData: getWarrantyData
        };

        return service;



        function getWarrantyData(id) {
            if (id) {
                var uri = CMS_URI + 'api/view/warranty/' + id;
                return call(uri);
            }
        }

        function call(uri) {
            return $http.get(uri)
                .then(getData)
                .catch(error);

            function getData(response) {
                return response.data;
            }

            function error(error) {
                $log.error('XHR Failed for brands.' + error.data);
            }
        }

    }
})();
;
'use strict';
(function () {

    angular
        .module('garanteasyApp')
        .factory('BrandService', BrandService);

    BrandService.$inject = ['$http', 'CMS_URI', '$log'];

    function BrandService($http, CMS_URI, $log) {
        var service = {
            getBrandData: getBrandData
        };

        return service;



        function getBrandData(id) {
            if (id) {
                var uri = CMS_URI + 'api/view/brand/' + id;
                return call(uri);
            }
        }

        function call(uri) {
            return $http.get(uri)
                .then(getData)
                .catch(error);

            function getData(response) {
                return response.data;
            }

            function error(error) {
                $log.error('XHR Failed for brands.' + error.data);
            }
        }

    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Register', Register);

  Register.$inject = ['$resource', 'API_URI'];

  function Register($resource, API_URI) {
    return $resource(API_URI + 'api/register', {}, {});
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Principal', Principal);

  Principal.$inject = ['$q', 'Account'];

  function Principal($q, Account) {
    var _identity,
      _authenticated = false;

    var service = {
      authenticate: authenticate,
      countAuthorities: countAuthorities,
      hasAnyAuthority: hasAnyAuthority,
      hasAuthority: hasAuthority,
      identity: identity,
      isAuthenticated: isAuthenticated,
      isIdentityResolved: isIdentityResolved
    };

    return service;

    function authenticate(identity) {
      _identity = identity;
      _authenticated = identity !== null;
      console.log(_identity);
    }

    function hasAnyAuthority(authorities) {
      if (!_authenticated || !_identity || !_identity.authorities) {
        return false;
      }

      for (var i = 0; i < authorities.length; i++) {
        if (_identity.authorities.indexOf(authorities[i]) !== -1) {
          return true;
        }
      }

      return false;
    }

    function hasAuthority(authority) {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(function (_id) {
        return _id.authorities && _id.authorities.indexOf(authority) !== -1;
      }, function () {
        return false;
      });
    }

    function countAuthorities() {
      if (!_authenticated) {
        return $q.when(0);
      }

      return this.identity().then(function (_id) {
        return _id.authorities && _id.authorities.length;
      }, function () {
        return 0;
      });

    }

    function identity(force) {
      var deferred = $q.defer();

      if (force === true) {
        _identity = undefined;
      }

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving
      if (_identity) {
        deferred.resolve(_identity);

        return deferred.promise;
      }

      // retrieve the identity data from the server, update the identity object, and then resolve.
      Account.get().$promise
        .then(getAccountThen)
        .catch(getAccountCatch);

      return deferred.promise;

      function getAccountThen(account) {
        _identity = account.data;
        _authenticated = true;
        deferred.resolve(_identity);
      }

      function getAccountCatch() {
        _identity = null;
        _authenticated = false;
        deferred.resolve(_identity);
      }
    }

    function isAuthenticated() {
      return _authenticated;
    }

    function isIdentityResolved() {
      return _identity;
    }
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('PasswordResetInit', PasswordResetInit);

  PasswordResetInit.$inject = ['$resource', 'API_URI'];

  function PasswordResetInit($resource, API_URI) {
    return $resource(API_URI + 'api/account/reset_password/init', {}, {});
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('PasswordResetFinish', PasswordResetFinish);

  PasswordResetFinish.$inject = ['$resource', 'API_URI'];

  function PasswordResetFinish($resource, API_URI) {
    return $resource(API_URI + 'api/account/reset_password/finish', {}, {});
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Password', Password);

  Password.$inject = ['$resource', 'API_URI'];

  function Password($resource, API_URI) {
    return $resource(API_URI + 'api/account/change_password', {}, {});
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'ActivateEmail', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$location'];

    function Auth($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, ActivateEmail, Password, PasswordResetInit, PasswordResetFinish, $location) {
        var service = {
            activateAccount: activateAccount,
            activateEmail: activateEmail,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function activateEmail(key, callback) {
            var cb = callback || angular.noop;

            return ActivateEmail.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);
            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('receipt');
                }
                // an authenticated user can't access to reset pages
                if (isAuthenticated && $rootScope.toState && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'requestReset')) {
                    $state.go('password');
                }
                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !($rootScope.fromState || {}).name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if (((($rootScope.toState || {}).data || {}).authorities || []).length > 0 && !Principal.hasAnyAuthority(((($rootScope.toState || {}).data || {}).authorities || []))) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams, $location.search());

                        // now, send them to the signin state so they can log in
                        $state.go('home');
                    }
                }
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams, previousStateQuery) {
            var previousState = { "name": previousStateName, "params": previousStateParams, "query": previousStateQuery };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('AuthServerProvider', AuthServerProvider);

  AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q', 'API_URI'];

  function AuthServerProvider($http, $localStorage, $sessionStorage, $q, API_URI) {
    var service = {
      getToken: getToken,
      login: login,
      loginWithToken: loginWithToken,
      storeAuthenticationToken: storeAuthenticationToken,
      logout: logout
    };

    return service;

    function getToken() {
      return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
    }

    function login(credentials) {

      var data = {
        username: credentials.username,
        password: credentials.password,
        rememberMe: credentials.rememberMe
      };
      return $http.post(API_URI + 'api/authenticate', data).then(authenticateSuccess);

      function authenticateSuccess(response) {
        var bearerToken = response.headers('Authorization');
        if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
          var jwt = bearerToken.slice(7, bearerToken.length);
          service.storeAuthenticationToken(jwt, credentials.rememberMe);
          return jwt;
        }
      }
    }

    function loginWithToken(jwt, rememberMe) {
      var deferred = $q.defer();

      if (angular.isDefined(jwt)) {
        this.storeAuthenticationToken(jwt, rememberMe);
        deferred.resolve(jwt);
      } else {
        deferred.reject();
      }

      return deferred.promise;
    }

    function storeAuthenticationToken(jwt, rememberMe) {
      if (rememberMe || true) { //keep always auth between sessions
        $localStorage.authenticationToken = jwt;
      } else {
        $sessionStorage.authenticationToken = jwt;
      }
    }

    function logout() {
      delete $localStorage.authenticationToken;
      delete $sessionStorage.authenticationToken;
    }
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Activate', Activate);

  Activate.$inject = ['$resource', 'API_URI'];

  function Activate($resource, API_URI) {
    return $resource(API_URI + 'api/activate', {}, {
      'get': {method: 'GET', params: {}, isArray: false}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ActivateEmail', ActivateEmail);

  ActivateEmail.$inject = ['$resource', 'API_URI'];

  function ActivateEmail($resource, API_URI) {
    return $resource(API_URI + 'api/activateEmail', {}, {
      'get': {method: 'GET', params: {}, isArray: false}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('Account', Account);

  Account.$inject = ['$resource', 'API_URI'];

  function Account($resource, API_URI) {
    return $resource(API_URI + 'api/account', {}, {
      'get': {
        method: 'GET', params: {}, isArray: false,
        interceptor: {
          response: function (response) {
            // expose response
            return response;
          }
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('SidebarViewsController', SidebarViewsController);

  SidebarViewsController.$inject = ['$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

  function SidebarViewsController($state, $scope, Auth, Principal, ProfileService, LoginService) {
    var vm = $scope;
    vm.showSuggestionsVar = 'falsee';

    vm.triggerObj = {};
    vm.triggerObj.trigger = false;
    $scope.name = 'SidebarController';
    vm.isNavbarCollapsed = true;
    vm.isAuthenticated = Principal.isAuthenticated;
    vm.currentState = $state.current.parent;

    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response && response.inProduction;
      vm.swaggerEnabled = response && response.swaggerEnabled;
    });
    Principal.countAuthorities().then(function (c) {
      if (c === 1) {
        Principal.hasAnyAuthority(['MERCHANT_ROSSETTI', 'MERCHANT_SUPERMEDIA']).then(function (result) {
          vm.isSupermedia = result;
        });
      }
    });
    vm.login = login;
    vm.logout = logout;
    vm.toggleNavbar = toggleNavbar;
    vm.collapseNavbar = collapseNavbar;
    vm.showUlSuggestions = showUlSuggestions;
    vm.$state = $state;

    function showUlSuggestions() {
      if (vm.triggerObj.trigger == true) {
        vm.triggerObj.trigger = false;
      }
      else {
        vm.triggerObj.trigger = true;
      }
    }

    function login() {
      collapseNavbar();
      LoginService.open();
    }

    function logout() {
      collapseNavbar();
      Auth.logout();
      $state.go('home');
    }

    function toggleNavbar() {
      vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
    }

    function collapseNavbar() {
      vm.isNavbarCollapsed = true;
    }
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('SidebarController', SidebarController);

  SidebarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'cmsViewMode'];

  function SidebarController($state, Auth, Principal, ProfileService, LoginService, cmsViewMode) {
    var vm = this;
    vm.showSuggestions = false;
    vm.name = 'SidebarController';
    vm.isNavbarCollapsed = true;
    vm.isAuthenticated = Principal.isAuthenticated;
    vm.triggerObj = {};
    vm.triggerObj.trigger = false;
    vm.cmsViewMode = cmsViewMode;
    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response && response.inProduction;
      vm.swaggerEnabled = response && response.swaggerEnabled;
    });

    vm.login = login;
    vm.logout = logout;
    vm.toggleNavbar = toggleNavbar;
    vm.collapseNavbar = collapseNavbar;
    vm.$state = $state;
    vm.isSupermedia = false;
    vm.showSidebarGrey = showSidebarGrey;
    Principal.countAuthorities().then(function (c) {
      if (c === 1) {
        Principal.hasAnyAuthority(['MERCHANT_ROSSETTI', 'MERCHANT_SUPERMEDIA']).then(function (result) {
          vm.isSupermedia = result;
        });
      }
    });

    function showSidebarGrey() {
      if (vm.triggerObj.trigger == true) {
        vm.triggerObj.trigger = false;
      }
      else {
        vm.triggerObj.trigger = true;
      }
    }

    function login() {
      collapseNavbar();
      LoginService.open();
    }

    function logout() {
      console.log('ciaso');
      collapseNavbar();
      Auth.logout();
      $state.go('home');
    }

    function toggleNavbar() {
      vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
    }

    function collapseNavbar() {
      vm.isNavbarCollapsed = true;
    }
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('garanteasyApp')
        .factory('Searchbar', Searchbar);

    Searchbar.$inject = ['$rootScope'];

    function Searchbar ($rootScope) {
        var listGlobal = [];

        return {
            pushList: pushList,
            getList: getList
        };

        function pushList(list) {
            listGlobal = list;
            $rootScope.searchVar = true;
            if(!$rootScope.searchChange) {
                $rootScope.searchChange = true;
            }
            else {
                $rootScope.searchChange = false;
            }
        }

        function getList() {
            return listGlobal;
        }
    }
})();
;
(function () {
    'use strict';
    angular
        .module('garanteasyApp')
        .controller('SearchbarController', SearchbarController);

    SearchbarController.$inject = ['$stateParams', '$scope', '$rootScope', '$state', '$transitions', '$uibModal'];

    function SearchbarController($stateParams, $scope, $rootScope, $state, $transitions, $uibModal) {
        var initialSortState = {
            customers: { field: 'legalName', type: 'asc' },
          documents: { field: 'shop.owner.name', type: 'desc' },
          shops: { field: 'owner.name', type: 'desc' }
        };
        var s = ($stateParams.s ? JSON.parse($stateParams.s) : initialSortState);
        while (typeof s === 'string' || s instanceof String) {
            s = JSON.parse(s);
        }
        $scope.model = {
            documents: ($stateParams.documents || 'true') === 'true',
            customers: ($stateParams.customers || 'true') === 'true',
            shops: ($stateParams.shops || 'true') === 'true',
            search: $stateParams.search,
            page: $stateParams.page || 0,
            size: $stateParams.size || 20,
            s: s
        };
        $scope.dispatch = function () {
            if (!$scope.model.search) {
                return;
            }
            $scope.model.search = $scope.model.search.replace('@', ' ');
            $rootScope.$broadcast('dashboardSearchChange', $scope.model);
        };
        $scope.clear = function () {
            $scope.model.search = '';
            $state.go('search', $scope.model);
        };
        $scope.openSort = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/layouts/navbar/sort.component.html',
                controller: 'ModalSortContentCtrl',
                size: '',
                resolve: {
                    model: function () {
                        return $scope.model.s;
                    }
                }
            });

            modalInstance.result.then(function (response) {
                $scope.result = response;
            });

        };
        var stateChangeStartListener = $transitions.onSuccess({}, function (trans) {
            const toParams = trans.params();
            $scope.model = {
                documents: (toParams.documents || 'true') === 'true',
                customers: (toParams.customers || 'true') === 'true',
                shops: ($stateParams.shops || 'true') === 'true',
                search: toParams.search,
                page: toParams.page || 0,
                size: toParams.size || 20,
                s: ($stateParams.s ? JSON.parse($stateParams.s) : initialSortState)
            };
        });

        $rootScope.$on('$destroy',
            function () {
                stateChangeStartListener();
            });
    }

    angular
        .module('garanteasyApp')
        .controller('ModalSortContentCtrl', ModalSortContentCtrl);

    ModalSortContentCtrl.$inject = ['$scope', '$uibModalInstance', 'model'];

    ModalSortContentCtrl

    function ModalSortContentCtrl($scope, $uibModalInstance, model) {

        $scope.ok = function () { $uibModalInstance.close($scope.model); }

        $scope.cancel = function () { $uibModalInstance.dismiss(); }

        $scope.model = model;

    }





})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('NavbarController', NavbarController);

  NavbarController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$rootScope', 'SelectedMerchantService', '$log'];

  function NavbarController($scope, $state, Auth, Principal, ProfileService, LoginService, $rootScope, SelectedMerchantService, $log) {
    var vm = this;
    vm.model = {
      get merchant() {
        return SelectedMerchantService.merchant;
      },
      set merchant(item) {
        return SelectedMerchantService.merchant = item;
      },
      get shop() {
        return SelectedMerchantService.shop;
      },
      set shop(item) {
        return SelectedMerchantService.shop = item;
      }
    };
    $scope.$watch(function () {
      return $rootScope.showSearchBar;
    }, function () {
      if ($rootScope.showSearchBar) {
        vm.show = true;
      }
      else {
        vm.show = false;
      }
    }, true);
    vm.isNavbarCollapsed = true;
    vm.isAuthenticated = Principal.isAuthenticated;
    /*vm.identity = Account.get({id : $stateParams.id}).$promise;*/

    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response && response.inProduction;
      vm.swaggerEnabled = response && response.swaggerEnabled;
    });

    vm.login = login;
    vm.logout = logout;
    vm.toggleNavbar = toggleNavbar;
    vm.collapseNavbar = collapseNavbar;
    vm.$state = $state;
    vm.selectEnabled = true

    vm.toggled = function (open) {
      $log.log('Dropdown is now: ', open);
    };

    vm.toggleDropdown = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.status.isopen = !$scope.status.isopen;
    };

    $scope.appendToEl = angular.element(document.querySelector('#dropdown-long-content'));

    function login() {
      collapseNavbar();
      LoginService.open();
    }

    function logout() {
      collapseNavbar();
      Auth.logout();
      vm.account = null;
      $state.go('home');
    }

    function toggleNavbar() {
      vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
    }

    function collapseNavbar() {
      vm.isNavbarCollapsed = true;
    }

    $scope.$on('authenticationSuccess', function () {
      getAccount();
    });

    getAccount();

    function getAccount() {
      Principal.identity().then(function (account) {
        vm.account = account;
        vm.isAuthenticated = Principal.isAuthenticated;
      });
    }
    vm.getShops = function () {
      return SelectedMerchantService.shops;
    }

    vm.getMerchants = function () {
      return SelectedMerchantService.merchants;
    };

    $rootScope.$on("enableMerchantSelector", function enableMerchantSelector(evt, state){
      $log.debug("Merchant selector should go", state)
      vm.selectEnabled = state
    })
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$state', 'Auth'];

    function ProfileController($state, Auth) {
        var vm = this;
        vm.logout = logout;

        function logout() {
            Auth.logout();
            $state.go('home');
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('mobile-navigation-info', {
                parent: 'entity',
                url: '/mobile-navigation-info',
                data: {
                    authorities: []
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'content@': {
                        templateUrl: 'app/layouts/mobile-navigation/info.html',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('receipt');
                        return $translate.refresh();
                    }]
                }
            })
            .state('mobile-navigation-profile', {
                parent: 'entity',
                url: '/mobile-navigation-profile',
                data: {
                    authorities: []
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'content@': {
                        templateUrl: 'app/layouts/mobile-navigation/profile.html',
                        controller: 'ProfileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('receipt');
                        return $translate.refresh();
                    }]
                }
            })
            .state('mobile-navigation-archive', {
                parent: 'entity',
                url: '/mobile-navigation-archive',
                data: {
                    authorities: []
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'content@': {
                        templateUrl: 'app/layouts/mobile-navigation/archive.html',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('receipt');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            ncyBreadcrumb: {
                label: "{{'global.menu.home' | translate}}"
            },
            data: {
                authorities: []
            },
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$rootScope', '$state', '$timeout', 'Auth', 'Receipt'];

    function HomeController($scope, Principal, LoginService, $rootScope, $state, $timeout, Auth, Receipt) {
        var vm = this;

        vm.showMessageSaveMerchant = false;
        vm.showRegisterForm = true;
        if ($state.messageSave) {
            vm.showMessageSaveMerchant = true;
            vm.messageSave = $state.messageSave;
        }
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.merchantRegister = merchantRegister;
        if (((Auth.getPreviousState() || {}).query || {}).username) {
            vm.username = Auth.getPreviousState().query.username;
            vm.showRegisterForm = false;
        }

        vm.closeAlert = function () {
            vm.show = false;
        }

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated();
                if (vm.isAuthenticated) {
                    $state.go('dashboard');
                }
            });
        }
        function register() {
            $state.go('register');
        }
        function merchantRegister() {
            $state.go('register');
        }


        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                    $state.current.name === 'claimChiccoReceipt' || $state.current.name === 'home' ||
                    $state.current.name === 'social-auth' || $state.current.name === 'social-register') {
                    $state.go('receipt');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
                vm.show = true;
            });
        }




        vm.requestResetPassword = function () {
            $state.go('requestReset');
        }
    }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('WarrantyStatus', WarrantyStatus);

  WarrantyStatus.$inject = ['$resource', 'API_URI'];

  function WarrantyStatus($resource, API_URI) {
    var resourceUrl = API_URI + 'api/merchant-dashboard/warrantyStatus/';

    return $resource(resourceUrl, {}, {
      'getWarrantyStatusTotal': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getWarrantyStatusCustomer': {
        method: 'GET',
        url: API_URI + '/api/merchant-dashboard/customerWarrantyStatus/:customer_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('WarrantyClaimFileDialogController', WarrantyClaimFileDialogController);

    WarrantyClaimFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DataUtils', 'WarrantyClaimFile', 'WarrantyClaim'];

    function WarrantyClaimFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DataUtils, WarrantyClaimFile, WarrantyClaim) {
        var vm = this;

        vm.warrantyClaimFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileTooLarge = false;

        vm.setFile = function ($file, warrantyClaimFile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
            	if($file.size>2048000) {
                    vm.fileTooLarge = true;
                    // Reset data in case there was a previous image selected
                	warrantyClaimFile.fileName = null;
                	warrantyClaimFile.fileData = null;
                	warrantyClaimFile.fileContentType = null;
            	} else {
                    vm.fileTooLarge = false;
	                DataUtils.toBase64($file, function(base64Data) {
	                    $scope.$apply(function() {
	                    	warrantyClaimFile.fileName = $file.name;
	                    	warrantyClaimFile.fileData = base64Data;
	                    	warrantyClaimFile.fileContentType = $file.type;
	                    });
	                });
            	}
            }
        };

        vm.canShow = function (contentType) {
        	return contentType != null && contentType.toLowerCase().indexOf('image') == 0 && contentType.toLowerCase().indexOf('tiff') == -1;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.warrantyClaimFile.id !== null) {
                WarrantyClaimFile.update(vm.warrantyClaimFile, onSaveSuccess, onSaveError);
            } else {
                WarrantyClaimFile.save(vm.warrantyClaimFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:warrantyClaimFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('WarrantyClaimFileDeleteController',WarrantyClaimFileDeleteController);

    WarrantyClaimFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'WarrantyClaimFile'];

    function WarrantyClaimFileDeleteController($uibModalInstance, entity, WarrantyClaimFile) {
        var vm = this;

        vm.warrantyClaimFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            WarrantyClaimFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warranty-claim-file', {
                parent: 'entity',
                url: '/warranty-claim-file',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaimFile.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-files.html',
                        controller: 'WarrantyClaimFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaimFile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warranty-claim-file-detail', {
                parent: 'entity',
                url: '/warranty-claim-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaimFile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-detail-html',
                        controller: 'WarrantyClaimFileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaimFile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WarrantyClaimFile', function ($stateParams, WarrantyClaimFile) {
                        return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'warranty-claim-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('warranty-claim-file-detail-edit', {
                parent: 'warranty-claim-file-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warranty-claim-file-new', {
                parent: 'warranty-claim-file',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileName: null,
                                    fileContentType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('warranty-claim-file');
                    });
                }]
            })
            .state('warranty-claim-file-edit', {
                parent: 'warranty-claim-file',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warranty-claim-file-delete', {
                parent: 'warranty-claim-file',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-delete-dialog.html',
                        controller: 'WarrantyClaimFileDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('WarrantyClaimFile', WarrantyClaimFile);

  WarrantyClaimFile.$inject = ['$resource', 'API_URI'];

  function WarrantyClaimFile($resource) {
    var resourceUrl = API_URI + 'api/warranty-claim-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('WarrantyClaimProductNewController', WarrantyClaimProductNewController);

  WarrantyClaimProductNewController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', '$state', 'Receipt'];

  function WarrantyClaimProductNewController($scope, $rootScope, $stateParams, previousState, DataUtils, $state, Receipt) {
    var vm = this;
    vm.ppId;
    vm.isGeneric = false;
    vm.receiptId;
    vm.loadedReceipt;

    vm.byteSize = DataUtils.byteSize;
    vm.openFile = DataUtils.openFile;
    vm.onCancelEdit = onCancelEdit;
    vm.onSaveWarrantyClaim = onSaveWarrantyClaim;

    init();

    function init() {
      if ($stateParams) {
        if ($stateParams.idPurchasedProduct) {
          vm.ppId = $stateParams.idPurchasedProduct;
        }
        if ($stateParams.idReceipt) {
          vm.isGeneric = true;
          vm.receiptId = $stateParams.idReceipt;
          Receipt.get({ id: vm.receiptId }, onSuccessLoadReceipt, onErrorLoadReceipt);
        }
      }
    }

    function onErrorLoadReceipt() {
      //TODO
    }

    function onSuccessLoadReceipt(receipt) {
      vm.loadedReceipt = receipt;
    }

    vm.canShow = function (contentType) {
      return contentType != null && contentType.toLowerCase().indexOf('image') == 0 && contentType.toLowerCase().indexOf('tiff') == -1;
    }

    var unsubscribe = $rootScope.$on('garanteasyApp:warrantyClaimUpdate', function (event, result) {
      vm.warrantyClaim = result;
    });
    $scope.$on('$destroy', unsubscribe);

    function onSaveWarrantyClaim() {
      $state.go('purchased-product.detail', {
        id: vm.ppId
      });
    }

    function onCancelEdit() {
      $state.go('purchased-product.detail', {
        id: vm.ppId
      });
    }
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('WarrantyClaimNewController', WarrantyClaimNewController);

  WarrantyClaimNewController.$inject = ['$stateParams', '$state', 'WarrantyClaim', 'Principal', 'SelectedMerchantService', 'AlertService', "Receipt", "entity", '$translate', 'CmsService'];

  function WarrantyClaimNewController($stateParams, $state, WarrantyClaim, Principal, SelectedMerchantService, AlertService, Receipt, entity, $translate, CmsService) {
    var vm = this;
    vm.ppId;
    vm.cancelClick = cancelClick;
    vm.onSubmit = onSubmit;
    vm.account;
    vm.message;
    vm.hiddenField;
    vm.receipt = entity;
    vm.merchant = entity.shop.merchant;
    vm.shop = entity.shop;
    vm.clientData = {
      "clientName": (vm.receipt.customer.user.login !== vm.receipt.customer.legalName ? vm.receipt.customer.legalName : ''),
      "clientEmail": vm.receipt.customer.user.login,
      "clientPhone": "",
      "cardNumber": vm.receipt.cardNumber
    };
    vm.reasons = [
      "EMAIL_UPDATE",
      "EMAIL_CHANGE",
      "RECEIPT",
      "DELETE_PROFILE",
      "OTHER"
    ];
    vm.warrantyClaim = { receiptId: vm.receipt.id };
    vm.loadCmsShop = function (lang, cmsReference) {
      if (cmsReference) {
        CmsService.getShop(lang, cmsReference).then(function (res) {
          vm.cmsShop = res.data;
          var address = '';

          if (res.data.address_address_line1) {
            address += ' ' + res.data.address_address_line1;
          }
          if (res.data.address_address_line2) {
            address += ' ' + res.data.address_address_line2;
          }
          if (res.data.address_postal_code) {
            address += ' ' + res.data.address_postal_code;
          }
          if (res.data.address_locality) {
            address += ' ' + res.data.address_locality;
          }
          if (res.data.address_country_code) {
            address += ' ' + res.data.address_country_code;
          }

          vm.cmsShop.address = address;

        });
      } else {
        console.log('cmsReference is null', vm.shop);
      }
    };
    init();

    function init() {
      if ($stateParams && $stateParams.receiptId) {
        vm.ppId = $stateParams.receiptId;
      }
      Principal.identity().then(function (account) {
        vm.account = account;
      });
      vm.loadCmsShop($translate.use(), vm.shop.cmsReference);
    }

    function onSubmit() {
      vm.hiddenField = "";
      if ((vm.account || {}).login) {
        vm.hiddenField += "sender: " + vm.account.login + '<br/>';
      }
      if ((vm.shop || {}).email) {
        vm.hiddenField += "shopEmail: " + vm.shop.email + '<br/>';
      }
      if (((vm.shop || {}).address || {}).descFull) {
        vm.hiddenField += "address: " + vm.shop.address.descFull + '<br/>';
      }
      if (((vm.shop || {}).shopSignboard || {}).code) {
        vm.hiddenField += "shopSignboard: " + vm.shop.shopSignboard.code + '<br/>';
      }
      if ((vm.shop || {}).mallName) {
        vm.hiddenField += "mallName: " + vm.shop.mallName + '<br/>';
      }
      if (((vm.shop || {}).merchant || {}).companyName) {
        vm.hiddenField += "companyName: " + vm.shop.owner.name + '<br/>';
      }
      if ((vm.receipt || {}).receiptNumber) {
        vm.hiddenField += "receiptNumber: " + vm.receipt.receiptNumber + '<br/>';
      }
      if ((vm.receipt || {}).buyingDate) {
        vm.hiddenField += "receiptDate: " + vm.receipt.buyingDate + '<br/>';
      }
      if ((vm.receipt || {}).transactionAmount) {
        vm.hiddenField += "receiptAmount: " + vm.receipt.transactionAmount + '<br/>';
      }
      if ((vm.clientData || {}).clientName) {
        vm.hiddenField += "clientName: " + vm.clientData.clientName + '<br/>';
      }
      if ((vm.clientData || {}).clientEmail) {
        vm.hiddenField += "clientEmail: " + vm.clientData.clientEmail + '<br/>';
      }
      if ((vm.clientData || {}).clientPhone) {
        vm.hiddenField += "clientPhone: " + vm.clientData.clientPhone + '<br/>';
      }
      if ((vm.clientData || {}).cardNumber) {
        vm.hiddenField += "cardNumber: " + vm.clientData.cardNumber + '<br/>';
      }

      vm.warrantyClaim.message = vm.hiddenField
        + '<br/>Messaggio dell\'utente:<br/>' + vm.message;
      WarrantyClaim.save(vm.warrantyClaim, onSaveSuccess, onSaveError);
    }
    function onSaveSuccess(result) {
      AlertService.success("Richiesta inviata correttamente");
      $state.go('receipt/detail', {
        id: vm.ppId
      });
    }


    function onSaveError(error) {
      AlertService.error("Errore nell'invio della richiesta");
    }
    function cancelClick() {
      $state.go('receipt/detail', {
        id: vm.ppId
      });
    }
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('WarrantyClaimDetailController', WarrantyClaimDetailController);

  WarrantyClaimDetailController.$inject = ['$state', 'entity',];

  function WarrantyClaimDetailController($state, entity) {
    var vm = this;
    vm.warrantyClaim = entity;

  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warranty-claim', {
                parent: 'entity',
                url: '/warranty-claim',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaim.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim/warranty-claims.html',
                        controller: 'WarrantyClaimController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaim');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('warrantyClaimStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('receipt');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warranty-claim-detail', {
                parent: 'entity',
                url: '/warranty-claim/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaim.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-detail.html',
                        controller: 'WarrantyClaimDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaim');
                        $translatePartialLoader.addPart('warrantyClaimStatus');
                        $translatePartialLoader.addPart('warrantyClaimFile');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('receipt');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WarrantyClaim', function ($stateParams, WarrantyClaim) {
                        return WarrantyClaim.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'warranty-claim',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('warranty-claim-new', {
                parent: 'warranty-claim',
                url: '/{receiptId}/new',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaim.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-new.html',
                        controller: 'WarrantyClaimNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaim');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('warrantyClaimStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('receipt');
                        console.log("RESOLVE");
                        return $translate.refresh();
                    }],
                    entity: [
                        "$stateParams",
                        "Receipt",
                        function ($stateParams, Receipt) {
                            return Receipt.get({ id: $stateParams.receiptId }).$promise;
                        }
                    ],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'warranty-claim',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('warranty-claim-product-new', {
              parent: 'warranty-claim',
              url: '/purchasedProduct/{idPurchasedProduct}/new',
              data: {
                  authorities: ['ROLE_USER'],
                  pageTitle: 'garanteasyApp.warrantyClaim.home.title'
              },
              views: {
                  'content@': {
                      templateUrl: 'app/entities/warranty-claim/warranty-claim-product-new.html',
                      controller: 'WarrantyClaimProductNewController',
                      controllerAs: 'vm'
                  }
              },
              resolve: {
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                      $translatePartialLoader.addPart('warrantyClaim');
                      $translatePartialLoader.addPart('feedback');
                      $translatePartialLoader.addPart('warrantyClaimStatus');
                      $translatePartialLoader.addPart('global');
                      $translatePartialLoader.addPart('receipt');
                      return $translate.refresh();
                  }],
                  previousState: ["$state", function ($state) {
                      var currentStateData = {
                          name: $state.current.name || 'warranty-claim',
                          params: $state.params,
                          url: $state.href($state.current.name, $state.params)
                      };
                      return currentStateData;
                  }]
              }
          });
    }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('WarrantyClaim', WarrantyClaim);

  WarrantyClaim.$inject = ['$resource', '$stateParams', 'API_URI'];

  function WarrantyClaim($resource, $stateParams, API_URI) {
    var resourceUrl = API_URI + '/api/merchant-dashboard/support/garanteasy/';

    return $resource(resourceUrl, {}, {
      'query': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/support/garanteasy/',
        isArray: true
      },
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);
        }
      },
      'send': {
        method: 'PUT',
        url: API_URI + 'api/warranty-claims/:id/send',
        transformRequest: function (data) {
          return angular.toJson(data);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('WarrantyClaimController', WarrantyClaimController);

  WarrantyClaimController.$inject = ['$scope', '$rootScope', '$state', 'WarrantyClaim', 'DataUtils', 'pagingParams', 'AlertService', 'ParseLinks'];

  function WarrantyClaimController($scope, $rootScope, $state, WarrantyClaim, DataUtils, pagingParams, AlertService, ParseLinks) {
    var vm = this;
    vm.warrantyClaims = [];
    vm.gridView = $rootScope.gridView;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.abbreviate = DataUtils.abbreviate;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.links = {
      last: 0
    };
    setTimeout(function () {
      if (!$scope.globalSearchChangeHandled) {
        loadAll();
      }
    }, 500);

    function loadAll() {
      WarrantyClaim.query({
        page: vm.page,
        size: 20,
        sort: sort()
      }, onSuccess, onError);
    }

    function search() {
      return vm.loadAll();
    }

    function sort() {
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'id') {
        result.push('id');
      }
      return result;
    }

    function onSuccess(data, headers) {
      // vm.links = ParseLinks.parse(headers('Link'));
      // vm.totalItems = headers('X-Total-Count');
      vm.warrantyClaims = data;
      vm.isLoading = false;
    }

    function onError(error) {
      vm.isLoading = false;
      AlertService.error(error.message ? error.message : error.data.message);
    }
  }
})();
;
(function () {
  'use strict';

  var warrantyClaimComponent = {
    templateUrl: 'app/entities/warranty-claim/components/warranty-claim-dialog.component.html',
    controller: WarrantyClaimDialogController,
    controllerAs: 'vm',
    bindings: {
      warrantyClaim: '<',
      ppId: '<',
      listProducts: '<',
      purchasedProduct: '<',
      isEdit: '<',
      onSave: '<',
      onCancel: '<',
      onError: '<',
      isGeneric: '<',
      receipt: '<'
    }
  };

  angular
    .module('garanteasyApp')
    .component('warrantyClaimComponent', warrantyClaimComponent);

  WarrantyClaimDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'WarrantyClaim', 'PurchasedProduct', 'Principal', 'Customer', 'DataUtils', 'WarrantyClaimFile', '$state'];

  function WarrantyClaimDialogController($timeout, $scope, $stateParams, $q, WarrantyClaim, PurchasedProduct, Principal, Customer, DataUtils, WarrantyClaimFile, $state) {
    var vm = this;
    /* vm.ppId = $stateParams.ppId;
    vm.listProducts = $stateParams.listProducts; */
    vm.warrantyClaim = {};
    vm.datePickerOpenStatus = {};
    vm.images = [];
    vm.tmp;

    vm.clear = clear;
    vm.openCalendar = openCalendar;
    vm.save = save;
    vm.isValidInput = isValidInput;
    vm.loadPurchasedProduct = loadPurchasedProduct;

    $scope.$watch("vm.receipt", function (newValue) {
      if (vm.isGeneric && newValue) {
        vm.warrantyClaim.purchasedProduct = {};
        vm.warrantyClaim.purchasedProduct.receipt = vm.receipt;


      }
    }, true);

    vm.$onInit = function () {
      if (!vm.warrantyClaim || !vm.warrantyClaim.id) {
        vm.warrantyClaim = {
          requestDate: new Date(),
          annotations: null,
          status: 'WAITING',
          closingDate: null,
          id: null,
          notifiedShop: 0,
          notifiedGaranteasy: 0,
          purchasedProductId: $stateParams.id,
          damageType: 'DEFECT'
        };
      }
      if (!vm.warrantyClaim.damageType) {
        vm.warrantyClaim.damageType = 'DEFECT';
      }
      angular.copy(vm.warrantyClaim, vm.tmp);

      if (vm.ppId) {
        vm.warrantyClaim.purchasedProductId = vm.ppId;
        vm.loadPurchasedProduct();
      } else {
        // vm.warrantyClaim.purchasedProductId = undefined;
      }

    };

    function onSuccessPP(result) {
      vm.warrantyClaim.purchasedProduct = result;
      vm.customer = result.receipt.customer;
      if (vm.customer) {
        vm.addresses = vm.customer.addresses;
      }

      if (vm.warrantyClaim.purchasedProduct.receipt.shop && vm.warrantyClaim.purchasedProduct.receipt.shop.email) {
        vm.warrantyClaim.shopEmailAddress = vm.warrantyClaim.purchasedProduct.receipt.shop.email
      }
      console.log(vm.warrantyClaim);
    }

    function onErrorPP() {

    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      if (typeof vm.onCancel === 'function') {
        angular.copy(vm.tmp, vm.customer);
        vm.onCancel();
      }
    }

    function save() {
      vm.isSaving = true;
      if (vm.warrantyClaim.id !== null) {
        WarrantyClaim.update(vm.warrantyClaim, onSaveSuccess, onSaveError);
      } else {
        WarrantyClaim.save(vm.warrantyClaim, onSaveSuccess, onSaveError);
      }
    }

    // Constraints beyond the ones in the form
    function isValidInput() {
      // For closed claims closing date is mandatory
      return vm.warrantyClaim.status == 'WAITING' || vm.warrantyClaim.status == 'OPEN' || vm.warrantyClaim.closingDate != null;
    }

    function onSaveSuccess(resultClaim) {
      if (angular.isDefined(vm.warrantyClaimFile)) {
        vm.warrantyClaimFile.warrantyClaimId = resultClaim.id;
        WarrantyClaimFile.save(vm.warrantyClaimFile, function (result) {
          vm.images.push(result);
          if (result) {
            vm.image = result;
          }
          onSaveFinal(resultClaim);
        });
      } else {
        onSaveFinal(resultClaim);
      }
    }

    function onSaveFinal(result) {
      vm.isSaving = false;
      WarrantyClaim.send(result, onSendSuccess, onSendError);
      if (typeof vm.onSave === 'function') {
        vm.onSave(result);
      }
    }

    function onSendSuccess(result) { }

    function onSendError(result) { }

    function onSaveError(error) {
      vm.isSaving = false;
      if (typeof vm.onError === 'function') {
        vm.onError(error);
      }
    }

    function loadPurchasedProduct() {
      if (vm.warrantyClaim.purchasedProductId) {
        PurchasedProduct.get({
          id: vm.warrantyClaim.purchasedProductId
        }, onSuccessPP, onErrorPP);
      }
    }

    //vm.datePickerOpenStatus.requestDate = false;
    vm.datePickerOpenStatus.closingDate = false;

    function openCalendar(date) {
      vm.datePickerOpenStatus[date] = true;
    }

    vm.canShow = function (contentType) {
      return contentType != null && contentType.toLowerCase().indexOf('image') == 0 && contentType.toLowerCase().indexOf('tiff') == -1;
    }

    vm.uploadFile = function ($file) {
      vm.warrantyClaimFile = {};
      vm.byteSize = DataUtils.byteSize;
      vm.openFile = DataUtils.openFile;
      vm.fileTooLarge = false;
      if ($file && $file.$error === 'pattern') {
        return;
      }
      if ($file) {
        if ($file.size > 5120000) {
          vm.fileTooLarge = true;
          // Reset data in case there was a previous image selected
          vm.warrantyClaimFile.fileName = null;
          vm.warrantyClaimFile.fileData = null;
          vm.warrantyClaimFile.contentType = null;
          vm.warrantyClaimFile.type = null;
        } else {
          vm.fileTooLarge = false;
          DataUtils.toBase64($file, function (base64Data) {
            $scope.$apply(function () {
              vm.warrantyClaimFile.fileData = base64Data;
              vm.warrantyClaimFile.fileContentType = $file.type;
              vm.warrantyClaimFile.fileName = $file.name;
              vm.image = vm.warrantyClaimFile;
              /*if(item.fileContentType && item.fileContentType.toLowerCase().indexOf("image") == 0){*/
              vm.imageNotPersistent = vm.warrantyClaimFile;

            });
          });
        }
      }
    };

    var imagesPath = {};
    vm.getImageUrl = function (warrantyClaimFile) {
      if (!warrantyClaimFile || !warrantyClaimFile.id) {
        imagesPath[warrantyClaimFile.id] = null;
      } else if (_.isUndefined(imagesPath[warrantyClaimFile.id])) {
        imagesPath[warrantyClaimFile.id] = "api/warranty-claim-files/" + warrantyClaimFile.id + "?width=-&height=377&token=" + AuthServerProvider.getToken();
      }
      return imagesPath[warrantyClaimFile.id];

    };

  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Warranty', Warranty);

  Warranty.$inject = ['$resource', 'DateUtils', '$stateParams', 'API_URI'];

  function Warranty($resource, DateUtils, $stateParams, API_URI) {
    var resourceUrl = API_URI + 'api/warranties/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.appliesFrom = DateUtils.convertLocalDateFromServer(data.appliesFrom);
            data.appliesTo = DateUtils.convertLocalDateFromServer(data.appliesTo);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.appliesFrom = DateUtils.convertLocalDateToServer(dataToSend.appliesFrom);
          dataToSend.appliesTo = DateUtils.convertLocalDateToServer(dataToSend.appliesTo);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.appliesFrom = DateUtils.convertLocalDateToServer(dataToSend.appliesFrom);
          dataToSend.appliesTo = DateUtils.convertLocalDateToServer(dataToSend.appliesTo);
          return angular.toJson(dataToSend);
        }
      },
      /* Actually deletes a PurchasedProductWarranty, hence the need to identify a PurchasedProduct. */
      'delete': {
        method: 'DELETE',
        url: ':id/:purchasedProductId',
        params: {purchasedProductId: $stateParams.id}
      },

      'getByPurchasedProduct': {
        method: 'GET',
        url: API_URI + 'api/warranties/purchased-product/:purchasedProductId',
        isArray: true
      }
    });
  }
})();
;
(function () {
  'use strict';

  var warrantyEditComponent = {
    templateUrl: 'app/entities/warranty/components/warranty-edit-component.html',
    controller: WarrantyEditController,
    controllerAs: 'vm',
    bindings: {
      warranty: '<',
      purchasedProductWarranty: '<',
      type: '<',
      isConventionalStandard: '<',
      onUpdate: '<',
      purchasedProduct: '<',
      isFast: '<',
      isEdit: '<'
    }
  };

  angular
    .module('garanteasyApp')
    .component('warrantyEditComponent', warrantyEditComponent);

  WarrantyEditController.$inject = ['$scope', 'Warranty', '$log'];

  function WarrantyEditController($scope, Warranty, $log) {
    var vm = this;

    vm.loadWarranties = loadWarranties;
    vm.initWarranty = initWarranty;
    vm.setWarrantyType = setWarrantyType;
    vm.changeRequired = changeRequired;
    vm.changeSelected = changeSelected;
    vm.changeStart = changeStart;
    vm.changeGuarantor = changeGuarantor;

    vm.warrantyEditForm;
    vm.warranties = [];
    vm.type = 'CONVENTIONAL';
    vm.collapsed = 'new';
    vm.warrantiesForRequired = [];
    vm.selectedWarranty;
    vm.warrantyConventionalStandard = null;
    vm.warrantyLegal = null;
    vm.startType = null;

    vm.$onInit = function () {
      if (!vm.purchasedProductWarranty || Object.keys(vm.purchasedProductWarranty).length === 0) {
        vm.initWarranty();
      } else {
        if (vm.purchasedProductWarranty.warranty && vm.purchasedProductWarranty.warranty.code === 'CUSTOM' &&
          !vm.purchasedProductWarranty.warranty.official) {
          vm.collapsed = 'search';
        } else if (vm.purchasedProductWarranty.warranty) {
          vm.selectedWarranty = vm.purchasedProductWarranty.warranty;
        }
      }
    };

    $scope.$watch("vm.purchasedProductWarranty", function () {
      var valid = true;
      switch (vm.collapsed) {
        case 'new':
          if (!vm.purchasedProductWarranty || !vm.purchasedProductWarranty.id) {
            valid = false;
          }
          break;
        default:
          if (!$scope.warrantyEditForm || !$scope.warrantyEditForm.$valid) {
            valid = false;
          }
          break;
      }
      if (vm.purchasedProductWarranty) {
        if (vm.purchasedProductWarranty.notifiedApplication === undefined) {
          vm.purchasedProductWarranty.notifiedApplication = 0;
        }
        if (vm.purchasedProductWarranty.notifiedExpiration === undefined) {
          vm.purchasedProductWarranty.notifiedExpiration = 0;
        }
        if (!vm.purchasedProductWarranty.purchasedProductId && vm.purchasedProduct) {
          vm.purchasedProductWarranty.purchasedProductId = vm.purchasedProduct.id;
        }
        initStartType();
      }
      if (typeof vm.onUpdate === 'function') {
        vm.onUpdate(vm.purchasedProductWarranty, valid);
      }

    }, true);

    $scope.$watch("vm.type", function () {
      if (vm.collapsed === 'search') {
        // vm.setWarrantyType();
      }
    });

    $scope.$watch("vm.purchasedProduct", function () {
      if (!vm.purchasedProduct.id) {
        vm.collapsed = 'search';
        vm.initWarranty();
      }
      buildWarrantiesForRequired();
    });

    $scope.$watch("vm.purchasedProduct.warranty", function () {
      buildWarrantiesForRequired();
    }, true);

    function initWarranty() {
      var id = undefined;
      if (vm.purchasedProductWarranty && vm.purchasedProductWarranty.id) {
        id = vm.purchasedProductWarranty.id;
      }
      vm.purchasedProductWarranty = {};
      vm.purchasedProductWarranty.warranty = {};
      vm.purchasedProductWarranty.id = id;
      vm.purchasedProductWarranty.warranty.automatic = 0;
      vm.purchasedProductWarranty.warranty.official = 0;
      vm.purchasedProductWarranty.warranty.legal = 0;
      vm.purchasedProductWarranty.warranty.code = 'CUSTOM';
      /*  vm.purchasedProductWarranty.warranty.type = vm.type ? vm.type : 'CONVENTIONAL'; */
      vm.purchasedProductWarranty.warranty.applicabilityType = null;
      if (vm.isConventionalStandard) {
        vm.purchasedProductWarranty.warranty.applicabilityType = 'STANDARD';
        vm.purchasedProductWarranty.warranty.guarantorType = 'PRODUCER';
        vm.purchasedProductWarranty.warranty.protectedRisk = 'DEFECT';
        vm.purchasedProductWarranty.warranty.warrantyType = 'CONVENTIONAL';
        vm.purchasedProductWarranty.warranty.contractType = 'CONVENTIONAL';
      }
      /*  vm.warranty.type = vm.type === 'STANDARD' ? 'CONVENTIONAL' : 'INSURANCE'; */
    }

    function loadWarranties(query) {
      if (vm.purchasedProduct && vm.purchasedProduct.id) {
        var params = {
          query: query,
          purchasedProductId: vm.purchasedProduct.id
        };
        Warranty.getByPurchasedProduct(params).$promise
          .then(function (result) {
            if (result && Array.isArray(result)) {
              vm.warranties = result;
              if (vm.isConventionalStandard) {
                vm.warranties = vm.warranties.filter(function (val) {
                  return val.type === 'CONVENTIONAL' && val.applicabilityType === 'STANDARD' &&
                    val.protectedRisk === 'DEFECT' && val.guarantorType === 'PRODUCER';
                });
              } else {
                vm.warranties = vm.warranties.filter(function (val) {
                  return val.type !== 'CONVENTIONAL' || val.applicabilityType !== 'STANDARD' ||
                    val.protectedRisk !== 'DEFECT' || val.guarantorType !== 'PRODUCER';
                });
              }
              /* vm.warranties = result.filter(function (val) {
                return val.type === vm.type;
              });
              if (vm.purchasedProductWarranty && vm.purchasedProductWarranty.warranty && vm.purchasedProductWarranty.warranty.applicabilityType) {
                vm.warranties = vm.warranties.filter(function (val) {
                  return val.applicabilityType === vm.purchasedProductWarranty.warranty.applicabilityType;
                });
              } */
            }
          }).catch(function (error) {
            vm.warranties = [];
          });
      } else {
        vm.warranties = [];
      }
    }

    function setWarrantyType() {
      if (!vm.purchasedProductWarranty) {
        vm.initWarranty();
      }
      switch (vm.type) {
        case 'SERVICE_CONTRACT':
          vm.purchasedProductWarranty.warranty.warrantyType = 'SERVICE_CONTRACT';
          vm.purchasedProductWarranty.warranty.applicabilityType = null;
          break;
        case 'INSURANCE':
          vm.purchasedProductWarranty.warranty.warrantyType = 'INSURANCE';
          vm.purchasedProductWarranty.warranty.applicabilityType = null;
          break;
        default:
          vm.purchasedProductWarranty.warranty.warrantyType = 'CONVENTIONAL';
          vm.purchasedProductWarranty.warranty.applicabilityType = 'STANDARD';
          vm.purchasedProductWarranty.warranty.guarantorType = 'PRODUCER';
          vm.purchasedProductWarranty.warranty.protectedRisk = 'DEFECT';
          break;
      }
    }

    function changeRequired() {
      if (!vm.purchasedProductWarranty.warranty) {
        return;
      }
      vm.purchasedProductWarranty.warranty.required = [];
      if (vm.required) {
        vm.purchasedProductWarranty.warranty.required.push(vm.required);
      }
    }

    function changeSelected() {
      if (!vm.purchasedProductWarranty) {
        vm.purchasedProductWarranty = {};
        vm.purchasedProductWarranty.purchasedProductId = vm.purchasedProduct.id;
      }
      vm.purchasedProductWarranty.warranty = vm.selectedWarranty;
      vm.purchasedProductWarranty.warrantyId = vm.selectedWarranty.id;
    }

    function changeStart() {
      switch (vm.startType) {
        case 'STANDARD':
          vm.purchasedProductWarranty.warranty.applicabilityType = 'STANDARD';
          vm.purchasedProductWarranty.warranty.required = [];
          break;
        case 'EXTENSION_LEGAL':
          vm.purchasedProductWarranty.warranty.applicabilityType = 'EXTENSION';
          vm.purchasedProductWarranty.warranty.warrantyType = 'EXTENSION';
          vm.purchasedProductWarranty.warranty.required = [];
          vm.purchasedProductWarranty.warranty.required.push(vm.warrantyLegal);
          break;
        case 'EXTENSION_CONVENTIONAL':
          vm.purchasedProductWarranty.warranty.applicabilityType = 'EXTENSION';
          vm.purchasedProductWarranty.warranty.warrantyType = 'EXTENSION';
          vm.purchasedProductWarranty.warranty.required = [];
          vm.purchasedProductWarranty.warranty.required.push(vm.warrantyConventionalStandard);
          break;
        case 'ARBITRARY':
          vm.purchasedProductWarranty.warranty.applicabilityType = 'ARBITRARY';
          vm.purchasedProductWarranty.warranty.required = [];
          break;
      }
    }

    function buildWarrantiesForRequired() {
      if (typeof vm.purchasedProduct === 'object') {
        vm.warrantiesForRequired = [];
        if (vm.purchasedProduct.purchasedProductWarranties && vm.purchasedProduct.purchasedProductWarranties.length) {
          vm.purchasedProduct.purchasedProductWarranties.forEach(function (item) {
            if (item.warranty.id && item.warranty.warrantyType === 'LEGAL' && (item.warranty.code === 'LAW_GENERAL' || item.warranty.code === 'LAW_BUSINESS')) {
              vm.warrantyLegal = item.warranty;
            }
            if (item.warranty.id && item.warranty.warrantyType === 'CONVENTIONAL' && item.warranty.guarantorType === 'PRODUCER' &&
              item.warranty.applicabilityType === 'STANDARD' && item.warranty.protectedRisk === 'DEFECT') {
              vm.warrantyConventionalStandard = item.warranty;
            }
          });
        }
        /* if (vm.purchasedProduct.warranty && vm.purchasedProduct.warranty.description) {
          vm.warrantiesForRequired.push(vm.purchasedProduct.warranty);
        } */
      }
    }

    function initStartType() {
      if (!vm.purchasedProductWarranty.warranty) {
        return;
      }
      switch (vm.purchasedProductWarranty.warranty.applicabilityType) {
        case 'STANDARD':
          vm.startType = 'STANDARD';
          break;
        case 'EXTENSION':
          vm.startType = 'EXTENSION_LEGAL';
          break;
        case 'ARBITRARY':
          vm.startType = 'ARBITRARY';
          break;
      }
    }

    function changeGuarantor() {
      if (vm.purchasedProductWarranty.warranty && vm.purchasedProductWarranty.warranty.guarantorType) {
        switch (vm.purchasedProductWarranty.warranty.guarantorType) {
          case 'PRODUCER':
            if (vm.purchasedProductWarranty.warranty.applicabilityType !== 'EXTENSION') {
              vm.purchasedProductWarranty.warranty.warrantyType = 'CONVENTIONAL';
            }
            vm.purchasedProductWarranty.warranty.contractType = 'CONVENTIONAL';
            break;
          case 'INSURANCE':
            vm.startType = 'EXTENSION_LEGAL';
            if (vm.purchasedProductWarranty.warranty.applicabilityType !== 'EXTENSION') {
              vm.purchasedProductWarranty.warranty.warrantyType = 'EXTRA';
            }
            vm.purchasedProductWarranty.warranty.contractType = 'INSURANCE_POLICY';
            break;
          case 'ASSISTANCE_CENTER':
            vm.startType = 'ARBITRARY';
            if (vm.purchasedProductWarranty.warranty.applicabilityType !== 'EXTENSION') {
              vm.purchasedProductWarranty.warranty.warrantyType = 'EXTRA';
            }
            vm.purchasedProductWarranty.warranty.contractType = 'SERVICE_CONTRACT';
            break;
        }
      }
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ShopDialogController', ShopDialogController);

    ShopDialogController.$inject = ['$scope', 'AlertService', '$stateParams', 'ShopService', '$window', 'BrandLookup', 'Brand', 'SelectedMerchantService'];

    function ShopDialogController($scope, AlertService, $stateParams, ShopService, $window, BrandLookup, Brand, SelectedMerchantService) {
        var vm = this;
        vm.currentBrand = {};
        vm.currentShop = $stateParams.shop ? JSON.parse($stateParams.shop) : {};
        vm.selectedMerchant;
        vm.merchantListner;
        if (vm.currentShop) {
            vm.shop_ecommerce = vm.currentShop.ecommerceUrl ? 'ecommerce' : 'shop';
            vm.currentBrand = vm.currentShop.shopSignboard;
        }
        vm.getMerchants = function () {
            return SelectedMerchantService.merchants;
        }
        setDefaultMerchant();
        function setDefaultMerchant() {
            vm.selectedMerchant = SelectedMerchantService.merchant;
            vm.merchantListner = SelectedMerchantService.onMerchantChange(function (data) {
                vm.selectedMerchant = data;
                vm.merchantListner();
            })
            $scope.$on('$destroy', function () {
                vm.merchantListner();
            });

        }
        vm.clear = function () {
            $window.history.back();
        }

        vm.save = function () {
            vm.isSaving = true;
            vm.currentShop.signboard = vm.getBrand();
            vm.currentShop.merchant = vm.selectedMerchant;
            vm.currentShop.code = vm.currentShop.vatCode;
            delete (vm.currentShop.shopSignboard);
            if (vm.currentShop.id) {
                ShopService.update(vm.currentShop, onSaveSuccess, onSaveError);
            } else {
                ShopService.save(vm.currentShop, onSaveSuccess, onSaveError);
            }
        }

        vm.findBrands = function (searchQuery) {
            if (searchQuery) {
                BrandLookup.query({ query: searchQuery }, function (result) {
                    vm.brands = result;
                }, function (response) {
                    if (response.status === 404) {
                        vm.brands = Brand.query({ isActive: true });
                    }
                });
            } else {
                vm.brands = Brand.query({ isActive: true });
            }
            (vm.currentBrand || {}).name = searchQuery;
        };

        vm.getBrand = function () {
            if ((vm.currentBrand || {}).id) {
                return {
                    id: vm.currentBrand.id
                };
            } else {
                return {
                    name: (vm.currentBrand || {}).name
                };
            }
        };
        vm.brandIsSelected = function () {
            return (vm.currentBrand || {}).id || (vm.currentBrand || {}).name;
        }
        function onSaveSuccess(result) {
            vm.isSaving = false;
            SelectedMerchantService.loadShops(true);
            $window.history.back();
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data.message);
        }
    }
})();
;
'use strict';
(function () {
  angular
    .module('garanteasyApp')
    .controller('ShopDeleteController', ShopDeleteController);

  ShopDeleteController.$inject = ['$uibModalInstance', '$stateParams', 'ShopService'];

  function ShopDeleteController($uibModalInstance, $stateParams, ShopService) {
    var vm = this;

    vm.shopId = $stateParams.id;
    vm.clear = clear;
    vm.confirmDelete = confirmDelete;
    console.log('shopId', vm.shopId);
    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmDelete() {
      ShopService.delete({ id: vm.shopId },
        function () {
          $uibModalInstance.close(true);
        });
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shop', {
                parent: 'entity',
                url: '/shop?page&sort&search&documents&customers&shops&s',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.shop.home.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.shop.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shop/shops.html',
                        controller: 'ShopController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shop');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shop/edit', {
                parent: 'shop',
                url: '/edit/:shop',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_REFERENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shop/shops-dialog.html',
                        controller: 'ShopDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shop');
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shop/new', {
                parent: 'shop',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_REFERENT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shop/shops-dialog.html',
                        controller: 'ShopDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    shop: function () { return null; },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shop');
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shop/delete', {
                parent: 'shop',
                url: '/delete/:id',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_REFERENT']
                },
                onEnter: [
                    "$stateParams",
                    "$state",
                    "$uibModal",
                    function ($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: "app/entities/shop/shop-delete-dialog.html",
                                controller: "ShopDeleteController",
                                controllerAs: "vm",
                                size: "md"
                            })
                            .result.then(
                                function () {
                                    $state.go("shop", null, { reload: true });
                                },
                                function () {
                                    $state.go("^");
                                }
                            );
                    }
                ]
            });
    }
})();
;
'use strict';
(function () {
  angular
    .module('garanteasyApp')
    .factory('ShopService', ShopService);

  ShopService.$inject = ['$resource', 'DateUtils', '$filter', 'API_URI'];

  function ShopService($resource, DateUtils, $filter, API_URI) {
    var resourceUrl = API_URI + 'api/shops';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', cache: true, isArray: true},
      'get': {
        method: 'GET',
        cache: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          // dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
          // dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          // dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
          // dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      },
      'getShopByMerchants': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/shops/:merchant_id',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ShopSearch', ShopSearch);

  ShopSearch.$inject = ['$resource', 'API_URI'];

  function ShopSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/shops/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ShopLookup', ShopLookup);

  ShopLookup.$inject = ['$resource', 'API_URI'];

  function ShopLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/shops';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ShopController', ShopController);

    ShopController.$inject = ['$scope', '$state', 'Principal', 'AlertService', 'SelectedMerchantService', 'bsScreenSize', 'DataUtils'];

    function ShopController($scope, $state, Principal, AlertService, SelectedMerchantService, bsScreenSize, DataUtils) {
        var vm = this;
        vm.accountId = null;
        vm.isAdmin = null;
        vm.gridView = true;
        vm.abbreviate = DataUtils.abbreviate;
        vm.predicate = 'id';


        if (bsScreenSize.state === 'md' || bsScreenSize.state === 'lg') {
            vm.gridView = false;
        }
        vm.model = {
            get merchant() {
                return SelectedMerchantService.merchant;
            },
            set merchant(item) {
                return SelectedMerchantService.merchant = item;
            },
            get shop() {
                return SelectedMerchantService.shop;
            },
            set shop(item) {
                return SelectedMerchantService.shop = item;
            }
        };
        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                vm.accountId = account.id;
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                });
            });
        }
        function compare(a, b) {
            var arr = vm.predicate.split(".");
            var objA = a[arr[0]];
            var objB = b[arr[0]];
            if (arr[1]) {
                objA = objA[arr[1]];
                objB = objB[arr[1]];
            }

            if (objA < objB) {
                return vm.reverse ? -1 : 1;
            }
            if (objA > objB) {
                return vm.reverse ? 1 : -1;
            }
            return 1;
        }
        vm.shops = SelectedMerchantService.shops;
        vm.transition = function () {
            vm.shops.sort(compare);
        }

        SelectedMerchantService.onShopChange(function (data) {
            vm.shops = SelectedMerchantService.shops;
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('search', {
                parent: 'app',
                url: '/search?page&sort&search&documents&shops&products&s&customers&r',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.search-bar.results'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'content@': {
                        templateUrl: 'app/entities/search/search.controller.html',
                        controller: 'SearchController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'name,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('global');
                      $translatePartialLoader.addPart('timeUnit');
                      $translatePartialLoader.addPart('warranty');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('SearchController', SearchController);

  SearchController.$inject = ['$stateParams', '$rootScope', 'CustomerSearch', 'ParseLinks', '$q', 'Dashboard', 'ShopSearch'];

  function SearchController($stateParams, $rootScope, CustomerSearch, ParseLinks, $q, Dashboard, ShopSearch) {
    var vm = this;
    vm.totalCount = 0;
    // Pagination bookkeeping for each dataset. The "link" property will hold the result of
    // parsing the HTTP Link header returned by the server (RFC 5988/8288). It maps relation names
    // like "first", "prev", "next", and "last" to their corresponding page numbers, which is
    // then used to decide whether more pages are available and to navigate between pages.
    vm.pagination = {
      documents: {
        totalCount: 0,
        link: {},
        page: 0
      },
      customers: {
        totalCount: 0,
        link: {},
        page: 0
      },
      shops: {
        totalCount: 0,
        link: {},
        page: 0
      },
      products: {
        totalCount: 0,
        link: {},
        page: 0
      },
      warrenties: {
        totalCount: 0,
        link: {},
        page: 0
      }
    }
    vm.totalItems = 0;
    var initialSortState = {
      customers: {field: 'legalName', type: 'asc'},
      documents: {field: 'shop.owner.name', type: 'desc'},
      shops: {field: 'owner.name', type: 'desc'}
    };
    var s = ($stateParams.s ? JSON.parse($stateParams.s) : initialSortState);
    while (typeof s === 'string' || s instanceof String) {
      s = JSON.parse(s);
    }
    vm.model = {
      documents: $stateParams.documents === "true",
      shops: $stateParams.shops === "true",
      customers: $stateParams.customers === "true",
      products: $stateParams.products === "true",
      warrenties: $stateParams.warrenties === "true",
      search: $stateParams.search,
      page: $stateParams.page || 0,
      size: $stateParams.size || 20,
      s: s,
      documentsList: [],
      customersList: [],
      shopsList: [],
      productsList: [],
      warrentiesList: [],
      list: []
    };

    vm.gridView = $rootScope.gridView;
    vm.isLoading = false;

    function loadAllCustomers(data) {
      var d = $q.defer();
      if (data.page > vm.pagination.customers.link.last || !vm.model.customers) {
        d.resolve([]);
      } else {
        CustomerSearch.getCustomerSearch(data,
          function (result, headers) {
            // The backend returns an RFC 5988/8288 HTTP Link header for pagination, e.g.:
            // Link: <.../search?page=0&size=20>; rel="first",
            //       <.../search?page=1&size=20>; rel="next",
            //       <.../search?page=9&size=20>; rel="last"
            // We parse this header to extract the page numbers for relations like first/prev/next/last.
            // The parsed object is stored in vm.pagination.customers.link and later used to avoid
            // requesting pages beyond the last page and to drive UI navigation.
            vm.pagination.customers.link = ParseLinks.parse(headers('Link'));
            // X-Total-Count comes from the server and indicates the total number of elements.
            vm.pagination.customers.totalCount = +headers('X-Total-Count');
            d.resolve(result);
          }, function (result, headers) {
            d.resolve([]);
          });
      }
      return d.promise;
    }

    function loadAllReceipts(data) {
      var d = $q.defer();
      if (data.page > vm.pagination.documents.link.last || !vm.model.documents) {
        d.resolve([]);
      } else {
        Dashboard.searchReceipts(data, function (result, headers) {
          // Parse the HTTP Link header for receipts pagination and store page indices by relation
          // (first, prev, next, last). This enables calculating the last page and navigating pages.
          vm.pagination.documents.link = ParseLinks.parse(headers('Link'));
          // Total number of receipts matching the query
          vm.pagination.documents.totalCount = +headers('X-Total-Count');
          d.resolve(result);
        }, function (result, headers) {
          d.resolve([]);
        });
      }
      return d.promise;
    }

    function loadAllShop(data) {
      var d = $q.defer();
      if (data.page > vm.pagination.shops.link.last || !vm.model.shops) {
        d.resolve([]);
      } else {
        ShopSearch.query(data, function (result, headers) {
          // Parse HTTP Link header for shops pagination (first/prev/next/last pages)
          vm.pagination.shops.link = ParseLinks.parse(headers('Link'));
          vm.pagination.shops.totalCount = +headers('X-Total-Count');
          d.resolve(result);
        }, function (result, headers) {
          d.resolve([]);
        });
      }
      return d.promise;
    }

    function loadAll() {
      vm.isLoading = true;
      if (!vm.model.search) {
        vm.model.list = [];
        return;
      }
      var data = {
        query: vm.model.search,
        page: vm.model.page,
        size: vm.model.size
      };
      var dataCustomer = Object.assign({}, data, {
        sort: vm.model.s.customers.field + ',' + vm.model.s.customers.type
      });
      var dataDocuments = Object.assign({}, data, {
        sort: vm.model.s.documents.field + ',' + vm.model.s.documents.type
      });
      var dataShops = Object.assign({}, data, {
        sort: vm.model.s.shops.field + ',' + vm.model.s.shops.type
      });
      $q.all([
        loadAllCustomers(dataCustomer),
        loadAllReceipts(dataDocuments),
        loadAllShop(dataShops)

      ]).then(function (data, headers) {
        vm.model.customersList = vm.model.customersList.concat(data[0].map(function (x) {
          return {type: "customer", obj: x};
        }));
        vm.model.documentsList = vm.model.documentsList.concat(data[1].map(function (x) {
          return {type: "document", obj: x};
        }));
        vm.model.shopsList = vm.model.shopsList.concat(data[2].map(function (x) {
          return {type: "shop", obj: x};
        }));
        // vm.model.warrentiesList = vm.model.warrentiesList.concat(data[3].map(function (x) { return { type: "warrenty", obj: x }; }));
        vm.model.list = vm.model.documentsList.concat(vm.model.shopsList).concat(vm.model.customersList);
        vm.totalCount = +vm.pagination.documents.totalCount + vm.pagination.shops.totalCount + vm.pagination.customers.totalCount;
      }).then(function () {
        vm.isLoading = false;
      }).catch(function (e) {
        vm.isLoading = false;
      });
    }

    vm.loadPage = function (page) {
      if (+vm.model.page !== page) {
        vm.model.page = page;
        loadAll();
      }
    };
    loadAll();
    vm.disableInfiniteScroll = function () {
      return vm.isLoading;
    };
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptFileDialogController', ReceiptFileDialogController);

    ReceiptFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DataUtils', 'ReceiptFile'];

    function ReceiptFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DataUtils, ReceiptFile) {
        var vm = this;

        vm.receiptFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileTooLarge = false;

        vm.setFile = function ($file, receiptFile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
            	if($file.size>5120000) {
                    vm.fileTooLarge = true;
                    // Reset data in case there was a previous image selected
                	receiptFile.fileName = null;
                	receiptFile.fileData = null;
                	receiptFile.fileContentType = null;
            	} else {
                    vm.fileTooLarge = false;
	                DataUtils.toBase64($file, function(base64Data) {
	                    $scope.$apply(function() {
	                    	receiptFile.fileName = $file.name;
	                    	receiptFile.fileData = base64Data;
	                    	receiptFile.fileContentType = $file.type;
	                    });
	                });
            	}
            }
        };

        vm.canShow = function (contentType) {
        	return contentType != null && contentType.toLowerCase().indexOf('image') == 0 && contentType.toLowerCase().indexOf('tiff') == -1;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.receiptFile.id !== null) {
                ReceiptFile.update(vm.receiptFile, onSaveSuccess, onSaveError);
            } else {
                ReceiptFile.save(vm.receiptFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:receiptFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptFileDetailController', ReceiptFileDetailController);

    ReceiptFileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReceiptFile', 'Receipt'];

    function ReceiptFileDetailController($scope, $rootScope, $stateParams, previousState, entity, ReceiptFile, Receipt) {
        var vm = this;

        vm.receiptFile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('garanteasyApp:receiptFileUpdate', function(event, result) {
            vm.receiptFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptFileDeleteController',ReceiptFileDeleteController);

    ReceiptFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReceiptFile'];

    function ReceiptFileDeleteController($uibModalInstance, entity, ReceiptFile) {
        var vm = this;

        vm.receiptFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReceiptFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('receipt-file', {
                parent: 'entity',
                url: '/receipt-file',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.receiptFile.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/receipt-file/receipt-files.html',
                        controller: 'ReceiptFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receiptFile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('receipt-file-detail', {
                parent: 'entity',
                url: '/receipt-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.receiptFile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/receipt-file/receipt-file-detail.html',
                        controller: 'ReceiptFileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receiptFile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ReceiptFile', function ($stateParams, ReceiptFile) {
                        return ReceiptFile.get({ id: $stateParams.id }).$promise;
                    }]
                }
            })
            .state('receipt-file-detail/edit', {
                parent: 'receipt-file-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('receipt-file/new', {
                parent: 'receipt-file',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileName: null,
                                    fileContentType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('receipt-file');
                    });
                }]
            })
            .state('receipt-file/edit', {
                parent: 'receipt-file',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-dialog.html',
                        controller: 'ReceiptFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('receipt-file/delete', {
                parent: 'receipt-file',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt-file/receipt-file-delete-dialog.html',
                        controller: 'ReceiptFileDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReceiptFile', function (ReceiptFile) {
                                return ReceiptFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('receipt-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('ReceiptFile', ReceiptFile);

  ReceiptFile.$inject = ['$resource', 'API_URI'];

  function ReceiptFile($resource, API_URI) {
    var resourceUrl = API_URI + 'api/receipt-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ReceiptFileSearch', ReceiptFileSearch);

  ReceiptFileSearch.$inject = ['$resource', 'API_URI'];

  function ReceiptFileSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/receipt-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptFileController', ReceiptFileController);

    ReceiptFileController.$inject = ['$scope', '$state', 'ReceiptFile', 'ReceiptFileSearch'];

    function ReceiptFileController ($scope, $state, ReceiptFile, ReceiptFileSearch) {
        var vm = this;
        
        vm.receiptFiles = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ReceiptFile.query(function(result) {
                vm.receiptFiles = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ReceiptFileSearch.query({query: vm.searchQuery}, function(result) {
                vm.receiptFiles = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptGiftDialogController', ReceiptGiftDialogController);

    ReceiptGiftDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Principal', 'PurchasedProduct', 'Receipt', 'Product', 'Gift'];

    function ReceiptGiftDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Principal, PurchasedProduct, Receipt, Product, Gift) {
        var vm = this;

        var params = $stateParams.listSelected;
        vm.receipt = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.saveGift = saveGift;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function saveGift() {
            vm.isSaving = true;
            if(params) {
                if (params.length === 1) {
                    params[0].deliveryDate = vm.purchasedProductGift.deliveryDate;
                    params[0].giftReceiverEmail = vm.purchasedProductGift.giftReceiverEmail;
                    params[0].giftNotificationDate = vm.purchasedProductGift.giftNotificationDate;
                    params[0].giftMakerDescription = vm.purchasedProductGift.giftMakerDescription;
                    params[0].giftDescription = vm.purchasedProductGift.giftDescription;
                    PurchasedProduct.update(params[0], onSaveSuccess, onSaveError);
                } else if (params.length > 1) {
                    angular.forEach(params, function (item) {
                        item.deliveryDate = vm.purchasedProductGift.deliveryDate;
                        item.giftReceiverEmail = vm.purchasedProductGift.giftReceiverEmail;
                        item.giftNotificationDate = vm.purchasedProductGift.giftNotificationDate;
                        item.giftMakerDescription = vm.purchasedProductGift.giftMakerDescription;
                        item.giftDescription = vm.purchasedProductGift.giftDescription;
                    });
                    PurchasedProduct.updateList(params, onSaveSuccess, onSaveError);
                }
/*                else if (params.length === 0) {
                    var gift = {};
                    gift.giftReceiverEmail = vm.purchasedProductGift.giftReceiverEmail;
                    gift.giftNotificationDate = vm.purchasedProductGift.giftNotificationDate;
                    gift.giftMakerDescription = vm.purchasedProductGift.giftMakerDescription;
                    gift.giftDescription = vm.purchasedProductGift.giftDescription;
                    gift.giftNotifiedReceiver = 0;
                    Gift.save(gift);
                }*/
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:purchasedProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.deliveryDate = false;
        vm.datePickerOpenStatus.giftNotificationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('ReceiptFastTrackController', ReceiptFastTrackController);

  ReceiptFastTrackController.$inject = ['$timeout', '$scope', '$q', 'entity', 'Principal', 'Receipt', 'Customer', 'Contact', 'ShopService', 'Merchant', 'MerchantLookup', 'Card', '$state', 'DataUtils', 'ReceiptFile', 'AlertService', 'ProductLookup', 'BrandLookup', 'AuthServerProvider', '$log', /* 'Warranty', */ '$rootScope', '$translate', 'bsScreenSize', 'CustomerSearch', 'uibDateParser', 'ProductSearch', 'PurchasedProductWarranty', 'Warranty', 'APPKEY', '$stateParams', 'PrivacyPolicy', 'API_URI'];

  function ReceiptFastTrackController($timeout, $scope, $q, entity, Principal, Receipt, Customer, Contact, ShopService, Merchant, MerchantLookup, Card, $state, DataUtils, ReceiptFile, AlertService, ProductLookup, BrandLookup, AuthServerProvider, $log, /* Warranty, */ $rootScope, $translate, bsScreenSize, CustomerSearch, uibDateParser, ProductSearch, PurchasedProductWarranty, Warranty, APPKEY, $stateParams, PrivacyPolicy, API_URI) {
    var vm = this;
    vm.slides = ['customer', 'receipt', 'receiptImage', 'productType', 'productFestina'];
    vm.activeSlide = 1;
    vm.ssize = bsScreenSize.state;
    vm.receipt = entity;
    vm.receipt.purchasedProducts = [];
    vm.receipt.receiptType = "RECEIPT";
    vm.clear = clear;
    vm.datePickerOpenStatus = {};
    vm.openCalendar = openCalendar;
    vm.save = save;
    vm.images = [];
    vm.documents = [];
    vm.customer = {};
    vm.merchantPrivacyPolicies = [];
    vm.isValidForm = false;
    vm.typeCodes = ["GTIN", "EAN", "UPC"];
    vm.isDisabled = isDisabled;
    vm.contPurchasedProducts = 0;
    vm.receipt.purchasedProducts = [];
    getAccount();
    getAccountMerchants();
    vm.disableAddProduct = disableAddProduct;
    vm.addImageToProduct = addImageToProduct;
    vm.getImageProductUrl = getImageProductUrl;
    vm.addPurchasedProduct = addPurchasedProduct;
    vm.onUpdateConventionalWarranty = onUpdateConventionalWarranty;
    vm.checkValidMail = checkValidMail;
    vm.noFestina = noFestina;
    vm.ccc13 = ccc13;
    vm.saveStepReceiptFile = saveStepReceiptFile;
    vm.isValidCode = false;
    vm.isFestina = false;
    // vm.sysdate = new Date();
    vm.receipt.buyingDate = new Date();
    vm.receipt.purchasedProduct = {};
    vm.receiptFiles = [];
    vm.datePickerOptions = {
      maxDate: new Date(),
      initDate: uibDateParser.parse(new Date())
    };

    vm.isNewCustomer = false;
    vm.isNewProduct = false;
    vm.isPlus = false;
    vm.isBasic = false;

    switch ($stateParams.type) {
      case 'festina':
        vm.isFestina = true;
        break;
      case 'plus':
        vm.isPlus = true;
        break;
      default:
        vm.isBasic = true;
        break
    }

    function getAccountMerchants() {
      Receipt.getMerchants({},
        function (result) {
          vm.accountMerchants = result;
          if (vm.accountMerchants && vm.accountMerchants.length) {
            vm.merchant = vm.accountMerchants[0];
            PrivacyPolicy.regMerchantCode({
                merchant_code: vm.merchant.code
              },
              onPpSuccess,
              onPpError
            );
            vm.getShopByMerchants();
            $translate('garanteasyApp.receipt.descriptionPlaceholder', vm.merchant).then(function (headline) {
              vm.receipt.description = headline;
            }, function (translationId) {
              $log.error("Missing translation for", translationId);
            });

          }
        },
        function (response) {
          if (response.status === 404) {
            vm.accountMerchants = {};
          }
        }
      );
    }

    vm.getShopByMerchants = function () {
      if (angular.isDefined(vm.merchant)) {
        ShopService.getShopByMerchants({
            merchant_id: vm.merchant.id
          },
          function (result) {
            vm.shops = result;
            if (vm.shops && vm.shops.length) {
              vm.receipt.shop = vm.shops[0];
            }
          },
          function (response) {
            if (response.status === 404) {
              vm.shops = {};
            }
          }
        );
      }
    };

    function getAccount() {
      Principal.identity().then(function (account) {
        vm.account = account;
        vm.isAuthenticated = Principal.isAuthenticated;
      });
    }

    vm.isValidPurchasedProduct = function () {
      if (!vm.receipt.purchasedProduct || !vm.receipt.purchasedProduct.product || !vm.receipt.purchasedProduct.product.name || !vm.receipt.purchasedProduct.product.brand) {
        return false;
      }
      return true;
    };

    vm.contacts = Contact.queryActive();


    $timeout(function () {
      angular.element(".form-group:eq(1)>input").focus();
    });
    vm.isValidInput = isValidInput;
    vm.validMerchant = null;
    vm.validAddress = null;

    // Le ricevute inviate da un negozio ufficiale (o in attesa di conferma dopo un claim) sono quasi totalmente readonly
    vm.receipt.source = "MERCHANT";
    vm.isOfficial = true;
    vm.isAdmin = null;
    vm.checkAccess = checkAccess;
    checkAccess();

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
          if (result) {
            vm.isAdmin = true;
          } else {
            vm.isAdmin = false;
          }
        });
      });
    }

    function clear() {
      $uibModalInstance.dismiss("cancel");
    }

    $scope.loadBrands = function (searchQuery) {
      BrandLookup.query({
          query: searchQuery
        },
        function (result) {
          $scope.brands = result;
        }
      );
    };

    $scope.loadActiveCards = function () {
      if (vm.receipt.customer) vm.receipt.customerId = vm.receipt.customer.id;
      if (vm.receipt.customer && vm.receipt.buyingDate)
        vm.cards = Card.queryActive(vm.receipt);
    };

    $scope.loadProducts = function (searchQuery) {
      if (vm.isFestina) {
        var query = '(brand.code:FESTINA)';
        if (searchQuery && searchQuery.trim().length > 0) {
          query += ' AND *' + searchQuery + '*';
        }
        ProductSearch.query({
            query: query
          },
          function (result) {
            $scope.products = result;
          },
          function (response) {
            if (response.status === 404) {
              $scope.products = Product.query({
                  isActive: true
                },
                onSuccess,
                onError
              );
            }
          }
        );
      } else {
        if (searchQuery && searchQuery.trim().length > 0) {
          ProductLookup.query({
              query: searchQuery
            },
            function (result) {
              $scope.products = result;
            },
            function (response) {
              if (response.status === 404) {
                $scope.products = Product.query({
                    isActive: true
                  },
                  onSuccess,
                  onError
                );
              }
            }
          );
        } else {
          ProductLookup.query({});
        }
      }
    };

    function onSuccess(result) {
      $scope.products = result;
      vm.isSaving = false;
    }

    function onError(result) {
      // $uibModalInstance.close(result);
    }

    // Constraints beyond the ones in the form
    function isValidInput() {
      if (
        vm.receipt.receiptType != null &&
        vm.receipt.description != null &&
        vm.receipt.buyingDate != null &&
        vm.receipt.receiptNumber != null &&
        vm.receipt.shop != null
      ) {
        return true;
      }

    }

    vm.datePickerOpenStatus.buyingDate = false;

    function openCalendar(date) {
      vm.datePickerOpenStatus[date] = true;
    }

    vm.canShow = function (contentType) {
      return (
        contentType != null &&
        contentType.toLowerCase().indexOf("image") == 0 &&
        contentType.toLowerCase().indexOf("tiff") == -1
      );
    };

    vm.uploadFile = function ($file, typeForProduct) {
      vm.receiptFile = {};
      vm.byteSize = DataUtils.byteSize;
      vm.openFile = DataUtils.openFile;
      vm.fileTooLarge = false;
      if ($file && $file.$error === 'pattern') {
        return;
      }
      if ($file) {
        if ($file.size > 5120000) {
          vm.fileTooLarge = true;
          // Reset data in case there was a previous image selected
          vm.receiptFile.receiptId = null;
          vm.receiptFile.fileData = null;
          vm.receiptFile.contentType = null;
          vm.receiptFile.type = null;
        } else {
          vm.fileTooLarge = false;
          DataUtils.toBase64($file, function (base64Data) {
            $scope.$apply(function () {
              vm.receiptFile.fileData = base64Data;
              vm.receiptFile.fileContentType = $file.type;
              vm.receiptFile.fileName = $file.name;
              if (typeForProduct) {
                var extension = $file.name.substr($file.name.lastIndexOf('.'));
                switch (typeForProduct) {
                  case 'warranty':
                    vm.receiptFile.fileName = 'garanzia' + extension;
                    vm.receiptFile.typeForProduct = 'warranty';
                    break;
                  case 'codes':
                    vm.receiptFile.fileName = 'codici' + extension;
                    vm.receiptFile.typeForProduct = 'codes';
                    break;
                  default:
                    vm.receiptFile.typeForProduct = 'default';
                }
                vm.activeSlide = 5;
              } else {
                vm.receiptFiles.push(vm.receiptFile);
                vm.receiptFile = null;
                vm.activeSlide = 3;
              }
            });
          });
        }
      }
    };

    vm.getImageTest = function (data) {
      return "data:image/jpeg;base64," + data;
    };

    var imagesPath = {};
    vm.getImageUrl = function (receiptFile) {
      if (!receiptFile || !receiptFile.id) {
        imagesPath[receiptFile.id] = null;
      } else if (_.isUndefined(imagesPath[receiptFile.id])) {
        imagesPath[receiptFile.id] =
          API_URI + "api/receipt-files/content/" +
          receiptFile.id +
          "?width=-&height=377&token=" +
          AuthServerProvider.getToken();
      }
      return imagesPath[receiptFile.id];
    };
    if (vm.receipt.receiptFiles != null && vm.receipt.receiptFiles.length > 0) {
      vm.receipt.receiptFiles.forEach(function (item) {
        if (
          item.fileContentType &&
          item.fileContentType.toLowerCase().indexOf("image") == 0
        )
          vm.images.push(item);
        else vm.documents.push(item);
      });
    }

    if (vm.images.length > 0) {
      vm.image = vm.images[0];
    }

    $scope.loadCustomers = function (searchQuery) {
      if (searchQuery && searchQuery.trim().length > 1) {
        CustomerSearch.getCustomerSearch({
            query: searchQuery,
            sort: 'legalName,asc'
          },
          function (result) {
            vm.customers = result;
            var customer = result.find(function (item) {
              return item.legalName === searchQuery.trim();
            });
            if (searchQuery && !customer) {
              result.unshift(transformCustomer(searchQuery));
            }
          },
          function (response) {
            if (response.status === 404) {
              vm.customers = Customer.query();
            }
          }
        );
      } else {
        Customer.query({}, function (result) {
          vm.customers = result;
        });
      }
    };

    // se il customer è stato selezionato in pagina bene, altrimenti settare le privacy policy ed inviare tutto al salvataggio

    function save() {
      if (vm.receipt && vm.receipt.shop && vm.receipt.shop.shopSignboard) {
        delete vm.receipt.shop.shopSignboard;
      }
      vm.receipt.creationDate = vm.receipt.buyingDate;
      if (vm.customerSelected && vm.customerSelected.id) {
        vm.receipt.customerId = vm.customerSelected.id;
        vm.isSaving = true;
        if (vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length) {
          vm.receipt.purchasedProducts = vm.receipt.purchasedProducts.map(function (purchasedProduct) {
            if (purchasedProduct.product.idxId) {
              purchasedProduct.allProductId = purchasedProduct.product.idxId;
              purchasedProduct.product = {};
            }
            return purchasedProduct;
          });
        }
        if (vm.receipt.id !== null) {
          Receipt.update(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
        } else {
          Receipt.save(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
        }
      } else {
        saveNewCustomer();
      }
    }

    function onSaveSuccessReceipt(result) {
      var receiptId = result.id;
      vm.receipt.id = result.id;
      var promiseArray = [];
      if (vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length &&
        result.purchasedProducts && result.purchasedProducts.length) {
        for (var i = 0; i < result.purchasedProducts.length; i++) {
          if (vm.receipt.purchasedProducts[i] && vm.receipt.purchasedProducts[i].receiptFiles &&
            vm.receipt.purchasedProducts[i].receiptFiles.length && result.purchasedProducts[i].id) {
            vm.receipt.purchasedProducts[i].receiptFiles.map(function (file) {
              file.purchasedProductId = result.purchasedProducts[i].id;
              return file;
            });
            vm.receiptFiles = vm.receiptFiles.concat(vm.receipt.purchasedProducts[i].receiptFiles);
          }
          if (vm.receipt.purchasedProducts[i].warrantyConventional && result.purchasedProducts[i].id) {
            vm.receipt.purchasedProducts[i].warrantyConventional.purchasedProductId = result.purchasedProducts[i].id;
            vm.receipt.purchasedProducts[i].warrantyConventional.receiptId = receiptId;
            promiseArray.push(saveUpdatePurchasedProductWarranty(vm.receipt.purchasedProducts[i].warrantyConventional));
          }
        }
      }
      if (vm.receiptFiles && vm.receiptFiles.length) {
        vm.receiptFiles.forEach(function (receiptFile) {
          if (receiptFile.fileDataChanged) {
            receiptFile.fileData = receiptFile.fileDataChanged;
          }
          delete receiptFile.fileDataChanged;
          delete receiptFile.changed;
          receiptFile.receiptId = receiptId;
          promiseArray.push(ReceiptFile.save(receiptFile, function (result) {
            vm.images.push(result);
            if (result) {
              vm.image = result;
              vm.images.push(result);
            }
          }).$promise);
        });
      }
      $q.all(promiseArray).then(function () {
        $scope.$emit("garanteasyApp:receiptUpdate", result);
        vm.isSaving = false;
        $state.go("receipt", null, {
          reload: true
        });
      });
    }

    function onSaveErrorReceipt(error) {
      vm.error = error;
      vm.isSaving = false;
      AlertService.error(error.data.message);
    }

    function saveNewCustomer() {
      vm.customer.legalName = '';
      if (vm.customer.surname) {
        vm.customer.legalName += vm.customer.surname + ' ';
      }
      if (vm.customer.name) {
        vm.customer.legalName += vm.customer.name;
      }
      vm.customer = {
        email: vm.customer.email,
        login: vm.customer.email,
        legalName: vm.customer.legalName,
        business: false,
        appKey: APPKEY,
        langKey: "it",
        merchantCode: vm.merchant.code,
        merchantPrivacyPolicies: vm.merchantPrivacyPolicies
      };
      Customer.saveCustomerFromReceipt(
        vm.customer,
        onSaveCustomerSuccess,
        onSaveCustomerError
      );
    }

    function onSaveCustomerSuccess(data) {
      vm.customerSelected = data;
      save();
    }

    function onSaveCustomerError(error) {
      vm.error = error;
      $log.error(error);
    }

    function isDisabled() {
      if (!vm.receipt.buyingDate ||
        !vm.receipt.receiptNumber ||
        !vm.receipt.shop ||
        !vm.merchant
      ) {
        return true;
      } else {
        if (vm.customerSelected) {
          return false;
        } else {
          if (!vm.customer.surname || !vm.customer.email) {
            return true;
          }
        }
      }
    }

    vm.updateCustomerData = function () {
      $log.debug("customer selezionato", vm.customerSelected);
      if (vm.customerSelected) {
        if (!vm.customerSelected.id) {
          vm.customer.email = vm.customerSelected.legalName;
          vm.customer.legalName = "";
          return;
        }
        vm.customer.name = vm.customerSelected.legalName
          .split(" ")
          .slice(0, -1)
          .join(" ");
        vm.customer.surname = vm.customerSelected.legalName
          .split(" ")
          .slice(-1)
          .join(" ");
        vm.customer.email = vm.customerSelected.user.login;
      } else {
        vm.customer.name = "";
        vm.customer.surname = "";
        vm.customer.email = "";
      }
    };

    vm.removePurchasedProduct = function (index) {
      vm.receipt.purchasedProducts.splice(index, 1);
    };

    function disableAddProduct() {
      if (vm.receipt.purchasedProduct == null || vm.receipt.purchasedProduct.product == null || vm.receipt.purchasedProduct.product.name == null ||
        (vm.receipt.purchasedProduct.product.eanCodes == null && vm.receipt.purchasedProduct.product.eanCode == null) ||
        vm.receipt.purchasedProduct.product.brand == null ||
        (vm.receipt.gift === 'Y' && vm.receipt.purchasedProduct.giftReceiverEmail == null) ||
        (vm.receipt.purchasedProduct.typeCode !== null && vm.receipt.purchasedProduct.typeCode === 'EAN' && vm.isValidCode === false)
      ) {
        return true;
      } else return false;
    }

    $translate('garanteasyApp.receipt.detail.required').then(function (headline) {
      vm.messageValidationRequired = headline;
      vm.message = headline;
    }, function (translationId) {
      $log.error("Missing translation for", translationId);
    });

    $translate('garanteasyApp.receipt.receiptNewPage.codeValidation').then(function (headline) {
      vm.messageValidationCodeNotValid = headline;
    }, function (translationId) {
      $log.error("Missing translation for", translationId);
    });

    vm.deleteFile = function (receiptFile, isProduct) {
      var index;
      if (isProduct) {
        index = vm.receipt.purchasedProduct.receiptFiles.indexOf(receiptFile);
        return vm.receipt.purchasedProduct.receiptFiles.splice(index, 1);
      }
      index = vm.receiptFiles.indexOf(receiptFile);
      if (!receiptFile.id) {
        vm.receiptFile = {};
        vm.receiptFiles.splice(index, 1);
      } else {
        ReceiptFile.delete({
          id: receiptFile.id
        }, function () {
          vm.receiptFiles.splice(index, 1);
        });
      }
    };


    function ccc13() {
      if (vm.receipt.purchasedProduct.typeCode !== null && vm.receipt.purchasedProduct.typeCode === 'EAN') {
        var factor = 3;
        var sum = 0;
        // var form = {};
        var number = '' + vm.receipt.purchasedProduct.product.eanCode;
        if (number === 'null') {
          vm.message = vm.messageValidationRequired;
        } else if (number.length !== 13) {
          vm.isValidCode = false;
          vm.message = vm.messageValidationCodeNotValid;
        } else if (number.length === 13) {
          vm.result = number.substring(0, 12);
          for (var index = 12; index > 0; --index) {
            sum = sum + number.substring(index - 1, index) * factor;
            factor = 4 - factor;
          }
          if (number.length !== 13) {
            vm.validationCodeMessage = 'FAI ATTENZIONE! Introdurre 12 digits';
          } else {
            var cc = ((1000 - sum) % 10);
            vm.result = vm.result + cc;
          }
          if (number === vm.result) {
            vm.isValidCode = true;
          } else {
            vm.isValidCode = false;
            vm.message = vm.messageValidationCodeNotValid;
          }
        }
      } else vm.isValidCode = true;
    }

    function addImageToProduct() {
      if (!vm.receipt.purchasedProduct.receiptFiles) {
        vm.receipt.purchasedProduct.receiptFiles = [];
      }
      var index = vm.receipt.purchasedProduct.receiptFiles.indexOf(vm.receiptFile);
      if (index !== -1) {
        vm.receipt.purchasedProduct.receiptFiles[index] = vm.receiptFile;
      } else {
        vm.receipt.purchasedProduct.receiptFiles.push(vm.receiptFile);
      }
      vm.receiptFile = null;
      vm.activeSlide = 4;
    }

    function getImageProductUrl(type) {
      var image;
      if (type === 'product-resource') {
        if (!vm.receipt.purchasedProduct.product || !vm.receipt.purchasedProduct.product.images || !vm.receipt.purchasedProduct.product.images.length) {
          return 'content/images/img-placeholder.jpg';
        } else {
          image = vm.receipt.purchasedProduct.product.images[0];
          return API_URI + 'api/product-resources/image/' + image.id;
        }
      }
      if (!vm.receipt.purchasedProduct.receiptFiles || !vm.receipt.purchasedProduct.receiptFiles.length) {
        return null;
      }
      image = vm.receipt.purchasedProduct.receiptFiles.find(function (file) {
        return file.typeForProduct === type;
      });
      if (image && image.fileData && image.fileContentType) {
        return 'data:' + image.fileContentType + ';base64,' + image.fileData;
      }
      return;
    }

    function addPurchasedProduct(saveReceipt) {
      vm.addProduct = false;
      if (
        angular.isDefined(vm.receipt.purchasedProduct) &&
        angular.isDefined(vm.receipt.purchasedProduct.product)
      ) {
        /* if (angular.isUndefined(vm.receipt.purchasedProduct.giftMakerDescription)) {
          vm.receipt.purchasedProduct.giftMakerDescription = vm.receipt.customer.legalName;
        } */
        var index = vm.receipt.purchasedProducts.indexOf(vm.receipt.purchasedProduct);
        if (index === -1) {
          vm.receipt.purchasedProducts.push(vm.receipt.purchasedProduct);
        } else {
          vm.receipt.purchasedProducts[index] = vm.receipt.purchasedProduct;
        }
        vm.receipt.purchasedProduct = {};
      }
      vm.receipt.numProducts = vm.receipt.purchasedProducts.length;
      vm.noFestina();
      if (saveReceipt) {
        save();
      } else {
        vm.addProduct = true;
        vm.activeSlide = 4;
      }
    }

    function onUpdateConventionalWarranty(purchasedProductWarranty) {
      vm.receipt.purchasedProduct.warrantyConventional = Object.assign({}, purchasedProductWarranty);
    }

    function saveUpdatePurchasedProductWarranty(purchasedProductWarranty) {
      var promise = new Promise(function (resolve) {
        resolve();
      });
      if (!purchasedProductWarranty.warranty.id) {
        if (!purchasedProductWarranty.warranty.description) {
          purchasedProductWarranty.warranty.description = '';
        }
        promise = Warranty.save(purchasedProductWarranty.warranty).$promise;
      } else if (purchasedProductWarranty.warranty.id && purchasedProductWarranty.warranty.code === 'CUSTOM') {
        promise = Warranty.update(purchasedProductWarranty.warranty).$promise;
      }
      if (!purchasedProductWarranty.id) {
        promise = promise.then(function (warranty) {
          purchasedProductWarranty.warrantyId = purchasedProductWarranty.warrantyId || warranty.id;
          return PurchasedProductWarranty.save(purchasedProductWarranty).$promise;
        });
      } else {
        promise = promise.then(function (warranty) {
          purchasedProductWarranty.warrantyId = purchasedProductWarranty.warrantyId || warranty.id;
          return PurchasedProductWarranty.update(purchasedProductWarranty).$promise;
        });
      }
      return promise.then(function (result) {
        purchasedProductWarranty = result;
        return purchasedProductWarranty;
      });
    }

    function transformCustomer(new_value) {
      var new_customer = {};
      new_customer.legalName = new_value;

      return new_customer;
    }

    function checkValidMail() {
      var exp = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]*\.([a-z]{2,4})$/;
      var email;
      if (vm.customerSelected && vm.customerSelected.legalName) {
        email = vm.customerSelected.legalName;
      }
      if (exp.test(email)) {
        vm.validEmail = true;
      } else {
        vm.validEmail = false;
      }
    }

    function onPpSuccess(privacyPolicy) {
      if (privacyPolicy) {
        vm.merchantPrivacyPolicies = [];
        vm.merchantPrivacyPolicies[0] = {
          approved: true,
          code: privacyPolicy[0].code,
          mandatory: true,
          merchant: vm.merchant,
          merchantCode: vm.merchant.code,
          policyId: privacyPolicy[0].id
        };
      }
    }

    function onPpError(error) {
      vm.error = error;
      $log.error(error);
    }

    function noFestina() {
      vm.isFestina = false;
      $scope.products = [];
    }

    function saveStepReceiptFile() {
      if (vm.isBasic) {
        vm.save();
      } else {
        vm.activeSlide = 4;
        vm.addProduct = true;
      }
    }

  }
})();
;
(function () {
  "use strict";

  angular
    .module("garanteasyApp")
    .controller("ReceiptDialogControllerPage", ReceiptDialogControllerPage);

  ReceiptDialogControllerPage.$inject = [
    "$timeout",
    "$scope",
    "$stateParams",
    "$q",
    "entity",
    "Principal",
    "Receipt",
    "Customer",
    "Contact",
    "PurchasedProduct",
    "ShopService",
    "ShopLookup",
    "Merchant",
    "MerchantLookup",
    "BrandLookup",
    "Card",
    "$state",
    "DataUtils",
    "ReceiptFile",
    "ProductLookup",
    "Product",
    "bsScreenSize",
    "CustomerSearch",
    "PrivacyPolicy",
    "Register",
    "APPKEY",
    "$log",
    "$translate",
    'API_URI'
  ];

  function ReceiptDialogControllerPage(
    $timeout,
    $scope,
    $stateParams,
    $q,
    entity,
    Principal,
    Receipt,
    Customer,
    Contact,
    PurchasedProduct,
    ShopService,
    ShopLookup,
    Merchant,
    MerchantLookup,
    BrandLookup,
    Card,
    $state,
    DataUtils,
    ReceiptFile,
    ProductLookup,
    Product,
    bsScreenSize,
    CustomerSearch,
    PrivacyPolicy,
    Register,
    APPKEY,
    $log,
    $translate,
    API_URI
  ) {
    var vm = this;
    vm.ssize = bsScreenSize.state;
    vm.receipt = entity;
    vm.receipt.purchasedProducts = [];
    vm.receipt.receiptType = "RECEIPT";
    vm.clear = clear;
    vm.datePickerOpenStatus = {};
    vm.openCalendar = openCalendar;
    vm.save = save;
    vm.addProductTest = addProductTest;
    vm.images = [];
    vm.documents = [];
    vm.customer = {};
    vm.merchantPrivacyPolicies = [];
    vm.isValidForm = false;
    vm.typeCodes = ["GTIN", "EAN", "UPC"];
    vm.isDisabled = isDisabled;
    vm.contPurchasedProducts = 0;
    vm.receipt.purchasedProducts = [];
    getAccount();
    getAccountMerchants();
    vm.disableAddProduct = disableAddProduct;
    vm.ccc13 = ccc13;
    vm.isValidCode = false;
    // vm.sysdate = new Date();
    vm.receipt.buyingDate = new Date();
    vm.receipt.purchasedProduct = {};
    vm.receiptFiles = [];

    vm.isNewCustomer = false;
    vm.isNewProduct = false;

    function getAccountMerchants() {
      Receipt.getMerchants({},
        function (result) {
          vm.accountMerchants = result;
        },
        function (response) {
          if (response.status === 404) {
            vm.accountMerchants = {};
          }
        }
      );
    }

    vm.getShopByMerchants = function () {
      if (angular.isDefined(vm.merchant)) {
        ShopService.getShopByMerchants({merchant_id: vm.merchant.id},
          function (result) {
            vm.shops = result;
          },
          function (response) {
            if (response.status === 404) {
              vm.shops = {};
            }
          }
        );
      }
    };

    function getAccount() {
      Principal.identity().then(function (account) {
        vm.account = account;
        vm.isAuthenticated = Principal.isAuthenticated;
      });
    }

    vm.customers = Customer.query({}, function (result) {
      vm.receipt.customer = result[0];
    });

    /*vm.cards = Card.queryActive(vm.receipt);*/
    vm.contacts = Contact.queryActive();
    // vm.shops = ShopService.query({ filter: "receipt-is-null" });
    // $q.all([vm.receipt.$promise, vm.shops.$promise])
    //     .then(function() {
    //         if (!vm.receipt.shopId) {
    //             return $q.reject();
    //         }
    //         return ShopService.get({ id: vm.receipt.shopId }).$promise;
    //     })
    //     .then(function(shop) {
    //         vm.shops.push(shop);
    //     });

    /* $q.all([vm.receipt.$promise, vm.cards.$promise]).then(function() {
                 if (!vm.receipt.buyingDateng || !vm.customerId) {
                     return $q.reject();
                 }
                 return Card.queryActive({receipt : vm.receipt}).$promise;
             }).then(function(card) {
                 vm.cards.push(card);
             });*/

    $timeout(function () {
      angular.element(".form-group:eq(1)>input").focus();
    });
    vm.isValidInput = isValidInput;
    vm.validMerchant = null;
    vm.validAddress = null;

    // Le ricevute inviate da un negozio ufficiale (o in attesa di conferma dopo un claim) sono quasi totalmente readonly
    vm.receipt.source = "MERCHANT";
    vm.isOfficial = true;
    vm.isAdmin = null;
    vm.checkAccess = checkAccess;
    checkAccess();

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
          if (result) {
            vm.isAdmin = true;
          } else {
            vm.isAdmin = false;
          }
        });
      });
    }

    function clear() {
      $uibModalInstance.dismiss("cancel");
    }

    $scope.resetShop = function () {
      vm.receipt.shop = null;
    };

    $scope.resetMerchant = function () {
      if (vm.receipt.shop !== null) {
        vm.receipt.shop.merchant = null;
      }
    };

    $scope.loadShops = function (searchQuery) {
      if (angular.isDefined(vm.merchant)) {
        if (searchQuery && searchQuery.trim().length > 1) {
          ShopService.getShopByMerchants({merchant_id: vm.merchant.id, query: searchQuery},
            function (result) {
              $scope.shops = result;
            }
          );
        } else {
          ShopService.getShopByMerchants({merchant_id: vm.merchant.id}, function (
            result
          ) {
            $scope.shops = result;
          });
        }

        PrivacyPolicy.regMerchantCode({merchant_code: vm.merchant.code},
          onPpSuccess,
          onPpError
        );

        $translate('garanteasyApp.receipt.descriptionPlaceholder', vm.merchant).then(function (headline) {
          vm.receipt.description = headline;
        }, function (translationId) {
          $log.error("Missing translation for", translationId);
        });
      }
    };

    $scope.loadBrands = function (searchQuery) {
      BrandLookup.query({query: searchQuery},
        function (result) {
          $scope.brands = result;
        }
      );
    };

    $scope.loadMerchants = function (searchQuery) {
      if (searchQuery) {
        MerchantLookup.query({query: searchQuery},
          function (result) {
            $scope.merchants = result;
          },
          function (response) {
            if (response.status === 404) {
              $scope.merchants = Merchant.query({isActive: true});
            }
          }
        );
      } else {
        $scope.merchants = Merchant.query({isActive: true});
      }
    };

    $scope.loadActiveCards = function () {
      if (vm.receipt.customer) vm.receipt.customerId = vm.receipt.customer.id;
      if (vm.receipt.customer && vm.receipt.buyingDate)
        vm.cards = Card.queryActive(vm.receipt);
    };

    $scope.loadProducts = function (searchQuery) {
      if (searchQuery && searchQuery.trim().length > 0) {
        ProductLookup.query({query: searchQuery},
          function (result) {
            $scope.products = result;
          },
          function (response) {
            if (response.status === 404) {
              $scope.products = Product.query({isActive: true},
                onSuccess,
                onError
              );
            }
          }
        );
      } else {
        ProductLookup.query({});
      }
    };

    function onSuccess(result) {
      $scope.products = result;
      vm.isSaving = false;
    }

    function onError(result) {
      // $uibModalInstance.close(result);
    }

    // Constraints beyond the ones in the form
    function isValidInput() {
      if (
        vm.receipt.receiptType != null &&
        vm.receipt.description != null &&
        vm.receipt.buyingDate != null &&
        vm.receipt.receiptNumber != null &&
        vm.receipt.shop != null
      ) {
        return true;
      }

      /*        	// And either ecommerce url or address must be valid
                            vm.validAddress =
                              (vm.receipt.shop.ecommerceUrl != null && vm.receipt.shop.ecommerceUrl.trim().length > 0)
                              ||
                              (vm.receipt.shop.address != null &&
                              vm.receipt.shop.address.street != null && vm.receipt.shop.address.street.trim().length > 0
                              && vm.receipt.shop.address.city != null && vm.receipt.shop.address.city.trim().length > 0);
                            return vm.validMerchant && vm.validAddress;*/
    }

    function onSaveSuccess(result) {
      if (vm.receiptFile != null) {
        vm.receiptFile.receiptId = result.id;
        ReceiptFile.save(vm.receiptFile, function (result) {
          vm.images.push(result);
          if (result) {
            vm.image = result;
            vm.images.push(result);
          }
        });
      }
      $scope.$emit("garanteasyApp:receiptUpdate", result);
      vm.isSaving = false;
      $state.go("receipt", null, {reload: true});
    }

    function onSaveError(error) {
      vm.error = error;
      vm.isSaving = false;
    }

    vm.datePickerOpenStatus.buyingDate = false;

    function openCalendar(date) {
      vm.datePickerOpenStatus[date] = true;
    }

    vm.canShow = function (contentType) {
      return (
        contentType != null &&
        contentType.toLowerCase().indexOf("image") == 0 &&
        contentType.toLowerCase().indexOf("tiff") == -1
      );
    };

    vm.uploadFile = function ($file, isProduct) {
      vm.receiptFile = {};
      vm.byteSize = DataUtils.byteSize;
      vm.openFile = DataUtils.openFile;
      vm.fileTooLarge = false;
      if ($file && $file.$error === 'pattern') {
        return;
      }
      if ($file) {
        if ($file.size > 5120000) {
          vm.fileTooLarge = true;
          // Reset data in case there was a previous image selected
          vm.receiptFile.receiptId = null;
          vm.receiptFile.fileData = null;
          vm.receiptFile.contentType = null;
          vm.receiptFile.type = null;
        } else {
          vm.fileTooLarge = false;
          DataUtils.toBase64($file, function (base64Data) {
            $scope.$apply(function () {
              // vm.receiptFile.receiptId = vm.receipt.id;
              vm.receiptFile.fileData = base64Data;
              vm.receiptFile.fileContentType = $file.type;
              vm.receiptFile.fileName = $file.name;
              if (isProduct) {
                if (!vm.receipt.purchasedProduct.receiptFiles) {
                  vm.receipt.purchasedProduct.receiptFiles = [];
                }
                vm.receipt.purchasedProduct.receiptFiles.push(vm.receiptFile);
              } else {
                vm.receiptFiles.push(vm.receiptFile);
              }
              /*if(item.fileContentType && item.fileContentType.toLowerCase().indexOf("image") == 0){*/
              //vm.imageNotPersistent = vm.receiptFile;
              //}
            });
          });
        }
      }
    };

    vm.getImageTest = function (data) {
      return "data:image/jpeg;base64," + data;
    };

    var imagesPath = {};
    vm.getImageUrl = function (receiptFile) {
      if (!receiptFile || !receiptFile.id) {
        imagesPath[receiptFile.id] = null;
      } else if (_.isUndefined(imagesPath[receiptFile.id])) {
        imagesPath[receiptFile.id] =
          API_URI + "api/receipt-files/content/" +
          receiptFile.id +
          "?width=-&height=377&token=" +
          AuthServerProvider.getToken();
      }
      return imagesPath[receiptFile.id];
    };
    if (vm.receipt.receiptFiles != null && vm.receipt.receiptFiles.length > 0) {
      vm.receipt.receiptFiles.forEach(function (item) {
        if (
          item.fileContentType &&
          item.fileContentType.toLowerCase().indexOf("image") == 0
        )
          vm.images.push(item);
        else vm.documents.push(item);
      });
    }

    if (vm.images.length > 0) {
      vm.image = vm.images[0];
    }

    vm.changeMainImage = function (image) {
      /*$('.zoomContainer').remove();*/
      vm.image = image;
    };

    vm.deleteImage = function (image) {
      ReceiptFile.delete({id: image.id}, function () {
        var ind = vm.images.indexOf(image);
        vm.images.splice(ind, ind + 1);
        /*$('.zoomContainer').remove();*/
        vm.image = vm.images[0];
      });
    };

    $scope.loadCustomers = function (searchQuery) {
      if (searchQuery && searchQuery.trim().length > 1) {
        CustomerSearch.query({query: searchQuery},
          function (result) {
            $scope.customers = result;
          },
          function (response) {
            if (response.status === 404) {
              $scope.customers = Customer.query();
            }
          }
        );
      } else {
        Customer.query({}, function (result) {
          $scope.customers = result;
        });
      }
    };

    // se il customer è stato selezionato in pagina bene, altrimenti settare le privacy policy ed inviare tutto al salvataggio

    function save() {
      vm.receipt.creationDate = vm.receipt.buyingDate;
      // temporaneo per evitare bug deserialize
      if (vm.receipt && vm.receipt.shop && vm.receipt.shop.shopSignboard) {
        delete vm.receipt.shop.shopSignboard;
      }

      if (vm.customerSelected) {
        vm.receipt.customerId = vm.customerSelected.id;
        vm.isSaving = true;
        if (vm.receipt.id !== null) {
          Receipt.update(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
        } else {
          Receipt.save(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
        }
      } else {
        saveNewCustomer();
      }
    }

    function onSaveSuccessReceipt(result) {
      if (vm.receiptFile != null) {
        vm.receiptFile.receiptId = result.id;
        ReceiptFile.save(vm.receiptFile, function (result) {
          vm.images.push(result);
          if (result) {
            vm.image = result;
            vm.images.push(result);
          }
        });
      }
      $scope.$emit("garanteasyApp:receiptUpdate", result);
      vm.isSaving = false;
      $state.go("receipt", null, {reload: true});
    }

    function onSaveErrorReceipt(error) {
      vm.error = error;
      vm.isSaving = false;
    }

    function saveNewCustomer() {
      vm.customer = {
        email: vm.customer.email,
        login: vm.customer.email,
        business: false,
        appKey: APPKEY,
        langKey: "it",
        merchantCode: vm.merchant.code,
        merchantPrivacyPolicies: vm.merchantPrivacyPolicies,
        legalName: vm.customer.surname + " " + vm.customer.name
      };
      Customer.saveCustomerFromReceipt(
        vm.customer,
        onSaveCustomerSuccess,
        onSaveCustomerError
      );
    }

    function onPpSuccess(privacyPolicy) {
      if (privacyPolicy) {
        vm.merchantPrivacyPolicies = [];
        vm.merchantPrivacyPolicies[0] = {
          approved: true,
          code: privacyPolicy[0].code,
          mandatory: true,
          merchant: vm.merchant,
          merchantCode: vm.merchant.code,
          policyId: privacyPolicy[0].id
        };
      }
    }

    function onPpError(error) {
      vm.error = error;
      $log.error(error);
    }

    function onSaveCustomerSuccess(data) {
      vm.customerSelected = data;
      save();
      // vm.receipt.customer = data;
      // if (vm.receipt.id !== null) {
      //   Receipt.update(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
      // } else {
      //   Receipt.save(vm.receipt, onSaveSuccessReceipt, onSaveErrorReceipt);
      // }
    }

    function onSaveCustomerError(error) {
      vm.error = error;
      $log.error(error);
    }

    function addProduct() {
      // TODO
      $log.error("TODO");
    }

    function addProductTest() {
      vm.addProduct = false;
      if (
        angular.isDefined(vm.receipt.purchasedProduct) &&
        angular.isDefined(vm.receipt.purchasedProduct.product)
      ) {
        if (angular.isUndefined(vm.receipt.purchasedProduct.giftMakerDescription)) {
          if (vm.customerSelected && vm.customerSelected.legalName !== null) {
            vm.receipt.purchasedProduct.giftMakerDescription = vm.customerSelected.legalName;
          } else if (vm.customerSelected === null) {
            vm.receipt.purchasedProduct.giftMakerDescription = vm.receipt.customer.legalName;
          }

        }
        vm.receipt.purchasedProducts.push(vm.receipt.purchasedProduct);
        vm.receipt.purchasedProduct = {};
      }
    }

    function isDisabled() {
      if (!vm.receipt.buyingDate ||
        !vm.receipt.receiptNumber ||
        !vm.receipt.shop ||
        !vm.merchant
      ) {
        return true;
      } else {
        if (vm.customerSelected) {
          return false;
        } else {
          if (!vm.customer.surname || !vm.customer.email) {
            return true;
          }
        }
      }
    }

    vm.updateCustomerData = function () {
      $log.debug("customer selezionato", vm.customerSelected);
      if (vm.customerSelected) {
        vm.customer.name = vm.customerSelected.legalName
          .split(" ")
          .slice(0, -1)
          .join(" ");
        vm.customer.surname = vm.customerSelected.legalName
          .split(" ")
          .slice(-1)
          .join(" ");
        vm.customer.email = vm.customerSelected.user.login;
      } else {
        vm.customer.name = "";
        vm.customer.surname = "";
        vm.customer.email = "";
      }
    };

    vm.removePurchasedProduct = function (index) {
      vm.receipt.purchasedProducts.splice(index, 1);
    };

    function disableAddProduct() {
      if (vm.receipt.purchasedProduct == null || vm.receipt.purchasedProduct.product == null || vm.receipt.purchasedProduct.product.name == null ||
        (vm.receipt.purchasedProduct.product.eanCodes == null && vm.receipt.purchasedProduct.product.eanCode == null) ||
        vm.receipt.purchasedProduct.product.brand == null ||
        (vm.receipt.gift === 'Y' && vm.receipt.purchasedProduct.giftReceiverEmail == null) ||
        (vm.receipt.purchasedProduct.typeCode !== null && vm.receipt.purchasedProduct.typeCode === 'EAN' && vm.isValidCode === false)
      ) {
        return true;
      } else return false;
    }

    $translate('garanteasyApp.receipt.detail.required').then(function (headline) {
      vm.messageValidationRequired = headline;
      vm.message = headline;
    }, function (translationId) {
      $log.error("Missing translation for", translationId);
    });

    $translate('garanteasyApp.receipt.receiptNewPage.codeValidation').then(function (headline) {
      vm.messageValidationCodeNotValid = headline;
    }, function (translationId) {
      $log.error("Missing translation for", translationId);
    });

    vm.deleteFile = function (receiptFile, isProduct) {
      var index;
      if (isProduct) {
        index = vm.receipt.purchasedProduct.receiptFiles.indexOf(receiptFile);
        return vm.receipt.purchasedProduct.receiptFiles.splice(index, 1);
      }
      index = vm.receiptFiles.indexOf(receiptFile);
      if (!receiptFile.id) {
        vm.receiptFile = {};
        vm.receiptFiles.splice(index, 1);
      } else {
        ReceiptFile.delete({id: receiptFile.id}, function () {
          vm.receiptFiles.splice(index, 1);
        });
      }
    };


    function ccc13() {
      if (vm.receipt.purchasedProduct.typeCode !== null && vm.receipt.purchasedProduct.typeCode === 'EAN') {
        var factor = 3;
        var sum = 0;
        // var form = {};
        var number = '' + vm.receipt.purchasedProduct.product.eanCode;
        if (number === 'null') {
          vm.message = vm.messageValidationRequired;
        } else if (number.length !== 13) {
          vm.isValidCode = false;
          vm.message = vm.messageValidationCodeNotValid;
        } else if (number.length === 13) {
          vm.result = number.substring(0, 12);
          for (var index = 12; index > 0; --index) {
            sum = sum + number.substring(index - 1, index) * factor;
            factor = 4 - factor;
          }
          if (number.length !== 13) {
            vm.validationCodeMessage = 'FAI ATTENZIONE! Introdurre 12 digits';
          } else {
            var cc = ((1000 - sum) % 10);
            vm.result = vm.result + cc;
          }
          if (number === vm.result) {
            vm.isValidCode = true;
          } else {
            vm.isValidCode = false;
            vm.message = vm.messageValidationCodeNotValid;
          }
        }
      } else vm.isValidCode = true;
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptDialogController', ReceiptDialogController);

    ReceiptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Principal', 'Receipt', 'Customer', 'Contact', 'PurchasedProduct', 'Shop', 'Dashboard', 'SelectedMerchantService', 'Card', 'CustomerSearch'];

    function ReceiptDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Principal, Receipt, Customer, Contact, PurchasedProduct, Shop, Dashboard, SelectedMerchantService, Card, CustomerSearch) {
        var vm = this;

        vm.receipt = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customer = [];
        vm.shops = [];
        vm.merchants = [];
        vm.merchantWrap = function () {
            return {
                get merchant() {
                    if (vm.receipt && vm.receipt.shop)
                        return vm.receipt.shop.merchant;
                    else
                        return null;
                },
                set merchant(merchant) {
                    vm.receipt.shop = { merchant: merchant };
                    SelectedMerchantService.merchant = merchant;
                }
            };
        }
        var _currentMerchant = null;

        var onSuccessCustomers = function (data) {
            vm.customers = data;
        };

        var onError = function (error) {
            vm.isLoading = false;
            AlertService.error(error.data.message);
        };

        var onSuccessShop = function (data) {
            vm.shops = SelectedMerchantService.shops;
        };

        var onSuccessMerchants = function (data) {
            vm.merchants = SelectedMerchantService.merchants;
        };

        vm.loadCustomers = function (query) {
            if (SelectedMerchantService.merchant) {
                Dashboard.getMerchantCustomers({ merchant_id: SelectedMerchantService.merchant.id, query: query }, onSuccessCustomers);
            } else onSuccessCustomers([]);

        };

        SelectedMerchantService.onMerchantChange(function (data) {
            onSuccessMerchants();
            vm.loadCustomers();
            // onSuccessShop();
        });

        SelectedMerchantService.onShopChange(function (data) {
            onSuccessShop();
        });



        onSuccessMerchants();

        vm.loadCustomers();

        /*vm.cards = Card.queryActive(vm.receipt);*/
        vm.contacts = Contact.queryActive();


        $q.all([vm.receipt.$promise]).then(function () {
            if (!vm.receipt.shopId) {
                onSuccessShop();
                return $q.reject();
            }
            return Shop.get({ id: vm.receipt.shopId }).$promise;
        }).then(function (shop) {
            vm.shops = [];
            vm.shops.push(shop);
        });

        /* $q.all([vm.receipt.$promise, vm.cards.$promise]).then(function() {
             if (!vm.receipt.buyingDateng || !vm.customerId) {
                 return $q.reject();
             }
             return Card.queryActive({receipt : vm.receipt}).$promise;
         }).then(function(card) {
             vm.cards.push(card);
         });*/

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });
        vm.isValidInput = isValidInput;
        vm.validMerchant = null;
        vm.validAddress = null;

        // Le ricevute inviate da un negozio ufficiale (o in attesa di conferma dopo un claim) sono quasi totalmente readonly
        vm.isOfficial = vm.receipt.source == 'MERCHANT' || vm.receipt.source == 'CLAIM' || vm.receipt.source == 'CLAIM_RESOLVED';
        vm.isAdmin = null;
        vm.checkAccess = checkAccess;
        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                });
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.resetShop = function () {
            vm.receipt.shop = null;
        }

        $scope.resetMerchant = function () {
            if (vm.receipt.shop !== null) {
                vm.receipt.shop.merchant = null;
            }
        }


        $scope.loadCustomers = function (searchQuery) {
            if (searchQuery && searchQuery.trim().length > 1) {
                CustomerSearch.query({ query: searchQuery }, function (result) {
                    $scope.customers = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.customers = Customer.query();
                    }
                });
            } else {
                $scope.customers = CustomerSearch.query();
            }
        };





        $scope.loadActiveCards = function () {
            if (vm.receipt.customer)
                vm.receipt.customerId = vm.receipt.customer.id;
            if (vm.receipt.customer && vm.receipt.buyingDate)
                vm.cards = Card.queryActive(vm.receipt);
        };

        // Constraints beyond the ones in the form
        function isValidInput() {
            // No shop or existing shop are ok
            if (vm.receipt.shop == null || vm.receipt.shop.id != null) {
                return true;
            }

            // New shop must be validated
            // Merchant must be valid
            vm.validMerchant = vm.receipt.shop.merchant != null &&
                (vm.receipt.shop.merchant.id != null || (vm.receipt.shop.owner.name != null && vm.receipt.shop.owner.name.trim().length > 0));
            // And either ecommerce url or address must be valid
            vm.validAddress =
                (vm.receipt.shop.ecommerceUrl != null && vm.receipt.shop.ecommerceUrl.trim().length > 0)
                ||
                (vm.receipt.shop.address != null &&
                    vm.receipt.shop.address.street != null && vm.receipt.shop.address.street.trim().length > 0
                    && vm.receipt.shop.address.city != null && vm.receipt.shop.address.city.trim().length > 0);

            return vm.validMerchant && vm.validAddress;
        }

        function save() {
            vm.isSaving = true;
            if (vm.receipt.id !== null) {
                Receipt.update(vm.receipt, onSaveSuccess, onSaveError);
            } else {
                Receipt.save(vm.receipt, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('garanteasyApp:receiptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.buyingDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
  "use strict";

  angular
    .module("garanteasyApp")
    .controller("ReceiptDetailController", ReceiptDetailController);


  ReceiptDetailController.$inject = [
    "$state",
    "$scope",
    "$rootScope",
    "$stateParams",
    "previousState",
    "ReceiptFile",
    "DataUtils",
    "entity",
    "Principal",
    "Receipt",
    "Customer",
    "Contact",
    "PurchasedProduct",
    "AuthServerProvider",
    '$window',
    'CmsService',
    '$translate',
    'API_URI'
  ];

  function ReceiptDetailController(
    $state,
    $scope,
    $rootScope,
    $stateParams,
    previousState,
    ReceiptFile,
    DataUtils,
    entity,
    Principal,
    Receipt,
    Customer,
    Contact,
    PurchasedProduct,
    AuthServerProvider,
    $window,
    CmsService,
    $translate,
    API_URI
  ) {
    var vm = this;
    vm.reasons = [
      "EMAIL_UPDATE",
      "EMAIL_CHANGE",
      "RECEIPT",
      "DELETE_PROFILE",
      "OTHER"
    ];
    vm.printPdf = function () {
      var pdf = new $window.jsPDF();
      var content = document.getElementById('receipt-image-build-panel');
      pdf.addHTML(content, function () {
        pdf.save(vm.receipt.id + '.pdf');
      });
    };


    vm.receipt = entity;
    vm.customers = Customer.query();
    vm.contacts = Contact.queryActive();
    vm.saveGift = saveGift;
    vm.showBuildReceiptImage = showBuildReceiptImage;
    vm.printReceipt = printReceipt;
    vm.getImageUrl = getImageUrl;
    // Le ricevute inviate da un negozio ufficiale (o in attesa di conferma dopo un claim) sono quasi totalmente readonly
    vm.isOfficial =
      vm.receipt.source === "MERCHANT" ||
      vm.receipt.source === "CLAIM" ||
      vm.receipt.source === "CLAIM_RESOLVED";

    vm.isOwner = null;
    vm.isAdmin = null;
    vm.currentUserId;
    vm.images = [];
    vm.documents = [];
    vm.listSelected = [];
    vm.receiptFiles = [];
    vm.imagesPath = {};
    vm.cmsShop;

    vm.loadCmsShop = function (lang, cmsReference) {
      if (cmsReference) {
        CmsService.getShop(lang, cmsReference).then(function (res) {
          vm.cmsShop = res.data;
          var address = '';

          if (res.data.address_address_line1) {
            address += ' ' + res.data.address_address_line1;
          }
          if (res.data.address_address_line2) {
            address += ' ' + res.data.address_address_line2;
          }
          if (res.data.address_postal_code) {
            address += ' ' + res.data.address_postal_code;
          }
          if (res.data.address_locality) {
            address += ' ' + res.data.address_locality;
          }
          if (res.data.address_country_code) {
            address += ' ' + res.data.address_country_code;
          }

          vm.cmsShop.address = address;

        });
      }
    };
    vm.addPurchasedProductToListSelected = function () {
      if (
        vm.receipt.purchasedProducts &&
        vm.receipt.purchasedProducts.length === 1
      ) {
        vm.listSelected.splice(0, 0, vm.receipt.purchasedProducts[0]);
      }
    };
    vm.showCustomerName = function (customer) {
      return DataUtils.showCustomerName(customer);
    };
    vm.addPurchasedProductToListSelected();

    vm.enableButtonGift = function () {
      if (vm.receipt.purchasedProducts.length > 1) {
        return vm.listSelected.length > 0;
      } else return true;
    };

    vm.addToListSelected = function (index, pp) {
      if (vm.listSelected && vm.listSelected.indexOf(pp) < 0) {
        vm.listSelected.splice(index, 0, pp);
      } else if (vm.listSelected && vm.listSelected.indexOf(pp) >= 0) {
        for (var i = 0; i < vm.listSelected.length; i++) {
          if (vm.listSelected[i].id == pp.id) vm.listSelected.splice(i, 1);
        }
      }
    };
    init();
    /*        angular.forEach(vm.receipt.purchasedProducts, function (value) {
                    if (value) {
                        value.selected = false;
                    }
                });*/

    vm.goToGift = function () {
      $state.go("receipt/detail/editGift", {
        id: vm.receipt.id,
        listSelected: vm.listSelected
      });
    };

    vm.evaluateBusiness = function () {
      var value = vm.receipt.customer.business;
      if (angular.isUndefined(value) || value === null) {
        return 'nd';
      }
      if (value) {
        return 'professional';
      } else {
        return 'private';
      }
    }


    vm.actionReso = function () {
      if (vm.listSelected && vm.listSelected.length > 0) {
        $state.go("receipt/purchased-product-reso", {
          listSelected: vm.listSelected,
          id: vm.receipt.id,
          ppId: vm.listSelected[0].id
        });
      }
    };

    function saveGift() {
      vm.isSaving = true;
      if (vm.purchasedProduct.id !== null) {
        PurchasedProduct.update(
          vm.purchasedProduct,
          onSaveSuccess,
          onSaveError
        );
      } else {
        PurchasedProduct.save(vm.purchasedProduct, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit("garanteasyApp:purchasedProductUpdate", result);
      // $uibModalInstance.close(result);
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    if (vm.receipt.receiptFiles && vm.receipt.receiptFiles.length > 0) {
      vm.receipt.receiptFiles.forEach(function (item) {
        if (
          item.fileContentType &&
          item.fileContentType.toLowerCase().indexOf("image") == 0
        ) {
          vm.images.push(item);
        } else vm.documents.push(item);
      });
    }

    if (vm.images.length > 0) {
      vm.image = vm.images[0];
    }

    vm.changeMainImage = function (image) {
      $(".zoomContainer").remove();
      vm.image = image;
    };

    vm.checkAccess = checkAccess;
    checkAccess();

    vm.byteSize = DataUtils.byteSize;
    vm.openFile = DataUtils.openFile;

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        vm.currentUserId = account.id;
        if (vm.receipt.id && vm.receipt.customer && vm.receipt.customer.user) {
          vm.isOwner = vm.receipt.customer.user.id == account.id;
        } else {
          // New receipt
          vm.isOwner = true;
        }
        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
          vm.isAdmin = !!result;
        });
      }, onIdentityError());
    }

    function onIdentityError() {
      console.log("ERROR");
    }

    vm.canShow = function (contentType) {
      return (
        contentType != null &&
        contentType.toLowerCase().indexOf("image") == 0 &&
        contentType.toLowerCase().indexOf("tiff") == -1
      );
    };

    vm.deleteImage = function (image) {
      ReceiptFile.delete({
        id: image.id
      }, function () {
        var ind = vm.receipt.receiptFiles.indexOf(image);
        vm.receipt.receiptFiles.splice(ind, ind + 1);
        $(".zoomContainer").remove();
        vm.image = vm.receipt.receiptFiles[0];
      });
    };

    var unsubscribe = $rootScope.$on("garanteasyApp:receiptUpdate", function (
      event,
      result
    ) {
      vm.receipt = result;
    });

    $scope.$on("$destroy", unsubscribe);

    $(document).ready(function () {
      window.scrollTo(0, 0);
    });

    function init() {
      if (vm.receipt.receiptFiles && vm.receipt.receiptFiles.length > 0) {
        vm.receipt.receiptFiles.forEach(function (item) {
          if (!item.purchasedProductId) {
            item.src = getImageUrl(item);
            vm.receiptFiles.push(item);
          }
        });
        if ((vm.receipt.receiptType === 'RECEIPT' || !vm.receipt.receiptType || vm.receipt.receiptType === 'OFFICIAL_RECEIPT') && vm.receipt.shop) {
          vm.receiptFiles.push({
            fileContentType: 'build',
            receipt: vm.receipt
          });
        }
      }
      vm.loadCmsShop($translate.use(), vm.receipt.shop.cmsReference);
      $rootScope.$emit("enableMerchantSelector", false);
    }

    $scope.$on('$destroy', function dismissed() {
      $rootScope.$emit("enableMerchantSelector", true);
    })

    function showBuildReceiptImage() {
      return !vm.receiptFiles.length && vm.receipt.shop && !vm.isEdit && (vm.receipt.receiptType === 'RECEIPT' || !vm.receipt.receiptType || vm.receipt.receiptType === 'OFFICIAL_RECEIPT');
    }

    function printReceipt() {
      var content = document.getElementById('receiptPrintContent').innerHTML;
      var headContent = document.getElementsByTagName('head')[0].innerHTML;
      var popupWin = window.open('', '_blank');
      popupWin.document.open();
      var style = '.receipt-print{ max-width: 600px; } @media print {@page {size: A4 portrait; } .receipt-print{ max-width: 300px; margin: auto; padding: 0; }	}';
      popupWin.document.write('<html><head>' + headContent + '<style type="text/css">' + style + '</style></head><body onload="window.print()"><div class="receipt-print">' + content + '</div></body></html>');
      popupWin.document.close();
    }

    function getImageUrl(receiptFile) {
      if (!receiptFile || !receiptFile.id) {
        vm.imagesPath[receiptFile.id] = null;
      } else if (_.isUndefined(vm.imagesPath[receiptFile.id])) {
        vm.imagesPath[receiptFile.id] =
          API_URI + "api/receipt-files/content/" +
          receiptFile.id +
          "?token=" +
          AuthServerProvider.getToken();
      }
      return vm.imagesPath[receiptFile.id];
    }

  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptDeleteController',ReceiptDeleteController);

    ReceiptDeleteController.$inject = ['$uibModalInstance', 'entity', 'Receipt'];

    function ReceiptDeleteController($uibModalInstance, entity, Receipt) {
        var vm = this;

        vm.receipt = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Receipt.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ReceiptClaimController', ReceiptClaimController);

    ReceiptClaimController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'entity', 'Principal', 'LoginService', 'Contact', 'Receipt'];

    function ReceiptClaimController($timeout, $scope, $state, $stateParams, $uibModalInstance, entity, Principal, LoginService, Contact, Receipt) {
        var vm = this;

        vm.receiptMatcher = entity;
        vm.receiptMatcher.receiptIdentifier;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.find = find;
        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.error = null;

        vm.login = LoginService.open;
        vm.register = register;

        vm.contacts = [];
        vm.loggedUser = false;
        vm.checkAccess = checkAccess;
        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                if (account) {
                    console.log("Account=" + account.login);
                    vm.loggedUser = true;
                    vm.contacts = Contact.queryActive();
                } else {
                    console.log("Anonymous access");
                    vm.loggedUser = false;
                }
            }, function () {
                console.log("Principal.identity() failed");
                vm.loggedUser = false;
            });
        }

        function clear() {
            if ($uibModalInstance) {
                $uibModalInstance.dismiss('cancel');
            } else {
                window.location.href = "http://it.garanteasy.com";
            }
        }

        function find() {
            vm.isSaving = true;
            //console.log("Searching shop="+vm.receiptMatcher.shopCode+", counter="+vm.receiptMatcher.counterCode+", receipt="+vm.receiptMatcher.receiptNumber+", email="+vm.receiptMatcher.email);
            vm.results = Receipt.claim(vm.receiptMatcher, onFindSuccess, onFindError);
        }

        function onFindSuccess(result) {
            //console.log("Claim result:");
            //console.log(JSON.stringify(result, null, 4));
            if (result.errorCode) {
                vm.error = "garanteasyApp.receipt.error." + result.errorCode;
            } else {
                vm.error = 0;
            }
            vm.isSaving = false;
        }

        function onFindError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.buyingDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function register() {
            $state.go('register');
        }
    }
})();
;
(function () {
  "use strict";

  angular.module("garanteasyApp").config(stateConfig);

  stateConfig.$inject = ["$stateProvider"];

  function stateConfig($stateProvider) {
    $stateProvider
      .state("receipt", {
        parent: "entity",
        url: "/receipt?page&sort&search&documents&customers&shops&s",
        ncyBreadcrumb: {
          label: "{{'garanteasyApp.receipt.home.title' | translate}}"
        },
        data: {
          authorities: ["ROLE_USER"],
          pageTitle: "garanteasyApp.receipt.home.title"
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipts.html"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipts.html",
            controller: "ReceiptController",
            controllerAs: "vm"
          }
        },
        params: {
          page: {
            value: "0",
            squash: true
          },
          sort: {
            value: "id,desc",
            squash: true
          },
          search: null
        },
        resolve: {
          pagingParams: [
            "$stateParams",
            "PaginationUtil",
            function ($stateParams, PaginationUtil) {
              return {
                page: PaginationUtil.parsePage($stateParams.page),
                sort: $stateParams.sort,
                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                ascending: PaginationUtil.parseAscending($stateParams.sort),
                search: $stateParams.search
              };
            }
          ],
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("paymentType");
              $translatePartialLoader.addPart("dataSource");
              $translatePartialLoader.addPart("warranty");
              $translatePartialLoader.addPart("global");
              $translatePartialLoader.addPart("receiptType");
              $translatePartialLoader.addPart("receiptUse");
              return $translate.refresh();
            }
          ]
        }
      })
      .state("receiptFiltered", {
        parent: "entity",
        url: "/receipt",
        params: { filterWarranty: null },
        ncyBreadcrumb: {
          label: "{{'garanteasyApp.receipt.home.title' | translate}}"
        },
        data: {
          authorities: ["ROLE_USER"],
          pageTitle: "garanteasyApp.receipt.home.title"
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipts.html"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipts.html",
            controller: "ReceiptController",
            controllerAs: "vm"
          }
        },
        resolve: {
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("paymentType");
              $translatePartialLoader.addPart("dataSource");
              $translatePartialLoader.addPart("warranty");
              $translatePartialLoader.addPart("global");
              $translatePartialLoader.addPart("receiptType");
              return $translate.refresh();
            }
          ]
        }
      })
      .state("claimChiccoReceipt", {
        parent: "entity",
        url: "/claimChiccoReceipt",
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          pageTitle: "garanteasyApp.receipt.claim.title"
        },
        views: {
          "content@": {
            templateUrl: "app/entities/receipt/receipt-claim-dialog.html",
            controller: "ReceiptClaimController",
            controllerAs: "vm"
          }
        },
        resolve: {
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("home");
              $translatePartialLoader.addPart("global");
              return $translate.refresh();
            }
          ],
          //Definisco una modal instance nulla per usare lo stesso controller in versione modale e non modale
          $uibModalInstance: function () {
            return null;
          },
          // search parameters, will be mapped to ReceiptMatcherDTO
          entity: function () {
            return {
              shopCode: null,
              counterCode: null,
              receiptNumber: null,
              errorCode: null,
              email: null
            };
          }
        }
      })
      /* Equivalente dello stato claimChiccoReceipt chiamato con una dialog modale da dentro l'area riservata. Al momento si è deciso di non renderlo disponibile.
        .state('receiptClaim', {
            parent: 'entity',
            url: '/receiptClaim',
			ncyBreadcrumb: {
				skip: true // Never display this state in breadcrumb.
			},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/receipt/receipt-claim-dialog.html',
                    controller: 'ReceiptClaimController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('receipt');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        // search parameters, will be mapped to ReceiptMatcherDTO
                        entity: function () {
                            return {
                            	shopCode: null,
                            	counterCode: null,
                            	receiptNumber: null,
                            	receiptId: null,
                            	email: null
                            };
                        }
                    }
                }).result.then(function(receipt) {
                	console.log("Claimed receipt with id " + receipt.id);
                    $state.go('receipt.detail', {"id": receipt.id}, { reload: true });
                }, function() {
                    $state.go('receipt');
                });
            }]
        })
        */
      .state("receipt/detail", {
        parent: "entity",
        url: "/receipt/{id}?from",
        ncyBreadcrumb: {
          label: "{{'garanteasyApp.receipt.detail.title' | translate}}",
          parent: function ($scope) {
            return $scope.from || "receipt";
          }
        },
        data: {
          authorities: ["ROLE_USER"],
          pageTitle: "garanteasyApp.receipt.detail.title"
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipt-detail.html",
            controller: "ReceiptDetailController",
            controllerAs: "vm"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipt-detail.html",
            controller: "ReceiptDetailController",
            controllerAs: "vm"
          }
        },
        resolve: {
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader
                .addPart("address")
                .addPart("brand")
                .addPart("customer")
                .addPart("dataSource")
                .addPart("feedback")
                .addPart("merchant")
                .addPart("paymentType")
                .addPart("product")
                .addPart("purchasedProduct")
                .addPart("receipt")
                .addPart("receiptFile")
                .addPart("receiptType")
                .addPart("shop")
                .addPart("warranty")
                .addPart("warrantyClaim");
              return $translate.refresh();
            }
          ],
          entity: [
            "$stateParams",
            "Receipt",
            function ($stateParams, Receipt) {
              return Receipt.get({ id: $stateParams.id }).$promise;
            }
          ],
          previousState: [
            "$state",
            function ($state) {
              var currentStateData = {
                name: $state.current.name || "receipt",
                params: $state.params,
                url: $state.href($state.current.name, $state.params)
              };
              return currentStateData;
            }
          ]
        }
      })
      .state("receipt/detail/edit", {
        parent: "receipt/detail",
        url: "/detail/edit",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/receipt/receipt-dialog.html",
                controller: "ReceiptDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: [
                    "Receipt",
                    function (Receipt) {
                      return Receipt.get({ id: $stateParams.id }).$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("^", {}, { reload: false });
                },
                function () {
                  $state.go("^");
                }
              );
          }
        ]
      })
      .state("receipt/detail/editGift", {
        parent: "receipt/detail",
        url: "/detail/editGift",
        params: { id: null, listSelected: null },
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/receipt/receipt-gift-dialog.html",
                controller: "ReceiptGiftDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: [
                    "Receipt",
                    function (Receipt) {
                      return Receipt.get({ id: $stateParams.id }).$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("^", {}, { reload: false });
                },
                function () {
                  $state.go("^");
                }
              );
          }
        ]
      })
      .state("receipt/new", {
        parent: "receipt",
        url: "/new",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/receipt/receipt-dialog.html",
                controller: "ReceiptDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: function () {
                    return {
                      receiptNumber: null,
                      counterCode: null,
                      description: null,
                      creationDate: null,
                      buyingDate: null,
                      paymentType: null,
                      source: "DATAENTRY",
                      id: null
                    };
                  }
                }
              })
              .result.then(
                function () {
                  $state.go("receipt", null, { reload: true });
                },
                function () {
                  $state.go("receipt");
                }
              );
          }
        ]
      })
      /* Modifica dall'elenco attualmente disabilitata
            .state('receipt.edit', {
                parent: 'receipt',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/receipt/receipt-dialog.html',
                        controller: 'ReceiptDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Receipt', function(Receipt) {
                                return Receipt.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('receipt', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            */

      .state("receipt/delete", {
        parent: "receipt/detail",
        url: "/{id}/delete",
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/receipt/receipt-delete-dialog.html",
                controller: "ReceiptDeleteController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  entity: [
                    "Receipt",
                    function (Receipt) {
                      return Receipt.get({ id: $stateParams.id }).$promise;
                    }
                  ]
                }
              })
              .result.then(
                function (arg) {
                  if ($state.params.receiptId == undefined)
                    $state.go("receipt", null, { reload: true });
                  else
                    $state.go(
                      "receipt/detail",
                      { id: $state.params.receiptId },
                      {
                        reload: false,
                        location: true,
                        relative: false,
                        inherit: false
                      }
                    );
                },
                function () {
                  $state.go("^");
                }
              );
            /*    .result.then(function() {
                        $state.go('receipt', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });*/
          }
        ]
      })
      .state("receipt/feedback-new", {
        parent: "receipt/detail",
        url: "/{id}/addReceiptFeedback",
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/feedback/feedback-dialog.html",
                controller: "FeedbackDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: function () {
                    return {
                      description: null,
                      creationDate: new Date(),
                      feedbackType: "BUYING",
                      id: null,
                      parentId: $stateParams.id
                    };
                  }
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/feedback-edit", {
        parent: "receipt/detail",
        url: "/{id}/editReceiptFeedback/{feedbackId}",
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/feedback/feedback-dialog.html",
                controller: "FeedbackDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: [
                    "Feedback",
                    function (Feedback) {
                      return Feedback.get({ id: $stateParams.feedbackId })
                        .$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/feedback-delete", {
        parent: "receipt/detail",
        url: "/{id}/deleteReceiptFeedback/{feedbackId}",
        ncyBreadcrumb: {
          skip: true // Never display this state in breadcrumb.
        },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/feedback/feedback-delete-dialog.html",
                controller: "FeedbackDeleteController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  entity: [
                    "Feedback",
                    function (Feedback) {
                      return Feedback.get({ id: $stateParams.feedbackId })
                        .$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/receipt-file-new", {
        parent: "receipt/detail",
        url: "/{id}/addReceiptFile",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/receipt-file/receipt-file-dialog.html",
                controller: "ReceiptFileDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  entity: function () {
                    return {
                      fileName: null,
                      fileContentType: null,
                      receiptId: $stateParams.id,
                      id: null
                    };
                  }
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/receipt-file-delete", {
        parent: "receipt/detail",
        url: "/{rfId}/deleteReceiptFile",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/receipt-file/receipt-file-delete-dialog.html",
                controller: "ReceiptFileDeleteController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  entity: [
                    "ReceiptFile",
                    function (ReceiptFile) {
                      return ReceiptFile.get({ id: $stateParams.rfId })
                        .$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/purchased-product-new", {
        parent: "receipt/detail",
        url: "/{id}/addPurchasedProduct/{addClaim}",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/purchased-product/purchased-product-dialog.html",
                controller: "PurchasedProductDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "lg",
                resolve: {
                  translatePartialLoader: [
                    "$translate",
                    "$translatePartialLoader",
                    function ($translate, $translatePartialLoader) {
                      $translatePartialLoader.addPart("purchasedProduct");
                      $translatePartialLoader.addPart("product");
                      $translatePartialLoader.addPart("global");
                      return $translate.refresh();
                    }
                  ],
                  entity: function () {
                    return {
                      serialNumber: null,
                      giftReceiverEmail: null,
                      giftReceiverDescription: null,
                      receiptId: $stateParams.id
                    };
                  }
                }
              })
              .result.then(
                function (entity) {
                  if ($stateParams.addClaim) {
                    $state.go(
                      "purchased-product/warranty-claim-new",
                      { id: entity.id },
                      { reload: false }
                    );
                  } else {
                    $state.go("receipt/detail", null, { reload: true });
                  }
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      /* Modifica dall'elenco attualmente disabilitata
		.state('receipt.purchased-product-edit', {
		    parent: 'receipt.detail',
		    url: '/{ppId}/editPurchasedProduct',
		    data: {
		        authorities: ['ROLE_USER']
		    },
		    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
		        $uibModal.open({
		            templateUrl: 'app/entities/purchased-product/purchased-product-dialog.html',
		            controller: 'PurchasedProductDialogController',
		            controllerAs: 'vm',
		            backdrop: 'static',
		            size: 'lg',
		            resolve: {
		                entity: ['PurchasedProduct', function(PurchasedProduct) {
		                    return PurchasedProduct.get({id : $stateParams.ppId}).$promise;
		                }]
		            }
		        }).result.then(function() {
		            $state.go('receipt.detail', null, { reload: true });
		        }, function() {
		            $state.go('receipt.detail');
		        });
		    }]
		})
		*/
      .state("receipt/purchased-product-delete", {
        parent: "receipt/detail",
        url: "/{ppId}/deletePurchasedProduct",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/purchased-product/purchased-product-delete-dialog.html",
                controller: "PurchasedProductDeleteController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  entity: [
                    "PurchasedProduct",
                    function (PurchasedProduct) {
                      return PurchasedProduct.get({ id: $stateParams.ppId })
                        .$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/purchased-product-reso", {
        parent: "receipt/detail",
        url: "/{ppId}/resoPurchasedProduct",
        params: { listSelected: null },
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl:
                  "app/entities/purchased-product/purchased-product-reso-dialog.html",
                controller: "PurchasedProductResoController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  entity: [
                    "PurchasedProduct",
                    function (PurchasedProduct) {
                      return PurchasedProduct.get({ id: $stateParams.ppId })
                        .$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  $state.go("receipt/detail", null, { reload: true });
                },
                function () {
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      })
      .state("receipt/new_page", {
        parent: "entity",
        url: "/new",
        data: {
          authorities: ["ROLE_USER"]
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipts.html"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipt-new-page.html",
            controller: "ReceiptDialogControllerPage",
            controllerAs: "vm"
          }
        },
        resolve: {
          entity: function () {
            return {
              receiptNumber: null,
              counterCode: null,
              description: null,
              creationDate: null,
              buyingDate: null,
              paymentType: null,
              source: "DATAENTRY",
              id: null
            };
          },
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("paymentType");
              $translatePartialLoader.addPart("dataSource");
              $translatePartialLoader.addPart("warranty");
              $translatePartialLoader.addPart("global");
              $translatePartialLoader.addPart("receiptType");
              $translatePartialLoader.addPart("address");
              return $translate.refresh();
            }
          ]
        }
      })
      .state("receipt/gift-delete", {
        parent: "receipt/detail",
        url: "/{giftId}/deleteGift",
        data: {
          authorities: ["ROLE_USER"]
        },
        onEnter: [
          "$stateParams",
          "$state",
          "$uibModal",
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: "app/entities/gift/gift-delete-dialog.html",
                controller: "GiftDeleteController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                  translatePartialLoader: [
                    "$translate",
                    "$translatePartialLoader",
                    function ($translate, $translatePartialLoader) {
                      $translatePartialLoader.addPart("purchasedProduct");
                      return $translate.refresh();
                    }
                  ],
                  entity: [
                    "Gift",
                    function (Gift) {
                      return Gift.get({ id: $stateParams.giftId }).$promise;
                    }
                  ]
                }
              })
              .result.then(
                function () {
                  //After deletion go to all receipts, since most of the times the receipt that contained the gift is
                  //no longer visible to the gift receiver
                  $state.go("receipt", null, { reload: true });
                },
                function () {
                  //If operation is canceled stay where you are
                  $state.go("receipt/detail");
                }
              );
          }
        ]
      }).state("receipt/fast_track", {
        parent: "entity",
        url: "/fast/:type",
        data: {
          authorities: ["ROLE_USER"]
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipts.html"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipt-fast-track.html",
            controller: "ReceiptFastTrackController",
            controllerAs: "vm"
          }
        },
        resolve: {
          entity: function () {
            return {
              receiptNumber: null,
              counterCode: null,
              description: null,
              creationDate: null,
              buyingDate: null,
              paymentType: null,
              source: "DATAENTRY",
              id: null
            };
          },
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("paymentType");
              $translatePartialLoader.addPart("dataSource");
              $translatePartialLoader.addPart("warranty");
              $translatePartialLoader.addPart("global");
              $translatePartialLoader.addPart("receiptType");
              $translatePartialLoader.addPart("receiptUse");
              $translatePartialLoader.addPart("address");
              $translatePartialLoader.addPart("timeUnit");
              $translatePartialLoader.addPart("bar-code-reader");
              return $translate.refresh();
            }
          ]
        }
      }).state("receipt/customer", {
        parent: "entity",
        url: "/receipt/customer/{customerId}",
        ncyBreadcrumb: {
          label: "{{'garanteasyApp.receipt.home.title' | translate}}"
        },
        data: {
          authorities: ["ROLE_USER"],
          pageTitle: "garanteasyApp.receipt.home.title"
        },
        views: {
          "sidebar@": {
            templateUrl: "app/entities/receipt/sidebar-receipts.html"
          },
          "content@": {
            templateUrl: "app/entities/receipt/receipts.html",
            controller: "ReceiptController",
            controllerAs: "vm"
          }
        },
        params: {
          page: {
            value: "0",
            squash: true
          },
          sort: {
            value: "id,desc",
            squash: true
          },
          search: null
        },
        resolve: {
          pagingParams: [
            "$stateParams",
            "PaginationUtil",
            function ($stateParams, PaginationUtil) {
              return {
                page: PaginationUtil.parsePage($stateParams.page),
                sort: $stateParams.sort,
                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                ascending: PaginationUtil.parseAscending($stateParams.sort),
                search: $stateParams.search
              };
            }
          ],
          translatePartialLoader: [
            "$translate",
            "$translatePartialLoader",
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart("receipt");
              $translatePartialLoader.addPart("paymentType");
              $translatePartialLoader.addPart("dataSource");
              $translatePartialLoader.addPart("warranty");
              $translatePartialLoader.addPart("global");
              $translatePartialLoader.addPart("receiptType");
              $translatePartialLoader.addPart("receiptUse");
              return $translate.refresh();
            }
          ]
        }
      });
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Receipt', Receipt);

  Receipt.$inject = ['$resource', 'DateUtils', '$filter', 'API_URI'];

  function Receipt($resource, DateUtils, $filter, API_URI) {
    var resourceUrl = API_URI + 'api/receipts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.creationDate = DateUtils.convertLocalDateFromServer(data.creationDate);
            data.buyingDate = DateUtils.convertLocalDateFromServer(data.buyingDate);
            if (!data.purchasedProducts) {
              data.purchasedProducts = [];
            }
          }
          return data;
        }
      },
      'getReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsByMerchant': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsByMerchantAndShop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'searchReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getValid': {
        method: 'GET',
        url: API_URI + 'api/receipts/validReceipts',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
          dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
          dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      },
      'getMerchants': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/merchants',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'claim': {
        method: 'POST',
        url: API_URI + 'api/receipts/claim',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          if (dataToSend.receiptIdentifier) {
            //IT100003007000012562120161205
            //01234567890123456789012345678
            //          1111111111222222222
            dataToSend.shopCode = dataToSend.receiptIdentifier.substr(4, 5);
            dataToSend.counterCode = dataToSend.receiptIdentifier.substr(9, 2);
            var pattern = /(\d{4})(\d{2})(\d{2})/;
            dataToSend.buyingDate = new Date(dataToSend.receiptIdentifier.substr(21, 8).replace(pattern, '$1-$2-$3'));
          } else {
            dataToSend.receiptIdentifier = "IT10" + dataToSend.shopCode + dataToSend.counterCode + dataToSend.receiptNumber + $filter('date')(dataToSend.buyingDate, 'yyyyMMdd');
          }
          dataToSend.receiptNumber = dataToSend.receiptIdentifier;
          dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
          return angular.toJson(dataToSend);
        }
      },
      'getCustomerReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customer_receipts/:customer_id/?',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ReceiptSearch', ReceiptSearch);

  ReceiptSearch.$inject = ['$resource', 'API_URI'];

  function ReceiptSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/receipts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'getReceiptsSearched': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .directive('backImg', function () {
      return function (scope, element, attrs) {
        var defaultImg = '/content/images/empty-product-placeholder.png';
        if (attrs.backImgDefault === 'shop') {
          defaultImg = '/content/images/empty-shop-placeholder.png';
        } else if (attrs.backImgDefault === 'warranty') {
          defaultImg = '/content/images/empty-warranty-placeholder.png';
        }
        var url = attrs.backImg ? attrs.backImg : defaultImg;
        element.css({
          'background-image': 'url(' + url + ')'
        });
      };
    })
    .controller('ReceiptController', ReceiptController);
  ReceiptController.$inject = ['$state', 'DataUtils', 'Receipt', 'Principal', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$rootScope', 'Searchbar', 'bsScreenSize', 'SelectedMerchantService', '$scope'];

  function ReceiptController($state, DataUtils, Receipt, Principal, ParseLinks, AlertService, pagingParams, paginationConstants, $rootScope, Searchbar, bsScreenSize, SelectedMerchantService, $scope) {
    var vm = this;
    vm.receipts = [];
    vm.loadPage = loadPage;
    vm.page = 0;
    vm.gridView = $rootScope.gridView;
    vm.links = {
      last: 0
    };
    vm.isLoading = false;
    vm.reset = reset;
    vm.clear = clear;
    vm.loadAll = loadAll;
    vm.screenSize = bsScreenSize.state;

    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.page = pagingParams.page;
    vm.itemsPerPage = paginationConstants.itemsPerPage;

    vm.openFile = DataUtils.openFile;
    vm.byteSize = DataUtils.byteSize;
    vm.abbreviate = DataUtils.abbreviate;
    vm.transition = transition;
    vm.currentUserId = null;
    vm.isAdmin = null;

    vm.model = {
      get merchant() {
        return SelectedMerchantService.merchant;
      },
      set merchant(item) {
        return SelectedMerchantService.merchant = item;
      },
      get shop() {
        return SelectedMerchantService.shop;
      },
      set shop(item) {
        return SelectedMerchantService.shop = item;
      }
    };

    checkSize();

    vm.validWarranties = 0;
    vm.expiredWarranties = 0;
    vm.checkAccess = checkAccess;
    checkAccess();
    vm.showCustomerName = function (customer) {
      return DataUtils.showCustomerName(customer);
    };

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        vm.currentUserId = account.id;
        Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
          if (result) {
            vm.isAdmin = true;
          } else {
            vm.isAdmin = false;
          }
        });
      });
    }

    vm.totalNumExpired = 0;
    vm.totalNumValid = 0;
    vm.totalNumExpiring = 0;
    loadAll();

    function checkSize() {
      if (vm.screenSize === 'md' || vm.screenSize === 'lg') {
        vm.gridView = false;
      }
    }

    function loadData() {
      vm.receipts = []
      loadAll()
    }

    function loadAll(stringSearch) {
      if (vm.isLoading) return;
      vm.isLoading = true;
      if (!$state.params.customerId) {
        Receipt.getReceiptsByMerchantAndShop({
          merchant_id: vm.model.merchant && vm.model.merchant.id,
          shop_id: vm.model.shop && vm.model.shop.id,
          page: vm.page,
          size: 20,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Receipt.getCustomerReceipts({
          customer_id: $state.params.customerId,
          page: vm.page,
          size: 20,
          sort: sort()
        }, onSuccess, onError);
      }

    }

    function sort() {
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'id') {
        result.push('id');
      }
      return result;
    }

    function onSuccess(data, headers) {
      if (headers('Link')) {
        vm.links = ParseLinks.parse(headers('Link'));
      }
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      vm.itemsPerPage = 20;
      vm.receipts = vm.receipts.concat(data);
      vm.isLoading = false;
    }

    function onError(error) {
      vm.isLoading = false;
      AlertService.error(error.data.message);
    }

    vm.getValidReceipts = function () {
      Receipt.getValid({}, onSuccess, onError);
      vm.valid = vm.validReceipt;

      function onSuccess(data) {
        vm.validWarranties = data.valid;
        vm.expiredWarranties = data.expired;
        vm.expiringWarranties = data.expiring;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }

    }

    vm.getValidReceipts();

    function loadPage(page) {
      vm.page = page;
      vm.loadAll();
    }

    function transition() {
      reset();
      vm.loadAll();
    }

    function reset() {
      vm.page = 0;
      vm.receipts = [];
    }

    function clear() {
      vm.links = null;
      vm.page = 0;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }

    vm.listenerMerchant = SelectedMerchantService.onMerchantChange(loadData);
    vm.listenerShop = SelectedMerchantService.onShopChange(loadData);

    $scope.$on('$destroy', function () {
      vm.listenerMerchant();
      vm.listenerShop();
    });

  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductWarrantyDialogController', PurchasedProductWarrantyDialogController);

    PurchasedProductWarrantyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PurchasedProductWarranty', 'PurchasedProduct', 'Warranty'];

    function PurchasedProductWarrantyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PurchasedProductWarranty, PurchasedProduct, Warranty) {
        var vm = this;

        vm.purchasedProductWarranty = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        // Carica il purchased product con le garanzie certificate del brand, se esistono
        vm.loadPurchasedProduct = loadPurchasedProduct;
        vm.purchasedProduct = {};
       	loadPurchasedProduct($stateParams.id);
        
        function loadPurchasedProduct (id) {
        	PurchasedProduct.get({id: id}, function(result) {
                vm.purchasedProduct = result;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            PurchasedProductWarranty.save(vm.purchasedProductWarranty, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyEntitiesApp:purchasedProductWarrantyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.expirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductWarrantyDeleteController',PurchasedProductWarrantyDeleteController);

    PurchasedProductWarrantyDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasedProductWarranty', 'Warranty', 'PurchasedProduct'];

    function PurchasedProductWarrantyDeleteController($uibModalInstance, entity, PurchasedProductWarranty, Warranty, PurchasedProduct) {
        var vm = this;

        vm.purchasedProductWarranty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        // Carica la warranty
        vm.loadWarranty = loadWarranty;
        vm.warranty = {};
       	loadWarranty(vm.purchasedProductWarranty.warrantyId);
        
        function loadWarranty (id) {
        	Warranty.get({id: id}, function(result) {
                vm.warranty = result;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	PurchasedProductWarranty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchased-product-warranty', {
                parent: 'entity',
                url: '/purchased-product-warranty',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.purchasedProductWarranty.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranties.html',
                        controller: 'PurchasedProductWarrantyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchasedProductWarranty');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchased-product-warranty-detail', {
                parent: 'entity',
                url: '/purchased-product-warranty/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.purchasedProductWarranty.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-detail.html',
                        controller: 'PurchasedProductWarrantyDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchasedProductWarranty');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchasedProductWarranty', function ($stateParams, PurchasedProductWarranty) {
                        return PurchasedProductWarranty.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'purchased-product-warranty',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('purchased-product-warranty-detail/edit', {
                parent: 'purchased-product-warranty-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-dialog.html',
                        controller: 'PurchasedProductWarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PurchasedProductWarranty', function (PurchasedProductWarranty) {
                                return PurchasedProductWarranty.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('purchased-product-warranty/new', {
                parent: 'purchased-product-warranty',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-dialog.html',
                        controller: 'PurchasedProductWarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    expirationDate: null,
                                    notifiedApplication: 0,
                                    notifiedExpiration: 0,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('purchased-product-warranty', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product-warranty');
                    });
                }]
            })
            .state('purchased-product-warranty/edit', {
                parent: 'purchased-product-warranty',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-dialog.html',
                        controller: 'PurchasedProductWarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PurchasedProductWarranty', function (PurchasedProductWarranty) {
                                return PurchasedProductWarranty.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product-warranty', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('purchased-product-warranty/delete', {
                parent: 'purchased-product-warranty',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-delete-dialog.html',
                        controller: 'PurchasedProductWarrantyDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PurchasedProductWarranty', function (PurchasedProductWarranty) {
                                return PurchasedProductWarranty.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product-warranty', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PurchasedProductWarranty', PurchasedProductWarranty);

  PurchasedProductWarranty.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function PurchasedProductWarranty($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/purchased-product-warranties/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.expirationDate = DateUtils.convertLocalDateFromServer(data.expirationDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductResoController',PurchasedProductResoController);

    PurchasedProductResoController.$inject = ['$stateParams','$uibModalInstance', 'entity', 'PurchasedProduct'];

    function PurchasedProductResoController($stateParams, $uibModalInstance, entity, PurchasedProduct) {
        var vm = this;

        var params = $stateParams.listSelected;
        vm.purchasedProduct = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

            function confirmDelete (id) {
                if(params && params.length > 0){
                    angular.forEach(params, function (item) {
                        PurchasedProduct.delete({id: item.id},
                            function () {
                                $uibModalInstance.close(true);
                            });
                    });
                }
            }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductDialogController', PurchasedProductDialogController);

    PurchasedProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Principal', 'PurchasedProduct', 'Receipt', 'Brand', 'BrandLookup', 'Product', 'ProductLookup', 'PurchasedProductWarranty', 'WarrantyClaim', 'IceProductLookup', 'IcecatSimpleProduct'];

    function PurchasedProductDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Principal, PurchasedProduct, Receipt, Brand, BrandLookup, Product, ProductLookup, PurchasedProductWarranty, WarrantyClaim, IceProductLookup, IcecatSimpleProduct) {
        var vm = this;

        vm.purchasedProduct = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.brands = Brand.query();
        vm.products = Product.query({ filter: 'purchasedproduct-is-null' });

        $q.all([vm.purchasedProduct.$promise, vm.products.$promise]).then(function () {
            if (!vm.purchasedProduct.productId) {
                return $q.reject();
            }
            return Product.get({ id: vm.purchasedProduct.productId }).$promise;
        }).then(function (product) {
            vm.products.push(product);
        });

        vm.purchasedproductwarranties = PurchasedProductWarranty.query();
        vm.warrantyclaims = WarrantyClaim.query();
        vm.isValidInput = isValidInput;
        vm.hasProduct = null;
        vm.validProduct = null;
        vm.hasBrand = null;
        vm.validBrand = null;

        vm.isOwner = null;
        vm.isAdmin = null;
        vm.isGiftReceiver = null;

        vm.receiptIsOfficial = vm.purchasedProduct.receipt && (vm.purchasedProduct.receipt.source == 'MERCHANT' || vm.purchasedProduct.receipt.source == 'CLAIM' || vm.purchasedProduct.receipt.source == 'CLAIM_RESOLVED');

        vm.checkAccess = checkAccess;
        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                vm.isOwner = !vm.purchasedProduct.id || vm.purchasedProduct.receipt.customer.user.id == account.id;
                vm.isGiftReceiver = vm.purchasedProduct.giftReceiverUserId == account.id;
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                });
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.resetProduct = function () {
            vm.purchasedProduct.product = null;
        }

        $scope.resetBrand = function () {
            if (vm.purchasedProduct.product !== null) {
                vm.purchasedProduct.product.brand = null;
            }
        }

        $scope.loadProducts = function (searchQuery) {
            if (searchQuery && searchQuery.trim().length > 0) {
                ProductLookup.query({ query: searchQuery }, function (result) {
                    $scope.products = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.products = Product.query({ isActive: true });
                    }
                });
            } else {
                $scope.products = Product.query({ isActive: true });
            }
        };

        /*        $scope.loadIceProducts = function(searchQuery) {
                    if (searchQuery && searchQuery.trim().length > 0){
                        IceProductLookup.query({query: searchQuery}, function(result) {
                            $scope.products = result;
                        }, function(response) {
                            if(response.status === 404) {
                                $scope.products = Product.query({isActive: true});
                            }
                        });
                    } else {
                        $scope.products = Product.query({isActive: true});
                    }
                };*/

        $scope.loadBrands = function (searchQuery) {
            if (searchQuery) {
                BrandLookup.query({ query: searchQuery }, function (result) {
                    $scope.brands = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.brands = Brand.query({ isActive: true });
                    }
                });
            } else {
                $scope.brands = Brand.query({ isActive: true });
            }
        };

        function save() {
            vm.isSaving = true;
            var pp = angular.copy(vm.purchasedProduct);
            if (pp.product.idxId) {
                var allProductId = pp.product.idxId;
                pp.product = {};
                pp.allProductId = allProductId;
            }

            if (vm.purchasedProduct.id !== null) {
                PurchasedProduct.update(pp, onSaveSuccess, onSaveError);
            } else {
                PurchasedProduct.save(pp, onSaveSuccess, onSaveError);
            }
        }

        // Constraints beyond the ones in the form
        function isValidInput() {
            vm.hasProduct = vm.purchasedProduct.product != null;
            vm.validProduct = vm.hasProduct && vm.purchasedProduct.product.name != null && vm.purchasedProduct.product.name.trim().length > 0;
            vm.hasBrand = vm.hasProduct && vm.purchasedProduct.product.brand != null;
            /*vm.validBrand = vm.hasBrand && vm.purchasedProduct.product.brand.name != null && vm.purchasedProduct.product.brand.name.trim().length > 0;*/
            vm.validBrand = vm.hasBrand && vm.purchasedProduct.product.brand != null;
            return vm.validProduct && vm.validBrand;
        }

        function onSaveSuccess(result) {
            $scope.$emit('garanteasyApp:purchasedProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.deliveryDate = false;
        vm.datePickerOpenStatus.giftNotificationDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('PurchasedProductDetailController', PurchasedProductDetailController);

  PurchasedProductDetailController.$inject = ['$scope', '$rootScope', '$http', '$stateParams', 'previousState', 'entity', 'Principal', 'PurchasedProduct', 'Receipt', 'Gift', 'Product', 'PurchasedProductWarranty', 'WarrantyClaim', 'ProductResources', 'DEFAULT_BARCODE_ENCODING', 'DataUtils', 'bsScreenSize', 'AuthServerProvider', 'API_URI'];

  function PurchasedProductDetailController($scope, $rootScope, $http, $stateParams, previousState, entity, Principal, PurchasedProduct, Receipt, Gift, Product, PurchasedProductWarranty, WarrantyClaim, ProductResources, DEFAULT_BARCODE_ENCODING, DataUtils, bsScreenSize, ngGallery, AuthServerProvider, API_URI) {
    var vm = this;

    vm.purchasedProduct = entity;
    vm.carouselImages = [];
    vm.isOwner = null;
    vm.isAdmin = null;
    vm.isGiftReceiver = null;
    vm.canManageWarranties = null;
    vm.getImageUrl = getImageUrl;
    vm.checkAccess = checkAccess;
    vm.saveSerialNumber = saveSerialNumber;
    checkAccess();
    vm.imagesPath = {};
    vm.barCodes = [];
    vm.productEanCode = '';
    if (((vm.purchasedProduct || {}).eanCodes || []).length) {
      vm.purchasedProduct.eanCodes.forEach(function (item) {
        vm.barCodes.push(item);
      });

    }
    if (((vm.purchasedProduct || {}).sku)) {
      vm.barCodes.push(product.sku);
    }

    buildGallery();
    getProductData();

    function buildGallery() {

      if (vm.purchasedProduct.receiptFiles && vm.purchasedProduct.receiptFiles.length) {
        vm.purchasedProduct.receiptFiles = vm.purchasedProduct.receiptFiles.filter(function (item) {
          return item.purchasedProductId === vm.purchasedProduct.id;
        });
        vm.purchasedProduct.receiptFiles.forEach(function (file) {
          if (file && file.id && vm.canShow(file.fileContentType)) {
            file.src = vm.getImageUrl(file);
            vm.carouselImages.push(file);
          }
        });
      }
    }

    function getImageUrl(receiptFile) {
      if (!receiptFile || !receiptFile.id) {
        vm.imagesPath[receiptFile.id] = null;
      } else if (_.isUndefined(vm.imagesPath[receiptFile.id])) {
        vm.imagesPath[receiptFile.id] = API_URI + "api/receipt-files/content/" + receiptFile.id + "?width=-&height=377&token=" + AuthServerProvider.getToken();
      }
      return vm.imagesPath[receiptFile.id];
    }

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        vm.isOwner = vm.purchasedProduct.receipt.customer.user.id == account.id;
        vm.isGiftReceiver = vm.purchasedProduct.giftReceiverUserId == account.id;
        Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
          vm.isAdmin = !!result;
        });

        //If this is a gift, after notification warranties can be managed by gift receiver and not by owner
        vm.canManageWarranties = !vm.purchasedProduct.giftId || vm.isAdmin || (vm.isGiftReceiver && vm.purchasedProduct.giftReceiverNotified == 1) || (vm.isOwner && vm.purchasedProduct.giftReceiverNotified == 0);
      });
    }

    function getProductData() {
      Product.get({id: vm.purchasedProduct.product.id},
        function (product) {
          vm.barCodes = [];
          vm.manuals = (product || {}).manuals;

          if (((product || {}).eanCodes || []).length) {
            product.eanCodes.forEach(function (item) {
              if (item !== product.brandEanCode && !vm.productEanCode) {
                vm.productEanCode = item;
              }
              vm.barCodes.push(item);
            });

          }
          if (((product || {}).sku)) {
            vm.barCodes.push(product.sku);
          }
          if (product && product.images && product.images.length) {
            product.images.forEach(function (image) {
              if (image.localCopy === null || image.localCopy) {
                image.src = API_URI + 'api/product-resources/image/' + image.id + '?width=-&heigth=350';
              } else {
                image.src = image.value;
              }
              vm.carouselImages.push(image);
            });
            product.images.sort(function (a, b) {
              if (a.main) {
                return -1;
              } else if (b.main) {
                return 1;
              }
              return 0;
            });
          }
        }, function (error) {
          $log.error(error);
        });
    }

    function saveSerialNumber() {
      PurchasedProduct.update(vm.purchasedProduct, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess() {

    }

    function onSaveError() {

    }

    $(document).ready(function () {
      window.scrollTo(0, 0);
    });
  }


})
();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PurchasedProductDeleteController',PurchasedProductDeleteController);

    PurchasedProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'PurchasedProduct'];

    function PurchasedProductDeleteController($uibModalInstance, entity, PurchasedProduct) {
        var vm = this;

        vm.purchasedProduct = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PurchasedProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchased-product', {
                parent: 'entity',
                url: '/purchased-product?page&sort&search',
                ncyBreadcrumb: {
                    label: "{{'global.menu.products' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.purchasedProduct.home.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html'
                    },
                    'content@': {
                        templateUrl: 'app/entities/purchased-product/purchased-products.html',
                        controller: 'PurchasedProductController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: "1",
                        squash: true
                    },
                    sort: {
                        value: "id,desc",
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchasedProduct');
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('warranty');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            /*.state('purchased-product/detail', {
             parent: 'entity',
             url: '/purchased-product/{id}?from&receiptId',
             ncyBreadcrumb: {
             label: "{{'garanteasyApp.purchasedProduct.detail.title' | translate}}",
             parent: function ($scope) {
             return $scope.from || 'purchased-product';
             }
             },
             data: {
             authorities: ['ROLE_USER'],
             pageTitle: 'garanteasyApp.purchasedProduct.detail.title'
             },
             views: {
             'content@': {
             templateUrl: 'app/entities/purchased-product/purchased-product-detail.html',
             controller: 'PurchasedProductDetailController',
             controllerAs: 'vm'
             }
             },
             resolve: {
             translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
             $translatePartialLoader.addPart('purchasedProduct');
             $translatePartialLoader.addPart('receipt');
             $translatePartialLoader.addPart('warranty');
             $translatePartialLoader.addPart('warrantyClaim');
             $translatePartialLoader.addPart('warrantyClaimStatus');
             $translatePartialLoader.addPart('timeUnit');
             return $translate.refresh();
             }],
             entity: ['$stateParams', 'PurchasedProduct', function($stateParams, PurchasedProduct) {
             return PurchasedProduct.get({id : $stateParams.id}).$promise;
             }],
             previousState: ["$state", function ($state) {
             var currentStateData = {
             name: $state.current.name || 'purchased-product',
             params: $state.params,
             url: $state.href($state.current.name, $state.params)
             };
             return currentStateData;
             }]
             }
             })*/

            .state('purchased-product/detail', {
                parent: 'entity',
                url: '/purchasedProduct/{id}?from&receiptId',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.purchasedProduct.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || 'purchased-product';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.purchasedProduct.detail.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                    },
                    'content@': {
                        templateUrl: 'app/entities/purchased-product/purchased-product-detail.html',
                        controller: 'PurchasedProductDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchasedProduct');
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('warranty');
                        $translatePartialLoader.addPart('warrantyClaim');
                        $translatePartialLoader.addPart('warrantyClaimStatus');
                        $translatePartialLoader.addPart('timeUnit');
                        $translatePartialLoader.addPart('purchasedProductWarranty');
                        $translatePartialLoader.addPart('dashboard');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PurchasedProduct', function ($stateParams, PurchasedProduct) {
                        return PurchasedProduct.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'purchased-product',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            /*.state('purchased-product/detail/edit', {
             parent: 'purchased-product/detail',
             url: '/detail/edit',
             ncyBreadcrumb: {
             skip: true // Never display this state in breadcrumb.
             },
             data: {
             authorities: ['ROLE_USER']
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
             $uibModal.open({
             templateUrl: 'app/entities/purchased-product/purchased-product-dialog.html',
             controller: 'PurchasedProductDialogController',
             controllerAs: 'vm',
             backdrop: 'static',
             size: 'lg',
             resolve: {
             entity: ['PurchasedProduct', function(PurchasedProduct) {
             return PurchasedProduct.get({id : $stateParams.id}).$promise;
             }]
             }
             }).result.then(function() {
             $state.go('^', {}, { reload: false });
             }, function() {
             $state.go('^');
             });
             }]
             })*/

            .state('purchased-product/detail/edit', {
                parent: 'purchased-product/detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product/purchased-product-dialog.html',
                        controller: 'PurchasedProductDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PurchasedProduct', function (PurchasedProduct) {
                                return PurchasedProduct.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


            .state('purchased-product/new', {
                parent: 'purchased-product',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product/purchased-product-dialog.html',
                        controller: 'PurchasedProductDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    serialNumber: null,
                                    deliveryDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('purchased-product', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product');
                    });
                }]
            })
            /* Modifica dall'elenco attualmente disabilitata
        .state('purchased-product/edit', {
            parent: 'purchased-product',
            url: '/{id}/edit',
			ncyBreadcrumb: {
				skip: true // Never display this state in breadcrumb.
			},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchased-product/purchased-product-dialog.html',
                    controller: 'PurchasedProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchasedProduct', function(PurchasedProduct) {
                            return PurchasedProduct.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchased-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        */
            /*.state('purchased-product/delete', {
            parent: 'purchased-product',
            url: '/{id}/delete',
			ncyBreadcrumb: {
				skip: true // Never display this state in breadcrumb.
			},
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchased-product/purchased-product-delete-dialog.html',
                    controller: 'PurchasedProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchasedProduct', function(PurchasedProduct) {
                            return PurchasedProduct.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchased-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
            .state('purchased-product/delete', {
                parent: 'purchased-product/detail',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product/purchased-product-delete-dialog.html',
                        controller: 'PurchasedProductDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PurchasedProduct', function (PurchasedProduct) {
                                return PurchasedProduct.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function (arg) {
                        if ($state.params.receiptId == undefined)
                            $state.go('purchased-product', null, { reload: true });
                        else
                            $state.go('receipt.detail', { id: $state.params.receiptId }, { reload: false, location: true, relative: false, inherit: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('purchased-product/warranty-new', {
                parent: 'purchased-product/detail',
                url: '/{id}/addWarranty',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty/warranty-dialog.html',
                        controller: 'WarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    code: 'CUSTOM',
                                    description: null,
                                    reference: null,
                                    appliesFrom: null,
                                    appliesTo: null,
                                    legal: false,
                                    validity: null,
                                    validityUnit: 'DAYS',
                                    official: 0,
                                    id: null,
                                    purchasedProductId: $stateParams.id
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })
            .state('purchased-product/warranty-select', {
                parent: 'purchased-product/detail',
                url: '/{id}/selectWarranty',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty/warranty-dialog-select.html',

                        controller: 'PurchasedProductWarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('purchasedProduct');
                                $translatePartialLoader.addPart('warranty');
                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    expirationDate: null,
                                    notifiedApplication: 0,
                                    notifiedExpiration: 0,
                                    notifiedClaimExpiration: 0,
                                    purchasedProductId: $stateParams.id,
                                    warrantyId: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })
            .state('purchased-product/warranty-edit', {
                parent: 'purchased-product/detail',
                url: '/{ppId}/{wId}/editWarranty',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty/warranty-dialog.html',
                        controller: 'WarrantyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Warranty', function (Warranty) {
                                return Warranty.get({ id: $stateParams.wId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })
            .state('purchased-product/warranty-delete', {
                parent: 'purchased-product/detail',
                url: '/{id}/deleteWarranty/{ppwId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/purchased-product-warranty/purchased-product-warranty-delete-dialog.html',
                        controller: 'PurchasedProductWarrantyDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PurchasedProductWarranty', function (PurchasedProductWarranty) {
                                return PurchasedProductWarranty.get({ id: $stateParams.ppwId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })
            /*.state('purchased-product/warranty-claim-new', {
            parent: 'purchased-product/detail',
            url: '/{id}/addWarrantyClaim',
			ncyBreadcrumb: {
				skip: true // Never display this state in breadcrumb.
			},
            data: {
                authorities: ['ROLE_USERPLUS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/warranty-claim/warranty-claim-dialog.html',
                    controller: 'WarrantyClaimDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('warrantyClaimStatus');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                requestDate: new Date(),
                                annotations: null,
                                status: 'WAITING',
                                closingDate: null,
                                id: null,
                                notifiedShop: 0,
                            	notifiedGaranteasy: 0,
                                purchasedProductId: $stateParams.id
                            };
                        }
                    }
                }).result.then(function(result) {
                    $state.go('warranty-claim-detail', {"id": result.id}, { reload: true });
                }, function() {
                    $state.go('purchased-product/detail');
                });
            }]
        })*/
            .state('purchased-product/warranty-claim-new', {
                parent: 'purchased-product/detail',
                url: '/{id}/addWarrantyClaim',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USERPLUS']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-dialog.html',
                        controller: 'WarrantyClaimDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('warrantyClaimStatus');
                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    requestDate: new Date(),
                                    annotations: null,
                                    status: 'WAITING',
                                    closingDate: null,
                                    id: null,
                                    notifiedShop: 0,
                                    notifiedGaranteasy: 0,
                                    purchasedProductId: $stateParams.id
                                };
                            }
                        }
                    }).result.then(function (result) {
                        $state.go('warranty-claim-detail', { "id": result.id }, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })

            /*.state('purchased-product/warranty-claim-edit', {
                parent: 'purchased-product/detail',
                url: '/{id}/editWarrantyClaim/{claimId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USERPLUS']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-dialog.html',
                        controller: 'WarrantyClaimDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaim', function(WarrantyClaim) {
                                return WarrantyClaim.get({id : $stateParams.claimId}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function() {
                        $state.go('purchased-product/detail');
                    });
                }]
            })*/
            .state('purchased-product/warranty-claim-edit', {
                parent: 'purchased-product/detail',
                url: '/{id}/editWarrantyClaim/{claimId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USERPLUS']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-dialog.html',
                        controller: 'WarrantyClaimDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaim', function (WarrantyClaim) {
                                return WarrantyClaim.get({ id: $stateParams.claimId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })
            /*.state('purchased-product/warranty-claim-delete', {
            parent: 'purchased-product/detail',
            url: '/{id}/deleteWarrantyClaim/{claimId}',
			ncyBreadcrumb: {
				skip: true // Never display this state in breadcrumb.
			},
            data: {
                authorities: ['ROLE_USERPLUS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/warranty-claim/warranty-claim-delete-dialog.html',
                    controller: 'WarrantyClaimDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['WarrantyClaim', function(WarrantyClaim) {
                            return WarrantyClaim.get({id : $stateParams.claimId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchased-product/detail', null, { reload: true });
                }, function() {
                    $state.go('purchased-product/detail');
                });
            }]
        })*/
            .state('purchased-product/warranty-claim-delete', {
                parent: 'purchased-product/detail',
                url: '/{id}/deleteWarrantyClaim/{claimId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USERPLUS']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim/warranty-claim-delete-dialog.html',
                        controller: 'WarrantyClaimDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WarrantyClaim', function (WarrantyClaim) {
                                return WarrantyClaim.get({ id: $stateParams.claimId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product/detail', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product/detail');
                    });
                }]
            })

            .state('purchased-product/gift-delete', {
                parent: 'purchased-product',
                url: '/{giftId}/deleteGift',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/gift/gift-delete-dialog.html',
                        controller: 'GiftDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('purchasedProduct');
                                return $translate.refresh();
                            }],
                            entity: ['Gift', function (Gift) {
                                return Gift.get({ id: $stateParams.giftId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('purchased-product', null, { reload: true });
                    }, function () {
                        $state.go('purchased-product');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PurchasedProduct', PurchasedProduct);

  PurchasedProduct.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function PurchasedProduct($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/purchased-products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.deliveryDate = DateUtils.convertLocalDateFromServer(data.deliveryDate);
            data.giftNotificationDate = DateUtils.convertLocalDateFromServer(data.giftNotificationDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.deliveryDate = DateUtils.convertLocalDateToServer(dataToSend.deliveryDate);
          dataToSend.giftNotificationDate = DateUtils.convertLocalDateToServer(dataToSend.giftNotificationDate);
          return angular.toJson(dataToSend);
        }
      },
      'updateList': {
        method: 'PUT',
        url: API_URI + 'api/purchased-products/purchased-products-list',
        transformRequest: function (data) {
          angular.forEach(data, function (item) {
            item.deliveryDate = DateUtils.convertLocalDateToServer(item.deliveryDate);
            item.giftNotificationDate = DateUtils.convertLocalDateToServer(item.giftNotificationDate);
          })
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.deliveryDate = DateUtils.convertLocalDateToServer(dataToSend.deliveryDate);
          dataToSend.giftNotificationDate = DateUtils.convertLocalDateToServer(dataToSend.giftNotificationDate);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('PurchasedProductSearch', PurchasedProductSearch);

  PurchasedProductSearch.$inject = ['$resource', 'API_URI'];

  function PurchasedProductSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/purchased-products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('PurchasedProductController', PurchasedProductController);

  PurchasedProductController.$inject = ['$scope', '$state', 'Principal', 'PurchasedProduct', 'PurchasedProductSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function PurchasedProductController($scope, $state, Principal, PurchasedProduct, PurchasedProductSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;
    $scope.stateData.vm = vm;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;
    vm.isAdmin = null;
    vm.currentUserId;

    checkAccess();

    function checkAccess() {
      Principal.identity().then(function (account) {
        if (!Principal.isAuthenticated()) {
          $state.go("home");
          return;
        }
        vm.currentUserId = account.id;
        Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
          if (result) {
            vm.isAdmin = true;
          } else {
            vm.isAdmin = false;
          }
        });
      });
    }

    vm.totalNumExpired = 0;
    vm.totalNumValid = 0;
    vm.totalNumExpiring = 0;

    loadAll();

    function loadAll() {
      if (pagingParams.search) {
        PurchasedProductSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        PurchasedProduct.query({
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.purchasedProducts = data;
        vm.page = pagingParams.page;
        for (var i = 0; i < data.length; i++) {
          vm.totalNumExpired += data[i].totalWarranties.numExpired;
          vm.totalNumValid += data[i].totalWarranties.numValid;
          vm.totalNumExpiring += data[i].totalWarranties.numExpiring;
        }
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }

    /*        var unsubscribe = $rootScope.$on('garanteasyApp:productUpdate', function(event, result) {
                vm.product = result;
            });
            $scope.$on('$destroy', unsubscribe);
            $scope.$on('$destroy', function(event, next, current) {
                $('.zoomContainer').remove();
            });*/
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('ProductResources', ProductResources);

  ProductResources.$inject = ['$resource', 'API_URI'];

  function ProductResources($resource, API_URI) {
    var resourceUrl = API_URI + 'api/product-resources/:id';

    var ret = $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'},
      'delete': {method: 'DELETE'}
    });

    ret.RType = {IMAGE: 'IMAGE', VIDEO: 'VIDEO', MANUAL: 'MANUAL'};

    return ret;
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Product', 'Brand', 'BrandLookup','DataUtils','Upload']; 
    
    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Product, Brand, BrandLookup, DataUtils) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.save = save;
        vm.brands = Brand.query({filter: 'product-is-null'});
        $q.all([vm.product.$promise, vm.brands.$promise]).then(function() {
            if (!vm.product.brand || !vm.product.brand.id) {
                return $q.reject();
            }
            return Brand.get({id : vm.product.brand.id}).$promise;
        }).then(function(brand) {
            vm.brands.push(brand);
        });
        vm.isValidInput = isValidInput;
        vm.hasBrand = null;
        vm.validBrand = null;

        $scope.resetBrand = function() {
           	vm.product.brand = null;
        }

        $scope.loadBrands = function(searchQuery) {
            if (searchQuery){
            	BrandLookup.query({query: searchQuery}, function(result) {
                    $scope.brands = result;
                }, function(response) {
                    if(response.status === 404) {
                        $scope.brands = Brand.query({isActive: true});
                    }
                });
            } else {
                $scope.brands = Brand.query({isActive: true});
            }
        };        

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        vm.uploadFile = function ($file) {
        	vm.productResource = [];
            vm.clear = clear;
            vm.save = save;
            vm.byteSize = DataUtils.byteSize;
            vm.openFile = DataUtils.openFile;
            vm.fileTooLarge = false;
                if ($file && $file.$error === 'pattern') {
                    return;
                }
                if ($file) {
                	if($file.size>5120000) {
                        vm.fileTooLarge = true;
                        // Reset data in case there was a previous image selected
                        vm.productResource.description = null;
                    	vm.productResource.productId = null;
                    	vm.productResource.fileData = null;
                    	vm.productResource.contentType = null;
                	} else {
                        vm.fileTooLarge = false;
    	                DataUtils.toBase64($file, function(base64Data) {
    	                    $scope.$apply(function() {
    	                    	vm.productResource.description = $file.name;
    	                    	vm.productResource.productId = vm.product.id;
    	                    	vm.productResource.fileData = base64Data;
    	                    	vm.productResource.contentType = $file.type;
    	                    });
    	                });
                	}
                }
            
        	
        	
//            Upload.upload({
//                url: 'upload/url',
//                data: {file: file, 'username': $scope.username}
//            }).then(function (resp) {
//                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
//            }, function (resp) {
//                console.log('Error status: ' + resp.status);
//            }, function (evt) {
//                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
//                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
//            });
        };

        
        function fileUploadSuccess(ret){
            vm.product.image = ret.data.data[0];
        }
        
        function fileUploadError(ret){
            this.onAjaxError(ret);
        }
        
        function deleteImage(){
        	vm.product.image = null;
            //this.$scope.$apply();
        }

        function save () {
            vm.isSaving = true;
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        // Constraints beyond the ones in the form
        function isValidInput () {
            vm.hasBrand = vm.product.brand != null;
            vm.validBrand = vm.hasBrand && vm.product.brand.name != null && vm.product.brand.name.trim().length > 0;

        	return vm.validBrand;
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'Principal', 'entity', 'Product', 'User', 'Brand', 'DataUtils', 'ProductResources', 'Maintenance', 'DEFAULT_BARCODE_ENCODING'];

    function ProductDetailController($scope, $rootScope, $stateParams, previousState, Principal, entity, Product, User, Brand, DataUtils, ProductResources, Maintenance, DEFAULT_BARCODE_ENCODING) {
        var vm = this;



        vm.barCodeOpt = undefined;
        vm.getBCOptions = function (format) {

            if (!vm.barCodeOpt) {

                vm.barCodeOpt = {
                    format: (format || DEFAULT_BARCODE_ENCODING).toUpperCase(),
                    lineColor: '#000000',
                    width: 2,
                    height: 100,
                    displayValue: true,
                    fontOptions: '',
                    font: 'monospace',
                    textAlign: 'center',
                    textPosition: 'bottom',
                    textMargin: 2,
                    fontSize: 20,
                    background: '#ffffff',
                    margin: 0,
                    marginTop: undefined,
                    marginBottom: undefined,
                    marginLeft: undefined,
                    marginRight: undefined,
                    valid: function (valid) {
                    }
                };
            }

            return vm.barCodeOpt
        };
        vm.product = entity;

        if (vm.product.images.length > 0) {
            vm.image = vm.product.images[0];
        }

        vm.changeMainImage = function (image) {
            if (vm.product.images != undefined && vm.product.images.length > 1) {
                $('.zoomContainer').remove();
                vm.image = image;
            }
        }

        if ($stateParams.from) {
            $scope.from = $stateParams.from
        }
        if ($stateParams.from2nd) {
            $scope.from2nd = $stateParams.from2nd
        }

        vm.isOwner = null;
        vm.isAdmin = null;




        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                vm.isOwner = vm.product.createdBy.id == account.id;
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                });
            });
        }

        vm.uploadFile = function ($file) {
            vm.productResource = {};

            vm.byteSize = DataUtils.byteSize;
            vm.openFile = DataUtils.openFile;
            vm.fileTooLarge = false;
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                if ($file.size > 5120000) {
                    vm.fileTooLarge = true;
                    // Reset data in case there was a previous image selected
                    vm.productResource.description = null;
                    vm.productResource.productId = null;
                    vm.productResource.fileData = null;
                    vm.productResource.contentType = null;
                    vm.productResource.type = null;
                } else {
                    vm.fileTooLarge = false;
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            vm.productResource.description = $file.name;
                            vm.productResource.productId = vm.product.id;
                            vm.productResource.fileData = base64Data;
                            vm.productResource.contentType = $file.type;
                            vm.productResource.type = ProductResources.RType.IMAGE;
                            ProductResources.save(vm.productResource, function (result) {
                                vm.product.images.push(result);
                                if (result) {
                                    vm.image = result;
                                    $('.zoomContainer').remove();
                                }
                            });
                        });
                    });
                }
            }
        };





        vm.deleteImage = function (image) {
            ProductResources.delete({ id: image.id }, function () {
                var ind = vm.product.images.indexOf(image);
                vm.product.images.splice(ind, ind + 1);
                $('.zoomContainer').remove();
                vm.image = vm.product.images[0];
            });
        };

        var unsubscribe = $rootScope.$on('garanteasyApp:productUpdate', function (event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
        $scope.$on('$destroy', function (event, next, current) {
            $('.zoomContainer').remove();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('product', {
                parent: 'entity',
                url: '/product?page&sort&search',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.product.home.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.product.home.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'content@': {
                        templateUrl: 'app/entities/product/products.html',
                        controller: 'ProductController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'name,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('brand');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('product-detail', {
                parent: 'entity',
                url: '/product/{id}?from&from2nd',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.product.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || $scope.from2nd || 'product';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/product-detail.html',
                        controller: 'ProductDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('purchasedProduct');
                        $translatePartialLoader.addPart('brand');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                        return Product.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'product',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('product-detail/edit', {
                parent: 'product-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Product', function (Product) {
                                return Product.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('product/new', {
                parent: 'product',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    description: null,
                                    category: null,
                                    eanCode: null,
                                    official: 0,
                                    transportable: 1,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('product', null, { reload: true });
                    }, function () {
                        $state.go('product');
                    });
                }]
            })
            .state('product/edit', {
                parent: 'product',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Product', function (Product) {
                                return Product.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('product/delete', {
                parent: 'product',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/product/product-delete-dialog.html',
                        controller: 'ProductDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Product', function (Product) {
                                return Product.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('product-detail/maintenance-new', {
                parent: 'product-detail',
                url: '/{id}/addMaintenance',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/maintenance/maintenance-dialog.html',
                        controller: 'MaintenanceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve:
                        {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('maintenance');
                                return $translate.refresh();
                            }],

                            entity: function () {
                                return {
                                    description: '',
                                    id: null,
                                    startVal: null,
                                    startType: null,
                                    intervalVal: null,
                                    intervalType: '',
                                    repetitions: null,
                                    productId: $stateParams.id
                                };
                            },
                            previousState: ["$state", function ($state) {
                                var currentStateData = {
                                    name: $state.current.name || 'product-detail',
                                    params: $state.params,
                                    url: $state.href($state.current.name, $state.params)
                                };
                                return currentStateData;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            })
            .state('product-detail/maintenance-edit', {
                parent: 'product-detail',
                url: '/{ppId}/{mId}/editMaintenance',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/maintenance/maintenance-dialog.html',
                        controller: 'MaintenanceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('maintenance');
                                return $translate.refresh();
                            }],
                            entity: ['Maintenance', function (Maintenance) {
                                return Maintenance.get({ id: $stateParams.mId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            })
            .state('product-detail/maintenance-delete', {
                parent: 'product-detail',
                url: '/{id}/deleteMaintenance/{pmId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/maintenance/maintenance-delete-dialog.html',
                        controller: 'MaintenanceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('maintenance');
                                return $translate.refresh();
                            }],
                            entity: ['Maintenance', function (Maintenance) {
                                return Maintenance.get({ id: $stateParams.pmId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            })
            .state('product-detail/link-new', {
                parent: 'product-detail',
                url: '/{id}/addLink',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/link/link-dialog.html',
                        controller: 'LinkDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve:
                        {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('maintenance');
                                return $translate.refresh();
                            }],

                            entity: function () {
                                return {
                                    description: '',
                                    value: '',
                                    id: null,
                                    productId: $stateParams.id
                                };
                            },
                            previousState: ["$state", function ($state) {
                                var currentStateData = {
                                    name: $state.current.name || 'product-detail',
                                    params: $state.params,
                                    url: $state.href($state.current.name, $state.params)
                                };
                                return currentStateData;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            })
            .state('product-detail/link-edit', {
                parent: 'product-detail',
                url: '/{ppId}/{lId}/editLink',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/link/link-dialog.html',
                        controller: 'LinkDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {

                            entity: ['ProductResources', function (ProductResources) {
                                return ProductResources.get({ id: $stateParams.lId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            })
            .state('product-detail/link-delete', {
                parent: 'product-detail',
                url: '/{id}/deleteLink/{lmId}',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/link/link-delete-dialog.html',
                        controller: 'LinkDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('maintenance');
                                return $translate.refresh();
                            }],
                            entity: ['ProductResources', function (ProductResources) {
                                return ProductResources.get({ id: $stateParams.lmId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('product-detail', null, { reload: true });
                    }, function () {
                        $state.go('product-detail');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Product', Product);

  Product.$inject = ['$resource', 'API_URI'];

  function Product($resource, API_URI) {
    var resourceUrl = API_URI + 'api/products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProductSearch', ProductSearch);

  ProductSearch.$inject = ['$resource', 'API_URI'];

  function ProductSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProductLookup', ProductLookup);

  ProductLookup.$inject = ['$resource', 'API_URI'];

  function ProductLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/all-products';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('ProductController', ProductController);

  ProductController.$inject = ['$scope', '$state', 'Product', 'ProductSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function ProductController($scope, $state, Product, ProductSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;

    loadAll();

    function loadAll() {
      if (pagingParams.search) {
        ProductSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Product.query({
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.products = data;
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('IcecatSimpleProduct', IcecatSimpleProduct);

  IcecatSimpleProduct.$inject = ['$resource', 'API_URI'];

  function IcecatSimpleProduct($resource, API_URI) {
    var resourceUrl = API_URI + 'api/ice-products/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('IceProductLookup', IceProductLookup);

  IceProductLookup.$inject = ['$resource', 'API_URI'];

  function IceProductLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/all-products';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PrivacyPolicy', PrivacyPolicy);

  PrivacyPolicy.$inject = ['$resource', 'API_URI'];

  function PrivacyPolicy($resource, API_URI) {
    var resourceUrl = API_URI + 'api/privacy-policies/:id';

    return $resource(resourceUrl, {}, {

      'reg': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/privacy-policies/reg',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'regMerchantCode': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/privacy-policies/reg/:merchant_code',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'requiredGet': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/privacy-policies/required',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'requiredPost': {
        method: 'POST',
        url: API_URI + 'api/privacy-policies/required',
        isArray: true
        /* transformRequest: function (data) {
             var dataToSend = angular.copy(data);
             return angular.toJson(dataToSend);
         }*/
      }
    });
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PersistentAuditEvent', PersistentAuditEvent);

  PersistentAuditEvent.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function PersistentAuditEvent($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/contacts/:id';
    return $resource(resourceUrl, {}, {
      'getPersistenceAuditEvents': {
        url: API_URI + 'api/cards/persistentAuditEvents/:userId',
        method: 'GET',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('MerchantDialogController', MerchantDialogController);

    MerchantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Merchant', 'User', 'Shop'];

    function MerchantDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Merchant, User, Shop) {
        var vm = this;

        vm.merchant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();
        vm.shops = Shop.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.merchant.id !== null) {
                Merchant.update(vm.merchant, onSaveSuccess, onSaveError);
            } else {
                Merchant.save(vm.merchant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:merchantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('MerchantDetailController', MerchantDetailController);

    MerchantDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Merchant', 'User', 'Shop'];

    function MerchantDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Merchant, User, Shop) {
        var vm = this;

        vm.merchant = entity;

        vm.isOwner = null;
        vm.isAdmin = null;

        checkAccess();

        function checkAccess() {
            Principal.identity().then(function (account) {
                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                vm.isOwner = vm.merchant.createdBy.id == account.id;
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                });
            });
        }

        if (typeof previousState.params.id != 'undefined') {
            vm.previousState = previousState.name + '({id: \'' + previousState.params.id + '\'})';
        } else {
            vm.previousState = previousState.name;
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:merchantUpdate', function (event, result) {
            vm.merchant = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('MerchantDeleteController',MerchantDeleteController);

    MerchantDeleteController.$inject = ['$uibModalInstance', 'entity', 'Merchant'];

    function MerchantDeleteController($uibModalInstance, entity, Merchant) {
        var vm = this;

        vm.merchant = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Merchant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('merchant', {
                parent: 'entity',
                url: '/merchant?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.merchant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/merchant/merchants.html',
                        controller: 'MerchantController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'companyName,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('merchant');
                        $translatePartialLoader.addPart('shop');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('merchant-detail', {
                parent: 'entity',
                url: '/merchant/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.merchant.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/merchant/merchant-detail.html',
                        controller: 'MerchantDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('merchant');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Merchant', function ($stateParams, Merchant) {
                        return Merchant.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'merchant',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('merchant-detail/edit', {
                parent: 'merchant-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/merchant/merchant-dialog.html',
                        controller: 'MerchantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Merchant', function (Merchant) {
                                return Merchant.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('merchant/new', {
                parent: 'merchant',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/merchant/merchant-dialog.html',
                        controller: 'MerchantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    companyName: null,
                                    code: null,
                                    description: null,
                                    vatCode: null,
                                    logoPath: null,
                                    websiteUrl: null,
                                    official: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('merchant', null, { reload: true });
                    }, function () {
                        $state.go('merchant');
                    });
                }]
            })
            .state('merchant/edit', {
                parent: 'merchant',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/merchant/merchant-dialog.html',
                        controller: 'MerchantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Merchant', function (Merchant) {
                                return Merchant.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('merchant', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('merchant/delete', {
                parent: 'merchant',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/merchant/merchant-delete-dialog.html',
                        controller: 'MerchantDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Merchant', function (Merchant) {
                                return Merchant.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('merchant', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Merchant', Merchant);

  Merchant.$inject = ['$resource', 'API_URI'];

  function Merchant($resource, API_URI) {
    var resourceUrl = API_URI + 'api/merchants/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('MerchantSearch', MerchantSearch);

  MerchantSearch.$inject = ['$resource', 'API_URI'];

  function MerchantSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/merchants/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('MerchantLookup', MerchantLookup);

  MerchantLookup.$inject = ['$resource', 'API_URI'];

  function MerchantLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/merchants';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('MerchantController', MerchantController);

  MerchantController.$inject = ['$scope', '$state', 'Merchant', 'MerchantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function MerchantController($scope, $state, Merchant, MerchantSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;

    loadAll();

    function loadAll() {
      if (pagingParams.search) {
        MerchantSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Merchant.query({
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.merchants = data;
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('gift', {
                parent: 'entity',
                url: '/gift',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.gift.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gift/gifts.html',
                        controller: 'GiftController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('gift');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('gift-detail', {
                parent: 'entity',
                url: '/gift/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.gift.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gift/gift-detail.html',
                        controller: 'GiftDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('gift');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Gift', function ($stateParams, Gift) {
                        return Gift.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'gift',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('gift-detail/edit', {
                parent: 'gift-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/gift/gift-dialog.html',
                        controller: 'GiftDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Gift', function (Gift) {
                                return Gift.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('gift/new', {
                parent: 'gift',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/gift/gift-dialog.html',
                        controller: 'GiftDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    description: null,
                                    notificationDate: null,
                                    giftMakerDescription: null,
                                    notifiedReceiver: 0,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('gift', null, { reload: true });
                    }, function () {
                        $state.go('gift');
                    });
                }]
            })
            .state('gift/edit', {
                parent: 'gift',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/gift/gift-dialog.html',
                        controller: 'GiftDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Gift', function (Gift) {
                                return Gift.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('gift', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('gift/delete', {
                parent: 'gift',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/gift/gift-delete-dialog.html',
                        controller: 'GiftDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Gift', function (Gift) {
                                return Gift.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('gift', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Gift', Gift);

  Gift.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function Gift($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/gifts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
          }
          return data;
        }
      },
      /* isArray=true because it returns the list of receipts, since most of the times
       * the receipt is no longer visible to the gift receiver after removing a gift. */
      'delete': {method: 'DELETE', isArray: true},
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.notificationDate = DateUtils.convertLocalDateToServer(dataToSend.notificationDate);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('FeedbackDialogController', FeedbackDialogController);

    FeedbackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Feedback'];

    function FeedbackDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Feedback) {
        var vm = this;

        vm.feedback = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.feedback.id !== null) {
                Feedback.update(vm.feedback, onSaveSuccess, onSaveError);
            } else {
                Feedback.save(vm.feedback, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:feedbackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('FeedbackDetailController', FeedbackDetailController);

    FeedbackDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Feedback', 'User'];

    function FeedbackDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Feedback, User) {
        var vm = this;

        vm.feedback = entity;
        
        if($stateParams.from) {
            $scope.from = $stateParams.from
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:feedbackUpdate', function(event, result) {
            vm.feedback = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('FeedbackDeleteController',FeedbackDeleteController);

    FeedbackDeleteController.$inject = ['$uibModalInstance', 'entity', 'Feedback'];

    function FeedbackDeleteController($uibModalInstance, entity, Feedback) {
        var vm = this;

        vm.feedback = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
    		Feedback.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('feedback', {
                parent: 'entity',
                url: '/feedback?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.feedback.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/feedback/feedbacks.html',
                        controller: 'FeedbackController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'description,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('feedbackType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('feedback-detail', {
                parent: 'entity',
                url: '/feedback/{id}?from',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.feedback.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || 'feedback';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.feedback.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/feedback/feedback-detail.html',
                        controller: 'FeedbackDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('receipt');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('feedbackType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Feedback', function ($stateParams, Feedback) {
                        return Feedback.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'feedback',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('feedback-detail/edit', {
                parent: 'feedback-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('feedback/new', {
                parent: 'feedback',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    description: null,
                                    creationDate: null,
                                    parentId: null,
                                    feedbackType: null,
                                    feedbackAnswer: null,
                                    satisfied: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('feedback');
                    });
                }]
            })
            .state('feedback/edit', {
                parent: 'feedback',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedbackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('feedback/delete', {
                parent: 'feedback',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-delete-dialog.html',
                        controller: 'FeedbackDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Feedback', function (Feedback) {
                                return Feedback.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('feedback', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Feedback', Feedback);

  Feedback.$inject = ['$resource', 'DateUtils', '$stateParams', 'API_URI'];

  function Feedback($resource, DateUtils, $stateParams, API_URI) {
    var resourceUrl = API_URI + 'api/feedbacks/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.creationDate = DateUtils.convertLocalDateFromServer(data.creationDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('FeedbackSearch', FeedbackSearch);

  FeedbackSearch.$inject = ['$resource', 'API_URI'];

  function FeedbackSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/feedbacks/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('FeedbackController', FeedbackController);

  FeedbackController.$inject = ['$scope', '$state', 'Feedback', 'FeedbackSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function FeedbackController($scope, $state, Feedback, FeedbackSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;

    loadAll();

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }

    function loadAll() {
      if (pagingParams.search) {
        FeedbackSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Feedback.query(function (result) {
          vm.feedbacks = result;
        });
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.feedbacks = data;
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    /* function search () {
         if (!vm.searchQuery) {
             return vm.loadAll();
         }
         FeedbackSearch.query({query: vm.searchQuery}, function(result) {
             vm.feedbacks = result;
         });
     }  */
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                parent: 'entity',
                url: '/dashboard?page&sort&search&documents&customers&shops&s',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.dashboard.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.dashboard.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html'
                    },
                    'content@': {
                        templateUrl: 'app/entities/dashboard/dashboard.html',
                        controller: 'DashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Dashboard', Dashboard);

  Dashboard.$inject = ['$resource', 'DateUtils', '$filter', 'API_URI'];

  function Dashboard($resource, DateUtils, $filter, API_URI) {
    var resourceUrl = API_URI + 'api/merchant-dashboard';

    return $resource(resourceUrl, {}, {
      'getMerchants': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/merchants',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getShops': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/shops/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTopMerchant': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceiptsTopMerchantShop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/top/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSalesMerchant': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSalesMerchantShop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getProductSales': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/sales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
      ,
      'getGaranteasyProductSales': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/garanteasySales/:merchant_id/:shop_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getCustomersTop': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/top',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + '/api/merchant-dashboard/merchants',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'searchReceipts': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/receipts/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getCustomers': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getMerchantCustomers': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/:merchant_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }

      /*'query': { method: 'GET', isArray: true},
      'get': {
          method: 'GET',
          transformResponse: function (data) {
              if (data) {
                  data = angular.fromJson(data);
                  data.creationDate = DateUtils.convertLocalDateFromServer(data.creationDate);
                  data.buyingDate = DateUtils.convertLocalDateFromServer(data.buyingDate);
              }
              return data;
          }
      },*/

      /*'update': {
          method: 'PUT',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
            dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
              return angular.toJson(dataToSend);
          }
      },
      'save': {
          method: 'POST',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
            dataToSend.creationDate = DateUtils.convertLocalDateToServer(dataToSend.creationDate);
              return angular.toJson(dataToSend);
          }
      },
      'claim': {
          method: 'POST',
          url: 'api/receipts/claim',
          transformRequest: function (data) {
            var dataToSend = angular.copy(data);
            if( dataToSend.receiptIdentifier ){
              //IT100003007000012562120161205
              //01234567890123456789012345678
              //          1111111111222222222
              dataToSend.shopCode = dataToSend.receiptIdentifier.substr(4, 5);
              dataToSend.counterCode =  dataToSend.receiptIdentifier.substr(9, 2);
      var pattern = /(\d{4})(\d{2})(\d{2})/;
      dataToSend.buyingDate = new Date(dataToSend.receiptIdentifier.substr(21, 8).replace(pattern, '$1-$2-$3'));
            } else {
              dataToSend.receiptIdentifier = "IT10" + dataToSend.shopCode + dataToSend.counterCode + dataToSend.receiptNumber + $filter('date')(dataToSend.buyingDate, 'yyyyMMdd');
            }
          dataToSend.receiptNumber =  dataToSend.receiptIdentifier;
            dataToSend.buyingDate = DateUtils.convertLocalDateToServer(dataToSend.buyingDate);
              return angular.toJson(dataToSend);
          }
      }
      */
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$scope', 'AlertService', '$rootScope', 'Principal', 'Receipt', 'Dashboard', 'SelectedMerchantService', '$log', '$state', 'DataUtils'];

    function DashboardController($scope, AlertService, $rootScope, Principal, Receipt, Dashboard, SelectedMerchantService, $log, $state, DataUtils) {
        var vm = this;
        vm.receipts = [];
        vm.productSales = [];
        vm.garanteasyProductSales = [];
        vm.customers = [];
        vm.summary = {};
        vm.model = {
            get merchant() {
                return SelectedMerchantService.merchant;
            },
            set merchant(item) {
                return SelectedMerchantService.merchant = item;
            },
            get shop() {
                return SelectedMerchantService.shop;
            },
            set shop(item) {
                return SelectedMerchantService.shop = item;
            }
        };

        vm.interval = 'SETTIMANE';
        vm.time = ['SETTIMANE', 'MESI'];

        vm.checkAccess = function () {
            Principal.identity().then(function (account) {

                if (!Principal.isAuthenticated()) {
                    $state.go("home");
                    return;
                }
                vm.currentUserId = account.id;
                Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                    if (result) {
                        vm.isAdmin = true;
                    } else {
                        vm.isAdmin = false;
                    }
                    loadData();
                });
            });
        };

        vm.checkAccess();
        vm.showCustomerName = function (customer) {
            return DataUtils.showCustomerName(customer);
        };
        function loadData() {
            if (!vm.model.merchant) {
                return;
            }
            var merchantId = vm.model.merchant.id;
            var shopId;
            if (vm.model.shop) {
                shopId = vm.model.shop.id;
            }
            Receipt.getValid({},
                function (data, headers) { return vm.summary = data; },
                function (e) { return $log.error(e); });


            if (merchantId && !shopId)
                vm.receipts = Dashboard.getReceiptsTopMerchant({}, onSuccessReceipt, onErrorReceipt);
            else if (merchantId && shopId) {
                vm.receipts = Dashboard.getReceiptsTopMerchantShop({ merchant_id: merchantId, shop_id: shopId }, onSuccessReceipt, onErrorReceipt);
            }
            else if (vm.isAdmin) {
                vm.receipts = Dashboard.getReceiptsTop({}, onSuccessReceipt, onErrorReceipt);
            }
            function onSuccessReceipt(data, headers) {
                vm.receipts = data;
            }
            function onErrorReceipt(data, headers) {
                $log.error('Error load receipts');
            }

            // if (merchantId && !shopId)
            //     vm.productSales = Dashboard.getProductSales({ merchant_id: merchantId, intervall: vm.interval });
            // else if (merchantId && shopId) {
            //     vm.productSales = Dashboard.getProductSales({ merchant_id: merchantId, shop_id: shopId, intervall: vm.interval });
            // }
            // else if (vm.isAdmin) {
            //     vm.productSales = Dashboard.getProductSales({ intervall: vm.interval });
            // }
            if (vm.isAdmin) {
                if (merchantId && !shopId)
                    vm.garanteasyProductSales = Dashboard.getGaranteasyProductSales({ merchant_id: merchantId });
                else if (merchantId && shopId) {
                    vm.garanteasyProductSales = Dashboard.getGaranteasyProductSales({ merchant_id: merchantId, shop_id: shopId });
                } else {
                    vm.garanteasyProductSales = Dashboard.getGaranteasyProductSales({});
                }
            }
            if (merchantId) {
                vm.customers = Dashboard.getCustomersTop({ merchant_id: merchantId });
            } else if (vm.isAdmin) {
                vm.customers = Dashboard.getCustomersTop({});
            }
            $log.debug(
                vm.summary,
                vm.receipts,
                vm.productSales,
                vm.garanteasyProductSales,
                vm.customers);
        }

        vm.listenerMerchant = SelectedMerchantService.onMerchantChange(loadData);
        vm.listenerShop = SelectedMerchantService.onShopChange(loadData);

        $scope.$on('$destroy', function () {
            vm.listenerMerchant();
            vm.listenerShop();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Customer', 'User', 'Gift', 'Receipt', 'Address'];

    function CustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Customer, User, Gift, Receipt, Address) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Customer', 'User', 'Contact', 'Card', 'PersistentAuditEvent', 'WarrantyStatus', 'AlertService', 'DataUtils'];

    function CustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Customer, User, Contact, Card, PersistentAuditEvent, WarrantyStatus, AlertService, DataUtils) {
        var vm = this;

        vm.customer = entity;
        vm.purchasedProducts = [];
        vm.contacts = [];
        vm.userId = entity.user.id;
        vm.cards = [];
        vm.persistenceAuditEvents = [];
        vm.isEdit = false;
        vm.receiptCount = 0;
        vm.lastReceipt = {};
        //WarrantyStatus.getWarrantyStatusCustomer({'customer_id' : vm.customer.id}, onSuccessW, onErrorW);
        vm.showCustomerName = function (customer) {
            return DataUtils.showCustomerName(customer);
        };
        function onSuccessW(data, headers) {
            vm.warrantyStatus = data;
            vm.totalNumExpired = data.numExpired;
            vm.totalNumExpiring = data.numExpiring;
            vm.totalNumValid = data.numValid;
        }
        function onErrorW(error) {
            AlertService.error(error.data.message);
        }

        $scope.stateData.vm = vm;
        vm.name = 'CUSTOMER-DETAIL';

        vm.buy = function (value) {
            if (!value) {
                return 'Privato';
            }
            else { return 'Business'; }
        }



        function loadContacts() {
            Contact.getUserContacts({ userId: vm.userId }, onSuccessContact, onError);
        }

        function onSuccessContact(data, headers) {
            vm.contacts = data;
            for (var i = 0; i < vm.contacts; i++) {
                if (vm.contacts[i].primaryContact) {
                    vm.primaryContact = vm.contacts[i];
                }
            }
        }

        function loadCards() {
            Card.getCards4Customer({ customerId: entity.id }, function (result) {
                vm.cards = result;
            });
        }

        function loadPersistenceAuditEvents() {
            PersistentAuditEvent.getPersistenceAuditEvents({ userId: vm.userId }, function (result) {
                vm.persistenceAuditEvents = result;
            });
        }

        loadContacts();
        loadCards();
        loadPersistenceAuditEvents();
        countReceiptAndFindLast();

        Customer.getCustomerDetail({ 'customer_id': entity.id }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.customer = data;
            vm.purchasedProducts = vm.customer.garanteasyProducts;
            for (var i = 0; i < vm.purchasedProducts.length; i++) {
                vm.totalNumExpired += vm.purchasedProducts[i].totalWarranties.numExpired;
                vm.totalNumValid += vm.purchasedProducts[i].totalWarranties.numValid;
                vm.totalNumExpiring += vm.purchasedProducts[i].totalWarranties.numExpiring;
            }
        }

        function onError(error) {
            console.log('Error in load customer!');
        }

        function countReceiptAndFindLast() {
          var receiptIds = [];
          var lastReceipt;
          if (Array.isArray(vm.customer.garanteasyProducts)) {
            vm.customer.garanteasyProducts.forEach(function(item) {
              if (item.receipt && item.receipt.id) {
                if (receiptIds.indexOf(item.receipt.id) === -1) {
                  receiptIds.push(item.receipt.id);
                }
                if (!lastReceipt) {
                  lastReceipt = item.receipt;
                } else {
                  if (item.receipt.creationDate > lastReceipt.creationDate) {
                    lastReceipt = item.receipt;
                  }
                }
              }
            });
          }
          vm.receiptCount = receiptIds.length;
          vm.lastReceipt = lastReceipt;
        }

        if ($stateParams.from) {
            $scope.from = $stateParams.from;
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:customerUpdate', function (event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);

        $rootScope.$emit("enableMerchantSelector", false);
        $scope.$on('$destroy', function dismissed() {
              $rootScope.$emit("enableMerchantSelector", true);
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CustomerDeleteController',CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customer', {
                parent: 'entity',
                url: '/customer?page&sort&search&documents&customers&shops&s',
                /*ncyBreadcrumb: {
    
                    parent: function ($scope) {
                        return 'dashboard';
                    }
                },*/
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.customer.home.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.customer.home.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebarCustomers.html'
                    },
                    'content@': {
                        templateUrl: 'app/entities/customer/customers.html',
                        controller: 'CustomerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: 'customer.legalName,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('dashboard');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('customer-detail', {
                parent: 'entity',
                url: '/customer/{id}?from',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.customer.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || 'customer';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.customer.detail.title'
                },
                views: {
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebarCustomers.html'
                    },
                    'content@': {
                        templateUrl: 'app/entities/customer/customer-detail.html',
                        controller: 'CustomerDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('purchasedProduct');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('contact');
                        $translatePartialLoader.addPart('card');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Customer', function ($stateParams, Customer) {
                        return Customer.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'customer',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('customer-detail/edit', {
                parent: 'customer-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('customer/new', {
                parent: 'customer',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    legalName: null,
                                    birthDate: null,
                                    vatid: null,
                                    business: false,
                                    gender: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('customer', null, { reload: true });
                    }, function () {
                        $state.go('customer');
                    });
                }]
            })
            .state('customer/edit', {
                parent: 'customer',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('customer', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('customer/delete', {
                parent: 'customer',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                        controller: 'CustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('customer', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Customer', Customer);

  Customer.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function Customer($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/customers/:id';

    return $resource(resourceUrl, {}, {
      'query': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/customers',
        isArray: true
      },
      'get': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/customer/:id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.birthDate = DateUtils.convertLocalDateToServer(dataToSend.birthDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.birthDate = DateUtils.convertLocalDateToServer(dataToSend.birthDate);
          return angular.toJson(dataToSend);
        }
      },
      'getCustomerDetail': {
        method: 'GET',
        url: API_URI + 'api/merchant-dashboard/customer/:customer_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'saveCustomerFromReceipt': {
        method: 'POST',
        url: API_URI + 'api/register',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('CustomerSearch', CustomerSearch);

  CustomerSearch.$inject = ['$resource', 'API_URI'];

  function CustomerSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/customers/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      /**
       * GET api/merchant-dashboard/customers/search
       *
       * Expected response structure:
       * - Body: a JSON array of Customer objects (not wrapped). For example:
       *   [
       *     {
       *       "id": 123,
       *       "legalName": "John Doe",
       *       "email": "john@example.com",
       *       // ...other customer fields
       *     }
       *   ]
       *
       * Pagination and metadata:
       * - RFC 5988/8288 HTTP Link header is provided by the server to expose pagination links
       *   (rel="first", rel="prev", rel="next", rel="last"). The UI parses this header via
       *   ParseLinks.parse(headers('Link')) to derive page indexes.
       * - X-Total-Count header contains the total number of matching elements across all pages.
       *
       * Notes:
       * - HATEOAS is NOT expected in the response body for this endpoint. The client only consumes
       *   the plain array payload plus the Link and X-Total-Count headers for pagination.
       */
      'getCustomerSearch': {
        method: 'GET',
        isArray: true,
        url: API_URI + 'api/merchant-dashboard/customers/search',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('CustomerController', CustomerController);

  CustomerController.$inject = ['$state', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Dashboard', 'Customer', '$log', '$rootScope', 'DataUtils'];

  function CustomerController($state, ParseLinks, AlertService, pagingParams, paginationConstants, Dashboard, Customer, $log, $rootScope, DataUtils) {
    var vm = this;
    vm.customers = [];
    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.loadAll = loadAll;
    vm.links = {
      last: 0
    };
    vm.isLoading = false;
    vm.name = 'CUSTOMERS';
    vm.gridView = $rootScope.gridView;
    loadAll();

    vm.showCustomerName = function (customer) {
      return DataUtils.showCustomerName(customer);
    };

    function loadAll() {
      if (vm.isLoading) return;
      vm.isLoading = true;
      Dashboard.getCustomers({
        page: vm.page,
        size: vm.itemsPerPage,
        sort: sort()
      }, onSuccess, onError);
    }

    function sort() {
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'id') {
        result.push('id');
      }
      return result;
    }

    function onSuccess(data, headers) {
      if (headers('Link')) {
        vm.links = ParseLinks.parse(headers('Link'));
      }
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      vm.itemsPerPage = 20;
      vm.customers = vm.customers.concat(data);
      angular.forEach(vm.customers, function (customer) {
        Customer.getCustomerDetail({customer_id: customer.id}, function (detail) {
            $log.debug(detail);
            customer.cards = detail.cards;
            countReceiptAndFindLast(customer, detail);
          },
          function (err) {
          });
      });
      vm.isLoading = false;
    }

    function onError(error) {
      vm.isLoading = false;
      AlertService.error(error.data.message);
    }

    function loadPage(page) {
      vm.page = page;
      vm.loadAll();
    }

    function transition() {
      reset();
      vm.loadAll();
    }

    function reset() {
      vm.page = 0;
      vm.customers = [];
      loadAll();
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }

    function countReceiptAndFindLast(customer, detail) {
      var receiptIds = [];
      var lastReceipt;
      if (Array.isArray(detail.garanteasyProducts)) {
        detail.garanteasyProducts.forEach(function (item) {
          if (item.receipt && item.receipt.id) {
            if (receiptIds.indexOf(item.receipt.id) === -1) {
              receiptIds.push(item.receipt.id);
            }
            if (!lastReceipt) {
              lastReceipt = item.receipt;
            } else {
              if (item.receipt.creationDate > lastReceipt.creationDate) {
                lastReceipt = item.receipt;
              }
            }
          }
        });
      }
      customer.receiptCount = receiptIds.length;
      customer.lastReceipt = lastReceipt;
    }
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ContactDialogController', ContactDialogController);

    ContactDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Contact'];

    function ContactDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Contact) {
        var vm = this;

        vm.contact = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contact.id !== null) {
                Contact.update(vm.contact, onSaveSuccess, onSaveError);
            } else {
                Contact.save(vm.contact, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('garanteasyApp:contactUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ContactDetailController', ContactDetailController);

    ContactDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Contact', 'User'];

    function ContactDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Contact, User) {
        var vm = this;

        vm.contact = entity;
        
        if($stateParams.from) {
            $scope.from = $stateParams.from
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:contactUpdate', function(event, result) {
            vm.contact = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ContactDeleteController',ContactDeleteController);

    ContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contact'];

    function ContactDeleteController($uibModalInstance, entity, Contact) {
        var vm = this;

        vm.contact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Contact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('contact', {
                parent: 'entity',
                url: '/contact',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.contact.home.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.contact.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contact/contacts.html',
                        controller: 'ContactController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contact');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('contact-detail', {
                parent: 'entity',
                url: '/contact/{id}?from',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.contact.detail.title' | translate}}",
                    parent: function ($scope) {
                        return $scope.from || 'contact';
                    }
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.contact.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contact/contact-detail.html',
                        controller: 'ContactDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('contact');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Contact', function ($stateParams, Contact) {
                        return Contact.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'contact',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('contact-detail/edit', {
                parent: 'contact-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-dialog.html',
                        controller: 'ContactDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Contact', function (Contact) {
                                return Contact.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('contact/new', {
                parent: 'contact',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-dialog.html',
                        controller: 'ContactDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    channel: null,
                                    primaryContact: false,
                                    activated: false,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('contact', null, { reload: true });
                    }, function () {
                        $state.go('contact');
                    });
                }]
            })
            .state('contact/edit', {
                parent: 'contact',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-dialog.html',
                        controller: 'ContactDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Contact', function (Contact) {
                                return Contact.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('contact', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('contact/delete', {
                parent: 'contact',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-delete-dialog.html',
                        controller: 'ContactDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Contact', function (Contact) {
                                return Contact.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('contact', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Contact', Contact);

  Contact.$inject = ['$resource', 'API_URI'];

  function Contact($resource, API_URI) {
    var resourceUrl = API_URI + 'api/contacts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'queryActive': {
        url: API_URI + 'api/contacts/active',
        method: 'GET',
        isArray: true
      },
      'getUserContacts': {
        url: API_URI + 'api/contacts/active/:userId',
        method: 'GET',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ContactSearch', ContactSearch);

  ContactSearch.$inject = ['$resource', 'API_URI'];

  function ContactSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/contacts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ContactLookup', ContactLookup);

  ContactLookup.$inject = ['$resource', 'API_URI'];

  function ContactLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/contacts';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ContactController', ContactController);

    ContactController.$inject = ['$scope', '$state', 'Contact', 'ContactSearch'];

    function ContactController ($scope, $state, Contact, ContactSearch) {
        var vm = this;
        
        vm.contacts = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Contact.query(function(result) {
                vm.contacts = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ContactSearch.query({query: vm.searchQuery}, function(result) {
                vm.contacts = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CardRequestUseController',CardRequestUseController);

    CardRequestUseController.$inject = ['$uibModalInstance', '$scope', 'entity', 'Card', 'CardCustomer', '$state', '$stateParams', 'Principal'];

    function CardRequestUseController($uibModalInstance, $scope, entity, Card, CardCustomer, $state, $stateParams, Principal) {
        var vm = this;
        var params = $stateParams.dataCard;
        vm.clear = clear;
        vm.confirmRequestUse = confirmRequestUse;
        vm.card = params;
        getAccount();


        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmRequestUse (id) {
            vm.isSaving = true;
            var cc = {};
            cc.card = vm.card;
            cc.contact = params.contact;
            cc.customer = vm.account;

            if (vm.postalCode){
                cc.postalCode = vm.postalCode;
                CardCustomer.connectTOUser(cc, onSaveSuccess, onSaveError);
            }
            else {
                CardCustomer.save(cc, onSaveSuccess, onSaveSuccess);
            }
        }

        function onSaveSuccess (result) {
           $scope.$emit('garanteasyApp:cardCustomerSave', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CardDialogController', CardDialogController);

    CardDialogController.$inject = ['$http', '$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Card', 'CardType', 'Contact', 'ContactLookup', 'PhoneNumberLookup', 'PhoneNumber', 'Principal', '$state', '$rootScope', 'CardCustomer'];

    function CardDialogController($http, $timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Card, CardType, Contact, ContactLookup, PhoneNumberLookup, PhoneNumber, Principal, $state, $rootScope, CardCustomer) {
        var vm = this;

        vm.card = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.cardTypes = [];
        vm.cardTypes = CardType.query();
        vm.contacts = Contact.query();
        vm.phoneNumbers = PhoneNumber.query();
        vm.isOwner = false;
        vm.isAdmin = false;

        checkAccess();

        function checkAccess() {
            Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                if (result) {
                    vm.isAdmin = true;
                }
            });
            var account = Principal.identity();
            if (vm.card && vm.card.contact && vm.card.contact.user && account.$$state && account.$$state.value.id)
                if (vm.card.contact.user.id == account.$$state.value.id) {
                    vm.isOwner = true;
                }
        }

        vm.disableEdit = function () {
            if (vm.card.flowMerchant && vm.isAdmin) {
                return false;
            }
            if (!vm.card.flowMerchant && vm.isOwner) {
                return false;
            }
            if (vm.card.id) {
                return true;
            }
        }

        $q.all([vm.card.$promise, vm.contacts.$promise]).then(function () {
            if (!vm.card.contactId) {
                return $q.reject();
            }
            return Contact.get({ id: vm.card.contactId }).$promise;
        }).then(function (contact) {
            vm.contacts.push(contact);
        });

        $q.all([vm.card.$promise, vm.phoneNumbers.$promise]).then(function () {
            if (!vm.card.phoneNumberId) {
                return $q.reject();
            }
            return PhoneNumber.get({ id: vm.card.phoneNumberId }).$promise;
        }).then(function (phoneNumber) {
            vm.phoneNumbers.push(phoneNumber);
        });

        $scope.resetContact = function () {
            vm.card.contact = null;
        }

        $scope.resetPhoneNumber = function () {
            vm.card.phoneNumber = null;
        }

        $scope.loadContacts = function (searchQuery) {
            if (searchQuery && searchQuery.trim().length > 1) {
                ContactLookup.query({ query: searchQuery }, function (result) {
                    $scope.contacts = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.contacts = Contact.query({ isActive: true }, onSuccess, onError);
                    }
                });
            } else {
                $scope.contacts = Contact.query({ isActive: true }, onSuccess, onError);
            }
        };

        function onSuccess(data, headers) {
            if ($scope.contacts) {
                $scope.contacts.forEach(function (item) {
                    if (item.primaryContact && !vm.card.contact)
                        vm.card.contact = item;
                });
            }
        }

        function onError(data, headers) {

        }

        $scope.loadPhoneNumbers = function (searchQuery) {
            if (searchQuery && searchQuery.trim().length > 1) {
                PhoneNumberLookup.query({ query: searchQuery }, function (result) {
                    $scope.phoneNumbers = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.phoneNumbers = PhoneNumber.query({ isActive: true });
                    }
                });
            } else {
                $scope.phoneNumbers = PhoneNumber.query({ isActive: true });
            }
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            vm.isSaving = true;
            if (vm.card.id !== null) {
                Card.update(vm.card, onSaveSuccess, onSaveError);
            } else {
                Card.save(vm.card, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess(result) {
            $scope.$emit('garanteasyApp:cardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }


        function onSaveError(error) {
            vm.isSaving = false;
            if (error && error.data && error.data.errCode && 'ERR_EXIST_CARD' == error.data.errCode) {
                vm.resp = error.data.errCode;
                $state.go('settings/card-requestUse', { 'dataCard': error.data, 'card': vm.card });
                // $uibModalInstance.close();
            }

        }

        vm.closeWindow = function () {
            $uibModalInstance.close();
        }

        vm.datePickerOpenStatus.activationDate = false;
        vm.datePickerOpenStatus.expirationDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CardDetailController', CardDetailController);

    CardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Card', 'User', 'Gift', 'Receipt', 'Address', 'CardCustomer', '$state'];

    function CardDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Card, User, Gift, Receipt, Address, CardCustomer, $state) {
        var vm = this;

        vm.card = entity;
        vm.cardCustomers = CardCustomer.query();


        $scope.cardCustomerVisible = function(cardCustomer) {
            return vm.isAdmin || (cardCustomer.card.id == vm.card.id);
        }

        if($stateParams.from) {
            $scope.from = $stateParams.from
        }

        vm.setCardCustomerId = function(ccId) {
            $state.params.cardId = vm.card.id;
            $state.params.ccId= ccId;
            $state.params.id= vm.card.id;
        }

        vm.isOwner = function() {
            var ret = false;
            var account = Principal.identity();
            if(vm.card.contact && vm.card.contact.user && account.$$state && account.$$state.value.id)
                ret = vm.card.contact.user.id == account.$$state.value.id;
            return ret;
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:cardUpdate', function(event, result) {
            vm.card = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('CardDeleteController',CardDeleteController);

    CardDeleteController.$inject = ['$uibModalInstance', 'entity', 'Card'];

    function CardDeleteController($uibModalInstance, entity, Card) {
        var vm = this;

        vm.card = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Card.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('card', {
                parent: 'entity',
                url: '/card?page&sort&search',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.card.home.title' | translate}}"
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.card.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/card/cards.html',
                        controller: 'CardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'legalName,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('card');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('card/detail', {
                parent: 'entity',
                url: '/card/{id}',
                ncyBreadcrumb: {
                    label: "{{'garanteasyApp.receipt.detail.title' | translate}}",
                    parent: 'card'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.receipt.detail.title'
                },
                views: {

                    'content@': {
                        templateUrl: 'app/entities/card/card-detail.html',
                        controller: 'CardDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('card');
                        $translatePartialLoader.addPart('cardCustomer');
                        $translatePartialLoader.addPart('purchasedProduct');
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('brand');
                        $translatePartialLoader.addPart('shop');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('merchant');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('dataSource');
                        $translatePartialLoader.addPart('warrantyClaim');
                        $translatePartialLoader.addPart('warranty');
                        $translatePartialLoader.addPart('feedback');
                        $translatePartialLoader.addPart('receiptType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Card', function ($stateParams, Card) {
                        return Card.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'card',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('card-detail/edit', {
                parent: 'card-detail',
                url: '/detail/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-dialog.html',
                        controller: 'CardDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('card/new', {
                parent: 'card',
                url: '/new',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-dialog.html',
                        controller: 'CardDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    activationDate: null,
                                    expirationDate: null,
                                    number: null,
                                    type: null,
                                    contact: null,
                                    phoneNumber: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('card', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            }).state('card/card-requestUse', {
                parent: 'card/new',
                url: '/requestUseCard',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-request-use-card-dialog.html',
                        controller: 'CardRequestUseController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('card/edit', {
                parent: 'card',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-dialog.html',
                        controller: 'CardDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('card', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('card/card-customer-edit', {
                parent: 'card/detail',
                url: '/detail/edit',

                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/cardCustomer/cardCustomer-dialog.html',
                        controller: 'CardCustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['$state', '$stateParams', 'CardCustomer', function ($state, $stateParams, CardCustomer) {
                                return CardCustomer.get({ id: $state.params.ccId }).$promise;
                            }]
                        }

                    }).result.then(function () {
                        $state.go('card/detail', null, { reload: true });
                    }, function () {
                        $state.go('card/detail');
                    });
                }]
            }).state('card/card-customer-delete', {
                parent: 'card/detail',
                url: '/{ccId}/deleteCardCustomer',
                params: { dataCard: null, ccId: null },
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/cardCustomer/cardCustomer-delete-dialog.html',
                        controller: 'CardCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CardCustomer', function (CardCustomer) {
                                return CardCustomer.get({ id: $stateParams.ccId }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings');
                    }, function () {
                        $state.go('settings');
                    });
                }]
            })
            .state('card/delete', {
                parent: 'card',
                url: '/{id}/delete',
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-delete-dialog.html',
                        controller: 'CardDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('card', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Card', Card);

  Card.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function Card($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/cards/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'queryActive': {
        url: API_URI + 'api/cards/active/:receipt',
        method: 'POST',
        isArray: true,
        /*params: {receipt: "-1"},*/
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);
        },
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            console.log(data);
          }
          return data;
        }
      },
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.activationDate = DateUtils.convertLocalDateFromServer(data.activationDate);
            data.expirationDate = DateUtils.convertLocalDateFromServer(data.expirationDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          if (dataToSend.activationDate) {
            dataToSend.activationDate = DateUtils.convertLocalDateToServer(dataToSend.activationDate);
          }
          if (dataToSend.expirationDate) {
            dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          }
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {

          var dataToSend = angular.copy(data);
          if (dataToSend.activationDate) {
            dataToSend.activationDate = DateUtils.convertLocalDateToServer(dataToSend.activationDate);
          }
          if (dataToSend.expirationDate) {
            dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          }
          return angular.toJson(dataToSend);

        },
        transformResponse: function (data, headers) {
          var response = {};
          response = angular.fromJson(data);
          return response;
        }
      },

      'getCards4Customer': {
        url: API_URI + 'api/cards/active/:customerId',
        method: 'GET',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('CardSearch', CardSearch);

  CardSearch.$inject = ['$resource', 'API_URI'];

  function CardSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/cards/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('CardController', CardController);

  CardController.$inject = ['$scope', '$state', 'Card', 'CardSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

  function CardController($scope, $state, Card, CardSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
    var vm = this;

    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.clear = clear;
    vm.search = search;
    vm.loadAll = loadAll;
    vm.searchQuery = pagingParams.search;
    vm.currentSearch = pagingParams.search;

    loadAll();

    function loadAll() {
      if (pagingParams.search) {
        CardSearch.query({
          query: pagingParams.search,
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      } else {
        Card.query({
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort()
        }, onSuccess, onError);
      }

      function sort() {
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.cards = data;
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }

    function search(searchQuery) {
      if (!searchQuery) {
        return vm.clear();
      }
      vm.links = null;
      vm.page = 1;
      vm.predicate = '_score';
      vm.reverse = false;
      vm.currentSearch = searchQuery;
      vm.transition();
    }

    function clear() {
      vm.links = null;
      vm.page = 1;
      vm.predicate = 'id';
      vm.reverse = true;
      vm.currentSearch = null;
      vm.transition();
    }
  }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Brand', Brand);

  Brand.$inject = ['$resource', 'API_URI'];

  function Brand($resource, API_URI) {
    var resourceUrl = API_URI + 'api/brands/:id';

    return $resource(resourceUrl, {}, {
      'query': {
        method: 'GET',
        cache: true,
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'get': {
        method: 'GET',
        cache: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'},
      'save': {method: 'POST'}
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('BrandLookup', BrandLookup);

  BrandLookup.$inject = ['$resource', 'API_URI'];

  function BrandLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/brands';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
;
angular
  .module('garanteasyApp')
  .component('warrantyBoxComponent', {
    templateUrl: 'app/components/warranty-box/warranty-box-component.html',
    controller: WarrantyBoxController,
    controllerAs: 'vm',
    bindings: {
      purchasedProductWarranty: '<',
      hideExpandButton: '<',
      isNewWarranty: '<'
    }
  });

WarrantyBoxController.$inject = ['Receipt', 'Warranty', 'PurchasedProductWarranty', 'CmsWarrantyService', 'CMS_URI'];


function WarrantyBoxController(Receipt, Warranty, PurchasedProductWarranty, CmsWarrantyService, CMS_URI) {
  var vm = this;
  vm.name = 'purchased.product.warranty.detail.controller';
  vm.receipt;
  vm.purchasedProduct;
  vm.isOwner = null;
  vm.isAdmin = null;
  vm.edit = false;
  vm.currentUserId;
  vm.onUpdateWarranty = onUpdateWarranty;
  vm.editWarranty = editWarranty;
  vm.cancelEdit = cancelEdit;
  vm.saveUpdatePurchasedProductWarranty = saveUpdatePurchasedProductWarranty;
  vm.onSave = onSave;
  vm.oldWarranty = null;
  vm.isOfficial;
  vm.resolveGuarantor = resolveGuarantor;
  vm.cmsWarrantyData;
  vm.resolveCmsData = resolveCmsData;
  vm.productBrandName = "";
  vm.productBrandLogo = "";
  vm.cmsUri = CMS_URI;
  vm.saveSecond = function () {
    Receipt.update(vm.receipt, onSaveSuccess, onSaveError);
  };
  vm.openCalendar = openCalendar;
  vm.datePickerOpenStatus = {};
  vm.datePickerOpenStatus.paymentDate = false;
  vm.convertIcon = convertIcon;
  vm.addExtraWarrantyToProduct = addExtraWarrantyToProduct;
  vm.onUpdateExtraWarranty = onUpdateExtraWarranty;




  vm.$onInit = function () {
    setModel(vm.purchasedProductWarranty.warranty);
    vm.receipt = vm.purchasedProductWarranty.receipt;
    vm.purchasedProduct = vm.purchasedProductWarranty.purchasedProduct;
    vm.isOfficial = vm.purchasedProductWarranty.warranty.official;
    fixDays();
    resolveCmsData();
  };


  function setModel(result) {
    switch (result.contractType) {
      case "CONVENTIONAL":
        vm.warrentyModel = {
          'image': 'azienda.png',
          'title': 'garanteasyApp.receipt.detail.infoConventionalWarrantyMobile'
        };
        break;
      case "LEGAL":
        vm.warrentyModel = {
          'image': 'bilancia_scudo_bianco.png',
          'title': 'garanteasyApp.receipt.detail.infoLegalWarrantyMobile'
        };
        break;
      case "INSURANCE_POLICY":
        vm.warrentyModel = {
          'image': 'ombrello_scudo_bianco.png',
          'title': 'garanteasyApp.receipt.detail.infoInsuranceWarrantyMobile'
        };
        break;
      case "SERVICE_CONTRACT":
        vm.warrentyModel = {
          'image': 'assistenza_1scudo_bianco.png',
          'title': 'garanteasyApp.receipt.detail.infoServiceContractWarranryMobile'
        };
        break;
      default:
        vm.warrentyModel = {
          'image': 'azienda.png',
          'title': 'garanteasyApp.receipt.detail.infoLegalWarrantyMobile'
        };
    }
  }


  function openCalendar(date) {
    vm.datePickerOpenStatus[date] = true;
  }

  function convertIcon(warrantyExtension) {
    if (warrantyExtension) {
      if (warrantyExtension.warranty.guarantorType === 'PRODUCER') {
        return "../../../content/images/icone_new/icone_sfondo_bianco/azienda.png";
      }
      if (warrantyExtension.warranty.guarantorType === 'INSURANCE') {
        return "../../../content/images/icone_new/icone_sfondo_bianco/ombrello_scudo_bianco.png";
      }
      if (warrantyExtension.warranty.guarantorType === 'ASSISTANCE_CENTER') {
        return "../../../content/images/icone_new/icone_sfondo_bianco/assistenza_1scudo_bianco.png";
      }
    }
    return "../../../content/images/icone_new/icone_sfondo_bianco/punto_domanda.png";
  }

  function addExtraWarrantyToProduct() {
    if (!vm.purchasedProduct.purchasedProductWarranties)
      vm.purchasedProduct.purchasedProductWarranties = [];
    vm.purchasedProduct.purchasedProductWarranties.push(vm.purchasedProduct.warrantyExtension);
    vm.purchasedProduct.warrantyExtension = {};
  }

  function onUpdateExtraWarranty(purchasedProductWarranty) {
    vm.purchasedProduct.warrantyExtension = Object.assign({}, purchasedProductWarranty);
  }


  function editWarranty() {
    if (!vm.isOfficial && !vm.isNewWarranty) {
      vm.oldWarranty = angular.copy(vm.purchasedProductWarranty);
      vm.edit = true;
    }
  }

  function fixDays() {
    if (vm.purchasedProductWarranty.status === 'valid' || vm.purchasedProductWarranty.status === 'expiring' && vm.purchasedProductWarranty.expirationDate) {
      const one_day = 1000 * 60 * 60 * 24;
      var dateTo = new Date(vm.purchasedProductWarranty.expirationDate);
      vm.purchasedProductWarranty.dayToExpiration = Math.round((dateTo.getTime() - new Date()) / one_day);
    }
  }

  function resolveGuarantor(purchasedProductWarranty) {
    if (purchasedProductWarranty.warranty && purchasedProductWarranty.warranty.contractType === 'LEGAL') {
      if (purchasedProductWarranty.receipt && purchasedProductWarranty.receipt.shop && purchasedProductWarranty.receipt.shop.description) {
        return purchasedProductWarranty.receipt.shop.description;
      }
    }
    if (purchasedProductWarranty.warranty && purchasedProductWarranty.warranty.contractType === 'CONVENTIONAL') {
      if (purchasedProductWarranty.purchasedProduct && purchasedProductWarranty.purchasedProduct.product && purchasedProductWarranty.purchasedProduct.product.producer && purchasedProductWarranty.purchasedProduct.product.producer.name) {
        if (vm.cmsWarrantyData && vm.cmsWarrantyData.holder_company) {
          return vm.cmsWarrantyData.holder_company;
        }
        return purchasedProductWarranty.purchasedProduct.product.producer.name;
      }
    }
    if (purchasedProductWarranty.warranty && purchasedProductWarranty.warranty.contractType === 'SERVICE_CONTRACT' ||
      purchasedProductWarranty.warranty.contractType === 'INSURANCE_POLICY'
    ) {
      return purchasedProductWarranty.warranty.description;
    }
  }

  function cancelEdit() {
    vm.purchasedProductWarranty = vm.oldWarranty;
    vm.oldWarranty = null;
    vm.edit = false;
  }

  function onUpdateWarranty(purchasedProductWarranty, valid) {
    if (!purchasedProductWarranty) {
      return;
    }
  }

  function resolveCmsData() {
    //resolve brand (non serve più perchè non include dati sul prodotto)
    /*
    if (vm.purchasedProductWarranty && vm.purchasedProductWarranty.product && vm.purchasedProductWarranty.product.brand && vm.purchasedProductWarranty.product.brand.cmsReference) {
      BrandService.getBrandData(vm.purchasedProductWarranty.product.brand.cmsReference).then(function (response) {
        vm.productBrandName = response[0].title;
        vm.productBrandLogo = CMS_URI + response[0].brand_image_full;
      });
    } else {
      vm.productBrandName = vm.purchasedProduct ? vm.purchasedProduct.product.brand.name : "";
    }*/
    //resolve warranty
    //vm.purchasedProductWarranty.warranty.reference ="10ae5337-30e4-4144-b632-c28b62d02413";
    if (vm.purchasedProductWarranty && vm.purchasedProductWarranty.warranty && vm.purchasedProductWarranty.warranty.reference) {
      //load data from cms
      CmsWarrantyService.getWarrantyData(vm.purchasedProductWarranty.warranty.reference).then(function (response) {
        vm.cmsWarrantyData = response[0];
      });
    }
  }

  function onSave() {
    vm.saveUpdatePurchasedProductWarranty(vm.purchasedProductWarranty, vm.oldWarranty).then(function (res) {
      onSaveSuccess(res);
    }).catch(function (error) {
      onSaveError();
    });
  }

  function onSaveSuccess(purchasedProductWarranty) {
    vm.edit = false;
  }

  function onSaveError() {

  }


  function saveUpdatePurchasedProductWarranty(purchasedProductWarranty, old) {
    delete purchasedProductWarranty.receipt;
    var promise = new Promise(function (resolve) {
      resolve(purchasedProductWarranty);
    });
    if (!purchasedProductWarranty.warranty.id) {
      promise = Warranty.save(purchasedProductWarranty.warranty).$promise;
    } else if (!purchasedProductWarranty.warranty.official && purchasedProductWarranty.warranty.id && purchasedProductWarranty.warranty.code === 'CUSTOM') {
      promise = Warranty.update(purchasedProductWarranty.warranty).$promise.then(function (result) {
        purchasedProductWarranty.warranty = result;
        return purchasedProductWarranty;
      });
    }
    if (!purchasedProductWarranty.id) {
      promise = promise.then(function (warranty) {
        purchasedProductWarranty.warrantyId = purchasedProductWarranty.warrantyId || purchasedProductWarranty.warranty.id || warranty.id;
        return PurchasedProductWarranty.save(purchasedProductWarranty).$promise;
      });
    } else if (purchasedProductWarranty.id && old && purchasedProductWarranty.warranty.id !== old.warranty.id) {
      promise = promise.then(function (warranty) {
        return PurchasedProductWarranty.delete({
          id: old.id
        }).$promise;
      }).then(function (warranty) {
        purchasedProductWarranty.id = null;
        purchasedProductWarranty.warrantyId = purchasedProductWarranty.warrantyId || purchasedProductWarranty.warranty.id || warranty.id;
        return PurchasedProductWarranty.save(purchasedProductWarranty).$promise;
      });
    }
    return promise.then(function (result) {
      purchasedProductWarranty = result;
      return purchasedProductWarranty;
    });
  }

}

;
angular
  .module('garanteasyApp')
  .component('warrantyAssistance', {
    templateUrl: 'app/components/warranty-assistance/warranty-assistance.component.html',
    controller: WarrantyAssistanceController,
    controllerAs: 'vm',
    bindings: {
      purchasedProduct: '<',
      receipt: '<',
      legal: '<',
      conventional: '<',
      insurance: '<',
      assistance: '<',
      claims: '<'
    }
  });

WarrantyAssistanceController.$inject = ['$scope', '$element', '$log', 'Receipt', 'ProductLookup', 'BrandLookup', '$state'];

function WarrantyAssistanceController($scope, $element, $log, Receipt, ProductLookup, BrandLookup, $state) {
  var vm = this;
  vm.checkStatus = checkStatus;
  vm.openProductSelect = openProductSelect;
  vm.productSelectToggle = false;
  vm.selectedProduct;
  vm.save = save;
  vm.warrantiesTotal = {};

  function calculateTotalWarranties() {

  }


  function checkStatus(status) {
    switch (status) {
      case "green":
        return "garanteasyApp.purchasedProduct.detail.valid";
      case "white":
        return "garanteasyApp.purchasedProduct.detail.notDefined";
      case "red":
        return "garanteasyApp.purchasedProduct.detail.expired";
      case "orange":
        return "garanteasyApp.purchasedProduct.detail.expiring";
      default:
        break;
    }
  }

  function openProductSelect() {
    vm.productSelectToggle = true;
  }

  $scope.$watch('vm.purchasedProduct', function (newValue) {
    convertWarrantyInfo(newValue);
    console.log(vm.purchasedProduct);
  });

  $scope.$watch('vm.receipt', function (newValue) {
    if (vm.receipt && vm.receipt.totalWarranties) {
      vm.totalWarranties = vm.receipt.totalWarranties;
    }
  });

  $scope.$watch('vm.purchasedProduct.purchasedProductWarranties', function (newValue) {
    if (vm.purchasedProduct) {
      vm.purchasedProduct.purchasedProductWarranties = newValue;
      convertWarrantyInfo(vm.purchasedProduct);
    }
  });

  function convertWarrantyInfo(purchasedProduct) {
    if (purchasedProduct) {
      purchasedProduct.purchasedProductWarranties.forEach(function (item) {
        if (item.status === 'valid') {
          item.color = 'green';
        } else if (item.status === 'aboutToExpire') {
          item.color = 'orange';
        } else if (item.status === 'expired') {
          item.color = 'red';
        } else {
          item.color = 'white';
        }

        if (item.warranty.contractType === 'LEGAL') {
          vm.legal = item.color;
        } else if (item.warranty.contractType === 'CONVENTIONAL') {
          vm.conventional = item.color;
        } else if (item.warranty.contractType === 'SERVICE_CONTRACT') {
          vm.assistance = item.color;
        } else if (item.warranty.contractType === 'INSURANCE_POLICY') {
          vm.assistance = item.color;
        }
      });

    }
  }


  //PRODUCT
  vm.ALL_PRODUCTS = -1;
  vm.PREFERRED_PRODUCTS = 0;
  vm.NEW_PRODUCT = 1;
  vm.isNewProductCollapsed = vm.PREFERRED_PRODUCTS;

  vm.products = [];
  $scope.loadProducts = function (searchQuery) {
    if (vm.isNewProductCollapsed === vm.PREFERRED_PRODUCTS) {
      ProductLookup.query({}, function (results) {
        vm.products = results;
      });
    } else {
      ProductLookup.query({ query: searchQuery },
        function (result) {
          vm.products = result;
          angular.forEach(vm.products, function (product, key) {
            product.description = String(product.description).replace(/<[^>]+>/gm, '');
          });
        },
        function (response) {
          $log.error("Error in productlokup", response);
          AlertService.error("Error: " + response.status);
        }
      );
    }
  };

  function addProduct() {
    vm.addProduct = false;
    if (
      angular.isDefined(vm.receipt.purchasedProduct) &&
      angular.isDefined(vm.receipt.purchasedProduct.product)
    ) {
      if (angular.isUndefined(vm.receipt.purchasedProduct.giftMakerDescription)) {
        vm.receipt.purchasedProduct.giftMakerDescription = vm.receipt.customer.legalName;
      }
      var index = vm.receipt.purchasedProducts.indexOf(vm.receipt.purchasedProduct);
      if (index === -1) {
        vm.receipt.purchasedProducts.push(vm.receipt.purchasedProduct);
      } else {
        vm.receipt.purchasedProducts[index] = vm.receipt.purchasedProduct;
      }
      vm.receipt.purchasedProduct = {};
    }
    console.log(vm.receipt);
  }

  function save() {

    addProduct();
    if (vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length) {
      vm.receipt.numProducts = Number(vm.receipt.purchasedProducts.length);
    }
    vm.isSaving = true;
    vm.receipt.cardId = vm.useCard ? vm.receipt.cardId : null;
    if (vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length) {
      vm.receipt.purchasedProducts = vm.receipt.purchasedProducts.map(function (purchasedProduct) {
        if (purchasedProduct.product.id) {
          purchasedProduct.allProductId = purchasedProduct.product.id;
          purchasedProduct.product = {};
        }
        return purchasedProduct;
      });
    }
    if (vm.receipt.id !== null) {
      Receipt.update(vm.receipt, onSaveSuccess, onSaveError);
    } else {
      vm.receipt.purchasedProduct = null;
      // if (!vm.receipt.receiptNumber) {
      //   vm.receipt.receiptNumber = Base64.encode(vm.receipt.buyingDate.toString());
      // }
      Receipt.save(vm.receipt, onSaveSuccess, onSaveError);

    }

  }

  function onSaveSuccess(result) {
    vm.isSaving = false;
    $state.go('warranty-claim.new', { 'idPurchasedProduct': result.purchasedProducts[0].id });
  }

  function onSaveError(error) {
    vm.error = error;
    /*if(error.statusText === 'Forbidden'){
        AlertService.error("zdfsf");
    }*/
    vm.isSaving = false;
    vm.isEdit = false;
    vm.isEdit2 = false;
    vm.isEdit3 = false;
  }

  $scope.loadBrands = function (searchQuery, producer) {
    if (producer && producer.code) {
      searchQuery = '\'(owner.code:' + producer.code + ')AND(official:1)\'' + searchQuery;
    }
    BrandLookup.query({ query: searchQuery },
      function (result) {
        $scope.brands = result;
      }
    );
  };
}
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('receiptUse', receiptUse);

    receiptUse.$inject = ['$translate'];
    function receiptUse($translate) {
        return receiptUseFilter;

        function receiptUseFilter(input) {
            if (!input) {
                input = null;
            }
            else {
                input = 'garanteasyApp.ReceiptUse.' + input;
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('receiptType', receiptType);

    receiptType.$inject = ['$translate'];
    function receiptType($translate) {
        return receiptTypeFilter;

        function receiptTypeFilter (input) {
            if (input === null) {
                input = null;
            }
            else {
                    input = 'garanteasyApp.ReceiptType.'+input;
            }
            return input;
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ParseLinks', ParseLinks);

  function ParseLinks() {

    return {
      parse: parse
    };

    function parse(header) {
      if (!header || header.length === 0) {
        return
        //throw new Error('input must not be of zero length');
      }

      // Split parts by comma
      var parts = header.split(',');
      var links = {};
      // Parse each part into a named link
      angular.forEach(parts, function (p) {
        var section = p.split(';');
        if (section.length !== 2) {
          throw new Error('section could not be split on ";"');
        }
        var url = section[0].replace(/<(.*)>/, '$1').trim();
        var queryString = {};
        url.replace(
          new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
          function ($0, $1, $2, $3) {
            queryString[$1] = $3;
          }
        );
        var page = queryString.page;
        if (angular.isString(page)) {
          page = parseInt(page);
        }
        var name = section[1].replace(/rel="(.*)"/, '$1').trim();
        links[name] = page;
      });
      return links;
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    "use strict";

    angular.module("garanteasyApp").directive("uppercaseOnly", uppercaseOnly);

    // Directive
    function uppercaseOnly() {
        var directive = {
            restrict: "A",
            require: "ngModel",
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            element.on("keypress", function(e) {
                var char = e.char || String.fromCharCode(e.charCode);
                if (!/^[A-Z0-9]$/i.test(char)) {
                    e.preventDefault();
                    return false;
                }
            });

            function parser(value) {
                if (ctrl.$isEmpty(value)) {
                    return value;
                }
                var formatedValue = value.toUpperCase();
                if (ctrl.$viewValue !== formatedValue) {
                    ctrl.$setViewValue(formatedValue);
                    ctrl.$render();
                }
                return formatedValue;
            }

            function formatter(value) {
                if (ctrl.$isEmpty(value)) {
                    return value;
                }
                return value.toUpperCase();
            }

            ctrl.$formatters.push(formatter);
            ctrl.$parsers.push(parser);
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
            'Showing {{($ctrl.queryCount == 0) ? 0 : ((($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1))}} - ' +
            '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
            'of {{$ctrl.queryCount}} items.' +
            '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('garanteasyApp')
        .component('jhiItemCount', jhiItemCount);
})();;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.replace('T', '').split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            showCustomerName: showCustomerName
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }
        function showCustomerName(customer) {
            if (customer.user.login === customer.legalName) {
                return '';
            } else {
                return customer.legalName;
            }
        }
        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            var objbuilder = '';
            objbuilder += ('<object width="100%" height="100%" ');
            objbuilder += ('  class="internal">');
            objbuilder += ('<embed width="100%" height="100%" src="data:' + type + ';base64,');
            objbuilder += (data);
            objbuilder += ('" type="' + type + '" />');
            objbuilder += ('</object>');
            var pop = $window.open("", '_blank', 'height=300,width=400');
            pop.document.write(objbuilder);

            // $window.open(objbuilder, '_blank', 'height=300,width=400');
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('booleanAsYesNo', booleanAsYesNo);

    function booleanAsYesNo() {
        return booleanAsYesNoFilter;

        function booleanAsYesNoFilter (input) {
            if (input === null) {
                input = false;
            }
            return input ? 'global.yes' : 'global.no';
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();
;
'use strict';

angular
  .module('garanteasyApp')
  .component('receiptImageBuild', {
    templateUrl: 'app/components/receipt-image-build/receipt-image-build.component.html',
    controller: ReceiptImageBuild,
    controllerAs: 'vm',
    bindings: {
      receipt: '<'
    }
  });

ReceiptImageBuild.$inject = ['$scope', '$element', '$log', 'AlertService', 'CmsService', '$translate', 'CMS_URI'];

function ReceiptImageBuild($scope, $element, $log, AlertService, CmsService, $translate, CMS_URI) {
  var vm = this;
  vm.buildProductsList = buildProductsList;
  vm.init = init;

  vm.logoUri;
  vm.cmsReference;
  vm.lang = 'eng';
  vm.products = [];
  vm.productsHasPrice = false;
  vm.getVatCode = getVatCode;

  vm.init();

  function init() {
    if ($translate.use()) {
      vm.lang = $translate.use();
    }
    $scope.$on('$destroy', function () {
      $log.debug("Destroing directive");
    });
    $scope.$watch("vm.receipt.purchasedProducts", function () {
      buildProductsList();
    }, true);
    $scope.$watch("vm.receipt", function () {
      if (vm.receipt) {
        getLogoImage();
      }
    });
  }

  function getVatCode() {
    if (vm.receipt) {
      if (vm.receipt.shop && vm.receipt.shop.cmsShopData) {
        return vm.receipt.shop.cmsShopData.company_vat_code;
      }
      if (vm.receipt.shop) {
        if (vm.receipt.shop.merchant && vm.receipt.shop.merchant.vatCode) {
          return vm.receipt.shop.merchant.vatCode;
        } else {
          return vm.receipt.shop.vatCode;
        }
      }

    }
  }

  function buildProductsList() {
    vm.products = [];
    if (vm.receipt && vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length) {
      vm.productsHasPrice = false;
      vm.receipt.purchasedProducts.forEach(function (purchasedProduct) {
        if (purchasedProduct.transactionAmount) {
          vm.productsHasPrice = true;
        }
        var indexFound = vm.products.findIndex(function (el) {
          return el.product.id === purchasedProduct.product.id;
        });
        if (indexFound !== -1) {
          vm.products[indexFound].quantity++;
          vm.products[indexFound].transactionAmount += purchasedProduct.transactionAmount;
        } else {
          purchasedProduct.quantity = 1;
          vm.products.push(purchasedProduct);
        }
      });
    }
  }

  function getLogoImage() {

    if (vm.receipt.shop && vm.receipt.shop.signboard && vm.receipt.shop.signboard.code) {

      CmsService.getBrandByCode(vm.receipt.shop.signboard.code).then(function (data) {
        if (data && data[0] && data[0].brand_image_full)
          vm.logoUri = CMS_URI + data[0].brand_image_full;
      });

      /*
      if (vm.receipt.shop.signboard.cmsReference) {
        vm.cmsReference = vm.receipt.shop.signboard.cmsReference;
        return getLogoImageByCmsReference();
      } else if (vm.receipt.shop.signboard.code) {


        return CmsService.searchBrandFromCode(vm.lang, vm.receipt.shop.signboard.code).then(function (data) {
          if (data && data[0] && data[0].id) {
            vm.cmsReference = data[0].id;
            getLogoImageByCmsReference();
          } else {
            getLogoImageByMerchant();
          }
        });*/
    }

    //getLogoImageByMerchant();
  }

  function getLogoImageByCmsReference() {
    CmsService.getBrandImageData(vm.lang, vm.cmsReference).then(function (data) {
      if (data.data && data.data.relationships && data.data.relationships.field_image &&
        data.data.relationships.field_image.links && data.data.relationships.field_image.links.related &&
        data.data.relationships.field_image.links.related.href) {
        CmsService.call(data.data.relationships.field_image.links.related.href).then(function (dataImage) {
          if (dataImage.data && dataImage.data.attributes && dataImage.data.attributes.uri && dataImage.data.attributes.uri.url) {
            setLogoUriGrayScale(CMS_URI + dataImage.attributes.uri.url);
          } else {
            getLogoImageByMerchant();
          }
        });
      } else {
        getLogoImageByMerchant();
      }
    });
  }

  function getLogoImageByMerchant() {
    if (vm.receipt.shop && vm.receipt.shop.merchant && vm.receipt.shop.merchant.logoPath != null && vm.receipt.shop.merchant.logoPath !== '') {
      var resultLogo = vm.receipt.shop.merchant.logoPath.substring(26);

      //setLogoUriGrayScale('/cms' + resultLogo);
      vm.logoUri = '/cms' + resultLogo;
    }
  }

  function setLogoUriGrayScale(logoUri) {
    var img = new Image;
    img.src = logoUri;
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      var imgDataUrl = grayscale(img);
      vm.logoUri = imgDataUrl;
    };
  }

  function grayscale(image) {
    var myCanvas = document.createElement("canvas");
    var myCanvasContext = myCanvas.getContext("2d");
    var imgWidth = image.width;
    var imgHeight = image.height;
    // You'll get some string error if you fail to specify the dimensions
    myCanvas.width = imgWidth;
    myCanvas.height = imgHeight;
    //  alert(imgWidth);
    myCanvasContext.drawImage(image, 0, 0);

    // This function cannot be called if the image is not rom the same domain.
    // You'll get security error if you do.
    var imageData = myCanvasContext.getImageData(0, 0, imgWidth, imgHeight);

    var pix = imageData.data;
    for (var i = 0, n = pix.length; i < n; i += 4) {
      var grayscale = pix[i] * .3 + pix[i + 1] * .59 + pix[i + 2] * .11;
      pix[i] = grayscale; // red
      pix[i + 1] = grayscale; // green
      pix[i + 2] = grayscale; // blue
      // alpha
    }
    contrastImage(imageData, 200);
    myCanvasContext.putImageData(imageData, 0, 0);
    return myCanvas.toDataURL('image/jpeg', 0.9);
  }

  function contrastImage(imgData, contrast) {  //input range [-100..100]
    var d = imgData.data;
    contrast = (contrast / 100) + 1;  //convert to decimal & shift range: [0..2]
    var intercept = 128 * (1 - contrast);
    for (var i = 0; i < d.length; i += 4) {   //r,g,b,a
      d[i] = d[i] * contrast + intercept;
      d[i + 1] = d[i + 1] * contrast + intercept;
      d[i + 2] = d[i + 2] * contrast + intercept;
    }
    return imgData;
  }

}
;
/*
 * printThis v1.10.0
 * @desc Printing plug-in for jQuery
 * @author Jason Day
 *
 * Resources (based on) :
 *              jPrintArea: http://plugins.jquery.com/project/jPrintArea
 *              jqPrint: https://github.com/permanenttourist/jquery.jqprint
 *              Ben Nadal: http://www.bennadel.com/blog/1591-Ask-Ben-Print-Part-Of-A-Web-Page-With-jQuery.htm
 *
 * Licensed under the MIT licence:
 *              http://www.opensource.org/licenses/mit-license.php
 *
 * (c) Jason Day 2015
 *
 * Usage:
 *
 *  $("#mySelector").printThis({
 *      debug: false,               // show the iframe for debugging
 *      importCSS: true,            // import page CSS
 *      importStyle: false,         // import style tags
 *      printContainer: true,       // grab outer container as well as the contents of the selector
 *      loadCSS: "path/to/my.css",  // path to additional css file - us an array [] for multiple
 *      pageTitle: "",              // add title to print page
 *      removeInline: false,        // remove all inline styles from print elements
 *      printDelay: 333,            // variable print delay
 *      header: null,               // prefix to html
 *      footer: null,               // postfix to html
 *      base: false,                // preserve the BASE tag, or accept a string for the URL
 *      formValues: true,           // preserve input/form values
 *      canvas: false,              // copy canvas elements (experimental)
 *      doctypeString: '...',       // enter a different doctype for older markup
 *      removeScripts: false        // remove script tags from print content
 *  });
 *
 * Notes:
 *  - the loadCSS will load additional css (with or without @media print) into the iframe, adjusting layout
 */
;
(function($) {

    function appendContent($el, content) {
        if (!content) return;

        // Simple test for a jQuery element
        $el.append(content.jquery ? content.clone() : content);
    }

    function appendBody($body, $element, opt) {
        // Clone for safety and convenience
        var $content = $element.clone();

        if (opt.removeScripts) {
            $content.find('script').remove();
        }

        if (opt.printContainer) {
            // grab $.selector as container
            $body.append($("<div/>").html($content).html());
        } else {
            // otherwise just print interior elements of container
            $content.each(function() {
                $body.append($(this).html());
            });
        }
    }

    var opt;
    $.fn.printThis = function(options) {
        opt = $.extend({}, $.fn.printThis.defaults, options);
        var $element = this instanceof jQuery ? this : $(this);

        var strFrameName = "printThis-" + (new Date()).getTime();

        if (window.location.hostname !== document.domain && navigator.userAgent.match(/msie/i)) {
            // Ugly IE hacks due to IE not inheriting document.domain from parent
            // checks if document.domain is set by comparing the host name against document.domain
            var iframeSrc = "javascript:document.write(\"<head><script>document.domain=\\\"" + document.domain + "\\\";</s" + "cript></head><body></body>\")";
            var printI = document.createElement('iframe');
            printI.name = "printIframe";
            printI.id = strFrameName;
            printI.className = "MSIE";
            document.body.appendChild(printI);
            printI.src = iframeSrc;

        } else {
            // other browsers inherit document.domain, and IE works if document.domain is not explicitly set
            var $frame = $("<iframe id='" + strFrameName + "' name='printIframe' />");
            $frame.appendTo("body");
        }

        var $iframe = $("#" + strFrameName);

        // show frame if in debug mode
        if (!opt.debug) $iframe.css({
            position: "absolute",
            width: "0px",
            height: "0px",
            left: "-600px",
            top: "-600px"
        });

        // $iframe.ready() and $iframe.load were inconsistent between browsers    
        setTimeout(function() {

            // Add doctype to fix the style difference between printing and render
            function setDocType($iframe, doctype){
                var win, doc;
                win = $iframe.get(0);
                win = win.contentWindow || win.contentDocument || win;
                doc = win.document || win.contentDocument || win;
                doc.open();
                doc.write(doctype);
                doc.close();
            }

            if (opt.doctypeString){
                setDocType($iframe, opt.doctypeString);
            }

            var $doc = $iframe.contents(),
                $head = $doc.find("head"),
                $body = $doc.find("body"),
                $base = $('base'),
                baseURL;

            // add base tag to ensure elements use the parent domain
            if (opt.base === true && $base.length > 0) {
                // take the base tag from the original page
                baseURL = $base.attr('href');
            } else if (typeof opt.base === 'string') {
                // An exact base string is provided
                baseURL = opt.base;
            } else {
                // Use the page URL as the base
                baseURL = document.location.protocol + '//' + document.location.host;
            }

            $head.append('<base href="' + baseURL + '">');

            // import page stylesheets
            if (opt.importCSS) $("link[rel=stylesheet]").each(function() {
                var href = $(this).attr("href");
                if (href) {
                    var media = $(this).attr("media") || "all";
                    $head.append("<link type='text/css' rel='stylesheet' href='" + href + "' media='" + media + "'>");
                }
            });
            
            // import style tags
            if (opt.importStyle) $("style").each(function() {
                $(this).clone().appendTo($head);
            });

            // add title of the page
            if (opt.pageTitle) $head.append("<title>" + opt.pageTitle + "</title>");

            // import additional stylesheet(s)
            if (opt.loadCSS) {
               if ($.isArray(opt.loadCSS)) {
                    jQuery.each(opt.loadCSS, function(index, value) {
                       $head.append("<link type='text/css' rel='stylesheet' href='" + this + "'>");
                    });
                } else {
                    $head.append("<link type='text/css' rel='stylesheet' href='" + opt.loadCSS + "'>");
                }
            }

            // print header
            appendContent($body, opt.header);

            if (opt.canvas) {
                // add canvas data-ids for easy access after cloning.
                var canvasId = 0;
                $element.find('canvas').each(function(){
                    $(this).attr('data-printthis', canvasId++);
                });
            }

            appendBody($body, $element, opt);

            if (opt.canvas) {
                // Re-draw new canvases by referencing the originals
                $body.find('canvas').each(function(){
                    var cid = $(this).data('printthis'),
                        $src = $('[data-printthis="' + cid + '"]');

                    this.getContext('2d').drawImage($src[0], 0, 0);

                    // Remove the markup from the original
                    $src.removeData('printthis');
                });
            }

            // capture form/field values
            if (opt.formValues) {
                // loop through inputs
                var $input = $element.find('input');
                if ($input.length) {
                    $input.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $checker = $this.is(':checkbox') || $this.is(':radio'),
                            $iframeInput = $doc.find('input[name="' + $name + '"]'),
                            $value = $this.val();

                        // order matters here
                        if (!$checker) {
                            $iframeInput.val($value);
                        } else if ($this.is(':checked')) {
                            if ($this.is(':checkbox')) {
                                $iframeInput.attr('checked', 'checked');
                            } else if ($this.is(':radio')) {
                                $doc.find('input[name="' + $name + '"][value="' + $value + '"]').attr('checked', 'checked');
                            }
                        }

                    });
                }

                // loop through selects
                var $select = $element.find('select');
                if ($select.length) {
                    $select.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('select[name="' + $name + '"]').val($value);
                    });
                }

                // loop through textareas
                var $textarea = $element.find('textarea');
                if ($textarea.length) {
                    $textarea.each(function() {
                        var $this = $(this),
                            $name = $(this).attr('name'),
                            $value = $this.val();
                        $doc.find('textarea[name="' + $name + '"]').val($value);
                    });
                }
            } // end capture form/field values

            // remove inline styles
            if (opt.removeInline) {
                // $.removeAttr available jQuery 1.7+
                if ($.isFunction($.removeAttr)) {
                    $doc.find("body *").removeAttr("style");
                } else {
                    $doc.find("body *").attr("style", "");
                }
            }

            // print "footer"
            appendContent($body, opt.footer);

            setTimeout(function() {
                if ($iframe.hasClass("MSIE")) {
                    // check if the iframe was created with the ugly hack
                    // and perform another ugly hack out of neccessity
                    window.frames["printIframe"].focus();
                    $head.append("<script>  window.print(); </s" + "cript>");
                } else {
                    // proper method
                    if (document.queryCommandSupported("print")) {
                        $iframe[0].contentWindow.document.execCommand("print", false, null);
                    } else {
                        $iframe[0].contentWindow.focus();
                        $iframe[0].contentWindow.print();
                    }
                }

                // remove iframe after print
                if (!opt.debug) {
                    setTimeout(function() {
                        $iframe.remove();
                    }, 1000);
                }

            }, opt.printDelay);

        }, 333);

    };

    // defaults
    $.fn.printThis.defaults = {
        debug: false,           // show the iframe for debugging
        importCSS: true,        // import parent page css
        importStyle: false,     // import style tags
        printContainer: true,   // print outer container/$.selector
        loadCSS: "",            // load an additional css file - load multiple stylesheets with an array []
        pageTitle: "",          // add title to print page
        removeInline: false,    // remove all inline styles
        printDelay: 333,        // variable print delay
        header: null,           // prefix to html
        footer: null,           // postfix to html
        formValues: true,       // preserve input/form values
        canvas: false,          // copy canvas content (experimental)
        base: false,            // preserve the BASE tag, or accept a string for the URL
        doctypeString: '<!DOCTYPE html>', // html doctype
        removeScripts: false    // remove script tags before appending
    };
})(jQuery);
;


$( document ).ready(function() {

    /*$('[data-fancybox="gallery"]').fancybox();*/

    $('[data-action="download-image"]').bind('click',function(e){
        e.stopPropagation();
        e.preventDefault();
        //$('[data-action="main-image-url"]').click();
        window.open($('#main-image').attr("href"),'_blank','','');
    });

    $('[data-action="show-more"]').bind('click',function(e){
        var el = $(this).siblings('.detail-text'),
            curHeight = el.height(),
            autoHeight = el.css('height', 'auto').height();

        if(!$(this).hasClass('open')){
        	 $(this).addClass('open');        	
            el.height(curHeight).animate({height: 73}, 500);
        }
        else{
        	 $(this).removeClass('open');
            el.height(curHeight).animate({height: autoHeight}, 500);
        }
       
        var old_title = $(this).text();
        $(this).text($(this).data('title'));
        $(this).data('title',old_title);
    });

    $('[data-action="print"]').bind('click',function(e){
        print();
        //window.print();
        //$('.main-wrapper').printThis();
    });
});
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'Receipt'];

    function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance, Receipt) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function () { angular.element('#username').focus(); });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                    $state.current.name === 'claimChiccoReceipt' || $state.current.name === 'home' ||
                    $state.current.name === 'social-auth' || $state.current.name === 'social-register') {
                    $state.go('dashboard');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register() {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
angular
    .module('garanteasyApp')
    .component('listItemWarrenty', {
        templateUrl: 'app/components/list-item/warrenty/warrenty.component.html',
        controller: ListItemWarrentyComponentController,
        controllerAs: 'vm',
        bindings: {
            warrenty: '<'
        }
    });

ListItemWarrentyComponentController.$inject = ['DataUtils'];

function ListItemWarrentyComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
    vm.getImage = getImage;
    vm.getIcon = getIcon;
    vm.isOfficial = isOfficial;

    function isOfficial() {
        if (vm.warrenty.receipt.source === 'MERCHANT') {
            return true;
        } else {
            return false;
        }
    }

    function getImage(purchasedProductWarranty) {
        var item = (((purchasedProductWarranty || {}).warranty || {}) || {}).warrantyType;
        if (item === 'LEGAL') {
            return '/content/images/ICONA_GARANZIE_LEGALE.png';
        } else if (item === 'CONVENTIONAL') {
            return '/content/images/ICONA_GARANZIE_CONVENZIONALE.png';
        } else if (item === 'SERVICE_CONTRACT') {
            return '/content/images/ICONA_GARANZIE_ASSISTENZA.png';
        } else if (item === 'INSURANCE') {
            return '/content/images/ICONA_GARANZIE_POLIZZA.png';
        } else {
            return '/content/images/ICONA_GARANZIE_LEGALE.png';
        }
    }

    function getIcon(purchasedProductWarranty) {
        var icon = 'fa-balance-scale';
        if (purchasedProductWarranty && purchasedProductWarranty.warranty) {
            icon = vm.warrantyIcons[purchasedProductWarranty.warranty.type] || icon;
        }
        return icon;
    }
}
;
angular
    .module('garanteasyApp')
    .component('listItemShop', {
        templateUrl: 'app/components/list-item/shop/shop.component.html',
        controller: ListItemShopComponentController,
        controllerAs: 'vm',
        bindings: {
            shop: '<'
        }
    });

ListItemShopComponentController.$inject = ['DataUtils'];

function ListItemShopComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
}
;
angular
  .module('garanteasyApp')
  .component('listItemReceipt', {
    templateUrl: 'app/components/list-item/receipt/receipt.component.html',
    controller: ListItemReceiptComponentController,
    controllerAs: 'vm',
    bindings: {
      receipt: '<'
    }
  });

ListItemReceiptComponentController.$inject = ['AuthServerProvider'];

function ListItemReceiptComponentController(AuthServerProvider) {
  var vm = this;
  vm.getImageUrl = function (receipt) {
    if (((receipt || {}).receiptFiles || {}).length > 0) {
      var image = _.find(receipt.receiptFiles, function (o) {
        if (o.fileContentType === null) return
        return o.fileContentType.startsWith('image/');
      });
      if (image) {
        return API_URI + "api/receipt-files/content/" + image.id + "?width=-&height=150&token=" + AuthServerProvider.getToken();
      }
    } else {
      // Se manca l'immagine della ricevuta mostro quella del prodotto.
      if ((receipt || {}).purchasedProducts) {
        receipt.purchasedProducts.forEach(function (purchasedProduct) {
          if (purchasedProduct.product && purchasedProduct.product.images[0]) {
            return purchasedProduct.product.images[0].value;
          }
        });
      }
    }

  };
}
;
angular
    .module('garanteasyApp')
    .component('listItemProduct', {
        templateUrl: 'app/components/list-item/product/product.component.html',
        controller: ListItemProductComponentController,
        controllerAs: 'vm',
        bindings: {
            product: '<'
        }
    });

ListItemProductComponentController.$inject = ['DataUtils'];

function ListItemProductComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
}
;
angular
    .module('garanteasyApp')
    .component('listItemCustomer', {
        templateUrl: 'app/components/list-item/customer/customer.component.html',
        controller: listItemCustomerComponentController,
        controllerAs: 'vm',
        bindings: {
            customer: '<'
        }
    });

listItemCustomerComponentController.$inject = ['DataUtils'];

function listItemCustomerComponentController(DataUtils) {
    var vm = this;
    vm.showCustomerName = function (customer) {
        return DataUtils.showCustomerName(customer);
    };
}
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'it',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
"function"!==typeof Object.create&&(Object.create=function(d){function h(){}h.prototype=d;return new h});
(function(d,h,l,m){var k={init:function(b,a){var c=this;c.elem=a;c.$elem=d(a);c.imageSrc=c.$elem.data("zoom-image")?c.$elem.data("zoom-image"):c.$elem.attr("src");c.options=d.extend({},d.fn.elevateZoom.options,b);c.options.tint&&(c.options.lensColour="none",c.options.lensOpacity="1");"inner"==c.options.zoomType&&(c.options.showLens=!1);c.$elem.parent().removeAttr("title").removeAttr("alt");c.zoomImage=c.imageSrc;c.refresh(1);d("#"+c.options.gallery+" a").click(function(a){c.options.galleryActiveClass&&
(d("#"+c.options.gallery+" a").removeClass(c.options.galleryActiveClass),d(this).addClass(c.options.galleryActiveClass));a.preventDefault();d(this).data("zoom-image")?c.zoomImagePre=d(this).data("zoom-image"):c.zoomImagePre=d(this).data("image");c.swaptheimage(d(this).data("image"),c.zoomImagePre);return!1})},refresh:function(b){var a=this;setTimeout(function(){a.fetch(a.imageSrc)},b||a.options.refresh)},fetch:function(b){var a=this,c=new Image;c.onload=function(){a.largeWidth=c.width;a.largeHeight=
c.height;a.startZoom();a.currentImage=a.imageSrc;a.options.onZoomedImageLoaded(a.$elem)};c.src=b},startZoom:function(){var b=this;b.nzWidth=b.$elem.width();b.nzHeight=b.$elem.height();b.isWindowActive=!1;b.isLensActive=!1;b.isTintActive=!1;b.overWindow=!1;b.options.imageCrossfade&&(b.zoomWrap=b.$elem.wrap('<div style="height:'+b.nzHeight+"px;width:"+b.nzWidth+'px;" class="zoomWrapper" />'),b.$elem.css("position","absolute"));b.zoomLock=1;b.scrollingLock=!1;b.changeBgSize=!1;b.currentZoomLevel=b.options.zoomLevel;
b.nzOffset=b.$elem.offset();b.widthRatio=b.largeWidth/b.currentZoomLevel/b.nzWidth;b.heightRatio=b.largeHeight/b.currentZoomLevel/b.nzHeight;"window"==b.options.zoomType&&(b.zoomWindowStyle="overflow: hidden;background-position: 0px 0px;text-align:center;background-color: "+String(b.options.zoomWindowBgColour)+";width: "+String(b.options.zoomWindowWidth)+"px;height: "+String(b.options.zoomWindowHeight)+"px;float: left;background-size: "+b.largeWidth/b.currentZoomLevel+"px "+b.largeHeight/b.currentZoomLevel+
"px;display: none;z-index:100;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;");if("inner"==b.options.zoomType){var a=b.$elem.css("border-left-width");b.zoomWindowStyle="overflow: hidden;margin-left: "+String(a)+";margin-top: "+String(a)+";background-position: 0px 0px;width: "+String(b.nzWidth)+"px;height: "+String(b.nzHeight)+"px;float: left;display: none;cursor:"+b.options.cursor+";px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;"}"window"==
b.options.zoomType&&(lensHeight=b.nzHeight<b.options.zoomWindowWidth/b.widthRatio?b.nzHeight:String(b.options.zoomWindowHeight/b.heightRatio),lensWidth=b.largeWidth<b.options.zoomWindowWidth?b.nzWidth:b.options.zoomWindowWidth/b.widthRatio,b.lensStyle="background-position: 0px 0px;width: "+String(b.options.zoomWindowWidth/b.widthRatio)+"px;height: "+String(b.options.zoomWindowHeight/b.heightRatio)+"px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:"+
b.options.lensOpacity+";filter: alpha(opacity = "+100*b.options.lensOpacity+"); zoom:1;width:"+lensWidth+"px;height:"+lensHeight+"px;background-color:"+b.options.lensColour+";cursor:"+b.options.cursor+";border: "+b.options.lensBorderSize+"px solid "+b.options.lensBorderColour+";background-repeat: no-repeat;position: absolute;");b.tintStyle="display: block;position: absolute;background-color: "+b.options.tintColour+";filter:alpha(opacity=0);opacity: 0;width: "+b.nzWidth+"px;height: "+b.nzHeight+"px;";
b.lensRound="";"lens"==b.options.zoomType&&(b.lensStyle="background-position: 0px 0px;float: left;display: none;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";width:"+String(b.options.lensSize)+"px;height:"+String(b.options.lensSize)+"px;background-repeat: no-repeat;position: absolute;");"round"==b.options.lensShape&&(b.lensRound="border-top-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-top-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+
"px;border-bottom-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-bottom-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;");b.zoomContainer=d('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:'+b.nzOffset.left+"px;top:"+b.nzOffset.top+"px;height:"+b.nzHeight+"px;width:"+b.nzWidth+'px;"></div>');d("body").append(b.zoomContainer);b.options.containLensZoom&&"lens"==b.options.zoomType&&b.zoomContainer.css("overflow",
"hidden");"inner"!=b.options.zoomType&&(b.zoomLens=d("<div class='zoomLens' style='"+b.lensStyle+b.lensRound+"'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")}),b.options.tint&&(b.tintContainer=d("<div/>").addClass("tintContainer"),b.zoomTint=d("<div class='zoomTint' style='"+b.tintStyle+"'></div>"),b.zoomLens.wrap(b.tintContainer),b.zoomTintcss=b.zoomLens.after(b.zoomTint),b.zoomTintImage=d('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: '+
b.nzWidth+"px; height: "+b.nzHeight+'px;" src="'+b.imageSrc+'">').appendTo(b.zoomLens).click(function(){b.$elem.trigger("click")})));isNaN(b.options.zoomWindowPosition)?b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+"' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function(){b.$elem.trigger("click")}):b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+
"' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")});b.zoomWindowContainer=d("<div/>").addClass("zoomWindowContainer").css("width",b.options.zoomWindowWidth);b.zoomWindow.wrap(b.zoomWindowContainer);"lens"==b.options.zoomType&&b.zoomLens.css({backgroundImage:"url('"+b.imageSrc+"')"});"window"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+"')"});"inner"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+
"')"});b.$elem.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchmove",function(a){"inner"==b.options.zoomType&&b.showHideWindow("show");a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});
b.$elem.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});b.options.showLens&&(b.zoomLens.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])}),b.zoomLens.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")}));
b.$elem.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"!=b.options.zoomType&&b.zoomLens.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),
b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.options.tint&&"inner"!=b.options.zoomType&&b.zoomTint.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"==b.options.zoomType&&b.zoomWindow.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.add(b.$elem).mouseenter(function(){!1==b.overWindow&&
b.setElements("show")}).mouseleave(function(){b.scrollLock||b.setElements("hide")});"inner"!=b.options.zoomType&&b.zoomWindow.mouseenter(function(){b.overWindow=!0;b.setElements("hide")}).mouseleave(function(){b.overWindow=!1});b.minZoomLevel=b.options.minZoomLevel?b.options.minZoomLevel:2*b.options.scrollZoomIncrement;b.options.scrollZoom&&b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll",function(a){b.scrollLock=!0;clearTimeout(d.data(this,"timer"));d.data(this,"timer",
setTimeout(function(){b.scrollLock=!1},250));var e=a.originalEvent.wheelDelta||-1*a.originalEvent.detail;a.stopImmediatePropagation();a.stopPropagation();a.preventDefault();0<e/120?b.currentZoomLevel>=b.minZoomLevel&&b.changeZoomLevel(b.currentZoomLevel-b.options.scrollZoomIncrement):b.options.maxZoomLevel?b.currentZoomLevel<=b.options.maxZoomLevel&&b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement):b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement);
return!1})},setElements:function(b){if(!this.options.zoomEnabled)return!1;"show"==b&&this.isWindowSet&&("inner"==this.options.zoomType&&this.showHideWindow("show"),"window"==this.options.zoomType&&this.showHideWindow("show"),this.options.showLens&&this.showHideLens("show"),this.options.tint&&"inner"!=this.options.zoomType&&this.showHideTint("show"));"hide"==b&&("window"==this.options.zoomType&&this.showHideWindow("hide"),this.options.tint||this.showHideWindow("hide"),this.options.showLens&&this.showHideLens("hide"),
this.options.tint&&this.showHideTint("hide"))},setPosition:function(b){if(!this.options.zoomEnabled)return!1;this.nzHeight=this.$elem.height();this.nzWidth=this.$elem.width();this.nzOffset=this.$elem.offset();this.options.tint&&"inner"!=this.options.zoomType&&(this.zoomTint.css({top:0}),this.zoomTint.css({left:0}));this.options.responsive&&!this.options.scrollZoom&&this.options.showLens&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/
this.heightRatio),lensWidth=this.largeWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.widthRatio=this.largeWidth/this.nzWidth,this.heightRatio=this.largeHeight/this.nzHeight,"lens"!=this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/
this.widthRatio,this.zoomLens.css("width",lensWidth),this.zoomLens.css("height",lensHeight),this.options.tint&&(this.zoomTintImage.css("width",this.nzWidth),this.zoomTintImage.css("height",this.nzHeight))),"lens"==this.options.zoomType&&this.zoomLens.css({width:String(this.options.lensSize)+"px",height:String(this.options.lensSize)+"px"}));this.zoomContainer.css({top:this.nzOffset.top});this.zoomContainer.css({left:this.nzOffset.left});this.mouseLeft=parseInt(b.pageX-this.nzOffset.left);this.mouseTop=
parseInt(b.pageY-this.nzOffset.top);"window"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.zoomLens.height()/2,this.Eboppos=this.mouseTop>this.nzHeight-this.zoomLens.height()/2-2*this.options.lensBorderSize,this.Eloppos=this.mouseLeft<0+this.zoomLens.width()/2,this.Eroppos=this.mouseLeft>this.nzWidth-this.zoomLens.width()/2-2*this.options.lensBorderSize);"inner"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.nzHeight/2/this.heightRatio,this.Eboppos=this.mouseTop>this.nzHeight-
this.nzHeight/2/this.heightRatio,this.Eloppos=this.mouseLeft<0+this.nzWidth/2/this.widthRatio,this.Eroppos=this.mouseLeft>this.nzWidth-this.nzWidth/2/this.widthRatio-2*this.options.lensBorderSize);0>=this.mouseLeft||0>this.mouseTop||this.mouseLeft>this.nzWidth||this.mouseTop>this.nzHeight?this.setElements("hide"):(this.options.showLens&&(this.lensLeftPos=String(this.mouseLeft-this.zoomLens.width()/2),this.lensTopPos=String(this.mouseTop-this.zoomLens.height()/2)),this.Etoppos&&(this.lensTopPos=0),
this.Eloppos&&(this.tintpos=this.lensLeftPos=this.windowLeftPos=0),"window"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize)),"inner"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.nzWidth-2*this.options.lensBorderSize)),
"lens"==this.options.zoomType&&(this.windowLeftPos=String(-1*((b.pageX-this.nzOffset.left)*this.widthRatio-this.zoomLens.width()/2)),this.windowTopPos=String(-1*((b.pageY-this.nzOffset.top)*this.heightRatio-this.zoomLens.height()/2)),this.zoomLens.css({backgroundPosition:this.windowLeftPos+"px "+this.windowTopPos+"px"}),this.changeBgSize&&(this.nzHeight>this.nzWidth?("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+
"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+"px"})):("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"})),this.changeBgSize=!1),this.setWindowPostition(b)),this.options.tint&&"inner"!=this.options.zoomType&&
this.setTintPosition(b),"window"==this.options.zoomType&&this.setWindowPostition(b),"inner"==this.options.zoomType&&this.setWindowPostition(b),this.options.showLens&&(this.fullwidth&&"lens"!=this.options.zoomType&&(this.lensLeftPos=0),this.zoomLens.css({left:this.lensLeftPos+"px",top:this.lensTopPos+"px"})))},showHideWindow:function(b){"show"!=b||this.isWindowActive||(this.options.zoomWindowFadeIn?this.zoomWindow.stop(!0,!0,!1).fadeIn(this.options.zoomWindowFadeIn):this.zoomWindow.show(),this.isWindowActive=
!0);"hide"==b&&this.isWindowActive&&(this.options.zoomWindowFadeOut?this.zoomWindow.stop(!0,!0).fadeOut(this.options.zoomWindowFadeOut):this.zoomWindow.hide(),this.isWindowActive=!1)},showHideLens:function(b){"show"!=b||this.isLensActive||(this.options.lensFadeIn?this.zoomLens.stop(!0,!0,!1).fadeIn(this.options.lensFadeIn):this.zoomLens.show(),this.isLensActive=!0);"hide"==b&&this.isLensActive&&(this.options.lensFadeOut?this.zoomLens.stop(!0,!0).fadeOut(this.options.lensFadeOut):this.zoomLens.hide(),
this.isLensActive=!1)},showHideTint:function(b){"show"!=b||this.isTintActive||(this.options.zoomTintFadeIn?this.zoomTint.css({opacity:this.options.tintOpacity}).animate().stop(!0,!0).fadeIn("slow"):(this.zoomTint.css({opacity:this.options.tintOpacity}).animate(),this.zoomTint.show()),this.isTintActive=!0);"hide"==b&&this.isTintActive&&(this.options.zoomTintFadeOut?this.zoomTint.stop(!0,!0).fadeOut(this.options.zoomTintFadeOut):this.zoomTint.hide(),this.isTintActive=!1)},setLensPostition:function(b){},
setWindowPostition:function(b){var a=this;if(isNaN(a.options.zoomWindowPosition))a.externalContainer=d("#"+a.options.zoomWindowPosition),a.externalContainerWidth=a.externalContainer.width(),a.externalContainerHeight=a.externalContainer.height(),a.externalContainerOffset=a.externalContainer.offset(),a.windowOffsetTop=a.externalContainerOffset.top,a.windowOffsetLeft=a.externalContainerOffset.left;else switch(a.options.zoomWindowPosition){case 1:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=
+a.nzWidth;break;case 2:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=a.nzWidth);break;case 3:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=a.nzWidth;break;case 4:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth;break;case 5:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 6:a.options.zoomWindowHeight>
a.nzHeight&&(a.windowOffsetTop=a.nzHeight,a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 7:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=0;break;case 8:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 9:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 10:a.options.zoomWindowHeight>a.nzHeight&&
(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize));break;case 11:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 12:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 13:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=
0;break;case 14:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize),a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 15:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 16:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth;break;default:a.windowOffsetTop=
a.options.zoomWindowOffety,a.windowOffsetLeft=a.nzWidth}a.isWindowSet=!0;a.windowOffsetTop+=a.options.zoomWindowOffety;a.windowOffsetLeft+=a.options.zoomWindowOffetx;a.zoomWindow.css({top:a.windowOffsetTop});a.zoomWindow.css({left:a.windowOffsetLeft});"inner"==a.options.zoomType&&(a.zoomWindow.css({top:0}),a.zoomWindow.css({left:0}));a.windowLeftPos=String(-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2));a.windowTopPos=String(-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/
2));a.Etoppos&&(a.windowTopPos=0);a.Eloppos&&(a.windowLeftPos=0);a.Eboppos&&(a.windowTopPos=-1*(a.largeHeight/a.currentZoomLevel-a.zoomWindow.height()));a.Eroppos&&(a.windowLeftPos=-1*(a.largeWidth/a.currentZoomLevel-a.zoomWindow.width()));a.fullheight&&(a.windowTopPos=0);a.fullwidth&&(a.windowLeftPos=0);if("window"==a.options.zoomType||"inner"==a.options.zoomType)1==a.zoomLock&&(1>=a.widthRatio&&(a.windowLeftPos=0),1>=a.heightRatio&&(a.windowTopPos=0)),a.largeHeight<a.options.zoomWindowHeight&&(a.windowTopPos=
0),a.largeWidth<a.options.zoomWindowWidth&&(a.windowLeftPos=0),a.options.easing?(a.xp||(a.xp=0),a.yp||(a.yp=0),a.loop||(a.loop=setInterval(function(){a.xp+=(a.windowLeftPos-a.xp)/a.options.easingAmount;a.yp+=(a.windowTopPos-a.yp)/a.options.easingAmount;a.scrollingLock?(clearInterval(a.loop),a.xp=a.windowLeftPos,a.yp=a.windowTopPos,a.xp=-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2),a.yp=-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/2),a.changeBgSize&&(a.nzHeight>
a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),
a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+"px "+a.windowTopPos+"px"}),a.scrollingLock=!1,a.loop=!1):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+
"px "+a.largeHeight/a.newvaluewidth+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.xp+"px "+a.yp+"px"}))},16))):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/
a.newvalueheight+"px"})):("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}),a.largeHeight/a.newvaluewidth<a.options.zoomWindowHeight?a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}):a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+
"px "+a.windowTopPos+"px"}))},setTintPosition:function(b){this.nzOffset=this.$elem.offset();this.tintpos=String(-1*(b.pageX-this.nzOffset.left-this.zoomLens.width()/2));this.tintposy=String(-1*(b.pageY-this.nzOffset.top-this.zoomLens.height()/2));this.Etoppos&&(this.tintposy=0);this.Eloppos&&(this.tintpos=0);this.Eboppos&&(this.tintposy=-1*(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize));this.Eroppos&&(this.tintpos=-1*(this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize));
this.options.tint&&(this.fullheight&&(this.tintposy=0),this.fullwidth&&(this.tintpos=0),this.zoomTintImage.css({left:this.tintpos+"px"}),this.zoomTintImage.css({top:this.tintposy+"px"}))},swaptheimage:function(b,a){var c=this,e=new Image;c.options.loadingIcon&&(c.spinner=d("<div style=\"background: url('"+c.options.loadingIcon+"') no-repeat center;height:"+c.nzHeight+"px;width:"+c.nzWidth+'px;z-index: 2000;position: absolute; background-position: center center;"></div>'),c.$elem.after(c.spinner));
c.options.onImageSwap(c.$elem);e.onload=function(){c.largeWidth=e.width;c.largeHeight=e.height;c.zoomImage=a;c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.swapAction(b,a)};e.src=a},swapAction:function(b,a){var c=this,e=new Image;e.onload=function(){c.nzHeight=e.height;c.nzWidth=e.width;c.options.onImageSwapComplete(c.$elem);c.doneCallback()};e.src=b;c.currentZoomLevel=c.options.zoomLevel;c.options.maxZoomLevel=
!1;"lens"==c.options.zoomType&&c.zoomLens.css({backgroundImage:"url('"+a+"')"});"window"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});"inner"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});c.currentImage=a;if(c.options.imageCrossfade){var f=c.$elem,g=f.clone();c.$elem.attr("src",b);c.$elem.after(g);g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()});c.$elem.width("auto").removeAttr("width");c.$elem.height("auto").removeAttr("height");
f.fadeIn(c.options.imageCrossfade);c.options.tint&&"inner"!=c.options.zoomType&&(f=c.zoomTintImage,g=f.clone(),c.zoomTintImage.attr("src",a),c.zoomTintImage.after(g),g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()}),f.fadeIn(c.options.imageCrossfade),c.zoomTint.css({height:c.$elem.height()}),c.zoomTint.css({width:c.$elem.width()}));c.zoomContainer.css("height",c.$elem.height());c.zoomContainer.css("width",c.$elem.width());"inner"!=c.options.zoomType||c.options.constrainType||
(c.zoomWrap.parent().css("height",c.$elem.height()),c.zoomWrap.parent().css("width",c.$elem.width()),c.zoomWindow.css("height",c.$elem.height()),c.zoomWindow.css("width",c.$elem.width()))}else c.$elem.attr("src",b),c.options.tint&&(c.zoomTintImage.attr("src",a),c.zoomTintImage.attr("height",c.$elem.height()),c.zoomTintImage.css({height:c.$elem.height()}),c.zoomTint.css({height:c.$elem.height()})),c.zoomContainer.css("height",c.$elem.height()),c.zoomContainer.css("width",c.$elem.width());c.options.imageCrossfade&&
(c.zoomWrap.css("height",c.$elem.height()),c.zoomWrap.css("width",c.$elem.width()));c.options.constrainType&&("height"==c.options.constrainType&&(c.zoomContainer.css("height",c.options.constrainSize),c.zoomContainer.css("width","auto"),c.options.imageCrossfade?(c.zoomWrap.css("height",c.options.constrainSize),c.zoomWrap.css("width","auto"),c.constwidth=c.zoomWrap.width()):(c.$elem.css("height",c.options.constrainSize),c.$elem.css("width","auto"),c.constwidth=c.$elem.width()),"inner"==c.options.zoomType&&
(c.zoomWrap.parent().css("height",c.options.constrainSize),c.zoomWrap.parent().css("width",c.constwidth),c.zoomWindow.css("height",c.options.constrainSize),c.zoomWindow.css("width",c.constwidth)),c.options.tint&&(c.tintContainer.css("height",c.options.constrainSize),c.tintContainer.css("width",c.constwidth),c.zoomTint.css("height",c.options.constrainSize),c.zoomTint.css("width",c.constwidth),c.zoomTintImage.css("height",c.options.constrainSize),c.zoomTintImage.css("width",c.constwidth))),"width"==
c.options.constrainType&&(c.zoomContainer.css("height","auto"),c.zoomContainer.css("width",c.options.constrainSize),c.options.imageCrossfade?(c.zoomWrap.css("height","auto"),c.zoomWrap.css("width",c.options.constrainSize),c.constheight=c.zoomWrap.height()):(c.$elem.css("height","auto"),c.$elem.css("width",c.options.constrainSize),c.constheight=c.$elem.height()),"inner"==c.options.zoomType&&(c.zoomWrap.parent().css("height",c.constheight),c.zoomWrap.parent().css("width",c.options.constrainSize),c.zoomWindow.css("height",
c.constheight),c.zoomWindow.css("width",c.options.constrainSize)),c.options.tint&&(c.tintContainer.css("height",c.constheight),c.tintContainer.css("width",c.options.constrainSize),c.zoomTint.css("height",c.constheight),c.zoomTint.css("width",c.options.constrainSize),c.zoomTintImage.css("height",c.constheight),c.zoomTintImage.css("width",c.options.constrainSize))))},doneCallback:function(){this.options.loadingIcon&&this.spinner.hide();this.nzOffset=this.$elem.offset();this.nzWidth=this.$elem.width();
this.nzHeight=this.$elem.height();this.currentZoomLevel=this.options.zoomLevel;this.widthRatio=this.largeWidth/this.nzWidth;this.heightRatio=this.largeHeight/this.nzHeight;"window"==this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.zoomLens&&(this.zoomLens.css("width",
lensWidth),this.zoomLens.css("height",lensHeight)))},getCurrentImage:function(){return this.zoomImage},getGalleryList:function(){var b=this;b.gallerylist=[];b.options.gallery?d("#"+b.options.gallery+" a").each(function(){var a="";d(this).data("zoom-image")?a=d(this).data("zoom-image"):d(this).data("image")&&(a=d(this).data("image"));a==b.zoomImage?b.gallerylist.unshift({href:""+a+"",title:d(this).find("img").attr("title")}):b.gallerylist.push({href:""+a+"",title:d(this).find("img").attr("title")})}):
b.gallerylist.push({href:""+b.zoomImage+"",title:d(this).find("img").attr("title")});return b.gallerylist},changeZoomLevel:function(b){this.scrollingLock=!0;this.newvalue=parseFloat(b).toFixed(2);newvalue=parseFloat(b).toFixed(2);maxheightnewvalue=this.largeHeight/(this.options.zoomWindowHeight/this.nzHeight*this.nzHeight);maxwidthtnewvalue=this.largeWidth/(this.options.zoomWindowWidth/this.nzWidth*this.nzWidth);"inner"!=this.options.zoomType&&(maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
maxheightnewvalue/this.nzHeight,this.newvalueheight=maxheightnewvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/maxwidthtnewvalue/this.nzWidth,this.newvaluewidth=maxwidthtnewvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1),"lens"==this.options.zoomType&&(maxheightnewvalue<=newvalue?
(this.fullwidth=!0,this.newvaluewidth=maxheightnewvalue):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1)));"inner"==this.options.zoomType&&(maxheightnewvalue=parseFloat(this.largeHeight/this.nzHeight).toFixed(2),maxwidthtnewvalue=parseFloat(this.largeWidth/this.nzWidth).toFixed(2),newvalue>maxheightnewvalue&&(newvalue=maxheightnewvalue),newvalue>maxwidthtnewvalue&&(newvalue=maxwidthtnewvalue),maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue>maxwidthtnewvalue?maxwidthtnewvalue:newvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=
newvalue,this.fullwidth=!1));scrcontinue=!1;"inner"==this.options.zoomType&&(this.nzWidth>this.nzHeight&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)),this.nzHeight>this.nzWidth&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)));"inner"!=this.options.zoomType&&(scrcontinue=!0);scrcontinue&&(this.zoomLock=0,this.changeZoom=!0,this.options.zoomWindowHeight/this.heightRatio<=this.nzHeight&&
(this.currentZoomLevel=this.newvalueheight,"lens"!=this.options.zoomType&&"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({height:String(this.options.zoomWindowHeight/this.heightRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),this.options.zoomWindowWidth/this.widthRatio<=this.nzWidth&&("inner"!=this.options.zoomType&&this.newvaluewidth>this.newvalueheight&&(this.currentZoomLevel=this.newvaluewidth),"lens"!=this.options.zoomType&&
"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({width:String(this.options.zoomWindowWidth/this.widthRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),"inner"==this.options.zoomType&&(this.changeBgSize=!0,this.nzWidth>this.nzHeight&&(this.currentZoomLevel=this.newvaluewidth),this.nzHeight>this.nzWidth&&(this.currentZoomLevel=this.newvaluewidth)));this.setPosition(this.currentLoc)},closeAll:function(){self.zoomWindow&&self.zoomWindow.hide();
self.zoomLens&&self.zoomLens.hide();self.zoomTint&&self.zoomTint.hide()},changeState:function(b){"enable"==b&&(this.options.zoomEnabled=!0);"disable"==b&&(this.options.zoomEnabled=!1)}};d.fn.elevateZoom=function(b){return this.each(function(){var a=Object.create(k);a.init(b,this);d.data(this,"elevateZoom",a)})};d.fn.elevateZoom.options={zoomActivation:"hover",zoomEnabled:!0,preloading:1,zoomLevel:1,scrollZoom:!1,scrollZoomIncrement:0.1,minZoomLevel:!1,maxZoomLevel:!1,easing:!1,easingAmount:12,lensSize:200,
zoomWindowWidth:400,zoomWindowHeight:400,zoomWindowOffetx:0,zoomWindowOffety:0,zoomWindowPosition:1,zoomWindowBgColour:"#fff",lensFadeIn:!1,lensFadeOut:!1,debug:!1,zoomWindowFadeIn:!1,zoomWindowFadeOut:!1,zoomWindowAlwaysShow:!1,zoomTintFadeIn:!1,zoomTintFadeOut:!1,borderSize:4,showLens:!0,borderColour:"#888",lensBorderSize:1,lensBorderColour:"#000",lensShape:"square",zoomType:"window",containLensZoom:!1,lensColour:"white",lensOpacity:0.4,lenszoom:!1,tint:!1,tintColour:"#333",tintOpacity:0.4,gallery:!1,
galleryActiveClass:"zoomGalleryActive",imageCrossfade:!1,constrainType:!1,constrainSize:!1,loadingIcon:!1,cursor:"default",responsive:!0,onComplete:d.noop,onZoomedImageLoaded:function(){},onImageSwap:d.noop,onImageSwapComplete:d.noop}})(jQuery,window,document);;
/*
 *	 Angular Elevated Zoom jquery wrapper (angular-elevate-zoom)
 *	 Elevated Zoom jQuery plugin wrapper for Angular.js, by AppFeel.
 *
 *	 Version: 1.0.3
 * 	 License: MIT
 */
!function(){"use strict";var o=angular.module("angular-elevate-zoom",[]);o.provider("ElevateZoomConfig",function(){this.zoomConfig={},this.setZoomConfig=function(o){this.zoomConfig=o},this.$get=function(){return this}}),o.directive("ezZoom",["ezZoomSvc",function(o){return{restrict:"AC",scope:{ezZoomConfig:"="},link:function(e,t,n){n.$observe("ezZoomImage",function(n){o.remove(t),n&&o.attach(t,n,e.ezZoomConfig)})}}}]),o.factory("ezZoomSvc",["ElevateZoomConfig",function(o){return{attach:function(e,t,n){var i=$(e);i.data("zoom-image",t),i.elevateZoom(n||o.zoomConfig)},remove:function(o){var e=$(o);e.length>0?($("#"+e.attr("id")+"-zoomContainer").remove(),e.removeData("elevateZoom"),e.removeData("zoomImage")):$(".zoomContainer").remove()}}}])}();

(function () {
  'use strict';

  var cropper = {
    templateUrl: 'app/components/crop/crop.directive.html',
    controller: CropperController,
    controllerAs: 'vm',
    bindings: {
      files: '<',
      image: '<',
      portrait: '<',
      customClass: '<',
      onUpdate: '<',
      hideDelete: '<',
      onCancel: '&'
    }
  };

  angular
    .module('garanteasyApp')
    .component('imageCropper', cropper);

  CropperController.$inject = ['$scope', '$element', '$log'];

  function CropperController($scope, $element, $log) {
    var vm = this;

    vm.createCroppie = createCroppie;
    vm.destroy = destroy;
    vm.zoomIn = zoomIn;
    vm.zoomOut = zoomOut;
    vm.rotate = rotate;
    vm.print = print;
    vm.cancel = cancel;
    vm.select = select;
    vm.isImage = isImage;
    vm.printReceipt = printReceipt;

    vm.croppie = null;
    vm.maxWidith = null;
    vm.maxHeight = 377;
    vm.selectedFile = null;

    init();

    $scope.$on('$destroy', function () {
      vm.alerts = [];
    });

    $scope.$watch("vm.image", function () {
      if (vm.image) {
        vm.destroy();
        if (vm.portrait && !(vm.selectedFile && vm.selectedFile.changed)) {
          return _forcePortrait(vm.image);
        }
        return vm.createCroppie(vm.image);
      } else if (vm.croppie) {
        return vm.destroy();
      }
    });

    $scope.$watch("vm.files", function () {
      if (vm.files && vm.files.length && !vm.selectedFile) {
        _buildSrcFiles();
        if (vm.files[0].src) {
          vm.image = vm.files[0].src;
        } else {
          vm.image = 'data:' + vm.files[0].fileContentType + ';base64,' + vm.files[0].fileData;
        }
        vm.selectedFile = vm.files[0];
      }
    }, true);

    function init() {
      var el = $element.find('.croppie-img-wrapper')[0];
      if (el) {
        vm.maxWidith = el.offsetWidth;
      }
      if (!vm.files) {
        vm.files = [];
      } else {
        _buildSrcFiles();
      }
    }

    function createCroppie(img, rotated) {
      var image = new Image;
      image.src = img;
      image.onload = function () {
        var width = image.width;
        var height = image.height;
        if (height > vm.maxHeight) {
          width = (width * vm.maxHeight / height);
          height = vm.maxHeight;
        }
        if (width > vm.maxWidith) {
          height = (height * vm.maxWidith / width);
          width = vm.maxWidith;
        }

        var myImg = $element.find('.croppie-my-image')[0];
        myImg.src = img;
        if (rotated) {
          _changedFile(img);
          if (typeof vm.onUpdate === 'function') {
            vm.onUpdate(img);
          }
        }
        vm.croppie = new Croppie(myImg, {
          viewport: {
            width: width,
            height: height
          },
          boundary: {
            width: width,
            height: height
          },
          showZoomer: false,
          enableResize: false,
          enableOrientation: true,
          enforceBoundary: true,
          enableExif: true,
          mouseWheelZoom: false
        });
      };
    }

    function zoomIn() {
      if (!vm.croppie) {
        return;
      }
      var zoom = vm.croppie.get('currentZoom');
      vm.croppie.setZoom(zoom.zoom + 0.05);
      vm.croppie.result({
        type: 'base64',
        size: 'original',
        format: 'jpeg',
        quality: 0.9
      }).then(function (result) {
        if (typeof vm.onUpdate === 'function') {
          vm.onUpdate(result);
        }
        _changedFile(result);
      });
    }

    function zoomOut() {
      if (!vm.croppie) {
        return;
      }
      var zoom = vm.croppie.get('currentZoom');
      vm.croppie.setZoom(zoom.zoom - 0.05);
      vm.croppie.result({
        type: 'base64',
        size: 'original',
        format: 'jpeg',
        quality: 0.9
      }).then(function (result) {
        if (typeof vm.onUpdate === 'function') {
          vm.onUpdate(result);
        }
        _changedFile(result);
      });
    }

    function rotate() {
      if (!vm.croppie) {
        return;
      }
      try {
        vm.croppie.destroy();
        $element.find('.croppie-img-wrapper')[0].innerHTML = $element.find('.croppie-my-image')[0].outerHTML;
        _rotateImage($element.find('.croppie-my-image')[0].src, vm.createCroppie);
      } catch (error) {
        $log.error(error);
      }
    }

    function print() {
      if (!vm.croppie) {
        return;
      }
      if (vm.selectedFile && vm.selectedFile.fileContentType === 'build') {
        return vm.printReceipt();
      }
      var source = $element.find('.croppie-my-image')[0].src;
      var popupWin = window.open('', '_blank');
      popupWin.document.open();
      var style = '@media print {@page {size: A4 portrait; }img {  max-width: 80%; margin: auto; padding: 0; }	}';
      popupWin.document.write('<html><head><style type="text/css">' + style + '</style></head><body onload="window.print()"><img style="max-width: 80%;" src="' + source + '" /></body></html>');
      popupWin.document.close();
    }

    function cancel() {
      vm.onCancel({
        file: vm.selectedFile
      });
    }

    function destroy() {
      $element.find('.croppie-my-image')[0].src = '';
      if (vm.croppie) {
        try {
          vm.croppie.destroy();
          $element.find('.croppie-img-wrapper')[0].innerHTML = $element.find('.croppie-my-image')[0].outerHTML;
        } catch (error) {
          vm.croppie = null;
        }
      }
    }

    function select(image) {
      if (vm.selectedFile.fileDataChanged) {
        vm.selectedFile.fileData = vm.selectedFile.fileDataChanged;
        vm.selectedFile.fileDataChanged = null;
        vm.selectedFile.changed = true;
      }
      vm.selectedFile = image;
      if (image.src) {
        vm.image = image.src;
      } else {
        vm.image = 'data:' + image.fileContentType + ';base64,' + image.fileData;
      }
    }

    function isImage(image) {
      return image && image.fileContentType && image.fileContentType.toLowerCase().indexOf('image') !== -1 && image.fileContentType.toLowerCase().indexOf('tiff') === -1;
    }

    function _rotateImage(srcBase64, callback) {
      var img = new Image();
      img.onload = function () {
        var width = img.width,
          height = img.height,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext("2d");

        canvas.width = height;
        canvas.height = width;

        ctx.transform(0, 1, -1, 0, height, 0);
        ctx.drawImage(img, 0, 0);
        callback(canvas.toDataURL('image/jpeg', 0.85), true);
      };
      img.src = srcBase64;
    }

    function _forcePortrait(srcBase64) {
      var img = new Image();
      img.onload = function () {
        if (img.width > img.height) {
          return _rotateImage(srcBase64, vm.createCroppie);
        } else {
          return vm.createCroppie(srcBase64);
        }

      };
      img.src = srcBase64;
    }

    function _buildSrcFiles() {
      angular.forEach(vm.files, function (element, key) {
        // Tutti ciò che non è immagine (pdf, doc, ...) deve passare per una rotta ad-hoc per evitare il filtro di ridimensionamento che altrimenti solleva una eccezione
        if (!isImage(element)) {
          element.srcDoc = '/doc/' + element.src;
          $log.debug("Selected file is NOT an image", element);
        }
      });
    }

    function _srcToFileData(data) {
      if (!data && typeof data !== 'string') {
        return '';
      }
      return data.slice(data.indexOf('base64,') + 'base64,'.length);
    }

    function _changedFile(result) {
      if (vm.selectedFile && vm.selectedFile.fileContentType && vm.selectedFile.fileData) {
        vm.selectedFile.fileDataChanged = _srcToFileData(result);
      }
    }

    function printReceipt() {
      var content = document.getElementById('receiptPrintContent').innerHTML;
      var headContent = document.getElementsByTagName('head')[0].innerHTML;
      var popupWin = window.open('', '_blank');
      popupWin.document.open();
      var style = '.receipt-print{ max-width: 600px; } @media print {@page {size: A4 portrait; } .receipt-print{ max-width: 300px; margin: auto; padding: 0; }	}';
      popupWin.document.write('<html><head>' + headContent + '<style type="text/css">' + style + '</style></head><body onload="window.print()"><div class="receipt-print">' + content + '</div></body></html>');
      popupWin.document.close();
    }
  }
})();
;
angular
    .module('garanteasyApp')
    .component('cardWarrenty', {
        templateUrl: 'app/components/cards/warrenty/warrenty.component.html',
        controller: CardWarrentyComponentController,
        controllerAs: 'vm',
        bindings: {
            warrenty: '<'
        }
    });

CardWarrentyComponentController.$inject = ['DataUtils'];

function CardWarrentyComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
    vm.getImage = getImage;
    vm.getIcon = getIcon;
    vm.isOfficial = isOfficial;

    function isOfficial() {
        if (vm.warrenty.receipt.source === 'MERCHANT') {
            return true;
        } else {
            return false;
        }
    }

    function getImage(purchasedProductWarranty) {
        var item = (((purchasedProductWarranty || {}).warranty || {}) || {}).warrantyType;
        if (item === 'LEGAL') {
            return '/content/images/ICONA_GARANZIE_LEGALE.png';
        } else if (item === 'CONVENTIONAL') {
            return '/content/images/ICONA_GARANZIE_CONVENZIONALE.png';
        } else if (item === 'SERVICE_CONTRACT') {
            return '/content/images/ICONA_GARANZIE_ASSISTENZA.png';
        } else if (item === 'INSURANCE') {
            return '/content/images/ICONA_GARANZIE_POLIZZA.png';
        } else {
            return '/content/images/ICONA_GARANZIE_LEGALE.png';
        }
    }

    function getIcon(purchasedProductWarranty) {
        var icon = 'fa-balance-scale';
        if (purchasedProductWarranty && purchasedProductWarranty.warranty) {
            icon = vm.warrantyIcons[purchasedProductWarranty.warranty.type] || icon;
        }
        return icon;
    }
}
;
angular
    .module('garanteasyApp')
    .component('cardShop', {
        templateUrl: 'app/components/cards/shop/shop.component.html',
        controller: CardShopComponentController,
        controllerAs: 'vm',
        bindings: {
            shop: '<'
        }
    });

CardShopComponentController.$inject = ['DataUtils'];

function CardShopComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
}
;
angular
  .module('garanteasyApp')
  .component('cardReceipt', {
    templateUrl: 'app/components/cards/receipt/receipt.component.html',
    controller: CardReceiptComponentController,
    controllerAs: 'vm',
    bindings: {
      receipt: '<'
    }
  });

CardReceiptComponentController.$inject = ['AuthServerProvider', 'DataUtils', 'API_URI'];

function CardReceiptComponentController(AuthServerProvider, DataUtils, API_URI) {
  var vm = this;
  vm.showCustomerName = function (customer) {
    return DataUtils.showCustomerName(customer);
  };
  vm.getImageUrl = function (receipt) {
    if (((receipt || {}).receiptFiles || {}).length > 0) {
      var image = _.find(receipt.receiptFiles, function (o) {
        if (o.fileContentType === null) return;
        return o.fileContentType.startsWith('image/');
      });
      if (image) {
        return API_URI + "api/receipt-files/content/" + image.id + "?width=-&height=150&token=" + AuthServerProvider.getToken();
      } else {
        return null;
      }
    }
  };
}
;
angular
    .module('garanteasyApp')
    .component('cardProduct', {
        templateUrl: 'app/components/cards/product/product.component.html',
        controller: CardProductComponentController,
        controllerAs: 'vm',
        bindings: {
            product: '<'
        }
    });

CardProductComponentController.$inject = ['DataUtils'];

function CardProductComponentController(DataUtils) {
    var vm = this;
    vm.abbreviate = DataUtils.abbreviate;
}
;
angular
    .module('garanteasyApp')
    .component('cardCustomer', {
        templateUrl: 'app/components/cards/customer/customer.component.html',
        controller: CardCustomerComponentController,
        controllerAs: 'vm',
        bindings: {
            customer: '<'
        }
    });

CardCustomerComponentController.$inject = ['AuthServerProvider', 'DataUtils'];

function CardCustomerComponentController(AuthServerProvider, DataUtils) {
    var vm = this;
    vm.showCustomerName = function (customer) {
        return DataUtils.showCustomerName(customer);
    };

}
;
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e(e.toString()).default:"object"==typeof exports?exports.Quagga=e(e.toString()).default:t.Quagga=e(e.toString()).default}(this,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=167)}([function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t,e){return this._row=[],this.config=t||{},this.supplements=e,this}var o=n(3);r.prototype._nextUnset=function(t,e){var n;for(void 0===e&&(e=0),n=e;n<t.length;n++)if(!t[n])return n;return t.length},r.prototype._matchPattern=function(t,e,n){var r,o,i,a,u=0,c=0,s=0,f=0;for(n=n||this.SINGLE_CODE_ERROR||1,r=0;r<t.length;r++)s+=t[r],f+=e[r];if(s<f)return Number.MAX_VALUE;for(o=s/f,n*=o,r=0;r<t.length;r++){if(i=t[r],a=e[r]*o,(c=Math.abs(i-a)/a)>n)return Number.MAX_VALUE;u+=c}return u/f},r.prototype._nextSet=function(t,e){var n;for(e=e||0,n=e;n<t.length;n++)if(t[n])return n;return t.length},r.prototype._correctBars=function(t,e,n){for(var r=n.length,o=0;r--;)(o=t[n[r]]*(1-(1-e)/2))>1&&(t[n[r]]=o)},r.prototype._matchTrace=function(t,e){var n,r,o=[],i=this,a=i._nextSet(i._row),u=!i._row[a],c=0,s={error:Number.MAX_VALUE,code:-1,start:0};if(t){for(n=0;n<t.length;n++)o.push(0);for(n=a;n<i._row.length;n++)if(i._row[n]^u)o[c]++;else{if(c===o.length-1)return r=i._matchPattern(o,t),r<e?(s.start=n-a,s.end=n,s.counter=o,s):null;c++,o[c]=1,u=!u}}else for(o.push(0),n=a;n<i._row.length;n++)i._row[n]^u?o[c]++:(c++,o.push(0),o[c]=1,u=!u);return s.start=a,s.end=i._row.length-1,s.counter=o,s},r.prototype.decodePattern=function(t){var e,n=this;return n._row=t,e=n._decode(),null===e?(n._row.reverse(),(e=n._decode())&&(e.direction=r.DIRECTION.REVERSE,e.start=n._row.length-e.start,e.end=n._row.length-e.end)):e.direction=r.DIRECTION.FORWARD,e&&(e.format=n.FORMAT),e},r.prototype._matchRange=function(t,e,n){var r;for(t=t<0?0:t,r=t;r<e;r++)if(this._row[r]!==n)return!1;return!0},r.prototype._fillCounters=function(t,e,n){var r,o=this,i=0,a=[];for(n=void 0===n||n,t=void 0!==t?t:o._nextUnset(o._row),e=e||o._row.length,a[i]=0,r=t;r<e;r++)o._row[r]^n?a[i]++:(i++,a[i]=1,n=!n);return a},r.prototype._toCounters=function(t,e){var n,r=this,i=e.length,a=r._row.length,u=!r._row[t],c=0;for(o.a.init(e,0),n=t;n<a;n++)if(r._row[n]^u)e[c]++;else{if(++c===i)break;e[c]=1,u=!u}return e},Object.defineProperty(r.prototype,"FORMAT",{value:"unknown",writeable:!1}),r.DIRECTION={FORWARD:1,REVERSE:-1},r.Exception={StartNotFoundException:"Start-Info was not found!",CodeNotFoundException:"Code could not be found!",PatternNotFoundException:"Pattern could not be found!"},r.CONFIG_KEYS={},e.a=r},function(t,e){var n=Array.isArray;t.exports=n},function(t,e,n){"use strict";e.a={init:function(t,e){for(var n=t.length;n--;)t[n]=e},shuffle:function(t){var e,n,r=t.length-1;for(r;r>=0;r--)e=Math.floor(Math.random()*r),n=t[r],t[r]=t[e],t[e]=n;return t},toPointList:function(t){var e,n,r=[],o=[];for(e=0;e<t.length;e++){for(r=[],n=0;n<t[e].length;n++)r[n]=t[e][n];o[e]="["+r.join(",")+"]"}return"["+o.join(",\r\n")+"]"},threshold:function(t,e,n){var r,o=[];for(r=0;r<t.length;r++)n.apply(t,[t[r]])>=e&&o.push(t[r]);return o},maxIndex:function(t){var e,n=0;for(e=0;e<t.length;e++)t[e]>t[n]&&(n=e);return n},max:function(t){var e,n=0;for(e=0;e<t.length;e++)t[e]>n&&(n=t[e]);return n},sum:function(t){for(var e=t.length,n=0;e--;)n+=t[e];return n}}},function(t,e,n){"use strict";function r(t,e){t=a()(o(),t),u.a.call(this,t,e)}function o(){var t={};return Object.keys(r.CONFIG_KEYS).forEach(function(e){t[e]=r.CONFIG_KEYS[e].default}),t}var i=n(28),a=n.n(i),u=n(1),c=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},s={CODE_L_START:{value:0},CODE_G_START:{value:10},START_PATTERN:{value:[1,1,1]},STOP_PATTERN:{value:[1,1,1]},MIDDLE_PATTERN:{value:[1,1,1,1,1]},EXTENSION_START_PATTERN:{value:[1,1,2]},CODE_PATTERN:{value:[[3,2,1,1],[2,2,2,1],[2,1,2,2],[1,4,1,1],[1,1,3,2],[1,2,3,1],[1,1,1,4],[1,3,1,2],[1,2,1,3],[3,1,1,2],[1,1,2,3],[1,2,2,2],[2,2,1,2],[1,1,4,1],[2,3,1,1],[1,3,2,1],[4,1,1,1],[2,1,3,1],[3,1,2,1],[2,1,1,3]]},CODE_FREQUENCY:{value:[0,11,13,14,19,25,28,21,22,26]},SINGLE_CODE_ERROR:{value:.7},AVG_CODE_ERROR:{value:.48},FORMAT:{value:"ean_13",writeable:!1}};r.prototype=Object.create(u.a.prototype,s),r.prototype.constructor=r,r.prototype._decodeCode=function(t,e){var n,r,o,i=[0,0,0,0],a=this,u=t,c=!a._row[u],s=0,f={error:Number.MAX_VALUE,code:-1,start:t,end:t};for(e||(e=a.CODE_PATTERN.length),n=u;n<a._row.length;n++)if(a._row[n]^c)i[s]++;else{if(s===i.length-1){for(r=0;r<e;r++)(o=a._matchPattern(i,a.CODE_PATTERN[r]))<f.error&&(f.code=r,f.error=o);return f.end=n,f.error>a.AVG_CODE_ERROR?null:f}s++,i[s]=1,c=!c}return null},r.prototype._findPattern=function(t,e,n,r,o){var i,a,u,c,s=[],f=this,l=0,d={error:Number.MAX_VALUE,code:-1,start:0,end:0};for(e||(e=f._nextSet(f._row)),void 0===n&&(n=!1),void 0===r&&(r=!0),void 0===o&&(o=f.AVG_CODE_ERROR),i=0;i<t.length;i++)s[i]=0;for(i=e;i<f._row.length;i++)if(f._row[i]^n)s[l]++;else{if(l===s.length-1){for(c=0,u=0;u<s.length;u++)c+=s[u];if((a=f._matchPattern(s,t))<o)return d.error=a,d.start=i-c,d.end=i,d;if(!r)return null;for(u=0;u<s.length-2;u++)s[u]=s[u+2];s[s.length-2]=0,s[s.length-1]=0,l--}else l++;s[l]=1,n=!n}return null},r.prototype._findStart=function(){for(var t,e,n=this,r=n._nextSet(n._row);!e;){if(!(e=n._findPattern(n.START_PATTERN,r)))return null;if((t=e.start-(e.end-e.start))>=0&&n._matchRange(t,e.start,0))return e;r=e.end,e=null}},r.prototype._verifyTrailingWhitespace=function(t){var e,n=this;return e=t.end+(t.end-t.start),e<n._row.length&&n._matchRange(t.end,e,0)?t:null},r.prototype._findEnd=function(t,e){var n=this,r=n._findPattern(n.STOP_PATTERN,t,e,!1);return null!==r?n._verifyTrailingWhitespace(r):null},r.prototype._calculateFirstDigit=function(t){var e,n=this;for(e=0;e<n.CODE_FREQUENCY.length;e++)if(t===n.CODE_FREQUENCY[e])return e;return null},r.prototype._decodePayload=function(t,e,n){var r,o,i=this,a=0;for(r=0;r<6;r++){if(!(t=i._decodeCode(t.end)))return null;t.code>=i.CODE_G_START?(t.code=t.code-i.CODE_G_START,a|=1<<5-r):a|=0<<5-r,e.push(t.code),n.push(t)}if(null===(o=i._calculateFirstDigit(a)))return null;if(e.unshift(o),null===(t=i._findPattern(i.MIDDLE_PATTERN,t.end,!0,!1)))return null;for(n.push(t),r=0;r<6;r++){if(!(t=i._decodeCode(t.end,i.CODE_G_START)))return null;n.push(t),e.push(t.code)}return t},r.prototype._decode=function(){var t,e,n=this,r=[],o=[],i={};if(!(t=n._findStart()))return null;if(e={code:t.code,start:t.start,end:t.end},o.push(e),!(e=n._decodePayload(e,r,o)))return null;if(!(e=n._findEnd(e.end,!1)))return null;if(o.push(e),!n._checksum(r))return null;if(this.supplements.length>0){var a=this._decodeExtensions(e.end);if(!a)return null;var u=a.decodedCodes[a.decodedCodes.length-1],s={start:u.start+((u.end-u.start)/2|0),end:u.end};if(!n._verifyTrailingWhitespace(s))return null;i={supplement:a,code:r.join("")+a.code}}return c({code:r.join(""),start:t.start,end:e.end,codeset:"",startInfo:t,decodedCodes:o},i)},r.prototype._decodeExtensions=function(t){var e,n,r=this._nextSet(this._row,t),o=this._findPattern(this.EXTENSION_START_PATTERN,r,!1,!1);if(null===o)return null;for(e=0;e<this.supplements.length;e++)if(null!==(n=this.supplements[e].decode(this._row,o.end)))return{code:n.code,start:r,startInfo:o,end:n.end,codeset:"",decodedCodes:n.decodedCodes};return null},r.prototype._checksum=function(t){var e,n=0;for(e=t.length-2;e>=0;e-=2)n+=t[e];for(n*=3,e=t.length-1;e>=0;e-=2)n+=t[e];return n%10==0},r.CONFIG_KEYS={supplements:{type:"arrayOf(string)",default:[],description:"Allowed extensions to be decoded (2 and/or 5)"}},e.a=r},function(t,e,n){var r=n(38),o="object"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function("return this")();t.exports=i},function(t,e){function n(t){return null!=t&&"object"==typeof t}t.exports=n},function(t,e){function n(t){var e=new Float32Array(2);return e[0]=t[0],e[1]=t[1],e}t.exports=n},function(t,e,n){function r(t){return null==t?void 0===t?c:u:s&&s in Object(t)?i(t):a(t)}var o=n(11),i=n(120),a=n(147),u="[object Null]",c="[object Undefined]",s=o?o.toStringTag:void 0;t.exports=r},function(t,e,n){"use strict";e.a={drawRect:function(t,e,n,r){n.strokeStyle=r.color,n.fillStyle=r.color,n.lineWidth=r.lineWidth||1,n.beginPath(),n.strokeRect(t.x,t.y,e.x,e.y)},drawPath:function(t,e,n,r){n.strokeStyle=r.color,n.fillStyle=r.color,n.lineWidth=r.lineWidth,n.beginPath(),n.moveTo(t[0][e.x],t[0][e.y]);for(var o=1;o<t.length;o++)n.lineTo(t[o][e.x],t[o][e.y]);n.closePath(),n.stroke()},drawImage:function(t,e,n){var r,o=n.getImageData(0,0,e.x,e.y),i=o.data,a=t.length,u=i.length;if(u/a!=4)return!1;for(;a--;)r=t[a],i[--u]=255,i[--u]=r,i[--u]=r,i[--u]=r;return n.putImageData(o,0,0),!0}}},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(134),i=n(135),a=n(136),u=n(137),c=n(138);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=a,r.prototype.has=u,r.prototype.set=c,t.exports=r},function(t,e,n){var r=n(5),o=r.Symbol;t.exports=o},function(t,e,n){function r(t,e){for(var n=t.length;n--;)if(o(t[n][0],e))return n;return-1}var o=n(17);t.exports=r},function(t,e,n){function r(t,e){return o(t)?t:i(t,e)?[t]:a(u(t))}var o=n(2),i=n(131),a=n(155),u=n(166);t.exports=r},function(t,e,n){function r(t,e){var n=t.__data__;return o(e)?n["string"==typeof e?"string":"hash"]:n.map}var o=n(132);t.exports=r},function(t,e){function n(t,e){var n=typeof t;return!!(e=null==e?r:e)&&("number"==n||"symbol"!=n&&o.test(t))&&t>-1&&t%1==0&&t<e}var r=9007199254740991,o=/^(?:0|[1-9]\d*)$/;t.exports=n},function(t,e,n){var r=n(22),o=r(Object,"create");t.exports=o},function(t,e){function n(t,e){return t===e||t!==t&&e!==e}t.exports=n},function(t,e,n){var r=n(97),o=n(6),i=Object.prototype,a=i.hasOwnProperty,u=i.propertyIsEnumerable,c=r(function(){return arguments}())?r:function(t){return o(t)&&a.call(t,"callee")&&!u.call(t,"callee")};t.exports=c},function(t,e,n){"use strict";function r(t,e){return{x:t,y:e,toVec2:function(){return b.clone([this.x,this.y])},toVec3:function(){return E.clone([this.x,this.y,1])},round:function(){return this.x=this.x>0?Math.floor(this.x+.5):Math.floor(this.x-.5),this.y=this.y>0?Math.floor(this.y+.5):Math.floor(this.y-.5),this}}}function o(t,e,n){n||(n=t);for(var r=t.data,o=r.length,i=n.data;o--;)i[o]=r[o]<e?1:0}function i(t,e){e||(e=8);for(var n=t.data,r=n.length,o=8-e,i=1<<e,a=new Int32Array(i);r--;)a[n[r]>>o]++;return a}function a(t,e){function n(t,e){var n,r=0;for(n=t;n<=e;n++)r+=o[n];return r}function r(t,e){var n,r=0;for(n=t;n<=e;n++)r+=n*o[n];return r}e||(e=8);var o,a=8-e;return function(){var a,u,c,s,f,l,d,h=[0],p=(1<<e)-1;for(o=i(t,e),s=1;s<p;s++)a=n(0,s),u=n(s+1,p),c=a*u,0===c&&(c=1),f=r(0,s)*u,l=r(s+1,p)*a,d=f-l,h[s]=d*d/c;return x.a.maxIndex(h)}()<<a}function u(t,e){var n=a(t);return o(t,n,e),n}function c(t,e,n){var r,o,i,a,u=[];for(n||(n="rad"),r=0;r<t.length;r++)a=m.a.createPoint(t[r],r,n),function(t){var e=!1;for(o=0;o<u.length;o++)i=u[o],i.fits(t)&&(i.add(t),e=!0);return e}(a)||u.push(m.a.create(a,e));return u}function s(t,e,n){var r,o,i,a,u=0,c=0,s=[];for(r=0;r<e;r++)s[r]={score:0,item:null};for(r=0;r<t.length;r++)if((o=n.apply(this,[t[r]]))>c)for(i=s[u],i.score=o,i.item=t[r],c=Number.MAX_VALUE,a=0;a<e;a++)s[a].score<c&&(c=s[a].score,u=a);return s}function f(t,e,n){for(var r,o=0,i=e.x,a=Math.floor(t.length/4),u=e.x/2,c=0,s=e.x;i<a;){for(r=0;r<u;r++)n[c]=(.299*t[4*o+0]+.587*t[4*o+1]+.114*t[4*o+2]+(.299*t[4*(o+1)+0]+.587*t[4*(o+1)+1]+.114*t[4*(o+1)+2])+(.299*t[4*i+0]+.587*t[4*i+1]+.114*t[4*i+2])+(.299*t[4*(i+1)+0]+.587*t[4*(i+1)+1]+.114*t[4*(i+1)+2]))/4,c++,o+=2,i+=2;o+=s,i+=s}}function l(t,e,n){var r,o=t.length/4|0;if(n&&!0===n.singleChannel)for(r=0;r<o;r++)e[r]=t[4*r+0];else for(r=0;r<o;r++)e[r]=.299*t[4*r+0]+.587*t[4*r+1]+.114*t[4*r+2]}function d(t,e){for(var n=t.data,r=t.size.x,o=e.data,i=0,a=r,u=n.length,c=r/2,s=0;a<u;){for(var f=0;f<c;f++)o[s]=Math.floor((n[i]+n[i+1]+n[a]+n[a+1])/4),s++,i+=2,a+=2;i+=r,a+=r}}function h(t,e){var n=t[0],r=t[1],o=t[2],i=o*r,a=i*(1-Math.abs(n/60%2-1)),u=o-i,c=0,s=0,f=0;return e=e||[0,0,0],n<60?(c=i,s=a):n<120?(c=a,s=i):n<180?(s=i,f=a):n<240?(s=a,f=i):n<300?(c=a,f=i):n<360&&(c=i,f=a),e[0]=255*(c+u)|0,e[1]=255*(s+u)|0,e[2]=255*(f+u)|0,e}function p(t){var e,n=[],r=[];for(e=1;e<Math.sqrt(t)+1;e++)t%e==0&&(r.push(e),e!==t/e&&n.unshift(Math.floor(t/e)));return r.concat(n)}function v(t,e){for(var n=0,r=0,o=[];n<t.length&&r<e.length;)t[n]===e[r]?(o.push(t[n]),n++,r++):t[n]>e[r]?r++:n++;return o}function _(t,e){function n(t){for(var e=0,n=t[Math.floor(t.length/2)];e<t.length-1&&t[e]<d;)e++;return e>0&&(n=Math.abs(t[e]-d)>Math.abs(t[e-1]-d)?t[e-1]:t[e]),d/n<c[f+1]/c[f]&&d/n>c[f-1]/c[f]?{x:n,y:n}:null}var r,o=p(e.x),i=p(e.y),a=Math.max(e.x,e.y),u=v(o,i),c=[8,10,15,20,32,60,80],s={"x-small":5,small:4,medium:3,large:2,"x-large":1},f=s[t]||s.medium,l=c[f],d=Math.floor(a/l);return r=n(u),r||(r=n(p(a)))||(r=n(p(d*l))),r}function g(t){return{value:parseFloat(t),unit:(t.indexOf("%"),t.length,"%")}}function y(t,e,n){var r={width:t,height:e},o=Object.keys(n).reduce(function(t,e){var o=n[e],i=g(o),a=C[e](i,r);return t[e]=a,t},{});return{sx:o.left,sy:o.top,sw:o.right-o.left,sh:o.bottom-o.top}}e.b=r,e.f=u,e.g=c,e.h=s,e.c=f,e.d=l,e.i=d,e.a=h,e.e=_,e.j=y;var m=n(51),x=n(3),b={clone:n(7)},E={clone:n(84)},C={top:function(t,e){if("%"===t.unit)return Math.floor(e.height*(t.value/100))},right:function(t,e){if("%"===t.unit)return Math.floor(e.width-e.width*(t.value/100))},bottom:function(t,e){if("%"===t.unit)return Math.floor(e.height-e.height*(t.value/100))},left:function(t,e){if("%"===t.unit)return Math.floor(e.width*(t.value/100))}}},function(t,e,n){"use strict";function r(t,e,n,r){e?this.data=e:n?(this.data=new n(t.x*t.y),n===Array&&r&&a.a.init(this.data,0)):(this.data=new Uint8Array(t.x*t.y),Uint8Array===Array&&r&&a.a.init(this.data,0)),this.size=t}var o=n(54),i=n(19),a=n(3),u={clone:n(7)};r.prototype.inImageWithBorder=function(t,e){return t.x>=e&&t.y>=e&&t.x<this.size.x-e&&t.y<this.size.y-e},r.sample=function(t,e,n){var r=Math.floor(e),o=Math.floor(n),i=t.size.x,a=o*t.size.x+r,u=t.data[a+0],c=t.data[a+1],s=t.data[a+i],f=t.data[a+i+1],l=u-c;return e-=r,n-=o,Math.floor(e*(n*(l-s+f)-l)+n*(s-u)+u)},r.clearArray=function(t){for(var e=t.length;e--;)t[e]=0},r.prototype.subImage=function(t,e){return new o.a(t,e,this)},r.prototype.subImageAsCopy=function(t,e){var n,r,o=t.size.y,i=t.size.x;for(n=0;n<i;n++)for(r=0;r<o;r++)t.data[r*i+n]=this.data[(e.y+r)*this.size.x+e.x+n]},r.prototype.copyTo=function(t){for(var e=this.data.length,n=this.data,r=t.data;e--;)r[e]=n[e]},r.prototype.get=function(t,e){return this.data[e*this.size.x+t]},r.prototype.getSafe=function(t,e){var n;if(!this.indexMapping){for(this.indexMapping={x:[],y:[]},n=0;n<this.size.x;n++)this.indexMapping.x[n]=n,this.indexMapping.x[n+this.size.x]=n;for(n=0;n<this.size.y;n++)this.indexMapping.y[n]=n,this.indexMapping.y[n+this.size.y]=n}return this.data[this.indexMapping.y[e+this.size.y]*this.size.x+this.indexMapping.x[t+this.size.x]]},r.prototype.set=function(t,e,n){return this.data[e*this.size.x+t]=n,this},r.prototype.zeroBorder=function(){var t,e=this.size.x,n=this.size.y,r=this.data;for(t=0;t<e;t++)r[t]=r[(n-1)*e+t]=0;for(t=1;t<n-1;t++)r[t*e]=r[t*e+(e-1)]=0},r.prototype.invert=function(){for(var t=this.data,e=t.length;e--;)t[e]=t[e]?0:1},r.prototype.convolve=function(t){var e,n,r,o,i=t.length/2|0,a=0;for(n=0;n<this.size.y;n++)for(e=0;e<this.size.x;e++){for(a=0,o=-i;o<=i;o++)for(r=-i;r<=i;r++)a+=t[o+i][r+i]*this.getSafe(e+r,n+o);this.data[n*this.size.x+e]=a}},r.prototype.moments=function(t){var e,n,r,o,i,a,c,s,f,l,d,h,p=this.data,v=this.size.y,_=this.size.x,g=[],y=[],m=Math.PI,x=m/4;if(t<=0)return y;for(i=0;i<t;i++)g[i]={m00:0,m01:0,m10:0,m11:0,m02:0,m20:0,theta:0,rad:0};for(n=0;n<v;n++)for(o=n*n,e=0;e<_;e++)(r=p[n*_+e])>0&&(a=g[r-1],a.m00+=1,a.m01+=n,a.m10+=e,a.m11+=e*n,a.m02+=o,a.m20+=e*e);for(i=0;i<t;i++)a=g[i],isNaN(a.m00)||0===a.m00||(l=a.m10/a.m00,d=a.m01/a.m00,c=a.m11/a.m00-l*d,s=a.m02/a.m00-d*d,f=a.m20/a.m00-l*l,h=(s-f)/(2*c),h=.5*Math.atan(h)+(c>=0?x:-x)+m,a.theta=(180*h/m+90)%180-90,a.theta<0&&(a.theta+=180),a.rad=h>m?h-m:h,a.vec=u.clone([Math.cos(h),Math.sin(h)]),y.push(a));return y},r.prototype.show=function(t,e){var n,r,o,i,a,u,c;for(e||(e=1),n=t.getContext("2d"),t.width=this.size.x,t.height=this.size.y,r=n.getImageData(0,0,t.width,t.height),o=r.data,i=0,c=0;c<this.size.y;c++)for(u=0;u<this.size.x;u++)a=c*this.size.x+u,i=this.get(u,c)*e,o[4*a+0]=i,o[4*a+1]=i,o[4*a+2]=i,o[4*a+3]=255;n.putImageData(r,0,0)},r.prototype.overlay=function(t,e,r){(!e||e<0||e>360)&&(e=360);for(var o=[0,1,1],a=[0,0,0],u=[255,255,255],c=[0,0,0],s=[],f=t.getContext("2d"),l=f.getImageData(r.x,r.y,this.size.x,this.size.y),d=l.data,h=this.data.length;h--;)o[0]=this.data[h]*e,s=o[0]<=0?u:o[0]>=360?c:n.i(i.a)(o,a),d[4*h+0]=s[0],d[4*h+1]=s[1],d[4*h+2]=s[2],d[4*h+3]=255;f.putImageData(l,r.x,r.y)},e.a=r},function(t,e,n){function r(t,e,n){"__proto__"==e&&o?o(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}var o=n(37);t.exports=r},function(t,e,n){function r(t,e){var n=i(t,e);return o(n)?n:void 0}var o=n(98),i=n(121);t.exports=r},function(t,e,n){function r(t){if("string"==typeof t||o(t))return t;var e=t+"";return"0"==e&&1/t==-i?"-0":e}var o=n(27),i=1/0;t.exports=r},function(t,e,n){function r(t){return null!=t&&i(t.length)&&!o(t)}var o=n(25),i=n(26);t.exports=r},function(t,e,n){function r(t){if(!i(t))return!1;var e=o(t);return e==u||e==c||e==a||e==s}var o=n(8),i=n(0),a="[object AsyncFunction]",u="[object Function]",c="[object GeneratorFunction]",s="[object Proxy]";t.exports=r},function(t,e){function n(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=r}var r=9007199254740991;t.exports=n},function(t,e,n){function r(t){return"symbol"==typeof t||i(t)&&o(t)==a}var o=n(8),i=n(6),a="[object Symbol]";t.exports=r},function(t,e,n){var r=n(101),o=n(117),i=o(function(t,e,n){r(t,e,n)});t.exports=i},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){"use strict";var r={searchDirections:[[0,1],[1,1],[1,0],[1,-1],[0,-1],[-1,-1],[-1,0],[-1,1]],create:function(t,e){function n(t,e,n,r){var o,f,l;for(o=0;o<7;o++){if(f=t.cy+c[t.dir][0],l=t.cx+c[t.dir][1],i=f*s+l,a[i]===e&&(0===u[i]||u[i]===n))return u[i]=n,t.cy=f,t.cx=l,!0;0===u[i]&&(u[i]=r),t.dir=(t.dir+1)%8}return!1}function r(t,e,n){return{dir:n,x:t,y:e,next:null,prev:null}}function o(t,e,o,i,a){var u,c,s,f=null,l={cx:e,cy:t,dir:0};if(n(l,i,o,a)){f=r(e,t,l.dir),u=f,s=l.dir,c=r(l.cx,l.cy,0),c.prev=u,u.next=c,c.next=null,u=c;do{l.dir=(l.dir+6)%8,n(l,i,o,a),s!==l.dir?(u.dir=l.dir,c=r(l.cx,l.cy,0),c.prev=u,u.next=c,c.next=null,u=c):(u.dir=s,u.x=l.cx,u.y=l.cy),s=l.dir}while(l.cx!==e||l.cy!==t);f.prev=u.prev,u.prev.next=f}return f}var i,a=t.data,u=e.data,c=this.searchDirections,s=t.size.x;return{trace:function(t,e,r,o){return n(t,e,r,o)},contourTracing:function(t,e,n,r,i){return o(t,e,n,r,i)}}}};e.a=r},function(t,e,n){"use strict";function r(){o.a.call(this)}var o=n(1),i=n(3),a={ALPHABETH_STRING:{value:"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. *$/+%"},ALPHABET:{value:[48,49,50,51,52,53,54,55,56,57,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,45,46,32,42,36,47,43,37]},CHARACTER_ENCODINGS:{value:[52,289,97,352,49,304,112,37,292,100,265,73,328,25,280,88,13,268,76,28,259,67,322,19,274,82,7,262,70,22,385,193,448,145,400,208,133,388,196,148,168,162,138,42]},ASTERISK:{value:148},FORMAT:{value:"code_39",writeable:!1}};r.prototype=Object.create(o.a.prototype,a),r.prototype.constructor=r,r.prototype._decode=function(){var t,e,n,r,o=this,a=[0,0,0,0,0,0,0,0,0],u=[],c=o._findStart();if(!c)return null;r=o._nextSet(o._row,c.end);do{if(a=o._toCounters(r,a),(n=o._toPattern(a))<0)return null;if((t=o._patternToChar(n))<0)return null;u.push(t),e=r,r+=i.a.sum(a),r=o._nextSet(o._row,r)}while("*"!==t);return u.pop(),u.length&&o._verifyTrailingWhitespace(e,r,a)?{code:u.join(""),start:c.start,end:r,startInfo:c,decodedCodes:u}:null},r.prototype._verifyTrailingWhitespace=function(t,e,n){var r=i.a.sum(n);return 3*(e-t-r)>=r},r.prototype._patternToChar=function(t){var e,n=this;for(e=0;e<n.CHARACTER_ENCODINGS.length;e++)if(n.CHARACTER_ENCODINGS[e]===t)return String.fromCharCode(n.ALPHABET[e]);return-1},r.prototype._findNextWidth=function(t,e){var n,r=Number.MAX_VALUE;for(n=0;n<t.length;n++)t[n]<r&&t[n]>e&&(r=t[n]);return r},r.prototype._toPattern=function(t){for(var e,n,r=t.length,o=0,i=r,a=0,u=this;i>3;){for(o=u._findNextWidth(t,o),i=0,e=0,n=0;n<r;n++)t[n]>o&&(e|=1<<r-1-n,i++,a+=t[n]);if(3===i){for(n=0;n<r&&i>0;n++)if(t[n]>o&&(i--,2*t[n]>=a))return-1;return e}}return-1},r.prototype._findStart=function(){var t,e,n,r=this,o=r._nextSet(r._row),i=o,a=[0,0,0,0,0,0,0,0,0],u=0,c=!1;for(t=o;t<r._row.length;t++)if(r._row[t]^c)a[u]++;else{if(u===a.length-1){if(r._toPattern(a)===r.ASTERISK&&(n=Math.floor(Math.max(0,i-(t-i)/4)),r._matchRange(n,i,0)))return{start:i,end:t};for(i+=a[0]+a[1],e=0;e<7;e++)a[e]=a[e+2];a[7]=0,a[8]=0,u--}else u++;a[u]=1,c=!c}return null},e.a=r},function(t,e){function n(t,e){return t[0]*e[0]+t[1]*e[1]}t.exports=n},function(t,e,n){var r=n(22),o=n(5),i=r(o,"Map");t.exports=i},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(139),i=n(140),a=n(141),u=n(142),c=n(143);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=a,r.prototype.has=u,r.prototype.set=c,t.exports=r},function(t,e,n){function r(t,e,n){(void 0===n||i(t[e],n))&&(void 0!==n||e in t)||o(t,e,n)}var o=n(21),i=n(17);t.exports=r},function(t,e,n){function r(t,e,n){var r=t[e];u.call(t,e)&&i(r,n)&&(void 0!==n||e in t)||o(t,e,n)}var o=n(21),i=n(17),a=Object.prototype,u=a.hasOwnProperty;t.exports=r},function(t,e,n){var r=n(22),o=function(){try{var t=r(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,e,n){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,n(48))},function(t,e,n){var r=n(148),o=r(Object.getPrototypeOf,Object);t.exports=o},function(t,e){function n(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||r)}var r=Object.prototype;t.exports=n},function(t,e,n){function r(t,e,n){return e=i(void 0===e?t.length-1:e,0),function(){for(var r=arguments,a=-1,u=i(r.length-e,0),c=Array(u);++a<u;)c[a]=r[e+a];a=-1;for(var s=Array(e+1);++a<e;)s[a]=r[a];return s[e]=n(c),o(t,this,s)}}var o=n(88),i=Math.max;t.exports=r},function(t,e){function n(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]}t.exports=n},function(t,e,n){var r=n(107),o=n(149),i=o(r);t.exports=i},function(t,e){function n(t){return t}t.exports=n},function(t,e,n){(function(t){var r=n(5),o=n(164),i="object"==typeof e&&e&&!e.nodeType&&e,a=i&&"object"==typeof t&&t&&!t.nodeType&&t,u=a&&a.exports===i,c=u?r.Buffer:void 0,s=c?c.isBuffer:void 0,f=s||o;t.exports=f}).call(e,n(29)(t))},function(t,e,n){var r=n(99),o=n(110),i=n(146),a=i&&i.isTypedArray,u=a?o(a):r;t.exports=u},function(t,e,n){function r(t){return a(t)?o(t,!0):i(t)}var o=n(89),i=n(100),a=n(24);t.exports=r},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(e,n,r){"use strict";function o(t){f(t),P=k.a.create($.decoder,S)}function i(t){var e;if("VideoStream"===$.inputStream.type)e=document.createElement("video"),R=H.a.createVideoStream(e);else if("ImageStream"===$.inputStream.type)R=H.a.createImageStream();else if("LiveStream"===$.inputStream.type){var n=a();n&&((e=n.querySelector("video"))||(e=document.createElement("video"),n.appendChild(e))),R=H.a.createLiveStream(e),F.a.request(e,$.inputStream.constraints).then(function(){R.trigger("canrecord")}).catch(function(e){return t(e)})}R.setAttribute("preload","auto"),R.setInputStream($.inputStream),R.addEventListener("canrecord",u.bind(void 0,t))}function a(){var t=$.inputStream.target;if(t&&t.nodeName&&1===t.nodeType)return t;var e="string"==typeof t?t:"#interactive.viewport";return document.querySelector(e)}function u(t){U.a.checkImageConstraints(R,$.locator),s(),w=V.a.create(R,K.dom.image),A($.numOfWorkers,function(){0===$.numOfWorkers&&o(),c(t)})}function c(t){R.play(),t()}function s(){if("undefined"!=typeof document){var t=a();if(K.dom.image=document.querySelector("canvas.imgBuffer"),K.dom.image||(K.dom.image=document.createElement("canvas"),K.dom.image.className="imgBuffer",t&&"ImageStream"===$.inputStream.type&&t.appendChild(K.dom.image)),K.ctx.image=K.dom.image.getContext("2d"),K.dom.image.width=R.getCanvasSize().x,K.dom.image.height=R.getCanvasSize().y,K.dom.overlay=document.querySelector("canvas.drawingBuffer"),!K.dom.overlay){K.dom.overlay=document.createElement("canvas"),K.dom.overlay.className="drawingBuffer",t&&t.appendChild(K.dom.overlay);var e=document.createElement("br");e.setAttribute("clear","all"),t&&t.appendChild(e)}K.ctx.overlay=K.dom.overlay.getContext("2d"),K.dom.overlay.width=R.getCanvasSize().x,K.dom.overlay.height=R.getCanvasSize().y}}function f(t){S=t||new j.a({x:R.getWidth(),y:R.getHeight()}),D=[q.clone([0,0]),q.clone([0,S.size.y]),q.clone([S.size.x,S.size.y]),q.clone([S.size.x,0])],U.a.init(S,$.locator)}function l(){return $.locate?U.a.locate():[[q.clone(D[0]),q.clone(D[1]),q.clone(D[2]),q.clone(D[3])]]}function d(t){function e(t){for(var e=t.length;e--;)t[e][0]+=o,t[e][1]+=i}var n,r=R.getTopRight(),o=r.x,i=r.y;if(0!==o||0!==i){if(t.barcodes)for(n=0;n<t.barcodes.length;n++)d(t.barcodes[n]);if(t.line&&2===t.line.length&&function(t){t[0].x+=o,t[0].y+=i,t[1].x+=o,t[1].y+=i}(t.line),t.box&&e(t.box),t.boxes&&t.boxes.length>0)for(n=0;n<t.boxes.length;n++)e(t.boxes[n])}}function h(t,e){e&&I&&(t.barcodes?t.barcodes.filter(function(t){return t.codeResult}).forEach(function(t){return h(t,e)}):t.codeResult&&I.addResult(e,R.getCanvasSize(),t.codeResult))}function p(t){return t&&(t.barcodes?t.barcodes.some(function(t){return t.codeResult}):t.codeResult)}function v(t,e){var n=t;t&&Q&&(d(t),h(t,e),n=t.barcodes||t),L.a.publish("processed",n),p(t)&&L.a.publish("detected",n)}function _(){var t,e;e=l(),e?(t=P.decodeFromBoundingBoxes(e),t=t||{},t.boxes=e,v(t,S.data)):v()}function g(){var t;if(Q){if(Y.length>0){if(!(t=Y.filter(function(t){return!t.busy})[0]))return;w.attachData(t.imageData)}else w.attachData(S.data);w.grab()&&(t?(t.busy=!0,t.worker.postMessage({cmd:"process",imageData:t.imageData},[t.imageData.buffer])):_())}else _()}function y(){var t=null,e=1e3/($.frequency||60);T=!1,function n(r){t=t||r,T||(r>=t&&(t+=e,g()),window.requestAnimFrame(n))}(performance.now())}function m(){Q&&"LiveStream"===$.inputStream.type?y():g()}function x(t){var e,n={worker:void 0,imageData:new Uint8Array(R.getWidth()*R.getHeight()),busy:!0};e=C(),n.worker=new Worker(e),n.worker.onmessage=function(r){if("initialized"===r.data.event)return URL.revokeObjectURL(e),n.busy=!1,n.imageData=new Uint8Array(r.data.imageData),t(n);"processed"===r.data.event?(n.imageData=new Uint8Array(r.data.imageData),n.busy=!1,v(r.data.result,n.imageData)):r.data.event},n.worker.postMessage({cmd:"init",size:{x:R.getWidth(),y:R.getHeight()},imageData:n.imageData,config:b($)},[n.imageData.buffer])}function b(t){return X({},t,{inputStream:X({},t.inputStream,{target:null})})}function E(t){function e(t){self.postMessage({event:"processed",imageData:o.data,result:t},[o.data.buffer])}function n(){self.postMessage({event:"initialized",imageData:o.data},[o.data.buffer])}if(t){var r=t().default;if(!r)return void self.postMessage({event:"error",message:"Quagga could not be created"})}var o;self.onmessage=function(t){if("init"===t.data.cmd){var i=t.data.config;i.numOfWorkers=0,o=new r.ImageWrapper({x:t.data.size.x,y:t.data.size.y},new Uint8Array(t.data.imageData)),r.init(i,n,o),r.onProcessed(e)}else"process"===t.data.cmd?(o.data=new Uint8Array(t.data.imageData),r.start()):"setReaders"===t.data.cmd&&r.setReaders(t.data.readers)}}function C(){var e,n;return void 0!==t&&(n=t),e=new Blob(["("+E.toString()+")("+n+");"],{type:"text/javascript"}),window.URL.createObjectURL(e)}function O(t){P?P.setReaders(t):Q&&Y.length>0&&Y.forEach(function(e){e.worker.postMessage({cmd:"setReaders",readers:t})})}function A(t,e){var n=t-Y.length;if(0===n)return e&&e();if(n<0){return Y.slice(n).forEach(function(t){t.worker.terminate()}),Y=Y.slice(0,n),e&&e()}for(var r=function(n){Y.push(n),Y.length>=t&&e&&e()},o=0;o<n;o++)x(r)}Object.defineProperty(n,"__esModule",{value:!0});var R,w,T,S,D,P,I,M=r(28),N=r.n(M),z=r(55),j=(r.n(z),r(20)),U=r(65),k=r(58),L=r(52),F=r(60),W=r(9),B=r(50),G=r(56),H=r(64),V=r(62),X=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},q={clone:r(7)},K={ctx:{image:null,overlay:null},dom:{image:null,overlay:null}},Y=[],Q=!0,$={};n.default={init:function(t,e,n){if($=N()({},G.a,t),n)return Q=!1,o(n),e();i(e)},start:function(){m()},stop:function(){T=!0,A(0),"LiveStream"===$.inputStream.type&&(F.a.release(),R.clearEventHandlers())},pause:function(){T=!0},onDetected:function(t){L.a.subscribe("detected",t)},offDetected:function(t){L.a.unsubscribe("detected",t)},onProcessed:function(t){L.a.subscribe("processed",t)},offProcessed:function(t){L.a.unsubscribe("processed",t)},setReaders:function(t){O(t)},registerResultCollector:function(t){t&&"function"==typeof t.addResult&&(I=t)},canvas:K,decodeSingle:function(t,e){var n=this;t=N()({inputStream:{type:"ImageStream",sequence:!1,size:800,src:t.src},numOfWorkers:1,locator:{halfSample:!1}},t),this.init(t,function(){L.a.once("processed",function(t){n.stop(),e.call(null,t)},!0),m()})},ImageWrapper:j.a,ImageDebug:W.a,ResultCollector:B.a,CameraAccess:F.a}},function(t,e,n){"use strict";function r(t,e){return!!e&&e.some(function(e){return Object.keys(e).every(function(n){return e[n]===t[n]})})}function o(t,e){return"function"!=typeof e||e(t)}var i=n(9);e.a={create:function(t){function e(e){return c&&e&&!r(e,t.blacklist)&&o(e,t.filter)}var n=document.createElement("canvas"),a=n.getContext("2d"),u=[],c=t.capacity||20,s=!0===t.capture;return{addResult:function(t,r,o){var f={};e(o)&&(c--,f.codeResult=o,s&&(n.width=r.x,n.height=r.y,i.a.drawImage(t,r,a),f.frame=n.toDataURL()),u.push(f))},getResults:function(){return u}}}}},function(t,e,n){"use strict";var r={clone:n(7),dot:n(32)};e.a={create:function(t,e){function n(t){u[t.id]=t,i.push(t)}function o(){var t,e=0;for(t=0;t<i.length;t++)e+=i[t].rad;a.rad=e/i.length,a.vec=r.clone([Math.cos(a.rad),Math.sin(a.rad)])}var i=[],a={rad:0,vec:r.clone([0,0])},u={};return function(){n(t),o()}(),{add:function(t){u[t.id]||(n(t),o())},fits:function(t){return Math.abs(r.dot(t.point.vec,a.vec))>e},getPoints:function(){return i},getCenter:function(){return a}}},createPoint:function(t,e,n){return{rad:t[n],point:t,id:e}}}},function(t,e,n){"use strict";e.a=function(){function t(t){return o[t]||(o[t]={subscribers:[]}),o[t]}function e(){o={}}function n(t,e){t.async?setTimeout(function(){t.callback(e)},4):t.callback(e)}function r(e,n,r){var o;if("function"==typeof n)o={callback:n,async:r};else if(o=n,!o.callback)throw"Callback was not specified on options";t(e).subscribers.push(o)}var o={};return{subscribe:function(t,e,n){return r(t,e,n)},publish:function(e,r){var o=t(e),i=o.subscribers;i.filter(function(t){return!!t.once}).forEach(function(t){n(t,r)}),o.subscribers=i.filter(function(t){return!t.once}),o.subscribers.forEach(function(t){n(t,r)})},once:function(t,e,n){r(t,{callback:e,async:n,once:!0})},unsubscribe:function(n,r){var o;n?(o=t(n),o.subscribers=o&&r?o.subscribers.filter(function(t){return t.callback!==r}):[]):e()}}}()},function(t,e,n){"use strict";function r(){return navigator.mediaDevices&&"function"==typeof navigator.mediaDevices.enumerateDevices?navigator.mediaDevices.enumerateDevices():Promise.reject(new Error("enumerateDevices is not defined"))}function o(t){return navigator.mediaDevices&&"function"==typeof navigator.mediaDevices.getUserMedia?navigator.mediaDevices.getUserMedia(t):Promise.reject(new Error("getUserMedia is not defined"))}e.b=r,e.a=o},function(t,e,n){"use strict";function r(t,e,n){n||(n={data:null,size:e}),this.data=n.data,this.originalSize=n.size,this.I=n,this.from=t,this.size=e}r.prototype.show=function(t,e){var n,r,o,i,a,u,c;for(e||(e=1),n=t.getContext("2d"),t.width=this.size.x,t.height=this.size.y,r=n.getImageData(0,0,t.width,t.height),o=r.data,i=0,a=0;a<this.size.y;a++)for(u=0;u<this.size.x;u++)c=a*this.size.x+u,i=this.get(u,a)*e,o[4*c+0]=i,o[4*c+1]=i,o[4*c+2]=i,o[4*c+3]=255;r.data=o,n.putImageData(r,0,0)},r.prototype.get=function(t,e){return this.data[(this.from.y+e)*this.originalSize.x+this.from.x+t]},r.prototype.updateData=function(t){this.originalSize=t.size,this.data=t.data},r.prototype.updateFrom=function(t){return this.from=t,this},e.a=r},function(t,e){"undefined"!=typeof window&&(window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){window.setTimeout(t,1e3/60)}}()),Math.imul=Math.imul||function(t,e){var n=t>>>16&65535,r=65535&t,o=e>>>16&65535,i=65535&e;return r*i+(n*i+r*o<<16>>>0)|0},"function"!=typeof Object.assign&&(Object.assign=function(t){"use strict";if(null===t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),n=1;n<arguments.length;n++){var r=arguments[n];if(null!==r)for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e})},function(t,e,n){"use strict";var r=void 0;r=n(57),e.a=r},function(t,e){t.exports={inputStream:{name:"Live",type:"LiveStream",constraints:{width:640,height:480,facingMode:"environment"},area:{top:"0%",right:"0%",left:"0%",bottom:"0%"},singleChannel:!1},locate:!0,numOfWorkers:4,decoder:{readers:["code_128_reader"]},locator:{halfSample:!0,patchSize:"medium"}}},function(t,e,n){"use strict";var r=n(59),o=(n(9),n(70)),i=n(4),a=n(31),u=n(71),c=n(69),s=n(78),f=n(75),l=n(73),d=n(74),h=n(77),p=n(76),v=n(68),_=n(72),g="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},y={code_128_reader:o.a,ean_reader:i.a,ean_5_reader:d.a,ean_2_reader:l.a,ean_8_reader:f.a,code_39_reader:a.a,code_39_vin_reader:u.a,codabar_reader:c.a,upc_reader:s.a,upc_e_reader:h.a,i2of5_reader:p.a,"2of5_reader":v.a,code_93_reader:_.a};e.a={create:function(t,e){function n(){t.readers.forEach(function(t){var e,n={},r=[];"object"===(void 0===t?"undefined":g(t))?(e=t.format,n=t.config):"string"==typeof t&&(e=t),n.supplements&&(r=n.supplements.map(function(t){return new y[t]})),l.push(new y[e](n,r))})}function o(t,n,r){function o(e){var r={y:e*Math.sin(n),x:e*Math.cos(n)};t[0].y-=r.y,t[0].x-=r.x,t[1].y+=r.y,t[1].x+=r.x}for(o(r);r>1&&(!e.inImageWithBorder(t[0],0)||!e.inImageWithBorder(t[1],0));)r-=Math.ceil(r/2),o(-r);return t}function i(t){return[{x:(t[1][0]-t[0][0])/2+t[0][0],y:(t[1][1]-t[0][1])/2+t[0][1]},{x:(t[3][0]-t[2][0])/2+t[2][0],y:(t[3][1]-t[2][1])/2+t[2][1]}]}function a(t){var n,o=null,i=r.a.getBarcodeLine(e,t[0],t[1]);for(r.a.toBinaryLine(i),n=0;n<l.length&&null===o;n++)o=l[n].decodePattern(i.line);return null===o?null:{codeResult:o,barcodeLine:i}}function u(t,e,n){var r,o,i,u=Math.sqrt(Math.pow(t[1][0]-t[0][0],2)+Math.pow(t[1][1]-t[0][1],2)),c=null,s=Math.sin(n),f=Math.cos(n);for(r=1;r<16&&null===c;r++)o=u/16*r*(r%2==0?-1:1),i={y:o*s,x:o*f},e[0].y+=i.x,e[0].x-=i.y,e[1].y+=i.x,e[1].x-=i.y,c=a(e);return c}function c(t){return Math.sqrt(Math.pow(Math.abs(t[1].y-t[0].y),2)+Math.pow(Math.abs(t[1].x-t[0].x),2))}function s(t){var e,n,r,s;f.ctx.overlay;return e=i(t),s=c(e),n=Math.atan2(e[1].y-e[0].y,e[1].x-e[0].x),null===(e=o(e,n,Math.floor(.1*s)))?null:(r=a(e),null===r&&(r=u(t,e,n)),null===r?null:{codeResult:r.codeResult,line:e,angle:n,pattern:r.barcodeLine.line,threshold:r.barcodeLine.threshold})}var f={ctx:{frequency:null,pattern:null,overlay:null},dom:{frequency:null,pattern:null,overlay:null}},l=[];return n(),{decodeFromBoundingBox:function(t){return s(t)},decodeFromBoundingBoxes:function(e){var n,r,o=[],i=t.multiple;for(n=0;n<e.length;n++){var a=e[n];if(r=s(a)||{},r.box=a,i)o.push(r);else if(r.codeResult)return r}if(i)return{barcodes:o}},setReaders:function(e){t.readers=e,l.length=0,n()}}}}},function(t,e,n){"use strict";var r=(n(20),{}),o={DIR:{UP:1,DOWN:-1}};r.getBarcodeLine=function(t,e,n){function r(t,e){l=y[e*m+t],x+=l,b=l<b?l:b,E=l>E?l:E,g.push(l)}var o,i,a,u,c,s,f,l,d=0|e.x,h=0|e.y,p=0|n.x,v=0|n.y,_=Math.abs(v-h)>Math.abs(p-d),g=[],y=t.data,m=t.size.x,x=0,b=255,E=0;for(_&&(s=d,d=h,h=s,s=p,p=v,v=s),d>p&&(s=d,d=p,p=s,s=h,h=v,v=s),o=p-d,i=Math.abs(v-h),a=o/2|0,c=h,u=h<v?1:-1,f=d;f<p;f++)_?r(c,f):r(f,c),(a-=i)<0&&(c+=u,a+=o);return{line:g,min:b,max:E}},r.toBinaryLine=function(t){var e,n,r,i,a,u,c=t.min,s=t.max,f=t.line,l=c+(s-c)/2,d=[],h=(s-c)/12,p=-h;for(r=f[0]>l?o.DIR.UP:o.DIR.DOWN,d.push({pos:0,val:f[0]}),a=0;a<f.length-2;a++)e=f[a+1]-f[a],n=f[a+2]-f[a+1],i=e+n<p&&f[a+1]<1.5*l?o.DIR.DOWN:e+n>h&&f[a+1]>.5*l?o.DIR.UP:r,r!==i&&(d.push({pos:a,val:f[a]}),r=i);for(d.push({pos:f.length,val:f[f.length-1]}),u=d[0].pos;u<d[1].pos;u++)f[u]=f[u]>l?0:1;for(a=1;a<d.length-1;a++)for(h=d[a+1].val>d[a].val?d[a].val+(d[a+1].val-d[a].val)/3*2|0:d[a+1].val+(d[a].val-d[a+1].val)/3|0,u=d[a].pos;u<d[a+1].pos;u++)f[u]=f[u]>h?0:1;return{line:f,threshold:h}},r.debug={printFrequency:function(t,e){var n,r=e.getContext("2d");for(e.width=t.length,e.height=256,r.beginPath(),r.strokeStyle="blue",n=0;n<t.length;n++)r.moveTo(n,255),r.lineTo(n,255-t[n]);r.stroke(),r.closePath()},printPattern:function(t,e){var n,r=e.getContext("2d");for(e.width=t.length,r.fillColor="black",n=0;n<t.length;n++)1===t[n]&&r.fillRect(n,0,1,100)}},e.a=r},function(t,e,n){"use strict";function r(t){return new Promise(function(e,n){function r(){o>0?t.videoWidth>10&&t.videoHeight>10?e():window.setTimeout(r,500):n("Unable to play video stream. Is webcam working?"),o--}var o=10;r()})}function o(t,e){return n.i(d.a)(e).then(function(e){return new Promise(function(n){s=e,t.setAttribute("autoplay",!0),t.setAttribute("muted",!0),t.setAttribute("playsinline",!0),t.srcObject=e,t.addEventListener("loadedmetadata",function(){t.play(),n()})})}).then(r.bind(null,t))}function i(t){var e=l()(t,["width","height","facingMode","aspectRatio","deviceId"]);return void 0!==t.minAspectRatio&&t.minAspectRatio>0&&(e.aspectRatio=t.minAspectRatio,console.log("WARNING: Constraint 'minAspectRatio' is deprecated; Use 'aspectRatio' instead")),void 0!==t.facing&&(e.facingMode=t.facing,console.log("WARNING: Constraint 'facing' is deprecated. Use 'facingMode' instead'")),e}function a(t){var e={audio:!1,video:i(t)};return e.video.deviceId&&e.video.facingMode&&delete e.video.facingMode,Promise.resolve(e)}function u(){return n.i(d.b)().then(function(t){return t.filter(function(t){return"videoinput"===t.kind})})}function c(){if(s){var t=s.getVideoTracks();if(t&&t.length)return t[0]}}var s,f=n(163),l=n.n(f),d=n(53);e.a={request:function(t,e){return a(e).then(o.bind(null,t))},release:function(){var t=s&&s.getVideoTracks();t&&t.length&&t[0].stop(),s=null},enumerateVideoDevices:u,getActiveStreamLabel:function(){var t=c();return t?t.label:""},getActiveTrack:c}},function(t,e,n){"use strict";function r(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:d;return/^blob\:/i.test(t)?i(t).then(o).then(function(t){return a(t,e)}):Promise.resolve(null)}function o(t){return new Promise(function(e){var n=new FileReader;n.onload=function(t){return e(t.target.result)},n.readAsArrayBuffer(t)})}function i(t){return new Promise(function(e,n){var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType="blob",r.onreadystatechange=function(){r.readyState!==XMLHttpRequest.DONE||200!==r.status&&0!==r.status||e(this.response)},r.onerror=n,r.send()})}function a(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:d,n=new DataView(t),r=t.byteLength,o=e.reduce(function(t,e){var n=Object.keys(l).filter(function(t){return l[t]===e})[0];return n&&(t[n]=e),t},{}),i=2;if(255!==n.getUint8(0)||216!==n.getUint8(1))return!1;for(;i<r;){if(255!==n.getUint8(i))return!1;if(225===n.getUint8(i+1))return u(n,i+4,o);i+=2+n.getUint16(i+2)}}function u(t,e,n){if("Exif"!==f(t,e,4))return!1;var r=e+6,o=void 0;if(18761===t.getUint16(r))o=!1;else{if(19789!==t.getUint16(r))return!1;o=!0}if(42!==t.getUint16(r+2,!o))return!1;var i=t.getUint32(r+4,!o);return!(i<8)&&c(t,r,r+i,n,o)}function c(t,e,n,r,o){for(var i=t.getUint16(n,!o),a={},u=0;u<i;u++){var c=n+12*u+2,f=r[t.getUint16(c,!o)];f&&(a[f]=s(t,c,e,n,o))}return a}function s(t,e,n,r,o){var i=t.getUint16(e+2,!o),a=t.getUint32(e+4,!o);switch(i){case 3:if(1===a)return t.getUint16(e+8,!o)}}function f(t,e,n){for(var r="",o=e;o<e+n;o++)r+=String.fromCharCode(t.getUint8(o));return r}e.a=r;var l={274:"orientation"},d=Object.keys(l).map(function(t){return l[t]})},function(t,e,n){"use strict";function r(t,e){t.width!==e.x&&(t.width=e.x),t.height!==e.y&&(t.height=e.y)}var o=n(19),i=Math.PI/180,a={};a.create=function(t,e){var a,u={},c=t.getConfig(),s=(n.i(o.b)(t.getRealWidth(),t.getRealHeight()),t.getCanvasSize()),f=n.i(o.b)(t.getWidth(),t.getHeight()),l=t.getTopRight(),d=l.x,h=l.y,p=null,v=null;return a=e||document.createElement("canvas"),a.width=s.x,a.height=s.y,p=a.getContext("2d"),v=new Uint8Array(f.x*f.y),u.attachData=function(t){v=t},u.getData=function(){return v},u.grab=function(){var e,u=c.halfSample,l=t.getFrame(),_=l,g=0;if(_){if(r(a,s),"ImageStream"===c.type&&(_=l.img,l.tags&&l.tags.orientation))switch(l.tags.orientation){case 6:g=90*i;break;case 8:g=-90*i}return 0!==g?(p.translate(s.x/2,s.y/2),p.rotate(g),p.drawImage(_,-s.y/2,-s.x/2,s.y,s.x),p.rotate(-g),p.translate(-s.x/2,-s.y/2)):p.drawImage(_,0,0,s.x,s.y),e=p.getImageData(d,h,f.x,f.y).data,u?n.i(o.c)(e,f,v):n.i(o.d)(e,v,c),!0}return!1},u.getSize=function(){return f},u},e.a=a},function(t,e,n){"use strict";function r(t,e){t.onload=function(){e.loaded(this)}}var o=n(61),i={};i.load=function(t,e,i,a,u){var c,s,f,l=new Array(a),d=new Array(l.length);if(!1===u)l[0]=t;else for(c=0;c<l.length;c++)f=i+c,l[c]=t+"image-"+("00"+f).slice(-3)+".jpg";for(d.notLoaded=[],d.addImage=function(t){d.notLoaded.push(t)},d.loaded=function(r){for(var i=d.notLoaded,a=0;a<i.length;a++)if(i[a]===r){i.splice(a,1);for(var c=0;c<l.length;c++){var s=l[c].substr(l[c].lastIndexOf("/"));if(-1!==r.src.lastIndexOf(s)){d[c]={img:r};break}}break}0===i.length&&(!1===u?n.i(o.a)(t,["orientation"]).then(function(t){d[0].tags=t,e(d)}).catch(function(t){console.log(t),e(d)}):e(d))},c=0;c<l.length;c++)s=new Image,d.addImage(s),r(s,d),s.src=l[c]},e.a=i},function(t,e,n){"use strict";var r=n(63),o={};o.createVideoStream=function(t){function e(){var e=t.videoWidth,o=t.videoHeight;n=i.size?e/o>1?i.size:Math.floor(e/o*i.size):e,r=i.size?e/o>1?Math.floor(o/e*i.size):i.size:o,s.x=n,s.y=r}var n,r,o={},i=null,a=["canrecord","ended"],u={},c={x:0,y:0},s={x:0,y:0};return o.getRealWidth=function(){return t.videoWidth},o.getRealHeight=function(){return t.videoHeight},o.getWidth=function(){return n},o.getHeight=function(){return r},o.setWidth=function(t){n=t},o.setHeight=function(t){r=t},o.setInputStream=function(e){i=e,t.src=void 0!==e.src?e.src:""},o.ended=function(){return t.ended},o.getConfig=function(){return i},o.setAttribute=function(e,n){t.setAttribute(e,n)},o.pause=function(){t.pause()},o.play=function(){t.play()},o.setCurrentTime=function(e){"LiveStream"!==i.type&&(t.currentTime=e)},o.addEventListener=function(e,n,r){-1!==a.indexOf(e)?(u[e]||(u[e]=[]),u[e].push(n)):t.addEventListener(e,n,r)},o.clearEventHandlers=function(){a.forEach(function(e){var n=u[e];n&&n.length>0&&n.forEach(function(n){t.removeEventListener(e,n)})})},o.trigger=function(t,n){var r,i=u[t];if("canrecord"===t&&e(),i&&i.length>0)for(r=0;r<i.length;r++)i[r].apply(o,n)},o.setTopRight=function(t){c.x=t.x,c.y=t.y},o.getTopRight=function(){return c},o.setCanvasSize=function(t){s.x=t.x,s.y=t.y},o.getCanvasSize=function(){return s},o.getFrame=function(){return t},o},o.createLiveStream=function(t){t.setAttribute("autoplay",!0);var e=o.createVideoStream(t);return e.ended=function(){return!1},e},o.createImageStream=function(){function t(){l=!1,r.a.load(v,function(t){if(d=t,t[0].tags&&t[0].tags.orientation)switch(t[0].tags.orientation){case 6:case 8:u=t[0].img.height,c=t[0].img.width;break;default:u=t[0].img.width,c=t[0].img.height}else u=t[0].img.width,c=t[0].img.height;n=a.size?u/c>1?a.size:Math.floor(u/c*a.size):u,o=a.size?u/c>1?Math.floor(c/u*a.size):a.size:c,x.x=n,x.y=o,l=!0,s=0,setTimeout(function(){e("canrecord",[])},0)},p,h,a.sequence)}function e(t,e){var n,r=y[t];if(r&&r.length>0)for(n=0;n<r.length;n++)r[n].apply(i,e)}var n,o,i={},a=null,u=0,c=0,s=0,f=!0,l=!1,d=null,h=0,p=1,v=null,_=!1,g=["canrecord","ended"],y={},m={x:0,y:0},x={x:0,y:0};return i.trigger=e,i.getWidth=function(){return n},i.getHeight=function(){return o},i.setWidth=function(t){n=t},i.setHeight=function(t){o=t},i.getRealWidth=function(){return u},i.getRealHeight=function(){return c},i.setInputStream=function(e){a=e,!1===e.sequence?(v=e.src,h=1):(v=e.src,h=e.length),t()},i.ended=function(){return _},i.setAttribute=function(){},i.getConfig=function(){return a},i.pause=function(){f=!0},i.play=function(){f=!1},i.setCurrentTime=function(t){s=t},i.addEventListener=function(t,e){-1!==g.indexOf(t)&&(y[t]||(y[t]=[]),y[t].push(e))},i.setTopRight=function(t){m.x=t.x,m.y=t.y},i.getTopRight=function(){return m},i.setCanvasSize=function(t){x.x=t.x,x.y=t.y},i.getCanvasSize=function(){return x},i.getFrame=function(){var t;return l?(f||(t=d[s],s<h-1?s++:setTimeout(function(){_=!0,e("ended",[])},0)),t):null},i},e.a=o},function(t,e,n){"use strict";(function(t){function r(){var e;v=p.halfSample?new R.a({x:O.size.x/2|0,y:O.size.y/2|0}):O,C=n.i(w.e)(p.patchSize,v.size),z.x=v.size.x/C.x|0,z.y=v.size.y/C.y|0,E=new R.a(v.size,void 0,Uint8Array,!1),y=new R.a(C,void 0,Array,!0),e=new ArrayBuffer(65536),g=new R.a(C,new Uint8Array(e,0,C.x*C.y)),_=new R.a(C,new Uint8Array(e,C.x*C.y*3,C.x*C.y),void 0,!0),A=n.i(P.a)("undefined"!=typeof window?window:"undefined"!=typeof self?self:t,{size:C.x},e),b=new R.a({x:v.size.x/g.size.x|0,y:v.size.y/g.size.y|0},void 0,Array,!0),m=new R.a(b.size,void 0,void 0,!0),x=new R.a(b.size,void 0,Int32Array,!0)}function o(){p.useWorker||"undefined"==typeof document||(N.dom.binary=document.createElement("canvas"),N.dom.binary.className="binaryBuffer",N.ctx.binary=N.dom.binary.getContext("2d"),N.dom.binary.width=E.size.x,N.dom.binary.height=E.size.y)}function i(t){var e,n,r,o,i,a,u,c=E.size.x,s=E.size.y,f=-E.size.x,l=-E.size.y;for(e=0,n=0;n<t.length;n++)o=t[n],e+=o.rad;for(e/=t.length,e=(180*e/Math.PI+90)%180-90,e<0&&(e+=180),e=(180-e)*Math.PI/180,i=M.copy(M.create(),[Math.cos(e),Math.sin(e),-Math.sin(e),Math.cos(e)]),n=0;n<t.length;n++)for(o=t[n],r=0;r<4;r++)I.transformMat2(o.box[r],o.box[r],i);for(n=0;n<t.length;n++)for(o=t[n],r=0;r<4;r++)o.box[r][0]<c&&(c=o.box[r][0]),o.box[r][0]>f&&(f=o.box[r][0]),o.box[r][1]<s&&(s=o.box[r][1]),o.box[r][1]>l&&(l=o.box[r][1]);for(a=[[c,s],[f,s],[f,l],[c,l]],u=p.halfSample?2:1,i=M.invert(i,i),r=0;r<4;r++)I.transformMat2(a[r],a[r],i);for(r=0;r<4;r++)I.scale(a[r],a[r],u);return a}function a(){n.i(w.f)(v,E),E.zeroBorder()}function u(){var t,e,n,r,o,i,a,u=[];for(t=0;t<z.x;t++)for(e=0;e<z.y;e++)n=g.size.x*t,r=g.size.y*e,l(n,r),_.zeroBorder(),T.a.init(y.data,0),i=S.a.create(_,y),a=i.rasterize(0),o=y.moments(a.count),u=u.concat(d(o,[t,e],n,r));return u}function c(t){var e,n,r=[];for(e=0;e<t;e++)r.push(0);for(n=x.data.length;n--;)x.data[n]>0&&r[x.data[n]-1]++;return r=r.map(function(t,e){return{val:t,label:e+1}}),r.sort(function(t,e){return e.val-t.val}),r.filter(function(t){return t.val>=5})}function s(t,e){var n,r,o,a,u=[],c=[];for(n=0;n<t.length;n++){for(r=x.data.length,u.length=0;r--;)x.data[r]===t[n].label&&(o=b.data[r],u.push(o));a=i(u),a&&c.push(a)}return c}function f(t){var e=n.i(w.g)(t,.9),r=n.i(w.h)(e,1,function(t){return t.getPoints().length}),o=[],i=[];if(1===r.length){o=r[0].item.getPoints();for(var a=0;a<o.length;a++)i.push(o[a].point)}return i}function l(t,e){E.subImageAsCopy(g,n.i(w.b)(t,e)),A.skeletonize()}function d(t,e,n,r){var o,i,a,u,c=[],s=[],l=Math.ceil(C.x/3);if(t.length>=2){for(o=0;o<t.length;o++)t[o].m00>l&&c.push(t[o]);if(c.length>=2){for(a=f(c),i=0,o=0;o<a.length;o++)i+=a[o].rad;a.length>1&&a.length>=c.length/4*3&&a.length>t.length/4&&(i/=a.length,u={index:e[1]*z.x+e[0],pos:{x:n,y:r},box:[I.clone([n,r]),I.clone([n+g.size.x,r]),I.clone([n+g.size.x,r+g.size.y]),I.clone([n,r+g.size.y])],moments:a,rad:i,vec:I.clone([Math.cos(i),Math.sin(i)])},s.push(u))}}return s}function h(t){function e(t){var n,r,a,u,c,s={x:t%x.size.x,y:t/x.size.x|0};if(t<x.data.length)for(a=b.data[t],x.data[t]=o,c=0;c<D.a.searchDirections.length;c++)r=s.y+D.a.searchDirections[c][0],n=s.x+D.a.searchDirections[c][1],u=r*x.size.x+n,0!==m.data[u]?0===x.data[u]&&Math.abs(I.dot(b.data[u].vec,a.vec))>i&&e(u):x.data[u]=Number.MAX_VALUE}var n,r,o=0,i=.95,a=0;for(T.a.init(m.data,0),T.a.init(x.data,0),T.a.init(b.data,null),n=0;n<t.length;n++)r=t[n],b.data[r.index]=r,m.data[r.index]=1;for(m.zeroBorder();(a=function(){var t;for(t=0;t<x.data.length;t++)if(0===x.data[t]&&1===m.data[t])return t;return x.length}())<x.data.length;)o++,e(a);return o}var p,v,_,g,y,m,x,b,E,C,O,A,R=n(20),w=n(19),T=n(3),S=(n(9),n(66)),D=n(30),P=n(67),I={clone:n(7),dot:n(32),scale:n(82),transformMat2:n(83)},M={copy:n(79),create:n(80),invert:n(81)},N={ctx:{binary:null},dom:{binary:null}},z={x:0,y:0};e.a={init:function(t,e){p=e,O=t,r(),o()},locate:function(){var t,e;if(p.halfSample&&n.i(w.i)(O,v),a(),t=u(),t.length<z.x*z.y*.05)return null;var r=h(t);return r<1?null:(e=c(r),0===e.length?null:s(e,r))},checkImageConstraints:function(t,e){var r,o,i,a=t.getWidth(),u=t.getHeight(),c=e.halfSample?.5:1;if(t.getConfig().area&&(i=n.i(w.j)(a,u,t.getConfig().area),t.setTopRight({x:i.sx,y:i.sy}),t.setCanvasSize({x:a,y:u}),a=i.sw,u=i.sh),o={x:Math.floor(a*c),y:Math.floor(u*c)},r=n.i(w.e)(e.patchSize,o),t.setWidth(Math.floor(Math.floor(o.x/r.x)*(1/c)*r.x)),t.setHeight(Math.floor(Math.floor(o.y/r.y)*(1/c)*r.y)),t.getWidth()%r.x==0&&t.getHeight()%r.y==0)return!0;throw new Error("Image dimensions do not comply with the current settings: Width ("+a+" )and height ("+u+") must a multiple of "+r.x)}}}).call(e,n(48))},function(t,e,n){"use strict";var r=n(30),o={createContour2D:function(){return{dir:null,index:null,firstVertex:null,insideContours:null,nextpeer:null,prevpeer:null}},CONTOUR_DIR:{CW_DIR:0,CCW_DIR:1,UNKNOWN_DIR:2},DIR:{OUTSIDE_EDGE:-32767,INSIDE_EDGE:-32766},create:function(t,e){var n=t.data,i=e.data,a=t.size.x,u=t.size.y,c=r.a.create(t,e);return{rasterize:function(t){var e,r,s,f,l,d,h,p,v,_,g,y,m=[],x=0;for(y=0;y<400;y++)m[y]=0;for(m[0]=n[0],v=null,d=1;d<u-1;d++)for(f=0,r=m[0],l=1;l<a-1;l++)if(g=d*a+l,0===i[g])if((e=n[g])!==r){if(0===f)s=x+1,m[s]=e,r=e,null!==(h=c.contourTracing(d,l,s,e,o.DIR.OUTSIDE_EDGE))&&(x++,f=s,p=o.createContour2D(),p.dir=o.CONTOUR_DIR.CW_DIR,p.index=f,p.firstVertex=h,p.nextpeer=v,p.insideContours=null,null!==v&&(v.prevpeer=p),v=p);else if(null!==(h=c.contourTracing(d,l,o.DIR.INSIDE_EDGE,e,f))){for(p=o.createContour2D(),p.firstVertex=h,p.insideContours=null,p.dir=0===t?o.CONTOUR_DIR.CCW_DIR:o.CONTOUR_DIR.CW_DIR,p.index=t,_=v;null!==_&&_.index!==f;)_=_.nextpeer;null!==_&&(p.nextpeer=_.insideContours,null!==_.insideContours&&(_.insideContours.prevpeer=p),_.insideContours=p)}}else i[g]=f;else i[g]===o.DIR.OUTSIDE_EDGE||i[g]===o.DIR.INSIDE_EDGE?(f=0,r=i[g]===o.DIR.INSIDE_EDGE?n[g]:m[0]):(f=i[g],r=m[f]);for(_=v;null!==_;)_.index=t,_=_.nextpeer;return{cc:v,count:x}},debug:{drawContour:function(t,e){var n,r,i,a=t.getContext("2d"),u=e;for(a.strokeStyle="red",a.fillStyle="red",a.lineWidth=1,n=null!==u?u.insideContours:null;null!==u;){switch(null!==n?(r=n,n=n.nextpeer):(r=u,u=u.nextpeer,n=null!==u?u.insideContours:null),r.dir){case o.CONTOUR_DIR.CW_DIR:a.strokeStyle="red";break;case o.CONTOUR_DIR.CCW_DIR:a.strokeStyle="blue";break;case o.CONTOUR_DIR.UNKNOWN_DIR:a.strokeStyle="green"}i=r.firstVertex,a.beginPath(),a.moveTo(i.x,i.y);do{i=i.next,a.lineTo(i.x,i.y)}while(i!==r.firstVertex);a.stroke()}}}}}};e.a=o},function(module, __webpack_exports__, __webpack_require__) {"use strict";function Skeletonizer(stdlib, foreign, buffer) {"use asm";var images=new stdlib.Uint8Array(buffer),size=foreign.size|0,imul=stdlib.Math.imul;function erode(inImagePtr, outImagePtr) {inImagePtr=inImagePtr|0;outImagePtr=outImagePtr|0;var v=0,u=0,sum=0,yStart1=0,yStart2=0,xStart1=0,xStart2=0,offset=0;for (v=1; (v|0)<(size - 1|0); v=v+1|0) {offset=offset+size|0;for (u=1; (u|0)<(size - 1|0); u=u+1|0) {yStart1=offset - size|0;yStart2=offset+size|0;xStart1=u - 1|0;xStart2=u+1|0;sum=(images[inImagePtr+yStart1+xStart1|0]|0)+(images[inImagePtr+yStart1+xStart2|0]|0)+(images[inImagePtr+offset+u|0]|0)+(images[inImagePtr+yStart2+xStart1|0]|0)+(images[inImagePtr+yStart2+xStart2|0]|0)|0;if ((sum|0) == (5|0)) {images[outImagePtr+offset+u|0]=1;} else {images[outImagePtr+offset+u|0]=0;}}}return;}function subtract(aImagePtr, bImagePtr, outImagePtr) {aImagePtr=aImagePtr|0;bImagePtr=bImagePtr|0;outImagePtr=outImagePtr|0;var length=0;length=imul(size, size)|0;while ((length|0)>0) {length=length - 1|0;images[outImagePtr+length|0]=(images[aImagePtr+length|0]|0) - (images[bImagePtr+length|0]|0)|0;}}function bitwiseOr(aImagePtr, bImagePtr, outImagePtr) {aImagePtr=aImagePtr|0;bImagePtr=bImagePtr|0;outImagePtr=outImagePtr|0;var length=0;length=imul(size, size)|0;while ((length|0)>0) {length=length - 1|0;images[outImagePtr+length|0]=images[aImagePtr+length|0]|0|(images[bImagePtr+length|0]|0)|0;}}function countNonZero(imagePtr) {imagePtr=imagePtr|0;var sum=0,length=0;length=imul(size, size)|0;while ((length|0)>0) {length=length - 1|0;sum=(sum|0)+(images[imagePtr+length|0]|0)|0;}return sum|0;}function init(imagePtr, value) {imagePtr=imagePtr|0;value=value|0;var length=0;length=imul(size, size)|0;while ((length|0)>0) {length=length - 1|0;images[imagePtr+length|0]=value;}}function dilate(inImagePtr, outImagePtr) {inImagePtr=inImagePtr|0;outImagePtr=outImagePtr|0;var v=0,u=0,sum=0,yStart1=0,yStart2=0,xStart1=0,xStart2=0,offset=0;for (v=1; (v|0)<(size - 1|0); v=v+1|0) {offset=offset+size|0;for (u=1; (u|0)<(size - 1|0); u=u+1|0) {yStart1=offset - size|0;yStart2=offset+size|0;xStart1=u - 1|0;xStart2=u+1|0;sum=(images[inImagePtr+yStart1+xStart1|0]|0)+(images[inImagePtr+yStart1+xStart2|0]|0)+(images[inImagePtr+offset+u|0]|0)+(images[inImagePtr+yStart2+xStart1|0]|0)+(images[inImagePtr+yStart2+xStart2|0]|0)|0;if ((sum|0)>(0|0)) {images[outImagePtr+offset+u|0]=1;} else {images[outImagePtr+offset+u|0]=0;}}}return;}function memcpy(srcImagePtr, dstImagePtr) {srcImagePtr=srcImagePtr|0;dstImagePtr=dstImagePtr|0;var length=0;length=imul(size, size)|0;while ((length|0)>0) {length=length - 1|0;images[dstImagePtr+length|0]=images[srcImagePtr+length|0]|0;}}function zeroBorder(imagePtr) {imagePtr=imagePtr|0;var x=0,y=0;for (x=0; (x|0)<(size - 1|0); x=x+1|0) {images[imagePtr+x|0]=0;images[imagePtr+y|0]=0;y=y+size - 1|0;images[imagePtr+y|0]=0;y=y+1|0;}for (x=0; (x|0)<(size|0); x=x+1|0) {images[imagePtr+y|0]=0;y=y+1|0;}}function skeletonize() {var subImagePtr=0,erodedImagePtr=0,tempImagePtr=0,skelImagePtr=0,sum=0,done=0;erodedImagePtr=imul(size, size)|0;tempImagePtr=erodedImagePtr+erodedImagePtr|0;skelImagePtr=tempImagePtr+erodedImagePtr|0;init(skelImagePtr, 0);zeroBorder(subImagePtr);do {erode(subImagePtr, erodedImagePtr);dilate(erodedImagePtr, tempImagePtr);subtract(subImagePtr, tempImagePtr, tempImagePtr);bitwiseOr(skelImagePtr, tempImagePtr, skelImagePtr);memcpy(erodedImagePtr, subImagePtr);sum=countNonZero(subImagePtr)|0;done=(sum|0) == 0|0;} while (!done);}return {skeletonize: skeletonize};} __webpack_exports__["a"]=(Skeletonizer); },function(t,e,n){"use strict";function r(t){o.a.call(this,t),this.barSpaceRatio=[1,1]}var o=n(1),i={START_PATTERN:{value:[3,1,3,1,1,1]},STOP_PATTERN:{value:[3,1,1,1,3]},CODE_PATTERN:{value:[[1,1,3,3,1],[3,1,1,1,3],[1,3,1,1,3],[3,3,1,1,1],[1,1,3,1,3],[3,1,3,1,1],[1,3,3,1,1],[1,1,1,3,3],[3,1,1,3,1],[1,3,1,3,1]]},SINGLE_CODE_ERROR:{value:.78,writable:!0},AVG_CODE_ERROR:{value:.3,writable:!0},FORMAT:{value:"2of5"}},a=i.START_PATTERN.value.reduce(function(t,e){return t+e},0);r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype._findPattern=function(t,e,n,r){var o,i,a,u,c=[],s=this,f=0,l={error:Number.MAX_VALUE,code:-1,start:0,end:0},d=s.AVG_CODE_ERROR;for(n=n||!1,r=r||!1,e||(e=s._nextSet(s._row)),o=0;o<t.length;o++)c[o]=0;for(o=e;o<s._row.length;o++)if(s._row[o]^n)c[f]++;else{if(f===c.length-1){for(u=0,a=0;a<c.length;a++)u+=c[a];if((i=s._matchPattern(c,t))<d)return l.error=i,l.start=o-u,l.end=o,l;if(!r)return null;for(a=0;a<c.length-2;a++)c[a]=c[a+2];c[c.length-2]=0,c[c.length-1]=0,f--}else f++;c[f]=1,n=!n}return null},r.prototype._findStart=function(){for(var t,e,n=this,r=n._nextSet(n._row),o=1;!e;){if(!(e=n._findPattern(n.START_PATTERN,r,!1,!0)))return null;if(o=Math.floor((e.end-e.start)/a),(t=e.start-5*o)>=0&&n._matchRange(t,e.start,0))return e;r=e.end,e=null}},r.prototype._verifyTrailingWhitespace=function(t){var e,n=this;return e=t.end+(t.end-t.start)/2,e<n._row.length&&n._matchRange(t.end,e,0)?t:null},r.prototype._findEnd=function(){var t,e,n,r=this;return r._row.reverse(),n=r._nextSet(r._row),t=r._findPattern(r.STOP_PATTERN,n,!1,!0),r._row.reverse(),null===t?null:(e=t.start,t.start=r._row.length-t.end,t.end=r._row.length-e,null!==t?r._verifyTrailingWhitespace(t):null)},r.prototype._decodeCode=function(t){var e,n,r,o=this,i=0,a=o.AVG_CODE_ERROR,u={error:Number.MAX_VALUE,code:-1,start:0,end:0};for(e=0;e<t.length;e++)i+=t[e];for(r=0;r<o.CODE_PATTERN.length;r++)(n=o._matchPattern(t,o.CODE_PATTERN[r]))<u.error&&(u.code=r,u.error=n);if(u.error<a)return u},r.prototype._decodePayload=function(t,e,n){for(var r,o,i=this,a=0,u=t.length,c=[0,0,0,0,0];a<u;){for(r=0;r<5;r++)c[r]=t[a]*this.barSpaceRatio[0],a+=2;if(!(o=i._decodeCode(c)))return null;e.push(o.code+""),n.push(o)}return o},r.prototype._verifyCounterLength=function(t){return t.length%10==0},r.prototype._decode=function(){var t,e,n,r=this,o=[],i=[];return(t=r._findStart())?(i.push(t),(e=r._findEnd())?(n=r._fillCounters(t.end,e.start,!1),r._verifyCounterLength(n)&&r._decodePayload(n,o,i)?o.length<5?null:(i.push(e),{code:o.join(""),start:t.start,end:e.end,startInfo:t,decodedCodes:i}):null):null):null},e.a=r},function(t,e,n){"use strict";function r(){o.a.call(this),this._counters=[]}var o=n(1),i={ALPHABETH_STRING:{value:"0123456789-$:/.+ABCD"},ALPHABET:{value:[48,49,50,51,52,53,54,55,56,57,45,36,58,47,46,43,65,66,67,68]},CHARACTER_ENCODINGS:{value:[3,6,9,96,18,66,33,36,48,72,12,24,69,81,84,21,26,41,11,14]},START_END:{value:[26,41,11,14]},MIN_ENCODED_CHARS:{value:4},MAX_ACCEPTABLE:{value:2},PADDING:{value:1.5},FORMAT:{value:"codabar",writeable:!1}};r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype._decode=function(){var t,e,n,r,o,i=this,a=[];if(this._counters=i._fillCounters(),!(t=i._findStart()))return null;r=t.startCounter;do{if((n=i._toPattern(r))<0)return null;if((e=i._patternToChar(n))<0)return null;if(a.push(e),r+=8,a.length>1&&i._isStartEnd(n))break}while(r<i._counters.length);return a.length-2<i.MIN_ENCODED_CHARS||!i._isStartEnd(n)?null:i._verifyWhitespace(t.startCounter,r-8)&&i._validateResult(a,t.startCounter)?(r=r>i._counters.length?i._counters.length:r,o=t.start+i._sumCounters(t.startCounter,r-8),{code:a.join(""),start:t.start,end:o,startInfo:t,decodedCodes:a}):null},r.prototype._verifyWhitespace=function(t,e){return(t-1<=0||this._counters[t-1]>=this._calculatePatternLength(t)/2)&&(e+8>=this._counters.length||this._counters[e+7]>=this._calculatePatternLength(e)/2)},r.prototype._calculatePatternLength=function(t){var e,n=0;for(e=t;e<t+7;e++)n+=this._counters[e];return n},r.prototype._thresholdResultPattern=function(t,e){var n,r,o,i,a,u=this,c={space:{narrow:{size:0,counts:0,min:0,max:Number.MAX_VALUE},wide:{size:0,counts:0,min:0,max:Number.MAX_VALUE}},bar:{narrow:{size:0,counts:0,min:0,max:Number.MAX_VALUE},wide:{size:0,counts:0,min:0,max:Number.MAX_VALUE}}},s=e;for(o=0;o<t.length;o++){for(a=u._charToPattern(t[o]),i=6;i>=0;i--)n=2==(1&i)?c.bar:c.space,r=1==(1&a)?n.wide:n.narrow,r.size+=u._counters[s+i],r.counts++,a>>=1;s+=8}return["space","bar"].forEach(function(t){var e=c[t];e.wide.min=Math.floor((e.narrow.size/e.narrow.counts+e.wide.size/e.wide.counts)/2),e.narrow.max=Math.ceil(e.wide.min),e.wide.max=Math.ceil((e.wide.size*u.MAX_ACCEPTABLE+u.PADDING)/e.wide.counts)}),c},r.prototype._charToPattern=function(t){var e,n=this,r=t.charCodeAt(0);for(e=0;e<n.ALPHABET.length;e++)if(n.ALPHABET[e]===r)return n.CHARACTER_ENCODINGS[e];return 0},r.prototype._validateResult=function(t,e){var n,r,o,i,a,u,c=this,s=c._thresholdResultPattern(t,e),f=e;for(n=0;n<t.length;n++){for(u=c._charToPattern(t[n]),r=6;r>=0;r--){if(o=0==(1&r)?s.bar:s.space,i=1==(1&u)?o.wide:o.narrow,(a=c._counters[f+r])<i.min||a>i.max)return!1;u>>=1}f+=8}return!0},r.prototype._patternToChar=function(t){var e,n=this;for(e=0;e<n.CHARACTER_ENCODINGS.length;e++)if(n.CHARACTER_ENCODINGS[e]===t)return String.fromCharCode(n.ALPHABET[e]);return-1},r.prototype._computeAlternatingThreshold=function(t,e){var n,r,o=Number.MAX_VALUE,i=0;for(n=t;n<e;n+=2)r=this._counters[n],r>i&&(i=r),r<o&&(o=r);return(o+i)/2|0},r.prototype._toPattern=function(t){var e,n,r,o,i=t+7,a=64,u=0;if(i>this._counters.length)return-1;for(e=this._computeAlternatingThreshold(t,i),n=this._computeAlternatingThreshold(t+1,i),r=0;r<7;r++)o=0==(1&r)?e:n,this._counters[t+r]>o&&(u|=a),a>>=1;return u},r.prototype._isStartEnd=function(t){var e;for(e=0;e<this.START_END.length;e++)if(this.START_END[e]===t)return!0;return!1},r.prototype._sumCounters=function(t,e){var n,r=0;for(n=t;n<e;n++)r+=this._counters[n];return r},r.prototype._findStart=function(){var t,e,n,r=this,o=r._nextUnset(r._row);for(t=1;t<this._counters.length;t++)if(-1!==(e=r._toPattern(t))&&r._isStartEnd(e))return o+=r._sumCounters(0,t),n=o+r._sumCounters(t,t+8),{start:o,end:n,startCounter:t,endCounter:t+8}},e.a=r},function(t,e,n){"use strict";function r(){i.a.call(this)}function o(t,e,n){for(var r=n.length,o=0,i=0;r--;)i+=t[n[r]],o+=e[n[r]];return i/o}var i=n(1),a={CODE_SHIFT:{value:98},CODE_C:{value:99},CODE_B:{value:100},CODE_A:{value:101},START_CODE_A:{value:103},START_CODE_B:{value:104},START_CODE_C:{value:105},STOP_CODE:{value:106},CODE_PATTERN:{value:[[2,1,2,2,2,2],[2,2,2,1,2,2],[2,2,2,2,2,1],[1,2,1,2,2,3],[1,2,1,3,2,2],[1,3,1,2,2,2],[1,2,2,2,1,3],[1,2,2,3,1,2],[1,3,2,2,1,2],[2,2,1,2,1,3],[2,2,1,3,1,2],[2,3,1,2,1,2],[1,1,2,2,3,2],[1,2,2,1,3,2],[1,2,2,2,3,1],[1,1,3,2,2,2],[1,2,3,1,2,2],[1,2,3,2,2,1],[2,2,3,2,1,1],[2,2,1,1,3,2],[2,2,1,2,3,1],[2,1,3,2,1,2],[2,2,3,1,1,2],[3,1,2,1,3,1],[3,1,1,2,2,2],[3,2,1,1,2,2],[3,2,1,2,2,1],[3,1,2,2,1,2],[3,2,2,1,1,2],[3,2,2,2,1,1],[2,1,2,1,2,3],[2,1,2,3,2,1],[2,3,2,1,2,1],[1,1,1,3,2,3],[1,3,1,1,2,3],[1,3,1,3,2,1],[1,1,2,3,1,3],[1,3,2,1,1,3],[1,3,2,3,1,1],[2,1,1,3,1,3],[2,3,1,1,1,3],[2,3,1,3,1,1],[1,1,2,1,3,3],[1,1,2,3,3,1],[1,3,2,1,3,1],[1,1,3,1,2,3],[1,1,3,3,2,1],[1,3,3,1,2,1],[3,1,3,1,2,1],[2,1,1,3,3,1],[2,3,1,1,3,1],[2,1,3,1,1,3],[2,1,3,3,1,1],[2,1,3,1,3,1],[3,1,1,1,2,3],[3,1,1,3,2,1],[3,3,1,1,2,1],[3,1,2,1,1,3],[3,1,2,3,1,1],[3,3,2,1,1,1],[3,1,4,1,1,1],[2,2,1,4,1,1],[4,3,1,1,1,1],[1,1,1,2,2,4],[1,1,1,4,2,2],[1,2,1,1,2,4],[1,2,1,4,2,1],[1,4,1,1,2,2],[1,4,1,2,2,1],[1,1,2,2,1,4],[1,1,2,4,1,2],[1,2,2,1,1,4],[1,2,2,4,1,1],[1,4,2,1,1,2],[1,4,2,2,1,1],[2,4,1,2,1,1],[2,2,1,1,1,4],[4,1,3,1,1,1],[2,4,1,1,1,2],[1,3,4,1,1,1],[1,1,1,2,4,2],[1,2,1,1,4,2],[1,2,1,2,4,1],[1,1,4,2,1,2],[1,2,4,1,1,2],[1,2,4,2,1,1],[4,1,1,2,1,2],[4,2,1,1,1,2],[4,2,1,2,1,1],[2,1,2,1,4,1],[2,1,4,1,2,1],[4,1,2,1,2,1],[1,1,1,1,4,3],[1,1,1,3,4,1],[1,3,1,1,4,1],[1,1,4,1,1,3],[1,1,4,3,1,1],[4,1,1,1,1,3],[4,1,1,3,1,1],[1,1,3,1,4,1],[1,1,4,1,3,1],[3,1,1,1,4,1],[4,1,1,1,3,1],[2,1,1,4,1,2],[2,1,1,2,1,4],[2,1,1,2,3,2],[2,3,3,1,1,1,2]]},SINGLE_CODE_ERROR:{value:.64},AVG_CODE_ERROR:{value:.3},FORMAT:{value:"code_128",writeable:!1},MODULE_INDICES:{value:{bar:[0,2,4],space:[1,3,5]}}};r.prototype=Object.create(i.a.prototype,a),r.prototype.constructor=r,r.prototype._decodeCode=function(t,e){var n,r,i,a=[0,0,0,0,0,0],u=this,c=t,s=!u._row[c],f=0,l={error:Number.MAX_VALUE,code:-1,start:t,end:t,correction:{bar:1,space:1}};for(n=c;n<u._row.length;n++)if(u._row[n]^s)a[f]++;else{if(f===a.length-1){for(e&&u._correct(a,e),r=0;r<u.CODE_PATTERN.length;r++)(i=u._matchPattern(a,u.CODE_PATTERN[r]))<l.error&&(l.code=r,l.error=i);return l.end=n,-1===l.code||l.error>u.AVG_CODE_ERROR?null:(u.CODE_PATTERN[l.code]&&(l.correction.bar=o(u.CODE_PATTERN[l.code],a,this.MODULE_INDICES.bar),l.correction.space=o(u.CODE_PATTERN[l.code],a,this.MODULE_INDICES.space)),l)}f++,a[f]=1,s=!s}return null},r.prototype._correct=function(t,e){this._correctBars(t,e.bar,this.MODULE_INDICES.bar),this._correctBars(t,e.space,this.MODULE_INDICES.space)},r.prototype._findStart=function(){var t,e,n,r,i,a=[0,0,0,0,0,0],u=this,c=u._nextSet(u._row),s=!1,f=0,l={error:Number.MAX_VALUE,code:-1,start:0,end:0,correction:{bar:1,space:1}};for(t=c;t<u._row.length;t++)if(u._row[t]^s)a[f]++;else{if(f===a.length-1){for(i=0,r=0;r<a.length;r++)i+=a[r];for(e=u.START_CODE_A;e<=u.START_CODE_C;e++)(n=u._matchPattern(a,u.CODE_PATTERN[e]))<l.error&&(l.code=e,l.error=n);if(l.error<u.AVG_CODE_ERROR)return l.start=t-i,l.end=t,l.correction.bar=o(u.CODE_PATTERN[l.code],a,this.MODULE_INDICES.bar),l.correction.space=o(u.CODE_PATTERN[l.code],a,this.MODULE_INDICES.space),l;for(r=0;r<4;r++)a[r]=a[r+2];a[4]=0,a[5]=0,f--}else f++;a[f]=1,s=!s}return null},r.prototype._decode=function(){var t,e,n=this,r=n._findStart(),o=null,i=!1,a=[],u=0,c=0,s=[],f=[],l=!1,d=!0;if(null===r)return null;switch(o={code:r.code,start:r.start,end:r.end,correction:{bar:r.correction.bar,space:r.correction.space}},f.push(o),c=o.code,o.code){case n.START_CODE_A:t=n.CODE_A;break;case n.START_CODE_B:t=n.CODE_B;break;case n.START_CODE_C:t=n.CODE_C;break;default:return null}for(;!i;){if(e=l,l=!1,null!==(o=n._decodeCode(o.end,o.correction)))switch(o.code!==n.STOP_CODE&&(d=!0),o.code!==n.STOP_CODE&&(s.push(o.code),u++,c+=u*o.code),f.push(o),t){case n.CODE_A:if(o.code<64)a.push(String.fromCharCode(32+o.code));else if(o.code<96)a.push(String.fromCharCode(o.code-64));else switch(o.code!==n.STOP_CODE&&(d=!1),o.code){case n.CODE_SHIFT:l=!0,t=n.CODE_B;break;case n.CODE_B:t=n.CODE_B;break;case n.CODE_C:t=n.CODE_C;break;case n.STOP_CODE:i=!0}break;case n.CODE_B:if(o.code<96)a.push(String.fromCharCode(32+o.code));else switch(o.code!==n.STOP_CODE&&(d=!1),o.code){case n.CODE_SHIFT:l=!0,t=n.CODE_A;break;case n.CODE_A:t=n.CODE_A;break;case n.CODE_C:t=n.CODE_C;break;case n.STOP_CODE:i=!0}break;case n.CODE_C:if(o.code<100)a.push(o.code<10?"0"+o.code:o.code);else switch(o.code!==n.STOP_CODE&&(d=!1),o.code){case n.CODE_A:t=n.CODE_A;break;case n.CODE_B:t=n.CODE_B;break;case n.STOP_CODE:i=!0}}else i=!0;e&&(t=t===n.CODE_A?n.CODE_B:n.CODE_A)}return null===o?null:(o.end=n._nextUnset(n._row,o.end),n._verifyTrailingWhitespace(o)?(c-=u*s[s.length-1])%103!==s[s.length-1]?null:a.length?(d&&a.splice(a.length-1,1),{code:a.join(""),start:r.start,end:o.end,codeset:t,startInfo:r,decodedCodes:f,endInfo:o}):null:null)},i.a.prototype._verifyTrailingWhitespace=function(t){var e,n=this;return e=t.end+(t.end-t.start)/2,e<n._row.length&&n._matchRange(t.end,e,0)?t:null},e.a=r},function(t,e,n){"use strict";function r(){o.a.call(this)}var o=n(31),i={IOQ:/[IOQ]/g,AZ09:/[A-Z0-9]{17}/};r.prototype=Object.create(o.a.prototype),r.prototype.constructor=r,r.prototype._decode=function(){var t=o.a.prototype._decode.apply(this);if(!t)return null;var e=t.code;return e?(e=e.replace(i.IOQ,""),e.match(i.AZ09)&&this._checkChecksum(e)?(t.code=e,t):null):null},r.prototype._checkChecksum=function(t){return!!t},e.a=r},function(t,e,n){"use strict";function r(){o.a.call(this)}var o=n(1),i=n(3),a="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*",u={ALPHABETH_STRING:{value:a},ALPHABET:{value:a.split("").map(function(t){return t.charCodeAt(0)})},CHARACTER_ENCODINGS:{value:[276,328,324,322,296,292,290,336,274,266,424,420,418,404,402,394,360,356,354,308,282,344,332,326,300,278,436,434,428,422,406,410,364,358,310,314,302,468,466,458,366,374,430,294,474,470,306,350]},ASTERISK:{value:350},FORMAT:{value:"code_93",writeable:!1}};r.prototype=Object.create(o.a.prototype,u),r.prototype.constructor=r,r.prototype._decode=function(){var t,e,n,r,o=this,a=[0,0,0,0,0,0],u=[],c=o._findStart();if(!c)return null;r=o._nextSet(o._row,c.end);do{if(a=o._toCounters(r,a),(n=o._toPattern(a))<0)return null;if((t=o._patternToChar(n))<0)return null;u.push(t),e=r,r+=i.a.sum(a),r=o._nextSet(o._row,r)}while("*"!==t);return u.pop(),u.length&&o._verifyEnd(e,r,a)&&o._verifyChecksums(u)?(u=u.slice(0,u.length-2),null===(u=o._decodeExtended(u))?null:{code:u.join(""),start:c.start,end:r,startInfo:c,decodedCodes:u}):null},r.prototype._verifyEnd=function(t,e){return!(t===e||!this._row[e])},r.prototype._patternToChar=function(t){var e,n=this;for(e=0;e<n.CHARACTER_ENCODINGS.length;e++)if(n.CHARACTER_ENCODINGS[e]===t)return String.fromCharCode(n.ALPHABET[e]);return-1},r.prototype._toPattern=function(t){for(var e=t.length,n=0,r=0,o=0;o<e;o++)r+=t[o];for(var i=0;i<e;i++){var a=Math.round(9*t[i]/r);if(a<1||a>4)return-1;if(0==(1&i))for(var u=0;u<a;u++)n=n<<1|1;else n<<=a}return n},r.prototype._findStart=function(){var t,e,n,r=this,o=r._nextSet(r._row),i=o,a=[0,0,0,0,0,0],u=0,c=!1;for(t=o;t<r._row.length;t++)if(r._row[t]^c)a[u]++;else{if(u===a.length-1){if(r._toPattern(a)===r.ASTERISK&&(n=Math.floor(Math.max(0,i-(t-i)/4)),r._matchRange(n,i,0)))return{start:i,end:t};for(i+=a[0]+a[1],e=0;e<4;e++)a[e]=a[e+2];a[4]=0,a[5]=0,u--}else u++;a[u]=1,c=!c}return null},r.prototype._decodeExtended=function(t){for(var e=t.length,n=[],r=0;r<e;r++){var o=t[r];if(o>="a"&&o<="d"){if(r>e-2)return null;var i=t[++r],a=i.charCodeAt(0),u=void 0;switch(o){case"a":if(!(i>="A"&&i<="Z"))return null;u=String.fromCharCode(a-64);break;case"b":if(i>="A"&&i<="E")u=String.fromCharCode(a-38);else if(i>="F"&&i<="J")u=String.fromCharCode(a-11);else if(i>="K"&&i<="O")u=String.fromCharCode(a+16);else if(i>="P"&&i<="S")u=String.fromCharCode(a+43);else{if(!(i>="T"&&i<="Z"))return null;u=String.fromCharCode(127)}break;case"c":if(i>="A"&&i<="O")u=String.fromCharCode(a-32);else{if("Z"!==i)return null;u=":"}break;case"d":if(!(i>="A"&&i<="Z"))return null;u=String.fromCharCode(a+32)}n.push(u)}else n.push(o)}return n},r.prototype._verifyChecksums=function(t){return this._matchCheckChar(t,t.length-2,20)&&this._matchCheckChar(t,t.length-1,15)},r.prototype._matchCheckChar=function(t,e,n){var r=this,o=t.slice(0,e),i=o.length,a=o.reduce(function(t,e,o){return t+((-1*o+(i-1))%n+1)*r.ALPHABET.indexOf(e.charCodeAt(0))},0);return this.ALPHABET[a%47]===t[e].charCodeAt(0)},e.a=r},function(t,e,n){"use strict";function r(){o.a.call(this)}var o=n(4),i={FORMAT:{value:"ean_2",writeable:!1}};r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype.decode=function(t,e){this._row=t;var n,r=0,o=0,i=e,a=this._row.length,u=[],c=[];for(o=0;o<2&&i<a;o++){if(!(n=this._decodeCode(i)))return null;c.push(n),u.push(n.code%10),n.code>=this.CODE_G_START&&(r|=1<<1-o),1!=o&&(i=this._nextSet(this._row,n.end),i=this._nextUnset(this._row,i))}return 2!=u.length||parseInt(u.join(""))%4!==r?null:{code:u.join(""),decodedCodes:c,end:n.end}},e.a=r},function(t,e,n){"use strict";function r(){a.a.call(this)}function o(t){var e;for(e=0;e<10;e++)if(t===c[e])return e;return null}function i(t){var e,n=t.length,r=0;for(e=n-2;e>=0;e-=2)r+=t[e];for(r*=3,e=n-1;e>=0;e-=2)r+=t[e];return(r*=3)%10}var a=n(4),u={FORMAT:{value:"ean_5",writeable:!1}},c=[24,20,18,17,12,6,3,10,9,5];r.prototype=Object.create(a.a.prototype,u),r.prototype.constructor=r,r.prototype.decode=function(t,e){this._row=t;var n,r=0,a=0,u=e,c=this._row.length,s=[],f=[];for(a=0;a<5&&u<c;a++){if(!(n=this._decodeCode(u)))return null;f.push(n),s.push(n.code%10),n.code>=this.CODE_G_START&&(r|=1<<4-a),4!=a&&(u=this._nextSet(this._row,n.end),u=this._nextUnset(this._row,u))}return 5!=s.length?null:i(s)!==o(r)?null:{code:s.join(""),decodedCodes:f,end:n.end}},e.a=r},function(t,e,n){"use strict";function r(t,e){o.a.call(this,t,e)}var o=n(4),i={FORMAT:{value:"ean_8",writeable:!1}};r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype._decodePayload=function(t,e,n){var r,o=this;for(r=0;r<4;r++){if(!(t=o._decodeCode(t.end,o.CODE_G_START)))return null;e.push(t.code),n.push(t)}if(null===(t=o._findPattern(o.MIDDLE_PATTERN,t.end,!0,!1)))return null;for(n.push(t),r=0;r<4;r++){if(!(t=o._decodeCode(t.end,o.CODE_G_START)))return null;n.push(t),e.push(t.code)}return t},e.a=r},function(t,e,n){"use strict";function r(t){t=a()(o(),t),u.a.call(this,t),this.barSpaceRatio=[1,1],t.normalizeBarSpaceWidth&&(this.SINGLE_CODE_ERROR=.38,this.AVG_CODE_ERROR=.09)}function o(){var t={};return Object.keys(r.CONFIG_KEYS).forEach(function(e){t[e]=r.CONFIG_KEYS[e].default}),t}var i=n(28),a=n.n(i),u=n(1),c={START_PATTERN:{value:[1,1,1,1]},STOP_PATTERN:{value:[1,1,3]},CODE_PATTERN:{value:[[1,1,3,3,1],[3,1,1,1,3],[1,3,1,1,3],[3,3,1,1,1],[1,1,3,1,3],[3,1,3,1,1],[1,3,3,1,1],[1,1,1,3,3],[3,1,1,3,1],[1,3,1,3,1]]},SINGLE_CODE_ERROR:{value:.78,writable:!0},AVG_CODE_ERROR:{value:.38,writable:!0},MAX_CORRECTION_FACTOR:{value:5},FORMAT:{value:"i2of5"}};r.prototype=Object.create(u.a.prototype,c),r.prototype.constructor=r,r.prototype._matchPattern=function(t,e){if(this.config.normalizeBarSpaceWidth){var n,r=[0,0],o=[0,0],i=[0,0],a=this.MAX_CORRECTION_FACTOR,c=1/a;for(n=0;n<t.length;n++)r[n%2]+=t[n],o[n%2]+=e[n];for(i[0]=o[0]/r[0],i[1]=o[1]/r[1],i[0]=Math.max(Math.min(i[0],a),c),i[1]=Math.max(Math.min(i[1],a),c),this.barSpaceRatio=i,n=0;n<t.length;n++)t[n]*=this.barSpaceRatio[n%2]}return u.a.prototype._matchPattern.call(this,t,e)},r.prototype._findPattern=function(t,e,n,r){var o,i,a,u,c=[],s=this,f=0,l={error:Number.MAX_VALUE,code:-1,start:0,end:0},d=s.AVG_CODE_ERROR;for(n=n||!1,r=r||!1,e||(e=s._nextSet(s._row)),o=0;o<t.length;o++)c[o]=0;for(o=e;o<s._row.length;o++)if(s._row[o]^n)c[f]++;else{if(f===c.length-1){for(u=0,a=0;a<c.length;a++)u+=c[a];if((i=s._matchPattern(c,t))<d)return l.error=i,l.start=o-u,l.end=o,l;if(!r)return null;for(a=0;a<c.length-2;a++)c[a]=c[a+2];c[c.length-2]=0,c[c.length-1]=0,f--}else f++;c[f]=1,n=!n}return null},r.prototype._findStart=function(){for(var t,e,n=this,r=n._nextSet(n._row),o=1;!e;){if(!(e=n._findPattern(n.START_PATTERN,r,!1,!0)))return null;if(o=Math.floor((e.end-e.start)/4),(t=e.start-10*o)>=0&&n._matchRange(t,e.start,0))return e;r=e.end,e=null}},r.prototype._verifyTrailingWhitespace=function(t){var e,n=this;return e=t.end+(t.end-t.start)/2,e<n._row.length&&n._matchRange(t.end,e,0)?t:null},r.prototype._findEnd=function(){var t,e,n=this;return n._row.reverse(),t=n._findPattern(n.STOP_PATTERN),n._row.reverse(),null===t?null:(e=t.start,t.start=n._row.length-t.end,t.end=n._row.length-e,null!==t?n._verifyTrailingWhitespace(t):null)},r.prototype._decodePair=function(t){var e,n,r=[],o=this;for(e=0;e<t.length;e++){if(!(n=o._decodeCode(t[e])))return null;r.push(n)}return r},r.prototype._decodeCode=function(t){var e,n,r,o=this,i=0,a=o.AVG_CODE_ERROR,u={error:Number.MAX_VALUE,code:-1,start:0,end:0};for(e=0;e<t.length;e++)i+=t[e];for(r=0;r<o.CODE_PATTERN.length;r++)(n=o._matchPattern(t,o.CODE_PATTERN[r]))<u.error&&(u.code=r,u.error=n);if(u.error<a)return u},r.prototype._decodePayload=function(t,e,n){for(var r,o,i=this,a=0,u=t.length,c=[[0,0,0,0,0],[0,0,0,0,0]];a<u;){for(r=0;r<5;r++)c[0][r]=t[a]*this.barSpaceRatio[0],c[1][r]=t[a+1]*this.barSpaceRatio[1],a+=2;if(!(o=i._decodePair(c)))return null;for(r=0;r<o.length;r++)e.push(o[r].code+""),n.push(o[r])}return o},r.prototype._verifyCounterLength=function(t){return t.length%10==0},r.prototype._decode=function(){var t,e,n,r=this,o=[],i=[];return(t=r._findStart())?(i.push(t),(e=r._findEnd())?(n=r._fillCounters(t.end,e.start,!1),r._verifyCounterLength(n)&&r._decodePayload(n,o,i)?o.length%2!=0||o.length<6?null:(i.push(e),{code:o.join(""),start:t.start,end:e.end,startInfo:t,decodedCodes:i}):null):null):null},r.CONFIG_KEYS={normalizeBarSpaceWidth:{type:"boolean",default:!1,description:"If true, the reader tries to normalize thewidth-difference between bars and spaces"}},e.a=r},function(t,e,n){"use strict";function r(t,e){o.a.call(this,t,e)}var o=n(4),i={CODE_FREQUENCY:{value:[[56,52,50,49,44,38,35,42,41,37],[7,11,13,14,19,25,28,21,22,26]]},STOP_PATTERN:{value:[1/6*7,1/6*7,1/6*7,1/6*7,1/6*7,1/6*7]},FORMAT:{value:"upc_e",writeable:!1}};r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype._decodePayload=function(t,e,n){var r,o=this,i=0;for(r=0;r<6;r++){if(!(t=o._decodeCode(t.end)))return null;t.code>=o.CODE_G_START&&(t.code=t.code-o.CODE_G_START,i|=1<<5-r),e.push(t.code),n.push(t)}return o._determineParity(i,e)?t:null},r.prototype._determineParity=function(t,e){var n,r;for(r=0;r<this.CODE_FREQUENCY.length;r++)for(n=0;n<this.CODE_FREQUENCY[r].length;n++)if(t===this.CODE_FREQUENCY[r][n])return e.unshift(r),e.push(n),!0;return!1},r.prototype._convertToUPCA=function(t){var e=[t[0]],n=t[t.length-2];return e=n<=2?e.concat(t.slice(1,3)).concat([n,0,0,0,0]).concat(t.slice(3,6)):3===n?e.concat(t.slice(1,4)).concat([0,0,0,0,0]).concat(t.slice(4,6)):4===n?e.concat(t.slice(1,5)).concat([0,0,0,0,0,t[5]]):e.concat(t.slice(1,6)).concat([0,0,0,0,n]),e.push(t[t.length-1]),e},r.prototype._checksum=function(t){return o.a.prototype._checksum.call(this,this._convertToUPCA(t))},r.prototype._findEnd=function(t,e){return e=!0,o.a.prototype._findEnd.call(this,t,e)},r.prototype._verifyTrailingWhitespace=function(t){var e,n=this;if((e=t.end+(t.end-t.start)/2)<n._row.length&&n._matchRange(t.end,e,0))return t},e.a=r},function(t,e,n){"use strict";function r(t,e){o.a.call(this,t,e)}var o=n(4),i={FORMAT:{value:"upc_a",writeable:!1}};r.prototype=Object.create(o.a.prototype,i),r.prototype.constructor=r,r.prototype._decode=function(){var t=o.a.prototype._decode.call(this);return t&&t.code&&13===t.code.length&&"0"===t.code.charAt(0)?(t.code=t.code.substring(1),t):null},e.a=r},function(t,e){function n(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t}t.exports=n},function(t,e){function n(){var t=new Float32Array(4);return t[0]=1,t[1]=0,t[2]=0,t[3]=1,t}t.exports=n},function(t,e){function n(t,e){var n=e[0],r=e[1],o=e[2],i=e[3],a=n*i-o*r;return a?(a=1/a,t[0]=i*a,t[1]=-r*a,t[2]=-o*a,t[3]=n*a,t):null}t.exports=n},function(t,e){function n(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t}t.exports=n},function(t,e){function n(t,e,n){var r=e[0],o=e[1];return t[0]=n[0]*r+n[2]*o,t[1]=n[1]*r+n[3]*o,t}t.exports=n},function(t,e){function n(t){var e=new Float32Array(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e}t.exports=n},function(t,e,n){function r(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}var o=n(123),i=n(124),a=n(125),u=n(126),c=n(127);r.prototype.clear=o,r.prototype.delete=i,r.prototype.get=a,r.prototype.has=u,r.prototype.set=c,t.exports=r},function(t,e,n){function r(t){var e=this.__data__=new o(t);this.size=e.size}var o=n(10),i=n(150),a=n(151),u=n(152),c=n(153),s=n(154);r.prototype.clear=i,r.prototype.delete=a,r.prototype.get=u,r.prototype.has=c,r.prototype.set=s,t.exports=r},function(t,e,n){var r=n(5),o=r.Uint8Array;t.exports=o},function(t,e){function n(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}t.exports=n},function(t,e,n){function r(t,e){var n=a(t),r=!n&&i(t),f=!n&&!r&&u(t),d=!n&&!r&&!f&&s(t),h=n||r||f||d,p=h?o(t.length,String):[],v=p.length;for(var _ in t)!e&&!l.call(t,_)||h&&("length"==_||f&&("offset"==_||"parent"==_)||d&&("buffer"==_||"byteLength"==_||"byteOffset"==_)||c(_,v))||p.push(_);return p}var o=n(108),i=n(18),a=n(2),u=n(45),c=n(15),s=n(46),f=Object.prototype,l=f.hasOwnProperty;t.exports=r},function(t,e){function n(t,e){for(var n=-1,r=null==t?0:t.length,o=Array(r);++n<r;)o[n]=e(t[n],n,t);return o}t.exports=n},function(t,e){function n(t,e){for(var n=-1,r=e.length,o=t.length;++n<r;)t[o+n]=e[n];return t}t.exports=n},function(t,e,n){var r=n(0),o=Object.create,i=function(){function t(){}return function(e){if(!r(e))return{};if(o)return o(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();t.exports=i},function(t,e,n){function r(t,e,n,a,u){var c=-1,s=t.length;for(n||(n=i),u||(u=[]);++c<s;){var f=t[c];e>0&&n(f)?e>1?r(f,e-1,n,a,u):o(u,f):a||(u[u.length]=f)}return u}var o=n(91),i=n(129);t.exports=r},function(t,e,n){var r=n(118),o=r();t.exports=o},function(t,e,n){function r(t,e){e=o(e,t);for(var n=0,r=e.length;null!=t&&n<r;)t=t[i(e[n++])];return n&&n==r?t:void 0}var o=n(13),i=n(23);t.exports=r},function(t,e){function n(t,e){return null!=t&&e in Object(t)}t.exports=n},function(t,e,n){function r(t){return i(t)&&o(t)==a}var o=n(8),i=n(6),a="[object Arguments]";t.exports=r},function(t,e,n){function r(t){return!(!a(t)||i(t))&&(o(t)?p:s).test(u(t))}var o=n(25),i=n(133),a=n(0),u=n(156),c=/[\\^$.*+?()[\]{}|]/g,s=/^\[object .+?Constructor\]$/,f=Function.prototype,l=Object.prototype,d=f.toString,h=l.hasOwnProperty,p=RegExp("^"+d.call(h).replace(c,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=r},function(t,e,n){function r(t){return a(t)&&i(t.length)&&!!u[o(t)]}var o=n(8),i=n(26),a=n(6),u={};u["[object Float32Array]"]=u["[object Float64Array]"]=u["[object Int8Array]"]=u["[object Int16Array]"]=u["[object Int32Array]"]=u["[object Uint8Array]"]=u["[object Uint8ClampedArray]"]=u["[object Uint16Array]"]=u["[object Uint32Array]"]=!0,u["[object Arguments]"]=u["[object Array]"]=u["[object ArrayBuffer]"]=u["[object Boolean]"]=u["[object DataView]"]=u["[object Date]"]=u["[object Error]"]=u["[object Function]"]=u["[object Map]"]=u["[object Number]"]=u["[object Object]"]=u["[object RegExp]"]=u["[object Set]"]=u["[object String]"]=u["[object WeakMap]"]=!1,t.exports=r},function(t,e,n){function r(t){if(!o(t))return a(t);var e=i(t),n=[];for(var r in t)("constructor"!=r||!e&&c.call(t,r))&&n.push(r);return n}var o=n(0),i=n(40),a=n(145),u=Object.prototype,c=u.hasOwnProperty;t.exports=r},function(t,e,n){function r(t,e,n,l,d){t!==e&&a(e,function(a,s){if(d||(d=new o),c(a))u(t,e,s,n,r,l,d);else{var h=l?l(f(t,s),a,s+"",t,e,d):void 0;void 0===h&&(h=a),i(t,s,h)}},s)}var o=n(86),i=n(35),a=n(94),u=n(102),c=n(0),s=n(47),f=n(42);t.exports=r},function(t,e,n){function r(t,e,n,r,m,x,b){var E=g(t,n),C=g(e,n),O=b.get(C);if(O)return void o(t,n,O);var A=x?x(E,C,n+"",t,e,b):void 0,R=void 0===A;if(R){var w=f(C),T=!w&&d(C),S=!w&&!T&&_(C);A=C,w||T||S?f(E)?A=E:l(E)?A=u(E):T?(R=!1,A=i(C,!0)):S?(R=!1,A=a(C,!0)):A=[]:v(C)||s(C)?(A=E,s(E)?A=y(E):p(E)&&!h(E)||(A=c(C))):R=!1}R&&(b.set(C,A),m(A,C,r,x,b),b.delete(C)),o(t,n,A)}var o=n(35),i=n(112),a=n(113),u=n(114),c=n(128),s=n(18),f=n(2),l=n(160),d=n(45),h=n(25),p=n(0),v=n(161),_=n(46),g=n(42),y=n(165);t.exports=r},function(t,e,n){function r(t,e){return o(t,e,function(e,n){return i(t,n)})}var o=n(104),i=n(159);t.exports=r},function(t,e,n){function r(t,e,n){for(var r=-1,u=e.length,c={};++r<u;){var s=e[r],f=o(t,s);n(f,s)&&i(c,a(s,t),f)}return c}var o=n(95),i=n(106),a=n(13);t.exports=r},function(t,e,n){function r(t,e){return a(i(t,e,o),t+"")}var o=n(44),i=n(41),a=n(43);t.exports=r},function(t,e,n){function r(t,e,n,r){if(!u(t))return t;e=i(e,t);for(var s=-1,f=e.length,l=f-1,d=t;null!=d&&++s<f;){var h=c(e[s]),p=n;if(s!=l){var v=d[h];p=r?r(v,h,d):void 0,void 0===p&&(p=u(v)?v:a(e[s+1])?[]:{})}o(d,h,p),d=d[h]}return t}var o=n(36),i=n(13),a=n(15),u=n(0),c=n(23);t.exports=r},function(t,e,n){var r=n(157),o=n(37),i=n(44),a=o?function(t,e){return o(t,"toString",{configurable:!0,enumerable:!1,value:r(e),writable:!0})}:i;t.exports=a},function(t,e){function n(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}t.exports=n},function(t,e,n){function r(t){if("string"==typeof t)return t;if(a(t))return i(t,r)+"";if(u(t))return f?f.call(t):"";var e=t+"";return"0"==e&&1/t==-c?"-0":e}var o=n(11),i=n(90),a=n(2),u=n(27),c=1/0,s=o?o.prototype:void 0,f=s?s.toString:void 0;t.exports=r},function(t,e){function n(t){return function(e){return t(e)}}t.exports=n},function(t,e,n){function r(t){var e=new t.constructor(t.byteLength);return new o(e).set(new o(t)),e}var o=n(87);t.exports=r},function(t,e,n){(function(t){function r(t,e){if(e)return t.slice();var n=t.length,r=s?s(n):new t.constructor(n);return t.copy(r),r}var o=n(5),i="object"==typeof e&&e&&!e.nodeType&&e,a=i&&"object"==typeof t&&t&&!t.nodeType&&t,u=a&&a.exports===i,c=u?o.Buffer:void 0,s=c?c.allocUnsafe:void 0;t.exports=r}).call(e,n(29)(t))},function(t,e,n){function r(t,e){var n=e?o(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)}var o=n(111);t.exports=r},function(t,e){function n(t,e){var n=-1,r=t.length;for(e||(e=Array(r));++n<r;)e[n]=t[n];return e}t.exports=n},function(t,e,n){function r(t,e,n,r){var a=!n;n||(n={});for(var u=-1,c=e.length;++u<c;){var s=e[u],f=r?r(n[s],t[s],s,n,t):void 0;void 0===f&&(f=t[s]),a?i(n,s,f):o(n,s,f)}return n}var o=n(36),i=n(21);t.exports=r},function(t,e,n){var r=n(5),o=r["__core-js_shared__"];t.exports=o},function(t,e,n){function r(t){return o(function(e,n){var r=-1,o=n.length,a=o>1?n[o-1]:void 0,u=o>2?n[2]:void 0;for(a=t.length>3&&"function"==typeof a?(o--,a):void 0,u&&i(n[0],n[1],u)&&(a=o<3?void 0:a,o=1),e=Object(e);++r<o;){var c=n[r];c&&t(e,c,r,a)}return e})}var o=n(105),i=n(130);t.exports=r},function(t,e){function n(t){return function(e,n,r){for(var o=-1,i=Object(e),a=r(e),u=a.length;u--;){var c=a[t?u:++o];if(!1===n(i[c],c,i))break}return e}}t.exports=n},function(t,e,n){function r(t){return a(i(t,void 0,o),t+"")}var o=n(158),i=n(41),a=n(43);t.exports=r},function(t,e,n){function r(t){var e=a.call(t,c),n=t[c];try{t[c]=void 0;var r=!0}catch(t){}var o=u.call(t);return r&&(e?t[c]=n:delete t[c]),o}var o=n(11),i=Object.prototype,a=i.hasOwnProperty,u=i.toString,c=o?o.toStringTag:void 0;t.exports=r},function(t,e){function n(t,e){return null==t?void 0:t[e]}t.exports=n},function(t,e,n){function r(t,e,n){e=o(e,t);for(var r=-1,f=e.length,l=!1;++r<f;){var d=s(e[r]);if(!(l=null!=t&&n(t,d)))break;t=t[d]}return l||++r!=f?l:!!(f=null==t?0:t.length)&&c(f)&&u(d,f)&&(a(t)||i(t))}var o=n(13),i=n(18),a=n(2),u=n(15),c=n(26),s=n(23);t.exports=r},function(t,e,n){function r(){this.__data__=o?o(null):{},this.size=0}var o=n(16);t.exports=r},function(t,e){function n(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}t.exports=n},function(t,e,n){function r(t){var e=this.__data__;if(o){var n=e[t];return n===i?void 0:n}return u.call(e,t)?e[t]:void 0}var o=n(16),i="__lodash_hash_undefined__",a=Object.prototype,u=a.hasOwnProperty;t.exports=r},function(t,e,n){function r(t){var e=this.__data__;return o?void 0!==e[t]:a.call(e,t)}var o=n(16),i=Object.prototype,a=i.hasOwnProperty;t.exports=r},function(t,e,n){function r(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=o&&void 0===e?i:e,this}var o=n(16),i="__lodash_hash_undefined__";t.exports=r},function(t,e,n){function r(t){return"function"!=typeof t.constructor||a(t)?{}:o(i(t))}var o=n(92),i=n(39),a=n(40);t.exports=r},function(t,e,n){function r(t){return a(t)||i(t)||!!(u&&t&&t[u])}var o=n(11),i=n(18),a=n(2),u=o?o.isConcatSpreadable:void 0;t.exports=r},function(t,e,n){function r(t,e,n){if(!u(n))return!1;var r=typeof e;return!!("number"==r?i(n)&&a(e,n.length):"string"==r&&e in n)&&o(n[e],t)}var o=n(17),i=n(24),a=n(15),u=n(0);t.exports=r},function(t,e,n){function r(t,e){if(o(t))return!1;var n=typeof t;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=t&&!i(t))||(u.test(t)||!a.test(t)||null!=e&&t in Object(e))}var o=n(2),i=n(27),a=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,u=/^\w*$/;t.exports=r},function(t,e){function n(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}t.exports=n},function(t,e,n){function r(t){return!!i&&i in t}var o=n(116),i=function(){var t=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=r},function(t,e){function n(){this.__data__=[],this.size=0}t.exports=n},function(t,e,n){function r(t){var e=this.__data__,n=o(e,t);return!(n<0)&&(n==e.length-1?e.pop():a.call(e,n,1),--this.size,!0)}var o=n(12),i=Array.prototype,a=i.splice;t.exports=r},function(t,e,n){function r(t){var e=this.__data__,n=o(e,t);return n<0?void 0:e[n][1]}var o=n(12);t.exports=r},function(t,e,n){function r(t){return o(this.__data__,t)>-1}var o=n(12);t.exports=r},function(t,e,n){function r(t,e){var n=this.__data__,r=o(n,t);return r<0?(++this.size,n.push([t,e])):n[r][1]=e,this}var o=n(12);t.exports=r},function(t,e,n){function r(){this.size=0,this.__data__={hash:new o,map:new(a||i),string:new o}}var o=n(85),i=n(10),a=n(33);t.exports=r},function(t,e,n){function r(t){var e=o(this,t).delete(t);return this.size-=e?1:0,e}var o=n(14);t.exports=r},function(t,e,n){function r(t){return o(this,t).get(t)}var o=n(14);t.exports=r},function(t,e,n){function r(t){return o(this,t).has(t)}var o=n(14);t.exports=r},function(t,e,n){function r(t,e){var n=o(this,t),r=n.size;return n.set(t,e),this.size+=n.size==r?0:1,this}var o=n(14);t.exports=r},function(t,e,n){function r(t){var e=o(t,function(t){return n.size===i&&n.clear(),t}),n=e.cache;return e}var o=n(162),i=500;t.exports=r},function(t,e){function n(t){var e=[];if(null!=t)for(var n in Object(t))e.push(n);return e}t.exports=n},function(t,e,n){(function(t){var r=n(38),o="object"==typeof e&&e&&!e.nodeType&&e,i=o&&"object"==typeof t&&t&&!t.nodeType&&t,a=i&&i.exports===o,u=a&&r.process,c=function(){try{var t=i&&i.require&&i.require("util").types;return t||u&&u.binding&&u.binding("util")}catch(t){}}();t.exports=c}).call(e,n(29)(t))},function(t,e){function n(t){return o.call(t)}var r=Object.prototype,o=r.toString;t.exports=n},function(t,e){function n(t,e){return function(n){return t(e(n))}}t.exports=n},function(t,e){function n(t){var e=0,n=0;return function(){var a=i(),u=o-(a-n);if(n=a,u>0){if(++e>=r)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}var r=800,o=16,i=Date.now;t.exports=n},function(t,e,n){function r(){this.__data__=new o,this.size=0}var o=n(10);t.exports=r},function(t,e){function n(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n}t.exports=n},function(t,e){function n(t){return this.__data__.get(t)}t.exports=n},function(t,e){function n(t){return this.__data__.has(t)}t.exports=n},function(t,e,n){function r(t,e){var n=this.__data__;if(n instanceof o){var r=n.__data__;if(!i||r.length<u-1)return r.push([t,e]),this.size=++n.size,this;n=this.__data__=new a(r)}return n.set(t,e),this.size=n.size,this}var o=n(10),i=n(33),a=n(34),u=200;t.exports=r},function(t,e,n){var r=n(144),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,i=/\\(\\)?/g,a=r(function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(o,function(t,n,r,o){e.push(r?o.replace(i,"$1"):n||t)}),e});t.exports=a},function(t,e){function n(t){if(null!=t){try{return o.call(t)}catch(t){}try{return t+""}catch(t){}}return""}var r=Function.prototype,o=r.toString;t.exports=n},function(t,e){function n(t){return function(){return t}}t.exports=n},function(t,e,n){function r(t){return(null==t?0:t.length)?o(t,1):[]}var o=n(93);t.exports=r},function(t,e,n){function r(t,e){return null!=t&&i(t,e,o)}var o=n(96),i=n(122);t.exports=r},function(t,e,n){function r(t){return i(t)&&o(t)}var o=n(24),i=n(6);t.exports=r},function(t,e,n){function r(t){if(!a(t)||o(t)!=u)return!1;var e=i(t);if(null===e)return!0;var n=l.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&f.call(n)==d}var o=n(8),i=n(39),a=n(6),u="[object Object]",c=Function.prototype,s=Object.prototype,f=c.toString,l=s.hasOwnProperty,d=f.call(Object);t.exports=r},function(t,e,n){function r(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError(i);var n=function(){var r=arguments,o=e?e.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var a=t.apply(this,r);return n.cache=i.set(o,a)||i,a};return n.cache=new(r.Cache||o),n}var o=n(34),i="Expected a function";r.Cache=o,t.exports=r},function(t,e,n){var r=n(103),o=n(119),i=o(function(t,e){return null==t?{}:r(t,e)});t.exports=i},function(t,e){function n(){return!1}t.exports=n},function(t,e,n){function r(t){return o(t,i(t))}var o=n(115),i=n(47);t.exports=r},function(t,e,n){function r(t){return null==t?"":o(t)}var o=n(109);t.exports=r},function(t,e,n){t.exports=n(49)}])});;
angular
    .module('garanteasyApp')
    .directive('customOnChange', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.customOnChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function () {
                    element.off();
                });

            }
        };
    });;
angular
    .module('garanteasyApp')
    .component('barCodeReader', {
        templateUrl: 'app/components/bar-code-reader/bar-code-reader.component.html',
        controller: BarCodeReaderComponentController,
        controllerAs: 'vm',
        bindings: {
            myModel: '=',
            btnClass: '<'
        }
    });

BarCodeReaderComponentController.$inject = ['$uibModal'];

function BarCodeReaderComponentController($uibModal) {
    var vm = this;
    vm.onReadBarCodeFile = function () {
        $uibModal
            .open({
                templateUrl: "app/components/bar-code-reader/bar-code-file-reader.html",
                controller: "BarCodeFileReaderController",
                controllerAs: "vm",
                size: "md"
            })
            .result.then(
                function () {
                    vm.myModel = "OK";
                },
                function () {
                    vm.myModel = "CANCEL";
                }
            );
    };
    vm.onReadBarCodeCamera = function () {
        $uibModal
            .open({
                templateUrl: "app/components/bar-code-reader/bar-code-camera-reader.html",
                controller: "BarCodeCameraReaderController",
                controllerAs: "vm",
                size: "md"
            })
            .result.then(
                function () {
                    vm.myModel = "OK";
                },
                function () {
                    vm.myModel = "CANCEL";
                }
            );
    };
}
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('BarCodeFileReaderController', BarCodeFileReaderController);

    BarCodeFileReaderController.$inject = ['$scope', 'AlertService', '$stateParams', 'ShopService', '$uibModalInstance'];

    function BarCodeFileReaderController($scope, AlertService, $stateParams, ShopService, $uibModalInstance) {
        var vm = this;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.save = function () {
            onSaveSuccess();
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close('ok');
        }

        function onSaveError(error) {
            AlertService.error(error.data.message);
        }

        vm.onFileImputChange = function (e) {
            if (e.target.files && e.target.files.length) {
                vm.decode(URL.createObjectURL(e.target.files[0]));
            }
        }
        vm.decode = function (src) {
            var self = vm,
                config = $.extend({}, self.state, { src: src });

            Quagga.decodeSingle(config, function (result) { });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('BarCodeCameraReaderController', BarCodeCameraReaderController);

    BarCodeCameraReaderController.$inject = ['$scope', 'AlertService', '$stateParams', 'ShopService', '$uibModalInstance'];

    function BarCodeCameraReaderController($scope, AlertService, $stateParams, ShopService, $uibModalInstance) {
        var vm = this;
        vm.cameraIsEnabled = false;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.save = function () {
            onSaveSuccess();
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close('ok');
        }

        function onSaveError(error) {
            AlertService.error(error.data.message);
        }

        vm.onFileImputChange = function (e) {
            if (e.target.files && e.target.files.length) {
                vm.decode(URL.createObjectURL(e.target.files[0]));
            }
        }
        vm.decode = function (src) {
            var self = vm,
                config = $.extend({}, self.state, { src: src });

            Quagga.decodeSingle(config, function (result) { });
        }

        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
        window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

        function getUserMedia(constraints, success, failure) {
            navigator.getUserMedia(constraints, function (stream) {
                var videoSrc = (window.URL && window.URL.createObjectURL(stream)) || stream;
                success.apply(null, [videoSrc]);
            }, failure);
        }


        function initCamera(constraints, video, callback) {
            getUserMedia(constraints, function (src) {
                video.src = src;
                video.addEventListener('loadeddata', function () {
                    var attempts = 10;

                    function checkVideo() {
                        if (attempts > 0) {
                            if (video.videoWidth > 0 && video.videoHeight > 0) {
                                console.log(video.videoWidth + "px x " + video.videoHeight + "px");
                                video.play();
                                callback();
                            } else {
                                window.setTimeout(checkVideo, 100);
                            }
                        } else {
                            vm.cameraIsEnabled = false;
                            callback('Unable to play video stream.');
                        }
                        attempts--;
                    }

                    checkVideo();
                }, false);
            }, function (e) {
                vm.cameraIsEnabled = false;
                console.log(e);
            });
        }

        function copyToCanvas(video, ctx) {
            (function frame() {
                ctx.drawImage(video, 0, 0);
                window.requestAnimationFrame(frame);
            }());
        }

        var constraints = {
            video: {
                mandatory: {
                    minWidth: 1280,
                    minHeight: 720
                }
            }
        }
        var video = angular.element(document.createElement('video'));
        var canvas = angular.element(document.createElement('canvas'));

        angular.element(document.body).append(video);
        angular.element(document.body).append(canvas);

        initCamera(constraints, video, function () {
            canvas.setAttribute('width', video.videoWidth);
            canvas.setAttribute('height', video.videoHeight);
            copyToCanvas(video, canvas.getContext('2d'));
        });
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('garanteasyApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('garanteasyApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-garanteasyApp-error');
                var entityKey = httpResponse.headers('X-garanteasyApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('garanteasyApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 403:
                addErrorAlert('Forbidden','error.unauthorized');
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('garanteasyApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
'use strict';
(function () {

  angular
    .module('garanteasyApp')
    .controller('CmsDetailController', CmsDetailController);


  CmsDetailController.$inject = ['$state', '$stateParams', '$translate', 'CmsService', '$log'];

  function CmsDetailController($state, $stateParams, $translate, CmsService, $log) {
    var vm = this;

    vm.id = '';
    vm.node = '';
    vm.lang = 'eng';
    vm.nodes = {
      'tutorial': 'garanteasyApp.receipt.sidebar.tutorial',
      'guide': 'garanteasyApp.receipt.sidebar.guide',
      'cataloghi': 'garanteasyApp.receipt.sidebar.catalogues',
      'warranty': 'garanteasyApp.receipt.sidebar.officialWarranties',
      'faq': 'garanteasyApp.receipt.sidebar.faq'
    };
    vm.data = {};

    vm.init = init;


    init();

    function init() {
      if (vm.nodes[$stateParams.node]) {
        vm.node = $stateParams.node;
      } else {
        return;
      }
      vm.id = $stateParams.id;
      if ($translate.use()) {
        vm.lang = $translate.use();
      }
      CmsService.getData(vm.lang, vm.node, vm.id).then(function (res) {
        if (res && res.attributes && res.attributes.body) {
          vm.data = res.attributes.body;
          vm.data.title = res.attributes.title;
          vm.data.id = res.id;
        }
      });
    }

  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('cms', {
      parent: 'account',
      url: '/cms/:node',
      data: {
        authorities: ['ROLE_USER'],
      },
      views: {
        'sidebar@': {
          templateUrl: 'app/entities/dashboard/sidebar-dashboard.html',
          controller: 'SidebarController',
          controllerAs: 'vm'
        },
        'content@': {
          templateUrl: 'app/cms/cms.html',
          controller: 'CmsController',
          controllerAs: 'vm'
        }
      },
      params: {
        // merchantCode: {
        //     value: 'GARANTEASY',
        //     squash: false
        // }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('register');
          $translatePartialLoader.addPart('merchant');
          $translatePartialLoader.addPart('accept-privacy');
          $translatePartialLoader.addPart('global');
          $translatePartialLoader.addPart('receipt');
          return $translate.refresh();
        }]
      }
    }).state('cms/detail', {
      parent: 'cms',
      url: '/:id',
      data: {
        authorities: ['ROLE_USER'],
      },
      views: {
        'sidebar@': {
          templateUrl: 'app/entities/dashboard/sidebar-dashboard.html',
          controller: 'SidebarController',
          controllerAs: 'vm'
        },
        'content@': {
          templateUrl: 'app/cms/cms-detail.html',
          controller: 'CmsDetailController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('register');
          $translatePartialLoader.addPart('merchant');
          $translatePartialLoader.addPart('accept-privacy');
          $translatePartialLoader.addPart('global');
          $translatePartialLoader.addPart('receipt');
          return $translate.refresh();
        }]
      }
    });
  }
})();
;
'use strict';
(function () {

  angular
    .module('garanteasyApp')
    .factory('CmsService', CmsService);

  CmsService.$inject = ['$http', 'CMS_URI', '$log', 'cmsViewMode'];

  function CmsService($http, CMS_URI, $log, cmsViewMode) {
    var service = {
      getCmsData: getCmsData,
      getShop: getShop,
      getNodeData: getNodeData,
      getData: getData,
      getLicenceData: getLicenceData,
      searchBrandFromCode: searchBrandFromCode,
      getBrandImageData: getBrandImageData,
      getBrandByCode: getBrandByCode,
      call: call
    };

    return service;

    function getNodes() {

    }
    function getCmsData(view, lang, pMerchantId) {
      var merchantId = pMerchantId || 'f58052e9-75c9-4320-bf40-2cbfaad1b86e';
      var uri;
      if (view == cmsViewMode.faq) {
        uri = CMS_URI + '/api/view/faq/BUSINESS/FAQ/all/' + (lang || 'it');
      }
      else if (view == cmsViewMode.advertising) {
        uri = CMS_URI + (lang || 'it') + '/api/view/merchant-advertising/' + merchantId;
      }
      else if (view == cmsViewMode.video) {
        uri = CMS_URI + (lang || 'it') + '/api/view/merchant-video/' + merchantId;
      }
      else if (view == cmsViewMode.docs) {
        uri = CMS_URI + (lang || 'it') + '/api/view/merchant-documents/' + merchantId;
      } else {
        uri = CMS_URI + (lang || 'it') + '/api/view/faq/merchant';
      }
      return $http.get(uri);
    }
    function getShop(lang, cmsReference) {
      var uri = CMS_URI + (lang || 'it') + '/api/view/shop/' + cmsReference;
      return $http.get(uri);
    }

    function getNodeData(lang, node, fields) {
      if (lang && node) {
        var uri = CMS_URI + lang + '/api/node/' + node + '?filter[destinatari.name]=Consumer';
        if (fields && fields.length) {
          uri += '&fields[node--' + node + ']=' + fields.join(',');
        }
        return call(uri);
      }
    }

    function getData(lang, node, id, fields) {
      if (lang && node && id) {
        var uri = CMS_URI + lang + '/api/node/' + node + '/' + id + '?filter[destinatari.name]=Consumer';
        if (fields && fields.length) {
          uri += '&fields[node--' + node + ']=' + fields.join(',');
        }
        return call(uri);
      }
    }

    function searchBrandFromCode(lang, code) {
      if (lang && code) {
        var uri = CMS_URI + lang + '/api/node/censimento_brand/?filter[code]=' + code;
        return call(uri);
      }
    }

    function getBrandImageData(lang, cmsBrandReference) {
      if (cmsBrandReference) {
        var uri = CMS_URI + lang + '/api/node/censimento_brand/' + cmsBrandReference + '/immagine_del_brand_completo';
        return call(uri);
      }
    }

    function getLicenceData(lang) {
      var uri = CMS_URI + lang + '/api/view/merchant/legal/GARANTEASY/INSTRUCTIONS/BUSINESS/ECOMMERCE_ONBOARDING/WORLD+IT/' + lang;
      console.log(uri);
      return call(uri).then(function (data) {
        var uniques = [];
        if (Array.isArray(data)) {
          data.forEach(function (licenseData) {
            var found = uniques.find(function (item) {
              return item.id === licenseData.id;
            });
            if (!found) {
              uniques.push(licenseData);
            }
          });
        }
        return uniques;
      });
    }

    function getBrandByCode(brandCode) {
      if (brandCode) {
        var uri = CMS_URI + 'api/view/brand-code/' + brandCode;
        return call(uri);
      }
    }


    function call(uri) {
      return $http.get(uri)
        .then(getData)
        .catch(error);

      function getData(response) {
        return response.data.data || response.data;
      }

      function error(error) {
        $log.error('XHR Failed for cms.' + error.data);
      }
    }

  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('remoteContent', remoteContent);

    remoteContent.$inject = ['$http'];

    function remoteContent($http) {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                $http.post('/endpoint', { format: 'html' })
                    .then(function (html) {
                        // remove wrapping html and body tags etc if necessary
                        angular.element(element).append(html);
                    })
                    .catch(function (data, status, headers, config) {
                        angular.element(element).append("<h1>Work in progress</h1>");
                    });
            }
        };
    }
})();
;
'use strict';
(function () {

  angular
    .module('garanteasyApp')
    .controller('CmsController', CmsController);


  CmsController.$inject = ['$state', '$stateParams', '$translate', 'CmsService', '$log', 'cmsViewMode', 'CMS_URI', '$sce', 'SelectedMerchantService'];

  function CmsController($state, $stateParams, $translate, CmsService, $log, cmsViewMode, CMS_URI, $sce, SelectedMerchantService) {
    var vm = this;

    vm.node = '';
    vm.lang = 'eng';

    vm.data = [];
    vm.init = init;
    vm.cmsViewMode = cmsViewMode;
    vm.CMS_URI = CMS_URI;
    function toDTO(element) {
      return {
        id: element.id,
        title: element.title,
        body: element.body,
        field_media_file: element.field_media_file,
        name: element.name
      };
    }
    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    }
    vm.loadData = function (node, lang, merchantId) {
      CmsService.getCmsData(node, lang, merchantId).then(function (res) {
        if (node == cmsViewMode.video) {
          res.data.map(function (element) {
            var c = element.field_media_video_embed_field;
            var start = c.indexOf('src="') + 5;
            var end = c.indexOf('"></iframe>');
            var s = c.substring(start, end);
            element.field_media_video_embed_field = s;
          });
        }
        vm.data = res.data;
      });
    };
    init();
    function init() {
      vm.node = $stateParams.node;
      if ($translate.use()) {
        vm.lang = $translate.use();
      }
      if (!SelectedMerchantService.merchant) {
        SelectedMerchantService.onMerchantChange(function (data) {
          vm.merchantId = data.cmsReference;
          vm.loadData(vm.node, vm.lang, vm.merchantId);
        });
      } else {
        vm.merchantId = SelectedMerchantService.merchant.cmsReference;
        vm.loadData(vm.node, vm.lang, vm.merchantId);
      }
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .constant('cmsViewMode', {
            'faq': 'faq',
            'advertising': 'advertising',
            'video': 'video',
            'docs': 'docs'
        });
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-garanteasyApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-garanteasyApp-params')});
            }
            return response;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))) {
                $rootScope.$emit('garanteasyApp.httpError', response);
                console.log("error intercepotr", response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401 && response.config.url.substr(0, 4) === 'api/') {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "it"');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('it');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $httpProvider.defaults.headers.common['X-Application-Context'] = 'garanteasy:partner-ui';

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(breadcrumb);

    breadcrumb.$inject = ['$breadcrumbProvider'];

    function breadcrumb($breadcrumbProvider) {
        // set below to true to make alerts look like toast
		$breadcrumbProvider.setOptions({
		  prefixStateName: 'home'
		});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
        'use strict';
        // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
        angular
            .module('garanteasyApp')
            		.constant('VERSION', "1.9.0")
		.constant('DEBUG_INFO_ENABLED', false)
		.constant('APPKEY', "58dd1674e73542b061f03fed54c1a11d8f0deb3ee5aed669a67ac5fdf51f7972")
		.constant('DEFAULT_BARCODE_ENCODING', "EAN13")
		.constant('API_URI', "https://api.garanteasy.com/")
		.constant('CMS_URI', "https://cms.garanteasy.com/")

            .config(['$sceDelegateProvider', function ($sceDelegateProvider) {
                $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                'self',
                // Allow loading from our assets domain. **.
                "https://api.garanteasy.com/" + '**'
            ])
          }])
    ;})();;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_USERPLUS', 'ROLE_ADMIN', 'ROLE_MERCHANT', 'MERCHANT_CHICCO', 'MERCHANT_CARMELAMAG'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'user-management.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management/new', {
                parent: 'user-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null, login: null, /*firstName: null, lastName: null,*/ email: null,
                                    activated: true, serviceConsent: true, commInfoConsent: null, commInfo3rdConsent: null,
                                    langKey: null, createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                    resetKey: null, authorities: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, { reload: true });
                    }, function () {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management/edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({ login: $stateParams.login });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management/delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({ login: $stateParams.login });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('UserManagementController', UserManagementController);

  UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

  function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
    var vm = this;

    vm.authorities = ['ROLE_USER', 'ROLE_USERPLUS', 'ROLE_ADMIN', 'ROLE_MERCHANT', 'MERCHANT_CHICCO', 'MERCHANT_CARMELAMAG'];
    vm.currentAccount = null;
    vm.languages = null;
    vm.loadAll = loadAll;
    vm.setActive = setActive;
    vm.users = [];
    vm.page = 1;
    vm.totalItems = null;
    vm.clear = clear;
    vm.links = null;
    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.transition = transition;

    vm.loadAll();

    JhiLanguageService.getAll().then(function (languages) {
      vm.languages = languages;
    });
    Principal.identity().then(function (account) {
      vm.currentAccount = account;
    });

    function setActive(user, isActivated) {
      user.activated = isActivated;
      User.update(user, function () {
        vm.loadAll();
        vm.clear();
      });
    }

    function loadAll() {
      User.query({
        page: pagingParams.page - 1,
        size: vm.itemsPerPage,
        sort: sort()
      }, onSuccess, onError);
    }

    function onSuccess(data, headers) {
      //hide anonymous user from user management: it's a required user for Spring Security
      for (var i in data) {
        if (data[i]['login'] === 'anonymoususer') {
          data.splice(i, 1);
        }
      }
      vm.links = ParseLinks.parse(headers('Link'));
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      vm.page = pagingParams.page;
      vm.users = data;
    }

    function onError(error) {
      AlertService.error(error.data.message);
    }

    function clear() {
      vm.user = {
        id: null, login: null, /*firstName: null, lastName: null, */email: null,
        activated: null, serviceConsent: true, commInfoConsent: null, commInfo3rdConsent: null,
        langKey: null, createdBy: null, createdDate: null,
        lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
        resetKey: null, authorities: null
      };
    }

    function sort() {
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'id') {
        result.push('id');
      }
      return result;
    }

    function loadPage(page) {
      vm.page = page;
      vm.transition();
    }

    function transition() {
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        search: vm.currentSearch
      });
    }
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('LogsService', LogsService);

  LogsService.$inject = ['$resource', 'API_URI'];

  function LogsService($resource, API_URI) {
    return $resource(API_URI + 'management/jhipster/logs', {}, {
      'findAll': {method: 'GET', isArray: true},
      'changeLevel': {method: 'PUT'}
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('import', {
            parent: 'admin',
            url: '/import',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'import.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/import/import.html',
                    controller: 'ImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('import');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ImportService', ImportService);

  ImportService.$inject = ['$resource', 'API_URI'];

  function ImportService($resource, API_URI) {
    var resourceUrl = API_URI + 'management/products-import/:id';
    return $resource(resourceUrl, {}, {
      'get': {method: 'GET'},
      'insert': {method: 'POST'}
    });
  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ImportController', ImportController);

    ImportController.$inject = ['$scope', '$rootScope', '$stateParams',  '$state','Principal', 'User', 'JhiLanguageService', 'DataUtils', 'ImportService', '$timeout'];

    function ImportController ($scope, $rootScope, $stateParams, Principal,  User, $state, JhiLanguageService, DataUtils, ImportService, $timeout) {
    	
        var vm = this;
        vm.process = null;
        vm.poll = true;
        
        var loopProcess = function(){
        	if(vm.poll){
        	$timeout(function(){
        		ImportService.get({id:1}, function(ret) {
        			vm.process = ret;
            		});
        		loopProcess();
        	},5000)
        }
        };
        
        loopProcess();
        
        vm.isInProcess = function(){
        	var ret = vm.process;
        	return ret && ret.progress != ret.total;
        		  	
        };
        
        vm.uploadFile = function ($file) {
        	vm.productImportResource = {};
            
            vm.byteSize = DataUtils.byteSize;
            vm.openFile = DataUtils.openFile;
            vm.fileTooLarge = false;
                if ($file && $file.$error === 'pattern') {
                    return;
                }
                if ($file) {
                	
                        vm.fileTooLarge = false;
    	                DataUtils.toBase64($file, function(base64Data) {
    	                    $scope.$apply(function() {
    	                    	vm.productImportResource.description = $file.name;
    	                    	vm.productImportResource.fileData = base64Data;
    	                    	vm.productImportResource.contentType = $file.type;
    	                    	ImportService.insert(vm.productImportResource)
    	                    });
    	                });
                	
                	
                }
        };
        
        
        
        vm.widthProgress = function(){
        	return 'width: 80%';
        }
    $scope.$on('$destroy', function(event, next, current) {
    	vm.poll = false;
    });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    $translatePartialLoader.addPart('receipt');
                    $translatePartialLoader.addPart('paymentType');
                    $translatePartialLoader.addPart('dataSource');
                    $translatePartialLoader.addPart('warranty');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('receiptType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('garanteasyApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex/dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ElasticsearchReindex', ElasticsearchReindex);

  ElasticsearchReindex.$inject = ['$resource', 'API_URI'];

  function ElasticsearchReindex($resource, API_URI) {
    return $resource(API_URI + 'api/elasticsearch/index', {}, {
      'reindex': {method: 'POST'}
    });
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('AuditsService', AuditsService);

  AuditsService.$inject = ['$resource', 'API_URI'];

  function AuditsService($resource, API_URI) {
    return $resource(API_URI + 'management/jhipster/audits/:id', {}, {
      'get': {
        method: 'GET',
        isArray: true
      },
      'query': {
        method: 'GET',
        isArray: true,
        params: {fromDate: null, toDate: null}
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('AuditsController', AuditsController);

  AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

  function AuditsController($filter, AuditsService, ParseLinks) {
    var vm = this;

    vm.audits = null;
    vm.fromDate = null;
    vm.links = null;
    vm.loadPage = loadPage;
    vm.onChangeDate = onChangeDate;
    vm.page = 1;
    vm.previousMonth = previousMonth;
    vm.toDate = null;
    vm.today = today;
    vm.totalItems = null;

    vm.today();
    vm.previousMonth();
    vm.onChangeDate();

    function onChangeDate() {
      var dateFormat = 'yyyy-MM-dd';
      var fromDate = $filter('date')(vm.fromDate, dateFormat);
      var toDate = $filter('date')(vm.toDate, dateFormat);

      AuditsService.query({
        page: vm.page - 1,
        size: 20,
        fromDate: fromDate,
        toDate: toDate
      }, function (result, headers) {
        vm.audits = result;
        vm.links = ParseLinks.parse(headers('Link'));
        vm.totalItems = headers('X-Total-Count');
      });
    }

    // Date picker configuration
    function today() {
      // Today + 1 day - needed if the current day must be included
      var today = new Date();
      vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    }

    function previousMonth() {
      var fromDate = new Date();
      if (fromDate.getMonth() === 0) {
        fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
      } else {
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
      }

      vm.fromDate = fromDate;
    }

    function loadPage(page) {
      vm.page = page;
      vm.onChangeDate();
    }
  }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('SocialAuthController', SocialAuthController);

    SocialAuthController.$inject = ['$state', '$cookies', 'Auth'];

    function SocialAuthController($state, $cookies, Auth) {
        var token = $cookies.get('social-authentication');

        Auth.loginWithToken(token, false).then(function () {
            $cookies.remove('social-authentication');
            Auth.authorize(true);
        }, function () {
            $state.go('social-register', {'success': 'false'});
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'social.register.title'
            },
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-auth', {
            parent: 'account',
            url: '/social-auth',
            data: {
                authorities: [],
            },
            views: {
                'content@': {
                    controller: 'SocialAuthController'
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .factory('SocialService', SocialService);

    function SocialService () {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            /* globals document */
            var name = 'CSRF-TOKEN=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) !== -1) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('settings', {
                parent: 'account',
                url: '/settings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.settings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/settings.html',
                        controller: 'SettingsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('contact');
                        $translatePartialLoader.addPart('phoneNumber');
                        $translatePartialLoader.addPart('card');
                        return $translate.refresh();
                    }]
                }
            })
            .state('settings-customer-new', {
                parent: 'settings',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    legalName: null,
                                    birthDate: null,
                                    vatid: null,
                                    business: false,
                                    gender: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('settings');
                    });
                }]
            })
            .state('settings-customer-edit', {
                parent: 'settings',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-dialog.html',
                        controller: 'CustomerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-customer-delete', {
                parent: 'settings',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                        controller: 'CustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Customer', function (Customer) {
                                return Customer.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-contact-new', {
                parent: 'settings',
                url: '/newContact',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-dialog.html',
                        controller: 'ContactDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    channel: null,
                                    primaryContact: false,
                                    activated: false,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('settings');
                    });
                }]
            })
            .state('settings-contact-edit', {
                parent: 'settings',
                url: '/{id}/editContact',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-dialog.html',
                        controller: 'ContactDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Contact', function (Contact) {
                                return Contact.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-contact-delete', {
                parent: 'settings',
                url: '/{id}/deleteContact',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/contact/contact-delete-dialog.html',
                        controller: 'ContactDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Contact', function (Contact) {
                                return Contact.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-card-new', {
                parent: 'settings',
                url: '/newCard',
                data: {

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-dialog.html',
                        controller: 'CardDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    number: null,
                                    activationDate: null,
                                    expirationDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('settings', $stateParams, {
                            reload: 'settings', inherit: false, notify: true
                        });
                    }, function () {
                        $state.go('settings');
                    });
                }]
            })
            .state('settings-card-edit', {
                parent: 'settings',
                url: '/{id}/editCard',
                data: {

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-dialog.html',
                        controller: 'CardDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-card-delete', {
                parent: 'settings',
                url: '/{id}/deleteCard',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-delete-dialog.html',
                        controller: 'CardDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Card', function (Card) {
                                return Card.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-phone-number-new', {
                parent: 'settings',
                url: '/newPhoneNumber',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/phone-number/phone-number-dialog.html',
                        controller: 'PhoneNumberDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    phoneNumber: null,
                                    activated: false,
                                    activationKey: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('settings');
                    });
                }]
            })
            .state('settings-phone-number-edit', {
                parent: 'settings',
                url: '/{id}/editPhoneNumber',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/phone-number/phone-number-dialog.html',
                        controller: 'PhoneNumberDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PhoneNumber', function (PhoneNumber) {
                                return PhoneNumber.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('settings-phone-number-delete', {
                parent: 'settings',
                url: '/{id}/deletePhoneNumber',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/phone-number/phone-number-delete-dialog.html',
                        controller: 'PhoneNumberDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PhoneNumber', function (PhoneNumber) {
                                return PhoneNumber.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            }).state('settings/card-requestUse', {
                parent: 'settings',
                url: '/requestUseCard',
                params: { dataCard: null, card: null },
                ncyBreadcrumb: {
                    skip: true // Never display this state in breadcrumb.
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/card/card-request-use-card-dialog.html',
                        controller: 'CardRequestUseController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                    legalName: null,
                                    birthDate: null,
                                    vatid: null,
                                    business: false,
                                    gender: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('settings', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });

    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'Customer', 'Contact', 'PhoneNumber', 'JhiLanguageService', '$translate', 'Card'];

    function SettingsController (Principal, Auth, Customer, Contact, PhoneNumber, JhiLanguageService, $translate, Card) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.customers = [];
        vm.contacts = [];
        vm.phoneNumbers = [];
        vm.cards = [];

        vm.isOwner=null;
        vm.isAdmin=null;

        checkAccess();

        function checkAccess() {
            Principal.hasAuthority('ROLE_ADMIN').then(function (result) {
                if (result) {
                    vm.isAdmin=true;
                } else {
                    vm.isAdmin=false;
                    }
                });
        }


        loadCustomers();
        loadContacts();
        loadPhoneNumbers();
        loadCards();

        function loadCustomers() {
            Customer.query(function(result) {
                vm.customers = result;
            });
        }

        function loadContacts() {
            Contact.query(function(result) {
                vm.contacts = result;
            });
        }

        function loadPhoneNumbers() {
            PhoneNumber.query(function(result) {
                vm.phoneNumbers = result;
            });
        }

        function loadCards() {
            Card.query(function(result) {
                vm.cards = result;
            });
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                serviceConsent: account.serviceConsent,
                commInfoConsent: account.commInfoConsent,
                commInfo3rdConsent: account.commInfo3rdConsent,
                /*
                firstName: account.firstName,
                lastName: account.lastName,
                */
                langKey: account.langKey,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        vm.isOwner = function(card) {
            var ret = false;
            var account = Principal.identity();
               if(card.contact && card.contact.user && account && account.$$state && account.$$state.value && account.$$state.value.id)
                   ret = card.contact.user.id == account.$$state.value.id;
            return ret;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', '$location','$log'];

    function RequestResetController($timeout, Auth, $location, $log) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        $log.debug('$location.search()', $location.search());
        if (($location.search() || {}).username) {
            vm.resetAccount.email = $location.search().username;
        }
        $timeout(function () { angular.element('#email').focus(); });

        function requestReset() {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('MerchantRegistrationController2', MerchantRegistrationController2);


  MerchantRegistrationController2.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', '$location', '$filter', '$state', 'MerchantRegistration', '$scope', 'AlertService'];

  function MerchantRegistrationController2($translate, $timeout, Auth, LoginService, $location, $filter, $state, MerchantRegistration, $scope, AlertService) {
    var vm = this;
    vm.doNotMatch = null;
    vm.error = null;
    vm.errorUserExists = null;
    vm.errorServiceConsent = null;
    vm.merchantRegistration = {};
    vm.merchantRegistration.operators = [{}];
    vm.success = null;
    vm.error = false;
    vm.save = save;
    vm.isValidInput = isValidInput;
    vm.merchantRegistration.webSite = false;
    vm.merchantRegistration.eCommerce = false;
    vm.merchantRegistration.questionPhone = true;
    vm.merchantRegistration.questionMail = true;

    if ($state.operators) {
      vm.merchantRegistration.operators = $state.operators;
    }
    if ($location.search().merchantCode) {
      vm.merchantCode = $location.search().merchantCode.toUpperCase();
    } else {
      vm.merchantCode = 'GARANTEASY';
    }

    $timeout(function () { angular.element('#login').focus(); });

    $scope.loadCategories = function (searchQuery) {
      if (searchQuery && searchQuery.trim().length > 1) {
        MerchantRegistration.searchCategories({ query: searchQuery }, onLoadCategoriesSuccess, onLoadCategoriesError)
      }
    };

    function onLoadCategoriesSuccess(result) {
      $scope.categories = result;
    }

    function onLoadCategoriesError(result) {

    }

    $scope.resetCategory = function () {
      vm.merchantRegistration.category = null;
    }


    $scope.resetMerchant = function () {
      vm.merchantRegistration.merchant = null;
    }

    $scope.loadMerchants = function (searchQuery) {
      if (searchQuery) {
        MerchantRegistration.searchMerchant({ query: searchQuery }, onLoadSuccess, onLoadError);
      }
    };

    function onLoadSuccess(result) {
      $scope.merchants = result;
    }

    function onLoadError(error) {
      AlertService.error(error.data.message);
    }


    $scope.resetShop = function () {
      vm.merchantRegistration.shop = null;
    }

    $scope.loadShops = function (searchQuery) {
      if (searchQuery) {
        MerchantRegistration.searchShop({ merchant_id: vm.merchantRegistration.merchant.id, query: searchQuery }, function (result) {
          $scope.shops = result;
        }
          /*, function(response) {
              if(response.status === 404) {
                  $scope.shops = Shop.query({isActive: true});
              }
          };*/
        );
      }
      /*else {
          $scope.shops = Shop.query({isActive: true});
      }*/
    };

    function onGetCodeSuccess(result) {
      vm.merchantRegistration.merchant.code = result.code;
      if (vm.merchantRegistration.operators[0] != null && vm.merchantRegistration.operators[0].name != null) {
        vm.merchantRegistration.operators[0].type = 'REFERENT';
      }
      if (vm.merchantRegistration.operators[1] != null && vm.merchantRegistration.operators[1].name != null) {
        vm.merchantRegistration.operators[1].type = 'OPERATING_REFERENT';
      }
      MerchantRegistration.save(vm.merchantRegistration, onSaveSuccess, onSaveError);
    }

    function onGetCodeError(error) {
      vm.error = error;
    }

    function save() {
      if (vm.merchantRegistration.merchant.email && vm.merchantRegistration.shop) {
        vm.merchantRegistration.shop.email = vm.merchantRegistration.merchant.email;
      }
      if (vm.merchantRegistration.merchant.phoneNumber && vm.merchantRegistration.merchant.shop) {
        vm.merchantRegistration.shop.phoneNumber = vm.merchantRegistration.merchant.phoneNumber;
      }
      if (vm.merchantRegistration.merchant.phoneNumber && vm.merchantRegistration.merchant.shop) { vm.merchantRegistration.shop.phoneNumber = vm.merchantRegistration.merchant.phoneNumber; }
      if (vm.category) {
        vm.merchantRegistration.merchant.categories = [];
        vm.merchantRegistration.merchant.categories[0] = vm.category;
      }


      if (angular.isUndefined(vm.merchantRegistration.shop)) {
        vm.error = true;
        $translate("merchantRegister2.error.shopRequired").then(function (t) {
          vm.errorMessage = t;
        });
      } else {
        // se id --> null sto creando un nuovo merchant e devo generare il code
        if (vm.merchantRegistration.merchant.id == null) {
          MerchantRegistration.getCode(vm.merchantRegistration.merchant, onGetCodeSuccess, onGetCodeError);
        } else {
          MerchantRegistration.save(vm.merchantRegistration, onSaveSuccess, onSaveError);
        }
      }
    }

    function onSaveSuccess(result) {
      $translate("merchantRegister2.saveSuccess").then(function (t) {
        $state.messageSave = t;
      });
      vm.isSaving = false;
      $state.go('home');
    }

    function onSaveError(error) {
      vm.error = true;
      if (error.headers()['x-garanteasyapp-error']) {
        var errorType = error.headers()['x-garanteasyapp-error'];
        $translate("merchantRegister2." + errorType).then(function (t) {
          vm.errorMessage = t;
        });
      } else {
        $translate("merchantRegister2.error.genericSaveError").then(function (t) {
          vm.errorMessage = t;
        });
      }
    }

    function isValidInput() {
      if (vm.merchantRegistration.merchant && vm.merchantRegistration.merchant.companyName && vm.merchantRegistration.merchant.vatCode) {
        if (vm.merchantRegistration.operators.length > 0) {
          return true;
        }
      }
    }


  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'content@': {
                    templateUrl: 'app/account/merchantRegistration/merchantRegistration.html',
                    controller: 'MerchantRegistrationController',
                    controllerAs: 'vm'
                }
            },
            params:{
                merchantCode: {
                    value: 'GARANTEASY',
                    squash: false
                }
            },
            resolve: {
                pagingParams: ['$state', function ($state) {
                    return {
                        operators: $state.operators
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('merchantRegister');
                    $translatePartialLoader.addPart('merchant');
                    return $translate.refresh();
                }]
            }
        }).state('merchantRegister2', {
            parent: 'account',
            url: '/merchantRegister2',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'content@': {
                    templateUrl: 'app/account/merchantRegistration/merchantRegistration2.html',
                    controller: 'MerchantRegistrationController2',
                    controllerAs: 'vm'
                }
            },
            params:{
                merchantCode: {
                    value: 'GARANTEASY',
                    squash: false

                }
            },
            resolve: {
                pagingParams: ['$state', function ($state) {
                    return {
                        operators: $state.operators
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('merchantRegister');
                    $translatePartialLoader.addPart('merchant');
                    return $translate.refresh();
                }]
            }
        }).state('getLicenceData', {
          parent: 'account',
          url: '/license',
          data: {
              authorities: [],
              pageTitle: 'register.title'
          },
          views: {
              'sidebar@': {
                  templateUrl: 'app/layouts/sidebar/sidebar-none.html',
                  controller: 'SidebarController',
                  controllerAs: 'vm'
              },
              'content@': {
                  templateUrl: 'app/account/merchantRegistration/licenseRegistration.html',
                  controller: 'LicenseRegistrationController',
                  controllerAs: 'vm'
              }
          },
          params:{
              merchantCode: {
                  value: 'GARANTEASY',
                  squash: false

              }
          },
          resolve: {
              pagingParams: ['$state', function ($state) {
                  return {
                      operators: $state.operators
                  };
              }],
              translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                  $translatePartialLoader.addPart('register');
                  $translatePartialLoader.addPart('merchantRegister');
                  $translatePartialLoader.addPart('merchant');
                  return $translate.refresh();
              }]
          }
      });
    }
})();
;
(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('MerchantRegistration', MerchantRegistration);

  MerchantRegistration.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function MerchantRegistration($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + '/api/merchant-register/:id';

    return $resource(resourceUrl, {}, {
      'searchCategories': {
        url: API_URI + 'api/merchant-register/categories/search',
        method: 'GET',
        isArray: true
      },
      'searchShop': {
        url: API_URI + 'api/merchant-register/shop/search/:merchant_id',
        method: 'GET',
        isArray: true
      },
      'searchMerchant': {
        url: API_URI + 'api/merchant-register/merchant/search',
        method: 'GET',
        isArray: true,
        transformResponse: function (data, headers) {
          var response = {};
          response = angular.fromJson(data);
          return response;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          if (dataToSend.activationDate) {
            dataToSend.activationDate = DateUtils.convertLocalDateToServer(dataToSend.activationDate);
          }
          if (dataToSend.expirationDate) {
            dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          }
          return angular.toJson(dataToSend);
        }
      },
      'getCode': {
        method: 'POST',
        url: API_URI + 'api/merchant-register/merchant/code',
        transformResponse: function (data, headers) {
          var response = {};
          response = angular.fromJson(data);
          return response;
        }
      },
      'saveRequired': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          return angular.toJson(dataToSend);

        },
        transformResponse: function (data, headers) {
          var response = {};
          response = angular.fromJson(data);
          return response;
        }
      }
    });
  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('MerchantRegistrationController', MerchantRegistrationController);


  MerchantRegistrationController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', '$location', '$filter', '$state', 'MerchantRegistration', '$scope'];

  function MerchantRegistrationController($translate, $timeout, Auth, LoginService, $location, $filter, $state, MerchantRegistration, $scope) {
    var vm = this;
    vm.doNotMatch = null;
    vm.error = null;
    vm.errorUserExists = null;
    vm.errorServiceConsent = null;
    vm.next = next;
    vm.merchantRegistration = {};
    vm.merchantRegistration.sameReferent = true;
    vm.merchantRegistration.merchant = {};
    vm.merchantRegistration.shop = {};
    vm.merchantRegistration.operators = [{}];
    vm.merchantRegistration.operators[0].role = 'OWNER';
    vm.merchantRegistration.operators[0].role = 'MANAGER';
    vm.success = null;
    var owner = $translate("merchantRegister.form.roleOwner").then(function (t) {
      var x = t;
      $translate("merchantRegister.form.roleManager").then(function (t) {
        var y = t;
        $translate("merchantRegister.form.roleEmployee").then(function (t) {
          var z = t;
          vm.roles = { 'OWNER': x, 'MANAGER': y, 'EMPLOYEE': z }
        })
      })
    })

    $translate("merchantRegister.form.referent").then(function (t) {
      vm.referent = t;
    })
    $translate("merchantRegister.form.operatingReferent").then(function (t) {
      vm.operatingReferent = t;
    })

    // vm.params = pagingParams.operators;
    /*if($state.operators){
        vm.merchantRegistration.operators = $state.operators;
    }*/
    if ($location.search().merchantCode) {
      vm.merchantCode = $location.search().merchantCode.toUpperCase();
    } else {
      vm.merchantCode = 'GARANTEASY';
    }

    $timeout(function () { angular.element('#login').focus(); });


    $scope.resetCategory = function () {
      vm.merchantRegistration.category = null;
    }


    $scope.resetMerchant = function () {
      vm.merchantRegistration.merchant = null;
    }

    $scope.loadMerchants = function (searchQuery) {
      if (searchQuery) {
        MerchantRegistration.searchMerchant({ query: searchQuery }, function (result) {
          $scope.merchants = result;
        }
          /*, function(response) {
              if(response.status === 404) {
                  $scope.merchants = Merchant.query({isActive: true});
              }
          }*/
        );
      }
      /*else {
          $scope.merchants = Merchant.query({isActive: true});
      }*/
    };


    $scope.resetShop = function () {
      vm.merchantRegistration.shop = null;
    }

    $scope.loadShops = function (searchQuery) {
      if (searchQuery) {
        MerchantRegistration.searchShop({ merchant_id: vm.merchantRegistration.merchant.id, query: searchQuery }, function (result) {
          $scope.shops = result;
        }
          /*, function(response) {
              if(response.status === 404) {
                  $scope.shops = Shop.query({isActive: true});
              }
          };*/
        );
      }
      /*else {
          $scope.shops = Shop.query({isActive: true});
      }*/
    };

    function next() {
      vm.merchantRegistration.langKey = $translate.use();
      if (vm.merchantRegistration.operators && vm.merchantRegistration.operators.length > 1) {
        vm.merchantRegistration.operators[1].type = vm.operatingReferent;
      }
      if (vm.merchantRegistration.operators && vm.merchantRegistration.operators.length > 0) {
        vm.merchantRegistration.operators[0].type = vm.referent;
      }
      $state.operators = vm.merchantRegistration.operators;
      vm.doNotMatch = null;
      vm.error = null;
      vm.errorUserExists = null;
      vm.errorEmailExists = null;
      vm.errorServiceConsent = null;
      $state.go('merchantRegister2');
      /*Auth.createAccount(vm.registerAccount).then(function () {
          vm.success = 'OK';
      }).catch(function (response) {
          vm.success = null;
          if (response.status === 400 && response.data === 'login already in use') {
              vm.errorUserExists = 'ERROR';
          } else if (response.status === 400 && response.data === 'e-mail address already in use') {
              vm.errorEmailExists = 'ERROR';
          } else if (response.status === 400 && response.data === 'service consent mandatory') {
              vm.errorServiceConsent = 'ERROR';
          } else {
              vm.error = 'ERROR';
          }
      });*/
    }


    /* OPERATORS --> array
    {
        langKey: string -> optional lingua size(2) (it/en...)
        name: string → required, min(3)
        surname: string → required, min(3)
        email: string →  required
        phoneNumber: string → required
        role: string → optional
        type: string → required, 'REFERENT' or 'OPERATING_REFERENT'
    }*/



  }
})();
;
(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .controller('LicenseRegistrationController', LicenseRegistrationController);


  LicenseRegistrationController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', '$location', '$filter', '$state', 'CmsService', '$scope', 'AlertService', 'SelectedMerchantService'];

  function LicenseRegistrationController($translate, $timeout, Auth, LoginService, $location, $filter, $state, CmsService, $scope, AlertService, SelectedMerchantService) {
    var vm = this;
    vm.lang = 'eng';
    vm.textSellCondition = '';
    vm.textPrivacyCondition = '';
    vm.merchantRegistration = {};
    vm.merchantRegistration.operators = [{}];
    vm.merchantCode = null;
    vm.copyToCliboard = copyToCliboard;
    vm.save = save;
    vm.model = {
      get merchant() {
          return SelectedMerchantService.merchant;
      },
      set merchant(item) {
          return SelectedMerchantService.merchant = item;
      },
      get shop() {
          return SelectedMerchantService.shop;
      },
      set shop(item) {
          return SelectedMerchantService.shop = item;
      }
  };

    init();

    if ($state.operators) {
      vm.merchantRegistration.operators = $state.operators;
    }
    if ($location.search().merchantCode) {
      vm.merchantCode = $location.search().merchantCode.toUpperCase();
    } else {
      vm.merchantCode = 'GARANTEASY';
    }

    function init() {
      if ($translate.use()) {
        vm.lang = $translate.use();
      }
      CmsService.getLicenceData(vm.lang).then(function (res) {
        if (res && Array.isArray(res)) {
          res.forEach(function (item) {
            if (typeof item.title === 'string' && item.title.toLowerCase().indexOf('vendita') !== -1) {
              vm.textSellCondition = item.body;
            }
            if (typeof item.title === 'string' && item.title.toLowerCase().indexOf('privacy') !== -1) {
              vm.textPrivacyCondition = item.body;
            }
          });
        }
        console.log(vm);
      });
    }

    function copyToCliboard(copyText) {
      var div = document.createElement("div");
      div.innerHTML = copyText;
      var text = div.textContent || div.innerText || "";

      var el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

    }

    function save() {

    }


  }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('EmailActivationController', EmailActivationController);

    EmailActivationController.$inject = ['$stateParams', 'Auth'];

    function EmailActivationController ($stateParams, Auth) {
        var vm = this;
        vm.contact = null;

        Auth.activateEmail({key: $stateParams.key}).then(function (result) {
            vm.error = null;
            vm.contact = result;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('activateEmail', {
            parent: 'account',
            url: '/activateEmail?key',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'activate.email.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.email.html',
                    controller: 'EmailActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }

})();
;
(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module('garanteasyApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/cms/cms-detail.html','<div class="register"><h1 class="main-title">{{vm.data.title}}</h1><div class="row"><div class="col-xs-12"><div ng-bind-html="vm.data.processed"></div></div></div></div>');
$templateCache.put('app/cms/cms.html','<div class="register"><h4 translate="garanteasyApp.sidebar.{{vm.node}}">Titolo</h4><div ng-if="vm.node == vm.cmsViewMode.faq"><div ng-repeat="content in vm.data track by $index"><div class="row"><div class="col-xs-12"><hr class="hr-green"><div><strong style="font-size: large" class="rdetail-font-size" ng-bind-html="content.title"></strong></div><div ng-bind-html="content.body"></div></div></div></div></div><div ng-if="vm.node == vm.cmsViewMode.video"><div class="row" ng-repeat="content in vm.data track by $index"><div><h3>{{ content.name }}</h3><div class="video-embed-field-provider-youtube video-embed-field-responsive-video"><iframe width="854" height="480" frameborder="0" allowfullscreen="allowfullscreen" src="{{ vm.trustSrc(content.field_media_video_embed_field) }}"></iframe></div></div></div></div><div ng-if="vm.node == vm.cmsViewMode.advertising || vm.node == vm.cmsViewMode.docs"><div class="row" ng-repeat="content in vm.data track by $index"><div><a target="_new" href="{{vm.CMS_URI + content.field_media_file}}"><h3><i class="fas fa-file-pdf"></i>&nbsp; {{ content.name }}</h3></a></div></div></div><div class="row faq-box"><p>Le risposte che trovi nelle FAQ di Garanteasy sono frutto della attivit\xE0 di esperti interni, ma non possono tenere conto delle molte possibili scelte strategiche e metodologiche dei Venditori e dei Produttori. Queste risposte hanno perci\xF2 esclusivamente una funzione di indirizzo, permettendo all\u2019Utente di avere le prime indicazioni generali.</p><p>Le risposte rappresentano le soluzioni che forniscono le normative sul Consumo e ove esse siano mancanti, gli usi e le prassi del settore commerciale. Garanteasy perci\xF2 non si assume alcuna responsabilit\xE0 relativamente a contestazioni che possano nascere dalla applicazione delle risposte alle FAQ ai casi concreti. Gli esperti interni di Garanteasy ricordano che, per la risoluzione dei singoli casi concreti \xE8 necessario rifarsi alla Normativa in vigore e alla documentazione ufficiale di Garanzia emessa da Venditori e Produttori.</p></div></div>');
$templateCache.put('app/home/home.html','<div class="col-md-10 col-lg-11"><div class="alert alert-danger" ng-if="vm.authenticationError && vm.show" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div class="row"><div ng-class="{\n        \'ge-divider\': vm.showRegisterForm,\n        \'col-md-10\': !vm.showRegisterForm,\n        \'col-md-5\': vm.showRegisterForm\n      }"><div class="row"><div class="col-xs-12"><h1 class="main-title" translate="login.title">Sign in</h1><div class="form-group"><input type="text" class="form-control" id="username" ng-click="vm.closeAlert()" placeholder="{{\'global.form.usernamePlaceholder\' | translate}}" ng-model="vm.username" tabindex="1"></div><div class="form-group"><input type="password" class="form-control" id="password" ng-click="vm.closeAlert()" placeholder="{{\'login.form.passwordPlaceholder\' | translate}}" ng-model="vm.password" tabindex="2"></div></div></div><div class="row"><div class="col-xs-12"><button ng-click="vm.login()" class="btn btn-default-green btn-md" translate="login.form.button">Sign in</button></div><!-- <div class="col-xs-7">\n                    <div class="form-group">\n                        <label for="rememberMe">\n                            <input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" tabindex="3" checked>\n                            <span translate="login.form.rememberme">Remember me</span>\n                        </label>\n                    </div>\n                </div> --></div><div class="row"><div class="col-xs-12"><br><a href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div></div></div><div class="col-md-5" ng-if="vm.showRegisterForm"><div class="row"><div class="col-xs-12"><h1 class="main-title" translate="global.messages.info.register">Registrati</h1></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-default dark btn-block" translate="global.messages.info.merchantRegister" ng-click="vm.merchantRegister()">Register a new Merchant account</button><p>&nbsp;</p></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><jh-social ng-provider="facebook"></jh-social></div></div><div class="col-lg-6"><div class="form-group"><jh-social ng-provider="google"></jh-social></div></div></div></div></div></div>');
$templateCache.put('app/home/sidebar-home.html','<div class="page"><div class="row-fluid"><div class="sidebar-left"><div style="position: relative; z-index: 30" class="sidebar-block sidebar-menu"><h4 class="block-title">Area personale</h4><ul class="side-menu"><li><a href="#/receipt" translate="garanteasyApp.receipt.home.title">Archivio ricevute, scontrini e fatture</a></li><li><a href="#/purchased-product" translate="garanteasyApp.receipt.sidebar.purchasedProduct">Archivio prodotti acquistati</a></li><li><a href="#/shop" translate="garanteasyApp.receipt.sidebar.shops">Negozi dove hai fatto acquisti</a></li><li><a ui-sref="receipt/new" href="#" translate="garanteasyApp.receipt.sidebar.newReceipt">Archivia nuova ricevuta, scontrino o fattura</a></li><li><a href="#/settings" translate="garanteasyApp.receipt.sidebar.profile">Modifica o completa il tuo profilo</a></li><li><a href="/contatti-2" translate="garanteasyApp.receipt.sidebar.support">Chiedi supporto</a></li></ul></div></div></div></div>');
$templateCache.put('app/account/activate/activate.email.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.email.title">Email activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.email.success" translate-values="{email: \'{{vm.contact.channel}}\'}"><strong>Email email@address.com has been activated.</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.email.error"><strong>Email could not be activated.</strong></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/merchantRegistration/licenseRegistration.html','<div class="register"><div class="col-md-offset-1"><div class="col-md-8 form-group"><h1 class="main-title" translate="merchantRegister.title">Registration</h1><h3 translate="merchantRegister2.subtitle3" style="margin-top: 30px"></h3><div uib-alert type="danger" ng-show="vm.error" close="vm.error = false">{{vm.errorMessage}}</div></div><form class="col-md-8" ng-show="!vm.success" name="licenseForm" role="form" novalidate ng-submit="vm.save()"><div class="col-xs-12 margin-top-4"><div class="privacyConsents form-group panel-default"><label for="privacyUrl" translate="merchantRegister2.formPrivacy.labelSellConditions">Testo da aggiungere alla Condizione di Vendita</label><!-- FIRST LICENCE--><div #clipboardmerchant class="panel-body legalese-privacy col-xs-12" ng-click="vm.copyToCliboard(vm.textSellCondition)" ng-bind-html="vm.textSellCondition">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div><button type="button" class="btn btn-light margin-top-1 pull-right" ng-click="vm.copyToCliboard(vm.textSellCondition)">Copia</button></div></div><div class="col-xs-12"><div class="form-group"><label for="termsOfSaleUrl" translate="merchantRegister2.formPrivacy.sellConditionsUrl">Link alla pagina del sito con l\'informativa sulle condizioni di vendita in cui \xE8 stato inserito il testo riguardante Garanteasy</label><input ng-model="vm.merchantRegistration.termsOfSaleUrl" type="text" class="form-control" id="termsOfSaleUrl" placeholder="Inserire url" ng-pattern="/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/" required></div></div><div class="col-xs-12 margin-top-4"><div class="privacyConsents form-group panel-default"><label for="privacyUrl" translate="merchantRegister2.formPrivacy.labelPrivacy">Testo da aggiungere all\'informativa sulla privacy</label><div #clipboardprivacy class="panel-body legalese-privacy col-xs-12" ng-click="vm.copyToCliboard(vm.textPrivacyCondition)" ng-bind-html="vm.textPrivacyCondition">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div><button type="button" class="btn btn-light margin-top-1 pull-right" ng-click="vm.copyToCliboard(vm.textPrivacyCondition)">Copia</button></div></div><div class="col-xs-12"><div class="form-group"><label for="privacyUrl" translate="merchantRegister2.formPrivacy.privacyUrl">Link alla pagina del sito con l\'informativa sulla privacy in cui \xE8 stato inserito il testo rigurdante Garanteasy</label><input ng-model="vm.merchantRegistration.privacyUrl" type="text" class="form-control" id="privacyUrl" placeholder="Inserire url" ng-pattern="/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)?/" required></div></div><div class="col-xs-12"><div class="form-group"><label for="privacyPhoneNumber" translate="merchantRegister2.formPrivacy.privacyPhone">Telefono per richiedere informazioni sulla gestione della privacy</label><input ng-model="vm.merchantRegistration.privacyPhoneNumber" type="text" class="form-control" id="privacyPhoneNumber" placeholder="Inserire telefono" ng-pattern="/^\\+?[0-9]{9,13}$/" required></div></div><div class="col-xs-12"><div class="form-group"><label for="privacyEmail" translate="merchantRegister2.formPrivacy.emailPrivacy">Indirizzo email per richiedere informazione sulla gestione della privacy</label><input type="email" ng-model="vm.merchantRegistration.privacyEmail" class="form-control" id="privacyEmail" placeholder="Inserire indirizzo email" required></div></div><!-- <div class="col-md-8 form-group">\n            {{vm.merchantRegistration}}\n            </div>--><div class="col-md-8 form-group" style="margin-top: 30px; float: right"><button type="submit" ng-disabled="licenseForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div>');
$templateCache.put('app/account/merchantRegistration/merchantRegistration.html','<div class="register"><div class="col-md-offset-1"><div class="col-md-7 form-group"><h1 class="main-title" translate="merchantRegister.title">Registration</h1><h3 translate="merchantRegister.subtitle" style="margin-top: 30px"></h3><h3 ng-show="vm.success" translate="merchantRegister.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</h3><h4 ng-show="vm.success" translate="merchantRegister.messages.checkYourMail">Registration saved! Please check your email for confirmation.</h4></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.next()" show-validation><div class="col-md-7 form-group"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.passwordPlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[0].password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.merchantRegistration.operators[0].password"></password-strength-bar></div><div class="col-md-7 form-group"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpasswordPlaceholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="col-md-7 form-group"><label translate="merchantRegister.form.sameReferent"></label><span style="float: right"><input type="checkbox" class="checkbox-inline" id="sameReferent" name="sameReferent" ng-model="vm.merchantRegistration.sameReferent"></span></div><div class="col-md-7 form-group"><select class="form-control" id="roleReferent" name="roleReferent" ng-model="vm.merchantRegistration.operators[0].role" ng-options="role as role for role in vm.roles" required><option value="" disabled="disabled" selected="selected">{{\'global.form.rolePlaceholder\' | translate}}</option></select></div><div class="col-md-7 form-group"><input type="text" class="form-control" id="nameReferent" name="nameReferent" placeholder="{{\'global.form.namePlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[0].name" ng-maxlength="100" required><div ng-show="form.nameReferent.$dirty && form.nameReferent.$invalid"><p class="help-block" ng-show="form.nameReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div><div class="col-md-7 form-group"><input type="text" class="form-control" id="surnameReferent" name="surnameReferent" placeholder="{{\'global.form.surnamePlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[0].surname" ng-maxlength="100" required><div ng-show="form.surnameReferent.$dirty && form.surnameReferent.$invalid"><p class="help-block" ng-show="form.surnameReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div><div class="col-md-7 form-group"><input type="email" class="form-control" id="emailReferent" name="emailReferent" placeholder="{{\'global.form.emailPlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[0].email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.emailReferent.$dirty && form.emailReferent.$invalid"><p class="help-block" ng-show="form.emailReferent.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.emailReferent.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.emailReferent.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.emailReferent.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="col-md-7 form-group"><input type="tel" class="form-control" id="phoneNumberReferent" name="phoneNumberReferent" placeholder="{{\'global.form.phoneNumberPlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[0].phoneNumber" ng-maxlength="20" required><div ng-show="form.phoneNumberReferent.$dirty && form.phoneNumberReferent.$invalid"><p class="help-block" ng-show="form.phoneNumberReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div><div ng-if="!vm.merchantRegistration.sameReferent"><div class="col-md-7 form-group"><h3 translate="merchantRegister.subtitle2" style="margin-top: 30px"></h3></div><div class="col-md-7 form-group"><select class="form-control" id="roleOperatingReferent" name="roleOperatingReferent" ng-model="vm.merchantRegistration.operators[1].role" ng-options="role as role for role in vm.roles" required><option value="" disabled="disabled" selected="selected">{{\'global.form.rolePlaceholder\' | translate}}</option></select></div><!--<div class="col-md-7 form-group" >\n                <input type="text" class="form-control" id="roleOperatingReferent" name="roleOperatingReferent" placeholder="{{\'global.form.rolePlaceholder\' | translate}}"\n                       ng-model="vm.merchantRegistration.operators[1].role" ng-maxlength=100>\n            </div>\n--><div class="col-md-7 form-group"><input type="text" class="form-control" id="nameOperatingReferent" name="nameOperatingReferent" placeholder="{{\'global.form.namePlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[1].name" ng-maxlength="100" required><div ng-show="form.nameOperatingReferent.$dirty && form.nameOperatingReferent.$invalid"><p class="help-block" ng-show="form.nameOperatingReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div><div class="col-md-7 form-group"><input type="text" class="form-control" id="surnameOperatingReferent" name="surnameOperatingReferent" placeholder="{{\'global.form.surnamePlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[1].surname" ng-maxlength="100" required><div ng-show="form.surnameOperatingReferent.$dirty && form.surnameOperatingReferent.$invalid"><p class="help-block" ng-show="form.surnameOperatingReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div><div class="col-md-7 form-group"><input type="email" class="form-control" id="emailOperatingReferent" name="emailOperatingReferent" placeholder="{{\'global.form.emailPlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[1].email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.emailOperatingReferent.$dirty && form.emailOperatingReferent.$invalid"><p class="help-block" ng-show="form.emailOperatingReferent.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.emailOperatingReferent.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.emailOperatingReferent.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.emailOperatingReferent.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="col-md-7 form-group"><input type="text" class="form-control" id="phoneNumberOperatingReferent" name="phoneNumberOperatingReferent" placeholder="{{\'global.form.phoneNumberPlaceholder\' | translate}}" ng-model="vm.merchantRegistration.operators[1].phoneNumber" ng-maxlength="20" required><div ng-show="form.phoneNumberOperatingReferent.$dirty && form.phoneNumberOperatingReferent.$invalid"><p class="help-block" ng-show="form.phoneNumberOperatingReferent.$error.required" translate="merchantRegister.form.errorRequired"></p></div></div></div><div class="col-md-7 form-group" style="margin-top: 30px; float: right"><button type="submit" ng-disabled="form.$invalid || (vm.merchantRegistration.operators[0].password != vm.confirmPassword)" class="btn btn-lg btn-default-green btn-custom"><span translate="merchantRegister.form.nextButton">Next</span></button></div></form></div></div>');
$templateCache.put('app/account/merchantRegistration/merchantRegistration2.html','<div class="register"><div class="col-md-offset-4"><div class="col-md-8 form-group"><h1 class="main-title" translate="merchantRegister.title">Registration</h1><h3 translate="merchantRegister2.subtitle" style="margin-top: 30px"></h3><div uib-alert type="danger" ng-show="vm.error" close="vm.error = false">{{vm.errorMessage}}</div></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.save()" show-validation><!-- <div class="col-md-8 form-group">\n            {{vm.merchantRegistration}}\n            </div>--><div class="col-md-8 form-group"><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="merchantRegister2.form.category" for="field_category">Choose a category...</label></uib-tab-heading><ng-form name="nestedForm"><!-- Typeahead search (search among all shops) --><div class="form-group"><ui-select reset-search-input="false" ng-model="vm.category"><ui-select-match allow-clear="true" placeholder="{{\'merchantRegister2.form.categoryTypeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected"></div></ui-select-match><ui-select-choices refresh="loadCategories($select.search)" refresh-delay="200" repeat="category in (categories)"><div ng-bind="category"></div></ui-select-choices></ui-select></div></ng-form></uib-tab><uib-tab index="1" select="resetCategory()"><uib-tab-heading><label translate="merchantRegister2.form.categoryCreate" for="field_merchantCategory">Or create a new one if missing:</label></uib-tab-heading><div class="form-group"><input type="text" class="form-control" name="merchantCategory" id="field_merchantCategory" placeholder="{{\'merchantRegister2.form.category\' | translate}}" ng-model="vm.category"></div></uib-tab></uib-tabset></div><div class="col-md-8 form-group"><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="merchantRegister2.form.merchantChoose" for="field_merchant">Choose a merchant...</label></uib-tab-heading><ng-form name="nestedForm"><div class="form-group"><!-- Typeahead search (search among all merchant) --><ui-select reset-search-input="false" ng-model="vm.merchantRegistration.merchant" ng-change="vm.merchantRegistration.shop = null;"><ui-select-match allow-clear="true" placeholder="{{\'merchantRegister2.form.merchantPlaceholder\' | translate}}"><div ng-bind="$select.selected.companyName"></div></ui-select-match><ui-select-choices refresh="loadMerchants($select.search)" refresh-delay="200" repeat="merchant in (merchants) track by merchant.id"><div ng-bind="merchant.companyName"></div></ui-select-choices></ui-select></div></ng-form></uib-tab><uib-tab index="1" select="resetMerchant()"><uib-tab-heading><label translate="merchantRegister2.form.merchantCreate" for="field_merchantName">Or create a new one if missing:</label></uib-tab-heading><div class="col-xs-10 form-group"><input type="text" class="form-control" name="merchantCompanyName" id="field_merchantCompanyName" placeholder="{{\'garanteasyApp.merchant.companyName\' | translate}}" ng-model="vm.merchantRegistration.merchant.companyName" required></div><div class="col-xs-10 form-group"><input type="text" class="form-control" name="description" id="field_description" placeholder="{{\'garanteasyApp.merchant.description\' | translate}}" ng-model="vm.merchantRegistration.merchant.description"></div><div class="col-xs-10 form-group"><input type="text" class="form-control" name="vatCode" id="field_vatCode" placeholder="{{\'garanteasyApp.merchant.vatCode\' | translate}}" ng-model="vm.merchantRegistration.merchant.vatCode" required></div><div class="col-xs-10 form-group"><input type="text" class="form-control" name="logoPath" id="field_logoPath" placeholder="{{\'garanteasyApp.merchant.logoPath\' | translate}}" ng-model="vm.merchantRegistration.merchant.logoPath"></div><div class="col-xs-10 form-group"><input type="number" class="form-control" id="numPuntiVendita" name="numPuntiVendita" placeholder="{{\'merchantRegister2.form.nShops\' | translate}}" ng-model="vm.merchantRegistration.merchant.numPuntiVendita"></div></uib-tab></uib-tabset></div><!-- Shop (readonly) if official and not admin, else editable --><div class="col-md-8 form-group"><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="merchantRegister2.form.shopChoose" for="field_shop">Choose a shop...</label></uib-tab-heading><ng-form name="nestedForm"><!-- Typeahead search (search among all shops) --><ui-select reset-search-input="false" ng-model="vm.merchantRegistration.shop" ng-disabled="! vm.merchantRegistration.merchant"><ui-select-match allow-clear="true" placeholder="{{\'merchantRegister2.form.shopTypeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.description"></div></ui-select-match><ui-select-choices refresh="loadShops($select.search)" refresh-delay="200" repeat="shop in (shops) track by shop.id"><div ng-bind="shop.description"></div></ui-select-choices></ui-select></ng-form></uib-tab><uib-tab index="1" select="resetShop()"><uib-tab-heading><label translate="merchantRegister2.form.shopCreate" for="field_shop">Or create a new one if missing</label></uib-tab-heading><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.code" for="field_shopCode">Street</label><input type="text" class="form-control" name="shopStreet" id="field_shopCode" ng-model="vm.merchantRegistration.shop.code" uppercase-only></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.shopDescription" for="field_shopDescription">shopDescription</label><input type="text" class="form-control" name="shopDescription" id="field_shopDescription" ng-model="vm.merchantRegistration.shop.description"></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.vatCode" for="field_shopVatCode">shopVatCode</label><input type="text" class="form-control" name="shopVatCode" id="field_shopVatCode" ng-model="vm.merchantRegistration.shop.vatCode"></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.address.street" for="field_shopStreet">Street</label><input type="text" class="form-control" name="shopStreet" id="field_shopStreet" ng-model="vm.merchantRegistration.shop.address.street" required></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.address.locality" for="field_shopLocality">Locality</label><input type="text" class="form-control" name="shopLocality" id="field_shopLocality" ng-model="vm.merchantRegistration.shop.address.locality"></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.address.city" for="field_shopCity">City</label><input type="text" class="form-control" name="shopCity" id="field_shopCity" ng-model="vm.merchantRegistration.shop.address.city" required></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.address.postcode" for="field_shopPostcode">Postcode</label><input type="text" class="form-control" name="shopPostcode" id="field_shopPostcode" ng-model="vm.merchantRegistration.shop.address.postcode"></div><div class="col-xs-10 form-group"><label class="control-label" translate="merchantRegister2.form.shop.address.country" for="field_shopCountry">Country</label><select class="form-control" name="shopCountry" id="field_shopCountry" ng-model="vm.merchantRegistration.shop.address.country" pvp-country-picker></div></uib-tab></uib-tabset></div><div class="col-md-8 form-group"><label translate="merchantRegister2.form.webSite"></label><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.webSite" name="optionsRadios" id="optionsRadios1" value="true" checked="checked"> {{\'global.form.yes\' | translate}}</label></div><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.webSite" name="optionsRadios" id="optionsRadios2" value="false"> {{\'global.form.no\' | translate}}</label></div></div><div ng-show="vm.merchantRegistration.webSite === \'true\'" class="col-md-8 form-group"><input type="url" class="form-control" id="websiteUrl" name="websiteUrl" placeholder="{{\'merchantRegister2.form.urlWebSite\' | translate}}" ng-model="vm.merchantRegistration.merchant.websiteUrl" ng-maxlength="100"></div><div class="col-md-8 form-group"><label translate="merchantRegister2.form.eCommerce"></label><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.eCommerce" name="optionsRadios2" id="optionsRadios3" value="true" checked="checked"> {{\'global.form.yes\' | translate}}</label></div><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.eCommerce" name="optionsRadios2" id="optionsRadios4" value="false"> {{\'global.form.no\' | translate}}</label></div></div><div ng-show="vm.merchantRegistration.eCommerce === \'true\'" class="col-md-8 form-group"><input type="url" class="form-control" id="eCommerceUrl" name="eCommerceUrl" placeholder="{{\'merchantRegister2.form.eCommerceUrl\' | translate}}" ng-model="vm.merchantRegistration.shop.ecommerceUrl" ng-maxlength="100"></div><div class="col-md-8 form-group"><label translate="merchantRegister2.form.questionPhone"></label><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.questionPhone" name="optionsRadios3" id="optionsRadios5" value="true" checked="checked"> {{\'merchantRegister2.form.unique\' | translate}}</label></div><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.questionPhone" name="optionsRadios3" id="optionsRadios6" value="false"> {{\'merchantRegister2.form.different\' | translate}}</label></div></div><div class="col-md-8 form-group"><input type="tel" class="form-control" id="phoneNumber" name="phoneNumber" placeholder="{{\'merchantRegister2.form.phoneNumberHelp\' | translate}}" ng-model="vm.merchantRegistration.merchant.phoneNumber" ng-maxlength="20" required></div><div class="col-md-8 form-group"><label translate="merchantRegister2.form.questionMail"></label><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.questionMail" name="optionsRadios4" id="optionsRadios7" value="true" checked="checked"> {{\'merchantRegister2.form.unique\' | translate}}</label></div><div class="radio"><label><input type="radio" ng-model="vm.merchantRegistration.questionMail" name="optionsRadios4" id="optionsRadios8" value="false"> {{\'merchantRegister2.form.different\' | translate}}</label></div></div><div class="col-md-8 form-group"><input type="email" class="form-control" id="emailHelp" name="emailHelp" placeholder="{{\'merchantRegister2.form.emailHelp\' | translate}}" ng-model="vm.merchantRegistration.merchant.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="col-md-8 form-group" style="margin-top: 30px; float: right"><button type="submit" ng-disabled="vm.isSaving || !vm.isValidInput()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div>');
$templateCache.put('app/account/password/password.html','<div><br><br><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpasswordPlaceholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpasswordPlaceholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><h2 class="main-title" translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><div><jhi-alert></jhi-alert><h2 class="main-title" translate="garanteasyApp.contact.home.title">Contacts</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="settings-contact-new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.contact.home.createLabel">Create new Contact</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.contact.channel">Channel</span></th><th><span translate="garanteasyApp.contact.primaryContact">Primary Contact</span></th><th><span translate="garanteasyApp.contact.activated">Activated</span></th><th></th></tr></thead><tbody><tr ng-repeat="contact in vm.contacts track by contact.id"><td>{{contact.channel}}</td><td>{{contact.primaryContact | booleanAsYesNo | translate}}</td><td>{{contact.activated | booleanAsYesNo | translate}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--\n\t\t\t\t\t\t\t\t<button type="submit" ui-sref="contact-detail({id:contact.id})" class="btn btn-info btn-sm">\n\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-eye-open"></span>\n\t\t\t\t\t\t\t\t\t<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t --> <button type="submit" ui-sref="settings-contact-edit({id:contact.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="settings-contact-delete({id:contact.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div><h2 class="main-title" translate="garanteasyApp.phoneNumber.home.title">Phone Numbers</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="settings-phone-number-new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.phoneNumber.home.createLabel">Create new Phone Number</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.phoneNumber.phoneNumber">Phone Number</span></th><th><span translate="garanteasyApp.phoneNumber.activated">Activated</span></th><th></th></tr></thead><tbody><tr ng-repeat="phoneNumber in vm.phoneNumbers track by phoneNumber.id"><td>{{phoneNumber.phoneNumber}}</td><td>{{phoneNumber.activated | booleanAsYesNo | translate}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--\n\t                            <button type="submit"\n\t                                    ui-sref="settings-phone-number-detail({id:phoneNumber.id})"\n\t                                    class="btn btn-info btn-sm">\n\t                                <span class="glyphicon glyphicon-eye-open"></span>\n\t                                <span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\n\t                            </button>\n\t                             --> <button type="submit" ui-sref="settings-phone-number-edit({id:phoneNumber.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="settings-phone-number-delete({id:phoneNumber.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div><h2 class="main-title" translate="garanteasyApp.customer.home.title">Customers</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="settings-customer-new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.customer.home.createLabel">Create new Customer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.customer.legalName">Legal Name</span></th><th><span translate="garanteasyApp.customer.vatid">Vatid</span></th><th><span translate="garanteasyApp.customer.business">Business</span></th><th><span translate="garanteasyApp.customer.address">Address</span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td><a ui-sref="customer-detail({id:customer.id})">{{customer.legalName}}</a></td><td>{{customer.vatid}}</td><td>{{customer.business | booleanAsYesNo | translate}}</td><td>{{customer.address.descShort}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="customer-detail({id:customer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="settings-customer-edit({id:customer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="settings-customer-delete({id:customer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div><h2 class="main-title" translate="garanteasyApp.card.home.title">Cards</h2><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="settings-card-new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.card.home.createLabel">Create new card</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.card.number">number</span></th><th><span translate="garanteasyApp.card.activationDate">activationDate</span></th><th><span translate="garanteasyApp.card.expirationDate">expirationDate</span></th><th></th></tr></thead><tbody><tr ng-repeat="card in vm.cards track by card.id"><td><a ui-sref="card/detail({id:card.id})">{{card.number}}</a></td><td>{{card.activationDate | date:\'mediumDate\'}}</td><td>{{card.expirationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="card/detail({id:card.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button ng-if="vm.isOwner(card) || vm.isAdmin" type="submit" ui-sref="settings-card-edit({id:card.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button ng-if="vm.isOwner(card)" type="submit" ui-sref="settings-card-delete({id:card.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><!--\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label>\n\t\t\t\t\t<input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstnamePlaceholder\' | translate}}"\n\t\t\t\t\t\tng-model="vm.settingsAccount.firstName" ng-minlength=1 ng-maxlength=50 required maxlength="50">\n\t\t\t\t\t<div ng-show="form.firstName.$dirty && form.firstName.$invalid">\n\t\t\t\t\t\t<p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is\n\t\t\t\t\t\t\trequired.</p>\n\t\t\t\t\t\t<p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name\n\t\t\t\t\t\t\tis required to be at least 1 character.</p>\n\t\t\t\t\t\t<p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name\n\t\t\t\t\t\t\tcannot be longer than 50 characters.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label>\n\t\t\t\t\t<input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastnamePlaceholder\' | translate}}"\n\t\t\t\t\t\tng-model="vm.settingsAccount.lastName" ng-minlength=1 ng-maxlength=50 required maxlength="50">\n\t\t\t\t\t<div ng-show="form.lastName.$dirty && form.lastName.$invalid">\n\t\t\t\t\t\t<p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is\n\t\t\t\t\t\t\trequired.</p>\n\t\t\t\t\t\t<p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is\n\t\t\t\t\t\t\trequired to be at least 1 character.</p>\n\t\t\t\t\t\t<p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name\n\t\t\t\t\t\t\tcannot be longer than 50 characters.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n --><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><!--         <div class="form-group"> --><!--             <label class="control-label" translate="global.form.serviceConsent" for="field_serviceConsent">Service Consent</label> --><!--             <input type="checkbox" class="form-control" name="serviceConsent" id="field_serviceConsent" --><!--                     ng-model="vm.settingsAccount.serviceConsent" --><!--                      /> --><!--             <div ng-show="!vm.settingsAccount.serviceConsent"> --><!-- \t\t\t\t<p class="alert alert-danger" translate="settings.messages.removeConsent"> --><!-- \t\t\t\tAttention! If you deny consent your account and all of your data will be deleted</p> --><!-- \t\t\t</div> --><!--         </div> --><!--         <div class="form-group"> --><!--             <label class="control-label" translate="global.form.commInfoConsent" for="field_commInfoConsent">Comm Info Consent</label> --><!--             <input type="checkbox" class="form-control" name="commInfoConsent" id="field_commInfoConsent" --><!--                     ng-model="vm.settingsAccount.commInfoConsent" --><!--                      /> --><!--         </div> --><!--         <div class="form-group"> --><!--             <label class="control-label" translate="global.form.commInfo3rdConsent" for="field_commInfo3rdConsent">Comm Info 3 Rd Consent</label> --><!--             <input type="checkbox" class="form-control" name="commInfo3rdConsent" id="field_commInfo3rdConsent" --><!--                     ng-model="vm.settingsAccount.commInfo3rdConsent" --><!--                      /> --><!--         </div> --> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-5 col-md-offset-2"><h1 ng-show="success" translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social><br><div class="alert alert-warning" translate="global.messages.info.authenticated">If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div><div class="col-md-5"></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 class="main-title" translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 class="main-title" translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex/dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 class="main-title" translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refreshButton">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="fas fa-expand-arrows-alt glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/import/import.html','<div><h2 class="main-title" translate="import.home.title">Import</h2><jhi-alert-error></jhi-alert-error><div class="panel" style="text-align: -webkit-center; background-color: transparent"><div class="panel-body"><button class="btn btn-primary" onclick="location.href=\'app/admin/import/productImportTemplate.zip\';"><span class="glyphicon glyphicon-download"></span> <span translate="import.home.downloadLabel"></span></button></div></div><div class="panel" style="text-align: -webkit-center; background-color: transparent"><div class="panel-body"><button ng-disabled="vm.isInProcess()" ngf-select="vm.uploadFile($file)" class="btn btn-primary"><span class="glyphicon glyphicon-upload"></span> <span translate="import.home.uploadLabel"></span></button></div></div><uib-progressbar ng-if="vm.process && vm.process.progress" animate="true" value="vm.process.progress" max="vm.process.total" type="success">{{vm.process.progress}} / {{vm.process.total}}</uib-progressbar></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 class="main-title" translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2 class="main-title"><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><!--\n        <dt><span translate="userManagement.firstName">First Name</span></dt>\n        <dd>{{vm.user.firstName}}</dd>\n        <dt><span translate="userManagement.lastName">Last Name</span></dt>\n        <dd>{{vm.user.lastName}}</dd>\n         --><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated | booleanAsYesNo | translate}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><!-- \n        <div class="form-group">\n            <label class="control-label" translate="userManagement.firstName">First Name</label>\n            <input type="text" class="form-control" name="firstName"\n                   ng-model="vm.user.firstName" ng-maxlength="50">\n\n            <div ng-show="editForm.firstName.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength"\n                   translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label translate="userManagement.lastName">Last Name</label>\n            <input type="text" class="form-control" name="lastName"\n                   ng-model="vm.user.lastName" ng-maxlength="50">\n\n            <div ng-show="editForm.lastName.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength"\n                   translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n         --><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 class="main-title" translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management/new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th rowspan="2" translate="global.field.id">ID</th>--><th rowspan="2" jh-sort-by="login"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2" jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th rowspan="2"></th><th colspan="3" translate="userManagement.consentCommon">Service Consent</th><th rowspan="2" translate="userManagement.langKey">Lang Key</th><th rowspan="2" translate="userManagement.profiles">Profiles</th><!--\n                <th rowspan="2" translate="userManagement.createdDate">Created Date</th>\n                <th rowspan="2" translate="userManagement.lastModifiedBy">Last Modified By</th>\n                <th rowspan="2" translate="userManagement.lastModifiedDate">Last Modified Date</th>\n                 --><th rowspan="2"></th></tr><tr><th translate="userManagement.serviceConsent">Service Consent</th><th translate="userManagement.commInfoConsent">Comm Info Consent</th><th translate="userManagement.commInfo3rdConsent">Comm Info 3 Rd Consent</th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><!-- <td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td> --><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.serviceConsent | booleanAsYesNo | translate}}</td><td>{{user.commInfoConsent | booleanAsYesNo | translate}}</td><td>{{user.commInfo3rdConsent | booleanAsYesNo | translate}}</td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><!--\n                <td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td>\n                <td>{{user.lastModifiedBy}}</td>\n                <td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td>\n                --><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management/edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management/delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/bar-code-reader/bar-code-camera-reader.html','<div ng-if="!vm.cameraIsEnabled"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="barCodeReader.title">Leggi il codice a Barre</h4></div><div class="modal-body"><i class="fas fa-camera"></i> <span translate="barCodeReader.error.camera.not.found">camera.not.found</span></div></div><div ng-if="vm.cameraIsEnabled"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <button type="button" class="pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.save()"><i class="fas fa-check"></i></button> Camera<h4 class="modal-title" translate="barCodeReader.title">Leggi il codice a Barre</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><section id="container" class="container"><div class="controls"><fieldset class="input-group"><input type="file" accept="image/*" capture="camera" custom-on-change="vm.onFileImputChange"></fieldset><!-- <fieldset class="reader-config-group">\n                <label>\n                    <span>Barcode-Type</span>\n                    <select name="decoder_readers">\n                        <option value="code_128" selected="selected">Code 128</option>\n                        <option value="code_39">Code 39</option>\n                        <option value="code_39_vin">Code 39 VIN</option>\n                        <option value="ean">EAN</option>\n                        <option value="ean_extended">EAN-extended</option>\n                        <option value="ean_8">EAN-8</option>\n                        <option value="upc">UPC</option>\n                        <option value="upc_e">UPC-E</option>\n                        <option value="codabar">Codabar</option>\n                        <option value="i2of5">Interleaved 2 of 5</option>\n                        <option value="2of5">Standard 2 of 5</option>\n                        <option value="code_93">Code 93</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Resolution (long side)</span>\n                    <select name="input-stream_size">\n                        <option value="320">320px</option>\n                        <option value="640">640px</option>\n                        <option selected="selected" value="800">800px</option>\n                        <option value="1280">1280px</option>\n                        <option value="1600">1600px</option>\n                        <option value="1920">1920px</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Patch-Size</span>\n                    <select name="locator_patch-size">\n                        <option value="x-small">x-small</option>\n                        <option value="small">small</option>\n                        <option value="medium">medium</option>\n                        <option selected="selected" value="large">large</option>\n                        <option value="x-large">x-large</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Half-Sample</span>\n                    <input type="checkbox" name="locator_half-sample" />\n                </label>\n                <label>\n                    <span>Single Channel</span>\n                    <input type="checkbox" name="input-stream_single-channel" />\n                </label>\n                <label>\n                    <span>Workers</span>\n                    <select name="numOfWorkers">\n                        <option value="0">0</option>\n                        <option selected="selected" value="1">1</option>\n                    </select>\n                </label>\n            </fieldset> --></div><div id="result_strip"><ul class="thumbnails"></ul></div><div id="interactive" class="viewport"></div><div id="debug" class="detection"></div></section></div><div class="modal-footer hidden-xs hidden-sm"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span translate="barCodeReader.action.cancel">Cancel</span></button> <button type="button" ng-click="vm.save()" class="btn btn-primary"><span translate="barCodeReader.action.confirm">Confirm</span></button></div></div>');
$templateCache.put('app/components/bar-code-reader/bar-code-file-reader.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> <button type="button" class="pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.save()"><i class="fas fa-check"></i></button><h4 class="modal-title" translate="barCodeReader.title">Leggi il codice a Barre</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><section id="container" class="container"><div class="controls"><fieldset class="input-group"><input type="file" accept="image/*" capture="camera" custom-on-change="vm.onFileImputChange"></fieldset><!-- <fieldset class="reader-config-group">\n                <label>\n                    <span>Barcode-Type</span>\n                    <select name="decoder_readers">\n                        <option value="code_128" selected="selected">Code 128</option>\n                        <option value="code_39">Code 39</option>\n                        <option value="code_39_vin">Code 39 VIN</option>\n                        <option value="ean">EAN</option>\n                        <option value="ean_extended">EAN-extended</option>\n                        <option value="ean_8">EAN-8</option>\n                        <option value="upc">UPC</option>\n                        <option value="upc_e">UPC-E</option>\n                        <option value="codabar">Codabar</option>\n                        <option value="i2of5">Interleaved 2 of 5</option>\n                        <option value="2of5">Standard 2 of 5</option>\n                        <option value="code_93">Code 93</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Resolution (long side)</span>\n                    <select name="input-stream_size">\n                        <option value="320">320px</option>\n                        <option value="640">640px</option>\n                        <option selected="selected" value="800">800px</option>\n                        <option value="1280">1280px</option>\n                        <option value="1600">1600px</option>\n                        <option value="1920">1920px</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Patch-Size</span>\n                    <select name="locator_patch-size">\n                        <option value="x-small">x-small</option>\n                        <option value="small">small</option>\n                        <option value="medium">medium</option>\n                        <option selected="selected" value="large">large</option>\n                        <option value="x-large">x-large</option>\n                    </select>\n                </label>\n                <label>\n                    <span>Half-Sample</span>\n                    <input type="checkbox" name="locator_half-sample" />\n                </label>\n                <label>\n                    <span>Single Channel</span>\n                    <input type="checkbox" name="input-stream_single-channel" />\n                </label>\n                <label>\n                    <span>Workers</span>\n                    <select name="numOfWorkers">\n                        <option value="0">0</option>\n                        <option selected="selected" value="1">1</option>\n                    </select>\n                </label>\n            </fieldset> --></div><div id="result_strip"><ul class="thumbnails"></ul></div><div id="interactive" class="viewport"></div><div id="debug" class="detection"></div></section></div><div class="modal-footer hidden-xs hidden-sm"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span translate="barCodeReader.action.cancel">Cancel</span></button> <button type="button" ng-click="vm.save()" class="btn btn-primary"><span translate="barCodeReader.action.confirm">Confirm</span></button></div>');
$templateCache.put('app/components/bar-code-reader/bar-code-reader.component.html','<span uib-tooltip="{{\'barCodeReader.title\' | translate}}" ng-class="vm.btnClass"><span ng-click="vm.onReadBarCodeCamera()"><i class="fas fa-camera"></i> </span><span ng-click="vm.onReadBarCodeFile()"><i class="fas fa-cloud-upload-alt"></i></span></span>');
$templateCache.put('app/components/crop/crop.directive.html','<div ng-class="vm.customClass"><div><div ng-show="vm.isImage(vm.selectedFile)" class="img-responsive croppie-img-wrapper" style="max-height: 377px"><img style="display: none" class="img-responsive croppie-my-image" src="#"></div><div ng-show="!vm.isImage(vm.selectedFile) && vm.selectedFile.fileContentType !== \'build\'" class="img-responsive" style="font-size: 2rem; width: 80px; height: 80px; padding: 2rem"><a target="_blank" ng-href="{{vm.selectedFile.srcDoc || vm.selectedFile.src}}" download><span ng-bind-html="vm.selectedFile.fileContentType|iconify"></span></a></div><div ng-show="!vm.isImage(vm.selectedFile) && vm.selectedFile.fileContentType === \'build\'" class="col-xs-12"><div class="col-md-10 col-sm-12 col-xs-12 no-padding"><receipt-image-build id="receiptPrintContent" class="row" receipt="vm.selectedFile.receipt"></receipt-image-build></div></div></div><ul ng-if="vm.files.length > 1" class="images-list ul-no-bump"><li ng-repeat="image in vm.files"><img ng-if="image.src && vm.isImage(image)" class="img-responsive img-thumbnail hello" style="width: 80px; height: 80px" ng-click="vm.select(image)" ng-src="{{image.src}}"> <img ng-if="!image.src && vm.isImage(image)" class="img-responsive img-thumbnail hello" style="width: 80px; height: 80px" ng-click="vm.select(image)" data-ng-src="{{\'data:\' + image.fileContentType + \';base64,\' + image.fileData}}" id="{{image.id}}"> <span ng-if="!vm.isImage(image)" class="img-responsive img-thumbnail hello" style="width: 80px; height: 80px; font-size:2rem; padding: 2rem; display: block" ng-click="vm.select(image)" ng-bind-html="image.fileContentType|iconify"></span></li></ul><div class="hidden-print"><button ng-show="vm.isImage(vm.selectedFile)" ng-click="vm.zoomIn()" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-search-plus"></span></button> <button ng-show="vm.isImage(vm.selectedFile)" ng-click="vm.zoomOut()" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-search-minus"></span></button> <button ng-show="vm.isImage(vm.selectedFile)" ng-click="vm.rotate()" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-sync"></span></button> <button ng-show="vm.isImage(vm.selectedFile) || vm.selectedFile.fileContentType === \'build\'" ng-click="vm.print()" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-print"></span></button> <a ng-show="!vm.isImage(vm.selectedFile) && vm.selectedFile.src" class="btn btn-default btn-dark" type="button" style="margin-left:3px" target="_blank" ng-href="{{vm.selectedFile.srcDoc || vm.selectedFile.src}}" download><span class="fas fa-download"></span></a> <button disabled="disabled" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-share-alt"></span></button> <button ng-if="!vm.hideDelete" ng-click="vm.cancel()" class="btn btn-default btn-dark" type="button" style="margin-left:3px"><span class="fas fa-trash"></span></button></div></div>');
$templateCache.put('app/components/login/login.html','<!--<div class="modal-header">\n\t<button type="button" class="close" data-dismiss="modal"\n\t\taria-hidden="true" ng-click="vm.cancel()">&times;</button>\n\t&lt;!&ndash; <h4 class="modal-title" translate="login.title">Sign in</h4>&ndash;&gt;\n</div>--><div class="modal-body"><div class="row"><div style="float: left" class="col-md-4"><h1 style="float: left" class="main-title" translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-6"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><input type="text" class="form-control" id="username" placeholder="{{\'global.form.usernamePlaceholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><input type="password" class="form-control" id="password" placeholder="{{\'login.form.passwordPlaceholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><div class="row col-md-4" style="margin-top: 20px"><button type="submit" class="btn btn-default-green btn-custom" translate="login.form.button">Sign in</button><div class="row col-md-4" style="margin-top: 20px"><div><a class="btn btn-default" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div><div><a style="color: #24b85b" translate="global.messages.info.register" class="btn btn-default" href="" ng-click="vm.merchantRegister()">Register a new account</a></div></div></div></form><p></p></div><div class="col-md-6"><div class="form-group"><jh-social ng-provider="facebook"></jh-social></div><div class="form-group"><jh-social ng-provider="google"></jh-social></div><jh-social ng-provider="twitter"></jh-social><!-- jhipster-needle-add-social-button --></div></div></div>');
$templateCache.put('app/components/receipt-image-build/receipt-image-build.component.html','<div class="panel panel-default receipt-image-build-panel" id="receipt-image-build-panel"><div class="row"><div ng-if="vm.receipt.shop" class="logo-container col-xs-8 col-xs-offset-2"><img ng-if="vm.logoUri" class="img-responsive" style="margin-left: auto; margin-right: auto; filter: grayscale(100%)" src="{{vm.logoUri}}"><h1 ng-if="!vm.logoUri && !vm.receipt.shop.ecommerceUrl"><i class="fas fa-store-alt"></i></h1><h1 ng-if="!vm.logoUri && vm.receipt.shop.ecommerceUrl"><i class="fas fa-shopping-cart"></i></h1></div></div><div class="row shop-detail margin-top-15"><div class="col-xs-12 text-center text-uppercase">{{vm.receipt.shop.owner.name}}<br>{{vm.receipt.shop.address.descFull}}<br>{{\'garanteasyApp.receipt.detail.pIva\' | translate}} {{vm.receipt.shop.vatCode || vm.receipt.shop.merchant.vatCode}}<br></div></div><div class="row margin-top-15"><div class="col-xs-12 text-center"><!-- <b>{{vm.receipt.shop.shopSignboard || vm.receipt.shop.description}}</b><br />\n            {{vm.receipt.shop.address.descFull}}<br /> --></div></div><div class="row margin-top-15"><div class="col-xs-12 text-center"><span translate="garanteasyApp.receipt.image.title"></span><br><span translate="garanteasyApp.receipt.image.subtitle"></span></div></div><div class="row margin-top-15"><div class="col-xs-8"><b translate="garanteasyApp.receipt.image.description">DESCRIZIONE</b></div><div class="col-xs-4"><b translate="garanteasyApp.receipt.image.price">PREZZO</b></div></div><div class="row"><div class="col-xs-12 text-uppercase" ng-repeat="purchasedProduct in vm.products track by purchasedProduct.id"><div class="col-xs-9 no-padding" style="font-size: 1rem" ng-if="vm.productsHasPrice">{{purchasedProduct.quantity}} &nbsp;{{ purchasedProduct.product.brand.name + \' - \' + purchasedProduct.product.name | limitTo:50}} <span ng-if="(purchasedProduct.product.brand.name + \' - \' + purchasedProduct.product.name).length > 50">...</span></div><div class="col-xs-3 no-padding" ng-if="vm.productsHasPrice">{{ purchasedProduct.transactionAmount | currency:\'\' }}<span ng-if="!purchasedProduct.transactionAmount">-</span></div><div class="col-xs-12 no-padding" style="font-size: 1rem" ng-if="!vm.productsHasPrice">{{purchasedProduct.quantity}} &nbsp;{{ purchasedProduct.product.brand.name + \' - \' + purchasedProduct.product.name | limitTo:70}} <span ng-if="(purchasedProduct.product.brand.name + \' - \' + purchasedProduct.product.name).length > 70">...</span></div></div></div><div class="row" ng-if="vm.receipt.transactionAmount"><div class="col-xs-8"><b translate="garanteasyApp.receipt.image.total">TOTALE</b></div><div class="col-xs-4" style="padding-left: 2rem"><b>{{ vm.receipt.transactionAmount | currency:\'\' }}<span ng-if="!vm.receipt.transactionAmount">-</span></b></div></div><!-- <div class="row" style="margin-top:15px;">\n        <div class="col-xs-6 text-left" translate="garanteasyApp.receipt.image.date">\n            DATA:\n        </div>\n        <div class="col-xs-6  text-right">\n            {{vm.receipt.buyingDate | date:\'mediumDate\'}}\n        </div>\n        <div class="col-xs-7 text-left" translate="garanteasyApp.receipt.image.register">\n            N. CASSA:\n        </div>\n        <div class="col-xs-5  text-right">\n            {{ vm.receipt.counterCode || \'-\'}}\n        </div>\n        <div class="col-xs-7 text-left" translate="garanteasyApp.receipt.image.receiptNumber">\n            N. SCONTRINO:\n        </div>\n        <div class="col-xs-5  text-right">\n            {{ vm.receipt.receiptNumber}}\n        </div>\n    </div> --><div class="row text-uppercase" style="margin-top:15px;margin-bottom: 2rem"><div class="col-xs-6 text-left">{{vm.receipt.buyingDate | date:\'short\'}}</div><div class="col-xs-6 text-left"><span translate="garanteasyApp.receipt.image.receiptNumber"></span>{{vm.receipt.receiptNumber}}</div><div class="col-xs-12 text-center">{{ vm.receipt.counterCode || \'-\'}}</div></div><div class="row text-uppercase" style="margin-top:15px"><div class="col-xs-12 text-center" style="font-size: 1rem"><span translate="garanteasyApp.receipt.image.footer"></span></div></div></div>');
$templateCache.put('app/components/warranty-assistance/product-select-list.html','<div ng-if="vm.receipt.purchasedProducts && vm.receipt.purchasedProducts.length > 0" class="row"><h4 class="rdetail-font-size" translate="garanteasyApp.warranty.warrantyAssistance.selectProduct">Select a product to receive assistance:</h4><div ng-repeat="purchasedProduct in vm.receipt.purchasedProducts"><input type="radio" name="radioInput" ng-model="vm.selectedProduct" ng-value="purchasedProduct"> {{purchasedProduct.product.name}}</div></div><div ng-if="!vm.receipt.purchasedProducts || vm.receipt.purchasedProducts.length == 0" class="row"><div style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12">Non ci sono prodotti associati alla ricevuta. Vuoi definirne uno nuovo?</span></strong></div><div class="row row-margin"><span class="col-sm-12 col-xs-12 nopadding"><span class="col-sm-6 col-xs-6 nopadding"><input type="radio" ng-model="vm.createNewProduct" name="createProd1" value="true"> <span class="rdetail-font-size" translate="global.form.yes">button one</span> </span><span class="col-sm-6 col-xs-6 nopadding" ui-sref="warranty-claim.newWithReceipt({idReceipt: vm.receipt.id})"><input type="radio" name="createProd2" value="N"> <span class="rdetail-font-size" translate="global.form.no">button one</span></span></span></div></div><div ng-if="vm.createNewProduct"><h4 class="rdetail-font-size">Definisci un nuovo prodotto per il quale richiedere assistenza</h4><!-- PRODOTTI ACQUISTATI ICONA E TITOLO--><div style="margin-bottom: 1em" class="col-xs-12 padding-step text-center"><div class="row row-margin"><i style="font-size: large" class="fas fa-barcode"></i> <strong style="font-size: large; margin-left: 5px" class="rdetail-font-size" translate="garanteasyApp.receipt.insertOrUpdateReceipt.infoProducts"></strong></div></div><ng-form name="addProductForm"><div class="row"><div class="col-sm-2 hidden-xs"><img src="/content/images/icone_new/icone_sfondo_bianco/codice_a_barrecerchio_bianco.png" class="img-responsive"></div><div class="col-sm-10 col-xs-12"><purchased-product-component receipt="vm.receipt"></purchased-product-component></div></div></ng-form></div></div>');
$templateCache.put('app/components/warranty-assistance/warranty-assistance.component.html','<div class="row"><div class="col-sm-2 hidden-xs"><img src="/content/images/icone_new/icone_sfondo_bianco/customer_cerchio_bianco.png" class="img-responsive"></div><div class="col-sm-10"><div class="row hidden-xs"><h4><span ng-if="!vm.receipt" translate="garanteasyApp.purchasedProduct.detail.warrantyAssistanceMessage"></span> <span ng-if="vm.receipt" translate="garanteasyApp.purchasedProduct.warrantyAssistanceMessageReceipt"></span></h4></div><div class="row" ng-if="!vm.receipt"><div class="col-sm-3 col-xs-4"><div class="row"><i class="fas fa-balance-scale"></i> <span translate="garanteasyApp.dashboard.sidebar.legalWarranty"></span> <span uib-tooltip="{{vm.checkStatus(vm.legal) | translate}}"><svg height="16" width="16" class="align-top"><circle r="6" cx="8" cy="9" fill="{{ vm.legal }}" stroke="black" stroke-width="1"></circle></svg></span></div><div class="row"><i class="fas fa-industry"></i> <span translate="garanteasyApp.dashboard.sidebar.conventionalWarranty"></span> <span uib-tooltip="{{vm.checkStatus(vm.conventional) | translate}}"><svg height="16" width="16" class="align-top"><circle r="6" cx="8" cy="9" fill="{{ vm.conventional }}" stroke="black" stroke-width="1"></circle></svg></span></div><div class="row"><i class="fas fa-umbrella"></i> <span translate="garanteasyApp.dashboard.sidebar.insurance"></span> <span uib-tooltip="{{vm.checkStatus(vm.insurance) | translate}}"><svg height="16" width="16" class="align-top"><circle r="6" cx="8" cy="9" fill="{{ vm.insurance }}" stroke="black" stroke-width="1"></circle></svg></span></div><div class="row"><i class="fas fa-briefcase"></i> <span translate="garanteasyApp.dashboard.sidebar.assistance"></span> <span uib-tooltip="{{vm.checkStatus(vm.assistance) | translate}}"><svg height="16" width="16" class="align-top"><circle r="6" cx="8" cy="9" fill="{{ vm.assistance }}" stroke="black" stroke-width="1"></circle></svg></span></div></div><div class="col-sm-7 col-xs-4"><!-- CMS Text test --></div></div><div style="margin-left:auto" class="row" ng-if="vm.receipt"><div class="row"><span><svg height="16" width="16" class="align-top"><circle r="6" cx="8" cy="9" fill="green" stroke="black" stroke-width="0"></circle></svg> </span><span class="align-top">({{vm.totalWarranties.numValid || 0}}) </span><span class="align-top" translate="garanteasyApp.receipt.sidebar.active"></span></div><div class="row"><svg height="16" width="15" class="align-top"><circle r="6" cx="8" cy="9" fill="orange" stroke="black" stroke-width="0"></circle></svg> <span class="align-top">({{vm.totalWarranties.numExpiring || 0}})</span> <span class="align-top" translate="garanteasyApp.receipt.sidebar.expiring"></span></div><div class="row"><svg height="16" width="15" class="align-top"><circle r="6" cx="8" cy="9" fill="red" stroke="black" stroke-width="0"></circle></svg> <span class="align-top">({{vm.totalWarranties.numExpired || 0}}) </span><span class="align-top" translate="garanteasyApp.receipt.sidebar.expired"></span></div><div class="row"><svg height="16" width="15" class="align-top"><circle r="6" cx="8" cy="9" fill="white" stroke="black" stroke-width="1"></circle></svg> <span class="align-top">({{vm.warrantiesTotal.incomplete || 0}})</span> <span class="align-top" translate="garanteasyApp.receipt.sidebar.undefined"></span></div></div><div class="row"><h4><span class="rdetail-font-size" translate="garanteasyApp.purchasedProduct.detail.infoWarrantyClaims"></span></h4></div><div class="row"><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.receipt.detail.numProducts"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{0 + vm.claims.length}}</span></div><div ng-repeat="warrantyClaim in vm.claims"><span class="rdetail-font-size"><a style="text-decoration: none; color: black"><span>{{warrantyClaim.annotations}} - {{warrantyClaim.requestDate | date:\'mediumDate\'}} - <span translate="{{\'garanteasyApp.WarrantyClaimStatus.\' + warrantyClaim.status}}">{{warrantyClaim.status}}</span></span></a></span></div><div class="col-4" ng-if="vm.productSelectToggle" ng-include="\'app/components/warranty-assistance/product-select-list.html\'"></div><div class="button-row single-row pull-right"><button ng-if="vm.purchasedProduct" ui-sref="warranty-claim-product-new({idPurchasedProduct: vm.purchasedProduct.id})" class="btn btn-default btn-dark"><i class="fas fa-user-shield"></i></button> <button ng-if="!vm.productSelectToggle && !vm.purchasedProduct && vm.receipt" ng-click="vm.openProductSelect()" class="btn btn-default btn-dark"><i class="fas fa-user-shield"></i></button> <button ui-sref="warranty-claim-product-new({idPurchasedProduct: vm.selectedProduct.id})" ng-if="vm.productSelectToggle && (!vm.receipt || !vm.receipt.purchasedProduct)" ng-disabled="!vm.selectedProduct" class="btn btn-default btn-dark"><i class="fas fa-user-shield"></i></button> <button ng-if="vm.productSelectToggle && vm.receipt && vm.receipt.purchasedProduct" ng-disabled="$scope.addProductForm.$invalid" ng-click="vm.save()" class="btn btn-default btn-dark"><i class="fas fa-user-shield"></i></button></div></div></div></div>');
$templateCache.put('app/components/warranty-box/warranty-box-component.html','<div class="row"><div class="col-sm-2 hidden-xs"><img ng-src="/content/images_no_gulp/{{vm.warrentyModel.image}}" class="img-responsive"></div><div class="col-sm-10 col-xs-12"><!--@@@@ {{vm.receipt.warrantyAggregate[0].warranty}}--><div class="hidden-xs"><h4><span class="rdetail-font-size" translate="{{vm.warrentyModel.title}}"></span></h4></div><div class="row title-page-mobile purchased-page visible-xs" style="background-image: url(\'/content/images/icone_new/icone_sfondo_bianco/{{vm.warrentyModel.image}}\')"><div class="text-center"><span><span class="rdetail-font-size text-uppercase" translate="{{vm.warrentyModel.title}}"></span></span><div class="button-row"><button disabled="disabled" uib-tooltip="{{ vm.receipt.shop.id ? \'garanteasyApp.purchasedProduct.addWarrantyClaim\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate | capitalize }}" class="btn btn-default btn-dark" style="margin-right: 0.5rem"><span class="fas fa-wrench"></span></button> <button disabled="disabled" uib-tooltip="{{ vm.receipt.shop.id ? \'garanteasyApp.purchasedProduct.detail.lack\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate | capitalize }}" class="btn btn-default btn-dark"><span class="fas fa-user-shield"></span></button></div></div></div><div><div class="row"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.coverageGrid"></span> <img ng-if="vm.purchasedProductWarranty.warranty.protectedRisk === \'DEFECT\' " src="../../../content/images/icone_new/icone_garanzie/DIFETTO.png" class="img-responsive" style="height: 26px; display: inline-block"> <img ng-if="vm.purchasedProductWarranty.warranty.protectedRisk === \'ACCIDENTAL_DAMAGE\' " src="../../../content/images/icone_new/icone_garanzie/CADUTA_ACCIDENTALE.png" class="img-responsive" style="height: 26px; display: inline-block"> <img ng-if="vm.purchasedProductWarranty.warranty.protectedRisk === \'FALL_DAMAGE\' " src="../../../content/images/icone_new/icone_garanzie/DANNO.png" class="img-responsive" style="height: 26px; display: inline-block"> <img ng-if="vm.purchasedProductWarranty.warranty.protectedRisk === \'THEFT\' " src="../../../content/images/icone_new/icone_garanzie/LADRO.png" class="img-responsive" style="height: 26px; display: inline-block"> <span ng-if="vm.purchasedProductWarranty.warranty.protectedRisk" class="rdetail-font-size" translate="garanteasyApp.purchasedProductWarranty.protectedRisk.{{vm.purchasedProductWarranty.warranty.protectedRisk}}">protectedRisk</span></div><div class="row"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.issuerGrid"></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.resolveGuarantor(vm.purchasedProductWarranty)}}</span></div><div class="row" ng-if="vm.purchasedProductWarranty.warranty.contractType === \'SERVICE_CONTRACT\'"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.warrantyName"></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProductWarranty.warranty.description}}</span></div><div class="row" ng-if="vm.isNewWarranty"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.warrantyName"></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProductWarranty.warranty.description}}</span></div><div class="row" ng-if="vm.purchasedProductWarranty.warranty"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.useCard"></span> <span class="rdetail-font-size col-xs-8 col-sm-9"><span ng-if="vm.purchasedProductWarranty.receipt.business">{{\'garanteasyApp.receipt.list.professional\' | translate}}</span> <span ng-if="!vm.purchasedProductWarranty.receipt.business">{{\'garanteasyApp.receipt.list.personal\' | translate}}</span></span></div><div class="row" ng-if="vm.warrenty.warranty"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.durationGrid"></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProductWarranty.warranty.validity}} {{\'garanteasyApp.timeUnit.\'+vm.purchasedProductWarranty.warranty.validityUnit | translate}}</span></div><div class="row" ng-if="vm.purchasedProductWarranty.warranty"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.startGrid"></span> <span class="rdetail-font-size col-xs-8 col-sm-9"><i style="color: red" ng-if="!vm.purchasedProductWarranty.startDate" class="fas fa-exclamation-triangle"></i>{{vm.purchasedProductWarranty.startDate | date : \'dd/MM/yy\' : timezone}}</span></div><div class="row" ng-if="vm.purchasedProductWarranty.warranty"><span class="col-xs-4 col-sm-3 text-muted" translate="garanteasyApp.purchasedProductWarranty.list.endGrid"></span> <span class="rdetail-font-size col-xs-8 col-sm-9"><i style="color: red" ng-if="!vm.purchasedProductWarranty.expirationDate" class="fas fa-exclamation-triangle"></i>{{vm.purchasedProductWarranty.expirationDate | date : \'dd/MM/yy\' : timezone}}</span></div><div class="row" ng-if="vm.purchasedProductWarranty"><span class="col-xs-4 col-sm-3"><span ng-if="vm.purchasedProductWarranty.warranty.code === \'LAW_GENERAL\'" class="fas fa-balance-scale"></span> <span ng-if="vm.purchasedProductWarranty.warranty.code != \'LAW_GENERAL\'" class="fas fa-industry"></span> <span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.statusGrid"></span></span> <span ng-if="vm.purchasedProductWarranty.status" class="rdetail-font-size col-xs-8 col-sm-6"><span class="text-nowrap"><span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.purchasedProductWarranty.status | translate}}" class="badge {{vm.purchasedProductWarranty.status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.purchasedProductWarranty.status | translate}}</span></span></div><div class="row" ng-if="vm.purchasedProductWarranty"><span class="col-xs-4 col-sm-3 text-muted"><i class="fas fa-stopwatch"></i></span> <span class="rdetail-font-size col-xs-8 col-sm-9"><i style="color: yellow" ng-if="!vm.purchasedProductWarranty.dayToExpiration" class="fas fa-exclamation-triangle"></i> <span ng-if="vm.purchasedProductWarranty.dayToExpiration">- {{vm.purchasedProductWarranty.dayToExpiration}} giorni</span></span></div><div class="row" ng-if="vm.cmsWarrantyData && vm.cmsWarrantyData.limitation_type"><span class="rdetail-font-size col-xs-8 col-sm-9"><span translate="garanteasyApp.purchasedProductWarranty.limitationType">limitation type:</span> <span translate="garanteasyApp.purchasedProductWarranty.limitationTypeValue.{{vm.cmsWarrantyData.limitation_type}}">value</span></span></div><div class="row" ng-if="vm.cmsWarrantyData && vm.cmsWarrantyData.limitations"><span class="rdetail-font-size col-xs-8 col-sm-9"><span translate="garanteasyApp.purchasedProductWarranty.limitations">limitations:</span></span></div><div class="row" ng-if="vm.cmsWarrantyData && vm.cmsWarrantyData.limitations"><span class="rdetail-font-size"><textarea rows="3" cols="80" style="resize: none; margin-left: 15px" ng-model="vm.cmsWarrantyData.limitations" readonly="readonly"></textarea></span></div><div class="row" ng-if="vm.cmsWarrantyData && vm.cmsWarrantyData.automatic_activation"><span class="rdetail-font-size col-xs-8 col-sm-9"><span translate="garanteasyApp.purchasedProductWarranty.automaticActivation">automatic activation:</span> <span translate="garanteasyApp.purchasedProductWarranty.automaticActivationValue.{{vm.cmsWarrantyData.automatic_activation}}">value</span></span></div></div><!-- <div ng-if="!vm.isEdit" class="hidden-print pull-right hidden-xs">\n            <button ng-if="vm.purchasedProduct && !vm.hideExpandButton"\n                ui-sref="purchased-product.detail({id: vm.purchasedProduct.id, warrantyId: vm.purchasedProductWarranty.id})"\n                class="btn btn-default btn-dark"><span class="fas fa-expand-arrows-alt"></span></button>\n            <button ng-if="!vm.purchasedProduct && !vm.hideExpandButton" class="btn btn-default btn-dark"\n                ui-sref="receipt.detail({id: vm.purchasedProductWarranty.receipt.id, warrantyId: vm.purchasedProductWarranty.id})"><span\n                    class="fas fa-expand-arrows-alt"></span></button>\n            <button ng-if="!vm.isNewWarranty"\n                uib-tooltip="{{ vm.receipt.shop.id ? \'garanteasyApp.purchasedProduct.detail.lack\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate | capitalize }}"\n                class="btn btn-default btn-dark"><span class="fas fa-user-shield"></span></button>\n            <button ng-if="!vm.isNewWarranty" ng-click="vm.editWarranty();" class="btn btn-default btn-dark"\n                ng-disabled="vm.isOfficial" uib-tooltip="{{\'garanteasyApp.receipt.detail.edit\' | translate}}"><span\n                    class="fas fa-pen"></span></button>\n            <button ng-if="$last && !vm.isNewWarranty"" ng-click=" vm.addNewExtraWarranty()"\n                class="btn btn-default btn-dark" style="margin-right: 0.8rem;"><i class="fas fa-plus"></i></button>\n        </div> --><div ng-if="vm.purchasedProductWarranty && vm.cmsWarrantyData.warranty_link && !vm.edit"><a href="{{vm.cmsWarrantyData.warranty_link}}" target="_blank" translate="garanteasyApp.purchasedProductWarranty.warrantyLink">warrantyLink</a></div><div ng-if="vm.purchasedProductWarranty && vm.cmsWarrantyData.warranty_pdf && !vm.edit"><a href="{{vm.cmsUri + vm.cmsWarrantyData.warranty_pdf}}" target="_blank" translate="garanteasyApp.purchasedProductWarranty.contractLink">contractLink</a></div><div ng-if="vm.edit"><ng-form name="extraWarrantyForm" novalidate><div style="min-height: 120px"><warranty-edit-component on-update="vm.onUpdateWarranty" purchased-product-warranty="vm.purchasedProductWarranty" purchased-product="vm.purchasedProductWarranty.purchasedProduct" is-edit="true"></warranty-edit-component></div><div class="pull-right"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancelEdit();"><span class="glyphicon glyphicon-ban-circle"></span><span translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="!extraWarrantyForm.$valid" ng-click="vm.onSave()" class="btn btn-default btn-dark"><span translate="entity.action.save">Save</span></button></div></ng-form></div></div></div>');
$templateCache.put('app/entities/card/card-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.card.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.card.delete.question">Are you sure you want to delete this Card?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/card/card-detail.html','<div><h2 class="main-title"><span translate="garanteasyApp.card.detail.title">Card</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="garanteasyApp.card.number">Number</span></dt><dd><span>{{vm.card.number}}</span></dd><dt><span translate="garanteasyApp.card.cardType">cardType</span></dt><dd><span>{{vm.card.cardType.description}}</span></dd><dt><span translate="garanteasyApp.card.activationDate">Activation Date</span></dt><dd><span>{{vm.card.activationDate | date:\'mediumDate\'}}</span></dd><dt><span translate="garanteasyApp.card.expirationDate">Expiration Date</span></dt><dd><span>{{vm.card.expirationDate | date:\'mediumDate\'}}</span></dd><dt><span translate="garanteasyApp.card.owner">Owner</span></dt><dd><span>{{vm.card.contact.user.login}}</span></dd></dl><div ng-if="vm.cardCustomers.length > 0"><h3 translate="garanteasyApp.cardCustomer.home.title">Card Customer</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.cardCustomer.customer.legalName">Customer</span></th><th><span translate="garanteasyApp.cardCustomer.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="cardCustomer in vm.card.cardCustomers"><td>{{cardCustomer.customer.legalName}}</td><td>{{cardCustomer.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.setCardCustomerId(cardCustomer.id)" ui-sref="cardCustomer.detail({id:cardCustomer.id, from: \'card/detail({id:{{vm.card.id}}})\' ,cardId :\'{{vm.card.id}}\'})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button ng-click="vm.setCardCustomerId(cardCustomer.id)" ng-if="vm.isOwner()" type="submit" ui-sref="card/card-customer-edit({id:{{vm.card.id}}, from: {{vm.card.id}} })" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button ng-click="vm.setCardCustomerId(cardCustomer.id)" type="submit" ui-sref="card/card-customer-delete({ccId:cardCustomer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><button class="btn btn-info" ui-sref="settings()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.card.goToSettings">Go to Receipt</span></button></div>');
$templateCache.put('app/entities/card/card-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCardLabel" translate="garanteasyApp.card.home.createOrEditLabel">Create or edit a Card</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.card.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.card.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.card.number" for="field_number">Number</label><input type="text" class="form-control" name="number" id="field_number" ng-model="vm.card.number" required><div ng-show="editForm.number.$invalid"><p class="help-block" ng-show="editForm.number.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.card.activationDate" for="field_activationDate">Activation Date</label><div class="input-group"><input id="field_activationDate" type="text" class="form-control" name="activationDate" uib-datepicker-popup="mediumDate" ng-model="vm.card.activationDate" is-open="vm.datePickerOpenStatus.activationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'activationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.card.expirationDate" for="field_expirationDate">Expiration Date</label><div class="input-group"><input id="field_expirationDate" type="text" class="form-control" name="expirationDate" uib-datepicker-popup="mediumDate" ng-model="vm.card.expirationDate" is-open="vm.datePickerOpenStatus.expirationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expirationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><!-- <div ng-show="editForm.expirationDate.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.expirationDate.$error.required" translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>--></div><div class="form-group"><label translate="garanteasyApp.card.type" for="field_cardType">Type</label><select class="form-control" id="field_cardType" name="cardType" ng-model="vm.card.cardType" ng-options="type as type.description for type in vm.cardTypes | orderBy:\'id\' track by type.id" required><option value=""></option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="garanteasyApp.card.contact" for="field_contact">contact</label><input type="text" class="form-control" name="contact" id="field_contact" value="{{vm.card.contact.channel}}" readonly="readonly"></div><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="garanteasyApp.contact.contactChoose" for="field_contact">Choose a contact...</label></uib-tab-heading><ng-form name="nestedForm"><!-- Typeahead search (search among all shops) --><ui-select reset-search-input="false" ng-model="vm.card.contact" ng-disabled="vm.disableEdit()"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.contact.typeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.channel"></div></ui-select-match><ui-select-choices refresh="loadContacts($select.search)" refresh-delay="200" repeat="contact in (contacts) track by contact.id"><div ng-bind="contact.channel"></div></ui-select-choices></ui-select></ng-form></uib-tab><uib-tab index="1" select="resetContact()"><uib-tab-heading><label translate="garanteasyApp.card.contactCreate" for="field_contact">Or create a new one if missing</label></uib-tab-heading><div class="form-group"><label class="control-label" translate="garanteasyApp.contact.channel" for="field_channel">Channel</label><input ng-disabled="vm.disableEdit()" type="email" class="form-control" name="channel" id="field_channel" placeholder="{{\'global.form.emailPlaceholder\' | translate}}" ng-model="vm.card.contact.channel" ng-minlength="5" ng-maxlength="100" required><div ng-show="editForm.channel.$invalid"><p class="help-block" ng-show="editForm.channel.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="editForm.channel.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="editForm.channel.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.channel.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.contact.primaryContact" for="field_primaryContact">Primary Contact</label><input ng-disabled="vm.disableEdit()" type="checkbox" class="form-control" name="primaryContact" id="field_primaryContact" ng-model="vm.card.contact"><div ng-show="editForm.primaryContact.$invalid"><p class="help-block" ng-show="editForm.primaryContact.$error.required" translate="entity.validation.required">This field is required.</p></div></div></uib-tab></uib-tabset><div class="form-group"><label translate="garanteasyApp.card.phoneNumber" for="field_phoneNumber">phoneNumber</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" value="{{vm.card.phoneNumber.phoneNumber}}" readonly="readonly"></div><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="garanteasyApp.phoneNumber.phoneNumberChoose" for="field_phoneNumber">Choose a phoneNumber...</label></uib-tab-heading><ng-form name="nestedForm"><!-- Typeahead search (search among all shops) --><ui-select reset-search-input="false" ng-model="vm.card.phoneNumber"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.phoneNumber.typeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.phoneNumber"></div></ui-select-match><ui-select-choices refresh="loadPhoneNumbers($select.search)" refresh-delay="200" repeat="phoneNumber in (phoneNumbers) track by phoneNumber.id"><div ng-bind="phoneNumber.phoneNumber"></div></ui-select-choices></ui-select></ng-form></uib-tab><uib-tab index="1" select="resetPhoneNumber()"><uib-tab-heading><label translate="garanteasyApp.card.phoneNumberCreate" for="field_number">Or create a new one if missing</label></uib-tab-heading><div class="form-group"><label class="control-label" translate="garanteasyApp.phoneNumber.phoneNumber" for="field_phoneNumber_">Phone Number</label><input type="text" class="form-control" name="phoneNumber_" id="field_phoneNumber_" ng-model="vm.card.phoneNumber.phoneNumber"><!--<div ng-show="editForm.phoneNumber.$invalid">\n                        <p class="help-block"\n                           ng-show="editForm.phoneNumber.$error.required" translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                    </div>--></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-blur="vm.closeWindow()" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/card/card-request-use-card-dialog.html','<form name="deleteForm" ng-submit="vm.confirmRequestUse(vm.card.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="garanteasyApp.card.requestUseCard.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-if="!vm.card.flowMerchant || vm.card.contact"><p translate="garanteasyApp.card.requestUseCard.question">Existing card. Do you want to become a user for it?</p></div><div ng-if="vm.card.flowMerchant && !vm.card.contact"><label translate="garanteasyApp.card.requestUseCard.questionPostCode" for="postalCode">Set your Postal Code</label><input type="text" class="form-control" name="postalCode" id="postalCode" ng-model="vm.postalCode"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span translate="garanteasyApp.card.requestUseCard.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/card/cards.html','<div><h2 class="main-title" translate="garanteasyApp.card.home.title">Cards</h2><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="card/new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.card.home.createLabel">Create new card</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.card.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.card.number">number</span></th><th><span translate="garanteasyApp.card.activationDate">activationDate</span></th><th><span translate="garanteasyApp.card.expirationDate">expirationDate</span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td><a ui-sref="card-detail({id:card.id})">{{card.number}}</a></td><td>{{card.activationDate | date:\'mediumDate\'}}</td><td>{{card.expirationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="card-detail({id:card.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="card/edit({id:card.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="card/delete({id:card.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/contact/contact-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contact.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.contact.delete.question" translate-values="{channel: \'{{vm.contact.channel}}\'}">Are you sure you want to delete this Contact?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/contact/contact-detail.html','<div><h2 class="main-title"><span translate="garanteasyApp.contact.detail.title">Contact</span> {{vm.contact.channel}}</h2><div ncy-breadcrumb></div><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="garanteasyApp.contact.channel">Channel</span></dt><dd><span>{{vm.contact.channel}}</span></dd><dt><span translate="garanteasyApp.contact.primaryContact">Primary Contact</span></dt><dd><span>{{vm.contact.primaryContact | booleanAsYesNo | translate}}</span></dd><dt><span translate="garanteasyApp.contact.activated">Activated</span></dt><dd><span>{{vm.contact.activated | booleanAsYesNo | translate}}</span></dd></dl><button type="button" ui-sref="contact-detail/edit({id:vm.contact.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/contact/contact-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContactLabel" translate="garanteasyApp.contact.home.createOrEditLabel">Create or edit a Contact</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" translate="garanteasyApp.contact.channel" for="field_channel">Channel</label><input type="email" class="form-control" name="channel" id="field_channel" placeholder="{{\'global.form.emailPlaceholder\' | translate}}" ng-model="vm.contact.channel" ng-minlength="5" ng-maxlength="100" required><div ng-show="editForm.channel.$invalid"><p class="help-block" ng-show="editForm.channel.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="editForm.channel.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="editForm.channel.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.channel.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.contact.primaryContact" for="field_primaryContact">Primary Contact</label><input type="checkbox" class="form-control" name="primaryContact" id="field_primaryContact" ng-model="vm.contact.primaryContact"><div ng-show="editForm.primaryContact.$invalid"><p class="help-block" ng-show="editForm.primaryContact.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/contact/contacts.html','<div><h2 class="main-title" translate="garanteasyApp.contact.home.title">Contacts</h2><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="contact/new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.contact.home.createLabel">Create new Contact</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.contact.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.contact.channel">Channel</span></th><th><span translate="garanteasyApp.contact.primaryContact">Primary Contact</span></th><th><span translate="garanteasyApp.contact.activated">Activated</span></th><th></th></tr></thead><tbody><tr ng-repeat="contact in vm.contacts track by contact.id"><td>{{contact.channel}}</td><td>{{contact.primaryContact | booleanAsYesNo | translate}}</td><td>{{contact.activated | booleanAsYesNo | translate}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contact-detail({id:contact.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="contact/edit({id:contact.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="contact/delete({id:contact.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/customer/customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.customer.delete.question" translate-values="{legalName: \'{{vm.customer.legalName}}\'}">Are you sure you want to delete this Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customer/customer-detail.html','<!--<div class="col-xs-12 col-sm-3" ng-include="\'app/layouts/sidebar/sidebar.html\'"></div>--><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><div class="row"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error></div><div class="row-fluid"><div class="main-wrapper"><div class="main"><!-- <span style="font-size: xx-large">{{vm.customer.legalName}}</span> --><h4 translate="garanteasyApp.customer.client"></h4><div class="row product-details-wrapper"><div class="col-xs-12"><form name="editForm" role="form" novalidate ng-submit="vm.save()" class="tab-form-demo"><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.name" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><strong>{{vm.showCustomerName(vm.customer)}}</strong></span></div><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.email" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><strong>{{vm.customer.user.login}}</strong></span></div><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.phone" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><strong><span ng-repeat="phoneNumber in vm.customer.phoneNumbers">{{phoneNumber.phoneNumber}}<br></span></strong></span></div><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.card" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><strong><span ng-repeat="card in vm.customer.cards">{{card.card.number}}<br></span></strong></span></div><!-- <div ng-if="!vm.isEdit" style="margin-top: 10px;" class="row">\n                            <span style="font-size: large" translate="garanteasyApp.customer.type"\n                                class=" col-xs-4"></span>\n                            <span style="font-size: large" class="col-xs-8">\n                                <strong> {{vm.buy(vm.customer.business)}} </strong>\n                            </span>\n                        </div> --><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.registrationDate" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><!--<strong>{{vm.customer.user.createdDate | date:\'mediumDate\'}}  </strong>--></span></div><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.receipts" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><a ui-sref="receipt/customer({customerId:vm.customer.id})"><strong>{{vm.receiptCount }}</strong></a></span></div><div ng-if="!vm.isEdit" style="margin-top: 10px" class="row"><span style="font-size: large" translate="garanteasyApp.customer.lastReceipt" class="col-xs-4"></span> <span style="font-size: large" class="col-xs-8"><a ui-sref="receipt/detail({id:vm.lastReceipt.id})"><strong>{{vm.lastReceipt.creationDate | date:\'mediumDate\'}}</strong></a></span></div></form></div><br><br></div></div></div></div>');
$templateCache.put('app/entities/customer/customer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerLabel" translate="garanteasyApp.customer.home.createOrEditLabel">Create or edit a Customer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customer.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.customer.legalName" for="field_legalName">Legal Name</label><input type="text" class="form-control" name="legalName" id="field_legalName" ng-model="vm.customer.legalName" required><div ng-show="editForm.legalName.$invalid"><p class="help-block" ng-show="editForm.legalName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.customer.vatid" for="field_vatid">Vatid</label><input type="text" class="form-control" name="vatid" id="field_vatid" ng-model="vm.customer.vatid"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.customer.business" for="field_business">Business</label><input type="checkbox" class="form-control" name="business" id="field_business" ng-model="vm.customer.business"><div ng-show="editForm.business.$invalid"><p class="help-block" ng-show="editForm.business.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!--\n        <div class="form-group">\n            <label translate="garanteasyApp.customer.address" for="field_address">Address</label>\n            <select class="form-control" id="field_address" name="address" ng-model="vm.customer.address" ng-options="address as address.id for address in vm.customer.addresses | orderBy:\'id\' track by address.id">\n                <option value=""></option>\n            </select>\n        </div>\n --><div class="form-group"><label class="control-label" translate="garanteasyApp.address.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" ng-model="vm.customer.address.street" required><div ng-show="editForm.street.$invalid"><p class="help-block" ng-show="editForm.street.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.address.locality" for="field_locality">Locality</label><input type="text" class="form-control" name="locality" id="field_locality" ng-model="vm.customer.address.locality"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.address.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.customer.address.city" required><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.address.region" for="field_region">Region</label><input type="text" class="form-control" name="region" id="field_region" ng-model="vm.customer.address.region"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.address.postcode" for="field_postcode">Postcode</label><input type="text" class="form-control" name="postcode" id="field_postcode" ng-model="vm.customer.address.postcode"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.address.country" for="field_country">Country</label><select class="form-control" name="country" id="field_country" ng-model="vm.customer.address.country.code" pvp-country-picker></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/customer/customers.html','<div><h4><span translate="garanteasyApp.customer.home.title">Customers</span><div class="pull-right hidden-xs"><button class="btn btn-default" ng-click="vm.gridView = true;" data-ng-disabled="vm.gridView"><span class="fas fa-th"></span></button> <button class="btn btn-default" ng-click="vm.gridView = false;" data-ng-disabled="!vm.gridView"><span class="fas fa-th-list"></span></button></div></h4><!--<div ncy-breadcrumb></div>--><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><br><div class="table-responsive" ng-if="!vm.gridView"><table class="jh-table table table-striped"><thead class="header-nowrap"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="th-green" jh-sort-by="customer.legalName"><span translate="garanteasyApp.customer.legalName">Legal Name</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="customer.user.login"><span translate="garanteasyApp.customer.email">Email</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green"><span translate="garanteasyApp.customer.card">Cards</span><!-- <span class="glyphicon glyphicon-sort"></span> --></th><th class="th-green"><span translate="garanteasyApp.customer.receipts">Receipts</span><!-- <span class="glyphicon glyphicon-sort"></span> --></th><th class="th-green"><span translate="garanteasyApp.customer.lastReceipt">Last Receipt</span><!-- <span class="glyphicon glyphicon-sort"></span> --></th><th class="th-green"></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="customer in vm.customers track by customer.id"><td>{{vm.showCustomerName(customer)}}</td><td><a ui-sref="customer-detail({id:customer.id})">{{customer.user.login}}</a></td><td><span ng-repeat="card in customer.cards">{{card.card.number}}<br></span></td><td><a ui-sref="receipt/customer({customerId:customer.id})">{{customer.receiptCount }}</a></td><td><a ui-sref="receipt/detail({id:customer.lastReceipt.id})">{{customer.lastReceipt.creationDate | date:\'mediumDate\'}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-default btn-dark" ui-sref="customer-detail({id:customer.id})"><span class="glyphicon glyphicon-search"></span></button></div></td></tr></tbody></table></div><div class="row" ng-if="vm.gridView" infinite-scroll="vm.loadPage(+vm.page + 1)" infinite-scroll-distance="3" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><div class="col-lg-3 col-sm-6" ng-repeat="customer in vm.customers track by customer.id"><!-- <card-customer customer="customer"></card-customer> --><list-item-customer customer="customer"></list-item-customer></div></div></div>');
$templateCache.put('app/entities/dashboard/dashboard.html','<div class="row"><div class="col-md-7 col-lg-8"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><!-- As the validRecepits return always 0 the below section is temporary commented--><!-- <div class="well">\n            <h4> <span style="color:black" translate="garanteasyApp.sidebar.dashboardTitle"\n                    class="g-title">Garanzie</span></h4>\n            <div class="row">\n                <div class="col-sm-6 col-md-4">\n                    <a href="#" ui-sref="receipt">\n                        <span class="badge valid">{{vm.summary.valid}}</span>\n                        <span translate="garanteasyApp.sidebar.active" class="g-title"></span>\n                    </a>\n                </div>\n                <div class="col-sm-6 col-md-4">\n                    <a href="#" ui-sref="receipt">\n                        <span class="badge aboutToExpire">{{vm.summary.expiring}}</span>\n                        <span translate="garanteasyApp.sidebar.expiring" class="g-title">IN\n                            SCADENZA</span>\n                    </a>\n\n                </div>\n                <div class="col-sm-6 col-md-4">\n                    <a href="#" ui-sref="receipt">\n                        <span class="badge expired">{{vm.summary.expired}}</span>\n                        <span translate="garanteasyApp.sidebar.expired" class="g-title">SCADUTA</span>\n                    </a>\n                </div>\n            </div>\n        </div> --><!-- As the validRecepits return always 0 the above section is temporary commented--><!-- <div class="card" ng-if="vm.customers.length">\n            <h4>&nbsp;\n                <span translate="garanteasyApp.dashboard.customer.title">Customers</span>\n            </h4>\n            <div>\n                <div class="table-responsive">\n                    <table class="jh-table table table-striped">\n                        <thead>\n                            <tr>\n                                <th><span translate="garanteasyApp.dashboard.customer.legalName">Legal Name</span>\n                                </th>\n                                <th><span>Email</span></th>\n                                <th><span translate="garanteasyApp.dashboard.customer.business">Business</span></th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat="customer in vm.customers">\n                                <td><a ui-sref="customer-detail({id:customer.id})">{{vm.showCustomerName(customer)}}</a>\n                                </td>\n                                <td>{{customer.user.login}}</td>\n                                <td>\n                                    <span ng-if="customer.business"\n                                        translate="garanteasyApp.dashboard.receipt.purchaseTypeValue.professional"></span>\n                                    <span ng-if="!customer.business"\n                                        translate="garanteasyApp.dashboard.receipt.purchaseTypeValue.private"></span>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div> --><div class="card" ng-if="vm.receipts.length"><h4>&nbsp; <span translate="garanteasyApp.dashboard.receipt.title">receipt</span> (Cod. {{vm.model.merchant.code}} {{vm.model.shop.code}})</h4><div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.dashboard.receipt.number">Code</span></th><th><span translate="garanteasyApp.dashboard.receipt.date">date</span></th><th><span translate="garanteasyApp.dashboard.products.shop">Shop code</span></th><th translate="garanteasyApp.dashboard.receipt.customer"><span>customer</span></th><th><span>Email</span></th><th></th></tr></thead><tbody><tr ng-repeat="receipt in vm.receipts"><td>{{receipt.receiptNumber }}</td><td>{{receipt.buyingDate | date:\'dd MMM yyyy\' }}</td><td>{{receipt.shop.code}} ({{receipt.shop.shopSignboard}})</td><td>{{vm.showCustomerName(receipt.customer)}}</td><td><a ui-sref="customer-detail({id:receipt.customer.id})">{{receipt.customer.user.login}}</a></td><td><a class="btn btn-default btn-dark" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="receipt/detail({id:receipt.id})"><span class="fas fa-expand-arrows-alt"></span></a></td></tr></tbody></table></div></div></div><div class="card" ng-if="vm.productSales.length"><h4>&nbsp; <span translate="garanteasyApp.dashboard.products.title">products</span></h4><div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.dashboard.products.name">name</span></th><th translate="garanteasyApp.dashboard.products.name"><span>customer</span></th></tr></thead><tbody><tr ng-repeat="product in vm.productSales"><td>{{product.product.brandAndName }}</td><td>{{product.shop.description}}</td></tr></tbody></table></div></div></div></div><div class="col-md-5 col-lg-4 text-muted tutorial"><ul class="list-group"><li class="list-group-item"><h5><i class="fas fa-plus align-top"></i> <span translate="garanteasyApp.dashboard.productGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.productGuide.description"></span></p></li><li class="list-group-item"><h5><i class="fas fa-cloud-upload-alt align-top"></i> <span translate="garanteasyApp.dashboard.receiptShopGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.receiptShopGuide.description"></span></p><!-- <a href="mailto:archivio@garanteasy.com">archivio@garanteasy.com</a> --></li><li class="list-group-item"><h5><i class="fas fa-camera align-top"></i> <span translate="garanteasyApp.dashboard.photoGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.photoGuide.description"></span></p></li><li class="list-group-item"><h5><i class="fas fa-user-shield align-top"></i> <span translate="garanteasyApp.dashboard.defectGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.defectGuide.description"></span></p></li><li class="list-group-item"><h5><i class="fas fa-life-ring"></i> <span translate="garanteasyApp.dashboard.technicalSupportGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.technicalSupportGuide.description"></span></p></li><li class="list-group-item"><h5><i class="fas fa-info-circle align-top"></i> <span translate="garanteasyApp.dashboard.infoGuide.title">title</span></h5><p><span translate="garanteasyApp.dashboard.infoGuide.description"></span></p></li></ul><!-- ********** INIZIO SECONDO BLOCCO ***************--></div></div>');
$templateCache.put('app/entities/dashboard/dashboard_OLD.html','<div class="row"><span class="main-title" translate="garanteasyApp.dashboard.title">dashboard</span></div><div class="row" style="margin-top: 40px"><ng-form class="col-xs-12 col-sm-offset-2 col-sm-4" name="nestedForm" ng-show="vm.viewSuggestionMerchant"><div class="form-group"><!-- Typeahead search (search among all merchant) --><ui-select reset-search-input="false" ng-model="vm.merchant" ng-change="vm.merchantSelected(vm.merchant.id)"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.dashboard.merchantPlaceholder\' | translate}}"><div ng-bind="$select.selected.companyName"></div></ui-select-match><ui-select-choices refresh="vm.loadMerchants($select.search)" refresh-delay="200" repeat="merchant in (merchants) track by merchant.id"><div ng-bind="merchant.companyName"></div></ui-select-choices></ui-select></div></ng-form><div class="col-xs-12 col-sm-offset-2 col-sm-4" ng-show="vm.viewInputMerchant"><input type="text" value="{{vm.merchant.companyName}}" disabled="disabled"></div><ng-form class="col-xs-12 col-sm-4" name="nestedForm" ng-show="vm.viewSuggestionShops"><!-- Typeahead search (search among all shops) --><ui-select reset-search-input="false" ng-model="vm.shop" ng-change="vm.shopSelected(vm.shop.id)"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.dashboard.shopPlaceholder\' | translate}}"><div ng-bind="$select.selected.description"></div></ui-select-match><ui-select-choices refresh="loadShops($select.search)" refresh-delay="200" repeat="shop in (shops) track by shop.id"><div ng-bind="shop.description"></div></ui-select-choices></ui-select></ng-form></div><div class="panel col-xs-12 col-sm-5 col-md-5 col-lg-5 panel-dashboard"><div class="panel-heading"><h6 class="main-title-half-page" translate="garanteasyApp.dashboard.receipt.title">Receipts</h6></div><div class="panel-body"><!-- <div ncy-breadcrumb></div>--><div class="table-responsive"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th class="th-green" jh-sort-by="buyingDate"><span translate="garanteasyApp.dashboard.receipt.buyingDate">Buying Date</span></th><th class="th-green" jh-sort-by="description"><span translate="garanteasyApp.dashboard.receipt.description">Description</span></th><!--<th class="th-green" jh-sort-by="shop.owner.name"><span translate="garanteasyApp.dashboard.receipt.shop">Shop</span> </th>--><th><span translate="garanteasyApp.dashboard.receipt.products">Prodotti</span></th><th><span translate="garanteasyApp.dashboard.receipt.warranty">Garanzie</span></th><th></th></tr></thead><tbody style="border: 1px solid #dddddd" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="receipt in vm.receipts track by receipt.id" ng-switch on="receipt.source"><td>{{receipt.buyingDate | date:\'mediumDate\'}}</td><td class="td-gray">{{vm.abbreviate(receipt.description)}}</td><!--<td  ng-show="receipt.shop"><a style="color:black" ui-sref="shop-detail({id:receipt.shopId, from: \'receipt\'})">{{receipt.shop.description}}</a></td>--> <!--<td  ng-show="!receipt.shop"><span translate="global.undefinedSM">Non definito</span></td>--><td class="td-gray">{{receipt.purchasedProducts.length > 0 ? receipt.purchasedProducts.length : \'global.undefinedPM\' | translate}}</td><td><span title="{{\'garanteasyApp.warranty.status.valid\' | translate}}" ng-show="receipt.totalWarranties.numValid > 0" class="badge valid">{{receipt.totalWarranties.numValid}}</span> <span title="{{\'garanteasyApp.warranty.status.aboutToExpire\' | translate}}" ng-show="receipt.totalWarranties.numExpiring > 0" class="badge aboutToExpire">{{receipt.totalWarranties.numExpiring}}</span> <span title="{{\'garanteasyApp.warranty.status.expired\' | translate}}" ng-show="receipt.totalWarranties.numExpired > 0" class="badge expired">{{receipt.totalWarranties.numExpired}}</span></td><td class="text-right td-gray"><div class="action-list btn-group flex-btn-group-container"><button class="button-search" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="receipt/detail({id:receipt.id})"><span class="glyphicon glyphicon-search"></span><!--<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>--></button></div></td></tr></tbody></table></div></div></div><div class="panel col-xs-12 col-sm-5 col-md-5 col-lg-5 col-sm-offset-2 panel-dashboard"><div class="panel-heading"><h6 class="main-title-half-page" translate="garanteasyApp.dashboard.customers.title">Customers</h6></div><div class="panel-body"><!-- <div ncy-breadcrumb></div>--><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th class="th-green" jh-sort-by="buyingDate"><span translate="garanteasyApp.dashboard.customers.name">Name</span></th><th class="th-green" jh-sort-by="description"><span translate="garanteasyApp.dashboard.customers.birthDate">Description</span></th><th></th></tr></thead><tbody style="border: 1px solid #dddddd" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="customer in vm.customers track by customer.id" ng-switch on="receipt.source"><td>{{customer.legalName}}</td><td class="td-gray">{{customer.birthDate | date:\'mediumDate\'}}</td><td class="text-right td-gray"><div class="action-list btn-group flex-btn-group-container"><button class="button-search" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="customer-detail({id:customer.id})"><span class="glyphicon glyphicon-search"></span><!--<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>--></button></div></td></tr></tbody></table></div></div></div><div class="col-xs-12 col-sm-4"><label>{{\'garanteasyApp.dashboard.sales.question\' | translate}}</label><select ng-model="vm.interval" class="form-control" id="format" ng-options="time for time in vm.time" ng-change="vm.getProductSales(vm.merchant,vm.shop)"></select></div><div class="panel col-xs-12 panel-dashboard"><div class="panel-heading"><h6 class="main-title-half-page" translate="garanteasyApp.dashboard.sales.title">Sales</h6></div><div class="panel-body"><!-- <div ncy-breadcrumb></div>--><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th class="th-green" jh-sort-by="product.name"><span translate="garanteasyApp.dashboard.sales.product">product</span></th><th class="th-green" jh-sort-by="product.description"><span translate="garanteasyApp.dashboard.sales.description">Shop</span></th><th><span translate="garanteasyApp.dashboard.sales.totalSales">Vendite</span></th><th></th></tr></thead><tbody style="border: 1px solid #dddddd" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="productSale in vm.productSales"><td>{{productSale.product.name}}</td><td class="td-gray">{{productSale.product.description}}</td><td>{{productSale.sales}}</td></tr></tbody></table></div></div></div><div class="panel col-xs-12 panel-dashboard" ng-if="vm.isAdmin"><div class="panel-heading"><h6 class="main-title-half-page" translate="garanteasyApp.dashboard.garanteasySales.title">Sales</h6></div><div class="panel-body"><!-- <div ncy-breadcrumb></div>--><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th class="th-green" jh-sort-by="product.name"><span translate="garanteasyApp.dashboard.sales.product">product</span></th><th class="th-green" jh-sort-by="product.description"><span translate="garanteasyApp.dashboard.sales.description">Shop</span></th><th class="th-green" jh-sort-by="merchant.companyName"><span translate="garanteasyApp.dashboard.garanteasySales.merchant">Shop</span></th><th><span translate="garanteasyApp.dashboard.sales.totalSales">Vendite</span></th><th></th></tr></thead><tbody style="border: 1px solid #dddddd" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="garanteasyProductSale in vm.garanteasyProductSales"><td>{{garanteasyProductSale.product.name}}</td><td class="td-gray">{{garanteasyProductSale.product.description}}</td><td class="td-gray">{{garanteasyProductSale.merchant.companyName}}</td><td>{{garanteasyProductSale.sales}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/dashboard/sidebar-dashboard.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div>');
$templateCache.put('app/entities/feedback/feedback-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.feedback.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.feedback.delete.question" translate-values="{id: \'{{vm.feedback.id}}\'}">Are you sure you want to delete this Feedback?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/feedback/feedback-detail.html','<div><h2 class="main-title"><span translate="garanteasyApp.feedback.detail.title">Feedback</span></h2><div ncy-breadcrumb></div><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="garanteasyApp.feedback.description">Description</span></dt><dd><span>{{vm.feedback.description}}</span></dd><dt><span translate="garanteasyApp.feedback.creationDate">Creation Date</span></dt><dd><span>{{vm.feedback.creationDate | date:\'mediumDate\'}}</span></dd><dt has-authority="ROLE_ADMIN"><span translate="garanteasyApp.feedback.feedbackType">Feedback Type</span></dt><dd has-authority="ROLE_ADMIN"><span translate="{{\'garanteasyApp.FeedbackType.\' + vm.feedback.feedbackType}}">{{vm.feedback.feedbackType}}</span></dd><dt><span translate="garanteasyApp.feedback.createdBy">Created By</span></dt><dd>{{vm.feedback.createdBy.login}}</dd></dl><button ui-sref="receipt/feedback-edit({id:vm.feedback.parentId, feedbackId:vm.feedback.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/feedback/feedback-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeedbackLabel" translate="garanteasyApp.feedback.home.createOrEditLabel">Create or edit a Feedback</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" translate="garanteasyApp.feedback.description" for="field_description">Description</label><textarea name="description" id="field_description" ng-model="vm.feedback.description" ng-maxlength="1000" cols="80" rows="10" required></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" translate="global.messages.validate.feedback.maxlength">A feedback cannot be longer than 1000 characters.</p></div></div><div ng-if="vm.feedback.feedbackType == \'WARRANTYCLAIM\'" class="form-group"><label class="control-label" translate="garanteasyApp.feedback.satisfied" for="field_satisfied">satisfied</label><input type="checkbox" class="form-control" name="satisfied" id="field_satisfied" ng-model="vm.feedback.satisfied"></div><div ng-if="vm.feedback.feedbackType == \'WARRANTYCLAIM\'" class="form-group"><label class="control-label" translate="garanteasyApp.feedback.feedbackAnswer" for="field_feedbackAnswer">feedbackAnswer</label><select class="form-control" id="field_feedbackAnswer" name="feedbackAnswer" ng-model="vm.feedback.feedbackAnswer"><option value="YES" translate="garanteasyApp.feedback.YES">YES</option><option value="NO" translate="garanteasyApp.feedback.NO">NO</option><option value="LONGER" translate="garanteasyApp.feedback.LONGER">LONGER</option><option value="SHORTER" translate="garanteasyApp.feedback.SHORTER">SHORTER</option></select></div><div class="form-group"><label class="control-label" translate="garanteasyApp.feedback.creationDate" for="field_creationDate">Creation Date</label><span>{{vm.feedback.creationDate| date:\'mediumDate\'}}</span></div><input type="hidden" class="form-control" name="feedbackType" ng-model="vm.feedback.feedbackType" id="field_feedbackType"> <input type="hidden" class="form-control" name="parentId" ng-model="vm.feedback.parentId" id="field_parentId"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/feedback/feedbacks.html','<div has-authority="ROLE_ADMIN"><h2 class="main-title" translate="garanteasyApp.feedback.home.title">Feedbacks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!-- Creazione feedback, che non ha senso se non entro una Receipt o WarrantyClaim --></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.feedback.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div><!--<div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.feedback.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>--></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span translate="garanteasyApp.feedback.description">Description</span></th><th><span translate="garanteasyApp.feedback.creationDate">Creation Date</span></th><th><span translate="garanteasyApp.feedback.parentId">Parent Id</span></th><th><span translate="garanteasyApp.feedback.feedbackType">Feedback Type</span></th><th><span translate="garanteasyApp.feedback.createdBy">Created By</span></th><th></th></tr></thead><tbody><tr ng-repeat="feedback in vm.feedbacks track by feedback.id"><td><a ui-sref="feedback-detail({id:feedback.id})">{{feedback.id}}</a></td><td>{{feedback.description}}</td><td>{{feedback.creationDate | date:\'mediumDate\'}}</td><td>{{feedback.parentId}}</td><td translate="{{\'garanteasyApp.FeedbackType.\' + feedback.feedbackType}}">{{feedback.feedbackType}}</td><td>{{feedback.createdBy.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="feedback-detail({id:feedback.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="feedback/edit({id:feedback.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="feedback/delete({id:feedback.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/purchased-product/purchased-product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.purchasedProduct.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.purchasedProduct.delete.question" translate-values="{id: \'{{vm.purchasedProduct.id}}\'}">Are you sure you want to delete this Purchased Product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/purchased-product/purchased-product-detail-OLD.html','<div><h2><span translate="garanteasyApp.purchasedProduct.detail.title">Purchased Product</span></h2><div ncy-breadcrumb></div><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="garanteasyApp.purchasedProduct.product">Product</span></dt><dd><a ui-sref="product-detail({id:vm.purchasedProduct.product.id, from2nd: \'purchased-product/detail({id:{{vm.purchasedProduct.id}}})\'})">{{vm.purchasedProduct.product.brandAndName}}</a></dd><dt><span translate="garanteasyApp.purchasedProduct.serialNumber">Serial Number</span></dt><dd><span>{{vm.purchasedProduct.serialNumber}}</span></dd><dt ng-show="vm.purchasedProduct.deliveryDate"><span translate="garanteasyApp.purchasedProduct.deliveryDate">Delivery Date</span></dt><dd ng-show="vm.purchasedProduct.deliveryDate"><span>{{vm.purchasedProduct.deliveryDate | date:\'mediumDate\'}}</span></dd></dl><dl ng-show="vm.purchasedProduct.giftReceiverDescription" class="dl-horizontal jh-entity-details"><!-- Gift section --><dt><div ng-switch="vm.purchasedProduct.giftReceiverNotified"><div ng-switch-when="1"><span translate="garanteasyApp.purchasedProduct.giftNotificatedTo">Notifica del regalo inviata a:</span></div><div ng-switch-default><span translate="garanteasyApp.purchasedProduct.giftReceiver">Gift Receiver</span></div></div></dt><dd><span>{{vm.purchasedProduct.giftReceiverDescription}}</span></dd><dt><span translate="garanteasyApp.purchasedProduct.giftMakerDescription">Gift Maker Description</span></dt><dd><span ng-show="vm.purchasedProduct.giftMakerDescription">{{vm.purchasedProduct.giftMakerDescription}}</span> <span ng-show="!vm.purchasedProduct.giftMakerDescription" translate="garanteasyApp.purchasedProduct.giftMakerAnonymous">Donatore anonimo</span></dd><dt ng-show="vm.purchasedProduct.giftDescription"><span translate="garanteasyApp.purchasedProduct.giftDescription">Gift Description</span></dt><dd ng-show="vm.purchasedProduct.giftDescription"><span>{{vm.purchasedProduct.giftDescription}}</span></dd><dt><span translate="garanteasyApp.purchasedProduct.giftNotificationDate">Gift Notification Date</span></dt><dd><span>{{vm.purchasedProduct.giftNotificationDate | date:\'mediumDate\'}}</span></dd></dl><div><h3 translate="garanteasyApp.warranty.home.title">Warranties</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.warranty.description">Description</span></th><th><span translate="garanteasyApp.warranty.duration">Duration</span></th><th><span translate="garanteasyApp.warranty.expirationDate">Expiration Date</span></th><th></th></tr></thead><tbody><tr ng-class="{expired: purchasedProductWarranty.status == \'expired\', aboutToExpire: purchasedProductWarranty.status == \'aboutToExpire\'}" ng-repeat="purchasedProductWarranty in vm.purchasedProduct.purchasedProductWarranties track by purchasedProductWarranty.id"><td>{{purchasedProductWarranty.warranty.description}}</td><td>{{purchasedProductWarranty.warranty.validity}}&nbsp;{{\'garanteasyApp.timeUnit.\'+purchasedProductWarranty.warranty.validityUnit | translate}}</td><td>{{purchasedProductWarranty.expirationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="purchased-product/warranty-edit({ppId:vm.purchasedProduct.id, wId:purchasedProductWarranty.warranty.id})" class="btn btn-primary btn-sm" ng-show="vm.canManageWarranties && purchasedProductWarranty.warranty.code == \'CUSTOM\'"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="purchased-product/warranty-delete({id:vm.purchasedProduct.id, ppwId:purchasedProductWarranty.id})" class="btn btn-danger btn-sm" ng-show="vm.canManageWarranties && !purchasedProductWarranty.warranty.legal"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div ng-if="vm.canManageWarranties && vm.purchasedProduct.claims.length > 0"><h3 translate="garanteasyApp.warrantyClaim.home.title">Warranty Claims</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.warrantyClaim.requestDate">Request date</span></th><th><span translate="garanteasyApp.warrantyClaim.status">Request status</span></th><!-- <th><span translate="garanteasyApp.warrantyClaim.annotations">Annotations</span></th> --></tr></thead><tbody><tr ng-repeat="warrantyClaim in vm.purchasedProduct.claims track by warrantyClaim.id"><td>{{warrantyClaim.requestDate}}</td><td><span translate="{{\'garanteasyApp.WarrantyClaimStatus.\' + warrantyClaim.status}}">status</span></td><!-- <td>{{warrantyClaim.annotations}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="warranty-claim-detail({id:warrantyClaim.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="purchased-product/warranty-claim-edit({id:vm.purchasedProduct.id, claimId:warrantyClaim.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="purchased-product/warranty-claim-delete({id:vm.purchasedProduct.id, claimId:warrantyClaim.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div><button type="button" ui-sref="purchased-product/detail/edit({id:vm.purchasedProduct.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button class="btn btn-info" ui-sref="receipt/detail({id:vm.purchasedProduct.receiptId})"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.goToReceipt">Go to Receipt</span></button> <button class="btn btn-info" ui-sref="purchased-product"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.goToProducts">Go to Products</span></button></div><div ng-show="vm.canManageWarranties"><br><button class="btn btn-primary" ui-sref="purchased-product/warranty-new({id:vm.purchasedProduct.id})"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.addWarranty">Add warranty</span></button> <button class="btn btn-primary" ui-sref="purchased-product/warranty-select({id:vm.purchasedProduct.id})" ng-show="vm.purchasedProduct.officialWarranties.length"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.selectWarranty" translate-values="{brand: \'{{vm.purchasedProduct.product.brand.name}}\'}">Add official warranty</span></button> <button has-authority="ROLE_USERPLUS" class="btn btn-warning" ui-sref="purchased-product/warranty-claim-new({id:vm.purchasedProduct.id})" ng-disabled="!vm.purchasedProduct.receipt.shop.id" title="{{ vm.purchasedProduct.receipt.shop.id ? \'\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate }}"><span class="glyphicon glyphicon-wrench"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.addWarrantyClaim">Add warranty claim</span></button></div></div>');
$templateCache.put('app/entities/purchased-product/purchased-product-detail.html','<meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><!--FOTO PRODOTTO: --><div class="list-detail"><div class="row"><!-- INIZIO PRIMO BLOCCO INFORMAZIONI PRODOTTO--><div class="col-sm-2 hidden-xs no-print"><img src="/content/images/icone_new/icone_sfondo_bianco/codice_a_barrecerchio_bianco.png" class="img-responsive"></div><div class="col-sm-10 col-xs-12"><div id="primoBlocco"><h4><span class="rdetail-font-size" translate="garanteasyApp.purchasedProduct.detail.title"></span></h4></div><div ng-if="vm.carouselImages.length" class="main-image row"><div class="col-sm-7"><div uib-carousel active="0" interval="false" no-wrap="false"><div uib-slide ng-repeat="slide in vm.carouselImages" index="$index"><img ng-src="{{slide.src}}" style="margin:auto; max-height: 400px; max-width: 100%" class="img-responsive"></div></div></div></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.brand"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.brand.name}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.name"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.name}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.category"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.category}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.buyingDate"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.receipt.buyingDate}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.brandCode"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.brand.code}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.serialNumber"></span></span> <span class="rdetail-font-size col-xs-4"><input type="text" class="form-control-modified" name="serialNumber" ng-model="vm.purchasedProduct.serialNumber"> </span><span class="col-xs-2"><button type="submit" class="btn btn-primary" translate="garanteasyApp.purchasedProduct.detail.save" ng-click="vm.saveSerialNumber()">Save</button></span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.eanCode"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.eanCode || vm.productEanCode}}</span></div><div class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.description"></span></span> <span class="rdetail-font-size col-xs-8 col-sm-9">{{vm.purchasedProduct.product.description}}</span></div><!--LINK A MANUALI--><div ng-if="vm.manuals.length" class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.manuals"></span></span> <span class="col-xs-8 col-sm-9"><span class="col-lg-3 col-md-4 col-sm-6 col-xs-12 no-padding" ng-repeat="productManual in vm.manuals track by productManual.id" class="rdetail-font-size"><a ng-if="!productManual.localCopy" target=" _blank" href="{{productManual.value}}"><span><img src="../../../content/images/icone_new/document/Libretto.png" style="height: 50px"><br>{{productManual.description}}</span> </a><a ng-if="productManual.localCopy" target="_blank" ng-href="api/product-resources/manual/{{productManual.id}}"><img src="../../../content/images/icone_new/document/Libretto.png" style="height: 50px"><br><span>{{productManual.description}}</span></a></span><br></span></div><!--LINK A VIDEO--><div ng-if="vm.purchasedProduct.product.videos.length" class="row"><span class="col-xs-4 col-sm-3"><span class="text-muted" translate="garanteasyApp.purchasedProduct.detail.videos"></span></span> <span class="col-xs-8 col-sm-9"><span ng-repeat="productVideo in vm.purchasedProduct.product.videos track by productVideo.id" class="rdetail-font-size"><a style="text-decoration: none; color: black" target="_blank" href="{{productVideo.value}}"><span>{{productVideo.description}}</span></a><br></span></span></div><div class="row" ng-repeat="code in vm.barCodes" index="$index"><div class="col-sm-8 col-md-5"><angular-barcode ng-model="code" bc-options="bc" bc-class="barcode" bc-type="svg"></angular-barcode></div></div><div class="row"><div class="col-xs-12 no-print"><button class="btn btn-info" ui-sref="receipt/detail({id:vm.purchasedProduct.receiptId})"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span class="hidden-xs hidden-sm" translate="garanteasyApp.purchasedProduct.goToReceipt">Go to Receipt</span></button> <button class="btn btn-info"><i class="fas fa-print"></i> <span translate="garanteasyApp.purchasedProduct.detail.print" ng-click="noprint(); printFromPage()"><span></span>Stampa</span></button></div></div></div></div><!-- ********** INIZIO SECONDO BLOCCO GARANZIA LEGALE***************--><div ng-repeat="item in vm.purchasedProduct.purchasedProductWarranties"><hr class="hr-green" noshade="noshade"><warranty-box-component purchased-product-warranty="item" hide-expand-button="false"></warranty-box-component></div><hr class="hr-sub-green hidden-xs" noshade="noshade"><warranty-assistance claims="vm.purchasedProduct.claims" purchased-product="vm.purchasedProduct"></warranty-assistance></div>');
$templateCache.put('app/entities/purchased-product/purchased-product-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="tab-form-demo"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPurchasedProductLabel" translate="garanteasyApp.purchasedProduct.home.createOrEditLabel">Create or edit a Purchased Product</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><input type="hidden" class="form-control" id="id" name="id" ng-model="vm.purchasedProduct.id"> <input type="hidden" class="form-control" id="receiptId" name="receiptId" ng-model="vm.purchasedProduct.receiptId"><div class="form-group"><label class="control-label" translate="garanteasyApp.purchasedProduct.serialNumber" for="field_serialNumber">Serial Number</label><input type="text" class="form-control" name="serialNumber" id="field_serialNumber" ng-model="vm.purchasedProduct.serialNumber"></div><div class="form-group" ng-show="vm.isOwner || vm.isAdmin"><label class="control-label" translate="garanteasyApp.purchasedProduct.deliveryDate" for="field_deliveryDate">Delivery Date</label>&nbsp;(*)<div class="input-group"><input id="field_deliveryDate" type="text" class="form-control" name="deliveryDate" uib-datepicker-popup="mediumDate" ng-model="vm.purchasedProduct.deliveryDate" is-open="vm.datePickerOpenStatus.deliveryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deliveryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div><p class="help-block" translate="garanteasyApp.purchasedProduct.deliveryDateNote">Delivery date explanation.</p></div></div><div class="form-group"><div ng-switch="vm.purchasedProduct.giftReceiverNotified"><div ng-switch-when="1"><!-- Cannot change receiver when gift has already been notified --><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificatedTo">Notifica del regalo inviata a:</label><input type="email" class="form-control" name="giftReceiverEmail" id="field_giftReceiverEmail" ng-model="vm.purchasedProduct.giftReceiverEmail" readonly="readonly"></div><div ng-switch-default><label class="control-label" translate="garanteasyApp.purchasedProduct.giftReceiverEmail" for="field_giftReceiverEmail">Se questo \uFFFD un regalo, inserisci l\'email di chi lo ricever\uFFFD</label><input type="email" class="form-control" name="giftReceiverEmail" id="field_giftReceiverEmail" ng-model="vm.purchasedProduct.giftReceiverEmail" ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.giftReceiverEmail.$invalid"><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.email" translate="global.messages.validate.email.invalid">E-mail is invalid.</p><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.minlength" translate="global.messages.validate.email.minlength">E-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.maxlength" translate="global.messages.validate.email.maxlength">E-mail cannot be longer than 100 characters.</p></div></div></div></div><div class="form-group"><div ng-switch="vm.purchasedProduct.giftReceiverNotified"><div ng-switch-when="1"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificatedDate">In data:</label><!-- Cannot change notification date when gift has already been notified --> <input id="field_giftNotificationDate" type="text" class="form-control" name="giftNotificationDateRO" value="{{vm.purchasedProduct.giftNotificationDate | date:\'mediumDate\'}}" readonly="readonly"></div><div ng-switch-default><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificationDate" for="field_giftNotificationDate">Gift Notification Date</label>&nbsp;(*)<div class="input-group"><input id="field_giftNotificationDate" type="text" class="form-control" name="giftNotificationDate" uib-datepicker-popup="mediumDate" ng-model="vm.purchasedProduct.giftNotificationDate" is-open="vm.datePickerOpenStatus.giftNotificationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'giftNotificationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div><p class="help-block" translate="garanteasyApp.purchasedProduct.giftNotificationDateNote">Gift notification date explanation.</p></div></div></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftMakerDescription" for="field_giftMakerDescription">Gift Maker Description</label><span ng-show="vm.purchasedProduct.giftReceiverNotified!=1">&nbsp;(*)</span><!-- Cannot change gift maker description when gift has already been notified --> <input type="text" class="form-control" name="giftMakerDescription" id="giftMakerDescription" ng-model="vm.purchasedProduct.giftMakerDescription" ng-readonly="vm.purchasedProduct.giftReceiverNotified==1"><div ng-show="vm.purchasedProduct.giftReceiverNotified!=1"><p class="help-block" translate="garanteasyApp.purchasedProduct.giftMakerDescriptionNote">giftMakerDescription explanation.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftDescription" for="field_giftDescription">Gift Description</label><input type="text" class="form-control" name="giftDescription" id="giftDescription" ng-model="vm.purchasedProduct.giftDescription"></div><div ng-switch="vm.purchasedProduct.giftReceiverNotified==1 || vm.receiptIsOfficial"><div ng-switch-when="true"><!-- Cannot change product when gift has already been notified --><label class="control-label" translate="garanteasyApp.purchasedProduct.product" for="field_productNameRO">Product name</label><input type="text" class="form-control" name="productNameRO" id="field_productNameRO" value="{{vm.purchasedProduct.product.brandAndName}}" readonly="readonly"></div><div ng-switch-default><uib-tabset active="0"><uib-tab index="0"><uib-tab-heading><label translate="garanteasyApp.purchasedProduct.productChoose" for="field_product">Choose a product...</label></uib-tab-heading><ng-form name="nestedForm"><!-- Typeahead search (search among all products) --><ui-select reset-search-input="false" ng-model="vm.purchasedProduct.product"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.product.typeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.brandAndName"></div></ui-select-match><ui-select-choices refresh="loadProducts($select.search)" refresh-delay="200" repeat="product in (products)"><!-- {{product}}--><div ng-bind="product.brandAndName"></div></ui-select-choices></ui-select></ng-form></uib-tab><uib-tab index="1" select="resetProduct()"><uib-tab-heading><label translate="garanteasyApp.purchasedProduct.productCreate" for="field_product">Or create a new one if missing</label></uib-tab-heading><div class="form-group"><label class="control-label" translate="garanteasyApp.product.name" for="field_productName">Product name</label><input type="text" class="form-control" name="productName" id="field_productName" ng-model="vm.purchasedProduct.product.name"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.product.description" for="field_productDescription">Description</label><input type="text" class="form-control" name="productDescription" id="field_productDescription" ng-model="vm.purchasedProduct.product.description"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.product.transportable" for="field_transportable">Transportable</label><input type="checkbox" class="form-control" name="transportable" id="field_transportable" ng-model="vm.purchasedProduct.product.transportable"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.product.eanCode" for="field_productEanCode">Ean code</label><input type="text" class="form-control" name="productEanCode" id="field_productEanCode" ng-model="vm.purchasedProduct.product.eanCode"></div><uib-tabset><uib-tab index="1"><uib-tab-heading><label translate="garanteasyApp.product.brandChoose" for="field_brand">Choose a brand...</label></uib-tab-heading><ng-form name="nestedForm"><div class="form-group"><!-- Typeahead search (search among all brands) --><ui-select reset-search-input="false" ng-model="vm.purchasedProduct.product.brand"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.brand.typeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.name"></div></ui-select-match><ui-select-choices refresh="loadBrands($select.search)" refresh-delay="200" repeat="brand in (brands) track by brand.id"><div ng-bind="brand.name"></div></ui-select-choices></ui-select></div></ng-form></uib-tab><uib-tab index="2" select="resetBrand()"><uib-tab-heading><label translate="garanteasyApp.product.brandCreate" for="field_brandName">Or create a new one if missing:</label></uib-tab-heading><div class="form-group"><label class="control-label" translate="garanteasyApp.product.name" for="field_brandName">Brand name</label><input type="text" class="form-control" name="brandName" id="field_brandName" ng-model="vm.purchasedProduct.product.brand.name"></div></uib-tab></uib-tabset></uib-tab></uib-tabset></div></div><br><div ng-show="!vm.isValidInput()"><p class="help-block" ng-show="!vm.hasProduct" translate="garanteasyApp.purchasedProduct.error.productRequired">Product required</p><p class="help-block" ng-show="vm.hasProduct && !vm.validProduct" translate="garanteasyApp.purchasedProduct.error.productNameRequired">Product name required</p><p class="help-block" ng-show="vm.hasProduct && !vm.hasBrand" translate="garanteasyApp.product.error.brandRequired">Brand required</p><p class="help-block" ng-show="vm.hasProduct && vm.hasBrand && !vm.validBrand" translate="garanteasyApp.product.error.brandNameRequired">Brand name required</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.isValidInput()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/purchased-product/purchased-product-reso-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.purchasedProduct.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="garanteasyApp.purchasedProduct.reso.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.purchasedProduct.reso.question" translate-values="{id: \'{{vm.purchasedProduct.id}}\'}">Are you sure you want to delete this Purchased Product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="garanteasyApp.purchasedProduct.reso.action">Delete</span></button></div></form>');
$templateCache.put('app/entities/purchased-product/purchased-products.html','<div><div class="col-xs-12"><h2 class="main-title" ng-show="vm.isAdmin" translate="garanteasyApp.purchasedProduct.home.title">Purchased Products</h2><h2 class="main-title" ng-show="!vm.isAdmin" translate="global.menu.products">Products</h2></div><!-- <div ncy-breadcrumb></div>--><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><!-- <div class="col-xs-4 no-padding-left">&lt;!&ndash; Creazione acquisti, che non ha senso se non entro una Receipt &ndash;&gt;\n            </div>--><div class="col-xs-12 col-sm-8"><form name="searchForm"><input style="width: 80%" type="text" class="col-xs-8 form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.purchasedProduct.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> <button ng-if="vm.currentSearch" class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></form></div></div></div><br><b><div class="table-responsive"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="th-green" jh-sort-by="product.name"><span translate="garanteasyApp.purchasedProduct.product">Product</span></th><th class="th-green" jh-sort-by="product.brand.name"><span translate="garanteasyApp.purchasedProduct.brand">Brand</span></th><th class="th-green" jh-sort-by="receipt.shop.owner.name"><span translate="garanteasyApp.receipt.shop">Shop</span></th><th class="th-green" jh-sort-by="receipt.buyingDate"><span translate="garanteasyApp.receipt.buyingDate">Receipt</span></th><th class="th-green" jh-sort-by="receipt.receiptNumber"><span translate="garanteasyApp.receipt.receiptNumber">Receipt Number</span></th><th><span translate="garanteasyApp.warranty.home.title">Garanzie</span></th><th></th></tr></thead><tbody style="border: 1px solid #dddddd"><tr ng-repeat="purchasedProduct in vm.purchasedProducts track by purchasedProduct.id"><td style="color: rgba(38,186,93,1)">{{purchasedProduct.product.name}}</td><td class="td-gray"><a style="color:black" ui-sref="brand-detail({id:purchasedProduct.product.brand.id})">{{purchasedProduct.product.brand.name}}</a></td><td ng-show="purchasedProduct.receipt.shop"><a style="color:black" ui-sref="shop-detail({id:purchasedProduct.receipt.shop.id, from: \'purchased-product\'})">{{purchasedProduct.receipt.shop.description}}</a></td><td ng-show="!purchasedProduct.receipt.shop"><span translate="global.undefinedSM">Non definito</span></td><td class="td-gray">{{purchasedProduct.receipt.buyingDate}}</td><td><a class="link-green" ui-sref="receipt/detail({id:purchasedProduct.receipt.id, from: \'purchased-product\'})">{{purchasedProduct.receipt.receiptNumber}}</a></td><td class="td-gray"><span title="{{\'garanteasyApp.warranty.status.valid\' | translate}}" ng-show="purchasedProduct.totalWarranties.numValid > 0" class="badge valid">{{purchasedProduct.totalWarranties.numValid}}</span> <span title="{{\'garanteasyApp.warranty.status.aboutToExpire\' | translate}}" ng-show="purchasedProduct.totalWarranties.numExpiring > 0" class="badge aboutToExpire">{{purchasedProduct.totalWarranties.numExpiring}}</span> <span title="{{\'garanteasyApp.warranty.status.expired\' | translate}}" ng-show="purchasedProduct.totalWarranties.numExpired > 0" class="badge expired">{{purchasedProduct.totalWarranties.numExpired}}</span></td><td class="text-right"><div class="action-list btn-group flex-btn-group-container"><button class="button-search" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="purchased-product/detail({id:purchasedProduct.id})"><span class="glyphicon glyphicon-search"></span></button><!-- Modifica possibile solo dalla pagina di dettaglio\n                            <button type="submit"\n                                    ui-sref="purchased-product/edit({id:purchasedProduct.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span>\n                            </button>\n                            --><!-- Purchase delete available for standard purchases and for non-notified gifts (only visible to buyer) --> <button ng-show="vm.currentUserId!=purchasedProduct.giftReceiverUserId" ng-disabled="purchasedProduct.giftReceiverNotified==1 && vm.currentUserId!=purchasedProduct.giftReceiverUserId" type="submit" title="{{\'entity.action.delete\' | translate}}" ui-sref="purchased-product/delete({id:purchasedProduct.id})" class="button-delete"><span class="glyphicon glyphicon-remove"></span></button><!-- Gift delete visible to gift receiver for notified gifts --> <button ng-show="purchasedProduct.giftReceiverNotified==1 && vm.currentUserId==purchasedProduct.giftReceiverUserId" type="submit" title="{{\'entity.action.delete\' | translate}}" ui-sref="purchased-product/gift-delete({giftId:purchasedProduct.giftId})" class="button-delete"><span class="glyphicon glyphicon-remove"></span></button></div></td></tr></tbody></table></div></b><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/purchased-product/sidebar-purchased-product-detail.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div><div style="margin-bottom: 120px"><h4 class="block-title"><span translate="garanteasyApp.purchasedProduct.detail.warrantiesState"></span></h4><div class="garanzie-holder"><span class="garanzie-wrapper color-green sp-icon-check"><span class="g-value">{{vm.purchasedProduct.totalWarranties.numValid}}</span> <span translate="garanteasyApp.purchasedProduct.detail.active" class="g-title"></span> </span><span class="garanzie-wrapper color-orange sp-icon-exclamation"><span class="g-value">{{vm.purchasedProduct.totalWarranties.numExpiring}}</span> <span translate="garanteasyApp.purchasedProduct.detail.expiring" class="g-title">IN SCADENZA</span> </span><span class="garanzie-wrapper color-orange-dark sp-icon-ban"><span class="g-value">{{vm.purchasedProduct.totalWarranties.numExpired}}</span> <span translate="garanteasyApp.purchasedProduct.detail.expired" class="g-title">SCADUTA</span></span></div></div><div><h4 class="block-title"><span translate="garanteasyApp.purchasedProduct.detail.warranty">GARANZIA</span></h4><table class="product-garanzia"><tbody><tr ng-repeat="purchasedProductWarranty in vm.purchasedProduct.purchasedProductWarranties track by purchasedProductWarranty.id"><td class="bb"><span ng-class="{ \'color-gr\': purchasedProductWarranty.status == \'expired\', \'color-gy\': purchasedProductWarranty.status == \'aboutToExpire\', \'color-gv\' : purchasedProductWarranty.status == \'valid\'}">{{purchasedProductWarranty.warranty.description}}</span></td></tr></tbody></table></div>');
$templateCache.put('app/entities/purchased-product/sidebar-purchased-products.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div>');
$templateCache.put('app/entities/receipt/receipt-claim-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.find()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReceiptLabel" translate="garanteasyApp.receipt.claim.title"></h4></div><div class="alert alert-success" ng-if="vm.error == 0"><span translate="garanteasyApp.receipt.claim.success" translate-compile></span></div><div class="modal-body" ng-if="vm.error != 0"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="alert alert-danger" ng-if="vm.error"><span translate="{{vm.error}}"></span><br></div><div class="alert alert-warning" ng-if="vm.error"><span translate="garanteasyApp.receipt.error.claimReportError1">&nbsp;</span><span><a href="mailto:{{\'home.link.mail_address\'|translate}}" translate="garanteasyApp.receipt.error.claimReportError2">Mail our support team</a></span></div><div><p>Grazie per aver acquistato il servizio GARANTEASY presso il punto vendita CHICCO VILLAGE DI GRANDATE.</p><p>Per attivare il servizio e poter accedere alla copia digitale dello scontrino devi inserire alcuni dati che trovi sullo scontrino poi accedere oppure completare la registrazione.</p><p>I dati dello scontrino che ti servono per attivare il servizio sono quelli che abbiamo evidenziato nell\u2019immagine qui sotto e che trovi subito sotto il totale dello scontrino</p></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.buyingDate" for="field_buyingDate">Buying Date</label><div class="input-group"><input id="field_buyingDate" type="text" class="form-control" name="buyingDate" uib-datepicker-popup="mediumDate" ng-model="vm.receiptMatcher.buyingDate" is-open="vm.datePickerOpenStatus.buyingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'buyingDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.buyingDate.$invalid"><p class="help-block" ng-show="editForm.buyingDate.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- User input falls into DATAENTRY category --><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.shopCode" for="field_counterCode">Shop code</label><input type="text" class="form-control" name="source" ng-model="vm.receiptMatcher.shopCode" id="field_source" ng-init="vm.receiptMatcher.shopCode=\'00030\'" ng-model="vm.receiptMatcher.shopCode" ng-maxlength="5" pattern="\\d\\d\\d\\d\\d"><div ng-show="editForm.shopCode.$invalid"><p class="help-block" ng-show="editForm.shopCode.$error.pattern" translate="entity.validation.fivedigits">This field must contain five numeric digits.</p><p class="help-block" ng-show="editForm.shopCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.counterCode" for="field_counterCode">Counter Number</label><input type="text" class="form-control" name="counterCode" id="field_counterCode" ng-model="vm.receiptMatcher.counterCode" ng-maxlength="2" pattern="\\d\\d"><div ng-show="editForm.counterCode.$invalid"><p class="help-block" ng-show="editForm.counterCode.$error.pattern" translate="entity.validation.twodigits">This field must contain two numeric digits.</p><p class="help-block" ng-show="editForm.counterCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.claim.receiptNumber" for="field_receiptNumber">Receipt Number</label><input type="text" class="form-control" name="receiptNumber" id="field_receiptNumber" ng-model="vm.receiptMatcher.receiptNumber" pattern="\\d{10}"><div ng-show="editForm.receiptNumber.$invalid"><p class="help-block" ng-show="editForm.receiptNumber.$error.pattern" translate="entity.validation.onlydigits">This field must contain only numeric digits.</p><p class="help-block" ng-show="editForm.receiptNumber.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><div>Identificativo scontrino: <strong>IT10-{{vm.receiptMatcher.shopCode}}-{{vm.receiptMatcher.counterCode}}-{{vm.receiptMatcher.receiptNumber}}-{{vm.receiptMatcher.buyingDate | date: \'yyyyMMdd\'}}</strong></div></div><div><h2>Oppure</h2></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.claim.receiptIdentifier" for="field_receiptIdentifier"></label><input type="text" , class="form-control" , name="receiptIdentifier" id="field_receiptIdentifier" ng-model="vm.receiptMatcher.receiptIdentifier" pattern="IT10\\d{5}\\d{2}\\d{10}\\d{8}" placeholder="IT10NNNNNXXYYYYYYYYYYZZZZZZZZ"><div ng-show="editForm.receiptIdentifier.$invalid"><p class="help-block" ng-show="editForm.receiptIdentifier.$error.pattern" translate="entity.validation.receiptIdentifier">This field must contain only numeric digits.</p></div></div><div ng-if="!vm.loggedUser" class="form-group"><label class="control-label" for="email" translate="garanteasyApp.receipt.claim.email">E-mail</label><input type="email" class="form-control" id="email" name="email" ng-model="vm.receiptMatcher.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="editForm.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div><p>Useremo il tuo indirizzo email solo per comunicarti se abbiamo rintracciato lo scontrino che ci hai richiesto. Nel caso non ti registrassi cancelleremo i dati della tua email tra 30 giorni.</p></div><div ng-if="vm.loggedUser" ng-switch="vm.contacts.length"><label class="control-label" for="email" translate="garanteasyApp.receipt.claim.email-select">E-mail</label><div ng-switch-when="1"><!-- Select the only contact --> <input type="email" class="form-control" id="email" name="email" ng-model="vm.receiptMatcher.email" ng-init="vm.receiptMatcher.email=vm.contacts[0].channel" readonly="readonly"></div><div ng-switch-default><!-- Have user select the contact --><div class="form-group"><select required class="form-control" id="email" name="email" ng-model="vm.receiptMatcher.email" ng-options="contact.channel as contact.channel for contact in vm.contacts"></select></div><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="garanteasyApp.receipt.claim.go">Invia richiesta</span></button></div></div><div ng-if="!vm.loggedUser"><p>Se sei un utente registrato puoi seguire lo stato di avanzamento della tua richiesta accedendo alla sezione \u201Cricevute\u201D.</p><button class="btn btn-default"><a ui-sref="register"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.menu.account.register">Register</span></a></button> <button class="btn btn-default"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></button></div></form>');
$templateCache.put('app/entities/receipt/receipt-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.receipt.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.receipt.delete.question" translate-values="{id: \'{{vm.receipt.id}}\'}">Are you sure you want to delete this Receipt?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/receipt/receipt-detail-edit-document.html','<!doctype html><!-- nome cliente\ncognome cliente\nemail cliente **  (la mail o il cellulare del cliente sono obbligatori)\ncellulare cliente **\ndata emissione scontrino*\ncaricamento foto scontrino*\n--><div class="row row-margin"><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-3 font-weight-bold" translate="garanteasyApp.receipt.detail.type"></span><label class="rdetail-font-size col-sm-3"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="OFFICIAL_RECEIPT"> {{\'garanteasyApp.ReceiptType.OFFICIAL_RECEIPT\' | translate}}</label><label class="rdetail-font-size col-sm-3"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="RECEIPT"> {{\'garanteasyApp.ReceiptType.RECEIPT\' | translate}}</label><label class="rdetail-font-size col-sm-3"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="INVOICE"> {{\'garanteasyApp.ReceiptType.INVOICE\' | translate}}</label></div><!-- CASSA --><div ng-if="vm.receipt.receiptType === \'RECEIPT\'" class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.cashRegister"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="text" class="form-control-modified" ng-model="vm.receipt.counterCode"> </span><span ng-if="vm.receipt.counterCode == null || vm.receipt.counterCode == \'\'"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div><!-- RECEIPT NUMBER --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.receiptNumber"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="text" class="form-control-modified" ng-model="vm.receipt.receiptNumber"> </span><span ng-if="vm.receipt.receiptNumber == null || vm.receipt.receiptNumber == \'\'"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div><!-- DATA DI EMISSIONE --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.detail.buyingDate"></span> </strong><span class="rdetail-font-size col-sm-9 nopadding input-group"><span class="fas fa-calendar-alt input-group-addon" ng-click="vm.openCalendar(\'buyingDate\')"></span> <input readonly="readonly" ng-click="vm.openCalendar(\'buyingDate\')" ng-change="loadActiveCards()" id="buyingDate" type="text" class="form-control-modified input-fast-track" name="buyingDate" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" tooltip-enable="vm.receipt.buyingDate == null || vm.receipt.buyingDate == \'\'" datepicker-options="vm.datePickerOptions" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.buyingDate" is-open="vm.datePickerOpenStatus.buyingDate" required aria-describedby="buyingDateStatus" style="background-color: #fff"> <span ng-if="vm.receipt.buyingDate == null || vm.receipt.buyingDate == \'\'" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback" aria-hidden="true"></span></span></div><!-- DATA Pagamento --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.detail.paymentDate"></span> </strong><span class="rdetail-font-size col-sm-9 nopadding input-group"><span class="fas fa-calendar-alt input-group-addon" ng-click="vm.openCalendar(\'paymentDate\')"></span> <input readonly="readonly" ng-click="vm.openCalendar(\'paymentDate\')" id="paymentDate" type="text" class="form-control-modified input-fast-track" name="paymentDate" datepicker-options="vm.datePickerOptions" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate" aria-describedby="paymentDateStatus" style="background-color: #fff"></span></div>');
$templateCache.put('app/entities/receipt/receipt-detail.html','<!-- receipt-detail.html --><div><h4><span ng-if="vm.receipt.receiptNumber" translate="garanteasyApp.receipt.detail.subTitle"></span> {{vm.receipt.counterCode ? vm.receipt.counterCode + \' - \' : \'\'}}{{ vm.receipt.receiptNumber }}</h4></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><!--hide cropper o image builder --><!-- <div class="col-xs-12 hidden-print">\n    <div ng-if="vm.receiptFiles.length">\n        <div class="col-sm-6 col-md-4 col-xs-12 no-padding">\n            <image-cropper hide-delete="true" ng-if="vm.receiptFiles.length" portrait="true" files="vm.receiptFiles">\n            </image-cropper>\n        </div>\n    </div>\n\n</div> --><!-- INIZIO NUOVA VERSIONE --><div class="list-detail"><div class="row"><div class="col-sm-6 col-md-5 col-lg-4 image-build-wrapper"><div id="pdf-wrapper"><receipt-image-build id="receiptPrintContent" receipt="vm.receipt"></receipt-image-build></div><button ng-click="vm.printReceipt()" class="btn btn-default btn-dark" type="button"><span class="fas fa-print"></span></button> <button ng-click="vm.printPdf()" class="btn btn-default btn-dark" type="button"><span class="fas fa-download"></span></button><br><br></div></div><!-- DATA ACQUISTO --><div class="row" ng-if="vm.receipt.buyingDate"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.buyingDate"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.buyingDate | date: "mediumDate"}}</span></div><!-- DESCRIZIONE --><div class="row" ng-if="vm.receipt.description"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.description"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.description}}</span></div><!-- TIPO DI ACQUISTO --><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.purchaseType"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{("garanteasyApp.receipt.purchaseTypeValue." + vm.evaluateBusiness() ) | translate}}</span></div><!-- Tipo di documento --><div class="row" ng-if="vm.receipt.receiptType"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.receiptType"></span></span> <span class="col-xs-8 col-sm-9 col-md-10" translate="{{\'garanteasyApp.ReceiptType.\' +vm.receipt.receiptType}}">{{vm.receipt.receiptType}}</span></div><!-- Tipo di PAGAMENTO --><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.paymentType"></span></span> <span class="col-xs-8 col-sm-9 col-md-10" translate="{{\'garanteasyApp.PaymentType.\' +vm.receipt.paymentType}}">{{vm.receipt.paymentType}}</span></div><!-- FONTE --><div class="row" ng-if="vm.receipt.source"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.receipt.source"></span></span> <span class="col-xs-8 col-sm-9 col-md-10" translate="{{\'garanteasyApp.DataSource.\' + vm.receipt.source}}">{{vm.receipt.source}}</span></div><!-- NOME --><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.customer.legalName"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.showCustomerName(vm.receipt.customer)}}</span></div><!-- LOGIN --><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted">Email</span></span> <a ui-sref="customer-detail({id:vm.receipt.customer.id})"><span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.user.login}}</span></a></div><!-- CF/ P.IVA--><div class="row" ng-if="vm.receipt.customer.vatid"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.customer.vatid"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.vatid}}</span></div><!-- VIA--><div class="row" ng-if="vm.receipt.customer.address.street || vm.receipt.customer.address.streetNumber"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.address.street"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.address.street}} {{vm.receipt.customer.address.streetNumber}}</span></div><!-- LOCALITA--><div class="row" ng-if="vm.receipt.customer.address.locality"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.address.locality"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.address.locality}}</span></div><!-- CITTA--><div class="row" ng-if="vm.receipt.customer.address.postcode || vm.receipt.customer.address.city"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.address.city"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.address.postcode}} {{vm.receipt.customer.address.city}}</span></div><!-- NAZIONE --><div class="row" ng-if="vm.receipt.customer.address.country.name"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.address.country"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.customer.address.country.name}}</span></div><ng-container ng-if="(vm.receipt || {}).shop && !vm.cmsShop"><div class="row" ng-if="vm.receipt.shop.shopSignboard"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopSignboard"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.shop.shopSignboard}}</span></div><div class="row" ng-if="(vm.receipt.shop.address || {}).descFull"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.address"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.shop.address.descFull}}</span></div><div class="row" ng-if="((vm.receipt.shop.owner||{}).name)"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.companyName"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.shop.owner.name}}</span></div><div class="row" ng-if="(vm.receipt.shop || {}).email"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopEmail"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.receipt.shop.email}}</span></div></ng-container><ng-container ng-if="vm.cmsShop"><div class="row" ng-if="(vm.cmsShop || {}).signboard_brand"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopSignboard"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.cmsShop.signboard_brand}}</span></div><div class="row" ng-if="(vm.cmsShop || {}).address"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.address"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.cmsShop.address}}</span></div><div class="row" ng-if="(vm.cmsShop || {}).owner_company"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.companyName"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.cmsShop.owner_company}}</span></div><div class="row" ng-if="(vm.cmsShop || {}).shop_email"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopEmail"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.cmsShop.shop_email}}</span></div></ng-container><hr class="hr-green hidden-xs" noshade="noshade"><div class="row"><div class="col-sm-2 hidden-xs"><img src="/content/images/icone_new/assistenza_tecnica.png" class="img-responsive"></div><div class="col-sm-10"><h4><span translate="garanteasyApp.purchasedProduct.request-assistance">request-assistance</span></h4><ul><li ng-repeat="o in vm.reasons">{{\'garanteasyApp.warrantyClaim.reasons.\'+ o | translate}}</li></ul><button uib-tooltip="{{ \'garanteasyApp.purchasedProduct.warranty-claim\' | translate}}" class="pull-right btn btn-default btn-dark" ui-sref="warranty-claim-new({receiptId: vm.receipt.id})"><i class="fas fa-life-ring"></i></button></div></div><hr class="hr-green hidden-xs" noshade="noshade"></div><!-- FINE NUOVA VERSIONE --><div class="row product-details-wrapper"><div class="col-sm-4" ng-if="vm.image"><div class="main-image" ng-if="vm.image"><a id="main-image" target="_blank" ng-href="{{ vm.getImageUrl(vm.image) }}"><img style="max-height: 377px" class="img-responsive" ez-zoom data-ng-src="{{ vm.getImageUrl(vm.image) }}" ez-zoom-config="{\'scrollZoom\': true,\'tint\':true, \'tintColour\':\'#F90\', \'tintOpacity\':0.5}" ez-zoom-image="{{ vm.getImageUrl(vm.image) }} "> <span ng-show="!vm.canShow(vm.image.fileContentType)" ng-bind-html="vm.image.fileContentType|iconify"></span></a><h4 title="Delete file" class="fa fa-trash" ng-show="vm.image != null && (vm.isOwner || vm.isAdmin)" ng-click="vm.deleteImage(vm.image)"></h4><ul ng-if="vm.images.length > 1" class="images-list ul-no-bump"><li ng-if="image.fileData != undefined" ng-repeat="image in vm.receipt.receiptFiles"><img class="img-responsive img-thumbnail" style="width: 80px; height: 80px" ng-click="vm.changeMainImage(image)" ng-src="{{ vm.getImageUrl(image) }}" id="{{ image.id }}"></li></ul></div></div><div class="col-sm-8"><div class="col-sm-12" ng-if="vm.documents.length > 0"><h3 translate="garanteasyApp.receipt.receiptFile">File Ricevuta</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th></th><th></th></tr></thead><tbody><tr ng-repeat="file in vm.documents track by file.id"><td><a href="{{ vm.getImageUrl(file) }}" download="{{ file.fileName }}" target="_blank"><span ng-show="!vm.canShow(file.fileContentType)" ng-bind-html="file.fileContentType|iconify"></span> </a>{{ file.fileContentType }}, {{ file.fileName }}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a href="{{ vm.getImageUrl(file) }}" download="{{ file.fileName }}" target="_blank" class="btn btn-info btn-sm" role="button"><span class="glyphicon glyphicon-download"></span> <span class="hidden-xs hidden-sm" translate="entity.action.download"></span></a></div></td></tr></tbody></table></div></div></div></div><div ng-if="vm.receipt.purchasedProducts.length > 0"><h3 translate="garanteasyApp.receipt.purchasedProduct">Purchased Products</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="garanteasyApp.purchasedProduct.brand">Brand</span></th><th><span translate="garanteasyApp.purchasedProduct.product">Product</span></th></tr></thead><tbody><tr ng-repeat="purchasedProduct in vm.receipt.purchasedProducts"><td><span ng-show="vm.isAdmin">{{ purchasedProduct.product.brand.name }}</span> <span ng-show="!vm.isAdmin">{{ purchasedProduct.product.brand.name }}</span></td><td><a ui-sref="purchased-product/detail({id:purchasedProduct.id, from: \'receipt.detail({id:{{\n                                    vm.receipt.id\n                                }}})\'})">{{ purchasedProduct.product.name }}</a></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/receipt/receipt-dialog.html','<!-- receipt-dialog.html --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-if="!vm.receipt.id" class="modal-title" id="myReceiptLabel" translate="garanteasyApp.receipt.home.createLabel">Create a Receipt</h4><h4 ng-if="vm.receipt.id" class="modal-title" id="myReceiptLabel" translate="garanteasyApp.receipt.home.createOrEditLabel">Create or edit a Receipt</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-if="vm.merchants.length > 1" ng-switch="vm.merchants.length"><div ng-switch-when="1"><!-- Have user select the merchant --><div class="form-group"><label translate="garanteasyApp.receipt.merchant" for="field_merchant">merchant</label><input type="text" readonly="readonly" class="form-control" id="field_merchant" name="merchant" ng-model="vm.receipt.shop.owner.name" ng-init="vm.merchantWrap().merchant=vm.merchant[0]"></div></div><div ng-switch-default><!-- Have user select the merchant --><div class="form-group"><label translate="garanteasyApp.receipt.merchant" for="field_merchant">Merchant</label><select required class="form-control" id="field_merchant" name="merchant" ng-model="vm.merchantWrap().merchant" ng-options="merchant as merchant.companyName for merchant in vm.merchants track by merchant.id"></select></div><div ng-show="editForm.merchant.$invalid"><p class="help-block" ng-show="editForm.merchant.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div ng-switch="vm.shops.length"><div ng-switch-when="1"><!-- Have user select the shop --><div class="form-group"><label translate="garanteasyApp.receipt.shop" for="field_shop">Shop</label><input type="text" readonly="readonly" class="form-control" id="field_shop" name="shop" ng-model="vm.receipt.shop.description" ng-init="vm.receipt.shop=vm.shops[0]"></div></div><div ng-switch-default><!-- Have user select the shop --><div class="form-group"><label translate="garanteasyApp.receipt.shop" for="field_shop">Shop</label><select required class="form-control" id="field_shop" name="shop" ng-model="vm.receipt.shop" ng-options="shop as shop.description for shop in vm.shops"></select></div><div ng-show="editForm.shop.$invalid"><p class="help-block" ng-show="editForm.shop.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div ng-switch="vm.receipt.source"><div ng-switch-when="CLAIM" class="alert alert-info"><span translate="garanteasyApp.receipt.claimReadonly">Alcuni dati non sono modificabili in attesa di conferma dal negozio</span></div><div ng-switch-when="CLAIM_RESOLVED" class="alert alert-info"><span translate="garanteasyApp.receipt.officialReadonly">I dati inviati a Garanteasy dal negozio non sono modificabili</span></div><div ng-switch-when="MERCHANT" class="alert alert-info"><span translate="garanteasyApp.receipt.officialReadonly">I dati inviati a Garanteasy dal negozio non sono modificabili</span></div><div ng-switch-default></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.receiptType" for="field_receiptType">Document type</label><select class="form-control" name="receiptType" ng-model="vm.receipt.receiptType" id="field_receiptType"><option value="OFFICIAL_RECEIPT" translate="garanteasyApp.ReceiptType.OFFICIAL_RECEIPT">OFFICIAL_RECEIPT</option><option value="RECEIPT" translate="garanteasyApp.ReceiptType.RECEIPT">RECEIPT</option><option value="INVOICE" translate="garanteasyApp.ReceiptType.INVOICE">INVOICE</option></select></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.receipt.description"></div><div class="form-group" ng-if="!vm.isOfficial || vm.isAdmin"><label class="control-label" translate="garanteasyApp.receipt.buyingDate" for="field_buyingDate">Buying Date</label><div class="input-group"><input id="field_buyingDate" type="text" class="form-control" name="buyingDate" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.buyingDate" is-open="vm.datePickerOpenStatus.buyingDate" required ng-change="loadActiveCards()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'buyingDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.buyingDate.$invalid"><p class="help-block" ng-show="editForm.buyingDate.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.isOfficial && !vm.isAdmin"><label class="control-label" translate="garanteasyApp.receipt.buyingDate" for="field_buyingDate">Buying Date</label><div class="input-group"><input id="field_buyingDate" type="text" class="form-control" name="buyingDate" value="{{vm.receipt.buyingDate | date:\'mediumDate\'}}" readonly="readonly"></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.receiptNumber" for="field_receiptNumber">Receipt Number</label><input type="text" class="form-control" name="receiptNumber" id="field_receiptNumber" ng-model="vm.receipt.receiptNumber" ng-readonly="vm.isOfficial && !vm.isAdmin" required><div ng-show="editForm.receiptNumber.$invalid"><p class="help-block" ng-show="editForm.receiptNumber.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.counterCode" for="field_counterCode">Counter Code</label><input type="text" class="form-control" name="counterCode" id="field_counterCode" ng-model="vm.receipt.counterCode" ng-readonly="vm.isOfficial && !vm.isAdmin"></div><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.paymentType" for="field_paymentType">Payment Type</label><select class="form-control" name="paymentType" ng-model="vm.receipt.paymentType" id="field_paymentType"><option value="CASH" translate="garanteasyApp.PaymentType.CASH">CASH</option><option value="PAYPAL" translate="garanteasyApp.PaymentType.PAYPAL">PAYPAL</option><option value="VISA" translate="garanteasyApp.PaymentType.VISA">VISA</option><option value="MASTERCARD" translate="garanteasyApp.PaymentType.MASTERCARD">MASTERCARD</option><option value="AM_EXP" translate="garanteasyApp.PaymentType.AM_EXP">AM_EXP</option><option value="DINERS" translate="garanteasyApp.PaymentType.DINERS">DINERS</option><option value="BANK" translate="garanteasyApp.PaymentType.BANK">BANK</option><option value="CHEQUE" translate="garanteasyApp.PaymentType.CHEQUE">CHEQUE</option><option value="OTHER" translate="garanteasyApp.PaymentType.OTHER">OTHER</option></select></div><div ng-switch="vm.customers.length"><!--<div ng-switch-when="1">\n\t\t\t\t&lt;!&ndash; Silently select the only customer &ndash;&gt;\n\t\t\t\t<input type="hidden" class="form-control" id="field_customer"\n                        name="customer" ng-model="vm.receipt.customerId" ng-init="vm.receipt.customerId=vm.customers[0].id" />\n\t\t\t</div>--><div ng-switch-default><!-- Have user select the customer --><div class="form-group"><label translate="garanteasyApp.receipt.customer" for="field_customer">Customer</label><select required class="form-control" id="field_customer" name="customer" ng-model="vm.receipt.customer" ng-change="loadActiveCards()" ng-options="customer as customer.legalName for customer in vm.customers"></select></div><div ng-show="editForm.customer.$invalid"><p class="help-block" ng-show="editForm.customer.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div ng-switch="vm.contacts.length"><div ng-switch-when="1"><!-- Silently select the only contact --> <input type="hidden" class="form-control" id="field_contact" name="contact" ng-model="vm.receipt.contactId" ng-init="vm.receipt.contactId=vm.contacts[0].id"></div><div ng-switch-default><!-- Have user select the contact --><div class="form-group"><label translate="garanteasyApp.receipt.contact" for="field_contact">Contact</label><select required class="form-control" id="field_contact" name="contact" ng-model="vm.receipt.contactId" ng-options="contact.id as contact.channel for contact in vm.contacts"></select></div><div ng-show="editForm.contact.$invalid"><p class="help-block" ng-show="editForm.contact.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><!-- Shop (readonly) if official and not admin, else editable --><!--<div class="form-group" ng-if="vm.isOfficial && !vm.isAdmin">\n\t\t\t\t\t<label translate="garanteasyApp.receipt.shop" for="field_shop">Shop</label>\n            <input type="text" class="form-control" name="shop" id="field_shop"\n                    value="{{vm.receipt.shop.description}}"\n                    readonly\n                    />\n        </div>\n\t\t<uib-tabset active="0" ng-if="!vm.isOfficial || vm.isAdmin">\n\t\t\t<uib-tab index="0">\n\t\t\t\t<uib-tab-heading>\n\t\t\t\t\t<label translate="garanteasyApp.receipt.shopChoose" for="field_shop">Choose a shop...</label>\n\t\t\t\t</uib-tab-heading>\n\t\t\t\t<ng-form name="nestedForm">\n\t\t\t\t\t&lt;!&ndash; Typeahead search (search among all shops) &ndash;&gt;\n\t\t\t\t\t<ui-select reset-search-input="false" ng-model="vm.receipt.shop">\n\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.shopTypeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.description"></div></ui-select-match>\n\t\t\t\t\t\t<ui-select-choices refresh="loadShops($select.search)" refresh-delay="200"\n                                        repeat="shop in (shops) track by shop.id">\n\t\t\t\t\t\t\t<div ng-bind="shop.description"></div>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t</ui-select>\n\t\t\t\t</ng-form>\n\t\t\t</uib-tab>\n\t\t\t<uib-tab index="1" select="resetShop()">\n\t\t\t\t<uib-tab-heading>\n\t\t\t\t\t<label translate="garanteasyApp.receipt.shopCreate" for="field_shop">Or create a new one if missing</label>\n\t\t\t\t</uib-tab-heading>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.shop.ecommerceUrl" for="field_ecommerceUrl">Ecommerce Url</label>\n\t\t            <input type="text" class="form-control" name="ecommerceUrl" id="field_ecommerceUrl"\n\t\t                    ng-model="vm.receipt.shop.ecommerceUrl"\n                            />\n\t\t        </div>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.address.street" for="field_shopStreet">Street</label>\n\t\t            <input type="text" class="form-control" name="shopStreet" id="field_shopStreet"\n\t\t                    ng-model="vm.receipt.shop.address.street"\n                            />\n\t\t        </div>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.address.locality" for="field_shopLocality">Locality</label>\n\t\t            <input type="text" class="form-control" name="shopLocality" id="field_shopLocality"\n\t\t                    ng-model="vm.receipt.shop.address.locality"\n                            />\n\t\t        </div>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.address.city" for="field_shopCity">City</label>\n\t\t            <input type="text" class="form-control" name="shopCity" id="field_shopCity"\n\t\t                    ng-model="vm.receipt.shop.address.city"\n                            />\n\t\t        </div>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.address.postcode" for="field_shopPostcode">Postcode</label>\n\t\t            <input type="text" class="form-control" name="shopPostcode" id="field_shopPostcode"\n\t\t                    ng-model="vm.receipt.shop.address.postcode"\n                            />\n\t\t        </div>\n\t\t        <div class="form-group">\n\t\t            <label class="control-label" translate="garanteasyApp.address.country" for="field_shopCountry">Country</label>\n\t\t            <select class="form-control" name="shopCountry" id="field_shopCountry"\n\t\t                    ng-model="vm.receipt.shop.address.country" pvp-country-picker\n                            />\n\t\t        </div>\n\n\t\t\t\t<uib-tabset>\n\t\t\t\t\t<uib-tab index="1">\n\t\t\t\t\t\t<uib-tab-heading>\n\t\t\t\t\t\t\t<label translate="garanteasyApp.shop.merchantChoose" for="field_merchant">Choose a merchant...</label>\n\t\t\t\t\t\t</uib-tab-heading>\n\t\t\t\t\t\t<ng-form name="nestedForm">\n\t\t\t\t\t\t\t<div class="form-group">\n\t\t\t\t\t\t\t\t&lt;!&ndash; Typeahead search (search among all merchant) &ndash;&gt;\n\t\t\t\t\t\t\t\t<ui-select reset-search-input="false" ng-model="vm.receipt.shop.merchant">\n\t\t\t\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.merchant.typeaheadPlaceholder\' | translate}}"><div ng-bind="$select.selected.companyName"></div></ui-select-match>\n\t\t\t\t\t\t\t\t\t<ui-select-choices refresh="loadMerchants($select.search)" refresh-delay="200"\n                                                    repeat="merchant in (merchants) track by merchant.id">\n\t\t\t\t\t\t\t\t\t\t<div ng-bind="merchant.companyName"></div>\n\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</ng-form>\n\t\t\t\t\t</uib-tab>\n\t\t\t\t\t<uib-tab index="2" select="resetMerchant()">\n\t\t\t\t\t\t<uib-tab-heading>\n\t\t\t\t            <label translate="garanteasyApp.shop.merchantCreate" for="field_merchantName">Or create a new one if missing:</label>\n\t\t\t\t\t\t</uib-tab-heading>\n\n\t\t\t\t        <div class="form-group">\n\t\t\t\t            <label class="control-label" translate="garanteasyApp.merchant.companyName" for="field_merchantCompanyName">Merchant company name</label>\n\t\t\t\t            <input type="text" class="form-control" name="merchantCompanyName" id="field_merchantCompanyName"\n\t\t\t\t                    ng-model="vm.receipt.shop.owner.name"\n                                    />\n\t\t\t\t        </div>\n\t\t\t\t\t</uib-tab>\n\t\t\t\t</uib-tabset>\n\t\t\t</uib-tab>\n\t\t</uib-tabset>--><div><div class="form-group"><label translate="garanteasyApp.receipt.card" for="field_card">card</label><select class="form-control" id="field_card" name="card" ng-model="vm.receipt.cardId" ng-options="card.id as card.number for card in vm.cards"></select></div></div><br><div ng-show="!vm.isValidInput()"><p class="help-block" ng-show="!vm.validAddress" translate="garanteasyApp.shop.error.addressRequired">Website or address required</p><p class="help-block" ng-show="!vm.validMerchant" translate="garanteasyApp.shop.error.merchantRequired">Merchant required</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.isValidInput()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/receipt/receipt-fast-track-customer.html','<!-- CUSTOMER --><ng-form name="customerForm" novalidate><!-- <div ng-init="vm.customerForm = customerForm"  class="row row-margin " style="margin-bottom: 1em; ">\n        <div class="btn-group">\n            <label ng-click="vm.customerSelected = null; vm.customer = null;" uib-btn-radio="false"\n                class="btn btn-default" ng-model="vm.isNewCustomer"\n                translate="garanteasyApp.receipt.receiptNewPage.customer">Seleziona un cliente\n                affezionato</label>\n            <label ng-click="vm.customerSelected = null; vm.customer = null;" uib-btn-radio="true"\n                class="btn btn-default" ng-model="vm.isNewCustomer">Inserisci un nuovo\n                cliente</label>\n        </div>\n    </div> --><!-- <div ng-init="vm.customerForm = customerForm"  class="row row-margin" >\n        <strong><span style="padding-left: 0px;"  class="rdetail-font-size-colored col-sm-12 col-xs-11"\n                translate="garanteasyApp.receipt.fastTrack.customerSearch"></span></strong>\n        <div class="rdetail-font-size nopadding col-sm-11 input-group col-xs-11">\n            <ui-select style="padding: 0em; " class="form-control-modified input-fast-track" id="field_customer " name="customer "\n                ng-model="vm.customerSelected" reset-search-input="false" ng-change="vm.updateCustomerData()" >\n                <ui-select-match allow-clear="true" placeholder="Seleziona un tuo cliente">\n                    <div ng-bind="$select.selected.legalName"></div>\n                </ui-select-match>\n                <ui-select-choices refresh="loadCustomers($select.search)" refresh-delay="200"\n                    repeat="customer in vm.customers | orderBy: \'legalName\'" minimum-input-length="5">\n                    <div ng-bind="customer.legalName"></div>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </div> --><div ng-init="vm.customerForm = customerForm" class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-11" translate="garanteasyApp.receipt.receiptNewPage.clientEmail"></span></strong><div class="rdetail-font-size nopadding col-sm-11 input-group col-xs-11"><ui-select style="padding: 0em" class="form-control-modified input-fast-track" id="field_customer " name="customer " required ng-model="vm.customerSelected" reset-search-input="false" ng-change="vm.updateCustomerData(); vm.checkValidMail()"><!--tagging="transformFunction" tagging-label="false" --><ui-select-match allow-clear="true" placeholder="Seleziona un tuo cliente"><div ng-bind="$select.selected.legalName"></div></ui-select-match><ui-select-choices refresh="loadCustomers($select.search)" refresh-delay="200" repeat="customer in vm.customers | orderBy: \'legalName\'" minimum-input-length="5"><div ng-bind="customer.legalName"></div></ui-select-choices></ui-select><span ng-if="(vm.customerSelected == null && vm.customer.name == null && vm.customer.surname == null) || !vm.validEmail" title="{{ \'garanteasyApp.receipt.detail.required\' | translate }}" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></span></div></div><!-- NOME CLIENTE --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-11" translate="garanteasyApp.receipt.receiptNewPage.clientName"></span></strong> <span class="rdetail-font-size nopadding col-sm-11 col-xs-11 input-group"><input ng-disabled="vm.customerSelected.id" type="text" class="form-control-modified input-fast-track" ng-model="vm.customer.name"></span></div><!-- COGNOME CLIENTE --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-11" translate="garanteasyApp.receipt.receiptNewPage.clientSurname"></span></strong> <span class="rdetail-font-size nopadding col-sm-11 col-xs-11 inpfut-group"><input ng-disabled="vm.customerSelected.id" type="text" class="form-control-modified input-fast-track" ng-model="vm.customer.surname"></span></div><!-- EMAIL CLIENTE --><!-- <div class="row row-margin">\n        <strong><span style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-12 col-xs-11"\n                translate="garanteasyApp.receipt.receiptNewPage.clientEmail"></span></strong>\n        <span class="rdetail-font-size nopadding col-sm-11 col-xs-11 input-group">\n            <input ng-disabled="vm.customerSelected != null" type="email" class="form-control-modified input-fast-track"\n                ng-model="vm.customer.email" ng-required="vm.isNewCustomer" />\n            <span ng-if="vm.customerSelected == null && vm.customer.email == null || vm.customer.email == \'\'"\n                title="{{\'garanteasyApp.receipt.detail.required\'|translate}} {{\'garanteasyApp.receipt.receiptNewPage.validationEmail\'|translate}}"\n                style="background-color: transparent" class=""><i style="color: #ecec14;"\n                    class="fas fa-exclamation-triangle form-control-feedback"></i></span>\n        </span>\n    </div> --><!-- CELLULARE CLIENTE --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-11" translate="garanteasyApp.receipt.receiptNewPage.clientPhone"></span></strong> <span class="rdetail-font-size nopadding col-sm-11 col-xs-11"><input ng-disabled="vm.customerSelected.id" type="text" class="form-control-modified input-fast-track" ng-model="vm.phoneNumber"></span></div></ng-form>');
$templateCache.put('app/entities/receipt/receipt-fast-track-gift.html','<ng-form name="giftForm"><div class="row row-margin"><div class="col-sm-4 col-xs-6"><img style="max-height: 150px" class="img-responsive" ng-if="vm.getImageProductUrl(\'default\')" ng-src="{{ vm.getImageProductUrl(\'default\') }}"> <img style="height: 150px" class="img-responsive" ng-if="!vm.getImageProductUrl(\'default\')" ng-src="{{ vm.getImageProductUrl(\'product-resource\') }}"></div><div style="padding-left: 0px; padding-top:2rem" class="col-sm-4 col-xs-6"><strong>{{ vm.receipt.purchasedProduct.product.brandAndName || vm.receipt.purchasedProduct.product.name }}</strong></div></div><div ng-init="vm.giftForm = giftForm" class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-12" translate="garanteasyApp.receipt.fastTrack.gift"></span></strong> <span class="col-sm-11 col-xs-12 nopadding"><span class="col-xs-6 nopadding"><input required type="radio" ng-model="vm.receipt.gift" name="gift1" value="Y"> <span class="rdetail-font-size" translate="global.form.yes">button one</span> </span><span class="col-xs-6 nopadding"><input required type="radio" ng-model="vm.receipt.gift" name="gift2" value="N"> <span class="rdetail-font-size" translate="global.form.no">button one</span></span></span></div><!-- GIFT --><div ng-if="vm.receipt.gift === \'Y\'"><!-- NOME DI CHI EFFETTUA IL REGALO --><!-- <div ng-if="vm.receipt.gift === \'Y\' && vm.customerSelected != null" style="margin-left: 2%; margin-top: 0.5em; "\n        class="col-xs-12 col-sm-12">\n        <div class="row row-margin">\n            <strong><span style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-2"\n                    translate="garanteasyApp.receipt.receiptNewPage.donorGift"></span></strong>\n            <span class="rdetail-font-size nopadding col-sm-9">\n                <input type="text" class="form-control-modified " placeholder="{{vm.customerSelected.legalName}}"\n                    ng-model="vm.receipt.purchasedProduct.giftMakerDescription" />\n            </span>\n        </div>\n    </div> --><!-- NOME DI CHI EFFETTUA IL REGALO --><!-- <div ng-if="vm.customerSelected == null && vm.customer.name != null" style="margin-left: 2%; margin-top: 0.5em; "\n        class="col-xs-12 col-sm-12">\n        <div class="row row-margin">\n            <strong><span style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-2"\n                    translate="garanteasyApp.receipt.receiptNewPage.donorGift"></span></strong>\n            <span class="rdetail-font-size nopadding col-sm-9">\n                <input type="text" class="form-control-modified " placeholder="{{vm.customer.name}}"\n                    ng-model="vm.receipt.purchasedProduct.giftMakerDescription" />\n            </span>\n        </div>\n    </div> --><!-- EMAIL DESTINATARIO DEL REGALO --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.receipt.fastTrack.emailReceiver"></strong></div><div class="row row-margin" style="padding-right: 2em"><span class="rdetail-font-size nopadding col-sm-12 col-xs-12 input-group"><input type="email" required class="form-control-modified" ng-model="vm.receipt.purchasedProduct.giftReceiverEmail"> <span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" ng-if="! vm.receipt.purchasedProduct.giftReceiverEmail" class="form-control-feedback fas fa-exclamation-triangle" style="color: #ecec14"></span></span></div><!-- MESSAGGIO DA INVIARE AL DESTINATARIO INSIEME ALLA GARANZIA --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.receipt.fastTrack.message"></strong></div><div class="row row-margin" style="padding-right: 2em"><span class="rdetail-font-size nopadding col-sm-12 col-xs-12 input-group"><textarea rows="2" required class="form-control-modified fast-track-text-area" ng-model="vm.receipt.purchasedProduct.giftDescription"></textarea><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" ng-if="! vm.receipt.purchasedProduct.giftDescription" class="form-control-feedback fas fa-exclamation-triangle" style="color: #ecec14"></span></span></div><!-- DATA DI CONSEGNA REGALO (OBBLIGATORIA SE REGALO == \'Y\') --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-9" translate="garanteasyApp.receipt.fastTrack.giftDate"></strong></div><div class="row" style="padding-right: 2em"><span class="rdetail-font-size col-sm-12 nopadding input-group"><span class="fas fa-calendar-alt input-group-addon" ng-click="vm.openCalendar(\'giftDate\')"></span> <input readonly="readonly" ng-click="vm.openCalendar(\'giftDate\')" id="giftDate" type="text" class="form-control-modified input-fast-track" name="giftDate" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.purchasedProduct.giftNotificationDate" is-open="vm.datePickerOpenStatus.giftDate" required aria-describedby="buyingDateStatus" style="background-color: #fff"> <span ng-if="vm.receipt.purchasedProduct.giftNotificationDate == null || vm.receipt.purchasedProduct.giftNotificationDate == \'\'" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback" aria-hidden="true"></span></span></div></div></ng-form>');
$templateCache.put('app/entities/receipt/receipt-fast-track-purchasedproduct.html','<!-- PRODOTTI ACQUISTATI ICONA E TITOLO--><!-- <div style=" margin-bottom: 1em;" class="col-xs-12 col-sm-11 ">\n    <div class="row row-margin">\n        <i style="font-size: large;" class="fas fa-barcode"></i>\n        <strong style="font-size: large; margin-left: 5px" class="rdetail-font-size"\n            translate="garanteasyApp.receipt.fastTrack.infoProducts"></strong>\n    </div>\n</div> --><div class="col-xs-12 col-sm-12"><div ng-repeat="product in vm.receipt.purchasedProducts track by $index" style="margin-bottom: 1em" class="row"><span class="col-xs-10 rdetail-font-size"><a style="text-decoration: none; color: black; font-size: large" ng-click="vm.addProduct = true; vm.receipt.purchasedProduct = product; "><strong>{{ product.product.name }} - {{ product.product.brand.name }}</strong></a> </span><span class="col-xs-2"><a ng-disabled="product.giftReceiverNotified==1 && vm.currentUserId!=product.giftReceiverUserId" title="{{ \'garanteasyApp.receipt.detail.deleteProduct\' | translate }}" style="text-decoration: none; text-align: right; color: black; margin-left: 20px" class="no-print"><button style="color: black; background-color: white" class="btn btn-default btn-dark"><i class="fas fa-times" ng-click="vm.removePurchasedProduct($index)"></i></button><!--<span  class="fa fa-edit"></span>\n                            <span >modifica</span>--></a></span></div></div><hr ng-if="vm.receipt.purchasedProducts.length" style="margin-top: 4em" class="hr-green" noshade="noshade"><ng-form name="addProductForm" novalidate><div ng-init="vm.addProductForm = addProductForm" style="margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin btn-group" ng-if="!vm.isFestina && !vm.isPlus"><label ng-click="vm.products = []; vm.receipt.purchasedProduct.product = null" uib-btn-radio="false" class="btn btn-default" ng-model="vm.isNewProduct">Seleziona up prodotto a catalogo</label><label ng-click="vm.receipt.purchasedProduct.product = {}" uib-btn-radio="true" class="btn btn-default" ng-model="vm.isNewProduct">Inserisci un nuovo prodotto</label></div></div><div uib-collapse="vm.isNewProduct" style="margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong ng-if="vm.isFestina"><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-12" translate="garanteasyApp.receipt.fastTrack.purchasedProductFestina"></span></strong> <strong ng-if="!vm.isFestina"><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12 col-xs-12" translate="garanteasyApp.receipt.receiptNewPage.purchasedProduct"></span></strong> <span class="rdetail-font-size nopadding col-sm-11 input-group col-xs-11"><ui-select style="padding: 0em" class="form-control-modified input-fast-track" reset-search-input="false" ng-model="vm.receipt.purchasedProduct.product"><ui-select-match allow-clear="true"><div ng-bind="$select.selected.description"></div></ui-select-match><ui-select-choices refresh="loadProducts($select.search)" refresh-delay="200" repeat="product in (products) track by product.id"><div ng-bind="product.brandAndName"></div></ui-select-choices></ui-select><span ng-if="vm.receipt.purchasedProduct.product.id == null && vm.receipt.purchasedProduct.product.name == null" title="{{ \'garanteasyApp.receipt.detail.required\' | translate }}" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></span></span></div><div ng-if="vm.receipt.purchasedProduct.product && vm.isFestina"><div class="row row-margin margin-row-fast"><strong><span style="padding-left: 0px" class="col-sm-12 col-xs-12">{{ vm.receipt.purchasedProduct.product.brandAndName }}</span></strong></div><div class="row row-margin"><div style="padding-left: 0px" class="col-xs-12"><strong class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductName">Nome</strong> <span>{{ vm.receipt.purchasedProduct.product.name }}</span></div></div><div class="row row-margin"><div style="padding-left: 0px" class="col-xs-12"><strong class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductCode">Codice</strong> <span>{{ vm.receipt.purchasedProduct.product.eanCode ? vm.receipt.purchasedProduct.product.eanCode : \'\'}}</span></div></div><div class="row row-margin"><div style="padding-left: 0px" class="col-xs-12"><strong class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductDescription">Desrizione</strong> <span>{{ vm.receipt.purchasedProduct.product.description }}</span></div></div><div class="row row-margin"><div class="col-xs-10"><img style="height: 300px" class="img-responsive" ng-src="{{vm.getImageProductUrl(\'product-resource\')}}"></div></div></div></div><div uib-collapse="!vm.isNewProduct" style="margin-top: 0.5em" class="col-xs-12 col-sm-12"><!-- PODUTTORE required --><!-- <div class="row row-margin">\n            <strong style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-2"\n                translate="garanteasyApp.receipt.fastTrack.producer"></strong>\n        </div>\n        <div class="row row-margin" style="padding-right: 2em;">\n            <span class="rdetail-font-size nopadding col-sm-12 col-xs-12 input-group" style="display: block">\n                <ui-select reset-search-input="false" ng-model="vm.receipt.purchasedProduct.product.producer"\n                    ng-disabled="vm.receipt.purchasedProduct.product.idxId != null"\n                    on-select="vm.onSelectedCompany($select.selected)">\n                    <ui-select-match allow-clear="true">\n                        <div ng-bind="$select.selected.name"></div>\n                    </ui-select-match>\n                    <ui-select-choices refresh="loadCompanies($select.search)"\n                        repeat="producer in (companies) track by producer.id">\n                        <div ng-bind="producer.code"></div>\n                    </ui-select-choices>\n                </ui-select>\n                <span ng-if="vm.receipt.purchasedProduct.product.producer == null"\n                    title="{{\'garanteasyApp.receipt.detail.required\'|translate}}"\n                    class="form-control-feedback fas fa-exclamation-triangle" style="color: red;"></span>\n            </span>\n        </div> --><!-- MARCA required --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.receipt.fastTrack.brand"></strong></div><div class="row row-margin" style="padding-right: 2em"><span class="rdetail-font-size nopadding col-sm-12 col-xs-12 input-group" style="display: block"><ui-select reset-search-input="false" ng-model="vm.receipt.purchasedProduct.product.brand" ng-disabled="vm.receipt.purchasedProduct.product.idxId != null"><ui-select-match allow-clear="true"><div ng-bind="$select.selected.name"></div></ui-select-match><ui-select-choices refresh="loadBrands($select.search, vm.receipt.purchasedProduct.product.producer)" repeat="brand in (brands) track by brand.id"><div ng-bind="\'(\' + brand.code + \') \' + brand.name"></div></ui-select-choices></ui-select><span ng-if="vm.receipt.purchasedProduct.product.brand == null" title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" class="form-control-feedback fas fa-exclamation-triangle" style="color: red"></span></span></div><!-- SIGLA/NOME PRODOTTO required --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.receipt.fastTrack.purchasedProductName"></strong></div><div class="row row-margin" style="padding-right: 2em"><span class="rdetail-font-size nopadding col-sm-12 col-xs-12 input-group"><input ng-disabled="vm.receipt.purchasedProduct.product.idxId != null" type="text" required class="form-control-modified" ng-model="vm.receipt.purchasedProduct.product.name"> <span ng-if="! vm.receipt.purchasedProduct.product.name" class="form-control-feedback fas fa-exclamation-triangle" style="color: red"></span></span></div></div><!-- IMMAGINE PRODOTTO --><div ng-if="!vm.isFestina" class="col-xs-12 col-sm-12" style="margin-top: 1em"><div class="row row-margin"><div class="col-xs-6" style="padding-left: 0px"><strong style="padding-left: 0px" class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductImage"></strong></div><div class="col-xs-6"><img style="max-height: 100px" ng-if="vm.getImageProductUrl(\'default\')" ng-src="{{vm.getImageProductUrl(\'default\')}}"> <button type="button" class="btn btn-default btn-dark" ng-if="!vm.getImageProductUrl(\'default\')" ngf-select="vm.uploadFile($file, \'default\')"><span class="fas fa-camera"></span></button></div></div></div><div ng-if="!vm.isFestina" class="col-xs-12 col-sm-12" style="margin-top: 1em"><div class="row row-margin"><div class="col-xs-6" style="padding-left: 0px"><strong style="padding-left: 0px" class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductCodesImage"></strong></div><div class="col-xs-6"><img style="max-height: 100px" ng-if="vm.getImageProductUrl(\'codes\')" ng-src="{{ vm.getImageProductUrl(\'codes\') }}"> <button ng-if="!vm.getImageProductUrl(\'codes\')" type="button" class="btn btn-default btn-dark" ngf-select="vm.uploadFile($file, \'codes\')"><span class="fas fa-camera"></span></button></div></div></div><div ng-if="!vm.isFestina" ng-init="vm.warrantyFormAdd = warrantyFormAdd" class="col-xs-12 col-sm-12" style="margin-top: 1em"><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warranty.hasWarrantyConventional">Aggiungi garanzia convenzionale</strong></div></div><div ng-if="!vm.isFestina" style="margin-top: 0.5em; margin-bottom: 0.5em"><div class="row row-margin"><span class="col-sm-12 col-xs-11 nopadding"><span class="col-sm-6 col-xs-6"><input type="radio" ng-click="vm.receipt.purchasedProduct.warrantyConventional = {}" ng-checked="vm.receipt.purchasedProduct.warrantyConventional" name="has_warranty_conventional"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.YES">Si</span> </span><span class="col-sm-6 col-xs-6"><input type="radio" ng-click="vm.receipt.purchasedProduct.warrantyConventional = null" ng-checked="vm.receipt.purchasedProduct.warrantyConventional === null" name="has_warranty_conventional"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.NO">No</span></span></span></div><div style="margin-left: 1em; margin-top: 0.5em; margin-bottom: 0.5em"><warranty-edit-component on-update="vm.onUpdateConventionalWarranty" ng-if="vm.receipt.purchasedProduct.warrantyConventional" purchased-product-warranty="vm.receipt.purchasedProduct.warrantyConventional" purchased-product="vm.receipt.purchasedProduct" is-conventional-standard="true" is-fast="true" type="\'CONVENTIONAL\'"></warranty-edit-component></div><div ng-if="!vm.isFestina && vm.receipt.purchasedProduct.warrantyConventional" class="col-xs-12 col-sm-12" style="margin-top: 1em"><div class="row row-margin"><div class="col-xs-6" style="padding-left: 0px"><strong style="padding-left: 0px" class="rdetail-font-size-colored" translate="garanteasyApp.receipt.fastTrack.purchasedProductWarrantyImage"></strong></div><div class="col-xs-6"><img style="max-height: 100px" ng-if="vm.getImageProductUrl(\'warranty\')" ng-src="{{vm.getImageProductUrl(\'warranty\')}}"> <button type="button" class="btn btn-default btn-dark" ng-if="!vm.getImageProductUrl(\'warranty\')" ngf-select="vm.uploadFile($file, \'warranty\')"><span class="fas fa-camera"></span></button></div></div></div></div></ng-form><!-- <div class="hidden-print col-xs-4 text-center">\n        <button ng-if="vm.receipt.purchasedProducts.length" type="button" class="btn btn-default btn-dark" ng-click="vm.toPreviousPurchasedProduct()" >BACK</button>\n    </div> --><!-- <div class="hidden-xs hidden-print col-xs-6 text-center">\n    <button type="button" ng-disabled="addProductForm.$invalid || !vm.isValidPurchasedProduct()"\n        class="btn btn-default btn-dark" ng-click="vm.receipt.gift=\'N\'; vm.addPurchasedProduct();"><span\n            class="fas fa-plus"></span></button>\n</div>\n<div class="hidden-xs hidden-print col-xs-6 text-center">\n    <button ng-disabled="addProductForm.$invalid || !vm.isValidPurchasedProduct()" type="button"\n        class="btn btn-default btn-dark" translate="garanteasyApp.receipt.receiptNewPage.done"\n        ng-click="vm.receipt.gift=\'N\'; vm.addPurchasedProduct(true);">DONE</button>\n</div> -->');
$templateCache.put('app/entities/receipt/receipt-fast-track.html','<!DOCTYPE html><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><div class="row-fluid"><div class="main-wrapper"><div class="main"><span style="font-size: 16px">{{ "garanteasyApp.receipt.receiptNewPage.title" | translate }}</span></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><!-- <div class="container-fluid">\n\n</div> --><!-- codice di test rapido per il componente barcodereader.\nCommittato del codice parziale funzionante per evitare conflitti\n--><!-- <span class="input-group">\n    <span class="input-group-addon" style="padding:2px;">\n        <bar-code-reader btn-class="" my-model="test"></bar-code-reader>\n    </span>\n    <input type="text" class="form-control-modified" ng-model="test" />\n</span> --><div style="margin-top: 12px; height: 80vh" class="product-details-wrapper"><form name="editForm" role="form" novalidate ng-submit="vm.save()" class=""><div ng-if="vm.activeSlide == 1"><div style="margin-left: 2%" class="col-xs-11 col-sm-12"><div class="row row-margin"><!-- <i style="font-size: large;" class="fas fa-file-invoice-dollar "></i> --> <strong><span style="font-size: large" class="rdetail-font-size" translate="garanteasyApp.receipt.fastTrack.customerTitle"></span></strong></div></div><div style="margin-left: 2%; min-height: 30vh" class="col-xs-12 col-sm-12" ng-include="\'app/entities/receipt/receipt-fast-track-customer.html\'"></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><a ui-sref="receipt" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.cancel">CANCEL</a></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button ng-disabled="editForm.$invalid || !vm.validEmail" type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.next" ng-click="vm.activeSlide = 2" ng-disabled="vm.customerForm.$invalid">NEXT</button></div></div><div ng-if="vm.activeSlide == 2"><div class="col-xs-12"><hr class="hr-green" noshade="noshade"></div><!--DATI SUL DOCUMENTO D\'ACQUISTO--><div style="margin-left: 2%; margin-bottom: 1em" class="col-xs-12 col-sm-11"><div class="row row-margin"><i style="font-size: large" class="fas fa-file-invoice-dollar"></i> <strong style="font-size: large; margin-left: 5px" class="rdetail-font-size" translate="garanteasyApp.receipt.fastTrack.documentTitle"></strong></div></div><div style="margin-left: 2%" class="col-xs-12 col-sm-12"><div class="row"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.receipt.detail.type"></strong></div><div class="row"><span class="col-sm-4 nopadding"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="OFFICIAL_RECEIPT"> <span class="rdetail-font-size" translate="garanteasyApp.ReceiptType.OFFICIAL_RECEIPT">button one</span> </span><span class="col-sm-4 nopadding"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="RECEIPT"> <span class="rdetail-font-size" translate="garanteasyApp.ReceiptType.RECEIPT">button one</span> </span><span class="col-sm-4 nopadding"><input type="radio" ng-model="vm.receipt.receiptType" name="type" value="INVOICE"> <span class="rdetail-font-size" translate="garanteasyApp.ReceiptType.INVOICE">button one</span> </span><span ng-if="vm.receipt.receiptType == null"><span uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent"><i style="color: red" class="fas fa-exclamation-triangle"></i></span></span></div><!-- DATA DI EMISSIONE --><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-9" translate="garanteasyApp.receipt.detail.buyingDate"></strong></div><div class="row" style="padding-right: 2em"><span class="rdetail-font-size col-sm-12 nopadding input-group"><span class="fas fa-calendar-alt input-group-addon" ng-click="vm.openCalendar(\'buyingDate\')"></span> <input readonly="readonly" ng-click="vm.openCalendar(\'buyingDate\')" ng-change="loadActiveCards()" id="buyingDate" type="text" class="form-control-modified input-fast-track" name="buyingDate" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" tooltip-enable="vm.receipt.buyingDate == null || vm.receipt.buyingDate == \'\'" datepicker-options="vm.datePickerOptions" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.buyingDate" is-open="vm.datePickerOpenStatus.buyingDate" required aria-describedby="buyingDateStatus" style="background-color: #fff"> <span ng-if="vm.receipt.buyingDate == null || vm.receipt.buyingDate == \'\'" style="color: red" class="fas fa-exclamation-triangle form-control-feedback" aria-hidden="true"></span></span></div></div><div class="row" style="margin-top: 15px; margin-bottom: 3rem"><div class="col-xs-12 col-sm-11 col-sm-offset-1"></div></div><div class="col-xs-6"></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button ng-disabled="editForm.$invalid" class="btn btn-default btn-dark" ngf-select="vm.uploadFile($file)"><span class="fas fa-cloud-upload-alt"></span></button></div></div><div ng-if="vm.activeSlide == 3"><div style="margin-left: 2%" class="row" style="margin-top: 15px; margin-bottom: 15px"><div class="col-xs-12 col-sm-11 col-sm-offset-1"><div class="main-image"><image-cropper on-cancel="vm.deleteFile(file)" ng-if="vm.receiptFiles.length" portrait="true" files="vm.receiptFiles"></image-cropper></div></div></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button ng-disabled="editForm.$invalid" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.back" ng-click="vm.deleteFile(vm.receiptFiles[0]); vm.activeSlide == 2">BACK</button></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button ng-disabled="editForm.$invalid" type="button" class="btn btn-default btn-dark" ng-click="vm.saveStepReceiptFile();"><span ng-if="!vm.isBasic" translate="garanteasyApp.receipt.fastTrack.ok">OK</span> <span ng-if="vm.isBasic" translate="garanteasyApp.receipt.fastTrack.end">END</span></button></div></div><div ng-if="vm.activeSlide == 4"><div style="min-height: 30vh" class="col-xs-12 col-sm-12" ng-include="\'app/entities/receipt/receipt-fast-track-purchasedproduct.html\'"></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button ng-if="vm.isFestina" type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.noFestina" ng-click="vm.noFestina();"></button></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.ok" ng-click="vm.activeSlide = 6" ng-disabled=" !vm.isValidPurchasedProduct()">OK</button></div></div><div ng-if="vm.activeSlide == 5"><div class="col-xs-12"><hr class="hr-green" noshade="noshade"></div><div class="row" style="margin-top: 15px; margin-bottom: 15px"><div class="col-xs-12 col-sm-11 col-sm-offset-1"><div class="main-image"><image-cropper on-cancel="vm.deleteFile(file)" ng-if="vm.receiptFile" portrait="true" files="[vm.receiptFile]"></image-cropper></div></div></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.back" ng-click="vm.receiptFile = null; vm.activeSlide = 4;">BACK</button></div><div class="hidden-print hidden-xs col-xs-6 text-center fast-track-button"><button type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.ok" ng-click="vm.addImageToProduct()">OK</button></div></div><div ng-if="vm.activeSlide == 6"><div style="margin-left: 2%; min-height: 40vh" class="col-xs-12 col-sm-12" ng-include="\'app/entities/receipt/receipt-fast-track-gift.html\'"></div><div class="hidden-print hidden-xs col-xs-5 text-center fast-track-button"><button ng-click="vm.activeSlide = 4;" type="button" translate="garanteasyApp.receipt.fastTrack.back" class="btn btn-default btn-dark" style="margin-top:3px">BACK</button></div><div class="hidden-print hidden-xs col-xs-2 text-center fast-track-button"><button ng-disabled="vm.giftForm.$invalid" ng-click="vm.addPurchasedProduct();" type="button" class="btn btn-default btn-dark" style="margin-top:3px"><span class="fas fa-plus"></span></button></div><div class="hidden-print hidden-xs col-xs-5 text-center fast-track-button"><button ng-disabled="vm.giftForm.$invalid" ng-click="vm.addPurchasedProduct(true);" type="button" translate="garanteasyApp.receipt.fastTrack.done" class="btn btn-default btn-dark" style="margin-top:3px">DONE</button></div></div></form></div><!-- INIZIO MENU MOBILE PER USER --><div ng-if="vm.isAuthenticated()" class="fast-track-footer visible-xs visible-sm text-center"><div class="col-xs-12 col-sm-11 no-padding"><div class="row" id="bottomNav"><div ng-if="vm.activeSlide == 1"><div class="col-xs-6 text-center"><a ui-sref="receipt" type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.cancel">CANCEL</a></div><div class="col-xs-6 text-center"><button ng-click="vm.activeSlide = 2" ng-disabled="vm.customerForm.$invalid || !vm.validEmail" type="button" translate="garanteasyApp.receipt.fastTrack.next" class="btn btn-default btn-dark">NEXT</button></div></div><div ng-if="vm.activeSlide == 2"><div class="col-xs-6 text-center"><a ui-sref="receipt" type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.cancel">CANCEL</a></div><div class="col-xs-6 text-center"><button ng-disabled="editForm.$invalid" type="button" class="btn btn-default btn-dark" ngf-select="vm.uploadFile($file)" ngf-capture="\'camera\'"><span class="fas fa-camera"></span></button></div></div><div ng-if="vm.activeSlide == 3"><div class="col-xs-6 text-center"><button ng-click="vm.deleteFile(vm.receiptFiles[0]); vm.activeSlide == 2" translate="garanteasyApp.receipt.fastTrack.back" type="button" class="btn btn-default btn-dark">BACK</button></div><div class="col-xs-6 text-center"><button ng-click="vm.saveStepReceiptFile();" type="button" class="btn btn-default btn-dark"><span ng-if="!vm.isBasic" translate="garanteasyApp.receipt.fastTrack.ok">OK</span> <span ng-if="vm.isBasic" translate="garanteasyApp.receipt.fastTrack.end">END</span></button></div></div><div ng-if="vm.activeSlide == 4"><div class="text-center" ng-class="vm.isFestina ? \'col-xs-8\': \'col-xs-6\'"><button ng-if="vm.isFestina" type="button" class="btn btn-default btn-dark" translate="garanteasyApp.receipt.fastTrack.noFestina" ng-click="vm.noFestina();"></button></div><div class="text-center" ng-class="vm.isFestina ? \'col-xs-4\': \'col-xs-6\'"><button ng-click="vm.activeSlide = 6" type="button" translate="garanteasyApp.receipt.fastTrack.ok" class="btn btn-default btn-dark" ng-disabled="!vm.isValidPurchasedProduct()">OK</button></div></div><div ng-if="vm.activeSlide == 5"><div class="col-xs-6 text-center"><button ng-click="vm.receiptFile = null; vm.activeSlide = 4;" type="button" translate="garanteasyApp.receipt.fastTrack.back" class="btn btn-default btn-dark">BACK</button></div><div class="col-xs-6 text-center"><button ng-click="vm.addImageToProduct()" type="button" translate="garanteasyApp.receipt.fastTrack.ok" class="btn btn-default btn-dark">OK</button></div></div><div ng-if="vm.activeSlide == 6"><div class="col-xs-5 text-center"><button ng-click="vm.activeSlide = 4;" type="button" translate="garanteasyApp.receipt.fastTrack.back" class="btn btn-default btn-dark">BACK</button></div><div class="col-xs-2 text-center"><button ng-disabled="vm.giftForm.$invalid" ng-click="vm.addPurchasedProduct();" type="button" class="btn btn-default btn-dark"><span class="fas fa-plus"></span></button></div><div class="col-xs-5 text-center"><button ng-disabled="vm.giftForm.$invalid" ng-click="vm.addPurchasedProduct(true);" type="button" translate="garanteasyApp.receipt.fastTrack.done" class="btn btn-default btn-dark">DONE</button></div></div></div></div></div>');
$templateCache.put('app/entities/receipt/receipt-gift-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.saveGift()" class="tab-form-demo"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPurchasedProductLabel" translate="garanteasyApp.purchasedProduct.home.createOrEditLabel">Create or edit a Purchased Product</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.isOwner || vm.isAdmin"><label class="control-label" translate="garanteasyApp.purchasedProduct.deliveryDate" for="field_deliveryDate">Delivery Date</label>&nbsp;(*)<div class="input-group"><input id="field_deliveryDate" type="text" class="form-control" name="deliveryDate" uib-datepicker-popup="mediumDate" ng-model="vm.purchasedProductGift.deliveryDate" is-open="vm.datePickerOpenStatus.deliveryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deliveryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div><p class="help-block" translate="garanteasyApp.purchasedProduct.deliveryDateNote">Delivery date explanation.</p></div></div><div class="form-group"><div ng-switch="vm.purchasedProduct.giftReceiverNotified"><div ng-switch-when="1"><!-- Cannot change receiver when gift has already been notified --><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificatedTo">Notifica del regalo inviata a:</label><input type="email" class="form-control" name="giftReceiverEmail" id="field_giftReceiverEmail" ng-model="vm.purchasedProductGift.giftReceiverEmail" readonly="readonly"></div><div ng-switch-default><label class="control-label" translate="garanteasyApp.purchasedProduct.giftReceiverEmail" for="field_giftReceiverEmail">Se questo \uFFFD un regalo, inserisci l\'email di chi lo ricever\uFFFD</label><input type="email" class="form-control" name="giftReceiverEmail" id="field_giftReceiverEmail" ng-model="vm.purchasedProductGift.giftReceiverEmail" ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.giftReceiverEmail.$invalid"><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.email" translate="global.messages.validate.email.invalid">E-mail is invalid.</p><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.minlength" translate="global.messages.validate.email.minlength">E-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.giftReceiverEmail.$error.maxlength" translate="global.messages.validate.email.maxlength">E-mail cannot be longer than 100 characters.</p></div></div></div></div><div class="form-group"><div ng-switch="vm.purchasedProduct.giftReceiverNotified"><div ng-switch-when="1"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificatedDate">In data:</label><!-- Cannot change notification date when gift has already been notified --> <input id="field_giftNotificationDate" type="text" class="form-control" name="giftNotificationDateRO" value="{{vm.purchasedProduct.giftNotificationDate | date:\'mediumDate\'}}" readonly="readonly"></div><div ng-switch-default><label class="control-label" translate="garanteasyApp.purchasedProduct.giftNotificationDate" for="field_giftNotificationDate">Gift Notification Date</label>&nbsp;(*)<div class="input-group"><input id="field_giftNotificationDate" type="text" class="form-control" name="giftNotificationDate" uib-datepicker-popup="mediumDate" ng-model="vm.purchasedProductGift.giftNotificationDate" is-open="vm.datePickerOpenStatus.giftNotificationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'giftNotificationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div><p class="help-block" translate="garanteasyApp.purchasedProduct.giftNotificationDateNote">Gift notification date explanation.</p></div></div></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftMakerDescription" for="giftMakerDescription">Gift Maker Description</label><span ng-show="vm.purchasedProduct.giftReceiverNotified!=1">&nbsp;(*)</span><!-- Cannot change gift maker description when gift has already been notified --> <input type="text" class="form-control" name="giftMakerDescription" id="giftMakerDescription" ng-model="vm.purchasedProductGift.giftMakerDescription" ng-readonly="vm.purchasedProduct.giftReceiverNotified==1"><div ng-show="vm.purchasedProduct.giftReceiverNotified!=1"><p class="help-block" translate="garanteasyApp.purchasedProduct.giftMakerDescriptionNote">giftMakerDescription explanation.</p></div></div><div class="form-group"><label class="control-label" translate="garanteasyApp.purchasedProduct.giftDescription" for="giftDescription">Gift Description</label><input type="text" class="form-control" name="giftDescription" id="giftDescription" ng-model="vm.purchasedProductGift.giftDescription"></div><br></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.saveGift()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/receipt/receipt-new-page-customer.html','<!-- <!DOCTYPE html>\n<meta charset="utf-8" />\n<meta http-equiv="X-UA-Compatible" content="IE=edge" />\n<meta name="viewport" content="width=device-width, initial-scale=1" /> --><!-- NOME CLIENTE --><form><!-- CUSTOMER --><div class="row row-margin" style="margin-bottom: 1em"><div class="btn-group"><label uib-btn-radio="false" class="btn btn-default" ng-model="vm.isNewCustomer" translate="garanteasyApp.receipt.receiptNewPage.customer">Seleziona un cliente affezionato</label><label uib-btn-radio="true" class="btn btn-default" ng-model="vm.isNewCustomer">Inserisci un nuovo cliente</label></div></div><div class="row row-margin" uib-collapse="vm.isNewCustomer"><div class="rdetail-font-size nopadding col-sm-9 input-group"><ui-select style="padding: 0em" class="form-control-modified" id="field_customer " name="customer " ng-model="vm.customerSelected" reset-search-input="false" ng-change="vm.updateCustomerData()"><ui-select-match allow-clear="true" placeholder="Seleziona un tuo cliente"><div ng-bind="$select.selected.legalName"></div></ui-select-match><ui-select-choices refresh="loadCustomers($select.search)" refresh-delay="200" repeat="customer in vm.customers | orderBy: \'legalName\'"><div ng-bind="customer.legalName"></div></ui-select-choices></ui-select><span ng-if="vm.customerSelected == null && vm.customer.name == null && vm.customer.surname == null" title="{{ \'garanteasyApp.receipt.detail.required\' | translate }}" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></span></div></div><!-- NOME CLIENTE --><div class="row row-margin" uib-collapse="!vm.isNewCustomer"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.clientName"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-disabled="vm.customerSelected != null" type="text" class="form-control-modified" ng-model="vm.customer.name"> </span><span ng-if="vm.customerSelected == null && vm.customer.name == null && vm.customer.surname == null"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div><!-- COGNOME CLIENTE --><div class="row row-margin" uib-collapse="!vm.isNewCustomer"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.clientSurname"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-disabled="vm.customerSelected != null" type="text" class="form-control-modified" ng-model="vm.customer.surname"> </span><span ng-if="vm.customerSelected == null && vm.customer.name == null && vm.customer.surname == null"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div><!-- EMAIL CLIENTE --><div class="row row-margin" uib-collapse="!vm.isNewCustomer"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.clientEmail"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-disabled="vm.customerSelected != null" type="email" class="form-control-modified" ng-model="vm.customer.email"> </span><span ng-if="vm.customerSelected == null && vm.customer.email == null || vm.customer.email == \'\'"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}} {{\'garanteasyApp.receipt.receiptNewPage.validationEmail\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div><!-- CELLULARE CLIENTE --><div class="row row-margin" uib-collapse="!vm.isNewCustomer"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.clientPhone"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-disabled="vm.customerSelected != null" type="text" class="form-control-modified" ng-model="vm.phoneNumber"></span></div></form>');
$templateCache.put('app/entities/receipt/receipt-new-page-purchasedproduct.html','<!-- ELENCO PRODOTTI ACQUISTATI --><div ng-repeat="product in vm.receipt.purchasedProducts track by $index" style="margin-bottom: 1em" class="col-xs-12 col-sm-11"><span class="rdetail-font-size"><a style="margin-left: 2%; text-decoration: none; color: black; font-size: large" ui-sref="purchased-product/detail({id:product.id})"><strong>{{ product.product.name }} </strong>- <strong>{{ product.product.brand.name }} </strong></a></span><a ng-disabled="product.giftReceiverNotified==1 && vm.currentUserId!=product.giftReceiverUserId" title="{{ \'garanteasyApp.receipt.detail.deleteProduct\' | translate }}" style="text-decoration: none; text-align: right; color: black; margin-left: 20px" class="no-print"><button style="color: black; background-color: white" class="btn btn-dark"><i class="fas fa-times" ng-click="vm.removePurchasedProduct($index)"></i></button><!--<span  class="fa fa-edit"></span>\n            <span >modifica</span>--></a></div><hr ng-if="vm.addProduct == true" style="margin-top: 4em" class="hr-green" noshade="noshade"><div ng-if="vm.addProduct == true" class="row row-margin" style="margin-left: 2%; margin-bottom: 1em"><div class="btn-group"><label uib-btn-radio="false" class="btn btn-default" ng-model="vm.isNewProduct">Seleziona up prodotto a catalogo</label><label uib-btn-radio="true" class="btn btn-default" ng-model="vm.isNewProduct">Inserisci un nuovo prodotto</label></div></div><!-- SUGGESTION SELEZIONE PRODOTTO  --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12" uib-collapse="vm.isNewProduct"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.purchasedProduct"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><ui-select reset-search-input="false" ng-model="vm.receipt.purchasedProduct.product"><ui-select-match allow-clear="true"><div ng-bind="$select.selected.description"></div></ui-select-match><ui-select-choices refresh="loadProducts($select.search)" refresh-delay="200" repeat="product in (products) track by product.idxId"><div ng-bind="product.brandAndName"></div></ui-select-choices></ui-select></span><span ng-if="vm.receipt.purchasedProduct.product.idxId == null && vm.receipt.purchasedProduct.product.name == null"><span title="{{\'garanteasyApp.receipt.detail.required\' | translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div><!-- BRAND --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12" uib-collapse="!vm.isNewProduct"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.brand"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><ui-select reset-search-input="false" ng-model="vm.receipt.purchasedProduct.product.brand" ng-disabled="vm.receipt.purchasedProduct.product.idxId != null"><ui-select-match allow-clear="true"><div ng-bind="$select.selected.name"></div></ui-select-match><ui-select-choices refresh="loadBrands($select.search)" refresh-delay="200" repeat="brand in (brands) track by brand.id"><div ng-bind="brand.code"></div></ui-select-choices></ui-select></span><span ng-if="vm.receipt.purchasedProduct.product.brand == null"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div><!-- NOME PRODOTTO --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12" uib-collapse="!vm.isNewProduct"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.purchasedProductName"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-disabled="vm.receipt.purchasedProduct.product.idxId != null" type="text" class="form-control-modified" ng-model="vm.receipt.purchasedProduct.product.name"> </span><span ng-if="vm.receipt.purchasedProduct.product.name == null"><span title="{{\'garanteasyApp.receipt.detail.required\' | translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div><!-- TIPOLOGIA DI CODICE PRODOTTO --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12" uib-collapse="!vm.isNewProduct"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.typeCode"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><select ng-disabled="vm.receipt.purchasedProduct.product.idxId != null" ng-change="vm.ccc13()" style="padding: 0em" class="form-control-modified" name="typeCode" ng-model="vm.receipt.purchasedProduct.typeCode" ng-options="typeCode as typeCode for typeCode in vm.typeCodes track by typeCode"></select></span></div></div><!-- CODICE --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12" uib-collapse="!vm.isNewProduct"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.eanCode"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input ng-change="vm.ccc13()" ng-disabled="vm.receipt.purchasedProduct.product.idxId != null" type="number" class="form-control-modified" ng-model="vm.receipt.purchasedProduct.product.eanCode"> </span><span ng-if="(vm.receipt.purchasedProduct.product.eanCode == null || !vm.isValidCode) && vm.receipt.purchasedProduct.product.idxId == null"><span title="{{vm.message}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div><!-- IMMAGINE PRODOTTO --><!-- <div ng-if="vm.addProduct == true" class="row product-details-wrapper" style="margin-bottom:0.5em;">\n    <div class="row row-margin ">\n        <div class="col-xs-12 col-sm-11 col-sm-offset-1">\n            <div class="main-image">\n                <image-cropper on-cancel="vm.deleteFile(file, true)" ng-if="vm.receipt.purchasedProduct.receiptFiles.length" files="vm.receipt.purchasedProduct.receiptFiles"></image-cropper>\n            </div>\n        </div>\n    </div>\n    <div ng-if="!vm.isEdit" class="hidden-print row row-margin">\n        <span class="rdetail-font-size nopadding col-sm-11 " style="text-align: right">\n            <button type="button" class="btn btn-light" uib-tooltip="Work in progress"><span class="fas fa-info-circle"></span></button>\n        <button type="button" class="btn btn-dark" ngf-select="vm.uploadFile($file, true)"><span class="fas fa-cloud-upload-alt"></span></button>\n        </span>\n    </div>\n</div> --><!-- REGALO SI/NO --><div ng-if="vm.addProduct == true" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.gift"></span></strong> <span class="col-sm-3 nopadding"><span class="col-sm-6 nopadding"><input type="radio" ng-model="vm.receipt.gift" name="gift1" value="Y"> <span class="rdetail-font-size" translate="global.form.yes">button one</span> </span><span class="col-sm-6 nopadding"><input type="radio" ng-model="vm.receipt.gift" name="gift2" value="N"> <span class="rdetail-font-size" translate="global.form.no">button one</span></span></span></div></div><!-- GIFT --><div ng-if="vm.receipt.gift === \'Y\'  && vm.addProduct == true"><!-- NOME DI CHI EFFETTUA IL REGALO --><div ng-if="vm.receipt.gift === \'Y\' && vm.customerSelected != null" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.donorGift"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="text" class="form-control-modified" placeholder="{{vm.customerSelected.legalName}}" ng-model="vm.receipt.purchasedProduct.giftMakerDescription"></span></div></div><!-- NOME DI CHI EFFETTUA IL REGALO --><div ng-if="vm.customerSelected == null && vm.customer.name != null" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.donorGift"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="text" class="form-control-modified" placeholder="{{vm.customer.name}}" ng-model="vm.receipt.purchasedProduct.giftMakerDescription"></span></div></div><!-- EMAIL DESTINATARIO DEL REGALO --><div style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.emailReceiver"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="email" class="form-control-modified" ng-model="vm.receipt.purchasedProduct.giftReceiverEmail"> </span><span ng-if="vm.receipt.purchasedProduct.giftReceiverEmail == null"><span title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div><!-- MESSAGGIO DA INVIARE AL DESTINATARIO INSIEME ALLA GARANZIA --><div style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.message"></span></strong> <span class="rdetail-font-size nopadding col-sm-9"><input type="text" class="form-control-modified" ng-model="vm.receipt.purchasedProduct.giftDescription"></span></div></div><div style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><!-- DATA DI CONSEGNA REGALO (OBBLIGATORIA SE REGALO == \'Y\') --><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.giftDate"></span></strong> <span class="rdetail-font-size col-sm-9 nopadding"><input id="giftDate" type="text" class="form-control-modified" name="giftDate" uib-datepicker-popup="mediumDate" ng-model="vm.receipt.purchasedProduct.giftNotificationDate" is-open="vm.datePickerOpenStatus.giftDate" required> </span><span><button type="button" class="btn btn-xs" ng-click="vm.openCalendar(\'giftDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><span ng-if="vm.receipt.purchasedProduct.giftNotificationDate == null || vm.receipt.purchasedProduct.giftNotificationDate == \'\'"><span title="{{\'garanteasyApp.receipt.detail.required\' | translate}}" style="background-color: transparent" class="btn btn-xs"><i style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></i></span></span></div></div></div><!-- vm.contPurchasedProducts = vm.receipt.purchasedProducts.size + 1; ***** {{vm.contPurchasedProducts}} --><!-- *** {{vm.receipt.purchasedProduct}} ---- {{vm.receipt.purchasedProducts}} -->');
$templateCache.put('app/entities/receipt/receipt-new-page.html','<!DOCTYPE html><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><div class="row-fluid"><div class="main-wrapper"><div class="main"><span style="font-size: 16px">{{ "garanteasyApp.receipt.receiptNewPage.title" | translate }}</span></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div style="margin-top: -12px" class="row product-details-wrapper"><hr class="hr-green" noshade="noshade"><!--CUSTOMER TITLE--><div style="margin-left: 2%" class="col-xs-12 col-sm-12"><div class="row row-margin"><!-- <i style="font-size: large;" class="fas fa-file-invoice-dollar "></i> --> <strong><span style="font-size: large" class="rdetail-font-size" translate="garanteasyApp.receipt.receiptNewPage.customerTitle"></span></strong></div></div><!--IMPORT CAMPI CLIENTE receipt-new-page-customer.html--><div style="margin-left: 2%" class="col-xs-12 col-sm-12" ng-include=" \'app/entities/receipt/receipt-new-page-customer.html\' "></div><!--SHOP TITLE--><div style="margin-left: 2%" class="col-xs-12 col-sm-12"><div class="row row-margin"><!-- <i style="font-size: large;" class="fas fa-file-invoice-dollar "></i> --> <strong><span style="font-size: large" class="rdetail-font-size" translate="garanteasyApp.receipt.receiptNewPage.shopTitle"></span></strong></div></div><!-- MERCHANT --><div style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.merchant "></span> </strong><span class="rdetail-font-size nopadding col-sm-9 input-group"><select style="padding: 0em" class="form-control-modified" id="merchant" name="merchant" ng-model="vm.merchant" ng-change="vm.receipt.shop = null; loadShops()" ng-options="merchant as merchant.companyName for merchant in vm.accountMerchants | orderBy: \'companyName\' "><option value="" disabled="disabled" selected="selected">{{\'garanteasyApp.receipt.receiptNewPage.merchantChoose\' | translate}}</option></select><span ng-if="! vm.merchant" title="{{ \'garanteasyApp.receipt.detail.required\' | translate }}" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></span></span></div></div><!-- SHOP --><!-- <div ng-if="vm.merchant != null" style="margin-left: 2%; margin-top: 0.5em; " class="col-xs-12 col-sm-12 ">\n            <div class="row row-margin ">\n                <strong><span style="padding-left: 0px; " class="rdetail-font-size-colored col-sm-2 " translate="garanteasyApp.receipt.receiptNewPage.shop " >\n                    </span>\n                </strong>\n\n                <span class="rdetail-font-size nopadding col-sm-9 ">\n                        <select style="padding: 0em; " class="form-control-modified " id="shop " name="shop " ng-model="vm.receipt.shopId"\n                             >\n                            <option value="" disabled selected>{{\'garanteasyApp.receipt.receiptNewPage.shopChoose\' | translate}}</option>\n                            <option value="{{shop.id}}" ng-repeat="shop in vm.shops">{{(shop.shopSignboard != null && shop.shopSignboard != \'\') ? shop.shopSignboard : (shop.description != null && shop.description != \'\') ? shop.description : shop.code}} </option>\n                        </select>\n                </span>\n\n                <span ng-if="vm.receipt.shopId == null">\n                    <span title="{{ \'garanteasyApp.receipt.detail.required\' | translate }}" style="background-color: transparent" class="btn btn-xs" >\n                        <i style="color: #ecec14;" class="fas fa-exclamation-triangle form-control-feedback" ></i\n                    ></span>\n                </span>\n            </div>\n        </div> --><div ng-if="vm.merchant != null" style="margin-left: 2%; margin-top: 0.5em" class="col-xs-12 col-sm-12"><div class="row row-margin"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-sm-2" translate="garanteasyApp.receipt.receiptNewPage.shop"></span></strong> <span class="rdetail-font-size nopadding col-sm-9 input-group"><ui-select reset-search-input="false" ng-model="vm.receipt.shop"><ui-select-match allow-clear="true"><div ng-bind="$select.selected.description"></div></ui-select-match><ui-select-choices refresh="loadShops($select.search)" refresh-delay="200" repeat="shop in (shops) track by shop.id"><div ng-bind="shop.shopSignboard != null ? shop.shopSignboard : shop.description != null ? shop.description : shop.code"></div></ui-select-choices></ui-select><span ng-if="vm.receipt.shop == null" title="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="color: #ecec14" class="fas fa-exclamation-triangle form-control-feedback"></span></span></div></div><!--DOCUMENTO D\'ACQUISTO TITLE--><div style="margin-left: 2%" class="col-xs-12 col-sm-12"><div class="row row-margin"><!-- <i style="font-size: large;" class="fas fa-file-invoice-dollar "></i> --> <strong><span style="font-size: large" class="rdetail-font-size" translate="garanteasyApp.receipt.receiptNewPage.documentTitle"></span></strong></div></div><!--IMPORT CAMPI DALLA PAGINA receipt-detail-edit-document.html--><div style="margin-left: 2%" class="col-xs-12 col-sm-12" ng-include=" \'app/entities/receipt/receipt-detail-edit-document.html\' "></div><!--FOTO DELLO SCONTRINO: --><div class="row" style="margin-top: 15px; margin-bottom: 15px"><div class="col-xs-12 col-sm-11 col-sm-offset-1"><div class="main-image" style="text-align: -webkit-center"><!-- <a id="main-image" target="_blank" ng-href="{{vm.getImageUrl(vm.image)}}"> --><!--<img  data-ng-src="{{\'data:\' + vm.receiptFile.fileContentType + \';base64,\' + vm.image.fileData}}" />--><image-cropper on-cancel="vm.deleteFile(file)" ng-if="vm.receiptFiles.length" portrait="true" files="vm.receiptFiles"></image-cropper><!-- <img style="max-height: 377px;" class="img-responsive" ng-if="vm.imageNotPersistent != null" src="data:image/png;base64,{{vm.image.fileData}}"> --><!-- <img ng-if="vm.canShow(vm.image.fileContentType)" style="max-height: 377px;" class="img-responsive" data-ng-src="{{vm.getImageUrl(vm.image)}}">\n                    <span ng-show="!vm.canShow(vm.image.fileContentType)" ng-bind-html="vm.image.fileContentType|iconify"></span> --><!--  </a> --><!-- <ul style="margin-bottom: 0px" ng-if="vm.images.length > 1" class="images-list ul-no-bump">\n                    <li ng-repeat="image in vm.images">\n                        <img class="img-responsive img-thumbnail " style="width: 80px; height: 80px ; " ng-click="vm.changeMainImage(image)" ng-src="{{\'data:\' + image.fileContentType + \';base64,\' + image.fileData}}" id="{{image.id}}">\n                    </li>\n                </ul> --></div><!-- <div style="margin-left: 10px; margin-top: 5px ">\n                <button ng-if="vm.imageNotPersistent != null" class="btn btn-dark" uib-tooltip="Delete file" ng-show="vm.image != null" ng-click="vm.imageNotPersistent = null"><span class="fa fa-trash "></span></button>\n                <button ng-if="vm.imageNotPersistent == null" class="btn btn-dark" uib-tooltip="Delete file" ng-show="vm.image != null" ng-click="vm.deleteImage(vm.image)"><span class="fa fa-trash "></span></button>\n            </div> --></div></div><div ng-if="!vm.isEdit" style="text-align: right" class="hidden-print col-xs-12"><button class="btn btn-light btn-info" uib-tooltip="Work in progress"><span class="fas fa-info-circle"></span></button> <button class="btn btn-default btn-dark" ngf-select="vm.uploadFile($file)"><span class="fas fa-cloud-upload-alt"></span></button></div><div><hr style="margin-top: 4em" class="hr-green" noshade="noshade"></div><!-- PRODOTTI ACQUISTATI ICONA E TITOLO--><div style="margin-left: 2%; margin-bottom: 1em" class="col-xs-12 col-sm-11"><div class="row row-margin"><i style="font-size: large" class="fas fa-barcode"></i> <strong><span style="font-size: large; margin-left: 5px" class="rdetail-font-size" translate="garanteasyApp.receipt.receiptNewPage.infoProducts"></span></strong></div></div><div ng-include="\'app/entities/receipt/receipt-new-page-purchasedproduct.html\'"></div><!-- PULSANTI INFO E + --><div ng-if="vm.addProduct != true" style="text-align: right; margin-top: 0.5em" class="row product-details-wrapper"><div class="row row-margin"><span style="padding-left: 0px; text-align: right" class="rdetail-font-size-colored col-sm-2"></span> <span class="rdetail-font-size nopadding col-sm-9" style="text-align: right"><button class="btn btn-light btn-info" title="Work in progress"><span class="fas fa-info-circle"></span></button> <button ng-click="vm.addProduct = true; " class="btn btn-default btn-dark" title="Add product"><a><span class="fas fa-plus" style="color:white"></span></a></button></span></div></div><!-- PULSANTI ANNULLA E AGGIUNGI PRODOTTO --><div ng-if="vm.addProduct == true" style="text-align: right; margin-top: 0.5em" class="row product-details-wrapper"><div class="row row-margin"><span style="padding-left: 0px; text-align: right" class="rdetail-font-size-colored col-sm-2"></span> <span class="rdetail-font-size nopadding col-sm-9" style="text-align: right"><button type="button" class="btn btn-default btn-dark" data-dismiss="modal" ng-click="vm.addProduct = false; vm.receipt.purchasedProduct = {};"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-disabled="vm.disableAddProduct()" class="btn btn-default btn-dark" ng-click="vm.receipt.gift=\'N\'; vm.addProductTest(); " translate="garanteasyApp.receipt.receiptNewPage.addProduct"></button></span></div></div><div><hr style="margin-top: 4em" class="hr-green" noshade="noshade"></div><div style="text-align: center"><button ng-disabled="vm.isDisabled()" ng-click="vm.save()" style="text-align: center" class="btn btn-default btn-dark"><span translate="entity.action.save">Save</span></button></div></div>');
$templateCache.put('app/entities/receipt/receipts.html','<h4><span translate="garanteasyApp.receipt.home.title">Receipts</span> (cod. <span>{{vm.model.merchant.code}} {{vm.model.shop.code}}</span>)<!-- <div ncy-breadcrumb></div>--><div class="pull-right hidden-xs"><button class="btn btn-default" ng-click="vm.gridView = true;" data-ng-disabled="vm.gridView"><span class="fas fa-th"></span></button> <button class="btn btn-default" ng-click="vm.gridView = false;" data-ng-disabled="!vm.gridView"><span class="fas fa-th-list"></span></button></div></h4><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><br><div class="table-responsive" ng-if="!vm.gridView"><table class="jh-table table table-striped"><thead class="header-nowrap"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="th-green" jh-sort-by="shop.code"><span translate="garanteasyApp.receipt.shop">Shop</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="shop.shopSignboard"><span translate="garanteasyApp.receipt.receiptNewPage.signboard">signboard</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="buyingDate"><span translate="garanteasyApp.receipt.buyingDate">Buying Date</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="receiptNumber"><span translate="garanteasyApp.receipt.document">document</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="receiptType"><span translate="garanteasyApp.receipt.receiptType">Receipt type</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="profile"><span translate="garanteasyApp.receipt.use">Receipt Use</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="customer.legalName"><span translate="garanteasyApp.receipt.customer">legalName</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="customer.user.login"><span>Email</span><span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="card.number">Card <span class="glyphicon glyphicon-sort"></span></th><th><i class="fas fa-shield-alt"></i></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="receipt in vm.receipts"><td>{{receipt.shop.code}}</td><td>{{receipt.shop.signboard.name}}</td><td>{{receipt.buyingDate | date:\'mediumDate\'}}</td><td><a ui-sref="receipt/detail({id:receipt.id})">{{receipt.counterCode ? receipt.counterCode + \' - \' : \'\'}}{{receipt.receiptNumber}}</a></td><td>{{receipt.receiptType | receiptType | translate}}</td><td>{{receipt.business ? \'BUSINESS\' : \'PERSONAL\' | receiptUse | translate}}</td><td>{{vm.showCustomerName(receipt.customer)}}</td><td><a ui-sref="customer-detail({id:receipt.customer.id})">{{receipt.customer.user.login}}</a></td><td>{{receipt.card.number}}</td><td><span uib-tooltip="{{\'garanteasyApp.warranty.status.valid\' | translate}}" ng-if="receipt.totalWarranties.numValid > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="rgba(38,186,93,1)" stroke="white" stroke-width="1"></circle></svg></span><span uib-tooltip="{{\'garanteasyApp.warranty.status.aboutToExpire\' | translate}}" ng-if="receipt.totalWarranties.numValid == 0 && receipt.totalWarranties.numExpiring > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="#f38426" stroke="white" stroke-width="1"></circle></svg></span><span uib-tooltip="{{\'garanteasyApp.warranty.status.expired\' | translate}}" ng-if="receipt.totalWarranties.numValid == 0 && receipt.totalWarranties.numExpiring == 0 && receipt.totalWarranties.numExpired > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="#f77777" stroke="white" stroke-width="1"></circle></svg></span></td><td class="text-right"><div class="action-list btn-group flex-btn-group-container"><button class="btn btn-default btn-dark" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="receipt/detail({id:receipt.id})"><span class="fas fa-expand-arrows-alt"></span><!--<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>--></button></div></td></tr></tbody></table></div><div class="row" ng-if="vm.gridView" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-distance="3" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><div class="col-lg-3 col-sm-6" ng-repeat="receipt in vm.receipts track by receipt.id"><card-receipt receipt="receipt"></card-receipt></div></div>');
$templateCache.put('app/entities/receipt/sidebar-receipt-detail.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div><!--div class="page">\n    <div class="row-fluid">\n        <div class="sidebar-left">\n\n\n\n    <h4 class="block-title"><span translate="garanteasyApp.receipt.detail.warrantiesState" ></span></h4>\n    <div class="garanzie-holder">\n                            <span class="garanzie-wrapper color-green sp-icon-check">\n                                <span class="g-value">{{vm.receipt.totalWarranties.numValid}}</span>\n                                <span translate="garanteasyApp.receipt.detail.active" class="g-title"></span>\n                            </span>\n                            <span class="garanzie-wrapper color-orange sp-icon-exclamation">\n                                <span class="g-value">{{vm.receipt.totalWarranties.numExpiring}}</span>\n                                <span translate="garanteasyApp.receipt.detail.expiring" class="g-title">IN SCADENZA</span>\n                            </span>\n                            <span class="garanzie-wrapper color-orange-dark sp-icon-ban">\n                                <span class="g-value">{{vm.receipt.totalWarranties.numExpired}}</span>\n                                <span translate="garanteasyApp.receipt.detail.expired" class="g-title">SCADUTA</span>\n                            </span>\n\n    </div>\n\n</div></div></div -->');
$templateCache.put('app/entities/receipt/sidebar-receipts.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div>');
$templateCache.put('app/entities/receipt-file/receipt-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.receiptFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.receiptFile.delete.question" translate-values="{id: \'{{vm.receiptFile.id}}\'}">Are you sure you want to delete this Receipt File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/receipt-file/receipt-file-detail.html','<div><h2 class="main-title"><span translate="garanteasyApp.receiptFile.detail.title">Receipt File</span> {{vm.receiptFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="garanteasyApp.receiptFile.fileName">File Name</span></dt><dd><span>{{vm.receiptFile.fileName}}</span></dd><dt><span translate="garanteasyApp.receiptFile.fileContentType">File Content Type</span></dt><dd><span>{{vm.receiptFile.fileContentType}}</span></dd><dt><span translate="garanteasyApp.receiptFile.receipt">Receipt</span></dt><dd><a ui-sref="receipt/detail({id:vm.receiptFile.receiptId})">{{vm.receiptFile.receiptId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="receipt-file-detail/edit({id:vm.receiptFile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/receipt-file/receipt-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReceiptFileLabel" translate="garanteasyApp.receiptFile.home.createLabel">Create or edit a Receipt File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><input type="hidden" class="form-control" id="id" name="id" ng-model="vm.receiptFile.id"> <input type="hidden" class="form-control" id="receiptId" name="receiptId" ng-model="vm.receiptFile.receiptId"><div class="form-group"><label class="control-label" translate="garanteasyApp.receipt.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.receiptFile.fileName" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.receiptFile)" ngf-pattern="\'image/*\'"><label class="control-label" translate="garanteasyApp.receiptFile.chooseFile" for="field_receiptFile">Receipt File</label><div><div ng-show="vm.receiptFile.fileContentType"><img ng-show="vm.canShow(vm.receiptFile.fileContentType)" data-ng-src="{{\'data:\' + vm.receiptFile.fileContentType + \';base64,\' + vm.receiptFile.fileData}}" style="max-width: 100px;max-height: 100px"> <span ng-show="!vm.canShow(vm.receiptFile.fileContentType)" ng-bind-html="vm.receiptFile.fileContentType.toLowerCase()|iconify"></span></div><div ng-if="vm.receiptFile.fileData" class="help-block clearfix"><span class="pull-left">{{vm.receiptFile.fileContentType}}, {{vm.byteSize(vm.receiptFile.fileData)}}</span> <button ng-click="vm.receiptFile.fileData=null;vm.receiptFile.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.receiptFile)" accept="image/*" translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="fileData" id="field_fileData" ng-model="vm.receiptFile.fileData"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.receiptFile.fileContentType"></div><br><div ng-show="vm.fileTooLarge"><p class="help-block" translate="garanteasyApp.receipt.error.fileSize">File too large</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.fileTooLarge || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/receipt-file/receipt-files.html','<div><h2 class="main-title" translate="garanteasyApp.receiptFile.home.title">Receipt Files</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="receipt-file/new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.receiptFile.home.createLabel">Create new Receipt File</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'garanteasyApp.receiptFile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span translate="garanteasyApp.receiptFile.fileName">File Name</span></th><th><span translate="garanteasyApp.receiptFile.fileContentType">File Content Type</span></th><th><span translate="garanteasyApp.receiptFile.receipt">Receipt</span></th><th></th></tr></thead><tbody><tr ng-repeat="receiptFile in vm.receiptFiles track by receiptFile.id"><td><a ui-sref="receipt-file-detail({id:receiptFile.id})">{{receiptFile.id}}</a></td><td>{{receiptFile.fileName}}</td><td>{{receiptFile.fileContentType}}</td><td><a ui-sref="receipt/detail({id:receiptFile.receiptId})">{{receiptFile.receiptId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="receipt-file-detail({id:receiptFile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="receipt-file/edit({id:receiptFile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="receipt-file/delete({id:receiptFile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/search/search.controller.html','<div ng-if="vm.model.list.length"><h4>{{\'global.search-bar.results\' | translate}} ({{vm.totalCount}})<div class="pull-right"><button class="btn btn-default" ng-click="vm.gridView = true;" data-ng-disabled="vm.gridView"><span class="fas fa-th"></span></button> <button class="btn btn-default" ng-click="vm.gridView = false;" data-ng-disabled="!vm.gridView"><span class="fas fa-th-list"></span></button></div></h4><!-- <p>\n                <span ng-if="vm.pagination.customers.totalCount"><span translate="global.search-bar.customers"></span>\n                        ({{vm.pagination.customers.totalCount}})</span>\n                <span ng-if="vm.pagination.documents.totalCount"><span translate="global.search-bar.documents"></span>\n                        ({{vm.pagination.documents.totalCount}})</span>\n                <span ng-if="vm.pagination.shops.totalCount"><span translate="global.search-bar.shops"></span>\n                        ({{vm.pagination.shops.totalCount}})</span>\n                <span ng-if="vm.pagination.products.totalCount"><span translate="global.search-bar.products"></span>\n                        ({{vm.pagination.products.totalCount}})</span>\n                <span ng-if="vm.pagination.warrenties.totalCount"><span translate="global.search-bar.warrenties"></span>\n                        ({{vm.pagination.warrenties.totalCount}})</span>\n        </p> --><br><div class="row" ng-if="vm.gridView" infinite-scroll="vm.loadPage(+vm.model.page + 1)" infinite-scroll-distance="3" infinite-scroll-disabled="vm.disableInfiniteScroll()"><div class="col-lg-3 col-sm-6" ng-repeat="item in vm.model.list"><ng-container ng-switch="item.type"><card-customer ng-switch-when="customer" customer="item.obj"></card-customer><card-receipt ng-switch-when="document" receipt="item.obj"></card-receipt><card-shop ng-switch-when="shop" shop="item.obj"></card-shop><!-- <card-product ng-switch-when="product" product="item.obj"></card-product>\n                                <card-warrenty ng-switch-when="warrenty" warrenty="item.obj"></card-warrenty> --></ng-container></div></div><div ng-if="!vm.gridView" infinite-scroll="vm.loadPage(+vm.model.page + 1)" infinite-scroll-distance="3" infinite-scroll-disabled="vm.disableInfiniteScroll()"><ul class="list-group"><ng-container ng-repeat="item in vm.model.list"><ng-container ng-switch="item.type"><list-item-customer ng-switch-when="customer" customer="item.obj"></list-item-customer><list-item-receipt ng-switch-when="document" receipt="item.obj"></list-item-receipt><list-item-shop ng-switch-when="shop" shop="item.obj"></list-item-shop><!-- <list-item-product ng-switch-when="product" product="item.obj">\n                                        </list-item-product>\n                                        <list-item-warrenty ng-switch-when="warrenty" warrenty="item.obj">\n                                        </list-item-warrenty> --></ng-container></ng-container></ul></div></div>');
$templateCache.put('app/entities/shop/shop-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.shop.delete.question" translate-values="{id: \'{{vm.shopId}}\'}">Are you sure you want to delete this Shop?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button><!--TODO: check why the action rest DELETE is not supported--><!-- <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="fas fa-trash-alt"></span>&nbsp;<span translate="entity.action.delete">Delete</span>\n        </button> --></div></form>');
$templateCache.put('app/entities/shop/shops-dialog.html','<h4><span translate="garanteasyApp.shop.home.title">Shops</span></h4><br><ng-form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><!--NEGOZIO FISICO - ECOMMERCE--><div ng-if="!vm.currentShop.official" class="form-group"><label class="form-check form-check-inline"><i style="font-size: large" class="fas fa-store-alt"></i> <input type="radio" ng-model="vm.shop_ecommerce" name="shop_type" value="shop" ng-disabled="vm.currentShop.official" ng-click="vm.currentShop.ecommerceUrl = undefined"> <span class="rdetail-font-size" translate="garanteasyApp.receipt.insertOrUpdateReceipt.phisicalShop" ng-disabled="vm.currentShop.official" ng-disabled="vm.currentShop.official">Negozio fisico</span></label><label class="form-check form-check-inline"><i style="font-size: large" class="fas fa-shopping-cart"></i> <input type="radio" ng-model="vm.shop_ecommerce" name="shop_type" value="ecommerce" ng-disabled="vm.currentShop.official"> <span class="rdetail-font-size" translate="garanteasyApp.receipt.insertOrUpdateReceipt.ecommerce">Negozio virtuale</span></label></div><!--SITO--><div class="form-group" ng-if="vm.shop_ecommerce === \'ecommerce\'"><label for="ecommerceUrlImput" translate="garanteasyApp.receipt.insertOrUpdateReceipt.ecommerceUrl">ecommerceUrl</label><span ng-if="!vm.currentShop.ecommerceUrl" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" class="form-control-feedback fas fa-exclamation-triangle form-triangle-left" style="color: red"></span> <input type="text" class="form-control" id="ecommerceUrlImput" aria-describedby="ecommerceUrlImputHelp" ng-disabled="vm.currentShop.official" type="url" class="form-control" ng-model="vm.currentShop.ecommerceUrl" placeholder="https://..." required name="ecommerceUrl" ng-pattern="/^(?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))(?::\\d{2,5})?(?:[/?#]\\S*)?$/"><div role="alert" class="text-danger" ng-if="editForm.ecommerceUrl.$touched"><div ng-if="editForm.ecommerceUrl.$error"><div ng-if="editForm.ecommerceUrl.$error.required">Url del sito obbligatoria</div><div ng-if="editForm.ecommerceUrl.$error.pattern">Inserire una Url valida</div></div></div></div><!-- CENTRO COMMERCIALE --><div class="form-group" ng-if="vm.shop_ecommerce === \'shop\'"><label for="mallNameImput" translate="garanteasyApp.receipt.insertOrUpdateReceipt.mallName">mallName</label><input type="text" class="form-control" id="mallNameImput" aria-describedby="mallNameHelp" ng-model="vm.currentShop.mallName" ng-disabled="vm.currentShop.official" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.receipt.detail.mallName\' | translate}}"></div><!-- INSEGNA --><div class="form-group"><label for="shopSignboardImput"><span translate="garanteasyApp.receipt.insertOrUpdateReceipt.signboard">signboard</span> {{vm.currentShop.shopSignboard.name}}</label><span ng-if="!vm.brandIsSelected()" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" class="form-control-feedback fas fa-exclamation-triangle form-triangle-left" style="color: red"></span><!-- Typeahead search (search among all brands) --><ui-select reset-search-input="true" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" tooltip-enable="{{!vm.currentShop.signboard}}" required ng-disabled="vm.currentShop.official" ng-model="vm.currentBrand" name="shopSignboard"><ui-select-match allow-clear="true" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.shop.shopSignboard\' | translate}}"><div ng-bind="$select.selected.name"></div></ui-select-match><ui-select-choices refresh="vm.findBrands($select.search)" refresh-delay="200" repeat="brand in (vm.brands) track by brand.id"><div ng-bind-html="brand.name | highlight: $select.search"></div></ui-select-choices></ui-select><div role="alert" class="text-danger" ng-if="editForm.shopSignboard.$touched"><div ng-if="editForm.shopSignboard.$error"><div ng-if="editForm.shopSignboard.$error.required">La Insegna &egrave; obbligatoria</div></div></div></div><!-- Merchant--><div class="form-group"><label translate="garanteasyApp.shared.merchant"></label><select class="form-control ng-pristine" aria-invalid="false" ng-options="obj as obj.owner.name for obj in vm.getMerchants()" ng-model-options="{ getterSetter: true }" ng-model="vm.selectedMerchant"></select></div><!-- PARTITA IVA --><div class="form-group"><label for="pIvaImput" translate="garanteasyApp.receipt.detail.pIva">PIVA</label><span ng-if="!vm.currentShop.vatCode" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" class="form-control-feedback fas fa-exclamation-triangle form-triangle-left" style="color: red"></span> <input type="text" class="form-control" id="pIvaImput" name="vatCode" aria-describedby="pIvaImputHelp" ng-model="vm.currentShop.vatCode" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" tooltip-enable="{{!vm.currentShop.vatCode}}" required ng-pattern="/^[A-Z]{0,2}\\d{11}$/" ng-disabled="vm.currentShop.official" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.receipt.detail.pIva\' | translate}}"><div role="alert" class="text-danger" ng-if="editForm.vatCode.$touched"><div ng-if="editForm.vatCode.$error"><div ng-if="editForm.vatCode.$error.required">La partita IVA &egrave; obbligatoria</div><div ng-if="editForm.vatCode.$error.pattern">La partita IVA pu&ograve; solo essere composta da 11 caratteri numerici <strong>oppure</strong> da un prefisso internazionale di due caratteri alfabetici seguito da 11 caratteri numerici (p.e. IT01234567890)</div></div></div></div><div class="panel panel-default"><div class="panel-heading"><span translate="garanteasyApp.receipt.detail.shopAddress">Address</span></div><div class="panel-body"><!-- CITTA\' --><div class="form-group"><input type="text" class="form-control" id="addressImput" aria-describedby="addressHelp" ng-model="vm.currentShop.address.city" ng-disabled="vm.currentShop.official" autocomplete="shipping locality address-level2" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.address.city\'|translate}}"></div><!-- LOCALITA\' --><div class="form-group"><input ng-disabled="vm.currentShop.official" type="text" class="form-control" ng-model="vm.currentShop.address.locality" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.address.locality\' | translate }}"></div><!--VIA--><div class="form-group"><input ng-disabled="vm.currentShop.official" type="text" class="form-control" ng-model="vm.currentShop.address.street" autocomplete="shipping street-address" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.address.street\' | translate }}"></div><!-- NUMERO --><div class="form-group"><input ng-disabled="vm.currentShop.official" type="text" class="form-control" ng-model="vm.currentShop.address.streetNumber" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.address.number\' | translate }}"></div><!-- CAP --><div class="form-group"><input ng-disabled="vm.currentShop.official" type="text" class="form-control" ng-model="vm.currentShop.address.postcode" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.address.postcode\'|translate}}" autocomplete="shipping postal-code"></div><!-- PAESE --><div class="form-group"><label translate="garanteasyApp.address.country">Country</label><select class="form-control" name="shopCountry" id="field_shopCountry" ng-disabled="vm.currentShop.official" ng-model="vm.currentShop.address.country.code" pvp-country-picker placeholder="{{\'garanteasyApp.address.country\'|translate}}" autocomplete="shipping country"></select></div></div></div><!-- TELEFONO --><div class="form-group"><label for="mobileImput" translate="garanteasyApp.receipt.detail.phoneNumber">mobile</label><input id="mobileImput" ng-disabled="vm.currentShop.official" type="tel" class="form-control" name="phoneNumber" ng-model="vm.currentShop.phoneNumber.phoneNumber" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.receipt.detail.phoneNumber\' | translate }}" ng-change="vm.phoneNumberUpdated()"></div><!-- EMAIL --><div class="form-group"><label for="emailImput" translate="garanteasyApp.receipt.detail.email">email</label><input id="email" ng-disabled="vm.currentShop.official" placeholder="{{\'garanteasyApp.shared.enter\' | translate}} {{\'garanteasyApp.receipt.detail.email\' | translate }}" type="email" class="form-control" name="email" ng-model="vm.currentShop.email"></div></ng-form><br><p class="text-center"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.save()" class="btn btn-default" ng-disabled="editForm.$invalid || vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></p><br><br><br>');
$templateCache.put('app/entities/shop/shops.html','<div><h4><span translate="garanteasyApp.shop.home.title">Shops</span> <span class="pull-right"><button class="btn btn-default btn-dark hidden-sm hidden-xs" ng-click="vm.gridView = true;"><span class="fas fa-th"></span></button> <button class="btn btn-default btn-dark hidden-sm hidden-xs" ng-click="vm.gridView = false;"><span class="fas fa-th-list"></span></button> <button class="btn btn-primary" ui-sref="shop/new" has-authority="ROLE_REFERENT"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="garanteasyApp.shop.home.createLabel">Create new Shop</span></button></span></h4><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="container-fluid"><br><div ng-if="!vm.gridView" class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="th-green" jh-sort-by="shopSignboard.name"><span translate="garanteasyApp.shop.shopSignboard">shopSignboard</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="owner.name"><span translate="garanteasyApp.shop.merchant">Merchant</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="phoneNumber"><span translate="garanteasyApp.shop.phoneNumber">Phone number</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="email"><span translate="garanteasyApp.shop.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="email"><span translate="garanteasyApp.shop.shopAddress">Address</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th class="th-green"><span translate="garanteasyApp.shop.numReceipts"># Ricevute</span></th>\n                        <th class="th-green"><span translate="garanteasyApp.shop.numProducts"># Prodotti</span></th> --><th></th><th></th></tr></thead><tbody><tr ng-repeat="shop in vm.shops "><td>{{shop.shopSignboard.name}}</td><td>{{shop.owner.name}}</td><td>{{shop.shopPhoneNumber.phoneNumber}}</td><td>{{shop.email}}</td><td>{{shop.address.descFull}}</td><td><a ng-if="shop.address.websiteUrl" href="{{shop.address.websiteUrl}}">\u221E</a></td><!-- <td>{{shop.numReceipts}}</td>\n                        <td>{{shop.numProducts}}</td> --><td class="text-right"><div class="btn-group flex-btn-group-container"><a class="btn btn-danger btn-twitter btn-sm" has-authority="ROLE_REFERENT" uib-tooltip="{{\'entity.action.delete\' | translate}}" ui-sref="shop/delete({id:shop.id})"><i class="fas fa-trash-alt"></i> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span> </a><a class="btn btn-primary btn-sm" ui-sref="shop/edit({shop: shop.toParamsJson})" has-authority="ROLE_REFERENT"><i class="fas fa-pen"></i> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span> </a><!--\n                                <button type="submit" ui-sref="shop-detail({id:shop.id})" class="btn btn-info btn-sm">\n                                    <span class="glyphicon glyphicon-eye-open"></span>\n                                    <span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\n                                </button> --><!-- PER IL MOMENTO LA CANCELLAZIONE NON E\'ATTIVA PERCHE\' ANDREBBE PRIMA RIMOSSO IL LINK CON LE RICEVUTE CHE REFERENZIANO IL NEGOZIO (bug #10)\n                            <button ng-disabled="!isAdmin && shop.createdBy.id != vm.accountId"\n                            \t\ttype="submit"\n                                    ui-sref="shop/delete({id:shop.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span>\n                            </button>\n                             --></div></td></tr></tbody></table></div><div ng-if="vm.gridView" ng-repeat="shop in vm.shops" class="thumbnail-container col-xs-12 col-sm-6"><div class="card hovercard shop"><div class="cardheader" back-img="{{shop.merchant.logoPath}}" back-img-default="shop"></div><div class="info"><div class="desc">{{vm.abbreviate(shop.owner.name)}}</div><div class="desc">{{vm.abbreviate(shop.address.descFull)}}</div><div class="desc" ng-if="shop.phoneNumber.phoneNumber" uib-tooltip="{{\'garanteasyApp.shop.list.phoneNumberBoxView\'|translate}}"><i class="fas fa-phone"></i> {{shop.shopPhoneNumber}}</div><div class="desc" ng-if="shop.email" uib-tooltip="{{\'garanteasyApp.shop.list.emailBoxView\' | translate}}"><i class="fas fa-at"></i> {{shop.email}}</div><div class="desc" ng-if="shop.ecommerceUrl" uib-tooltip="{{\'garanteasyApp.shop.list.webSiteLink\' | translate}}"><i class="fas fa-globe"></i> {{vm.abbreviate(shop.ecommerceUrl)}}</div><!-- <div class="desc">\n                        <span class="rdetail-font-size-colored"\n                            translate="garanteasyApp.shop.numReceipts"></span>:&nbsp;\n                        {{shop.numReceipts || 0}}\n                    </div>\n                    <div class="desc">\n                        <span class="rdetail-font-size-colored"\n                            translate="garanteasyApp.shop.numProducts"></span>:&nbsp;\n                        {{shop.numProducts || 0}}\n                    </div> --></div><div class="bottom"><a class="btn btn-danger btn-twitter btn-sm" uib-tooltip="{{\'entity.action.delete\' | translate}}" ui-sref="shop/delete({id:shop.id})"><i class="fas fa-trash-alt"></i></a> <a class="btn btn-primary btn-sm" ui-sref="shop/edit({shop: shop.toParamsJson})"><i class="fas fa-pen"></i></a></div></div></div></div></div>');
$templateCache.put('app/entities/warranty-claim/warranty-claim-detail.html','<!doctype html><h4>{{ \'garanteasyApp.warrantyClaim.detail.title\' | translate }}</h4><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-sm-2 hidden-xs"><img src="../../../content/images/icone_new/icone_sfondo_bianco/customer_cerchio_bianco.png" class="img-responsive"></div><div class="col-sm-10 col-xs-12 col-md-8 list-detail"><div class="title-page-mobile visible-xs row" style="background-image: url(\'/content/images/icone_new/icone_sfondo_bianco/customer_cerchio_bianco.png\')"><div class="text-center"><span><span class="rdetail-font-size text-uppercase" translate="garanteasyApp.warrantyClaim.detail.titleMobile"></span></span></div></div><form name="form" class="css-form" novalidate><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.id"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.warrantyClaim.id}}</span></div><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.receiptId"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.warrantyClaim.receiptId}}</span></div><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.requesterEmail"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.warrantyClaim.requesterEmail}}</span></div><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.freshdeskId"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{vm.warrantyClaim.freshdeskId}}</span></div><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.reason"></span></span> <span class="col-xs-8 col-sm-9 col-md-10">{{\'garanteasyApp.warrantyClaim.reasons.\'+ vm.warrantyClaim.reason | translate}}</span></div><div class="row"><span class="col-xs-4 col-sm-3 col-md-2"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.message"></span></span> <span class="col-xs-8 col-sm-9 col-md-10"><pre>\n                    {{vm.warrantyClaim.message | json}}\n                </pre></span></div><button type="button" class="btn btn-danger" ui-sref="warranty-claim"><span translate="entity.action.cancel">Cancel</span></button></form></div></div>');
$templateCache.put('app/entities/warranty-claim/warranty-claim-new.html','<!doctype html><h4>{{ \'garanteasyApp.warrantyClaim.request-assistance\' | translate }}</h4><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-sm-2 hidden-xs"><img src="/content/images/icone_new/assistenza_tecnica.png" class="img-responsive"></div><div class="col-sm-10 col-xs-12 col-md-4"><ul class="list-group"><ng-container ng-if="vm.shop && !vm.cmsShop"><li class="list-group-item" ng-if="(vm.shop || {}).shopSignboard"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopSignboard"></span>: <span>{{vm.shop.shopSignboard}}</span></li><li class="list-group-item" ng-if="(vm.shop.address || {}).descFull"><span class="text-muted" translate="garanteasyApp.warrantyClaim.address"></span>: <span>{{vm.shop.address.descFull}}</span></li><li class="list-group-item" ng-if="((vm.receipt.shop.owner||{}).name)"><span class="text-muted" translate="garanteasyApp.warrantyClaim.companyName"></span>: <span>{{vm.receipt.shop.owner.name}}</span></li><li class="list-group-item" ng-if="vm.shop.email"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopEmail"></span>: <span>{{vm.shop.email}}</span></li></ng-container><ng-container ng-if="vm.cmsShop" class="list-group"><li class="list-group-item" ng-if="(vm.cmsShop || {}).signboard_brand"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopSignboard"></span>: <span>{{vm.cmsShop.signboard_brand}}</span></li><li class="list-group-item" ng-if="(vm.cmsShop || {}).address"><span class="text-muted" translate="garanteasyApp.warrantyClaim.address"></span>: <span>{{vm.cmsShop.address}}</span></li><li class="list-group-item" ng-if="(vm.cmsShop || {}).owner_company"><span class="text-muted" translate="garanteasyApp.warrantyClaim.companyName"></span>: <span>{{vm.cmsShop.owner_company}}</span></li><li class="list-group-item" ng-if="(vm.cmsShop || {}).shop_email"><span class="text-muted" translate="garanteasyApp.warrantyClaim.shopEmail"></span>: <span>{{vm.cmsShop.shop_email}}</span></li></ng-container><li class="list-group-item"><span class="text-muted" translate="garanteasyApp.warrantyClaim.sender"></span>: <span>{{vm.account.login}}</span></li><li class="list-group-item" ng-if="(vm.receipt || {}).buyingDate"><span class="text-muted" translate="garanteasyApp.warrantyClaim.receiptDate"></span>: <span>{{vm.receipt.buyingDate | date:\'dd/MM/yyyy hh:mm\'}}</span></li><li class="list-group-item" ng-if="vm.receipt.receiptNumber"><span class="text-muted" translate="garanteasyApp.warrantyClaim.receiptNumber"></span>: <span>{{vm.receipt.receiptNumber}}</span></li><li class="list-group-item" ng-if="(vm.receipt || {}).transactionAmount"><span class="text-muted" translate="garanteasyApp.warrantyClaim.receiptiAmount"></span>: <span>{{vm.receipt.transactionAmount}}</span></li></ul><form name="form" class="css-form" novalidate ng-submit="vm.onSubmit()"><input type="hidden" class="form-control" id="receiptId" value="{{vm.ppId}}"><div class="form-group"><label for="reason" translate="garanteasyApp.warrantyClaim.clientName">client name</label><input class="form-control" ng-model="vm.clientData.clientName" data-ng-disabled="vm.clientData.clientName"></div><div class="form-group"><label for="reason" translate="garanteasyApp.warrantyClaim.clientEmail">client email</label><input class="form-control" ng-model="vm.clientData.clientEmail" ng-disabled="vm.clientData.clientEmail"></div><div class="form-group"><label for="reason" translate="garanteasyApp.warrantyClaim.clientPhone">phone</label><input class="form-control" ng-model="vm.clientData.clientPhone" data-ng-disabled="vm.clientData.clientPhone"></div><div class="form-group"><label for="reason" translate="garanteasyApp.warrantyClaim.cardNumber">card number</label><input class="form-control" ng-model="vm.clientData.cardNumber" data-ng-disabled="vm.clientData.cardNumber"></div><div class="form-group"><label for="reason"><i style="color: red" ng-if="!vm.warrantyClaim.reason" class="fas fa-exclamation-triangle"></i> <span translate="garanteasyApp.warrantyClaim.reasons.title">reason</span></label><select class="form-control" id="reason" name="reason" ng-model="vm.warrantyClaim.reason" required><option ng-repeat="o in vm.reasons" value="{{o}}">{{\'garanteasyApp.warrantyClaim.reasons.\'+ o | translate}}</option></select></div><div class="form-group"><label for="message"><i style="color: red" ng-if="!vm.message" class="fas fa-exclamation-triangle"></i> <span translate="garanteasyApp.warrantyClaim.message">message</span></label><textarea class="form-control" name="message" id="field_message" ng-model="vm.message" ng-maxlength="1024" cols="80" rows="5" required></textarea><p ng-show="form.message.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1024" class="error">This field cannot be longer than 1024 characters.</p></div><button type="button" class="btn btn-danger" ng-click="vm.cancelClick()"><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="alert(\'dsf\')" data-ng-disabled="form.$invalid"><span translate="garanteasyApp.warrantyClaim.send.action">SEND</span></button></form></div></div>');
$templateCache.put('app/entities/warranty-claim/warranty-claim-product-new.html','<!doctype html><h4>{{ \'garanteasyApp.warrantyClaim.detail.title\' | translate }}</h4><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-sm-2 hidden-xs"><img src="../../../content/images/icone_new/icone_sfondo_bianco/customer_cerchio_bianco.png" class="img-responsive"></div><div class="col-sm-10 col-xs-12"><div class="title-page-mobile visible-xs row" style="background-image: url(\'/content/images/icone_new/icone_sfondo_bianco/customer_cerchio_bianco.png\')"><div class="text-center"><span><span class="rdetail-font-size text-uppercase" translate="garanteasyApp.warrantyClaim.detail.titleMobile"></span></span><div class="button-row single-row"></div></div></div><warranty-claim-component ng-if="vm.ppId && !vm.isGeneric" warranty-claim="vm.warrantyClaim" pp-id="vm.ppId" list-products="vm.receipt.purchasedProducts" on-cancel="vm.onCancelEdit" on-save="vm.onSaveWarrantyClaim"></warranty-claim-component><warranty-claim-component ng-if="vm.isGeneric" warranty-claim="vm.warrantyClaim" on-cancel="vm.onCancelEdit" on-save="vm.onSaveWarrantyClaim" receipt="vm.loadedReceipt" is-generic="true"></warranty-claim-component></div></div>');
$templateCache.put('app/entities/warranty-claim/warranty-claims.html','<div><h4>{{\'garanteasyApp.warrantyClaim.home.title\' | translate}}<div class="pull-right"><button class="btn btn-default btn-dark" ng-click="vm.gridView = true;"><span class="fas fa-th"></span></button> <button class="btn btn-default btn-dark" ng-click="vm.gridView = false;"><span class="fas fa-th-list"></span></button></div></h4><br><div class="table-responsive" ng-if="!vm.gridView"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th class="th-green" jh-sort-by="id"><span translate="garanteasyApp.warrantyClaim.table.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="receiptId"><span translate="garanteasyApp.warrantyClaim.table.receiptId">receiptId</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="requesterEmail"><span translate="garanteasyApp.warrantyClaim.table.requesterEmail">requesterEmail</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="freshdeskId"><span translate="garanteasyApp.warrantyClaim.table.freshdeskId">freshdeskId</span> <span class="glyphicon glyphicon-sort"></span></th><th class="th-green" jh-sort-by="reason"><span translate="garanteasyApp.warrantyClaim.table.reason">reason</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody style="border: 1px solid #dddddd" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><tr ng-repeat="warrantyClaim in vm.warrantyClaims track by warrantyClaim.id" on="receipt.source"><td><a ui-sref="warranty-claim-detail({id:warrantyClaim.id})">{{warrantyClaim.id}}</a></td><td><a ui-sref="receipt/detail({id:warrantyClaim.receiptId})">{{warrantyClaim.receiptId}}</a></td><td>{{warrantyClaim.requesterEmail}}</td><td>{{warrantyClaim.freshdeskId}}</td><td>{{\'garanteasyApp.warrantyClaim.reasons.\'+ warrantyClaim.reason | translate}}</td></tr></tbody></table></div><div class="row" ng-if="vm.gridView" infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-distance="3" infinite-scroll-disabled="vm.isLoading || vm.page >= vm.links[\'last\']"><div class="col-lg-3 col-sm-6" ng-repeat="warrantyClaim in vm.warrantyClaims track by warrantyClaim.id"><div class="card hovercard"><a ui-sref="warranty-claim-detail({id:warrantyClaim.id})"><div class="cardheader" back-img-default="warranty" back-img="{{vm.getImageUrl(receipt)}}"></div></a><div class="info"><div class="title"><span translate="garanteasyApp.warrantyClaim.table.id">ID</span>&nbsp; <a ui-sref="warranty-claim-detail({id:warrantyClaim.id})">{{warrantyClaim.id}}</a></div><div class="desc"><span class="text-muted" translate="garanteasyApp.warrantyClaim.requestDate"></span>&nbsp; {{warrantyClaim.requestDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.receiptId">receiptId</span>&nbsp; <a ui-sref="receipt/detail({id:warrantyClaim.receiptId})">{{warrantyClaim.receiptId}}</a></div><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.requesterEmail">requesterEmail</span>&nbsp; {{warrantyClaim.requesterEmail}}</div><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.freshdeskId">freshdeskId</span>&nbsp; {{warrantyClaim.freshdeskId}}</div><span class="text-muted" translate="garanteasyApp.warrantyClaim.table.reason">reason</span>&nbsp; {{\'garanteasyApp.warrantyClaim.reasons.\'+ warrantyClaim.reason | translate}}</div></div></div>');
$templateCache.put('app/entities/warranty-claim-file/warranty-claim-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.warrantyClaimFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="garanteasyApp.warrantyClaimFile.delete.question" translate-values="{id: \'{{vm.warrantyClaimFile.id}}\'}">Are you sure you want to delete this Warranty Claim File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="fas fa-trash-alt"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/warranty-claim-file/warranty-claim-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mywarrantyClaimFileLabel" translate="garanteasyApp.warrantyClaimFile.home.createLabel">Create or edit a warrantyClaim File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><input type="hidden" class="form-control" id="id" name="id" ng-model="vm.warrantyClaimFile.id"> <input type="hidden" class="form-control" id="warrantyClaimId" name="warrantyClaimId" ng-model="vm.warrantyClaimFile.warrantyClaimId"><div class="form-group"><label class="control-label" translate="garanteasyApp.warrantyClaimFile.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.warrantyClaimFile.fileName" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.warrantyClaimFile)" ngf-pattern="\'image/*\'"><label class="control-label" translate="garanteasyApp.warrantyClaimFile.chooseFile" for="field_warrantyClaimFile">warrantyClaim File</label><div><div ng-show="vm.warrantyClaimFile.fileContentType"><img ng-show="vm.canShow(vm.warrantyClaimFile.fileContentType)" data-ng-src="{{\'data:\' + vm.warrantyClaimFile.fileContentType + \';base64,\' + vm.warrantyClaimFile.fileData}}" style="max-width: 100px;max-height: 100px"> <span ng-show="!vm.canShow(vm.warrantyClaimFile.fileContentType)" ng-bind-html="vm.warrantyClaimFile.fileContentType.toLowerCase()|iconify"></span></div><div ng-if="vm.warrantyClaimFile.fileData" class="help-block clearfix"><span class="pull-left">{{vm.warrantyClaimFile.fileContentType}}, {{vm.byteSize(vm.warrantyClaimFile.fileData)}}</span> <button ng-click="vm.warrantyClaimFile.fileData=null;vm.warrantyClaimFile.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.warrantyClaimFile)" accept="image/*" translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="fileData" id="field_fileData" ng-model="vm.warrantyClaimFile.fileData"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.warrantyClaimFile.fileContentType"></div><br><div ng-show="vm.fileTooLarge"><p class="help-block" translate="garanteasyApp.warrantyClaim.error.fileSize">File too large</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.fileTooLarge || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 translate="error.403-title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/mobile-navigation/archive.html','<!DOCTYPE html><div class="list-group"><a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'basic\'})" href="#"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.bottom-bar.doc-type.basic">Archivia Veloce</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'plus\'})" href="#"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.bottom-bar.doc-type.plus">Archivia Veloce</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/new_page" href="#"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.bottom-bar.doc-type.full">Documento di acquisto</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'festina\'})" href="#"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.bottom-bar.doc-type.festina">Archivia Festina</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="garanteasyApp.sidebar.customer">Archivia dati CLIENTE </span></a><a class="list-group-item list-group-item-action disabled"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="garanteasyApp.sidebar.product">Aggiungi PRODOTTO al catalogo</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="garanteasyApp.sidebar.shop">Aggiungi NEGOZIO </span></a><a class="list-group-item list-group-item-action disabled"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="garanteasyApp.sidebar.merchant-operator">Aggiungi OPERATORE </span></a><a class="list-group-item list-group-item-action disabled"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="garanteasyApp.sidebar.warranty-claim">SegnalaDIFETTO al Produttore</span></a></div>');
$templateCache.put('app/layouts/mobile-navigation/info.html','<!DOCTYPE html><div class="list-group"><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'faq\' })"><span class="fas fa-info-circle"></span>&nbsp; <span translate="garanteasyApp.sidebar.faq">FAQ</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'advertising\' })"><span class="fas fa-file-pdf"></span>&nbsp; <span translate="garanteasyApp.sidebar.advertising">Volantini</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'video\' })"><span class="fas fa-video"></span>&nbsp; <span translate="garanteasyApp.sidebar.video">Video</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'docs\' })"><span class="fas fa-file-download"></span>&nbsp; <span translate="garanteasyApp.sidebar.docs">Materiale Informativo</span></a></div>');
$templateCache.put('app/layouts/mobile-navigation/profile.html','<!DOCTYPE html><div class="list-group"><a href="https://garanteasy.freshdesk.com/a/tickets/filters/all_tickets" class="list-group-item list-group-item-action" ui-sref="purchased-product-warranty"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-barcode"></span>&nbsp; <span translate="garanteasyApp.sidebar.helpdesk">Gestisci TICKET</span></a> <a class="list-group-item list-group-item-action" ui-sref="shop"><span class="fas fa-chevron-right pull-right"></span> <span class="fas fa-shopping-cart"></span>&nbsp; <span translate="garanteasyApp.sidebar.shops">Shops</span> </a><a href="" class="list-group-item list-group-item-action" ng-click="vm.logout()" id="logout"><span class="fas fa-chevron-right pull-right"></span> <span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<!doctype html><div class="page-header"><div class="row"><nav class="navigation-menu hidden-print space-between" role="navigation"><a href="{{vm.isAuthenticated()? \'#!/dashboard?documents=true&customers=true&shops=true\': \'#/\'}}" class="navbar-brand logo inline-flex"><img src="content/images/logo.png" alt="Garanteasy" class="logo-img hidden-xs"> <img src="content/images/GE-sigillo-2017-300dpi.png" alt="Garanteasy" class="logo-img hidden-print visible-xs"><!-- <span class="navbar-version">v{{VERSION}}</span> --></a><div ng-if="vm.isAuthenticated()" ng-include="\'app/layouts/navbar/searchbar.html\'" class="inline-flex"></div><div ng-show="!vm.show;" ng-if="vm.isAuthenticated()"></div><div class="logo-img hidden-xs hidden-sm inline-flex"><div id="not-collapse" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right hidden-print"><li ng-switch-when="true" uib-dropdown class="hidden-xs"><a class="dropdown-toggle navBar-links" href="" uib-tooltip="Notifiche" tooltip-placement="bottom"><span class="glyphicon glyphicon-bell"></span><!-- <span class="hidden-sm hidden-xs" translate="global.menu.alerts">Alerts</span> --></a></li><li ng-switch-when="true" class="hidden-xs"><a class="dropdown-toggle navBar-links" href="https://garanteasy.freshdesk.com"><span class="glyphicon glyphicon-question-sign"></span><!-- <span class="hidden-sm hidden-xs" translate="global.menu.help">help</span> --></a></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle navBar-links" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm hidden-xs" translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li><li ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle navBar-links" uib-dropdown-toggle href="" id="account-menu" uib-tooltip="Profilo" tooltip-placement="bottom"><span><span class="glyphicon glyphicon-user"></span><!-- <span class="hidden-sm hidden-xs">\n                                        {{vm.account.login}}\n                                    </span> --> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li></ul></li></ul></div></div></nav></div><div class="row" ng-if="vm.isAuthenticated()"><div class="col well well-sm" ng-if="vm.getMerchants().length > 1"><ul class="nav nav-pills" color="primary"><li class="form-inline">&nbsp; <span translate="garanteasyApp.shared.merchant"></span><select class="form-control ng-pristine" aria-invalid="false" ng-options="obj as obj.owner.name for obj in vm.getMerchants()" ng-model-options="{ getterSetter: true }" ng-model="vm.model.merchant" ng-disabled="!vm.selectEnabled"></select></li><li class="form-inline" ng-if="vm.getShops().length > 0">&nbsp; <span translate="garanteasyApp.shared.shop"></span><select class="form-control ng-pristine" aria-invalid="false" ng-model="vm.model.shop" ng-options="obj as obj.description for obj in vm.getShops()" ng-disabled="!vm.selectEnabled"></select></li></ul></div></div></div><!-- INIZIO MENU MOBILE PER USER --><div id="mobile-footer" ng-if="vm.isAuthenticated()" class="visible-xs visible-sm text-center"><div class="navbar-fixed-bottom"><div class="row" id="bottomNav"><div class="col-xs-2"><a ui-sref="mobile-navigation-profile" ui-sref-active="active"><i class="glyphicon glyphicon-user"></i></a></div><div class="col-xs-2"><a href="#" ui-sref="receipt" ui-sref-active="active"><i class="glyphicon glyphicon-folder-open"></i></a></div><div class="col-xs-2 text-center"><a ui-sref="mobile-navigation-archive" ui-sref-active="active"><i class="glyphicon glyphicon-plus-sign"></i></a></div><div class="col-xs-2"><a href ui-sref="mobile-navigation-info" ui-sref-active="active"><i class="glyphicon glyphicon-info-sign"></i></a></div><div class="col-xs-2"><a href="#"><i class="glyphicon glyphicon-comment"></i></a></div></div></div></div><!-- FINE MENU MOBILE PER USER -->');
$templateCache.put('app/layouts/navbar/searchbar.html','<div ng-controller="SearchbarController" class="searchBar"><form name="searchForm"><div class="input-group input-group-lg"><div class="input-group-btn"><button class="btn btn-link" ng-click="openSort()"><i class="fas fa-sort-amount-up-alt"></i></button></div><input type="text" class="form-control" ng-model="model.search" id="searchQuery" placeholder="{{ \'global.search\' | translate }}" style="min-width: 120px"> <a ng-click="this.clear()" ng-if="model.search" aria-label="Select box clear" class="btn btn-md btn-link input-group-btn search-form-reset" aria-hidden="false"><i class="glyphicon glyphicon-remove" aria-hidden="true"></i> </a><span class="input-group-btn hidden-xs"><button class="btn btn-default btn-clean" ng-click="dispatch();"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn hidden-md hidden-lg hidden-xl" uib-tooltip="Cerca In Clienti" tooltip-placement="bottom"><label class="css-checkbox-container checkbox-inline check-box-align-middle"><input type="checkbox" class="css-checkbox" ng-model="model.customers"> <span class="css-label customers"></span></label></span><span class="input-group-btn hidden-md hidden-lg hidden-xl"><label class="css-checkbox-container checkbox-inline check-box-align-middle" uib-tooltip="Cerca In Documenti" tooltip-placement="bottom"><input type="checkbox" class="css-checkbox" ng-model="model.documents"> <span class="css-label document"></span></label></span><span class="input-group-btn hidden-md hidden-lg hidden-xl"><label class="css-checkbox-container checkbox-inline check-box-align-middle" uib-tooltip="Cerca In Negozi" tooltip-placement="bottom"><input type="checkbox" class="css-checkbox" ng-model="model.shops"> <span class="css-label shop"></span></label></span></div><ng-container class="hidden-xs hidden-sm"><label translate="global.search-bar.searchIn" class="hidden-md"></label><div class="css-checkbox-container"><label class="check checkbox-inline check-box-align-middle" uib-tooltip="Cerca In Clienti" tooltip-placement="bottom"><input type="checkbox" class="css-checkbox" ng-model="model.customers"><!-- <i class="fas fa-check"></i> --> <span translate="global.search-bar.customers" class="hidden-sm hidden-xs"></span></label></div><div class="css-checkbox-container"><label class="check checkbox-inline check-box-align-middle" uib-tooltip="Cerca In Documenti" tooltip-placement="bottom" uib-tooltip="Cerca In Documenti" tooltip-placement="bottom"><input type="checkbox" class="css-checkbox" ng-model="model.documents"><!-- <i class="fas fa-check"></i> --> <span class="hidden-sm hidden-xs" translate="global.search-bar.documents"></span></label></div><div class="css-checkbox-container"><label class="check checkbox-inline check-box-align-middle" uib-tooltip="Cerca In Negozi" tooltip-placement="bottom"><input type="checkbox" class="css-checkbox" ng-model="model.shops"><!-- <i class="fas fa-check"></i> --> <span translate="global.search-bar.shops" class="hidden-sm hidden-xs"></span></label></div></ng-container></form></div>');
$templateCache.put('app/layouts/navbar/searchbarNone.html','<!--\n<div class="col-xs-5">\n    <form name="searchForm" class="form-inline">\n        <div class="input-group pull-right" >\n            <input style="height: 46px; font-size: 20px; margin-top: 3px" type="text" class="form-control" id="searchQuery" placeholder="{{ \'garanteasyApp.global.search\' | translate }}">\n        </div>\n    </form>\n</div>\n--><div class="col-xs-5"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input style="height: 46px; font-size: 20px; margin-top: 3px" type="hidden" class="form-control" id="searchQuery" placeholder="{{ \'garanteasyApp.global.search\' | translate }}"> <span hidden class="input-group-btn width-min"><button style="z-index: -1; margin-top: 3px" class="btn btn-lg"><span class="glyphicon glyphicon-search"></span></button> </span><!--<span class="input-group-btn width-min" ng-if="$rootScope.currenSearch">\n                            <button style="margin-top: 5px" class="btn btn-lg" ng-click="this.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>--></div></form></div>');
$templateCache.put('app/layouts/navbar/sort.component.html','<div class="modal-header"><h3><span translate="global.search-bar.sort.title">Set or Apply</span></h3></div><div class="modal-body sort-wrapper"><div class="form-group"><label for="sortCustomerSelect"><span translate="global.search-bar.sort.customer">Clienti</span></label><select class="form-control" id="sortCustomerSelect" ng-model="model.customers.field"><option value="legalName">{{\'global.search-bar.sort.options.customers.name\' | translate}}</option><option value="user.login">Email</option></select><label class="radio-inline"><input ng-model="model.customers.type" type="radio" name="optradio1" value="asc"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.asc">Asc</span></label><label class="radio-inline"><input ng-model="model.customers.type" type="radio" name="optradio1" value="desc"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.desc">Desc</span></label></div><div class="form-group"><label for="sortDoumentSelect"><span translate="global.search-bar.sort.document">Document</span></label><select class="form-control" id="sortDoumentSelect" ng-model="model.documents.field"><option value="shop.company.name">{{\'global.search-bar.sort.options.documents.store\' | translate}}</option><option value="shop.shopSignboard.name">{{\'global.search-bar.sort.options.documents.store_sign\' | translate}}</option><option value="buyingDate">{{\'global.search-bar.sort.options.documents.date\' | translate}}</option><option value="receiptNumber">{{\'global.search-bar.sort.options.documents.document\' | translate}}</option><option value="receiptType">{{\'global.search-bar.sort.options.documents.type\' | translate}}</option><option value="profile">{{\'global.search-bar.sort.options.documents.use\' | translate}}</option><option value="customer.legalName">{{\'global.search-bar.sort.options.documents.customer\' | translate}}</option></select><label class="radio-inline"><input ng-model="model.documents.type" type="radio" name="optradio2" value="asc" checked="checked"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.asc">Asc</span></label><label class="radio-inline"><input ng-model="model.documents.type" type="radio" name="optradio2" value="desc"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.desc">Desc</span></label></div><div class="form-group"><label for="sortShopSelect"><span translate="global.search-bar.sort.shop">Shop</span></label><select class="form-control" id="sortShopSelect" ng-model="model.shops.field"><option value="owner.name">{{\'global.search-bar.sort.options.shops.merchant\' | translate}}</option><option value="shopSignboard.name">{{\'global.search-bar.sort.options.shops.signboard\' | translate}}</option><option value="phoneNumber">{{\'global.search-bar.sort.options.shops.phone\' | translate}}</option><option value="email">Email</option></select><label class="radio-inline"><input ng-model="model.shops.type" type="radio" name="optradio3" value="asc"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.asc">Asc</span></label><label class="radio-inline"><input ng-model="model.shops.type" type="radio" name="optradio3" value="desc"> <i class="fas fa-check"></i> <span translate="global.search-bar.sort.desc">Desc</span></label></div></div><div class="modal-footer"><button class="btn btn-primary" ng-click="ok()">OK</button> <button class="btn btn-warning" ng-click="cancel()">Cancel</button></div>');
$templateCache.put('app/layouts/sidebar/sidebar-none.html','');
$templateCache.put('app/layouts/sidebar/sidebar.html','<!DOCTYPE html><div ng-controller="SidebarViewsController" style="z-index: 0" class="hidden-xs"><div class="shidden-print ge-sidebar no-print"><h5 translate="garanteasyApp.sidebar.add" ng-if="!isSupermedia"></h5><div class="list-group" ng-if="!isSupermedia"><a class="list-group-item list-group-item-action disabled"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.customer">Archivia dati CLIENTE</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'basic\'})" href="#" ng-class="getClass(\'/fast/faq\')"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.documentBasic">Archivia DOCUMENTO d\u2019acquisto semplificato</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'plus\'})" href="#" ng-class="getClass(\'/fast/faq\')"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.documentPlus">Archivia DOCUMENTO d\u2019acquisto semplificato</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/new_page" href="#" ng-class="getClass(\'/new\')"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.documentFull">Archivia DOCUMENTO d\u2019acquisto</span></a> <a class="list-group-item list-group-item-action" ui-sref="receipt/fast_track({type:\'festina\'})" href="#" ng-class="getClass(\'/fast/festina\')"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.documentFestina">Archivia DOCUMENTO d\u2019acquisto festina</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.product">Aggiungi PRODOTTO al catalogo</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.shop">Aggiungi NEGOZIO</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.merchant-operator">Aggiungi OPERATORE</span></a> <a class="list-group-item list-group-item-action disabled"><span class="fas fa-plus"></span>&nbsp; <span translate="garanteasyApp.sidebar.warranty-claim">Richiedi supporto a Garanteasy al Produttore</span></a></div><!--<h4 class="block-title">Area personale</h4>--><h5 translate="garanteasyApp.sidebar.title"></h5><div class="list-group"><!--<li><a   href="#/receipt" translate="garanteasyApp.sidebar.dashboard">Archivio ricevute, scontrini e fatture</a></li>--> <a class="list-group-item list-group-item-action" target="_new" href="https://garanteasy.freshdesk.com/a/tickets/filters/all_tickets"><i class="fas fa-ticket-alt"></i>&nbsp; <span translate="garanteasyApp.sidebar.helpdesk">Gestisci TICKET</span></a> <a class="list-group-item list-group-item-action" ui-sref="customer({ documents:false,customers:true,shops:false })" ng-class="getClass(\'/customer\')"><span class="fas fa-user"></span>&nbsp; <span translate="garanteasyApp.sidebar.customers">Customers</span> </a><a class="list-group-item list-group-item-action" ui-sref="receipt({ documents:true,customers:false,shops:false })" ng-class="getClass(\'/receipt\')"><span class="fas fa-file-invoice-dollar"></span>&nbsp;<span translate="garanteasyApp.sidebar.receipts">Receipts</span> </a><a class="list-group-item list-group-item-action disabled"><span class="fas fa-barcode"></span>&nbsp; <span translate="garanteasyApp.sidebar.products">Products</span> </a><a class="list-group-item list-group-item-action" ui-sref="shop({ documents:false,customers:false,shops:true })"><span class="fas fa-shopping-cart"></span>&nbsp; <span translate="garanteasyApp.sidebar.shops">Shops</span> </a><a class="list-group-item list-group-item-action disabled"><span class="fas fa-shield-alt"></span>&nbsp;<span translate="garanteasyApp.sidebar.warranties">Warranties</span> </a><a class="list-group-item list-group-item-action" ui-sref="warranty-claim"><span class="fas fa-user-shield"></span>&nbsp; <span translate="garanteasyApp.sidebar.warrantyClaims">Richieste di intervento</span></a></div><div class="no-print"><h5><span translate="garanteasyApp.sidebar.info"></span></h5><div class="list-group"><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'faq\' })"><span class="fas fa-info-circle"></span>&nbsp; <span translate="garanteasyApp.sidebar.faq">FAQ</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'advertising\' })"><span class="fas fa-file-pdf"></span>&nbsp; <span translate="garanteasyApp.sidebar.advertising">Volantini</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'video\' })"><span class="fas fa-video"></span>&nbsp; <span translate="garanteasyApp.sidebar.video">Video</span> </a><a class="list-group-item list-group-item-action" ui-sref="cms({ node:\'docs\' })"><span class="fas fa-file-download"></span>&nbsp; <span translate="garanteasyApp.sidebar.docs">Materiale Informativo</span></a></div></div></div></div>');
$templateCache.put('app/layouts/sidebar/sidebarCustomers.html','<div class="hidden-sm hidden-xs" ng-include="\'app/layouts/sidebar/sidebar.html\'" ng-controller="SidebarController"></div>');
$templateCache.put('app/layouts/sidebar/warrantyStates.html','<!--<h4 class="block-title"><span translate="garanteasyApp.receipt.detail.warrantiesState" ></span></h4>\n        <div  class="garanzie-holder">\n            <a  ui-sref="receiptFiltered({filterWarranty:\'valid\'})">\n                            <span class="garanzie-wrapper color-green sp-icon-check">\n                                <span class="g-value">{{stateData.vm.validWarranties}}</span>\n                                <span translate="garanteasyApp.receipt.detail.active" class="g-title"></span>\n                            </span>\n            </a>\n            <a  ui-sref="receiptFiltered({filterWarranty:\'expiring\'})">\n                            <span class="garanzie-wrapper color-orange sp-icon-exclamation">\n                                <span class="g-value">{{stateData.vm.expiringWarranties}}</span>\n                                <span translate="garanteasyApp.receipt.detail.expiring" class="g-title">IN SCADENZA</span>\n                            </span>\n            </a>\n            <a  ui-sref="receiptFiltered({filterWarranty:\'expired\'})">\n                            <span class="garanzie-wrapper color-orange-dark sp-icon-ban">\n                                <span class="g-value">{{stateData.vm.expiredWarranties}}</span>\n                                <span translate="garanteasyApp.receipt.detail.expired" class="g-title">SCADUTA</span>\n                            </span>\n            </a>\n\n        </div>--><div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'valid\'})">--> <span>{{stateData.vm.name}} <span class="badge valid">{{stateData.vm.validWarranties}}</span><!--<span style="color:green" class="g-value color-green">{{stateData.vm.validWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.sidebar.active" class="g-title"></span> </span><!--</a>--></h4></div><div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'expiring\'})">--> <span><span class="badge aboutToExpire">{{stateData.vm.expiringWarranties}}</span><!--<span style="color:orange" class="g-value">{{stateData.vm.expiringWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.sidebar.expiring" class="g-title">IN SCADENZA</span> </span><!--</a>--></h4></div><div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'expired\'})">--> <span><span class="badge expired">{{stateData.vm.expiredWarranties}}</span><!--<span style="color:darkorange" class="g-value">{{stateData.vm.expiredWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.sidebar.expired" class="g-title">SCADUTA</span> </span><!--</a>--></h4></div>');
$templateCache.put('app/layouts/sidebar/warrantyStatesCustomers.html','<div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'valid\'})">--> <span><span class="badge valid">{{stateData.vm.totalNumValid}}</span><!--<span style="color:green" class="g-value color-green">{{stateData.vm.validWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.dashboard.sidebar.active" class="g-title"></span> </span><!--</a>--></h4></div><div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'expiring\'})">--> <span><span class="badge aboutToExpire">{{stateData.vm.totalNumExpiring}}</span><!--<span style="color:orange" class="g-value">{{stateData.vm.expiringWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.dashboard.sidebar.expiring" class="g-title">IN SCADENZA</span> </span><!--</a>--></h4></div><div><h4><!--<a  ui-sref="receiptFiltered({filterWarranty:\'expired\'})">--> <span><span class="badge expired">{{stateData.vm.totalNumExpired}}</span><!--<span style="color:darkorange" class="g-value">{{stateData.vm.expiredWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.dashboard.sidebar.expired" class="g-title">SCADUTA</span> </span><!--</a>--></h4></div>');
$templateCache.put('app/layouts/sidebar/warrantyStatesDashboard.html','<div class="well"><h1><span style="color:black" translate="garanteasyApp.sidebar.dashboardTitle" class="g-title">Garanzie</span></h1><div class="row"><div class="col-sm-6 col-md-4"><span class="badge valid">{{stateData.vm.validWarranties}}</span> <span style="color:black" translate="garanteasyApp.sidebar.active" class="g-title"></span></div><div class="col-sm-6 col-md-4"><span class="badge aboutToExpire">{{stateData.vm.expiringWarranties}}</span> <span style="color:black" translate="garanteasyApp.sidebar.expiring" class="g-title">IN SCADENZA</span></div><div class="col-sm-6 col-md-4"><span class="badge expired">{{stateData.vm.expiredWarranties}}</span><!--<span style="color:darkorange" class="g-value">{{stateData.vm.expiredWarranties}}</span>--> <span style="color:black" translate="garanteasyApp.sidebar.expired" class="g-title">SCADUTA</span></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpasswordPlaceholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpasswordPlaceholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="row"><div class="col-md-8"><h1 class="main-title" translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.emailPlaceholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div><br><button type="submit" ng-disabled="form.$invalid" class="btn btn-default-green btn-block" translate="reset.request.form.button">Reset</button></form></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');
$templateCache.put('app/components/cards/customer/customer.component.html','<div class="card hovercard customer"><a ui-sref="customer-detail({id:vm.customer.id})"><div class="cardheader customer"></div></a><div class="info"><div class="title"><a ui-sref="customer-detail({id:vm.customer.id})">{{vm.showCustomerName(vm.customer)}}</a></div><div class="desc" ng-if="vm.customer.user.login"><span class="text-muted" translate="garanteasyApp.customer.email"></span> {{vm.customer.user.login}}</div></div><div class="bottom"><a class="btn btn-default btn-dark" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="customer-detail({id:vm.customer.id})"><span class="fas fa-expand-arrows-alt"></span><!--<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>--></a></div></div>');
$templateCache.put('app/components/cards/product/product.component.html','<div class="card hovercard products"><div class="cardheader" back-img="{{vm.product.image.src}}"><a ng-if="vm.product.product.underWarranty" style="display: block; width: 100%; height: 100%" ui-sref="purchased-product.detail({id:vm.product.id})"></a></div><div class="info"><div class="title"><a ng-if="vm.product.product.underWarranty" ui-sref="purchased-product.detail({id:vm.product.id})">{{vm.abbreviate(vm.product.product.name)}} </a><span ng-if="!vm.product.product.underWarranty">{{vm.abbreviate(vm.product.product.name)}}</span></div><div class="desc">{{vm.abbreviate(vm.product.product.brand.name)}}</div><div class="desc" ng-if="vm.product.product.category">{{vm.abbreviate(vm.product.product.category)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.creationDate"></span>&nbsp; {{vm.product.receipt.creationDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.shop"></span>&nbsp; {{vm.abbreviate(vm.product.receipt.shop.owner.name)}}</div><div class="desc" ng-if="vm.product.receipt.customer.business"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.use"></span>&nbsp; {{\'garanteasyApp.receipt.list.professional\' | translate}}</div><div class="desc" ng-if="!vm.product.receipt.customer.business"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.use"></span>&nbsp; {{\'garanteasyApp.receipt.list.personal\' | translate}}</div><div class="desc" ng-if="vm.product.warrantiesDett[\'LAW_GENERAL\']"><!-- <i class="fas fa-balance-scale thumbnail-icon"></i> --> <span class="text-muted" translate="garanteasyApp.purchasedProduct.list.legalWarranty"></span>&nbsp; <span class="text-nowrap"><span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.product.warrantiesDett[\'LAW_GENERAL\'].status | translate}}" class="badge {{vm.product.warrantiesDett[\'LAW_GENERAL\'].status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.product.warrantiesDett[\'LAW_GENERAL\'].status | translate}}</span></div><div class="desc" ng-if="vm.product.warrantiesDett[\'PRODUCTOR\']"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.productorWarranty"></span>&nbsp; <span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.product.warrantiesDett[\'PRODUCTOR\'].status | translate}}" class="badge {{vm.product.warrantiesDett[\'PRODUCTOR\'].status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.product.warrantiesDett[\'PRODUCTOR\'].status | translate}}</div></div><div class="bottom"><a class="btn btn-danger btn-twitter btn-sm" ng-if="!vm.product.product.official || vm.isAdmin" uib-tooltip="{{\'entity.action.delete\' | translate}}" ui-sref="purchased-product.delete({id:vm.product.id})"><i class="fas fa-trash-alt"></i></a> <a class="btn btn-primary btn-sm" ng-if="vm.product.product.underWarranty" ui-sref="purchased-product.detail({id:vm.product.id})" uib-tooltip="{{\'global.more-detail\'|translate}}"><i class="fas fa-expand-arrows-alt"></i></a> <a disabled="disabled" class="btn btn-primary btn-sm" ng-if="!vm.product.product.underWarranty" uib-tooltip="{{\'garanteasyApp.receipt.detail.notUnderWarranty\' | translate}}"><i class="fas fa-expand-arrows-alt"></i></a></div></div>');
$templateCache.put('app/components/cards/receipt/receipt.component.html','<div class="card hovercard"><a ui-sref="receipt.detail({id:vm.receipt.id})"><!--Immagine scontrino--><ng-container ng-if="vm.getImageUrl(vm.receipt)"><div class="cardheader" back-img-default="warranty" back-img="{{vm.getImageUrl(vm.receipt)}}"></div></ng-container><!--Ricostruzione scontrino Preview--><ng-container ng-if="!vm.getImageUrl(vm.receipt)"><div class="cardheader"><receipt-image-build class="receipt-image-build-preview" id="receiptPrintContent" receipt="vm.receipt"></receipt-image-build></div></ng-container></a><div class="info"><div class="title"><a ui-sref="receipt/detail({id:vm.receipt.id})">{{vm.abbreviate(vm.receipt.description)}}</a></div><div class="desc" ng-if="vm.receipt.counterCode"><span class="rdetail-font-size-colored" translate="garanteasyApp.receipt.counterCode"></span> {{ vm.receipt.counterCode }}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.receiptNumber"></span> <a ui-sref="receipt/detail({id:vm.receipt.id})">{{vm.receipt.receiptNumber}}</a></div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.buyingDate"></span>&nbsp; {{vm.receipt.buyingDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.customer"></span> <a ui-sref="customer-detail({id:vm.customer.id})">{{vm.showCustomerName(vm.receipt.customer)}}</a></div><div class="desc" ng-if="vm.receipt.customer.user.login"><span class="text-muted" translate="garanteasyApp.receipt.customerEmail"></span> {{vm.receipt.customer.user.login}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.shop"></span> <a ui-sref="shop-detail({id:vm.receipt.shopId, from: \'receipt\'})" ng-show="vm.receipt.shop">{{vm.receipt.shop.code}} - {{vm.receipt.shop.description}}</a> <span ng-show="!vm.receipt.shop" translate="global.undefinedSM">Non definito</span></div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.products"></span> {{vm.receipt.purchasedProducts.length > 0 ? vm.receipt.purchasedProducts.length : \'global.undefinedPM\' | translate}}</div><div class="desc"><span translate="garanteasyApp.warranty.home.title" class="text-muted"></span> <span title="{{\'garanteasyApp.warranty.status.valid\' | translate}}" ng-show="vm.receipt.totalWarranties.numValid > 0" class="badge valid">{{vm.receipt.totalWarranties.numValid}}</span> <span title="{{\'garanteasyApp.warranty.status.aboutToExpire\' | translate}}" ng-show="vm.receipt.totalWarranties.numExpiring > 0" class="badge aboutToExpire">{{vm.receipt.totalWarranties.numExpiring}}</span> <span title="{{\'garanteasyApp.warranty.status.expired\' | translate}}" ng-show="vm.receipt.totalWarranties.numExpired > 0" class="badge expired">{{vm.receipt.totalWarranties.numExpired}}</span></div></div><div class="bottom"><span><span ng-if="vm.receipt.totalWarranties.numValid > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="rgba(38,186,93,1)" stroke="white" stroke-width="1"></circle></svg> <span class="text-muted" translate="garanteasyApp.warranty.status.valid"></span> </span><span ng-if="vm.receipt.totalWarranties.numValid == 0 && receipt.totalWarranties.numExpiring > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="#f38426" stroke="white" stroke-width="1"></circle></svg> <span class="text-muted" translate="garanteasyApp.warranty.status.aboutToExpire"></span> </span><span ng-if="receipt.totalWarranties.numValid == 0 && receipt.totalWarranties.numExpiring == 0 && receipt.totalWarranties.numExpired > 0"><svg height="16" width="15"><circle r="6" cx="8" cy="9" fill="#f77777" stroke="white" stroke-width="1"></circle></svg> <span class="text-muted" translate="garanteasyApp.warranty.status.expired"></span> </span></span><span class="pull-right"><a class="btn btn-default btn-dark" type="submit" title="{{\'entity.action.view\' | translate}}" ui-sref="receipt/detail({id:vm.receipt.id})"><span class="fas fa-expand-arrows-alt"></span><!--<span class="hidden-xs hidden-sm" translate="entity.action.view"></span>--></a></span></div></div>');
$templateCache.put('app/components/cards/shop/shop.component.html','<div class="card hovercard shop"><a ui-sref="shop-detail({id:vm.shop.id})"><div class="cardheader" back-img-default="shop" back-img="{{vm.shop.merchant.logoPath}}"></div></a><div class="info"><div class="title"><a ui-sref="shop-detail({id:vm.shop.id})">{{vm.abbreviate(vm.shop.owner.name)}}</a></div><div class="desc">{{vm.abbreviate(vm.shop.address.descFull)}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.phoneNumber.phoneNumber}" uib-tooltip="{{\'garanteasyApp.shop.list.phoneNumberBoxView\'|translate}}"><i class="fas fa-phone"></i> {{vm.shop.phoneNumber.phoneNumber}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.email}" uib-tooltip="{{\'garanteasyApp.shop.list.emailBoxView\' | translate}}"><i class="fas fa-at"></i> {{vm.shop.email}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.ecommerceUrl}" uib-tooltip="{{\'garanteasyApp.shop.list.webSiteLink\' | translate}}"><i class="fas fa-globe"></i> {{vm.abbreviate(vm.shop.ecommerceUrl)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.shop.list.nProductsBoxView"></span>&nbsp; {{vm.shop.numProducts || 0}}</div></div><div class="bottom"><a class="btn btn-danger btn-twitter btn-sm" uib-tooltip="{{\'entity.action.delete\' | translate}}" ui-sref="shop.delete({id:vm.shop.id})"><i class="fas fa-trash-alt"></i></a> <a class="btn btn-primary btn-sm" ui-sref="shop-detail({id:vm.shop.id})"><i class="fas fa-expand-arrows-alt"></i></a></div></div>');
$templateCache.put('app/components/cards/warrenty/warrenty.component.html','<div class="card hovercard warranty"><div class="cardheader" back-img-default="warranty" back-img="{{vm.getImage(vm.warrenty)}}"><a ng-if="vm.warrenty.receipt.source !== \'MERCHANT\' && !vm.warrenty.warranty.official" ui-sref="purchased-product-warranty-detail({id:vm.warrenty.id})" style="display: block; width: 100%; height: 100"></a></div><div class="info"><div class="title"><span ng-if="(vm.warrenty.warranty ||{}).type">{{\'garanteasyApp.purchasedProductWarranty.type.\'+vm.warrenty.warranty.contractType | translate}}</span></div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.coverageGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.warranty.description)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.issuerGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.receipt.shop.description)}}</div><div class="desc" ng-if="vm.warrenty.purchasedProduct"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.productGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.purchasedProduct.product.brandAndName)}}</div><div class="desc" ng-if="vm.warrenty.purchasedProduct"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.brandGrid"></span>&nbsp; {{vm.warrenty.purchasedProduct.product.brand.name}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.durationGrid"></span>&nbsp; {{vm.warrenty.warranty.validity}} {{\'garanteasyApp.timeUnit.\'+vm.warrenty.warranty.validityUnit | translate}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.startGrid"></span>&nbsp; {{vm.warrenty.startDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.endGrid"></span>&nbsp; {{vm.warrenty.expirationDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc" ng-if="vm.warrenty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.statusGrid"></span>&nbsp; <span class="text-nowrap"><span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.warrenty.status | translate}}" class="badge {{vm.warrenty.status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.warrenty.status | translate}}</span></div><div class="desc" ng-if="vm.warrenty"><!-- <span class="text-muted"\n                    translate="garanteasyApp.vm.warrenty.list.dayToExpiration"></span>&nbsp; --> <i class="fas fa-stopwatch"></i> <strong><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.expirationDaysGrid"></span></strong> {{vm.warrenty.dayToExpiration}}</div></div><div class="bottom"><a class="btn btn-danger btn-twitter btn-sm" ui-sref="purchased-product-warranty.delete({id:vm.warrenty.id})" uib-tooltip="{{\'entity.action.delete\' | translate}}" ui-sref="shop.delete({id:shop.id})"><i class="fas fa-trash-alt"></i></a> <a class="btn btn-primary btn-sm" role="button" disabled="vm.isOfficial()" ui-sref="purchased-product-warranty-detail({id:vm.warrenty.id})"><i class="fas fa-expand-arrows-alt"></i></a></div></div>');
$templateCache.put('app/components/list-item/customer/customer.component.html','<a ui-sref="customer-detail({id:vm.customer.id})" class="customer list-group-item list-group-item-action flex-column align-items-start list-item-controller"><div class="cardheader"></div><div class="body-item"><h5>{{vm.customer.user.login}}</h5><div class="desc">{{vm.showCustomerName(vm.customer)}}</div></div></a>');
$templateCache.put('app/components/list-item/product/product.component.html','<a ui-sref="purchased-product.detail({id:vm.product.id})" class="list-group-item list-group-item-action flex-column align-items-start list-item-controller"><div class="cardheader" back-img="{{vm.product.image.src}}"></div><div class="body-item"><h5>{{vm.abbreviate(vm.product.product.name)}}</h5><div class="desc">{{vm.abbreviate(vm.product.product.brand.name)}}</div><div class="desc" ng-if="vm.product.product.category">{{vm.abbreviate(vm.product.product.category)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.creationDate"></span>&nbsp; {{vm.product.receipt.creationDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.shop"></span>&nbsp; {{vm.abbreviate(vm.product.receipt.shop.owner.name)}}</div><div class="desc" ng-if="vm.product.receipt.customer.business"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.use"></span>&nbsp; {{\'garanteasyApp.receipt.list.professional\' | translate}}</div><div class="desc" ng-if="!vm.product.receipt.customer.business"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.use"></span>&nbsp; {{\'garanteasyApp.receipt.list.personal\' | translate}}</div><div class="desc" ng-if="vm.product.warrantiesDett[\'LAW_GENERAL\']"><!-- <i class="fas fa-balance-scale thumbnail-icon"></i> --> <span class="text-muted" translate="garanteasyApp.purchasedProduct.list.legalWarranty"></span>&nbsp; <span class="text-nowrap"><span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.product.warrantiesDett[\'LAW_GENERAL\'].status | translate}}" class="badge {{vm.product.warrantiesDett[\'LAW_GENERAL\'].status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.product.warrantiesDett[\'LAW_GENERAL\'].status | translate}}</span></div><div class="desc" ng-if="vm.product.warrantiesDett[\'PRODUCTOR\']"><span class="text-muted" translate="garanteasyApp.purchasedProduct.list.productorWarranty"></span>&nbsp; <span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.product.warrantiesDett[\'PRODUCTOR\'].status | translate}}" class="badge {{vm.product.warrantiesDett[\'PRODUCTOR\'].status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.product.warrantiesDett[\'PRODUCTOR\'].status | translate}}</div></div></a>');
$templateCache.put('app/components/list-item/receipt/receipt.component.html','<a ui-sref="receipt/detail({id:vm.receipt.id})" class="list-group-item list-group-item-action flex-column align-items-start list-item-controller"><div class="cardheader" back-img-default="warranty" back-img="{{vm.getImageUrl(vm.receipt)}}"></div><div class="body-item"><h5><span ng-if="((vm.receipt || {}).purchasedProductWarranty || {}).status" uib-tooltip="{{\'garanteasyApp.warranty.status.\'+ vm.receipt.purchasedProductWarranty.status | translate}}" class="avatar badge {{vm.receipt.purchasedProductWarranty.status}}"></span> {{vm.receipt.receiptNumber}}</h5><div class="desc" ng-if="((vm.receipt || {}).purchasedProductWarranty || {}).statu"><span class="text-muted" translate="garanteasyApp.receipt.list.status"></span>:&nbsp; <span>{{ \'garanteasyApp.receipt.detail.\'+vm.receipt.purchasedProductWarranty.status | translate}}</span></div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.buyingDateGrid"></span>&nbsp; {{vm.receipt.buyingDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.creationDateGrid"></span>&nbsp; {{vm.receipt.creationDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc" ng-if="vm.receipt.counterCode && (vm.receipt.receiptType == \'OFFICIAL_RECEIPT\' || vm.receipt.receiptType == \'RECEIPT\')"><span class="text-muted" translate="garanteasyApp.receipt.list.cassa"></span> {{ vm.receipt.counterCode }}</div><div ng-if="vm.receipt.profile === \'BUSINESS\'" class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.useGrid"></span> {{\'garanteasyApp.receipt.list.professional\' | translate}}</div><div ng-if="vm.receipt.profile === \'PERSONAL\'" class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.useGrid"></span> {{\'garanteasyApp.receipt.list.personal\' | translate}}</div><div ng-if="vm.receipt.shop.ecommerceUrl == null || vm.receipt.shop.ecommerceUrl == \'\'" class="desc"><span class="text-mutedd">{{vm.receipt.shop.owner.name || vm.receipt.shop.shopSignboard}}</span></div><div ng-if="vm.receipt.shop.code && (vm.receipt.receiptType == \'OFFICIAL_RECEIPT\' || vm.receipt.receiptType == \'RECEIPT\')" class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.shopCode"></span> <span>{{ vm.receipt.shop.code.length > 19 ? vm.receipt.shop.code.substring(0,19) + \'...\' : vm.receipt.shop.code }}</span></div><div ng-if="vm.receipt.shop.ecommerceUrl != null && vm.receipt.shop.ecommerceUrl != \'\'" class="desc"><span>{{vm.receipt.shop.ecommerceUrl}}</span></div><div class="desc"><span class="text-muted" translate="garanteasyApp.receipt.list.purchasedProductsLength"></span> {{vm.receipt.purchasedProducts.length}}</div></div></a>');
$templateCache.put('app/components/list-item/shop/shop.component.html','<a ui-sref="shop-detail({id:vm.shop.id})" class="list-group-item list-group-item-action flex-column align-items-start list-item-controller"><div class="cardheader" back-img-default="shop" back-img="{{vm.shop.merchant.logoPath}}"></div><div class="body-item"><h5>{{vm.shop.owner.name}}</h5><div class="desc">{{vm.abbreviate(vm.shop.address.descFull)}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.phoneNumber.phoneNumber}" uib-tooltip="{{\'garanteasyApp.shop.list.phoneNumberBoxView\'|translate}}"><i class="fas fa-phone"></i> {{vm.shop.phoneNumber.phoneNumber}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.email}" uib-tooltip="{{\'garanteasyApp.shop.list.emailBoxView\' | translate}}"><i class="fas fa-at"></i> {{vm.shop.email}}</div><div class="desc" ng-class="{isDisabled: ! vm.shop.ecommerceUrl}" uib-tooltip="{{\'garanteasyApp.shop.list.webSiteLink\' | translate}}"><i class="fas fa-globe"></i> {{vm.abbreviate(vm.shop.ecommerceUrl)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.shop.list.nProductsBoxView"></span>&nbsp; {{vm.shop.numProducts || 0}}</div></div></a>');
$templateCache.put('app/components/list-item/warrenty/warrenty.component.html','<a ui-sref="purchased-product-warranty-detail({id:vm.warrenty.id})" class="list-group-item list-group-item-action flex-column align-items-start list-item-controller"><div class="cardheader" back-img-default="warranty" back-img="{{vm.getImage(vm.warrenty)}}"></div><div class="body-item"><h5>{{\'garanteasyApp.purchasedProductWarranty.type.\'+vm.warrenty.warranty.contractType | translate}}</h5><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.coverageGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.warranty.description)}}</div><div class="desc"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.issuerGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.receipt.shop.description)}}</div><div class="desc" ng-if="vm.warrenty.purchasedProduct"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.productGrid"></span>&nbsp; {{vm.abbreviate(vm.warrenty.purchasedProduct.product.brandAndName)}}</div><div class="desc" ng-if="vm.warrenty.purchasedProduct"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.brandGrid"></span>&nbsp; {{vm.warrenty.purchasedProduct.product.brand.name}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.durationGrid"></span>&nbsp; {{vm.warrenty.warranty.validity}} {{\'garanteasyApp.timeUnit.\'+vm.warrenty.warranty.validityUnit | translate}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.startGrid"></span>&nbsp; {{vm.warrenty.startDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc" ng-if="vm.warrenty.warranty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.endGrid"></span>&nbsp; {{vm.warrenty.expirationDate | date : \'dd/MM/yy\' : timezone}}</div><div class="desc" ng-if="vm.warrenty"><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.statusGrid"></span>&nbsp; <span class="text-nowrap"><span uib-tooltip="{{\'garanteasyApp.warranty.status.\'+vm.warrenty.status | translate}}" class="badge {{vm.warrenty.status}}">&nbsp;</span> {{ \'garanteasyApp.receipt.detail.\'+vm.warrenty.status | translate}}</span></div><div class="desc" ng-if="vm.warrenty"><!-- <span class="text-muted"\n                    translate="garanteasyApp.vm.warrenty.list.dayToExpiration"></span>&nbsp; --> <i class="fas fa-stopwatch"></i> <strong><span class="text-muted" translate="garanteasyApp.purchasedProductWarranty.list.expirationDaysGrid"></span></strong> {{vm.warrenty.dayToExpiration}}</div></div></a>');
$templateCache.put('app/entities/warranty/components/warranty-edit-component.html','<!-- INIZIO GARANZIA --><div class="" ng-if="vm.purchasedProduct.id && !vm.isEdit"><div class="row row-margin btn-group"><label class="btn btn-default btn-dark" ng-class="{\'active\': vm.collapsed == \'new\'}" ng-click="vm.collapsed = \'new\'; vm.warranty = null" translate="garanteasyApp.warranty.selectFromOfficial">Cerca tra le garanzie ufficiali</label><label class="btn btn-default btn-dark" ng-class="{\'active\': vm.collapsed == \'search\'}" ng-click="vm.collapsed = \'search\'; vm.initWarranty()" translate="garanteasyApp.warranty.defineNew">Definisci la garanzia</label></div></div><ng-form name="warrantyEditForm" novalidate><div uib-collapse="vm.collapsed === \'search\'" class=""><!-- <div class="row row-margin" style="padding-right: 2em;">\n            <strong><span style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warranty.selectFromOfficial"></span></strong>\n        </div> --><div ng-if="vm.collapsed == \'new\'" class="row row-margin" style="padding-right: 2em"><span class="rdetail-font-size nopadding col-sm-12"><ui-select reset-search-input="false" ng-model="vm.selectedWarranty" ng-change="vm.changeSelected()"><ui-select-match allow-clear="true"><div ng-if="$select.selected.description" ng-bind="$select.selected.description +\' - \'+$select.selected.validity+\' \'+( \'garanteasyApp.timeUnit.\'+$select.selected.validityUnit| translate)"></div></ui-select-match><ui-select-choices refresh="vm.loadWarranties($select.search)" miimum-input-length="3" repeat="warranty in (vm.warranties) track by warranty.id"><div ng-bind="warranty.description +\' - \'+warranty.validity+\' \'+( \'garanteasyApp.timeUnit.\'+warranty.validityUnit| translate)"></div></ui-select-choices></ui-select></span></div></div><div uib-collapse="vm.collapsed === \'new\'"><div ng-if="!vm.isConventionalStandard" class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.warrantyIssuer">Issuer</strong></div><div ng-if="!vm.isConventionalStandard" class="row row-margin"><span class="col-sm-12 nopadding"><span class="col-sm-4 nopadding"><input ng-click="vm.changeGuarantor();" value="PRODUCER" ng-model="vm.purchasedProductWarranty.warranty.guarantorType" type="radio" name="warranty_issuer"> <img src="../../../content/images/ICONA_GARANZIE_CONVENZIONALE.png" class="img-responsive" style="height: 26px; display: inline-block"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.issuerProducer" style="font-weight: bold">Produttore</span> </span><span class="col-sm-4 nopadding"><input ng-click="vm.changeGuarantor();" value="INSURANCE" ng-model="vm.purchasedProductWarranty.warranty.guarantorType" type="radio" name="warranty_issuer"> <img src="../../../content/images/ICONA_GARANZIE_POLIZZA.png" class="img-responsive" style="height: 26px; display: inline-block"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.issuerInsurance" style="font-weight: bold">Assicurazione</span> </span><span class="col-sm-4 nopadding"><input ng-click="vm.changeGuarantor();" value="ASSISTANCE_CENTER" ng-model="vm.purchasedProductWarranty.warranty.guarantorType" type="radio" name="warranty_issuer"> <img src="../../../content/images/ICONA_GARANZIE_ASSISTENZA.png" class="img-responsive" style="height: 26px; display: inline-block"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.issuerAssistanceCenter" style="font-weight: bold">Centro assistena</span></span></span></div><div ng-if="!vm.isConventionalStandard" class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.protectedRisk">Protected Risk</strong></div><div ng-if="!vm.isConventionalStandard" class="row row-margin"><span class="col-sm-12 nopadding"><span class="col-sm-4 nopadding"><input value="DEFECT" ng-model="vm.purchasedProductWarranty.warranty.protectedRisk" type="radio" name="protected_risk"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.riskDefect">Difetto di conformit\xE0</span> </span><span class="col-sm-4 nopadding"><input value="ACCIDENTAL_DAMAGE" ng-model="vm.purchasedProductWarranty.warranty.protectedRisk" type="radio" name="protected_risk"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.riskAccidentalDamage">Danno accidentale</span> </span><span class="col-sm-4 nopadding"><input value="THEFT" ng-model="vm.purchasedProductWarranty.warranty.protectedRisk" type="radio" name="protected_risk"> <span class="rdetail-font-size" translate="garanteasyApp.warranty.riskTheft">Furto</span></span></span></div><div class="row row-margin" has-authority="ROLE_ADMIN"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.code">Code</strong></div><div class="row row-margin" has-authority="ROLE_ADMIN"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input required type="text" class="form-control-modified" ng-model="vm.purchasedProductWarranty.warranty.code" uib-tooltip="{{\'\'|translate}}" tooltip-enable="!vm.purchasedProductWarranty.warranty.code"> <span ng-if="!vm.purchasedProductWarranty.warranty.code" style="color: red; margin-right: 2.1rem" class="fas fa-exclamation-triangle form-control-feedback form-triangle-left" aria-hidden="true"></span></span></div><div ng-if="!vm.isConventionalStandard" class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warranty.warrantyStart">Tipo di applicabilit\xE0</strong></div><div ng-if="!vm.isConventionalStandard" class="row row-margin"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><select ng-change="vm.changeStart();" class="form-control-modified" name="type" ng-model="vm.startType" id="field_warrantyType"><option value="STANDARD" translate="garanteasyApp.warranty.warrantyStartStandard">Standard</option><option ng-disabled="!vm.warrantyLegal" value="EXTENSION_LEGAL" translate="garanteasyApp.warranty.warrantyStartEndLegal">Extension</option><option ng-disabled="!vm.warrantyConventionalStandard" value="EXTENSION_CONVENTIONAL" translate="garanteasyApp.warranty.warrantyStartEndConventional">Extension</option><option value="ARBITRARY" translate="garanteasyApp.warranty.warrantyStartArbitrary">Arbitrary</option></select><span ng-if="vm.purchasedProductWarranty.warranty.applicabilityType == null" style="margin-right: 3rem" class="form-control-feedback"><span uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" style="background-color: transparent"><i style="color: red" class="fas fa-exclamation-triangle form-triangle-left"></i></span></span></span></div></div><!-- <div ng-if="vm.purchasedProductWarranty.warranty.applicabilityType === \'EXTENSION\'">\n        <div class="row row-margin">\n            <strong style="padding-left: 0px;" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.warrantyToExtend">Garanzia\n                da Estendere</strong>\n        </div>\n        <div class="row row-margin">\n            <span class="nopadding col-xs-12 input-group" style="padding-right: 2em;">\n                <select ng-change="vm.changeRequired()" class="form-control-modified" name="required" ng-model="vm.required"\n                    ng-options="warranty.description for warranty in vm.warrantiesForRequired track by warranty.id">\n                    <option value=""></option>\n                </select>\n                <span ng-if="!vm.required" style="color: red; margin-right: 3rem;" class="fas fa-exclamation-triangle form-control-feedback"\n                    aria-hidden="true"></span>\n            </span>\n        </div>\n    </div> --><div ng-if="vm.purchasedProductWarranty.warranty.applicabilityType === \'ARBITRARY\'"><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.startDate">Data inizio Garanzia</strong></div><div class="row row-margin"><span class="rdetail-font-size col-xs-12 nopadding input-group" style="padding-right: 2em"><span class="fas fa-calendar-alt input-group-addon" ng-click="vm.datePickerOpen = true"></span> <input ng-click="vm.datePickerOpen = true" readonly="readonly" id="startDate" type="text" class="form-control-modified" name="startDate" uib-tooltip="{{\'garanteasyApp.receipt.detail.required\'|translate}}" tooltip-enable="vm.purchasedProductWarranty.startDate == null || vm.purchasedProductWarranty.startDate == \'\'" uib-datepicker-popup="mediumDate" ng-model="vm.purchasedProductWarranty.startDate" is-open="vm.datePickerOpen" required aria-describedby="buyingDateStatus" style="background-color: #fff"> <span ng-if="vm.purchasedProductWarranty.startDate== null || vm.purchasedProductWarranty.startDate == \'\'" style="color: red; margin-right: 2.1rem" class="fas fa-exclamation-triangle form-control-feedback form-triangle-left" aria-hidden="true"></span></span></div></div><div uib-collapse="vm.collapsed === \'new\'"><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.description">Description</strong></div><div class="row row-margin"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" ng-model="vm.purchasedProductWarranty.warranty.description" uib-tooltip="{{\'\'|translate}}" tooltip-enable="!vm.purchasedProductWarranty.warranty.description"></span></div><div class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.validity">Validity</strong></div><div class="row row-margin"><div class="nopadding col-sm-8 col-xs-8"><span class="input-group col-xs-12"><input type="number" class="form-control-modified" name="validity" id="field_validity" ng-model="vm.purchasedProductWarranty.warranty.validity" step="1" min="0" required> <span ng-if="!vm.purchasedProductWarranty.warranty.validity" style="color: red" class="fas fa-exclamation-triangle form-control-feedback form-triangle-left" aria-hidden="true"></span></span></div><div class="rdetail-font-size nopadding col-sm-4 col-xs-4" style="padding-right: 2em"><span class="input-group col-xs-12 select-group"><select class="form-control-modified" name="validityUnit" ng-model="vm.purchasedProductWarranty.warranty.validityUnit" id="field_validityUnit" required><option value="DAYS" translate="garanteasyApp.timeUnit.DAYS">DAYS</option><option value="MONTHS" translate="garanteasyApp.timeUnit.MONTHS">MONTHS</option><option value="YEARS" translate="garanteasyApp.timeUnit.YEARS">YEARS</option></select><span ng-if="!vm.purchasedProductWarranty.warranty.validityUnit" style="color: red" class="fas fa-exclamation-triangle form-control-feedback form-triangle-left" aria-hidden="true"></span></span></div><!-- <input ng-init="vm.warranty.automatic=0; vm.warranty.code=\'CUSTOM\'; vm.warranty.type=\'STANDARD\'; vm.warranty.legal = false;"\n                type="hidden" ng-model="vm.warranty.type" value="STANDARD" /> --></div><div ng-if="!vm.isFast" class="row row-margin"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warranty.reference">Reference</strong></div><div ng-if="!vm.isFast" class="row row-margin"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" ng-model="vm.purchasedProductWarranty.warranty.Reference" uib-tooltip="{{\'\'|translate}}" tooltip-enable="!vm.purchasedProductWarranty.warranty.Reference"></span></div></div></ng-form>');
$templateCache.put('app/entities/warranty-claim/components/warranty-claim-dialog.component.html','<!-- <div ng-if="vm.type === \'DEFECT\' && !vm.isEdit" class="col-sm-12 col-xs-12"\n    style="margin-bottom: 15px; padding-left: 3px; padding-right: 0px;">\n    <div class="row" id="primoBlocco">\n        <div class="warranty-claim-icon col-sm-2 col-xs-3">\n            <i class="fas fa-user-shield"></i>\n        </div>\n        <div class="col-sm-10 col-xs-9">\n            <strong>\n                <span class="rdetail-font-size" translate="garanteasyApp.warrantyClaim.home.createLabelDefect"></span>\n            </strong>\n            <div class="row col-xs-12">\n                <span translate="garanteasyApp.warrantyClaim.home.caseAccidental"></span>\n                <button ng-click="vm.type = \'ACCIDENTAL\'" style="margin-right: 0.5rem;"\n                    uib-tooltip="{{ vm.receipt.shop.id ? \'garanteasyApp.purchasedProduct.addWarrantyClaim\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate | capitalize }}"\n                    class="btn btn-default btn-dark">\n                    <i class="fas fa-wrench"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if="vm.type !== \'DEFECT\' && !vm.isEdit" class="col-sm-12 col-xs-12"\n    style="margin-bottom: 15px; padding-left: 3px; padding-right: 0px;">\n    <div class="row" id="primoBlocco">\n        <div class="warranty-claim-icon col-sm-2 col-xs-3">\n            <i class="fas fa-wrench"></i>\n        </div>\n        <div class="col-sm-10 col-xs-9">\n            <strong>\n                <span class="rdetail-font-size" translate="garanteasyApp.warrantyClaim.home.createLabel"></span>\n            </strong>\n            <div class="row col-xs-12">\n                <span translate="garanteasyApp.warrantyClaim.home.caseDefect"></span>\n                <button ng-click="vm.type = \'DEFECT\'" style="margin-right: 0.5rem;"\n                    uib-tooltip="{{ vm.receipt.shop.id ? \'garanteasyApp.purchasedProduct.addWarrantyClaim\' : \'garanteasyApp.purchasedProduct.claimShopRequired\' | translate | capitalize }}"\n                    class="btn btn-default btn-dark">\n                    <i class="fas fa-user-shield"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div> --><ng-form name="warrantyClaimForm" novalidate><!--DATA SEGNALAZIONE--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.damageType">Tipo Danno</strong></div><div class="row row-margin"><span class="col-sm-12 col-xs-12 warranty-claim-type"><span class="col-sm-4 col-xs-12 nopadding"><img src="../../../content/images/icone_new/icone_garanzie/DIFETTO.png" class="img-responsive"> <input value="DEFECT" ng-model="vm.warrantyClaim.damageType" type="radio" name="damage_type"> <span class="rdetail-font-size" translate="garanteasyApp.warrantyClaim.damageTypeDefect" style="font-weight: bold">Defect</span> </span><span class="col-sm-4 col-xs-12 nopadding"><img src="../../../content/images/icone_new/icone_garanzie/DANNO.png" class="img-responsive"> <input value="ACCIDENTAL_DAMAGE" ng-model="vm.warrantyClaim.damageType" type="radio" name="damage_type"> <span class="rdetail-font-size" translate="garanteasyApp.warrantyClaim.damageTypeAccidental" style="font-weight: bold">Accidenta Damage</span> </span><span class="col-sm-4 col-xs-12 nopadding"><img src="../../../content/images/icone_new/icone_garanzie/CADUTA_ACCIDENTALE.png" class="img-responsive"> <input value="FALL_DAMAGE" ng-model="vm.warrantyClaim.damageType" type="radio" name="damage_type"> <span class="rdetail-font-size" translate="garanteasyApp.warrantyClaim.damageTypeFall" style="font-weight: bold">Fall Damage</span></span></span></div><input type="hidden" class="form-control" name="id" ng-model="vm.warrantyClaim.id"> <input type="hidden" class="form-control" name="id" ng-model="vm.warrantyClaim.purchasedProductId"><!--DATA SEGNALAZIONE--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.requestDate">Data segnalazione</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="requestDate" value="{{vm.warrantyClaim.requestDate | date : \'dd/MM/yy\' : timezone}}" readonly="readonly"></span></div><!--PRODOTTO ACQUISTATO IL--><div ng-if="!vm.isGeneric"><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.buyingDate">Prodotto acquistato il</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="buyingDate" value="{{vm.warrantyClaim.purchasedProduct.receipt.buyingDate | date : \'dd/MM/yy\' : timezone}}" readonly="readonly"></span></div></div><!--RAGIONE SOCIALE--><div ng-if="vm.warrantyClaim.damageType === \'DEFECT\'"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.shop">Ragione sociale</strong></div><div ng-if="vm.warrantyClaim.damageType === \'DEFECT\'"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="buyingDate" value="{{vm.warrantyClaim.purchasedProduct.receipt.shop.merchant.owner.name}}" readonly="readonly"></span></div><!--RICEVUTA NUMERO--><div ng-if="vm.warrantyClaim.damageType === \'DEFECT\'"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.receiptNumber">Numero ricevuta</strong></div><div ng-if="vm.warrantyClaim.damageType === \'DEFECT\'"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="buyingDate" value="{{vm.warrantyClaim.purchasedProduct.receipt.receiptNumber}}" readonly="readonly"></span></div><!--NOME CLIENTE--><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.customer"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.clientName">Nome cliente</strong></div><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.customer"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="clientName" value="{{vm.warrantyClaim.purchasedProduct.receipt.customer.legalName}}" readonly="readonly"></span></div><!--EMAIL CLIENTE--><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.customer.user"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.clientEmail">Email cliente</strong></div><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.customer.user"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="clientEmail" value="{{vm.warrantyClaim.purchasedProduct.receipt.customer.user.login}}" readonly="readonly"></span></div><!--CARD CLIENTE--><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.card.number"><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.cardNumber">Card cliente</strong></div><div ng-if="vm.warrantyClaim.purchasedProduct.receipt.card.number"><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="cardNumber" value="{{vm.warrantyClaim.purchasedProduct.receipt.card.number}}" readonly="readonly"></span></div><!--NOME PRODOTTO--><div ng-if="!vm.isGeneric"><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.productName">Nome Prodotto</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="productName" value="{{vm.warrantyClaim.purchasedProduct.product.name}}" readonly="readonly"></span></div><!--MARCA PRODOTTO--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.brand">Marca Prodotto</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="productName" value="{{vm.warrantyClaim.purchasedProduct.product.brand.name}}" readonly="readonly"></span></div><!--PRODUTTORE--><!-- <div>\n        <strong style="padding-left: 0px;" class="rdetail-font-size-colored col-sm-12"\n            translate="garanteasyApp.warrantyClaim.brand">Produttore</strong>\n    </div>\n    <div>\n        <span class="nopadding col-xs-12 input-group" style="padding-right: 2em;">\n            <input type="text" class="form-control-modified" name="productName"\n                value="{{vm.warrantyClaim.purchasedProduct.product.producer.name}}" readonly />\n        </span>\n    </div> --><!--CODICE PRODOTTO--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.productCode">Codice Prodotto</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="productCode" value="{{vm.warrantyClaim.purchasedProduct.product.eanCode}}" readonly="readonly"></span></div><!--NUMERO DI SERIE PRODOTTO--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.serialNumber">Seriale Prodotto</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input type="text" class="form-control-modified" name="serialNumber" value="{{vm.warrantyClaim.purchasedProduct.serialNumber}}" readonly="readonly"></span></div></div><!--EMAIL A CUI INVIARE LA SEGNALAZIONE--><div><strong style="padding-left: 0px" class="rdetail-font-size-colored col-sm-12" translate="garanteasyApp.warrantyClaim.email">Email segnalazione</strong></div><div><span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><input ng-model="vm.warrantyClaim.shopEmailAddress" type="email" class="form-control-modified" name="email" value=""></span></div><!-- ********* DESCRIPTION *************** --><div ng-show="vm.warrantyClaim.id"><strong><span style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.informativa"></span></strong> <span ng-bind-html="vm.warrantyClaim.informativa" name="informativa" id="field_informativa"></span><!--<div text-angular name="informativa" id="field_informativa" ng-model="vm.warrantyClaim.informativa" ta-disabled=true>  </div>--></div><div><strong><span ng-show="vm.warrantyClaim.notifiedShop==1" style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.notifiedShop"></span></strong><!--<label class="control-label" ng-show="vm.warrantyClaim.notifiedShop==1" translate="garanteasyApp.warrantyClaim.notifiedShop" for="field_annotations">Notified Shop</label>--> <strong><span ng-show="vm.warrantyClaim.notifiedGaranteasy==1" style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.notifiedGaranteasy"></span></strong><!--<label class="control-label" ng-show="vm.warrantyClaim.notifiedGaranteasy==1" translate="garanteasyApp.warrantyClaim.notifiedGaranteasy" for="field_annotations">Notified Garanteasy</label>--> <strong><span ng-show="!vm.warrantyClaim.notifiedShop && !vm.warrantyClaim.notifiedGaranteasy && vm.warrantyClaim.damageType === \'DEFECT\'" style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.annotationsDefect"></span></strong> <strong><span ng-show="!vm.warrantyClaim.notifiedShop && !vm.warrantyClaim.notifiedGaranteasy && vm.warrantyClaim.damageType === \'ACCIDENTAL_DAMAGE\'" style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.annotationsAccidentalDamage"></span></strong> <strong><span ng-show="!vm.warrantyClaim.notifiedShop && !vm.warrantyClaim.notifiedGaranteasy && vm.warrantyClaim.damageType === \'FALL_DAMAGE\'" style="padding-left: 0px" class="rdetail-font-size-colored col-xs-12" translate="garanteasyApp.warrantyClaim.annotationsFall"></span></strong><!--<label class="control-label" ng-show="!vm.warrantyClaim.notifiedShop && !vm.warrantyClaim.notifiedGaranteasy" translate="garanteasyApp.warrantyClaim.annotations" for="field_annotations">Annotations</label>--><br><span ng-if="vm.warrantyClaim.notifiedShop==1 || vm.warrantyClaim.notifiedGaranteasy==1">{{vm.warrantyClaim.annotations}}</span> <span class="nopadding col-xs-12 input-group" style="padding-right: 2em"><textarea class="col-xs-12 form-control-modified" ng-if="vm.warrantyClaim.notifiedShop==0 && vm.warrantyClaim.notifiedGaranteasy==0" name="annotations" id="field_annotations" ng-model="vm.warrantyClaim.annotations" ng-maxlength="1024" cols="80" rows="5" required></textarea><div ng-show="warrantyClaimForm.annotations.$invalid"><p class="help-block" ng-show="warrantyClaimForm.annotations.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1024">This field cannot be longer than 1024 characters.</p></div></span></div><!-- ********* IMAGE *********** --><div class="row" style="margin-top: 15px; margin-bottom: 15px"><div class="col-sm-8 col-xs-12"><div class="main-image" ng-if="vm.image != undefined"><a id="main-image" target="_blank" ng-href="{{vm.getImageUrl(vm.image)}}"><!--<img  data-ng-src="{{\'data:\' + vm.receiptFile.fileContentType + \';base64,\' + vm.image.fileData}}" />--> <img style="max-height: 377px" class="img-responsive" ng-if="vm.imageNotPersistent != null" src="data:image/png;base64,{{vm.image.fileData}}"> <img ng-if="vm.canShow(vm.image.fileContentType)" style="max-height: 377px" class="img-responsive" data-ng-src="{{vm.getImageUrl(vm.image)}}"> <span ng-show="!vm.canShow(vm.image.fileContentType)" ng-bind-html="vm.image.fileContentType|iconify"></span></a><ul style="margin-bottom: 0px" ng-if="vm.images.length > 1" class="images-list ul-no-bump"><li ng-repeat="image in vm.images"><img class="img-responsive img-thumbnail" style="width: 80px; height: 80px" ng-click="vm.changeMainImage(image)" ng-src="{{\'data:\' + image.fileContentType + \';base64,\' + image.fileData}}" id="{{image.id}}"></li></ul></div><div style="margin-top: 5px"><button ng-if="vm.imageNotPersistent != null" class="btn btn-default btn-dark" uib-tooltip="Delete file" ng-show="vm.image != null" ng-click="vm.imageNotPersistent = null; vm.image = null;"><span class="fa fa-trash"></span></button></div></div></div><div class="hidden-print row row-margin"><div class="col-xs-12"><button type="button" ng-disabled="vm.image != null" class="btn btn-default btn-dark" ngf-select="vm.uploadFile($file)" uib-tooltip="{{\'garanteasyApp.warrantyClaim.addImage\' | translate}}"><span class="fas fa-cloud-upload-alt"></span> <span translate="garanteasyApp.warrantyClaim.addImage">Cancel</span></button> <button type="submit" ng-disabled="warrantyClaimForm.$invalid || vm.isSaving || !vm.isValidInput()" class="btn btn-default btn-dark pull-right" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp; <span ng-if="!vm.isEdit" translate="garanteasyApp.warrantyClaim.send.action">SEND</span> <span ng-if="vm.isEdit" translate="entity.action.save">SEND</span></button> <button type="button" class="btn btn-default pull-right dashboard-inline-margin" style="margin-right: 5px" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></ng-form>');}]);})();